import React, { forwardRef, createContext, useContext } from 'react';
import invariant from 'tiny-invariant';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["width", "height", "weight", "mirrored", "title", "children", "renderPath"];
var IconBase = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$width = props.width,
      width = _props$width === void 0 ? '1.25rem' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '1.25rem' : _props$height,
      _props$weight = props.weight,
      weight = _props$weight === void 0 ? 'outline' : _props$weight,
      _props$mirrored = props.mirrored,
      mirrored = _props$mirrored === void 0 ? false : _props$mirrored,
      title = props.title,
      children = props.children,
      renderPath = props.renderPath,
      htmlProps = _objectWithoutPropertiesLoose(props, _excluded);

  return React.createElement("svg", Object.assign({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    fill: "currentColor",
    viewBox: "0 0 256 256",
    transform: mirrored ? 'scale(-1, 1)' : undefined
  }, htmlProps), title ? React.createElement("title", null, title) : null, React.createElement("rect", {
    width: "16rem",
    height: "16rem",
    fill: "none"
  }), children, renderPath(weight, 'currentColor'));
});
var IconContext = /*#__PURE__*/createContext({
  useIconProps: function useIconProps(props) {
    return props;
  }
});

function useIconContext() {
  var context = useContext(IconContext);
  !context ? process.env.NODE_ENV !== "production" ? invariant(false, 'Make sure you are using VTEX icons under an IconProvider') : invariant(false) : void 0;
  return context;
}

function createIconProvider(props) {
  var useIconProps = props.useIconProps;

  function IconProvider(iconProps) {
    var children = iconProps.children;
    return React.createElement(IconContext.Provider, {
      value: {
        useIconProps: useIconProps
      }
    }, children);
  }

  return IconProvider;
}

var weights = ['outline', 'fill'];

var renderPathForWeight = function renderPathForWeight(weight, path) {
  if (weights.includes(weight)) {
    return path();
  }

  console.error('Unsupported icon weight. Choose from "outline" or "fill".');
  return null;
};
/* GENERATED FILE */


var IconActivity = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "24.002 128 56.002 128 96.002 40 160.002 208 200.002 128 232.002 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAddressBook = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160,112a24,24,0,1,1-24-24A24.0275,24.0275,0,0,1,160,112Zm64-72V216a16.01833,16.01833,0,0,1-16,16H64a16.01833,16.01833,0,0,1-16-16V196H32a8,8,0,0,1,0-16H48V156H32a8,8,0,0,1,0-16H48V116H32a8,8,0,0,1,0-16H48V76H32a8,8,0,0,1,0-16H48V40A16.01833,16.01833,0,0,1,64,24H208A16.01833,16.01833,0,0,1,224,40ZM190.397,163.19141a67.80622,67.80622,0,0,0-27.42627-21.68067,40,40,0,1,0-53.94153-.00012,67.80949,67.80949,0,0,0-27.42858,21.68274,8,8,0,1,0,12.793,9.60937,52.0088,52.0088,0,0,1,83.21143-.00195,7.99961,7.99961,0,1,0,12.792-9.60937Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "136",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "108.00005",
          x2: "56",
          y2: "108.00005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "68.00005",
          x2: "56",
          y2: "68.00005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "148.00005",
          x2: "56",
          y2: "148.00005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "188.00005",
          x2: "56",
          y2: "188.00005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M87.99717,167.99792a60.00878,60.00878,0,0,1,96.004-.00225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(264 -8) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAirplane = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240.22559,136v32a8.00013,8.00013,0,0,1-9.56934,7.84473L160.22559,161.7583v26.96143l13.47168,13.66357A8.00119,8.00119,0,0,1,176,208v24a7.99947,7.99947,0,0,1-10.9707,7.42773L128,224.61621,90.9707,239.42773A7.99953,7.99953,0,0,1,80,232V208a8.00035,8.00035,0,0,1,2.34277-5.65674L96,188.686V161.7583L25.56934,175.84473A8.00012,8.00012,0,0,1,16,168V136a7.99967,7.99967,0,0,1,4.42188-7.15527L96.01172,91.0498l.10058-43.06835a32,32,0,0,1,64,.01855l.10157,43.0498,75.58984,37.79493A7.99969,7.99969,0,0,1,240.22559,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,216,88,232V200l16-16V152L24,168V136l80-40,.11255-48a24,24,0,0,1,48,0l.11255,48,80,40v32l-80-16v32L168,200v32Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAirplaneInFlight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,216a8.00008,8.00008,0,0,1-8,8H72a8,8,0,0,1,0-16H216A8.00008,8.00008,0,0,1,224,216ZM208,100H153.75977L110.94824,53.29688A3.99911,3.99911,0,0,0,108,52H91.09961A12.00015,12.00015,0,0,0,79.71484,67.79492L90.4502,100H65.87305L47.07324,77.43945A4.001,4.001,0,0,0,44,76H26.752A11.99986,11.99986,0,0,0,15.25879,91.44824l14.06836,46.89649A35.77737,35.77737,0,0,0,63.80859,164H240a4.0002,4.0002,0,0,0,4-4V136A36.04061,36.04061,0,0,0,208,100Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "72",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M26.75225,80H44l20,24H96L83.50994,66.52982A8,8,0,0,1,91.09941,56H108l44,48h56a32,32,0,0,1,32,32v24H63.809a32,32,0,0,1-30.65044-22.80487L19.08963,90.29878A8,8,0,0,1,26.75225,80Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAirplaneLanding = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248,216a8.00008,8.00008,0,0,1-8,8H96a8,8,0,0,1,0-16H240A8.00008,8.00008,0,0,1,248,216Zm-24-28a4.00035,4.00035,0,0,0,4-4V148.32275a36.10691,36.10691,0,0,0-26.36523-34.68652l-46.97852-13.0498L123.47266,46.01562a4.00193,4.00193,0,0,0-2.208-1.81054l-13.46973-4.49024A12.00071,12.00071,0,0,0,92,51.09961V82.55908L66.75781,74.6709,51.5293,46.11768a4.00065,4.00065,0,0,0-2.26465-1.9126L35.79492,39.71484A12.00071,12.00071,0,0,0,20,51.09961v52.62988A36.11994,36.11994,0,0,0,46.294,138.396l176.62793,49.45605A4.00591,4.00591,0,0,0,224,188Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M24,103.72927V51.09941a8,8,0,0,1,10.52982-7.58947L48,48,64,78,96,88V51.09941a8,8,0,0,1,10.52982-7.58947L120,48l32,56,48.5646,13.49017A32,32,0,0,1,224,148.32274V184L47.37184,134.54412A32,32,0,0,1,24,103.72927Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAirplaneTakeoff = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,216a8.00008,8.00008,0,0,1-8,8H24a8,8,0,0,1,0-16H168A8.00008,8.00008,0,0,1,176,216ZM247.0957,89.4668,228.45605,66.686a35.81374,35.81374,0,0,0-46.11523-8.2334L139.53906,83.62988,81.26465,64.20508a4.0083,4.0083,0,0,0-2.83985.11816l-16.5,7.0708A12.00078,12.00078,0,0,0,58.625,91.34375L85.21191,115.272l-21.46679,12.2666L37.5752,116.32324a4.00251,4.00251,0,0,0-3.1504,0l-16.75292,7.17969a12.00032,12.00032,0,0,0-3.48145,19.78418h.001l37.69531,35.33935a35.78229,35.78229,0,0,0,42.7168,4.85938L246.01074,95.458a4.001,4.001,0,0,0,1.085-5.99121Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "24",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M16.92713,140.36918,54.6225,175.70859a32,32,0,0,0,37.97,4.319L244,92,225.3607,69.21863a32,32,0,0,0-40.99128-7.31829L140,88,80,68,63.501,75.071a8,8,0,0,0-2.20037,13.29951L92,116,64,132,36,120l-16.7527,7.17973A8,8,0,0,0,16.92713,140.36918Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAirplaneTilt = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.01538,86.23437l-29.80762,27.98829,30.19824,83.043a8.00184,8.00184,0,0,1-1.86181,8.39161l-24,24A7.99924,7.99924,0,0,1,177.282,228.5127l-42.58691-62.33692-18.80762,17.33106V204a8.0008,8.0008,0,0,1-2.34326,5.65723l-20,20a7.99986,7.99986,0,0,1-13.23291-3.08789L67.38745,188.457l-38.064-12.87891a8.00081,8.00081,0,0,1-3.09326-13.23535l20-20A8.00235,8.00235,0,0,1,51.88745,140H72.574l18.75635-18.75684L27.45,78.65625a8.00073,8.00073,0,0,1-1.21973-12.31348l24-24a8.003,8.003,0,0,1,8.39111-1.86132l83.0625,30.20507,26.606-28.14062a7.98306,7.98306,0,0,1,.97071-1.17383,32.0006,32.0006,0,0,1,47.01806,43.34375A8.03536,8.03536,0,0,1,215.01538,86.23437Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M209.53911,80.402,175.88745,112l32,88-24,24-47.80786-69.97929L111.88745,176v24l-24,24L73.695,182.14581,31.88745,168l24-24h24l24-24-72-48,24-24,88,32L175.598,46.46089l-.68109.56855A24,24,0,1,1,208.858,80.97056Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAirplay = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M134.07666,154.794a8.0003,8.0003,0,0,0-12.14844-.00049l-48.00293,56A8,8,0,0,0,79.99951,224h96a8.00032,8.00032,0,0,0,6.07422-13.20605Z"
        }), React.createElement("path", {
          d: "M208.00244,40H47.99951a24.0275,24.0275,0,0,0-24,24V176a24.0275,24.0275,0,0,0,24,24h14.104l47.67919-55.62231a24.00045,24.00045,0,0,1,36.44239.0039L193.895,200h14.10742a24.0275,24.0275,0,0,0,24-24V64A24.0275,24.0275,0,0,0,208.00244,40Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "128.002 160 176 216 80 216 128.002 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAlarm = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M235.48047,54.46094,201.53906,20.51953a8,8,0,0,0-11.31347,11.314L224.1665,65.77441a8,8,0,1,0,11.314-11.31347Z"
        }), React.createElement("path", {
          d: "M65.77441,20.51953a8,8,0,0,0-11.31347,0L20.51953,54.46094a8,8,0,0,0,11.314,11.31347L65.77441,31.8335A8.00061,8.00061,0,0,0,65.77441,20.51953Z"
        }), React.createElement("path", {
          d: "M223.957,125.22363c-.02051-.71777-.0459-1.43408-.082-2.14892-.001-.02491-.00293-.04932-.00439-.07373A96.003,96.003,0,0,0,132.999,32.12939c-.02441-.00146-.04882-.00341-.07373-.00439-.71484-.03613-1.43115-.06152-2.14892-.082-.10742-.00293-.21436-.00879-.32227-.01172Q129.2295,32.00048,128,32q-1.22973,0-2.4541.03125c-.10791.00293-.21485.00879-.32227.01172-.71777.02051-1.43408.0459-2.14892.082-.02491.001-.04932.00293-.07373.00439A96.004,96.004,0,0,0,32.12939,123.001c-.00146.02441-.00341.04882-.00439.07373-.03613.71484-.06152,1.43115-.082,2.14892-.00293.10742-.00879.21436-.01172.32227Q32.00048,126.7705,32,128q0,1.22973.03125,2.4541c.00293.10791.00879.21485.01172.32227.02051.71777.0459,1.43408.082,2.14892.001.02491.00293.04932.00439.07373A96.003,96.003,0,0,0,123.001,223.87061c.02441.00146.04882.00341.07373.00439.71484.03613,1.43115.06152,2.14892.082.10742.00293.21436.00879.32227.01172q1.2246.03077,2.4541.03125,1.22973,0,2.4541-.03125c.10791-.00293.21485-.00879.32227-.01172.71777-.02051,1.43408-.0459,2.14892-.082.02491-.001.04932-.00293.07373-.00439A96.004,96.004,0,0,0,223.87061,132.999c.00146-.02441.00341-.04882.00439-.07373.03613-.71484.06152-1.43115.082-2.14892.00293-.10742.00879-.21436.01172-.32227Q223.99952,129.2295,224,128q0-1.22973-.03125-2.4541C223.96582,125.438,223.96,125.33105,223.957,125.22363ZM184,136H128a8.00008,8.00008,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "195.88225",
          y1: "26.17662",
          x2: "229.82338",
          y2: "60.11775",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "26.17662",
          y1: "60.11775",
          x2: "60.11775",
          y2: "26.17662",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAlignBottom = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.00488,216.00586a8.00008,8.00008,0,0,1-8,8h-176a8,8,0,1,1,0-16h176A8.00008,8.00008,0,0,1,224.00488,216.00586ZM152,192h40a16.01833,16.01833,0,0,0,16-16V80a16.01833,16.01833,0,0,0-16-16H152a16.01833,16.01833,0,0,0-16,16v96A16.01833,16.01833,0,0,0,152,192Zm-88,0h40a16.01833,16.01833,0,0,0,16-16V40a16.01833,16.01833,0,0,0-16-16H64A16.01833,16.01833,0,0,0,48,40V176A16.01833,16.01833,0,0,0,64,192Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "216.00488",
          y1: "216.00586",
          x2: "40.00488",
          y2: "216.00586",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(44 300) rotate(-90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "56",
          y: "32",
          width: "56",
          height: "152",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAlignCenterHorizontal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,152v40a16.01833,16.01833,0,0,1-16,16H136v15.99512a8,8,0,0,1-16,0V208H48a16.01833,16.01833,0,0,1-16-16V152a16.01833,16.01833,0,0,1,16-16h72V120H72a16.01833,16.01833,0,0,1-16-16V64A16.01833,16.01833,0,0,1,72,48h48V31.99512a8,8,0,1,1,16,0V48h48a16.01833,16.01833,0,0,1,16,16v40a16.01833,16.01833,0,0,1-16,16H136v16h72A16.01833,16.01833,0,0,1,224,152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "31.99512",
          x2: "128",
          y2: "55.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "199.99512",
          x2: "128",
          y2: "223.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "111.99512",
          x2: "128",
          y2: "143.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "64",
          y: "56",
          width: "128",
          height: "56",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAlignCenterVertical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232.00488,128a7.99977,7.99977,0,0,1-8,8H208v48a16.01833,16.01833,0,0,1-16,16H152a16.01833,16.01833,0,0,1-16-16V136H120v72a16.01833,16.01833,0,0,1-16,16H64a16.01833,16.01833,0,0,1-16-16V136H32.00488a8,8,0,0,1,0-16H48V48A16.01833,16.01833,0,0,1,64,32h40a16.01833,16.01833,0,0,1,16,16v72h16V72a16.01833,16.01833,0,0,1,16-16h40a16.01833,16.01833,0,0,1,16,16v48h16.00488A7.99977,7.99977,0,0,1,232.00488,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "224.00488",
          y1: "128",
          x2: "200.00488",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56.00488",
          y1: "128",
          x2: "32.00488",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144.00488",
          y1: "128",
          x2: "112.00488",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "108",
          y: "100",
          width: "128",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "56",
          y: "40",
          width: "56",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAlignLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M47.99414,39.99512v176a8,8,0,0,1-16,0v-176a8,8,0,0,1,16,0ZM80,120h96a16.01833,16.01833,0,0,0,16-16V64a16.01833,16.01833,0,0,0-16-16H80A16.01833,16.01833,0,0,0,64,64v40A16.01833,16.01833,0,0,0,80,120Zm136,16H80a16.01833,16.01833,0,0,0-16,16v40a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V152A16.01833,16.01833,0,0,0,216,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "39.99414",
          y1: "39.99512",
          x2: "39.99414",
          y2: "215.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "72",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAlignRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.00586,39.99512v176a8,8,0,0,1-16,0v-176a8,8,0,0,1,16,0ZM176,48H80A16.01833,16.01833,0,0,0,64,64v40a16.01833,16.01833,0,0,0,16,16h96a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,176,48Zm0,88H40a16.01833,16.01833,0,0,0-16,16v40a16.01833,16.01833,0,0,0,16,16H176a16.01833,16.01833,0,0,0,16-16V152A16.01833,16.01833,0,0,0,176,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "216.00586",
          y1: "39.99512",
          x2: "216.00586",
          y2: "215.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(256 168) rotate(180)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "32",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAlignTop = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.00488,39.99414a7.99977,7.99977,0,0,1-8,8h-176a8,8,0,0,1,0-16h176A7.99977,7.99977,0,0,1,224.00488,39.99414ZM192,64H152a16.01833,16.01833,0,0,0-16,16v96a16.01833,16.01833,0,0,0,16,16h40a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,192,64Zm-88,0H64A16.01833,16.01833,0,0,0,48,80V216a16.01833,16.01833,0,0,0,16,16h40a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,104,64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "216.00488",
          y1: "39.99414",
          x2: "40.00488",
          y2: "39.99414",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "56",
          y: "72",
          width: "56",
          height: "152",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAnchor = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,136a8.00039,8.00039,0,0,0-8,8,40.04584,40.04584,0,0,1-40,40,47.79539,47.79539,0,0,0-32,12.27148V120h32a8,8,0,0,0,0-16H136V78.8291a28,28,0,1,0-16,0V104H88a8,8,0,0,0,0,16h32v76.27148A47.79539,47.79539,0,0,0,88,184a40.04584,40.04584,0,0,1-40-40,8,8,0,0,0-16,0,56.0629,56.0629,0,0,0,56,56,32.03667,32.03667,0,0,1,32,32,8,8,0,0,0,16,0,32.03667,32.03667,0,0,1,32-32,56.0629,56.0629,0,0,0,56-56A8.00039,8.00039,0,0,0,216,136ZM116,52a12,12,0,1,1,12,12A12.01312,12.01312,0,0,1,116,52Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAnchorSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.001,111.99707h-24a8,8,0,0,0,0,16h15.63964A88.14248,88.14248,0,0,1,136.001,207.626V94.98437a32,32,0,1,0-16,0V207.626a88.1425,88.1425,0,0,1-79.63965-79.62891H56.001a8,8,0,0,0,0-16h-24a8.00039,8.00039,0,0,0-8,8,104,104,0,0,0,208,0A8.00039,8.00039,0,0,0,224.001,111.99707Zm-112-48a16,16,0,1,1,16,16A16.01833,16.01833,0,0,1,112.001,63.99707Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128.00098",
          cy: "63.99707",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128.00098",
          y1: "215.99707",
          x2: "128.00098",
          y2: "87.99707",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56.001,119.99707h-24a96,96,0,0,0,192,0h-24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAndroidLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.05811,88.666q-1.10724-1.103-2.24146-2.16895l24.84009-24.84033a7.99984,7.99984,0,0,0-11.31348-11.31348L192.3728,76.3135a111.42105,111.42105,0,0,0-128.55444.19092L37.65674,50.34328A7.99984,7.99984,0,0,0,26.34326,61.65676L51.40283,86.71633A113.38256,113.38256,0,0,0,16,169.12893V192a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V168A111.25215,111.25215,0,0,0,207.05811,88.666ZM92,168a12,12,0,1,1,12-12A12,12,0,0,1,92,168Zm72,0a12,12,0,1,1,12-12A12,12,0,0,1,164,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "164",
          cy: "156",
          r: "12"
        }), React.createElement("circle", {
          cx: "92",
          cy: "156",
          r: "12"
        }), React.createElement("path", {
          d: "M24,192V169.12886C24,111.65,70.15361,64.19953,127.63214,64.00066A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "56.00002",
          x2: "63.07266",
          y2: "87.07268",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "56.00002",
          x2: "193.10334",
          y2: "86.89668",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAperture = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,128A103.99994,103.99994,0,0,0,54.46094,54.46094,103.99951,103.99951,0,0,0,127.97,231.99951c.01,0,.0199.00244.03.00244.02148,0,.04321-.00244.0647-.00293A103.99851,103.99851,0,0,0,232,128ZM49.17554,88.91992l51.21631,9.35059L46.65076,161.53613A88.43277,88.43277,0,0,1,49.17554,88.91992Zm160.17383,5.54395a88.43282,88.43282,0,0,1-2.52491,72.61621l-51.21631-9.35059Zm-8.079-15.2041-33.7201,39.69628L139.63037,40.78027a87.98552,87.98552,0,0,1,61.64,38.4795ZM122.43164,40.19336l17.51148,49.03271L58.2959,74.32031a88.35033,88.35033,0,0,1,7.47851-8.54492A87.33436,87.33436,0,0,1,122.43164,40.19336Zm-67.702,136.54687L88.44971,137.044l27.91992,78.17578a87.98552,87.98552,0,0,1-61.64-38.4795Zm78.83875,39.06641-17.51148-49.03271,23.08216,4.21386.04553.0083,58.51953,10.6836a88.35033,88.35033,0,0,1-7.47851,8.54492A87.33436,87.33436,0,0,1,133.56836,215.80664Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "32",
          x2: "164.6771",
          y2: "134.69588",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "44.86156",
          y1: "80",
          x2: "152.13735",
          y2: "99.58464",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "44.86156",
          y1: "176",
          x2: "115.46025",
          y2: "92.88876",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "224",
          x2: "91.3229",
          y2: "121.30412",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "211.13844",
          y1: "176",
          x2: "103.86265",
          y2: "156.41536",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "211.13844",
          y1: "80",
          x2: "140.53975",
          y2: "163.11124",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAppWindow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40.00586H40a16.01833,16.01833,0,0,0-16,16v144a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16v-144A16.01833,16.01833,0,0,0,216,40.00586Zm-148,56a12,12,0,1,1,12-12A12,12,0,0,1,68,96.00586Zm40,0a12,12,0,1,1,12-12A12,12,0,0,1,108,96.00586Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48.00586",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "68",
          cy: "84.00586",
          r: "12"
        }), React.createElement("circle", {
          cx: "108",
          cy: "84.00586",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAppleLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M130.66016,29.63136A40.25041,40.25041,0,0,1,168,4a8,8,0,0,1,0,16,24.15408,24.15408,0,0,0-22.4082,15.38037,8.00008,8.00008,0,0,1-14.93164-5.749Zm91.38476,126.12451a40.01719,40.01719,0,0,1-2.73144-69.99951,8.00039,8.00039,0,0,0,2.14111-11.7915A68.012,68.012,0,0,0,128,61.00441,68.00487,68.00487,0,0,0,20,116c0,25.50293,8.33594,52.4668,22.87109,73.97852C57.26514,211.28224,75.63086,224,92,224h72c22.46533,0,47.92578-23.86523,61.916-58.03515A8.00438,8.00438,0,0,0,222.04492,155.75587Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M138.12628,32.506A32.01179,32.01179,0,0,1,168,12",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M218.51254,162.9332C205.936,193.65156,183.10562,216,164,216H92c-28,0-64-48-64-100A60.00062,60.00062,0,0,1,128.00185,71.27954l-.00164-.00185a60.0047,60.0047,0,0,1,87.16862,7.63587l-.00019.00015a48.01693,48.01693,0,0,0,3.33915,84.01754Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArchive = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,48H32A16.01833,16.01833,0,0,0,16,64V88a16.01833,16.01833,0,0,0,16,16v88a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V104a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,224,48Zm-72,96H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm72-56H32V64H224l.00977,24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "40",
          rx: "7.99999",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "136",
          x2: "152",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArchiveBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.15527,68.42188l-16-32A7.99967,7.99967,0,0,0,200,32H56a7.99967,7.99967,0,0,0-7.15527,4.42188l-16,32A7.99934,7.99934,0,0,0,32,72V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V72A7.99934,7.99934,0,0,0,223.15527,68.42188Zm-55.55713,87.29394-33.94091,33.94141c-.0542.0542-.11426.10107-.16944.15332-.1333.126-.26611.25244-.4082.36914-.06689.05517-.13867.10254-.207.15527-.13916.10693-.27686.21484-.42285.313-.05616.0376-.11621.06885-.17334.105-.16358.104-.32813.207-.49951.29883-.04248.023-.08692.041-.12989.0625-.18945.09765-.38135.1914-.57959.27392-.02832.01221-.05859.02051-.0874.03223-.2124.08545-.42725.16455-.64844.23193-.02929.00928-.05957.01465-.08886.02295-.21973.064-.44141.12256-.668.168-.06543.01319-.13282.01856-.19873.03028-.19092.0332-.38184.06689-.57715.08593a7.89257,7.89257,0,0,1-1.59766,0c-.19531-.019-.38623-.05273-.57715-.08593-.06591-.01172-.1333-.01709-.19873-.03028-.22656-.04541-.44824-.104-.668-.168-.02929-.0083-.05957-.01367-.08886-.02295-.22168-.06738-.438-.14746-.65088-.23291-.02783-.01123-.05713-.01953-.085-.03125-.19824-.08252-.39014-.17627-.58008-.27392-.04248-.022-.08692-.03955-.1294-.0625-.17138-.0918-.33593-.19483-.49951-.29883-.05713-.03613-.11718-.06738-.17334-.105-.146-.09815-.28369-.20606-.42285-.313-.06836-.05273-.14014-.1001-.207-.15527-.13818-.11328-.26709-.23731-.39746-.35938-.05908-.05566-.12256-.10547-.18018-.16308L88.40186,155.71582a8.00035,8.00035,0,0,1,11.314-11.31445L120,164.686V104a8,8,0,0,1,16,0v60.686l20.28418-20.28467a8.00035,8.00035,0,0,1,11.314,11.31445ZM52.94434,64l8-16H195.05566l8,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "94.059 150.059 128 184 161.941 150.059",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArchiveTray = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V159.88379c-.00049.03906-.00586.07715-.00586.11621s.00537.07715.00586.11621V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM88.40234,112.40137a8.0018,8.0018,0,0,1,11.31348,0L120,132.686V72a8,8,0,0,1,16,0v60.686l20.28418-20.28467a8.00035,8.00035,0,0,1,11.314,11.31445l-33.94091,33.94141c-.0542.0542-.11426.10107-.16944.15332-.1333.126-.26611.25244-.4082.36914-.06689.05517-.13867.10254-.207.15527-.13916.10693-.27686.21484-.42285.313-.05616.0376-.11621.06885-.17334.105-.16358.104-.32813.207-.49951.29883-.04248.023-.08692.041-.12989.0625-.18945.09765-.38135.1914-.57959.27392-.02832.01221-.05859.02051-.0874.03223-.2124.08545-.42725.16455-.64844.23193-.02929.00928-.05957.01465-.08886.02295-.21973.064-.44141.12256-.668.168-.06543.01319-.13282.01856-.19873.03028-.19092.0332-.38184.06689-.57715.08593a7.89257,7.89257,0,0,1-1.59766,0c-.19531-.019-.38623-.05273-.57715-.08593-.06591-.01172-.1333-.01709-.19873-.03028-.22656-.04541-.44824-.104-.668-.168-.02929-.0083-.05957-.01367-.08886-.02295-.22168-.06738-.438-.14746-.65088-.23291-.02783-.01123-.05713-.01953-.085-.03125-.19824-.08252-.39014-.17627-.58008-.27392-.04248-.022-.08692-.03955-.1294-.0625-.17138-.0918-.33593-.19483-.49951-.29883-.05713-.03613-.11718-.06738-.17334-.105-.146-.09815-.28369-.20606-.42285-.313-.06836-.05273-.14014-.1001-.207-.15527-.13818-.11328-.26709-.23731-.39746-.35938-.05908-.05566-.12256-.10547-.18018-.16308L88.40186,123.71582A8.00076,8.00076,0,0,1,88.40234,112.40137ZM208,208H48V168l28.68066-.001,19.31446,19.31641A15.89834,15.89834,0,0,0,107.30762,192h41.373a15.89606,15.89606,0,0,0,11.31348-4.68652L179.30762,168h28.6997l.00245,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "94.059 118.059 128 152 161.941 118.059",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArmchair = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M48,80a48.07871,48.07871,0,0,1,47.3335,40h65.333A47.95539,47.95539,0,0,1,216,80.6792V72a40.04521,40.04521,0,0,0-40-40H80A40.04521,40.04521,0,0,0,40,72v8.6792A48.11745,48.11745,0,0,1,48,80Z"
        }), React.createElement("path", {
          d: "M239.93188,126.01025c-.02233-.36181-.04809-.72265-.08251-1.08154-.01563-.165-.03455-.3291-.05274-.49316q-.05933-.53247-.135-1.05957c-.02124-.14551-.04248-.291-.06555-.43555q-.09558-.59985-.21338-1.19141c-.01758-.08886-.03332-.17773-.05164-.26611A32.00094,32.00094,0,0,0,176,128v40a8,8,0,0,1-16,0V136H96v32a8,8,0,0,1-16,0V128a32.00094,32.00094,0,0,0-63.331-6.51709c-.01832.08838-.03406.17725-.05164.26611q-.11773.5918-.21338,1.19141c-.02307.14453-.04443.29-.06555.43555q-.07655.52661-.135,1.05957c-.01819.16406-.03711.32812-.05274.49316-.03442.35889-.06018.71973-.08251,1.08154-.00928.15137-.022.30176-.02906.45362C16.01477,126.97314,16,127.48486,16,128a32.01333,32.01333,0,0,0,24,30.9917V200a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V158.9917A32.01319,32.01319,0,0,0,240,128c0-.51514-.01477-1.02686-.03906-1.53613C239.95386,126.312,239.94116,126.16162,239.93188,126.01025Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,168V128a32,32,0,1,0-32,32v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160a32,32,0,1,0-32-32v40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowArcLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,184a8,8,0,0,1-16,0A87.99083,87.99083,0,0,0,71.69507,116.38086l26.08032,26.08008a8.00064,8.00064,0,0,1-5.65723,13.65722h-64a8.0004,8.0004,0,0,1-8-8v-64a8.00065,8.00065,0,0,1,13.65723-5.65722L60.333,105.01855A104.00326,104.00326,0,0,1,232,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "92.118 148.118 28.118 148.118 28.118 84.118",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,184A96,96,0,0,0,60.11775,116.11775l-32,32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowArcRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M235.88184,84.11816v64a8.0004,8.0004,0,0,1-8,8h-64a8.00064,8.00064,0,0,1-5.65723-13.65722l26.08032-26.08008A87.99487,87.99487,0,0,0,40,184a8,8,0,0,1-16,0,104.00481,104.00481,0,0,1,171.667-78.98145l26.55762-26.55761a8.00065,8.00065,0,0,1,13.65723,5.65722Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "163.882 148.118 227.882 148.118 227.882 84.118",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,184a96,96,0,0,1,163.88225-67.88229l32,32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendDoubleUpLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M85.65723,146.34277a8.00053,8.00053,0,0,1-11.31446,11.31446l-48-48a8.00122,8.00122,0,0,1,0-11.31446l48-48A8.00053,8.00053,0,0,1,85.65723,61.65723L43.31348,104ZM136,96.30469V56a8.00066,8.00066,0,0,0-13.65723-5.65723l-48,48a8.00122,8.00122,0,0,0,0,11.31446l48,48A8.00065,8.00065,0,0,0,136,152V112.36768A88.11673,88.11673,0,0,1,216,200a8,8,0,0,0,16,0A104.13965,104.13965,0,0,0,136,96.30469Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "128 152 80 104 128 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,200a96,96,0,0,0-96-96H80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendDoubleUpRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65723,109.65723l-48,48a8.00053,8.00053,0,0,1-11.31446-11.31446L212.68652,104,170.34277,61.65723a8.00053,8.00053,0,0,1,11.31446-11.31446l48,48A8.00122,8.00122,0,0,1,229.65723,109.65723Zm-48-11.31446-48-48A8.00066,8.00066,0,0,0,120,56V96.30469A104.13965,104.13965,0,0,0,24,200a8,8,0,0,0,16,0,88.11673,88.11673,0,0,1,80-87.63232V152a8.00053,8.00053,0,0,0,13.65723,5.65723l48-48A8.00122,8.00122,0,0,0,181.65723,98.34277Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "128 152 176 104 128 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,200a96,96,0,0,1,96-96h48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendDownLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,56A104.11791,104.11791,0,0,1,128,160H88v40a8.00053,8.00053,0,0,1-13.65723,5.65723l-48-48a8.00122,8.00122,0,0,1,0-11.31446l48-48A8.00065,8.00065,0,0,1,88,104v40h40a88.09957,88.09957,0,0,0,88-88,8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "80 104 32 152 80 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,56a96,96,0,0,1-96,96H32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendDownRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65723,157.65723l-48,48A8.00066,8.00066,0,0,1,168,200V160H128A104.11791,104.11791,0,0,1,24,56a8,8,0,0,1,16,0,88.09957,88.09957,0,0,0,88,88h40V104a8.00065,8.00065,0,0,1,13.65723-5.65723l48,48A8.00122,8.00122,0,0,1,229.65723,157.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176 104 224 152 176 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,56a96,96,0,0,0,96,96h96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendLeftDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32a8.00039,8.00039,0,0,1-8,8,88.09957,88.09957,0,0,0-88,88v40h40a8.00066,8.00066,0,0,1,5.65723,13.65723l-48,48a8.00181,8.00181,0,0,1-11.31446,0l-48-48A8.00065,8.00065,0,0,1,56,168H96V128A104.11791,104.11791,0,0,1,200,24,8.00039,8.00039,0,0,1,208,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "152 176 104 224 56 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,32a96,96,0,0,0-96,96v96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendLeftUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,224a8.00039,8.00039,0,0,1-8,8A104.11791,104.11791,0,0,1,96,128V88H56a8.00065,8.00065,0,0,1-5.65723-13.65723l48-48a8.003,8.003,0,0,1,11.31446,0l48,48A8.00066,8.00066,0,0,1,152,88H112v40a88.09957,88.09957,0,0,0,88,88A8.00039,8.00039,0,0,1,208,224Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "152 80 104 32 56 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,224a96,96,0,0,1-96-96V32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendRightDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M205.65723,181.65723l-48,48a8.00181,8.00181,0,0,1-11.31446,0l-48-48A8.00065,8.00065,0,0,1,104,168h40V128A88.09957,88.09957,0,0,0,56,40a8,8,0,0,1,0-16A104.11791,104.11791,0,0,1,160,128v40h40a8.00066,8.00066,0,0,1,5.65723,13.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "104 176 152 224 200 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,32a96,96,0,0,1,96,96v96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendRightUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.39062,83.06152A8,8,0,0,1,200,88H160v40A104.11791,104.11791,0,0,1,56,232a8,8,0,0,1,0-16,88.09957,88.09957,0,0,0,88-88V88H104a8.00065,8.00065,0,0,1-5.65723-13.65723l48-48a8.003,8.003,0,0,1,11.31446,0l48,48A8.00028,8.00028,0,0,1,207.39062,83.06152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "104 80 152 32 200 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,224a96,96,0,0,0,96-96V32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendUpLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,200a8,8,0,0,1-16,0,88.09957,88.09957,0,0,0-88-88H88v40a8.00053,8.00053,0,0,1-13.65723,5.65723l-48-48a8.00122,8.00122,0,0,1,0-11.31446l48-48A8.00065,8.00065,0,0,1,88,56V96h40A104.11791,104.11791,0,0,1,232,200Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,200a96,96,0,0,0-96-96H32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowBendUpRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65723,109.65723l-48,48A8.00066,8.00066,0,0,1,168,152V112H128a88.09957,88.09957,0,0,0-88,88,8,8,0,0,1-16,0A104.11791,104.11791,0,0,1,128,96h40V56a8.00065,8.00065,0,0,1,13.65723-5.65723l48,48A8.00122,8.00122,0,0,1,229.65723,109.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,200a96,96,0,0,1,96-96h96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowCircleDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm39.59375,115.71875L133.666,173.64648a8.02367,8.02367,0,0,1-11.332,0L88.40625,139.71875a7.99915,7.99915,0,0,1,11.3125-11.3125L120,148.6875V88a8,8,0,0,1,16,0v60.6875l20.28125-20.28125a7.99915,7.99915,0,0,1,11.3125,11.3125Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "94.059 134.059 128 168 161.941 134.059",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowCircleDownLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm33.65625,81.65625L119.3125,148H148a8,8,0,0,1,0,16H100a8.02752,8.02752,0,0,1-8-8V108a8,8,0,0,1,16,0v28.6875l42.34375-42.34375a7.99915,7.99915,0,0,1,11.3125,11.3125Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "100 108 100 156 148 156",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowCircleDownRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,132a8.02752,8.02752,0,0,1-8,8H108a8,8,0,0,1,0-16h28.6875L94.34375,105.65625a7.99915,7.99915,0,0,1,11.3125-11.3125L148,136.6875V108a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowCircleLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm40,112H107.3125l20.28125,20.28125a7.99915,7.99915,0,1,1-11.3125,11.3125L82.35352,133.666a8.02367,8.02367,0,0,1,0-11.332l33.92773-33.92773a7.99915,7.99915,0,0,1,11.3125,11.3125L107.3125,120H168a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "121.941 161.941 88 128 121.941 94.059",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowCircleRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm47.38477,107.05469a7.99866,7.99866,0,0,1-1.73829,2.61133l-33.92773,33.92773a7.99915,7.99915,0,0,1-11.3125-11.3125L148.6875,136H88a8,8,0,0,1,0-16h60.6875L128.40625,99.71875a7.99915,7.99915,0,0,1,11.3125-11.3125L173.64648,122.334a8.02367,8.02367,0,0,1,1.73829,8.72071Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "134.059 161.941 168 128 134.059 94.059",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowCircleUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm39.59375,103.59375a7.99708,7.99708,0,0,1-11.3125,0L136,107.3125V168a8,8,0,0,1-16,0V107.3125L99.71875,127.59375a7.99915,7.99915,0,0,1-11.3125-11.3125L122.334,82.35352a8.02367,8.02367,0,0,1,11.332,0l33.92773,33.92773A7.99708,7.99708,0,0,1,167.59375,127.59375Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "94.059 121.941 128 88 161.941 121.941",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowCircleUpLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm33.65625,137.65625a7.99708,7.99708,0,0,1-11.3125,0L108,119.3125V148a8,8,0,0,1-16,0V100a8.02752,8.02752,0,0,1,8-8h48a8,8,0,0,1,0,16H119.3125l42.34375,42.34375A7.99708,7.99708,0,0,1,161.65625,161.65625Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowCircleUpRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M201.541,54.458a104,104,0,1,0,0,147.07813A104.10845,104.10845,0,0,0,201.541,54.458ZM163.99414,147.9971a8,8,0,0,1-16,0V119.3096l-42.34375,42.34375a7.99915,7.99915,0,0,1-11.3125-11.3125l42.34375-42.34375h-28.6875a8,8,0,0,1,0-16h48a8.02753,8.02753,0,0,1,8,8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowClockwise = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232.167,51.71582v48a8.00008,8.00008,0,0,1-8,8h-48a8.00037,8.00037,0,0,1-5.65722-13.65674L188.853,75.71582l-4.28467-4.28467a80.00009,80.00009,0,1,0,0,113.1377,8.00018,8.00018,0,1,1,11.31445,11.31347,96.00044,96.00044,0,1,1,0-135.76464l4.28418,4.28418,18.34278-18.34278A8.00009,8.00009,0,0,1,232.167,51.71582Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176.167 99.716 224.167 99.716 224.167 51.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowCounterClockwise = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M195.88281,195.88281a96.11136,96.11136,0,0,1-135.76562,0,8.00052,8.00052,0,0,1,11.31445-11.31445,79.99992,79.99992,0,1,0,0-113.13721L67.147,75.71582,85.49023,94.05908A8.00037,8.00037,0,0,1,79.833,107.71582h-48a8.00008,8.00008,0,0,1-8-8v-48a8.00009,8.00009,0,0,1,13.65722-5.65674L55.833,64.40186l4.28418-4.28418A96.00062,96.00062,0,0,1,195.88281,195.88281Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "79.833 99.716 31.833 99.716 31.833 51.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M205.65674,149.65723l-72,72a8.00063,8.00063,0,0,1-11.31348,0l-72-72A8.0001,8.0001,0,0,1,56,136h64V40a8,8,0,0,1,16,0v96h64a8.0001,8.0001,0,0,1,5.65674,13.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "56 144 128 216 200 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowDownLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M197.65674,69.65723,127.314,140l46.34327,46.34277A8.00038,8.00038,0,0,1,168,200H64a8.00039,8.00039,0,0,1-8-8V88a8.00065,8.00065,0,0,1,13.65723-5.65723L116,128.686l70.34326-70.34327a8.00018,8.00018,0,1,1,11.31348,11.31446Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "192",
          y1: "64",
          x2: "64",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "168 192 64 192 64 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowDownRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,88V192a8.00039,8.00039,0,0,1-8,8H88a8.00038,8.00038,0,0,1-5.65723-13.65723L128.686,140,58.34326,69.65723A8.00018,8.00018,0,0,1,69.65674,58.34277L140,128.686l46.34277-46.34327A8.00065,8.00065,0,0,1,200,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "88 192 192 192 192 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowDownLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,32V176a8.00008,8.00008,0,0,1-8,8H104v40a8.00018,8.00018,0,0,1-13.65723,5.65674l-48-48a8,8,0,0,1,0-11.31348l48-48A8.0001,8.0001,0,0,1,104,128v40h80V32a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "96 128 48 176 96 224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192 32 192 176 48 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowDownRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.65723,181.65674l-48,48A8.0001,8.0001,0,0,1,152,224V184H64a8.00008,8.00008,0,0,1-8-8V32a8,8,0,0,1,16,0V168h80V128a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8,8,0,0,1,213.65723,181.65674Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "160 128 208 176 160 224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "64 32 64 176 208 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M237.65723,101.65723l-96,96a8.00181,8.00181,0,0,1-11.31446,0L60,127.31445,29.65723,157.65723A8.00066,8.00066,0,0,1,16,152V80a8.00039,8.00039,0,0,1,8-8H96a8.00066,8.00066,0,0,1,5.65723,13.65723l-30.343,30.343L136,180.68652l90.34277-90.34375a8.00053,8.00053,0,0,1,11.31446,11.31446Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "96 80 24 80 24 152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "232 96 136 192 24 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowLeftDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,64a8.00008,8.00008,0,0,1-8,8H88v80h40a8.00038,8.00038,0,0,1,5.65723,13.65674l-48,48a8.00063,8.00063,0,0,1-11.31446,0l-48-48A8.00037,8.00037,0,0,1,32,152H72V64a8.00008,8.00008,0,0,1,8-8H224A8.00008,8.00008,0,0,1,232,64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "128 160 80 208 32 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "224 64 80 64 80 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowLeftUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,192a8.00008,8.00008,0,0,1-8,8H80a8.00008,8.00008,0,0,1-8-8V104H32a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00122,8.00122,0,0,1,11.31446,0l48,48A8.00038,8.00038,0,0,1,128,104H88v80H224A8.00008,8.00008,0,0,1,232,192Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "128 96 80 48 32 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "224 192 80 192 80 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,80v72a8.00053,8.00053,0,0,1-13.65723,5.65723L196,127.31445l-70.34277,70.34278a8.00181,8.00181,0,0,1-11.31446,0l-96-96A8.00053,8.00053,0,0,1,29.65723,90.34277L120,180.68652l64.68579-64.68628-30.343-30.343A8.00065,8.00065,0,0,1,160,72h72A8.00039,8.00039,0,0,1,240,80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "160 80 232 80 232 152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "24 96 120 192 232 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowRightDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65723,165.65674l-48,48a8.00063,8.00063,0,0,1-11.31446,0l-48-48A8.00037,8.00037,0,0,1,128,152h40V72H32a8,8,0,0,1,0-16H176a8.00008,8.00008,0,0,1,8,8v88h40a8.00038,8.00038,0,0,1,5.65723,13.65674Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "128 160 176 208 224 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "32 64 176 64 176 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowRightUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.39062,99.06152A8,8,0,0,1,224,104H184v88a8.00008,8.00008,0,0,1-8,8H32a8,8,0,0,1,0-16H168V104H128a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00122,8.00122,0,0,1,11.31446,0l48,48A7.99949,7.99949,0,0,1,231.39062,99.06152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "128 96 176 48 224 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "32 192 176 192 176 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowUpLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,80V224a8,8,0,0,1-16,0V88H104v40a8.00018,8.00018,0,0,1-13.65723,5.65674l-48-48a8,8,0,0,1,0-11.31348l48-48A8.0001,8.0001,0,0,1,104,32V72h88A8.00008,8.00008,0,0,1,200,80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "192 224 192 80 48 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 128 48 80 96 32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192 224 192 80 48 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowElbowUpRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.65723,85.65674l-48,48A8.0001,8.0001,0,0,1,152,128V88H72V224a8,8,0,0,1-16,0V80a8.00008,8.00008,0,0,1,8-8h88V32a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8,8,0,0,1,213.65723,85.65674Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "160 128 208 80 160 32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "64 224 64 80 208 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65723,141.65723l-96,96a8.003,8.003,0,0,1-11.31446,0l-96-96A8.00065,8.00065,0,0,1,32,128H72V48A16.01833,16.01833,0,0,1,88,32h80a16.01833,16.01833,0,0,1,16,16v80h40a8.00066,8.00066,0,0,1,5.65723,13.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M114.34277,229.65723l-96-96a8.003,8.003,0,0,1,0-11.31446l96-96A8.00065,8.00065,0,0,1,128,32V72h80a16.01833,16.01833,0,0,1,16,16v80a16.01833,16.01833,0,0,1-16,16H128v40a8.00066,8.00066,0,0,1-13.65723,5.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatLineDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65723,141.65723l-96,96a8.003,8.003,0,0,1-11.31446,0l-96-96A8.00065,8.00065,0,0,1,32,128H72V72a8.00039,8.00039,0,0,1,8-8h96a8.00039,8.00039,0,0,1,8,8v56h40a8.00066,8.00066,0,0,1,5.65723,13.65723ZM184,40a8.00039,8.00039,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8.00039,8.00039,0,0,0,184,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatLineLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M114.34277,229.65723l-96-96a8.003,8.003,0,0,1,0-11.31446l96-96A8.00065,8.00065,0,0,1,128,32V72h56a8.00039,8.00039,0,0,1,8,8v96a8.00039,8.00039,0,0,1-8,8H128v40a8.00066,8.00066,0,0,1-13.65723,5.65723ZM216,184a8.00039,8.00039,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8.00039,8.00039,0,0,0,216,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatLineRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132.93848,231.39062A8,8,0,0,1,128,224V184H72a8.00039,8.00039,0,0,1-8-8V80a8.00039,8.00039,0,0,1,8-8h56V32a8.00065,8.00065,0,0,1,13.65723-5.65723l96,96a8.003,8.003,0,0,1,0,11.31446l-96,96A8.002,8.002,0,0,1,132.93848,231.39062ZM48,176V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatLineUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.39062,123.06152A8,8,0,0,1,224,128H184v56a8.00039,8.00039,0,0,1-8,8H80a8.00039,8.00039,0,0,1-8-8V128H32a8.00065,8.00065,0,0,1-5.65723-13.65723l96-96a8.003,8.003,0,0,1,11.31446,0l96,96A8.002,8.002,0,0,1,231.39062,123.06152ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatLinesDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65674,141.65723l-96,96a8.00182,8.00182,0,0,1-11.31348,0l-96-96A8.0001,8.0001,0,0,1,32,128H72V104a8.00008,8.00008,0,0,1,8-8h96a8.00008,8.00008,0,0,1,8,8v24h40a8.0001,8.0001,0,0,1,5.65674,13.65723ZM184,40a8.00008,8.00008,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8.00008,8.00008,0,0,0,184,40Zm0,32a8.00008,8.00008,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8.00008,8.00008,0,0,0,184,72Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "72",
          x2: "80",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatLinesLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M114.34277,229.65674l-96-96a8.00182,8.00182,0,0,1,0-11.31348l96-96A8.0001,8.0001,0,0,1,128,32V72h24a8.00008,8.00008,0,0,1,8,8v96a8.00008,8.00008,0,0,1-8,8H128v40a8.0001,8.0001,0,0,1-13.65723,5.65674ZM216,184a8.00008,8.00008,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8.00008,8.00008,0,0,0,216,184Zm-32,0a8.00008,8.00008,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8.00008,8.00008,0,0,0,184,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "176",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatLinesRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132.93848,231.39111A8.00015,8.00015,0,0,1,128,224V184H104a8.00008,8.00008,0,0,1-8-8V80a8.00008,8.00008,0,0,1,8-8h24V32a8.0001,8.0001,0,0,1,13.65723-5.65674l96,96a8.00182,8.00182,0,0,1,0,11.31348l-96,96A8.00061,8.00061,0,0,1,132.93848,231.39111ZM48,176V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Zm32,0V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72",
          y1: "176",
          x2: "72",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatLinesUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.39111,123.06152A8.00015,8.00015,0,0,1,224,128H184v24a8.00008,8.00008,0,0,1-8,8H80a8.00008,8.00008,0,0,1-8-8V128H32a8.0001,8.0001,0,0,1-5.65674-13.65723l96-96a8.00182,8.00182,0,0,1,11.31348,0l96,96A8.00061,8.00061,0,0,1,231.39111,123.06152ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0-32H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "184",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132.93848,231.39062A8,8,0,0,1,128,224V184H48a16.01833,16.01833,0,0,1-16-16V88A16.01833,16.01833,0,0,1,48,72h80V32a8.00065,8.00065,0,0,1,13.65723-5.65723l96,96a8.003,8.003,0,0,1,0,11.31446l-96,96A8.002,8.002,0,0,1,132.93848,231.39062Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowFatUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.39062,123.06152A8,8,0,0,1,224,128H184v80a16.01833,16.01833,0,0,1-16,16H88a16.01833,16.01833,0,0,1-16-16V128H32a8.00065,8.00065,0,0,1-5.65723-13.65723l96-96a8.003,8.003,0,0,1,11.31446,0l96,96A8.002,8.002,0,0,1,231.39062,123.06152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,128a8.00039,8.00039,0,0,1-8,8H120v64a8.00018,8.00018,0,0,1-13.65674,5.65723l-72-72a8.00034,8.00034,0,0,1,0-11.31446l72-72A8.00037,8.00037,0,0,1,120,56v64h96A8.00039,8.00039,0,0,1,224,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "112 56 40 128 112 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowLineDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M50.34326,117.65283A7.99981,7.99981,0,0,1,56,103.99609h64v-72a8,8,0,0,1,16,0v72h64a7.99981,7.99981,0,0,1,5.65674,13.65674l-72,72a7.99945,7.99945,0,0,1-11.31348,0ZM216,207.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "31.99627",
          x2: "128",
          y2: "183.99627",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "56 111.996 128 183.996 200 111.996",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "215.99627",
          x2: "216",
          y2: "215.99627",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowLineDownLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M181.65723,82.34277a8.00122,8.00122,0,0,1,0,11.31446L125.31445,150l44.34278,44.34277A8.00038,8.00038,0,0,1,164,208H64a8.00039,8.00039,0,0,1-8-8V100a8.00065,8.00065,0,0,1,13.65723-5.65723L114,138.68579l56.34277-56.343A8.003,8.003,0,0,1,181.65723,82.34277ZM216,32.00391H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "176",
          y1: "88",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "64 100 64 200 164 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "40.00373",
          x2: "40",
          y2: "40.00373",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowLineDownRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,100V200a8.00039,8.00039,0,0,1-8,8H92a8.00038,8.00038,0,0,1-5.65723-13.65723L130.686,150,74.34277,93.65674A8.00018,8.00018,0,1,1,85.65723,82.34326L142,138.686l44.34277-44.34278A8.0001,8.0001,0,0,1,200,100Zm16-67.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "80",
          y1: "88",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192 100 192 200 92 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "40.00373",
          x2: "216",
          y2: "40.00373",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowLineLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232.00391,128a8.00009,8.00009,0,0,1-8,8h-72v64a8.00018,8.00018,0,0,1-13.65723,5.65674l-72-72a8,8,0,0,1,0-11.31348l72-72A8.0001,8.0001,0,0,1,152.00391,56v64h72A8.00009,8.00009,0,0,1,232.00391,128ZM40,32a8.00008,8.00008,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8.00008,8.00008,0,0,0,40,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "224.00373",
          y1: "128",
          x2: "72.00373",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "144.004 56 72.004 128 144.004 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowLineRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M189.65332,122.34326a8,8,0,0,1,0,11.31348l-72,72A8.0001,8.0001,0,0,1,103.99609,200V136h-72a8,8,0,0,1,0-16h72V56a8.0001,8.0001,0,0,1,13.65723-5.65674ZM216,32a8.00008,8.00008,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8.00008,8.00008,0,0,0,216,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "31.99627",
          y1: "128",
          x2: "183.99627",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "111.996 56 183.996 128 111.996 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowLineUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M205.65674,138.34717A7.99981,7.99981,0,0,1,200,152.00391H136v72a8,8,0,1,1-16,0v-72H56a7.99981,7.99981,0,0,1-5.65674-13.65674l72-72a8,8,0,0,1,11.31348,0ZM216,32H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "224.00373",
          x2: "128",
          y2: "72.00373",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "56 144.004 128 72.004 200 144.004",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowLineUpLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56,156V56a8.00008,8.00008,0,0,1,8-8H164a8.0001,8.0001,0,0,1,5.65723,13.65674L125.31348,106l56.34375,56.34326a8.00018,8.00018,0,0,1-11.31446,11.31348L114,117.31372l-44.34277,44.343A8.0001,8.0001,0,0,1,56,156Zm160,51.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "176",
          y1: "168",
          x2: "64",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "64 156 64 56 164 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "215.99627",
          x2: "40",
          y2: "215.99627",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowLineUpRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M74.34277,173.65674a8,8,0,0,1,0-11.31348L130.68652,106,86.34277,61.65674A8.0001,8.0001,0,0,1,92,48H192a8.00008,8.00008,0,0,1,8,8V156a8.00018,8.00018,0,0,1-13.65723,5.65674L142,117.31372l-56.34277,56.343a8.00063,8.00063,0,0,1-11.31446,0ZM216,207.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "80",
          y1: "168",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192 156 192 56 92 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "215.99627",
          x2: "216",
          y2: "215.99627",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.65674,133.65723l-72,72A8.00038,8.00038,0,0,1,136,200V136H40a8,8,0,0,1,0-16h96V56a8.00037,8.00037,0,0,1,13.65674-5.65723l72,72A8.00034,8.00034,0,0,1,221.65674,133.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "144 56 216 128 144 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99414,32h-160a16.01583,16.01583,0,0,0-16,16V208a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16V48A16.01582,16.01582,0,0,0,207.99414,32ZM167.60352,139.71875l-33.94336,33.92773a8.02367,8.02367,0,0,1-11.332,0L88.40039,139.71875a7.99915,7.99915,0,0,1,11.3125-11.3125l20.28125,20.28125V88a8,8,0,1,1,16,0v60.69238L156.291,128.40625a7.99915,7.99915,0,0,1,11.3125,11.3125Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "94.059 134.059 128 168 161.941 134.059",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareDownLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,208V48a16.01833,16.01833,0,0,0-16-16H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208A16.01833,16.01833,0,0,0,224,208ZM161.65674,105.65723,119.314,148H148a8,8,0,0,1,0,16H100c-.05981,0-.11768-.00781-.17725-.00879-.20251-.00488-.405-.01123-.60693-.03076-.13867-.01367-.27344-.03857-.41-.05908-.12171-.01856-.24366-.03174-.36451-.05567-.14636-.02881-.2882-.06884-.43151-.10547-.10938-.02783-.21949-.05175-.32789-.084-.13732-.042-.27014-.09277-.40429-.1416-.11231-.04053-.22547-.07715-.33618-.123-.12281-.05078-.24073-.11035-.36036-.167-.1173-.05566-.23559-.10742-.35058-.169-.11231-.06054-.219-.1289-.32813-.19384-.11523-.06885-.23181-.13428-.34423-.20948-.1167-.07812-.22669-.165-.339-.249-.09681-.07227-.19629-.13965-.29053-.21728-.1825-.14991-.35657-.30909-.525-.47413-.01953-.01953-.041-.03515-.0603-.05468-.01672-.01661-.03052-.03516-.04712-.05225-.168-.1709-.32959-.34766-.48169-.53271-.08007-.09766-.14966-.2002-.22436-.3003-.0813-.10888-.166-.21582-.242-.3291-.07788-.11621-.1455-.2373-.21655-.35644-.0625-.105-.12829-.207-.186-.315-.06482-.12109-.11988-.2456-.178-.36914-.05322-.11328-.10987-.22461-.158-.34033-.04956-.11963-.0896-.24219-.13318-.36377-.04468-.125-.09253-.24756-.13123-.375-.0371-.123-.06433-.24756-.09545-.37158-.03235-.12891-.06861-.25635-.09449-.38721-.02881-.145-.04614-.2915-.06677-.4375-.01587-.1123-.03747-.22265-.04858-.33642-.026-.26367-.03992-.52832-.03992-.793V108a8,8,0,0,1,16,0v28.686l42.34326-42.34327a8.00018,8.00018,0,1,1,11.31348,11.31446Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "148 156 100 156 100 108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareDownRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M48,224H208a16.01833,16.01833,0,0,0,16-16V48a16.01833,16.01833,0,0,0-16-16H48A16.01833,16.01833,0,0,0,32,48V208A16.01833,16.01833,0,0,0,48,224ZM94.34326,94.34277a8.00063,8.00063,0,0,1,11.31348,0L148,136.686V108a8,8,0,0,1,16,0v47.99756c0,.26465-.01392.5293-.03992.793-.01111.11377-.03271.22412-.04858.33642-.02063.146-.038.29248-.06677.4375-.02588.13086-.06214.2583-.09449.38721-.03112.124-.05835.24854-.09545.37158-.0387.12744-.08655.25-.13123.375-.04358.12158-.08362.24414-.13318.36377-.04809.11572-.10474.22705-.158.34033-.0581.12354-.11316.248-.178.36914-.05774.10791-.12353.21-.186.315-.07105.11914-.13867.24023-.21655.35644-.07593.11328-.16065.22022-.242.3291-.0747.1001-.14429.20264-.22436.3003-.1521.185-.31372.36181-.48169.53271-.0166.01709-.0304.03564-.04712.05225-.01929.01953-.04077.03515-.0603.05468-.16846.165-.34253.32422-.525.47413-.09424.07763-.19372.145-.29053.21728-.1123.084-.22229.1709-.339.249-.11242.0752-.229.14063-.34423.20948-.10913.06494-.21582.1333-.32813.19384-.115.06153-.23328.11329-.35058.169-.11963.05664-.23755.11621-.36036.167-.11071.0459-.22387.08252-.33618.123-.13415.04883-.267.09961-.40429.1416-.1084.03223-.21851.05615-.32789.084-.14331.03663-.28515.07666-.43151.10547-.12085.02393-.2428.03711-.36451.05567-.13659.02051-.27136.04541-.41.05908-.2019.01953-.40442.02588-.60693.03076-.05957.001-.11744.00879-.17725.00879H108a8,8,0,0,1,0-16h28.686L94.34326,105.65723A8.00034,8.00034,0,0,1,94.34326,94.34277Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareIn = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M119.99219,144.00684,120,203.999a8.00018,8.00018,0,0,1-13.65674,5.65821l-24.3435-24.34375L45.62793,221.68555a8.00018,8.00018,0,0,1-11.31348-11.31446L70.68579,174,46.34326,149.65723A8.00038,8.00038,0,0,1,52,136h.001l59.99218.00781A8,8,0,0,1,119.99219,144.00684ZM208,32H72A16.01833,16.01833,0,0,0,56,48V96a8,8,0,0,0,16,0V48H208V184H160a8,8,0,0,0,0,16h48a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "112 204 111.992 144.008 52 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "39.9714",
          y1: "216.0286",
          x2: "111.9714",
          y2: "144.0286",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,207.99414v-160a16.01583,16.01583,0,0,0-16-16H48a16.01583,16.01583,0,0,0-16,16v160a16.01582,16.01582,0,0,0,16,16H208A16.01582,16.01582,0,0,0,224,207.99414ZM116.28125,167.60352,82.35352,133.66016a8.02367,8.02367,0,0,1,0-11.332l33.92773-33.92773a7.99915,7.99915,0,0,1,11.3125,11.3125L107.3125,119.99414H168a8,8,0,1,1,0,16H107.30762L127.59375,156.291a7.99915,7.99915,0,0,1-11.3125,11.3125Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "121.941 94.059 88 128 121.941 161.941",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareOut = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,99.999a8.00053,8.00053,0,0,1-13.65723,5.65821L186,81.314l-36.37207,36.37159a8.00018,8.00018,0,1,1-11.31348-11.31446L174.68555,70,150.34277,45.65723A8.00066,8.00066,0,0,1,156,32h.001l59.99218.00781a8,8,0,0,1,7.999,7.999ZM184,136a8.00039,8.00039,0,0,0-8,8v64H48V80h64a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,80V208a16.01833,16.01833,0,0,0,16,16H176a16.01833,16.01833,0,0,0,16-16V144A8.00039,8.00039,0,0,0,184,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "216 100 215.992 40.008 156 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "143.9714",
          y1: "112.0286",
          x2: "215.9714",
          y2: "40.0286",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M48,223.99414H208a16.01582,16.01582,0,0,0,16-16v-160a16.01583,16.01583,0,0,0-16-16H48a16.01583,16.01583,0,0,0-16,16v160A16.01582,16.01582,0,0,0,48,223.99414Zm80.40625-56.39062a7.99708,7.99708,0,0,1,0-11.3125l20.28613-20.29688H88a8,8,0,0,1,0-16h60.6875L128.40625,99.71289a7.99915,7.99915,0,0,1,11.3125-11.3125l33.92773,33.92773a8.02367,8.02367,0,0,1,0,11.332l-33.92773,33.94336A7.99708,7.99708,0,0,1,128.40625,167.60352Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "134.059 94.059 168 128 134.059 161.941",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.99414,208V48a16.01582,16.01582,0,0,0-16-16h-160a16.01583,16.01583,0,0,0-16,16V208a16.01583,16.01583,0,0,0,16,16h160A16.01582,16.01582,0,0,0,223.99414,208Zm-56.39062-80.40625a7.99708,7.99708,0,0,1-11.3125,0l-20.29688-20.28613V168a8,8,0,1,1-16,0V107.3125L99.71289,127.59375a7.99915,7.99915,0,0,1-11.3125-11.3125l33.92773-33.92773a8.02367,8.02367,0,0,1,11.332,0l33.94336,33.92773A7.99708,7.99708,0,0,1,167.60352,127.59375Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "94.059 121.941 128 88 161.941 121.941",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareUpLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM161.65674,161.65723a8.00063,8.00063,0,0,1-11.31348,0L108,119.314V148a8,8,0,0,1-16,0V100.00244c0-.26465.01392-.5293.03992-.793.01111-.11377.03271-.22412.04858-.33642.02063-.146.038-.29248.06677-.4375.02588-.13086.06214-.2583.09449-.38721.03112-.124.05835-.24854.09545-.37158.0387-.12744.08655-.25.13123-.375.04358-.12158.08362-.24414.13318-.36377.04809-.11572.10474-.22705.158-.34033.0581-.12354.11316-.24805.178-.36914.05774-.10791.12353-.21.186-.31495.071-.11914.13867-.24023.21655-.35644.07593-.11328.16065-.22022.242-.3291.0747-.1001.14429-.20264.22436-.3003.1521-.18505.31372-.36181.48169-.53271.0166-.01709.0304-.03564.04712-.05225.01929-.01953.04077-.03515.0603-.05468.16846-.165.34253-.32422.525-.47413.09424-.07763.19372-.145.29053-.21728.1123-.084.22229-.1709.339-.249.11242-.0752.229-.14063.34423-.20948.10913-.06494.21582-.1333.32813-.19384.115-.06153.23328-.11329.35058-.16895.11963-.05664.23755-.11621.36036-.167.11071-.0459.22387-.08252.33618-.12305.13415-.04883.267-.09961.40429-.1416.1084-.03223.21851-.05615.32789-.084.14331-.03663.28515-.07666.43151-.10547.12085-.02393.2428-.03711.36451-.05567.13659-.02051.27136-.04541.41-.05908.2019-.01953.40442-.02588.60693-.03076C99.88232,92.00781,99.94019,92,100,92h48a8,8,0,0,1,0,16H119.314l42.34278,42.34277A8.00034,8.00034,0,0,1,161.65674,161.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowSquareUpRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48a16.01833,16.01833,0,0,0-16-16H48A16.01833,16.01833,0,0,0,32,48ZM94.34326,150.34277,136.686,108H108a8,8,0,0,1,0-16h48c.05981,0,.11768.00781.17725.00879.20251.00488.405.01123.60693.03076.13867.01367.27344.03857.41.05908.12171.01856.24366.03174.36451.05567.14636.02881.2882.06884.43151.10547.10938.02783.21949.05175.32789.084.13732.042.27014.09277.40429.1416.11231.04053.22547.07715.33618.12305.12281.05078.24073.11035.36036.167.1173.05566.23559.10742.35058.16895.11231.06054.219.1289.32813.19384.11523.06885.23181.13428.34423.20948.1167.07812.22669.165.339.249.09681.07227.19629.13965.29053.21728.1825.14991.35657.30909.525.47413.01953.01953.041.03515.0603.05468.01672.01661.03052.03516.04712.05225.168.1709.32959.34766.48169.53271.08007.09766.14966.2002.22436.3003.0813.10888.166.21582.242.3291.07788.11621.1455.2373.21655.35644.0625.105.12829.207.186.31495.06482.12109.11988.2456.178.36914.05322.11328.10987.22461.158.34033.04956.11963.0896.24219.13318.36377.04468.125.09253.24756.13123.375.0371.123.06433.24756.09545.37158.03235.12891.06861.25635.09449.38721.02881.145.04614.2915.06677.4375.01587.1123.03747.22265.04858.33642.026.26367.03992.52832.03992.793V148a8,8,0,0,1-16,0V119.314l-42.34326,42.34327a8.00018,8.00018,0,0,1-11.31348-11.31446Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowUDownLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,112a64.07207,64.07207,0,0,1-64,64H88v40a8.00018,8.00018,0,0,1-13.65723,5.65674l-48-48a8,8,0,0,1,0-11.31348l48-48A8.0001,8.0001,0,0,1,88,120v40h80a48,48,0,0,0,0-96H80a8,8,0,0,1,0-16h88A64.07207,64.07207,0,0,1,232,112Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "80 120 32 168 80 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,56h88a56,56,0,0,1,56,56v.00011A55.99988,55.99988,0,0,1,168.00011,168H32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowUDownRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65723,173.65674l-48,48A8.0001,8.0001,0,0,1,168,216V176H88A64,64,0,0,1,88,48h88a8,8,0,0,1,0,16H88a48,48,0,0,0,0,96h80V120a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8,8,0,0,1,229.65723,173.65674Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176 120 224 168 176 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,56H88a56,56,0,0,0-56,56v.00011A55.99988,55.99988,0,0,0,87.99989,168H224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowULeftDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,88v88a8,8,0,0,1-16,0V88a48,48,0,0,0-96,0v80h40a8.00038,8.00038,0,0,1,5.65723,13.65674l-48,48a8.00063,8.00063,0,0,1-11.31446,0l-48-48A8.00037,8.00037,0,0,1,40,168H80V88a64,64,0,0,1,128,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "136 176 88 224 40 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,176V88a56,56,0,0,0-56-56h-.00011A55.99988,55.99988,0,0,0,88,87.99989V224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowULeftUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,80v88a64,64,0,0,1-128,0V88H40a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00122,8.00122,0,0,1,11.31446,0l48,48A8.00038,8.00038,0,0,1,136,88H96v80a48,48,0,0,0,96,0V80a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "136 80 88 32 40 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,80v88a56,56,0,0,1-56,56h-.00011A55.99988,55.99988,0,0,1,88,168.00011V32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowURightDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.65723,181.65674l-48,48a8.00063,8.00063,0,0,1-11.31446,0l-48-48A8.00037,8.00037,0,0,1,120,168h40V88a48,48,0,0,0-96,0v88a8,8,0,0,1-16,0V88a64,64,0,0,1,128,0v80h40a8.00038,8.00038,0,0,1,5.65723,13.65674Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "120 176 168 224 216 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,176V88a56,56,0,0,1,56-56h.00011A55.99988,55.99988,0,0,1,168,87.99989V224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowURightUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.39062,83.06152A8,8,0,0,1,216,88H176v80a64,64,0,0,1-128,0V80a8,8,0,0,1,16,0v88a48,48,0,0,0,96,0V88H120a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00034,8.00034,0,0,1,11.31446,0l48,48A7.99931,7.99931,0,0,1,223.39062,83.06152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "120 80 168 32 216 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,80v88a56,56,0,0,0,56,56h.00011A55.99988,55.99988,0,0,0,168,168.00011V32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowUUpLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,144a64.07239,64.07239,0,0,1-64,64H80a8,8,0,0,1,0-16h88a48,48,0,0,0,0-96H88v40a8.00018,8.00018,0,0,1-13.65723,5.65674l-48-48a8,8,0,0,1,0-11.31348l48-48A8.0001,8.0001,0,0,1,88,40V80h80A64.07207,64.07207,0,0,1,232,144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "80 136 32 88 80 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,200h88a56,56,0,0,0,56-56v-.00011A55.99988,55.99988,0,0,0,168.00011,88H32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowUUpRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,136V96H88a48,48,0,0,0,0,96h88a8,8,0,0,1,0,16H88A64,64,0,0,1,88,80h80V40a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48a8,8,0,0,1,0,11.31348l-48,48A8.0001,8.0001,0,0,1,168,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176 136 224 88 176 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,200H88a56,56,0,0,1-56-56v-.00011A55.99988,55.99988,0,0,1,87.99989,88H224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.39111,115.06152A8.00065,8.00065,0,0,1,200,120H136v96a8,8,0,0,1-16,0V120H56a8.0001,8.0001,0,0,1-5.65674-13.65723l72-72a8.00182,8.00182,0,0,1,11.31348,0l72,72A8.00148,8.00148,0,0,1,207.39111,115.06152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "56 112 128 40 200 112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowUpLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M197.65674,197.65723a8.00063,8.00063,0,0,1-11.31348,0L116,127.314,69.65723,173.65723A8.00066,8.00066,0,0,1,56,168V64a8.00039,8.00039,0,0,1,8-8H168a8.00038,8.00038,0,0,1,5.65723,13.65723L127.314,116l70.34278,70.34277A8.00034,8.00034,0,0,1,197.65674,197.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "192",
          y1: "192",
          x2: "64",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "168 64 64 64 64 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowUpRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,64V168a8.00053,8.00053,0,0,1-13.65723,5.65723L140,127.314,69.65674,197.65723a8.00018,8.00018,0,0,1-11.31348-11.31446L128.686,116,82.34277,69.65723A8.00038,8.00038,0,0,1,88,56H192A8.00039,8.00039,0,0,1,200,64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "88 64 192 64 192 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsClockwise = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232.167,51.71582v48a8.00039,8.00039,0,0,1-8,8h-48a8.00065,8.00065,0,0,1-5.65722-13.65723l18.34277-18.34277-4.28418-4.28418a80.08769,80.08769,0,0,0-113.13672,0A8.00052,8.00052,0,0,1,60.11719,60.11719a96.11137,96.11137,0,0,1,135.76562,0l4.28418,4.28418,18.34278-18.34278A8.00065,8.00065,0,0,1,232.167,51.71582ZM184.56836,184.56836a80.08769,80.08769,0,0,1-113.13672,0l-4.28418-4.28418,18.34277-18.34277A8.00065,8.00065,0,0,0,79.833,148.28418h-48a8.00039,8.00039,0,0,0-8,8v48a8.00052,8.00052,0,0,0,13.65722,5.65723L55.833,191.59863l4.28418,4.28418a96.11136,96.11136,0,0,0,135.76562,0,8.00052,8.00052,0,0,0-11.31445-11.31445Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176.167 99.716 224.167 99.716 224.167 51.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M65.7746,65.7746a88,88,0,0,1,124.4508,0l33.94112,33.94113",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "79.833 156.284 31.833 156.284 31.833 204.284",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M190.2254,190.2254a88,88,0,0,1-124.4508,0L31.83348,156.28427",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsCounterClockwise = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M79.833,107.71582h-48a8.00008,8.00008,0,0,1-8-8v-48a8.00009,8.00009,0,0,1,13.65722-5.65674L55.833,64.40186l4.28418-4.28418a96.10959,96.10959,0,0,1,135.76562,0,8.00018,8.00018,0,1,1-11.31445,11.31347,80.09125,80.09125,0,0,0-113.13672,0L67.147,75.71582,85.49023,94.05908A8.00037,8.00037,0,0,1,79.833,107.71582Zm144.334,40.56836h-48a8.00037,8.00037,0,0,0-5.65722,13.65674L188.853,180.28418l-4.28467,4.28467a80.09125,80.09125,0,0,1-113.13672,0,8.00018,8.00018,0,0,0-11.31445,11.31347,96.11017,96.11017,0,0,0,135.76562,0l4.28418-4.28418,18.34278,18.34278a8.00009,8.00009,0,0,0,13.65722-5.65674v-48A8.00008,8.00008,0,0,0,224.167,148.28418Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "79.833 99.716 31.833 99.716 31.833 51.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M190.2254,65.7746a88,88,0,0,0-124.4508,0L31.83348,99.71573",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "176.167 156.284 224.167 156.284 224.167 204.284",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M65.7746,190.2254a88,88,0,0,0,124.4508,0l33.94112-33.94113",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsDownUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M119.39062,172.93848a8.00028,8.00028,0,0,1-1.73339,8.71875l-32,32a8.00181,8.00181,0,0,1-11.31446,0l-32-32A8.00065,8.00065,0,0,1,48,168H72V48a8,8,0,0,1,16,0V168h24A8,8,0,0,1,119.39062,172.93848Zm94.26661-98.59571-32-32a8.00122,8.00122,0,0,0-11.31446,0l-32,32A8.00065,8.00065,0,0,0,144,88h24V208a8,8,0,0,0,16,0V88h24a8.00066,8.00066,0,0,0,5.65723-13.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "112 176 80 208 48 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "144 80 176 48 208 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "208.00006",
          x2: "176",
          y2: "48.00006",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsIn = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M144,104V64a8.0001,8.0001,0,0,1,13.65723-5.65674L172,72.686l30.34277-30.34278a8.00018,8.00018,0,0,1,11.31446,11.31348L183.314,84l14.34327,14.34326A8.00038,8.00038,0,0,1,192,112H152A8.00008,8.00008,0,0,1,144,104Zm-40,40H64a8.00038,8.00038,0,0,0-5.65723,13.65674L72.686,172,42.34277,202.34277a8.00053,8.00053,0,0,0,11.31446,11.31446L84,183.31421l14.34277,14.343A8.00066,8.00066,0,0,0,112,192V152A8.00008,8.00008,0,0,0,104,144Zm79.314,28,14.34327-14.34326A8.00038,8.00038,0,0,0,192,144H152a8.00008,8.00008,0,0,0-8,8v40a8.00053,8.00053,0,0,0,13.65723,5.65723L172,183.31421l30.34277,30.343a8.00053,8.00053,0,0,0,11.31446-11.31446ZM107.06152,56.60889a7.9999,7.9999,0,0,0-8.71875,1.73437L84,72.686,53.65723,42.34326A8.00018,8.00018,0,1,0,42.34277,53.65674L72.686,84,58.34277,98.34326A8.00038,8.00038,0,0,0,64,112h40a8.00008,8.00008,0,0,0,8-8V64A8.00015,8.00015,0,0,0,107.06152,56.60889Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "192 104 152 104 152 64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "64 152 104 152 104 192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 192 152 152 192 152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "208",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "104 64 104 104 64 104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "48",
          x2: "104",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsInCardinal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M161.94141,182.627a8.00066,8.00066,0,0,1-5.65723,13.65723H136V232a8,8,0,0,1-16,0V196.28418H99.71582A8.00066,8.00066,0,0,1,94.05859,182.627l28.28418-28.28418a8.003,8.003,0,0,1,11.31446,0Zm-39.59864-80.96972a8.00181,8.00181,0,0,0,11.31446,0l28.28418-28.28418a8.00066,8.00066,0,0,0-5.65723-13.65723H136V24a8,8,0,0,0-16,0V59.71582H99.71582a8.00066,8.00066,0,0,0-5.65723,13.65723Zm-20.68554,20.68554L73.37305,94.05859a8.00066,8.00066,0,0,0-13.65723,5.65723V120H24a8,8,0,0,0,0,16H59.71582v20.28418a8.00053,8.00053,0,0,0,13.65723,5.65723l28.28418-28.28418A8.00122,8.00122,0,0,0,101.65723,122.34277ZM232,120H196.28418V99.71582A8.00066,8.00066,0,0,0,182.627,94.05859l-28.28418,28.28418a8.00122,8.00122,0,0,0,0,11.31446L182.627,161.94141a8.00066,8.00066,0,0,0,13.65723-5.65723V136H232a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "156.284 188.284 128 160 99.716 188.284",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "99.716 67.716 128 96 156.284 67.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "67.716 156.284 96 128 67.716 99.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "188.284 99.716 160 128 188.284 156.284",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "232",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsInLineHorizontal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM69.65723,90.34277A8.00066,8.00066,0,0,0,56,96v24H16a8,8,0,0,0,0,16H56v24a8.00053,8.00053,0,0,0,13.65723,5.65723l32-32a8.00122,8.00122,0,0,0,0-11.31446ZM240,120H200V96a8.00066,8.00066,0,0,0-13.65723-5.65723l-32,32a8.00122,8.00122,0,0,0,0,11.31446l32,32A8.00066,8.00066,0,0,0,200,160V136h40a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "64 96 96 128 64 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "240",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192 160 160 128 192 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsInLineVertical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,128a8.00039,8.00039,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8.00039,8.00039,0,0,1,224,128ZM122.34277,101.65723a8.00181,8.00181,0,0,0,11.31446,0l32-32A8.00066,8.00066,0,0,0,160,56H136V16a8,8,0,0,0-16,0V56H96a8.00066,8.00066,0,0,0-5.65723,13.65723Zm11.31446,52.68554a8.003,8.003,0,0,0-11.31446,0l-32,32A8.00066,8.00066,0,0,0,96,200h24v40a8,8,0,0,0,16,0V200h24a8.00066,8.00066,0,0,0,5.65723-13.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "160 64 128 96 96 64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "240",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 192 128 160 160 192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsInSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.65723,53.65723,187.31445,80l18.34278,18.34277A8.00066,8.00066,0,0,1,200,112H152a8.00039,8.00039,0,0,1-8-8V56a8.00066,8.00066,0,0,1,13.65723-5.65723L176,68.68555l26.34277-26.34278a8.00053,8.00053,0,0,1,11.31446,11.31446ZM104,144H56a8.00066,8.00066,0,0,0-5.65723,13.65723L68.68555,176,42.34277,202.34277a8.00053,8.00053,0,0,0,11.31446,11.31446L80,187.31445l18.34277,18.34278A8.00066,8.00066,0,0,0,112,200V152A8.00039,8.00039,0,0,0,104,144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "152 56 152 104 200 104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "56 152 104 152 104 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsLeftRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.65723,181.65723l-32,32A8.00038,8.00038,0,0,1,168,208V184H48a8,8,0,0,1,0-16H168V144a8.00038,8.00038,0,0,1,13.65723-5.65723l32,32A8.00122,8.00122,0,0,1,213.65723,181.65723Zm-139.31446-64A8.00038,8.00038,0,0,0,88,112V88H208a8,8,0,0,0,0-16H88V48a8.00038,8.00038,0,0,0-13.65723-5.65723l-32,32a8.00122,8.00122,0,0,0,0,11.31446Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176 144 208 176 176 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "176",
          x2: "208",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "80 112 48 80 80 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208.00006",
          y1: "80",
          x2: "48.00006",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsOut = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,48V88a8.00018,8.00018,0,0,1-13.65723,5.65674L188,79.314l-30.34277,30.34278a8.00018,8.00018,0,0,1-11.31446-11.31348L176.686,68,162.34277,53.65674A8.00037,8.00037,0,0,1,168,40h40A8.00008,8.00008,0,0,1,216,48ZM98.34277,146.34326,68,176.686,53.65723,162.34326A8.0001,8.0001,0,0,0,40,168v40a8.00008,8.00008,0,0,0,8,8H88a8.00038,8.00038,0,0,0,5.65723-13.65674L79.314,188l30.34327-30.34326a8.00018,8.00018,0,0,0-11.31446-11.31348Zm112.71875,14.26563a8.00113,8.00113,0,0,0-8.71875,1.73437L188,176.686l-30.34277-30.34278a8.00018,8.00018,0,0,0-11.31446,11.31348L176.686,188l-14.34327,14.34326A8.00037,8.00037,0,0,0,168,216h40a8.00008,8.00008,0,0,0,8-8V168A8.00015,8.00015,0,0,0,211.06152,160.60889ZM79.314,68,93.65723,53.65674A8.00038,8.00038,0,0,0,88,40H48a8.00008,8.00008,0,0,0-8,8V88a8.00018,8.00018,0,0,0,13.65723,5.65674L68,79.314l30.34277,30.34278a8.00018,8.00018,0,0,0,11.31446-11.31348Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "152",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "104",
          x2: "48",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsOutCardinal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M163.6748,200.6543a7.99949,7.99949,0,0,1-1.73339,8.71826l-28.28418,28.28418a8.00063,8.00063,0,0,1-11.31446,0L94.05859,209.37256a8.00038,8.00038,0,0,1,5.65723-13.65674H120V160a8,8,0,0,1,16,0v35.71582h20.28418A8,8,0,0,1,163.6748,200.6543ZM99.71582,60.28418H120V96a8,8,0,0,0,16,0V60.28418h20.28418a8.00038,8.00038,0,0,0,5.65723-13.65674L133.65723,18.34326a8.00063,8.00063,0,0,0-11.31446,0L94.05859,46.62744a8.00038,8.00038,0,0,0,5.65723,13.65674ZM96,136a8,8,0,0,0,0-16H60.28418V99.71582A8.00038,8.00038,0,0,0,46.627,94.05859L18.34277,122.34326a8,8,0,0,0,0,11.31348L46.627,161.94141a8.00038,8.00038,0,0,0,13.65723-5.65723V136Zm141.65723-13.65674L209.37305,94.05859a8.00038,8.00038,0,0,0-13.65723,5.65723V120H160a8,8,0,0,0,0,16h35.71582v20.28418a8.00018,8.00018,0,0,0,13.65723,5.65723l28.28418-28.28467A8,8,0,0,0,237.65723,122.34326Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "156.284 203.716 128 232 99.716 203.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "99.716 52.284 128 24 156.284 52.284",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "52.284 156.284 24 128 52.284 99.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "203.716 99.716 232 128 203.716 156.284",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsOutLineHorizontal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM96,120H56V96a8.00066,8.00066,0,0,0-13.65723-5.65723l-32,32a8.00122,8.00122,0,0,0,0,11.31446l32,32A8.00066,8.00066,0,0,0,56,160V136H96a8,8,0,0,0,0-16Zm149.65723,2.34277-32-32A8.00066,8.00066,0,0,0,200,96v24H160a8,8,0,0,0,0,16h40v24a8.00053,8.00053,0,0,0,13.65723,5.65723l32-32A8.00122,8.00122,0,0,0,245.65723,122.34277Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "48 160 16 128 48 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 96 240 128 208 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsOutLineVertical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,128a8.00039,8.00039,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8.00039,8.00039,0,0,1,224,128ZM96,56h24V96a8,8,0,0,0,16,0V56h24a8.00066,8.00066,0,0,0,5.65723-13.65723l-32-32a8.003,8.003,0,0,0-11.31446,0l-32,32A8.00066,8.00066,0,0,0,96,56Zm64,144H136V160a8,8,0,0,0-16,0v40H96a8.00066,8.00066,0,0,0-5.65723,13.65723l32,32a8.00181,8.00181,0,0,0,11.31446,0l32-32A8.00066,8.00066,0,0,0,160,200Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 48 128 16 160 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "160 208 128 240 96 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArrowsOutSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,48V96a8.00018,8.00018,0,0,1-13.65723,5.65674L184,83.314l-26.34277,26.34278a8.00018,8.00018,0,0,1-11.31446-11.31348L172.686,72,154.34277,53.65674A8.00038,8.00038,0,0,1,160,40h48A8.00008,8.00008,0,0,1,216,48ZM98.34277,146.34326,72,172.686,53.65723,154.34326A8.0001,8.0001,0,0,0,40,160v48a8.00008,8.00008,0,0,0,8,8H96a8.00038,8.00038,0,0,0,5.65723-13.65674L83.314,184l26.34327-26.34326a8.00018,8.00018,0,0,0-11.31446-11.31348Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "160 48 208 48 208 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 208 48 208 48 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArticle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM180,168H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "76",
          y1: "96",
          x2: "180",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "76",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "76",
          y1: "160",
          x2: "180",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArticleMedium = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M48.02344,128.00094V83.89547l25.21582,40.34571a8.00063,8.00063,0,0,0,13.56836,0l25.21582-40.34571v44.10547a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16h-8v-64h8a8,8,0,0,0,0-16h-16c-.04,0-.07862.00537-.11817.00586-.15478.00244-.3081.01221-.46191.02344-.11768.0083-.23584.01611-.35205.0293-.12793.01513-.2544.03711-.38135.05859-.13769.02246-.27539.04443-.41064.07422-.103.02246-.20459.05176-.30664.07861-.15088.03955-.30176.07862-.44922.12647-.09424.03076-.186.06836-.2793.10254-.11816.04345-.23926.08105-.35449.12988-.02881.01172-.05518.02734-.0835.04-.104.04492-.20459.09814-.30713.14746-.125.06152-.25146.12061-.373.188s-.23877.14355-.35743.21728c-.09619.06006-.19384.11719-.28711.18116-.1289.08837-.25244.18554-.37695.28173-.07812.061-.1582.11914-.23437.18262-.11914.09961-.23243.20752-.3462.31494-.0581.05469-.12109.10449-.17724.16114-.01807.01757-.0332.03759-.05078.05566-.09766.09961-.18994.20557-.28321.31152-.05957.06787-.125.13086-.18261.20069-.02344.02832-.043.05957-.06592.08838-.07373.09228-.14307.189-.21289.28515-.09082.124-.18067.249-.26416.37842-.02149.0332-.04639.063-.06787.09668l-33.21582,53.146-33.21582-53.146c-.02149-.03369-.04639-.06348-.06787-.09668-.0835-.1294-.17334-.2544-.26416-.37842-.06983-.09619-.13916-.19287-.2129-.28515-.02294-.02881-.043-.06006-.06591-.08838-.05762-.06983-.12256-.13282-.18262-.20069-.09326-.10547-.18555-.21191-.2832-.312-.01758-.01758-.03321-.0376-.05078-.05517-.05616-.05616-.11866-.106-.17627-.16065-.11426-.10791-.228-.21582-.34766-.31592-.0752-.063-.1543-.12011-.23193-.18017-.125-.09717-.24952-.19483-.3794-.28369-.09277-.064-.19043-.1211-.28613-.18116-.11865-.07373-.23584-.14941-.35791-.21679-.12256-.06836-.25-.12793-.37647-.19-.10058-.04882-.20019-.10107-.30273-.1455-.02881-.0127-.05566-.02881-.08447-.04053-.1167-.04981-.23926-.08789-.35889-.13184-.09131-.0332-.18164-.06982-.27393-.10009-.14843-.04834-.30127-.08789-.45361-.12745-.10059-.02636-.20068-.05566-.30225-.07812-.1372-.02979-.27636-.05225-.416-.0752-.125-.0205-.249-.04248-.375-.05712-.11817-.01368-.23828-.02149-.35791-.02979-.15186-.01123-.30322-.02051-.45557-.02344-.04052-.00049-.08008-.00586-.1206-.00586h-16a8,8,0,0,0,0,16h8v64h-8a8,8,0,1,0,0,16h24a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M168.02344,112.00094h72a8,8,0,0,0,0-16h-72a8,8,0,0,0,0,16Z"
        }), React.createElement("path", {
          d: "M240.02344,128.00094h-72a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M240.02344,160.00094h-168a8,8,0,0,0,0,16h168a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M240.02344,192.00094h-168a8,8,0,0,0,0,16h168a8,8,0,0,0,0-16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "24.07031",
          y1: "56.00094",
          x2: "40.07031",
          y2: "56.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120.07031",
          y1: "56.00094",
          x2: "136.07031",
          y2: "56.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24.07031",
          y1: "136.00094",
          x2: "48.07031",
          y2: "136.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112.07031",
          y1: "136.00094",
          x2: "136.07031",
          y2: "136.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168.07031",
          y1: "104.00094",
          x2: "240.07031",
          y2: "104.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168.07031",
          y1: "136.00094",
          x2: "240.07031",
          y2: "136.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72.07031",
          y1: "168.00094",
          x2: "240.07031",
          y2: "168.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72.07031",
          y1: "200.00094",
          x2: "240.07031",
          y2: "200.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "40.07 136.001 40.07 56.001 80.07 120.001 120.07 56.001 120.07 136.001",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24.07031",
          y1: "56.00094",
          x2: "40.07031",
          y2: "56.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120.07031",
          y1: "56.00094",
          x2: "136.07031",
          y2: "56.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24.07031",
          y1: "136.00094",
          x2: "48.07031",
          y2: "136.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112.07031",
          y1: "136.00094",
          x2: "136.07031",
          y2: "136.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168.07031",
          y1: "104.00094",
          x2: "240.07031",
          y2: "104.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168.07031",
          y1: "136.00094",
          x2: "240.07031",
          y2: "136.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72.07031",
          y1: "168.00094",
          x2: "240.07031",
          y2: "168.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72.07031",
          y1: "200.00094",
          x2: "240.07031",
          y2: "200.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "40.07 136.001 40.07 56.001 80.07 120.001 120.07 56.001 120.07 136.001",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconArticleNyTimes = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,104a8.00008,8.00008,0,0,1,8-8h80a8,8,0,0,1,0,16H160A8.00008,8.00008,0,0,1,152,104Zm88,24H160a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Zm0,32H160a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Zm0,32H72a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM79.92969,176A55.96817,55.96817,0,0,1,30.43091,93.85059,27.99468,27.99468,0,0,1,47.92969,44a8.00234,8.00234,0,0,1,4.24023,1.21582l61.78174,38.61377A12.00063,12.00063,0,0,0,111.92969,60a8,8,0,0,1,0-16,28,28,0,0,1,0,56,8.00238,8.00238,0,0,1-4.24024-1.21582L77.73535,80.0625A40.00129,40.00129,0,0,0,71.88391,159.187l.04578-44.71826a8.00029,8.00029,0,0,1,8-7.99219h.0083a8.00041,8.00041,0,0,1,7.9917,8.0083l-.04578,44.71875a39.8882,39.8882,0,0,0,30.86755-29.51806,7.99978,7.99978,0,1,1,15.52735,3.8584A55.88761,55.88761,0,0,1,79.92969,176ZM39.88574,80.90771A56.18282,56.18282,0,0,1,58.72546,68.18164L45.90771,60.17041a12.00319,12.00319,0,0,0-6.022,20.7373Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "160",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M126.51493,131.6147A48.00511,48.00511,0,1,1,79.92969,72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "79.92969",
          y1: "114.47668",
          x2: "79.87491",
          y2: "167.89045",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M111.92969,52a20,20,0,0,1,0,40l-64-40a20.00331,20.00331,0,0,0-6.25081,39.00379",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAsterisk = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.21045,165.07178,144,128l64.21045-37.07178a8,8,0,1,0-8-13.85644L136,114.14355V40a8,8,0,0,0-16,0v74.14355L55.78955,77.07178a8,8,0,0,0-8,13.85644L112,128,47.78955,165.07178a8,8,0,1,0,8,13.85644L120,141.85645V216a8,8,0,0,0,16,0V141.85645l64.21045,37.07177a8,8,0,0,0,8-13.85644Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "51.78976",
          y1: "84",
          x2: "204.21024",
          y2: "172",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "51.78976",
          y1: "172",
          x2: "204.21024",
          y2: "84",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAt = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M128,23.99121a104,104,0,1,0,93.78125,148.9364A49.2519,49.2519,0,0,1,204,175.99121c-18.28711,0-28.52441-8.00488-33.8916-14.7207a39.57375,39.57375,0,0,1-3.37793-4.96948A48.00646,48.00646,0,1,1,160,92.2522v-4.261a8,8,0,0,1,16,0v40c0,14.59863,4.85742,32,28,32,22.3457,0,27.64258-16.22314,27.98047-30.4823.00732-.50574.01953-1.01037.01953-1.5177A104.11791,104.11791,0,0,0,128,23.99121Z"
        }), React.createElement("circle", {
          cx: "128",
          cy: "127.99121",
          r: "32"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128.00293",
          cy: "127.99512",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M181.08446,207.99724a96.00809,96.00809,0,1,1,42.91847-80.00212c0,22.09139-8,40-28,40s-28-17.90861-28-40v-40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconAtom = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M196.09521,128a195.65007,195.65007,0,0,0,19.2002-32.71777c11.07715-24.61524,11.21436-44.13575.38574-54.96387C198.23242,22.87354,162.541,35.40918,128,60.00342,93.45947,35.40869,57.76758,22.87256,40.31885,40.31836,29.49023,51.14648,29.62744,70.667,40.70459,95.28223A195.65007,195.65007,0,0,0,59.90479,128a195.65007,195.65007,0,0,0-19.2002,32.71777c-11.07715,24.61524-11.21436,44.13575-.38574,54.96387,5.61767,5.61719,13.12549,8.127,21.87842,8.127,18.4331,0,42.38232-11.1394,65.80273-27.81616,23.42041,16.677,47.36914,27.81616,65.80273,27.81616,8.75,0,16.26172-2.51074,21.87842-8.127,10.82862-10.82812,10.69141-30.34863-.38574-54.96387A195.65007,195.65007,0,0,0,196.09521,128Zm-2.31982-79.7002c4.77539,0,8.39453,1.13575,10.59229,3.333,5.62451,5.624,4.25537,19.48731-3.66309,37.084a172.9306,172.9306,0,0,1-14.79053,25.93188,306.72561,306.72561,0,0,0-21.14453-23.41821,300.50739,300.50739,0,0,0-23.48389-21.13184C163.18457,55.21191,182.00049,48.2998,193.77539,48.2998ZM176.12061,128a288.40831,288.40831,0,0,1-22.66456,25.45508,288.63877,288.63877,0,0,1-25.45459,22.69873A288.50733,288.50733,0,0,1,102.544,153.45508,288.40831,288.40831,0,0,1,79.87939,128,296.26257,296.26257,0,0,1,128,79.84717a288.52058,288.52058,0,0,1,25.45605,22.69775A288.40831,288.40831,0,0,1,176.12061,128ZM55.29541,88.7168c-7.91846-17.59668-9.2876-31.46-3.66309-37.084,2.19776-2.19824,5.815-3.333,10.59229-3.333,11.77539,0,30.59131,6.91285,52.48975,21.79908A300.45376,300.45376,0,0,0,91.23047,91.23047a306.72561,306.72561,0,0,0-21.14453,23.41821A172.9306,172.9306,0,0,1,55.29541,88.7168ZM51.63232,204.36719c-5.62451-5.624-4.25537-19.48731,3.66309-37.084a172.9306,172.9306,0,0,1,14.79053-25.93188,306.72561,306.72561,0,0,0,21.14453,23.41821,300.52025,300.52025,0,0,0,23.4917,21.13233C83.93555,206.83276,59.249,211.98193,51.63232,204.36719Zm152.73536,0c-2.19776,2.19824-5.815,3.333-10.59229,3.333-11.77588-.00123-30.59326-6.91456-52.49316-21.80176a300.51532,300.51532,0,0,0,23.4873-21.12891,306.72561,306.72561,0,0,0,21.14453-23.41821,172.9306,172.9306,0,0,1,14.79053,25.93188C208.62305,184.87988,209.99219,198.74316,204.36768,204.36719ZM140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("ellipse", {
          cx: "128",
          cy: "128",
          rx: "44",
          ry: "116",
          transform: "translate(-53.01934 128) rotate(-45)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("ellipse", {
          cx: "128",
          cy: "128",
          rx: "116",
          ry: "44",
          transform: "translate(-53.01934 128) rotate(-45)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBaby = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M131.92139,24.0813C120.32031,40.37354,120.002,55.87939,120,56.044A8.00006,8.00006,0,0,0,136,56a8,8,0,0,1,16,0,24,24,0,0,1-48,0c0-.72876.125-14.4248,8.57715-30.85474a104.06072,104.06072,0,1,0,19.34424-1.064ZM80,128a12,12,0,1,1,12,12A12,12,0,0,1,80,128Zm78.9668,46.665a56.03047,56.03047,0,0,1-61.93213.001,7.99982,7.99982,0,1,1,8.85742-13.32422,40.03347,40.03347,0,0,0,44.21777-.001A7.99969,7.99969,0,1,1,158.9668,174.665ZM164,140a12,12,0,1,1,12-12A12,12,0,0,1,164,140Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "128",
          r: "12"
        }), React.createElement("path", {
          d: "M154.53832,168.00269a48.03112,48.03112,0,0,1-53.07491.00115",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBackspace = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,39.99805H68.52637a16.1162,16.1162,0,0,0-13.71875,7.76562L9.13574,123.88086a8.02459,8.02459,0,0,0,0,8.23437l45.67188,76.11719v.00781a16.10652,16.10652,0,0,0,13.71875,7.75782H215.99512a16.01583,16.01583,0,0,0,16-16v-144A16.01582,16.01582,0,0,0,215.99512,39.99805ZM165.65137,146.3418a7.99915,7.99915,0,1,1-11.3125,11.3125l-18.34375-18.34375L117.65137,157.6543a7.99915,7.99915,0,0,1-11.3125-11.3125l18.34375-18.34375L106.33887,109.6543a7.99915,7.99915,0,0,1,11.3125-11.3125l18.34375,18.34375L154.33887,98.3418a7.99915,7.99915,0,0,1,11.3125,11.3125l-18.34375,18.34375Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M61.66958,204.116,16,128l45.66958-76.116a8,8,0,0,1,6.85994-3.884H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.52952A8,8,0,0,1,61.66958,204.116Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "104.00005",
          x2: "112",
          y2: "152.00005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "152.00005",
          x2: "112",
          y2: "104.00005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBag = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,64H175.3208a47.99073,47.99073,0,0,0-94.6416,0H40A16.01833,16.01833,0,0,0,24,80V208a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216,64ZM95.99219,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0ZM97.0127,64a32.00443,32.00443,0,0,1,61.9746,0Zm78.97949,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBagSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,64H175.3208a47.99073,47.99073,0,0,0-94.6416,0H40A16.01833,16.01833,0,0,0,24,80V208a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216,64ZM128,40a32.05773,32.05773,0,0,1,30.9873,24H97.0127A32.05773,32.05773,0,0,1,128,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBandaids = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }), React.createElement("path", {
          d: "M184.56836,128l27.71582-27.71558a40,40,0,1,0-56.56836-56.5686L128,71.43164,100.28418,43.71582a39.99987,39.99987,0,1,0-56.56836,56.56836L71.43164,128,43.71582,155.71558a40,40,0,1,0,56.56836,56.5686L128,184.56836l27.71582,27.71582a39.99987,39.99987,0,1,0,56.56836-56.56836ZM128,94.05957,161.94043,128,128,161.94043,94.05957,128ZM167.03027,55.0293a23.99951,23.99951,0,1,1,33.93946,33.9414L173.25439,116.686,139.314,82.74561ZM88.96973,200.9707a23.99951,23.99951,0,1,1-33.93946-33.9414L82.74561,139.314,116.686,173.25439Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M49.37258,94.62742A32,32,0,0,1,94.62742,49.37258l112,112a32,32,0,0,1-45.25484,45.25484Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M161.37258,49.37258a32,32,0,0,1,45.25484,45.25484l-112,112a32,32,0,0,1-45.25484-45.25484Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "4",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18",
          opacity: "0.5"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBank = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248.00244,208a8.00039,8.00039,0,0,1-8,8h-224a8,8,0,0,1,0-16h224A8.00039,8.00039,0,0,1,248.00244,208ZM16.30518,98.17871a7.99868,7.99868,0,0,1,3.50488-8.99219l104-64a7.9998,7.9998,0,0,1,8.38476,0l104,64A8.0001,8.0001,0,0,1,232.00244,104h-24v64h16a8,8,0,0,1,0,16h-192a8,8,0,0,1,0-16h16V104h-24A7.999,7.999,0,0,1,16.30518,98.17871ZM144.00244,160a8,8,0,0,0,16,0V112a8,8,0,1,0-16,0Zm-48,0a8,8,0,0,0,16,0V112a8,8,0,0,0-16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "24.002 96 232.002 96 128.002 32 24.002 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56.00244",
          y1: "96",
          x2: "56.00244",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104.00244",
          y1: "96",
          x2: "104.00244",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152.00244",
          y1: "96",
          x2: "152.00244",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200.00244",
          y1: "96",
          x2: "200.00244",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32.00244",
          y1: "176",
          x2: "224.00244",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16.00244",
          y1: "208",
          x2: "240.00244",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBarbell = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248,120h-8V88a16.01833,16.01833,0,0,0-16-16H208V64a16.01833,16.01833,0,0,0-16-16H168a16.01833,16.01833,0,0,0-16,16v56H104V64A16.01833,16.01833,0,0,0,88,48H64A16.01833,16.01833,0,0,0,48,64v8H32A16.01833,16.01833,0,0,0,16,88v32H8a8,8,0,0,0,0,16h8v32a16.01833,16.01833,0,0,0,16,16H48v8a16.01833,16.01833,0,0,0,16,16H88a16.01833,16.01833,0,0,0,16-16V136h48v56a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16v-8h16a16.01833,16.01833,0,0,0,16-16V136h8a8,8,0,0,0,0-16ZM32,168V88H48v80Zm192,0H208V88h16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "56",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "160",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "232",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "8",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBarcode = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "184 48 224 48 224 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "72 208 32 208 32 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "224 168 224 208 184 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "32 88 32 48 72 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "88",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "88",
          x2: "144",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "88",
          x2: "112",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBaseball = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.24951,60.73486c-.02392.021-.04468.044-.06885.06446a88.76639,88.76639,0,0,0-10.37841,10.37841,8.0001,8.0001,0,1,1-12.21289-10.33691,104.79143,104.79143,0,0,1,11.3872-11.48828,103.80743,103.80743,0,0,0-135.95312,0,104.83246,104.83246,0,0,1,11.387,11.48779,8.00014,8.00014,0,0,1-6.102,13.169h-.00366a7.98253,7.98253,0,0,1-6.10987-2.83106A88.78841,88.78841,0,0,0,48.81592,60.7998c-.02368-.02-.0437-.04248-.0669-.0625a103.77819,103.77819,0,0,0,0,134.52588c.02417-.021.04493-.04443.06958-.06543A88.82286,88.82286,0,0,0,59.197,184.81934,8.00144,8.00144,0,0,1,71.4126,195.15723a104.89749,104.89749,0,0,1-11.38916,11.49023,103.80743,103.80743,0,0,0,135.95312,0,104.83154,104.83154,0,0,1-11.38916-11.49023,8,8,0,1,1,12.21192-10.33789,88.76639,88.76639,0,0,0,10.37841,10.37841c.02539.02149.04688.04541.07178.0669a103.77881,103.77881,0,0,0,0-134.52979ZM79.62866,87.97949A7.99764,7.99764,0,0,1,89.866,92.80518a104.86829,104.86829,0,0,1,4.4851,16.73877,8.00663,8.00663,0,0,1-7.88159,9.42431h-.00366a8.00242,8.00242,0,0,1-7.863-6.57861,88.81047,88.81047,0,0,0-3.79907-14.17676A8.00027,8.00027,0,0,1,79.62866,87.97949Zm14.72315,58.47315a104.886,104.886,0,0,1-4.48487,16.73925,8.003,8.003,0,0,1-7.52954,5.29834h-.00366a8.00492,8.00492,0,0,1-7.52905-10.70556,88.874,88.874,0,0,0,3.79883-14.17774,8.00167,8.00167,0,0,1,15.74829,2.84571Zm82.01391,21.56494a7.993,7.993,0,0,1-10.23291-4.82569,104.83662,104.83662,0,0,1-4.48486-16.73925,8.00011,8.00011,0,0,1,15.74512-2.84571,88.80709,88.80709,0,0,0,3.79834,14.17774A8.00013,8.00013,0,0,1,176.36572,168.01758Zm4.82666-69.8042a88.82819,88.82819,0,0,0-3.79883,14.17676,8.00019,8.00019,0,1,1-15.74511-2.84668,104.80436,104.80436,0,0,1,4.48633-16.73926,7.99986,7.99986,0,1,1,15.05761,5.40918Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M169.172,113.03177a96.58913,96.58913,0,0,1,3.80409-15.5448",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M172.975,158.5097a96.58848,96.58848,0,0,1-3.80352-15.54493",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M86.828,113.03177A96.58913,96.58913,0,0,0,83.02388,97.487",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M83.025,158.5097a96.58848,96.58848,0,0,0,3.80352-15.54493",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M186.79812,70.93634a96.59069,96.59069,0,0,1,9.20058-10.701",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M195.999,195.765a96.59178,96.59178,0,0,1-9.20291-10.70411",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M60.0012,195.76479A96.5897,96.5897,0,0,0,69.204,185.06084",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M69.20188,70.93634A96.59162,96.59162,0,0,0,60.001,60.235",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBasketball = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M59.99512,49.37646A103.57046,103.57046,0,0,1,120,24.30469V120H95.69531A103.84891,103.84891,0,0,0,59.99512,49.37646ZM48.71558,60.77637A103.54348,103.54348,0,0,0,24.30469,120H79.63257A87.91116,87.91116,0,0,0,48.71558,60.77637Zm147.2893-11.39991A103.57046,103.57046,0,0,0,136,24.30469V120h24.30469A103.84891,103.84891,0,0,1,196.00488,49.37646ZM231.69531,120a103.54348,103.54348,0,0,0-24.41089-59.22363A87.91116,87.91116,0,0,0,176.36743,120ZM24.30469,136a103.54348,103.54348,0,0,0,24.41089,59.22363A87.91116,87.91116,0,0,0,79.63257,136Zm182.97973,59.22363A103.54348,103.54348,0,0,0,231.69531,136H176.36743A87.91116,87.91116,0,0,0,207.28442,195.22363ZM59.99512,206.62354A103.57046,103.57046,0,0,0,120,231.69531V136H95.69531A103.84891,103.84891,0,0,1,59.99512,206.62354ZM160.30469,136H136v95.69531a103.57046,103.57046,0,0,0,60.00488-25.07177A103.84891,103.84891,0,0,1,160.30469,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M60,60.23573A95.69771,95.69771,0,0,1,88,128a95.69767,95.69767,0,0,1-27.99925,67.76354",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M196,60.23573a96,96,0,0,0-.00072,135.52781",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBatteryCharging = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M248,88a8.00008,8.00008,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8.00008,8.00008,0,0,0,248,88Z"
        }), React.createElement("path", {
          d: "M200,47.99805H48a24.02624,24.02624,0,0,0-24,24v112a24.02624,24.02624,0,0,0,24,24H200a24.02625,24.02625,0,0,0,24-24v-112A24.02624,24.02624,0,0,0,200,47.99805ZM147.42187,130.9668l-16,40a7.99361,7.99361,0,1,1-14.84375-5.9375l11.60938-29.03125H108a7.99271,7.99271,0,0,1-7.42188-10.96875l16-40a7.99361,7.99361,0,1,1,14.84375,5.9375L119.8125,119.99805H140a7.9927,7.9927,0,0,1,7.42187,10.96875Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "124 168 140 128 108 128 124 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBatteryChargingVertical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M96,16h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16Z"
        }), React.createElement("path", {
          d: "M184,32.00781H72a24.02625,24.02625,0,0,0-24,24v152a24.02624,24.02624,0,0,0,24,24H184a24.02624,24.02624,0,0,0,24-24v-152A24.02624,24.02624,0,0,0,184,32.00781ZM151.42969,134.97656l-16,40a8.00086,8.00086,0,0,1-14.85938-5.9375l11.61719-29.03125L112,139.99219a8.001,8.001,0,0,1-7.42969-10.96875l16-39.98438a8.00086,8.00086,0,0,1,14.85938,5.9375L123.8125,123.99219,144,124.00781a8.001,8.001,0,0,1,7.42969,10.96875Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "128 172 144 132 112 132 128 92",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBatteryEmpty = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M248,88a8.00008,8.00008,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8.00008,8.00008,0,0,0,248,88Z"
        }), React.createElement("path", {
          d: "M200,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H200a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,200,48Zm8,136a8.00917,8.00917,0,0,1-8,8H48a8.00917,8.00917,0,0,1-8-8V72a8.00917,8.00917,0,0,1,8-8H200a8.00917,8.00917,0,0,1,8,8Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBatteryFull = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M248,88a7.99977,7.99977,0,0,0-8,8v64a8,8,0,0,0,16,0V96A7.99977,7.99977,0,0,0,248,88Z"
        }), React.createElement("path", {
          d: "M200,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H200a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,200,48Zm8,136a8.00917,8.00917,0,0,1-8,8H48a8.00917,8.00917,0,0,1-8-8V72a8.00917,8.00917,0,0,1,8-8H200a8.00917,8.00917,0,0,1,8,8Z"
        }), React.createElement("rect", {
          x: "56",
          y: "80.00049",
          width: "136",
          height: "96",
          rx: "8"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "142.4",
          y1: "168.00043",
          x2: "142.4",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "105.6",
          y1: "168.00043",
          x2: "105.6",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "68.8",
          y1: "168.00043",
          x2: "68.8",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "179.2",
          y1: "168.00043",
          x2: "179.2",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBatteryHigh = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M248,88.00781a7.9954,7.9954,0,0,0-8,8v64a8,8,0,0,0,16,0v-64A7.99541,7.99541,0,0,0,248,88.00781Z"
        }), React.createElement("path", {
          d: "M200,48.00781H48a24.02624,24.02624,0,0,0-24,24v112a24.02624,24.02624,0,0,0,24,24H200a24.02624,24.02624,0,0,0,24-24v-112A24.02625,24.02625,0,0,0,200,48.00781Zm8,136a8.01042,8.01042,0,0,1-8,8H48a8.01042,8.01042,0,0,1-8-8v-112a8.01042,8.01042,0,0,1,8-8H200a8.01042,8.01042,0,0,1,8,8Z"
        }), React.createElement("rect", {
          x: "56",
          y: "80.00781",
          width: "96",
          height: "96",
          rx: "8"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "142.4",
          y1: "168.00043",
          x2: "142.4",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "105.6",
          y1: "168.00043",
          x2: "105.6",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "68.8",
          y1: "168.00043",
          x2: "68.8",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBatteryLow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M248,88a8.00008,8.00008,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8.00008,8.00008,0,0,0,248,88Z"
        }), React.createElement("path", {
          d: "M200,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H200a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,200,48Zm8,136a8.00917,8.00917,0,0,1-8,8H48a8.00917,8.00917,0,0,1-8-8V72a8.00917,8.00917,0,0,1,8-8H200a8.00917,8.00917,0,0,1,8,8Z"
        }), React.createElement("rect", {
          x: "56",
          y: "80.00049",
          width: "32",
          height: "96",
          rx: "8"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "68.8",
          y1: "168.00043",
          x2: "68.8",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBatteryMedium = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M248,88a7.99977,7.99977,0,0,0-8,8v64a8,8,0,0,0,16,0V96A7.99977,7.99977,0,0,0,248,88Z"
        }), React.createElement("path", {
          d: "M200,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H200a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,200,48Zm8,136a8.00917,8.00917,0,0,1-8,8H48a8.00917,8.00917,0,0,1-8-8V72a8.00917,8.00917,0,0,1,8-8H200a8.00917,8.00917,0,0,1,8,8Z"
        }), React.createElement("rect", {
          x: "56",
          y: "80.00049",
          width: "72",
          height: "96",
          rx: "8"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "105.6",
          y1: "168.00043",
          x2: "105.6",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "68.8",
          y1: "168.00043",
          x2: "68.8",
          y2: "88.00043",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBatteryWarning = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M256,96.00012v64a8,8,0,1,1-16,0v-64a8,8,0,1,1,16,0Zm-32-24v112a24.0275,24.0275,0,0,1-24,24H48a24.0275,24.0275,0,0,1-24-24v-112a24.0275,24.0275,0,0,1,24-24H200A24.0275,24.0275,0,0,1,224,72.00012Zm-108,56a8,8,0,0,0,16,0v-40a8,8,0,1,0-16,0Zm20,36a12,12,0,1,0-12,12A12.01375,12.01375,0,0,0,136,164.00012Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "124",
          y1: "88",
          x2: "124",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "124",
          cy: "164",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBatteryWarningVertical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M88,8a7.99977,7.99977,0,0,1,8-8h64a8,8,0,0,1,0,16H96A7.99977,7.99977,0,0,1,88,8ZM208,56V208a24.0275,24.0275,0,0,1-24,24H72a24.0275,24.0275,0,0,1-24-24V56A24.0275,24.0275,0,0,1,72,32H184A24.0275,24.0275,0,0,1,208,56Zm-88,76a8,8,0,0,0,16,0V92a8,8,0,0,0-16,0Zm20,36a12,12,0,1,0-12,12A12.01375,12.01375,0,0,0,140,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "92",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "128",
          cy: "168",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBed = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,72H24V48A8,8,0,0,0,8,48V208a8,8,0,0,0,16,0V176H232v32a8,8,0,0,0,16,0V112A40.04521,40.04521,0,0,0,208,72ZM24,88H96v72H24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M104,168V80H208a32,32,0,0,1,32,32v56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "208",
          x2: "16",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "16 168 240 168 240 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "80",
          x2: "16",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBell = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M220.81445,175.9397c-5.93457-10.21582-13.00976-29.60157-13.00976-63.93946v-7.09668c0-44.28515-35.52735-80.57715-79.19629-80.90136-.2041-.001-.40625-.002-.61035-.002a79.89891,79.89891,0,0,0-79.79493,80v8c0,34.33594-7.0791,53.72071-13.0166,63.93555A15.99885,15.99885,0,0,0,48.9834,200.00024H88a40,40,0,0,0,80,0h39.0166a15.99808,15.99808,0,0,0,13.79785-24.06054ZM128,224.00024a24.0275,24.0275,0,0,1-24-24h48A24.0275,24.0275,0,0,1,128,224.00024Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBellRinging = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.80469,112A79.70738,79.70738,0,0,0,128.6084,32.002c-.2041-.001-.40625-.002-.61035-.002a79.89888,79.89888,0,0,0-79.79492,80c0,34.33594-7.07911,53.7207-13.01661,63.93555A15.99886,15.99886,0,0,0,48.9834,200H88a40,40,0,0,0,80,0h39.0166a15.99808,15.99808,0,0,0,13.79785-24.06055C214.87988,165.72363,207.80469,146.33789,207.80469,112ZM128,224a24.0275,24.0275,0,0,1-24-24h48A24.0275,24.0275,0,0,1,128,224ZM224.88574,73.28027a7.995,7.995,0,0,1-10.71191-3.6416,96.29849,96.29849,0,0,0-35.01074-38.88574,7.9996,7.9996,0,1,1,8.54-13.5293,112.28362,112.28362,0,0,1,40.82421,45.34473A8,8,0,0,1,224.88574,73.28027Zm-190.24219.8252a8.00344,8.00344,0,0,1-7.17089-11.53711A112.28357,112.28357,0,0,1,68.29688,17.22363a7.99959,7.99959,0,1,1,8.54,13.5293A96.29849,96.29849,0,0,0,41.82617,69.63867,8.002,8.002,0,0,1,34.64355,74.10547Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBellSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M221.048,175.93066C215.09778,165.7168,208.004,146.335,208.004,112v-7.0957c0-44.28516-35.61621-80.57813-79.39453-80.90235-.20508-.001-.40722-.002-.61133-.002A79.99928,79.99928,0,0,0,48.004,104v8c0,34.33105-7.09668,53.71387-13.0498,63.92676A15.999,15.999,0,0,0,48.76478,200h158.4707a15.99861,15.99861,0,0,0,13.8125-24.06934Z"
        }), React.createElement("path", {
          d: "M159.92884,216h-64a8,8,0,1,0,0,16h64a8,8,0,1,0,0-16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBellSimpleRinging = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,224a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8.00039,8.00039,0,0,1,168,224Zm39.80469-112A79.70738,79.70738,0,0,0,128.6084,32.002c-.2041-.001-.40625-.002-.61035-.002a79.89888,79.89888,0,0,0-79.79492,80c0,34.33594-7.07911,53.7207-13.01661,63.93555A15.99886,15.99886,0,0,0,48.9834,200H207.0166a15.99808,15.99808,0,0,0,13.79785-24.06055C214.87988,165.72363,207.80469,146.33789,207.80469,112Zm20.72265-49.43164a112.28362,112.28362,0,0,0-40.82421-45.34473,7.9996,7.9996,0,1,0-8.54,13.5293,96.29849,96.29849,0,0,1,35.01074,38.88574,8.0002,8.0002,0,1,0,14.35351-7.07031ZM41.82617,69.63867A96.29849,96.29849,0,0,1,76.83691,30.75293a7.99959,7.99959,0,1,0-8.54-13.5293A112.28357,112.28357,0,0,0,27.47266,62.56836a8.0002,8.0002,0,1,0,14.35351,7.07031Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56.20305,112a71.80121,71.80121,0,1,1,143.60186,0h0c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M183.43247,23.98832a104.46641,104.46641,0,0,1,37.91845,42.1156",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M34.64909,66.10391A104.46639,104.46639,0,0,1,72.56757,23.98829",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBellSimpleSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.91992,210.61816a8.0006,8.0006,0,0,1-11.83984,10.76368l-19.45654-21.40235H48.9834A15.99885,15.99885,0,0,1,35.18652,175.915c5.9375-10.21484,13.0166-29.59961,13.0166-63.93555v-8a79.6939,79.6939,0,0,1,10.7212-40.06885L42.08008,45.38184A8.0006,8.0006,0,1,1,53.91992,34.61816ZM160,215.97949H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm42.90039-41.2666a8.0004,8.0004,0,0,0,13.36328-8.31445c-5.61328-14.24414-8.459-32.55274-8.459-54.41895v-7.09668c0-44.28515-35.52735-80.57715-79.19629-80.90136A79.49567,79.49567,0,0,0,88.5332,34.43652,8.00109,8.00109,0,0,0,86.583,46.76367Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "223.97925",
          x2: "160",
          y2: "223.97925",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M92.50261,41.38177a71.33429,71.33429,0,0,1,36.04579-9.4005c39.58967.29432,71.25651,33.20133,71.25651,72.90185v7.09613c0,26.69367,4.16238,45.03713,9.015,57.35221",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M186.163,191.97925H48.98365A7.99908,7.99908,0,0,1,42.103,179.93566c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.806,71.806,0,0,1,68.93758,63.03139",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBellSimpleZ = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,224a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8.00039,8.00039,0,0,1,168,224Zm52.85352-32.00293A15.80079,15.80079,0,0,1,207.0166,200H48.9834a15.99886,15.99886,0,0,1-13.79688-24.06445C41.124,165.7207,48.20313,146.33594,48.20313,112v-8a79.89888,79.89888,0,0,1,79.79492-80c.2041,0,.40625.001.61035.002,43.66894.32422,79.19629,36.61719,79.19629,80.90235V112c0,34.33789,7.07519,53.72363,13.00976,63.93945A15.87,15.87,0,0,1,220.85352,191.99707ZM156,144a8.00039,8.00039,0,0,0-8-8H125.08008l29.06543-34.87891A7.99925,7.99925,0,0,0,148,88H108a8,8,0,0,0,0,16h22.91992l-29.06543,34.87891A7.99925,7.99925,0,0,0,108,152h40A8.00039,8.00039,0,0,0,156,144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBellSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M53.91992,34.61816A8.0006,8.0006,0,1,0,42.08008,45.38184L58.93164,63.91846A79.70131,79.70131,0,0,0,48.20312,104v8c0,34.33594-7.0791,53.7207-13.0166,63.93555A15.99886,15.99886,0,0,0,48.9834,200H88a40,40,0,0,0,80,0h14.64209l19.438,21.38184a8.0006,8.0006,0,1,0,11.83984-10.76368ZM128,224a24.0275,24.0275,0,0,1-24-24h48A24.0275,24.0275,0,0,1,128,224ZM86.59473,46.77734a8.00066,8.00066,0,0,1,1.95215-12.32812A79.89269,79.89269,0,0,1,128.6084,24.002c43.66894.32422,79.19629,36.61719,79.19629,80.90235V112c0,21.85059,2.84179,40.14844,8.44531,54.38672a8.00047,8.00047,0,0,1-13.36426,8.31152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M186.18182,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641v-8A71.80594,71.80594,0,0,1,68.9457,63.0404",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M92.515,41.39547A71.33425,71.33425,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,26.66813,4.15442,45.002,9.001,57.31684",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBellZ = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M220.81445,175.93945C214.87988,165.72363,207.80469,146.33789,207.80469,112v-7.0957c0-44.28516-35.52735-80.57813-79.19629-80.90235-.2041-.001-.40625-.002-.61035-.002a79.89888,79.89888,0,0,0-79.79492,80v8c0,34.33594-7.07911,53.7207-13.01661,63.93555A15.99886,15.99886,0,0,0,48.9834,200H88a40,40,0,0,0,80,0h39.0166a15.99808,15.99808,0,0,0,13.79785-24.06055ZM128,224a24.0275,24.0275,0,0,1-24-24h48A24.0275,24.0275,0,0,1,128,224Zm20-72H108a7.99925,7.99925,0,0,1-6.14551-13.12109L130.91992,104H108a8,8,0,0,1,0-16h40a7.99925,7.99925,0,0,1,6.14551,13.12109L125.08008,136H148a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56.20305,104A71.899,71.899,0,0,1,128.5484,32.002c39.58967.29432,71.25651,33.20133,71.25651,72.90185V112c0,35.81563,7.49325,56.59893,14.093,67.95814A7.999,7.999,0,0,1,207.01628,192H48.98365A7.99908,7.99908,0,0,1,42.103,179.95641c6.60328-11.35959,14.1-32.1426,14.1-67.95641Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBicycle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M256,160a48,48,0,1,1-78.74414-36.82715l23.834,40.85791a7.99983,7.99983,0,1,0,13.82032-8.06152l-23.84375-40.87549A47.983,47.983,0,0,1,256,160ZM47.99316,168.00049a8.00038,8.00038,0,0,1-6.457-12.71387l27.875-38.22827a48.13563,48.13563,0,1,0,12.918,9.43994L54.46387,164.71338A7.98855,7.98855,0,0,1,47.99316,168.00049ZM165.92871,72H192a8.00917,8.00917,0,0,1,8,8,8,8,0,0,0,16,0,24.02718,24.02718,0,0,0-24-24H152a7.99957,7.99957,0,0,0-6.91016,12.03076L156.73853,88H99.26147L82.91016,59.96924A7.999,7.999,0,0,0,76,56H48a8,8,0,0,0,0,16H71.40527L85.12134,95.51318,69.41113,117.05835a48.23239,48.23239,0,0,1,12.918,9.43994l11.59278-15.89844,31.168,53.43091a7.99983,7.99983,0,1,0,13.82032-8.06152L108.59473,104h57.477l11.18408,19.17285a48.02278,48.02278,0,0,1,13.81055-8.0791Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,80a16,16,0,0,0-16-16H152l56,96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "208",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "48",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "48 64 76 64 132 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "170.087 96 94.667 96 48 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBird = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M236.4375,73.34375,213.207,57.85547A60.00943,60.00943,0,0,0,96,76V93.19385L1.75293,211.00244A7.99963,7.99963,0,0,0,8,224H112A104.11791,104.11791,0,0,0,216,120V100.28125l20.4375-13.625a7.99959,7.99959,0,0,0,0-13.3125Zm-126.292,67.77783-40,48a7.99987,7.99987,0,0,1-12.291-10.24316l40-48a7.99987,7.99987,0,0,1,12.291,10.24316ZM164,80a12,12,0,1,1,12-12A12,12,0,0,1,164,80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "164",
          cy: "68",
          r: "12"
        }), React.createElement("line", {
          x1: "120",
          y1: "136",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52.00738,52.00738,0,0,1,206.33275,62.88778L232,80Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBluetooth = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188.79883,169.60193l-55.46631-41.59967,55.46631-41.6a7.99952,7.99952,0,0,0,0-12.7998l-64-48a8,8,0,0,0-12.79981,6.3999v80.00006l-51.20019-38.4a7.9998,7.9998,0,1,0-9.59961,12.7998l55.46631,41.6L51.19922,169.60193a8.0002,8.0002,0,0,0,9.59961,12.80078L111.999,144.00238v79.99994a8.00025,8.00025,0,0,0,12.79981,6.40039l64-48a8.0005,8.0005,0,0,0,0-12.80078ZM127.999,48.00232l42.667,32-42.667,32Zm0,160v-64l42.667,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "120 32.003 184 80.003 120 128.003 120 32.003",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "120 128.003 184 176.003 120 224.003 120 128.003",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "80.00256",
          x2: "120",
          y2: "128.00256",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "176.00256",
          x2: "120",
          y2: "128.00256",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBluetoothConnected = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188.7998,169.6,133.334,128.00037,188.7998,86.40076a8.00048,8.00048,0,0,0,0-12.80078l-64-48A8.0003,8.0003,0,0,0,112,32.00037v79.99957L60.7998,73.6a8.00019,8.00019,0,0,0-9.5996,12.80078L106.666,128.00037,51.2002,169.6a8.00019,8.00019,0,0,0,9.5996,12.80078l51.2002-38.4v79.99958a8.00024,8.00024,0,0,0,12.7998,6.40039l64-48a8.00048,8.00048,0,0,0,0-12.80078ZM128,48.00037l42.667,32-42.667,32Zm0,160v-64l42.667,32Zm80-80a12,12,0,1,1-12-12A12.01344,12.01344,0,0,1,208,128.00037Zm-156,12a12,12,0,1,1,12-12A12.01344,12.01344,0,0,1,52,140.00037Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "52",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "196",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBluetoothSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M213.91943,210.61865l-31.39087-34.53-.009-.01-31.35718-34.49292-.02148-.02343L53.91943,34.61865a7.99991,7.99991,0,1,0-11.83886,10.7627l70.8413,77.92553L51.19434,169.60254a7.9998,7.9998,0,1,0,9.5996,12.7998l51.2002-38.40014v80.00024a7.99975,7.99975,0,0,0,12.7998,6.3999l50.83033-38.12292,26.4563,29.10193a7.99991,7.99991,0,0,0,11.83886-10.7627Zm-85.92529-2.61621v-64l11.76013,8.82007,25.05945,27.56519Z"
        }), React.createElement("path", {
          d: "M119.99414,79.62207a7.99977,7.99977,0,0,0,8-8V48.00244l42.6665,32L145.67041,98.74561a7.9998,7.9998,0,1,0,9.59961,12.7998l33.52392-25.14307a7.9995,7.9995,0,0,0,0-12.7998l-64-48a8,8,0,0,0-12.7998,6.3999V71.62207A7.99977,7.99977,0,0,0,119.99414,79.62207Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "55.99414",
          y1: "176.00256",
          x2: "119.99414",
          y2: "128.00256",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "119.994 71.622 119.994 32.003 183.994 80.003 150.47 105.146",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "176.648 181.512 119.994 224.003 119.994 128.003 145.163 146.879",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBluetoothX = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M188.7998,169.60254,133.333,128.00244l23.46679-17.6001a7.9998,7.9998,0,1,0-9.59961-12.7998L128,112.00244v-64l19.19922,14.39893a7.99981,7.99981,0,0,0,9.59961-12.79981l-31.999-23.999A8,8,0,0,0,112,32.00244v80.00025L60.7998,73.60254a7.9998,7.9998,0,0,0-9.59961,12.7998l55.4668,41.6001-55.4668,41.6001a7.9998,7.9998,0,1,0,9.59961,12.7998L112,144.0022v80.00024a7.99975,7.99975,0,0,0,12.7998,6.3999l64-48a7.9995,7.9995,0,0,0,0-12.7998ZM128,208.00244v-64l42.6665,32Z"
        }), React.createElement("path", {
          d: "M219.31348,80l18.34326-18.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L208,68.68652,189.65674,50.34326a7.99984,7.99984,0,0,0-11.31348,11.31348L196.68652,80,178.34326,98.34326a7.99984,7.99984,0,1,0,11.31348,11.31348L208,91.31348l18.34326,18.34326a7.99984,7.99984,0,1,0,11.31348-11.31348Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "120 128.003 184 176.003 120 224.003 120 128.003",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "80.00256",
          x2: "120",
          y2: "128.00256",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "176.00256",
          x2: "120",
          y2: "128.00256",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "232",
          y1: "56",
          x2: "184",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "232",
          y1: "104",
          x2: "184",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 104.002 120 128.003 120 32.003 151.999 56.002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBoat = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.06055,110.58691,208,106.2334V56a16.01833,16.01833,0,0,0-16-16H136V24a8,8,0,0,0-16,0V40H64A16.01833,16.01833,0,0,0,48,56v50.2334l-13.06055,4.35351A15.98076,15.98076,0,0,0,24,125.76611V160a8.00533,8.00533,0,0,0,.30762,2.19775c15.71972,55.01856,86.11816,73.957,100.07031,77.19483a16.1234,16.1234,0,0,0,7.24414,0c13.95215-3.23779,84.35059-22.17627,100.07031-77.19483A8.00533,8.00533,0,0,0,232,160V125.76611A15.98076,15.98076,0,0,0,221.06055,110.58691ZM136,168a8,8,0,0,1-16,0V112.43262a8,8,0,1,1,16,0Zm56-67.09961L133.05957,81.25391a16.0984,16.0984,0,0,0-10.12012,0L64,100.90039V56H192Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,160c-14.57032,50.99614-82.21424,68.82128-94.18651,71.59963a8.00355,8.00355,0,0,1-3.627,0C114.21424,228.82128,46.57032,210.99614,32,160V125.76607a8,8,0,0,1,5.47018-7.58946l88-29.33334a8.0001,8.0001,0,0,1,5.05964,0l88,29.33334A8,8,0,0,1,224,125.76607Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88.43274",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBook = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,32V192a8.00039,8.00039,0,0,1-8,8H72a16.01833,16.01833,0,0,0-16,16H192a8,8,0,0,1,0,16H48a8.00039,8.00039,0,0,1-8-8V56A32.03667,32.03667,0,0,1,72,24H208A8.00039,8.00039,0,0,1,216,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M48,216a24,24,0,0,1,24-24H208V32H72A24,24,0,0,0,48,56Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "48 216 48 224 192 224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBookBookmark = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.00244,24h-136a32.03667,32.03667,0,0,0-32,32V224a8.00039,8.00039,0,0,0,8,8h144a8,8,0,0,0,0-16h-136a16.01833,16.01833,0,0,1,16-16h136a8.00039,8.00039,0,0,0,8-8V32A8.00039,8.00039,0,0,0,208.00244,24Zm-24,96.001L158.394,100.7998a4.0005,4.0005,0,0,0-4.7998,0L128.00244,119.999V40h56Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176.002 32 176.002 128 143.995 104 112.002 128 112.002 32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48.00244,216a24,24,0,0,1,24-24h136V32h-136a24,24,0,0,0-24,24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "48.002 216 48.002 224 192.002 224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBookOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M96,208a24.0275,24.0275,0,0,1,24,24,8,8,0,0,0,16,0,24.0275,24.0275,0,0,1,24-24h64a16.01833,16.01833,0,0,0,16-16V64a16.01833,16.01833,0,0,0-16-16H176a40.04552,40.04552,0,0,0-40,40v80a8,8,0,0,1-16,0V88A40.04552,40.04552,0,0,0,80,48H32A16.01833,16.01833,0,0,0,16,64V192a16.01833,16.01833,0,0,0,16,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBookmark = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M183.97656,32h-112a16.01833,16.01833,0,0,0-16,16V224a8.00043,8.00043,0,0,0,12.24024,6.78418l59.75293-37.35059,59.76709,37.35059A8,8,0,0,0,199.97656,224V48A16.01833,16.01833,0,0,0,183.97656,32ZM132.209,177.21582a8.00107,8.00107,0,0,0-8.48,0L71.97656,209.56543V180.434l55.99317-35.00043,56.00683,35.00068v29.13311Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,224l-64.0074-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192 176 127.993 136 64 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBookmarkSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M183.97656,32h-112a16.01833,16.01833,0,0,0-16,16V224a8.00043,8.00043,0,0,0,12.24024,6.78418l59.75293-37.35059,59.76709,37.35059A8,8,0,0,0,199.97656,224V48A16.01833,16.01833,0,0,0,183.97656,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,224l-64.0074-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBookmarks = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,24H96A16.01833,16.01833,0,0,0,80,40V56H64A16.01833,16.01833,0,0,0,48,72V224a8.00026,8.00026,0,0,0,12.65039,6.50977l51.34277-36.67872,51.35743,36.67872A7.99952,7.99952,0,0,0,176,224V184.6897l19.35059,13.82007A7.99952,7.99952,0,0,0,208,192V40A16.01833,16.01833,0,0,0,192,24Zm0,152.45508-16-11.42676V72a16.01833,16.01833,0,0,0-16-16H96V40h96Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,224l-56.0074-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.85412",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBookmarksSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M160.00586,56h-96a16.01833,16.01833,0,0,0-16,16V224a8.00026,8.00026,0,0,0,12.65039,6.50977L111.999,193.83105l51.35743,36.67872A7.99952,7.99952,0,0,0,176.00586,224V72A16.01833,16.01833,0,0,0,160.00586,56Z"
        }), React.createElement("path", {
          d: "M192.00586,24h-104a8,8,0,0,0,0,16h104V192a8,8,0,0,0,16,0V40A16.01833,16.01833,0,0,0,192.00586,24Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168.00586,224l-56.0074-40-55.9926,40V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88.00586,32h104a8,8,0,0,1,8,8V192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBooks = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M233.61523,195.5752,192.2041,41.02637a16.01548,16.01548,0,0,0-19.5957-11.31348l-30.91016,8.28223c-.33935.09094-.66357.20923-.99219.32043A15.96591,15.96591,0,0,0,128,32H96a15.8799,15.8799,0,0,0-8,2.16492A15.8799,15.8799,0,0,0,80,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H80a15.8799,15.8799,0,0,0,8-2.16492A15.8799,15.8799,0,0,0,96,224h32a16.01833,16.01833,0,0,0,16-16V108.40283l27.7959,103.73584a15.992,15.992,0,0,0,19.5957,11.31445l30.91016-8.28222A16.01822,16.01822,0,0,0,233.61523,195.5752ZM176.749,45.167l6.21338,23.18238-30.91113,8.28247L145.83984,53.4502ZM128,48l.00732,120H96V48ZM80,48V72H48V48Zm48,160H96V184h32.0083l.00147,24Zm90.16016-8.28418-30.90967,8.28223-6.21143-23.18189,30.918-8.28491,6.21289,23.18164Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "40",
          y1: "80",
          x2: "88",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "88",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "88",
          y1: "176",
          x2: "136",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "158",
          y: "38.58284",
          width: "48",
          height: "176",
          rx: "8",
          transform: "matrix(0.96593, -0.25882, 0.25882, 0.96593, -26.56055, 51.41827)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "171.24109",
          y1: "179.15894",
          x2: "217.60553",
          y2: "166.73563",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "146.39447",
          y1: "86.43006",
          x2: "192.75891",
          y2: "74.00675",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBoundingBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,96a16.01833,16.01833,0,0,0,16-16V48a16.01833,16.01833,0,0,0-16-16H176a16.01833,16.01833,0,0,0-16,16v8H96V48A16.01833,16.01833,0,0,0,80,32H48A16.01833,16.01833,0,0,0,32,48V80A16.01833,16.01833,0,0,0,48,96h8v64H48a16.01833,16.01833,0,0,0-16,16v32a16.01833,16.01833,0,0,0,16,16H80a16.01833,16.01833,0,0,0,16-16v-8h64v8a16.01833,16.01833,0,0,0,16,16h32a16.01833,16.01833,0,0,0,16-16V176a16.01833,16.01833,0,0,0-16-16h-8V96Zm-24,64h-8a16.01833,16.01833,0,0,0-16,16v8H96v-8a16.01833,16.01833,0,0,0-16-16H72V96h8A16.01833,16.01833,0,0,0,96,80V72h64v8a16.01833,16.01833,0,0,0,16,16h8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "168",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "168",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "40",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "64",
          y1: "168",
          x2: "64",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "192",
          x2: "88",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "192",
          y1: "88",
          x2: "192",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "64",
          x2: "168",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBracketsAngle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M86.749,44.29492,33.48242,128,86.749,211.70508a7.99973,7.99973,0,1,1-13.498,8.58984l-56-88a7.99826,7.99826,0,0,1,0-8.58984l56-88a7.99973,7.99973,0,0,1,13.498,8.58984Zm152,79.41016-56-88a7.99973,7.99973,0,0,0-13.498,8.58984L222.51758,128,169.251,211.70508a7.99973,7.99973,0,1,0,13.498,8.58984l56-88A7.99826,7.99826,0,0,0,238.749,123.70508Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "80 40 24 128 80 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "176 40 232 128 176 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBracketsCurly = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M43.17529,128a29.7852,29.7852,0,0,1,8.023,10.25977C56,148.16309,56,160.28125,56,172c0,24.31348,1.01953,36,24,36a8,8,0,0,1,0,16c-17.48145,0-29.32422-6.14355-35.19824-18.25977C40,195.83691,40,183.71875,40,172c0-24.31348-1.01953-36-24-36a8,8,0,0,1,0-16c22.98047,0,24-11.68652,24-36,0-11.71875,0-23.83691,4.80176-33.74023C50.67578,38.14355,62.51855,32,80,32a8,8,0,0,1,0,16C57.01953,48,56,59.68652,56,84c0,11.71875,0,23.83691-4.80176,33.74023A29.7852,29.7852,0,0,1,43.17529,128ZM240,120c-22.98047,0-24-11.68652-24-36,0-11.71875,0-23.83691-4.80176-33.74023C205.32422,38.14355,193.48145,32,176,32a8,8,0,0,0,0,16c22.98047,0,24,11.68652,24,36,0,11.71875,0,23.83691,4.80176,33.74023A29.7852,29.7852,0,0,0,212.82471,128a29.7852,29.7852,0,0,0-8.023,10.25977C200,148.16309,200,160.28125,200,172c0,24.31348-1.01953,36-24,36a8,8,0,0,0,0,16c17.48145,0,29.32422-6.14355,35.19824-18.25977C216,195.83691,216,183.71875,216,172c0-24.31348,1.01953-36,24-36a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBracketsRound = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40,128c0,58.28906,34.6748,80.25488,36.15088,81.16113a8.00025,8.00025,0,0,1-8.26709,13.69922C66.09229,221.78516,24,195.751,24,128S66.09229,34.21484,67.88379,33.13965a8,8,0,0,1,8.2583,13.7041C74.544,47.8291,40,69.82129,40,128ZM188.11621,33.13965a8.00032,8.00032,0,0,0-8.26709,13.69922C181.3252,47.74512,216,69.71094,216,128s-34.6748,80.25488-36.11621,81.13965a8.00047,8.00047,0,1,0,8.23242,13.7207C189.90771,221.78516,232,195.751,232,128S189.90771,34.21484,188.11621,33.13965Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M72,40S32,64,32,128s40,88,40,88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,40s40,24,40,88-40,88-40,88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBracketsSquare = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M48,48V208H80a8,8,0,0,1,0,16H40a8.00039,8.00039,0,0,1-8-8V40a8.00039,8.00039,0,0,1,8-8H80a8,8,0,0,1,0,16ZM216,32H176a8,8,0,0,0,0,16h32V208H176a8,8,0,0,0,0,16h40a8.00039,8.00039,0,0,0,8-8V40A8.00039,8.00039,0,0,0,216,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "80 40 40 40 40 216 80 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "176 40 216 40 216 216 176 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBrain = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248,132a56.1211,56.1211,0,0,0-31.99951-50.61035L216,72a47.98283,47.98283,0,0,0-88-26.49316A47.98283,47.98283,0,0,0,40,71.99951l-.00049,9.39014A56.00268,56.00268,0,0,0,40,182.58569V184a47.98283,47.98283,0,0,0,88,26.49316A47.98283,47.98283,0,0,0,216,184v-1.41431A56.06726,56.06726,0,0,0,248,132ZM88,216a32.0433,32.0433,0,0,1-31.812-28.55664A56.1738,56.1738,0,0,0,64,188h8a8,8,0,0,0,0-16H64A40.00827,40.00827,0,0,1,50.66553,94.27393a7.99958,7.99958,0,0,0,5.33349-7.542L56,72a32,32,0,0,1,64,0v76.26147A47.80252,47.80252,0,0,0,88,136a8,8,0,0,0,0,16,32,32,0,0,1,0,64Zm104-44h-8a8,8,0,0,0,0,16h8a56.1738,56.1738,0,0,0,7.812-.55664A31.999,31.999,0,1,1,168,152a8,8,0,0,0,0-16,47.80252,47.80252,0,0,0-32,12.26147V72a32,32,0,1,1,64,.00049l.001,14.73144a7.99958,7.99958,0,0,0,5.33349,7.542A40.00827,40.00827,0,0,1,192,172ZM60,128a8,8,0,0,1,0-16A20.0226,20.0226,0,0,0,80,92V84a8,8,0,0,1,16,0v8A36.04061,36.04061,0,0,1,60,128Zm144-8a8.00008,8.00008,0,0,1-8,8,36.04061,36.04061,0,0,1-36-36V84a8,8,0,0,1,16,0v8a20.0226,20.0226,0,0,0,20,20A8.00008,8.00008,0,0,1,204,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,144a40,40,0,1,1-40,40v-6.73323",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,144a40,40,0,1,0,40,40v-6.7317",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,180H64A48.00813,48.00813,0,0,1,47.99924,86.73156L48,72a40,40,0,0,1,80,0V184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,180h8a48.00813,48.00813,0,0,0,16.00076-93.26844L208,72a40,40,0,0,0-80,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,84v8a28,28,0,0,1-28,28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,84v8a28,28,0,0,0,28,28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBrandy = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,88a95.63426,95.63426,0,0,0-15.53223-52.37207,7.99982,7.99982,0,0,0-6.70117-3.63086H54.2334A7.99954,7.99954,0,0,0,47.53223,35.627,96.014,96.014,0,0,0,120,183.66406V216H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.66406A96.127,96.127,0,0,0,224,88ZM58.70312,47.99707H197.29736A79.54855,79.54855,0,0,1,207.60205,80H48.398A79.53944,79.53944,0,0,1,58.70312,47.99707Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "224",
          x2: "168",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M201.76684,39.99737a88,88,0,1,1-147.53337-.00048Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBriefcase = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.00781,64H176V56a24.0275,24.0275,0,0,0-24-24H104A24.0275,24.0275,0,0,0,80,56v8H40.00781a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h176a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216.00781,64ZM96,56a8.00917,8.00917,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8v8H96ZM216.00781,80l.00318,41.606A184.00072,184.00072,0,0,1,128,144a184.00068,184.00068,0,0,1-87.99219-22.38428V80ZM108,120a8.00039,8.00039,0,0,1,8-8h24a8,8,0,0,1,0,16H116A8.00039,8.00039,0,0,1,108,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32.00781",
          y: "72.00005",
          width: "192",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224.00806,126.30915A191.11647,191.11647,0,0,1,128,152a191.11667,191.11667,0,0,1-95.99345-25.68239",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "116",
          y1: "120",
          x2: "140",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBriefcaseMetal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("rect", {
          x: "24",
          y: "120",
          width: "208",
          height: "48"
        }), React.createElement("path", {
          d: "M24,184v24a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V184Z"
        }), React.createElement("path", {
          d: "M232,104V80a16.01833,16.01833,0,0,0-16-16H176V56a24.0275,24.0275,0,0,0-24-24H104A24.0275,24.0275,0,0,0,80,56v8H40A16.01833,16.01833,0,0,0,24,80v24ZM96,56a8.00917,8.00917,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8v8H96Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "112",
          x2: "224",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBroadcast = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "40"
        }), React.createElement("path", {
          d: "M82.74512,82.74512A8.00018,8.00018,0,1,0,71.43066,71.43164a79.94026,79.94026,0,0,0,0,113.13672,8.00018,8.00018,0,1,0,11.31446-11.31348,63.93958,63.93958,0,0,1,0-90.50976Z"
        }), React.createElement("path", {
          d: "M208,128a79.7769,79.7769,0,0,0-23.43066-56.56836,8.00018,8.00018,0,1,0-11.31446,11.31348,63.93958,63.93958,0,0,1,0,90.50976,8.00018,8.00018,0,0,0,11.31446,11.31348A79.7769,79.7769,0,0,0,208,128Z"
        }), React.createElement("path", {
          d: "M32.16992,168.479a103.90428,103.90428,0,0,1,22.291-114.01806A8.00018,8.00018,0,0,0,43.14648,43.14746a119.906,119.906,0,0,0,0,169.70508,8.00018,8.00018,0,1,0,11.31446-11.31348A103.65105,103.65105,0,0,1,32.16992,168.479Z"
        }), React.createElement("path", {
          d: "M238.56641,81.28809a119.58135,119.58135,0,0,0-25.71289-38.14063,8.00018,8.00018,0,1,0-11.31446,11.31348,103.90471,103.90471,0,0,1,0,147.07812,8.00018,8.00018,0,0,0,11.31446,11.31348A120.12116,120.12116,0,0,0,238.56641,81.28809Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M77.08831,178.91169a71.93858,71.93858,0,0,1,0-101.82338",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M178.91169,77.08831a71.93858,71.93858,0,0,1,0,101.82338",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48.804,207.196a111.90445,111.90445,0,0,1,0-158.39192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M207.196,48.804a111.90445,111.90445,0,0,1,0,158.39192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBrowser = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.0006,40H40.00721a16.018,16.018,0,0,0-15.9994,16V95.84521C24.00684,95.89746,24,95.94775,24,96s.00684.10254.00781.15479V200a16.018,16.018,0,0,0,15.9994,16H216.0006A16.018,16.018,0,0,0,232,200V56A16.018,16.018,0,0,0,216.0006,40Zm0,16,.002,32H40.00721V56Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "32",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBrowsers = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.00781,40h-144a16.01818,16.01818,0,0,0-16,16V72h-16a16.01818,16.01818,0,0,0-16,16v23.84521c-.001.052-.00781.10254-.00781.15479s.00684.10278.00781.15479V200a16.01833,16.01833,0,0,0,16,16h144a16.01833,16.01833,0,0,0,16-16V184h16a16.01833,16.01833,0,0,0,16-16V56A16.01817,16.01817,0,0,0,216.00781,40Zm-32,48,.00147,16H40.00781V88Zm32,80h-16V88a16.01817,16.01817,0,0,0-16-16h-112V56h144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32.00781",
          y: "80.00005",
          width: "160",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M64.00781,80.00005v-24a8,8,0,0,1,8-8h144a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8h-24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBug = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M167.92969,92a12,12,0,1,1-12-12A12,12,0,0,1,167.92969,92Zm-68-12a12,12,0,1,0,12,12A12,12,0,0,0,99.92969,80ZM252,128a8.00039,8.00039,0,0,1-8,8H216v8a87.78437,87.78437,0,0,1-3.24438,23.69629l23.16723,13.37549a8,8,0,1,1-8,13.85644l-20.96533-12.104a87.9757,87.9757,0,0,1-157.915,0l-20.96533,12.104a8,8,0,1,1-8-13.85644l23.16723-13.37549A87.78437,87.78437,0,0,1,40,144v-8H12a8,8,0,0,1,0-16H40v-8a87.787,87.787,0,0,1,3.24438-23.69629L20.07715,74.92822a8,8,0,0,1,8-13.85644L49.04248,73.17627a87.97531,87.97531,0,0,1,157.915,0l20.96533-12.10449a8,8,0,0,1,8,13.85644L212.75562,88.30371A87.787,87.787,0,0,1,216,112v8h28A8.00039,8.00039,0,0,1,252,128ZM136,144a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm64-32a72,72,0,0,0-144,0v8H200Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "156",
          cy: "92",
          r: "12"
        }), React.createElement("circle", {
          cx: "100",
          cy: "92",
          r: "12"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "244",
          y1: "128.00007",
          x2: "12",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "231.92301",
          y1: "188.00006",
          x2: "203.18198",
          y2: "171.40642",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "231.92308",
          y1: "68.00006",
          x2: "203.18193",
          y2: "84.59378",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24.07695",
          y1: "68",
          x2: "52.81817",
          y2: "84.59375",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24.07695",
          y1: "188",
          x2: "52.81789",
          y2: "171.40641",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBugBeetle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M50.416,33.7959A7.99956,7.99956,0,0,1,61.44336,22.2041L80.10742,39.959a79.84411,79.84411,0,0,1,95.70777-.05908L194.416,22.2041a7.99956,7.99956,0,1,1,11.02734,11.5918L187.63013,50.74268A79.69432,79.69432,0,0,1,207.59912,96H48.40088A79.69482,79.69482,0,0,1,68.30664,50.81543ZM32,96a8,8,0,0,0,0,16H48V96Zm176,56c0,2.7002-.13843,5.36816-.40088,8H224a8,8,0,0,1,0,16H204.31714a80.00273,80.00273,0,0,1-152.63428,0H32a8,8,0,0,1,0-16H48.40088C48.13843,157.36816,48,154.7002,48,152v-8H32a8,8,0,0,1,0-16H48V112H208v16h16a8,8,0,0,1,0,16H208Zm-72-16a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm96-32a8.00039,8.00039,0,0,0-8-8H208v16h16A8.00039,8.00039,0,0,0,232,104Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "56",
          y: "32",
          width: "144",
          height: "192",
          rx: "71.99993",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "200",
          y1: "136",
          x2: "224",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "136",
          x2: "56",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "168",
          x2: "57.78445",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "198.21531",
          y1: "168",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "55.92969",
          y1: "28",
          x2: "79.69497",
          y2: "50.6085",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "199.92969",
          y1: "28",
          x2: "176.23303",
          y2: "50.54341",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBugDroid = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M191.28711,46.99316l14.09765-13.14111A8.00027,8.00027,0,0,0,194.47461,22.148L179.11914,36.4624a87.81742,87.81742,0,0,0-102.37891,0L61.38476,22.148a8.00027,8.00027,0,0,0-10.91015,11.7041L64.57226,46.99268A87.69686,87.69686,0,0,0,39.92969,108v40a88,88,0,0,0,176,0V108A87.69484,87.69484,0,0,0,191.28711,46.99316ZM127.92969,36a72.08124,72.08124,0,0,1,72,72v12h-144V108A72.08124,72.08124,0,0,1,127.92969,36Zm16,56a12,12,0,1,1,12,12A12,12,0,0,1,143.92969,92Zm-56,0a12,12,0,1,1,12,12A12,12,0,0,1,87.92969,92Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "128",
          x2: "48",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "156",
          cy: "91.99998",
          r: "12"
        }), React.createElement("circle", {
          cx: "100",
          cy: "91.99998",
          r: "12"
        }), React.createElement("line", {
          x1: "56",
          y1: "28",
          x2: "76.3142",
          y2: "46.93601",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "28",
          x2: "179.68538",
          y2: "46.93662",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBuildings = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M240,207.98316h-8.00586v-104a16.01833,16.01833,0,0,0-16-16h-64v-48a16.01833,16.01833,0,0,0-16-16h-96a16.01833,16.01833,0,0,0-16,16v168H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-120.00586-72a8.00009,8.00009,0,0,1-8,8h-32a8,8,0,0,1,0-16h32A8.00008,8.00008,0,0,1,119.99414,135.98316Zm-56-72h32a8,8,0,1,1,0,16h-32a8,8,0,0,1,0-16Zm0,104h32a8,8,0,1,1,0,16h-32a8,8,0,0,1,0-16Zm88-64h64v104h-64Z"
        }), React.createElement("path", {
          d: "M191.99414,167.98316h-16a8,8,0,0,0,0,16h16a8,8,0,1,0,0-16Z"
        }), React.createElement("path", {
          d: "M175.99414,143.98316h16a8,8,0,1,0,0-16h-16a8,8,0,0,0,0,16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "16",
          y1: "215.98316",
          x2: "240",
          y2: "215.98316",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M143.99414,215.98316v-176a8,8,0,0,0-8-8h-96a8,8,0,0,0-8,8v176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M223.99414,215.98316v-112a8,8,0,0,0-8-8h-72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "63.99414",
          y1: "71.98316",
          x2: "95.99414",
          y2: "71.98316",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "79.99414",
          y1: "135.98316",
          x2: "111.99414",
          y2: "135.98316",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "63.99414",
          y1: "175.98316",
          x2: "95.99414",
          y2: "175.98316",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "175.99414",
          y1: "175.98316",
          x2: "191.99414",
          y2: "175.98316",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "175.99414",
          y1: "135.98316",
          x2: "191.99414",
          y2: "135.98316",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconBus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M190,32H66A32.03667,32.03667,0,0,0,34,64V216a16.01833,16.01833,0,0,0,16,16H74a16.01833,16.01833,0,0,0,16-16V200h76v16a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16V64A32.03667,32.03667,0,0,0,190,32ZM82,168a12,12,0,1,1,12-12A12,12,0,0,1,82,168Zm92,0a12,12,0,1,1,12-12A12,12,0,0,1,174,168Zm32-48H50V72H206Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "42",
          y1: "72",
          x2: "214",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "42",
          y1: "120",
          x2: "214",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M214,192H42V64A24,24,0,0,1,66,40H190a24,24,0,0,1,24,24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "84",
          cy: "156",
          r: "12"
        }), React.createElement("circle", {
          cx: "172",
          cy: "156",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCake = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M206,80H136V69.439c11.49683-5.13232,18.2417-12.52441,20.07031-22.03027,4.11914-21.41113-20.06445-43.06006-22.835-45.458a7.99935,7.99935,0,0,0-10.35644-.09619c-2.85938,2.38184-27.81446,23.895-23.76661,45.34717,1.82349,9.6665,8.84131,17.15674,20.8877,22.31885V80H50a32.03635,32.03635,0,0,0-32,32v13.32812A43.21843,43.21843,0,0,0,30.90918,155.9834c.35693.35058.72461.68408,1.09082,1.02V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V157.00439c.36646-.33593.73389-.67041,1.09082-1.021A43.21843,43.21843,0,0,0,238,125.32812V112A32.03635,32.03635,0,0,0,206,80Zm2,128H48V166.20312a41.105,41.105,0,0,0,12.81641,1.78907,42.04634,42.04634,0,0,0,33.15014-17.42432,41.9385,41.9385,0,0,0,68.0669,0,42.04634,42.04634,0,0,0,33.15014,17.42432q.40137.00732.80079.00781A41.06205,41.06205,0,0,0,208,166.209Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,64c46.22222-16,0-56,0-56S80,48,128,64Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M162,126a34,34,0,0,1-68,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M94,126a34.0002,34.0002,0,0,1-33.337,33.99366C41.60193,160.35824,26,144.393,26,125.32842V112A24,24,0,0,1,50,88H206a24,24,0,0,1,24,24v13.32842c0,19.06459-15.60193,35.02982-34.663,34.66524A34.0002,34.0002,0,0,1,162,126",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216,153.26948V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.26978",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCalculator = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,24H56A16.01833,16.01833,0,0,0,40,40V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V40A16.01833,16.01833,0,0,0,200,24ZM88,199.99219a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,88,199.99219Zm0-40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,88,159.99219Zm40,40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,128,199.99219Zm0-40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,128,159.99219Zm40,40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,168,199.99219Zm0-40a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,168,159.99219Zm16-56a7.99977,7.99977,0,0,1-8,8H80a7.99977,7.99977,0,0,1-8-8v-40a7.99977,7.99977,0,0,1,8-8h96a7.99977,7.99977,0,0,1,8,8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "80",
          y: "64",
          width: "96",
          height: "48",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "88",
          cy: "148",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "148",
          r: "12"
        }), React.createElement("circle", {
          cx: "168",
          cy: "148",
          r: "12"
        }), React.createElement("circle", {
          cx: "88",
          cy: "188",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "188",
          r: "12"
        }), React.createElement("circle", {
          cx: "168",
          cy: "188",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCalendar = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99414,31.99707h-24v-8a8,8,0,0,0-16,0v8h-80v-8a8,8,0,1,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.99707ZM104,187.99707a23.84464,23.84464,0,0,1-16.96045-7.01953,8,8,0,0,1,11.30713-11.32031A7.99993,7.99993,0,1,0,104,155.99707h-.00488c-.249,0-.49805-.01465-.74658-.03809-.07959-.00732-.15723-.01953-.23584-.029-.16651-.02075-.33252-.04492-.498-.07593-.09229-.01757-.1836-.03711-.2749-.05761-.15039-.03369-.3003-.07276-.44922-.11548-.09082-.02612-.18164-.05152-.271-.08081-.15039-.04907-.29932-.10523-.44726-.16358-.08057-.03173-.16211-.06054-.24122-.09472-.17236-.07447-.34179-.15845-.51074-.24585-.04883-.02564-.1001-.04712-.14843-.07349q-.31641-.17322-.6211-.37744c-.06836-.0459-.13183-.09741-.19873-.14526-.11719-.08374-.23584-.16455-.34961-.25562-.01465-.01172-.02734-.02515-.042-.03711-.12061-.09814-.23389-.2041-.34863-.30908-.0835-.07617-.17139-.14917-.251-.22827-.07715-.07666-.147-.15991-.22119-.23975a8.03993,8.03993,0,0,1-1.95069-3.71777c-.00537-.02539-.01416-.05-.01953-.07544-.02783-.13477-.04443-.27344-.06543-.41065-.019-.12426-.04345-.24755-.05664-.37255-.01123-.10279-.01269-.208-.02-.312-.01123-.16381-.02343-.32739-.02441-.4917C96.00244,148.032,96,148.01489,96,147.99707c0-.083.00977-.16357.0127-.24609.00488-.16577.00976-.3313.0249-.49683.01025-.11182.02783-.221.043-.3313.02-.14892.03955-.29761.06787-.44556.023-.11889.05273-.23461.08056-.3518.03272-.13623.06495-.27246.105-.40772.03614-.12109.07862-.239.12012-.35766.04444-.12671.08789-.25366.13867-.37891.04981-.12231.10645-.24048.16211-.35986.05469-.1167.10742-.23364.168-.34863.06543-.12452.13867-.24439.21045-.365.062-.10375.12158-.20849.18848-.3103.085-.12817.17724-.25024.269-.37329.05566-.07446.10352-.1521.16211-.2251l5.602-7.00195H92a8,8,0,1,1,0-16h28a8.00023,8.00023,0,0,1,6.24707,12.998l-8.86914,11.08642A23.99341,23.99341,0,0,1,104,187.99707Zm64-8a8,8,0,0,1-16,0v-36l-3.2002,2.40039a8.00019,8.00019,0,0,1-9.5996-12.80078l16-12A8.00031,8.00031,0,0,1,168,127.99707Zm39.99414-100h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M92,127.99666h28l-16,20a16,16,0,1,1-11.30681,27.3206",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "144 139.997 160 127.997 160 179.997",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCalendarBlank = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99414,31.9971h-24v-8a8,8,0,1,0-16,0v8h-80v-8a8,8,0,0,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01582,16.01582,0,0,0,16,16h160a16.01581,16.01581,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.9971Zm0,48h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCalendarCheck = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99414,31.99707h-24v-8a8,8,0,0,0-16,0v8h-80v-8a8,8,0,1,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.99707ZM169.48242,133.81543l-46.6665,44a7.99905,7.99905,0,0,1-10.98975-.0127l-25.33349-24a8,8,0,1,1,11.0039-11.61523l19.84424,18.7998,41.166-38.8125a7.99949,7.99949,0,1,1,10.97558,11.64063Zm38.51172-53.81836h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "163.995 127.995 117.328 171.995 91.995 147.995",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCalendarPlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99414,31.99707h-24v-8a8,8,0,0,0-16,0v8h-80v-8a8,8,0,1,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.99707ZM156,160H136v20a8,8,0,0,1-16,0V160H100a8,8,0,0,1,0-16h20V124a8,8,0,0,1,16,0v20h20a8,8,0,0,1,0,16Zm51.99414-80.00293h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "156",
          y1: "152",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCalendarX = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99414,31.9971h-24v-8a8,8,0,1,0-16,0v8h-80v-8a8,8,0,0,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01582,16.01582,0,0,0,16,16h160a16.01581,16.01581,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.9971ZM157.65039,170.34085a7.99915,7.99915,0,1,1-11.3125,11.3125L127.99414,163.3096l-18.34375,18.34375a7.99915,7.99915,0,0,1-11.3125-11.3125l18.34375-18.34375L98.33789,133.65335a7.99915,7.99915,0,1,1,11.3125-11.3125l18.34375,18.34375,18.34375-18.34375a7.99915,7.99915,0,1,1,11.3125,11.3125L139.30664,151.9971ZM207.99414,79.9971h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "176",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCamera = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,56H180.27539l-13.625-20.4375A7.99942,7.99942,0,0,0,159.99414,32h-64a7.99943,7.99943,0,0,0-6.65625,3.5625L75.71289,56H48A24.0275,24.0275,0,0,0,24,80V192a24.0275,24.0275,0,0,0,24,24H208a24.0275,24.0275,0,0,0,24-24V80A24.0275,24.0275,0,0,0,208,56Zm-44,76a36,36,0,1,1-36-36A36.04043,36.04043,0,0,1,164,132Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H79.99414l16-24h64l16,24H208a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "132",
          r: "36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCameraSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M39.37451,18.61865a8.00027,8.00027,0,0,0-11.83984,10.7627L51.7334,56H47.99951a24.0275,24.0275,0,0,0-24,24V192a24.0275,24.0275,0,0,0,24,24H197.188l19.4375,21.38135a8.00027,8.00027,0,0,0,11.83984-10.7627ZM128,168a35.97306,35.97306,0,0,1-27.86426-58.75781L148.02246,161.918A35.81152,35.81152,0,0,1,128,168Z"
        }), React.createElement("path", {
          d: "M207.99951,56H180.2749l-13.625-20.4375A7.99942,7.99942,0,0,0,159.99365,32h-64a7.99954,7.99954,0,0,0-6.65722,3.56348l-2.00782,3.01318a8.00079,8.00079,0,0,0,.73731,9.81787L218.07959,191.41016a8.0004,8.0004,0,0,0,13.91992-5.38135V80A24.0275,24.0275,0,0,0,207.99951,56Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "33.45455",
          y1: "24",
          x2: "222.54545",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M93.98553,43.01291,95.99414,40h64l16,24H208a16,16,0,0,1,16,16V186.02889",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200.72725,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8181",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M154.13957,156.75336a36.00072,36.00072,0,1,1-48.298-53.128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCar = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,112H229.199L201.42188,49.501A16.01649,16.01649,0,0,0,186.80078,40H69.19922a16.0158,16.0158,0,0,0-14.6211,9.502L26.801,112H16a8,8,0,0,0,0,16h8v80a16.01833,16.01833,0,0,0,16,16H64a16.01833,16.01833,0,0,0,16-16V192h96v16a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16V128h8a8,8,0,0,0,0-16ZM80,160H64a8,8,0,0,1,0-16H80a8,8,0,0,1,0,16Zm96,0a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,120,194.11151,52.75089A8,8,0,0,0,186.801,48H69.199a8,8,0,0,0-7.31049,4.75089L32,120v64H224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCarSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,112H229.199L201.42188,49.501A16.01649,16.01649,0,0,0,186.80078,40H69.19922a16.0158,16.0158,0,0,0-14.6211,9.502L26.801,112H16a8,8,0,0,0,0,16h8v80a16.01833,16.01833,0,0,0,16,16H64a16.01833,16.01833,0,0,0,16-16V192h96v16a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16V128h8a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.88849,52.75089A8,8,0,0,1,69.199,48H186.801a8,8,0,0,1,7.31049,4.75089L224,120v88A8,8,0,0,1,216,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCardholder = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,48H48A24.0275,24.0275,0,0,0,24,72V184a24.0275,24.0275,0,0,0,24,24H208a24.0275,24.0275,0,0,0,24-24V72A24.0275,24.0275,0,0,0,208,48Zm-56.47949,76.80762a24.00866,24.00866,0,0,1-47.041.001A16.03939,16.03939,0,0,0,88.80957,112H40V96H216v16H167.19043A16.0395,16.0395,0,0,0,151.52051,124.80762ZM48,64H208a8.00917,8.00917,0,0,1,8,8v8H40V72A8.00917,8.00917,0,0,1,48,64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "16",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M32,120H88.80976A7.98836,7.98836,0,0,1,96.64,126.39917a32.00785,32.00785,0,0,0,62.7201,0A7.98836,7.98836,0,0,1,167.19024,120H224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "88",
          x2: "224",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCards = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("rect", {
          x: "24.00781",
          y: "72",
          width: "176",
          height: "144",
          rx: "16"
        }), React.createElement("path", {
          d: "M216.00781,40h-152a8,8,0,0,0,0,16h152V176a8,8,0,0,0,16,0V56A16.01833,16.01833,0,0,0,216.00781,40Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32.00781",
          y: "80.00005",
          width: "160",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M64.00781,48.00005h152a8,8,0,0,1,8,8V176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretCircleDoubleDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M54.46094,54.46094a103.95314,103.95314,0,1,0,147.07812,0A104.12262,104.12262,0,0,0,54.46094,54.46094Zm99.88281,83.88281a7.99915,7.99915,0,1,1,11.3125,11.3125l-32,32a7.99708,7.99708,0,0,1-11.3125,0l-32-32a7.99915,7.99915,0,0,1,11.3125-11.3125L128,164.6875Zm0-56a7.99915,7.99915,0,1,1,11.3125,11.3125l-32,32a7.99708,7.99708,0,0,1-11.3125,0l-32-32a7.99915,7.99915,0,0,1,11.3125-11.3125L128,108.6875Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "160 88 128 120 96 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "160 144 128 176 96 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretCircleDoubleLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M201.53906,54.46094a103.95314,103.95314,0,1,0,0,147.07812A104.12262,104.12262,0,0,0,201.53906,54.46094Zm-83.88281,99.88281a7.99915,7.99915,0,1,1-11.3125,11.3125l-32-32a7.99708,7.99708,0,0,1,0-11.3125l32-32a7.99915,7.99915,0,0,1,11.3125,11.3125L91.3125,128Zm56,0a7.99915,7.99915,0,1,1-11.3125,11.3125l-32-32a7.99708,7.99708,0,0,1,0-11.3125l32-32a7.99915,7.99915,0,0,1,11.3125,11.3125L147.3125,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "168 160 136 128 168 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "112 160 80 128 112 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretCircleDoubleRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M201.53906,54.46094a103.95314,103.95314,0,1,0,0,147.07812A104.12262,104.12262,0,0,0,201.53906,54.46094Zm-75.88281,79.19531-32,32a7.99915,7.99915,0,0,1-11.3125-11.3125L108.6875,128,82.34375,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125l32,32A7.99708,7.99708,0,0,1,125.65625,133.65625Zm56,0-32,32a7.99915,7.99915,0,0,1-11.3125-11.3125L164.6875,128l-26.34375-26.34375a7.99915,7.99915,0,0,1,11.3125-11.3125l32,32A7.99708,7.99708,0,0,1,181.65625,133.65625Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "88 160 120 128 88 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "144 160 176 128 144 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretCircleDoubleUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M201.53906,201.53906a103.95314,103.95314,0,1,0-147.07812,0A104.12262,104.12262,0,0,0,201.53906,201.53906Zm-99.88281-83.88281a7.99915,7.99915,0,1,1-11.3125-11.3125l32-32a7.99708,7.99708,0,0,1,11.3125,0l32,32a7.99915,7.99915,0,0,1-11.3125,11.3125L128,91.3125Zm0,56a7.99915,7.99915,0,1,1-11.3125-11.3125l32-32a7.99708,7.99708,0,0,1,11.3125,0l32,32a7.99915,7.99915,0,0,1-11.3125,11.3125L128,147.3125Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 168 128 136 160 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 112 128 80 160 112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretCircleDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm41.94531,97.35156-36,40a7.99734,7.99734,0,0,1-11.89062,0l-36-40a7.99912,7.99912,0,1,1,11.89062-10.70312L128,144.03906l30.05469-33.39062a7.99912,7.99912,0,1,1,11.89062,10.70312Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "164 116 128 156 92 116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretCircleLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm21.35156,134.05469a7.99912,7.99912,0,1,1-10.70312,11.89062l-40-36a7.99734,7.99734,0,0,1,0-11.89062l40-36a7.99912,7.99912,0,1,1,10.70312,11.89062L115.96094,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "144 92 104 128 144 164",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretCircleRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm33.35156,109.94531-40,36a7.99912,7.99912,0,1,1-10.70312-11.89062L144.03906,128,110.64844,97.94531a7.99912,7.99912,0,0,1,10.70312-11.89062l40,36a7.99734,7.99734,0,0,1,0,11.89062Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "116 92 156 128 116 164",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretCircleUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm41.35156,125.94531a7.997,7.997,0,0,1-11.29687-.59375L128,115.96094,97.94531,149.35156a7.99912,7.99912,0,0,1-11.89062-10.70312l36-40a8.24769,8.24769,0,0,1,11.89062,0l36,40A8.00337,8.00337,0,0,1,169.35156,149.94531Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "164 144 128 104 92 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretDoubleDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,120H147.31348l66.34326-66.34326A7.99981,7.99981,0,0,0,208,40H48a7.99981,7.99981,0,0,0-5.65674,13.65674L108.68652,120H48a7.99981,7.99981,0,0,0-5.65674,13.65674l80,80.00049a8.00063,8.00063,0,0,0,11.31348,0l80-80.00049A7.99981,7.99981,0,0,0,208,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "208 128 128 208 48 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 48 128 128 48 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretDoubleLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M203.06152,40.60889a7.99927,7.99927,0,0,0-8.71826,1.73437L128,108.68652V48a7.99981,7.99981,0,0,0-13.65674-5.65674l-80,80a7.99915,7.99915,0,0,0,0,11.31348l80,80A7.99981,7.99981,0,0,0,128,208V147.31348l66.34326,66.34326A7.99981,7.99981,0,0,0,208,208V48A8.00015,8.00015,0,0,0,203.06152,40.60889Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "200 208 120 128 200 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "120 208 40 128 120 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretDoubleRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.65674,122.34326l-80-80A7.99981,7.99981,0,0,0,128,48v60.68652L61.65674,42.34326A7.99981,7.99981,0,0,0,48,48V208a7.99984,7.99984,0,0,0,13.65674,5.65674L128,147.31348V208a7.99984,7.99984,0,0,0,13.65674,5.65674l80-80A7.99915,7.99915,0,0,0,221.65674,122.34326Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "56 48 136 128 56 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "136 48 216 128 136 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretDoubleUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M147.314,136H208a8.0001,8.0001,0,0,0,5.65674-13.65723l-80-80a8.00182,8.00182,0,0,0-11.31348,0l-80,80A8.0001,8.0001,0,0,0,48,136h60.686L42.34326,202.34277A8.0001,8.0001,0,0,0,48,216H208a8.0001,8.0001,0,0,0,5.65674-13.65723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "48 208 128 128 208 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "48 128 128 48 208 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.39111,92.93848A8.00015,8.00015,0,0,0,208,88H48a8,8,0,0,0-5.65674,13.657l80,79.99976a7.99945,7.99945,0,0,0,11.31348,0l80-79.99976A8.00011,8.00011,0,0,0,215.39111,92.93848Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "208 96 128 176 48 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M163.06152,40.60889a8.00159,8.00159,0,0,0-8.71826,1.73388l-80,80a8.00034,8.00034,0,0,0,0,11.31446l80,80A8.0001,8.0001,0,0,0,168,208V48A8.00065,8.00065,0,0,0,163.06152,40.60889Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "160 208 80 128 160 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M181.65674,122.34277l-80-80A8.0001,8.0001,0,0,0,88,48V208a8.00018,8.00018,0,0,0,13.65674,5.65723l80-80A8.00034,8.00034,0,0,0,181.65674,122.34277Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "96 48 176 128 96 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCaretUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.65674,154.34326l-80-80a8,8,0,0,0-11.31348,0l-80,80A7.99981,7.99981,0,0,0,48,168H208a7.99981,7.99981,0,0,0,5.65674-13.65674Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "48 160 128 80 208 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCat = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.4126,36.25659a16.40365,16.40365,0,0,0-17.04737,4.06372L187.46,57.22656a111.22891,111.22891,0,0,0-118.91894,0L51.63379,40.31982a16.40325,16.40325,0,0,0-17.04688-4.063A15.9582,15.9582,0,0,0,24,51.31348V136c0,47.50391,37.57251,87.05957,86.72656,94.67578A8.01964,8.01964,0,0,0,120,222.77075V195.314l-13.42163-13.42163a8.21993,8.21993,0,0,1-.40625-11.37329,8.00123,8.00123,0,0,1,11.48511-.17578L128,180.68652l10.34277-10.34326a8.00123,8.00123,0,0,1,11.48511.17578,8.21993,8.21993,0,0,1-.40625,11.37329L136,195.314v27.45679a8.01964,8.01964,0,0,0,9.27344,7.905C194.42749,223.05957,232,183.50391,232,136V51.31348A15.95841,15.95841,0,0,0,221.4126,36.25659ZM84,152a12,12,0,1,1,12-12A12,12,0,0,1,84,152Zm20-64a8,8,0,0,1-16,0V69.00879a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Zm16,0V69.00879a8,8,0,0,1,16,0V88a8,8,0,0,1-16,0Zm20,64a12,12,0,1,1,12-12A12,12,0,0,1,172,152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "84",
          cy: "140",
          r: "12"
        }), React.createElement("circle", {
          cx: "172",
          cy: "140",
          r: "12"
        }), React.createElement("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "53.00879",
          x2: "96",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "53.00879",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,136V51.31371a8,8,0,0,1,13.65685-5.65686L67.59832,67.59832l-.0003-.00039a102.88019,102.88019,0,0,1,120.804,0l-.00032.00037,21.94147-21.94147A8,8,0,0,1,224,51.31371V136c0,48.60106-42.98066,88-96,88S32,184.60106,32,136Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCellSignalFull = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M198.12305,28.53186a15.95339,15.95339,0,0,0-17.4375,3.46826L16.001,196.68616a15.99933,15.99933,0,0,0,11.3125,27.314H192a16.018,16.018,0,0,0,16-16V43.3136A15.95222,15.95222,0,0,0,198.12305,28.53186Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCellSignalHigh = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M198.12305,28.53186a15.95339,15.95339,0,0,0-17.4375,3.46826L16.001,196.68616a15.95542,15.95542,0,0,0-4.69092,11.65869q.01319.58374.06933,1.168a16.06842,16.06842,0,0,0,8.02735,12.40771q.50536.28712,1.031.53662a16.00569,16.00569,0,0,0,6.87574,1.543H192a16.018,16.018,0,0,0,16-16V43.3136A15.95222,15.95222,0,0,0,198.12305,28.53186ZM192,208.00012l-24-.00049V67.31946L192,43.32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCellSignalLow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M198.12305,28.53186a15.95427,15.95427,0,0,0-17.4375,3.46826L74.34692,138.33948l-.00415.0039L16.001,196.68616a15.99945,15.99945,0,0,0,11.3125,27.314H192a16.01833,16.01833,0,0,0,16-16V43.3136A15.95272,15.95272,0,0,0,198.12305,28.53186ZM192,208.00012,88,207.9967V147.31653L192,43.32043Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCellSignalMedium = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M198.12305,28.53186a15.95339,15.95339,0,0,0-17.4375,3.46826L114.34473,98.34143l-.002.00195L16.001,196.68616a15.95542,15.95542,0,0,0-4.69092,11.65869q.01319.58374.06933,1.168a16.06842,16.06842,0,0,0,8.02735,12.40771q.50536.28712,1.031.53662a16.00569,16.00569,0,0,0,6.87574,1.543H192a16.018,16.018,0,0,0,16-16V43.3136A15.95272,15.95272,0,0,0,198.12305,28.53186ZM192,208.00012l-64-.002V107.318l64-63.99756Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCellSignalNone = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,224H27.31348A15.9994,15.9994,0,0,1,16.001,196.686L180.68555,32A16.00046,16.00046,0,0,1,208,43.31372V208A16.01825,16.01825,0,0,1,192,224ZM27.31934,207.99512,192,208V43.32031L27.31445,208Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,43.31371V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCellSignalSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M194.08057,165.025A8.00011,8.00011,0,0,0,208,159.64319V43.31409a15.99974,15.99974,0,0,0-27.31348-11.31446L129.75146,82.9342a7.99987,7.99987,0,0,0-.26269,11.03809Z"
        }), React.createElement("path", {
          d: "M214.2179,221.02112c.13305-.16455.25988-.33252.37805-.50537.02783-.04053.054-.082.08105-.12354.113-.17187.22034-.34619.31885-.52441.03027-.05469.05786-.11084.08691-.16651.08765-.16845.17139-.33838.24634-.51123.03333-.07666.063-.15478.094-.23242.06225-.15723.12182-.31494.17382-.4751.032-.09814.05957-.19775.08777-.29736.04138-.147.08093-.29395.11377-.44238.02478-.11133.0448-.22364.06494-.33643.02552-.144.04871-.28857.06629-.43408.01416-.11621.02441-.23291.03344-.35059.01136-.14648.01917-.29345.02234-.44043.00135-.061.00916-.12011.00916-.18164s-.00781-.12109-.00928-.18213c-.00317-.13818-.0105-.27587-.02075-.41406-.01-.13428-.022-.26806-.03857-.40039-.01465-.1167-.03321-.23193-.053-.34766-.02539-.1499-.053-.29834-.08655-.44531-.02222-.09668-.04822-.19189-.0741-.28808-.04321-.16065-.08886-.31983-.1416-.47657-.02759-.082-.05884-.16308-.08935-.24414-.06226-.1665-.12745-.33056-.2002-.49121-.032-.0708-.06689-.14013-.10107-.21-.08277-.16943-.16968-.33642-.26392-.49951-.03345-.05762-.06909-.11426-.10425-.17139-.10644-.17383-.21826-.34326-.33716-.50781-.03247-.04443-.06579-.08838-.09912-.13232q-.19886-.26369-.41784-.50928c-.01551-.01709-.0282-.03613-.04383-.05322l-160-176A8.00024,8.00024,0,1,0,42.0752,45.39026l59.62866,65.59179L16,196.68616a15.99962,15.99962,0,0,0,11.31348,27.31347H207.82361c.058.00147.1156.00879.17346.00879a7.98959,7.98959,0,0,0,3.10938-.63672l.00537-.00244q.34863-.14721.68505-.33008l.02356-.01269q.31842-.17358.62342-.37891l.04736-.03174q.28491-.19482.55615-.416l.06983-.05762c.08593-.07226.175-.13769.25879-.21387.07837-.07129.14648-.14892.22143-.22265.03711-.03662.07349-.07324.10987-.11084.14733-.15039.28808-.3042.42114-.46338C214.15894,221.09534,214.18811,221.05823,214.2179,221.02112Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "47.99463",
          y1: "40.00842",
          x2: "207.99463",
          y2: "216.00842",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M135.40815,88.59185l50.935-50.935A8,8,0,0,1,200,43.31371V159.64292",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M207.99463,216.00842,27.31371,216a8,8,0,0,1-5.65686-13.65685l91.09823-91.09823",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCellSignalX = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M211.314,128l18.34278-18.34277a8.00018,8.00018,0,1,0-11.31348-11.31446L200,116.686,181.65674,98.34277a8.00018,8.00018,0,0,0-11.31348,11.31446L188.686,128l-18.34278,18.34277a8.00018,8.00018,0,0,0,11.31348,11.31446L200,139.314l18.34326,18.34327a8.00018,8.00018,0,0,0,11.31348-11.31446Z"
        }), React.createElement("path", {
          d: "M200,161.94141l-7.0293,7.02929a24.00019,24.00019,0,0,1-33.9414-33.9414L166.05859,128l-7.02929-7.0293a24.00019,24.00019,0,0,1,33.9414-33.9414L200,94.05859l7.0293-7.02929c.312-.312.64624-.58594.9707-.87744V43.31348A15.99974,15.99974,0,0,0,180.68652,32L15.99951,196.68652A16.00018,16.00018,0,0,0,27.31348,224H192a16.01833,16.01833,0,0,0,16-16V169.84814c-.32446-.2915-.65869-.56543-.9707-.87744Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,173.2544V208a8,8,0,0,1-8,8H27.31371a8,8,0,0,1-5.65686-13.65685l164.6863-164.6863A8,8,0,0,1,200,43.31371V82.74556",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChalkboard = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,192h-8V56a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,56V192H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-24,0H144V176a7.99993,7.99993,0,0,1,8-8h56a7.99993,7.99993,0,0,1,8,8Zm0-48a8,8,0,0,1-16,0V72H56V184a8,8,0,0,1-16,0V64a8.00008,8.00008,0,0,1,8-8H208a8.00008,8.00008,0,0,1,8,8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "120 200 120 168 192 168 192 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "64 200 64 80 192 80 192 136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChalkboardSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,192h-8V56a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,56V192H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-40,0H128V176a7.99993,7.99993,0,0,1,8-8h56a7.99993,7.99993,0,0,1,8,8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "120 200 120 168 184 168 184 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChalkboardTeacher = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200.001A15.99912,15.99912,0,0,0,40.001,216l13.38965-.00146a7.99978,7.99978,0,0,0,7.2246-4.5669,48.02362,48.02362,0,0,1,86.76954,0,7.99952,7.99952,0,0,0,7.22558,4.5669L216,216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM104,168a32,32,0,1,1,32-32A32.03667,32.03667,0,0,1,104,168Zm112,32-56.56641-.00146A63.89863,63.89863,0,0,0,146.26563,184H192a8.00008,8.00008,0,0,0,8-8V80a8.00008,8.00008,0,0,0-8-8H64a8.00008,8.00008,0,0,0-8,8v96a7.99618,7.99618,0,0,0,6.02881,7.74518,63.91387,63.91387,0,0,0-13.4624,16.25433L40,200.001V56H216Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "104",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M53.38964,207.99876a56.02294,56.02294,0,0,1,101.22072,0L215.99984,208A8,8,0,0,0,224,200V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200.00074A7.99926,7.99926,0,0,0,40,208Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "176 176 192 176 192 80 64 80 64 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChartBar = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M228,200h-8V40a8.00008,8.00008,0,0,0-8-8H156a8.00008,8.00008,0,0,0-8,8V80H100a8.00008,8.00008,0,0,0-8,8v40H44a8.00008,8.00008,0,0,0-8,8v64H28a8,8,0,0,0,0,16H228a8,8,0,0,0,0-16ZM108,96h40V200H108ZM52,144H92v56H52Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "44 208 44 136 100 136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "228",
          y1: "208",
          x2: "28",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "100 208 100 88 156 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "156",
          y: "40",
          width: "56",
          height: "168",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChartBarHorizontal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,96H176V56a7.99977,7.99977,0,0,0-8-8H48V40a8,8,0,0,0-16,0V216a8,8,0,0,0,16,0v-8h88a7.99977,7.99977,0,0,0,8-8V160h72a7.99977,7.99977,0,0,0,8-8V104A7.99977,7.99977,0,0,0,216,96ZM160,64V96H48V64ZM128,192H48V160h80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "40 56 168 56 168 104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "104",
          width: "176",
          height: "48",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "136 152 136 200 40 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChartLine = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.99951,200h-184V163.63232L96.39014,114.291l58.8125,44.10888a7.99913,7.99913,0,0,0,10.06738-.37939l64-56a7.99962,7.99962,0,1,0-10.53516-12.041L159.61475,141.709,100.80225,97.6001a7.99909,7.99909,0,0,0-10.06739.37939L39.99951,142.37305V48a8,8,0,0,0-16,0V208a8.00039,8.00039,0,0,0,8,8h192a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "224.002 96 160.002 152 96.002 104 32.002 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChartLineUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.99951,208a8.00039,8.00039,0,0,1-8,8h-192a8.00039,8.00039,0,0,1-8-8V48a8,8,0,0,1,16,0V156.68848l50.3457-50.34571a8.00122,8.00122,0,0,1,11.31446,0l26.34277,26.34375L176.68848,84,162.34521,69.65674A8.00038,8.00038,0,0,1,168.00244,56h40a8.00039,8.00039,0,0,1,8,8v40a8.00018,8.00018,0,0,1-13.65723,5.65674L188.00244,95.314l-54.34277,54.34327a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.31348l-56.00293,56.0039V200h184A8.00039,8.00039,0,0,1,231.99951,208Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208.002 64 128.002 144 96.002 112 32.002 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208.002 104 208.002 64 168.002 64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChartPie = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M218.27124,76.39893c-.06738-.13331-.12878-.26807-.20435-.39893-.102-.17676-.21545-.34229-.32849-.50781A103.97483,103.97483,0,0,0,37.72876,179.60107c.06738.1333.12878.26807.20435.39893.07153.124.15856.23242.23559.35107A103.97546,103.97546,0,0,0,218.27124,76.39893Zm-18.40454.87158L136,114.14355V40.36768A88.02766,88.02766,0,0,1,199.8667,77.27051ZM128,216a87.95493,87.95493,0,0,1-71.8667-37.27051L207.88574,91.11572A87.9798,87.9798,0,0,1,128,216Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "211.13844",
          y1: "80",
          x2: "44.86156",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChartPieSlice = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M99.99854,116.45312a7.99932,7.99932,0,0,0,4-6.92773V37.46289a8.00029,8.00029,0,0,0-10.666-7.54248,104.15035,104.15035,0,0,0-67.59863,117.0835,7.99907,7.99907,0,0,0,11.8667,5.47461Zm-12-66.86328v55.31641L40.11621,132.55078Q40.00048,130.27881,40,128A88.20107,88.20107,0,0,1,87.99854,49.58984Z"
        }), React.createElement("path", {
          d: "M218.27124,76.39893c-.06738-.13331-.12878-.26807-.20435-.39893-.102-.17676-.21545-.34229-.32849-.50781A104.0515,104.0515,0,0,0,128,24a8.00008,8.00008,0,0,0-8,8v91.38135L40.86133,169.07178A8.00042,8.00042,0,0,0,37.93311,180c.03369.05811.07592.10791.11084.165.08837.17969.17614.35889.27929.53418A104.0111,104.0111,0,0,0,232,128,103.36465,103.36465,0,0,0,218.27124,76.39893Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "211.13844",
          y1: "80",
          x2: "44.86156",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M33.60061,145.5506A96.15147,96.15147,0,0,1,95.99845,37.46313V109.5252Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,32A96,96,0,1,1,45.21664,176.64005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChat = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.002,48.00293h-176a16.02085,16.02085,0,0,0-16,16V222.82324a15.8614,15.8614,0,0,0,9.25,14.50781,16.11258,16.11258,0,0,0,6.79688,1.51563,15.86968,15.86968,0,0,0,10.25-3.77344l31.75-26.69531,133.95312-.375a16.02084,16.02084,0,0,0,16-16v-128A16.02084,16.02084,0,0,0,216.002,48.00293Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatCentered = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V183.999a16.01833,16.01833,0,0,0,16,16L99.46973,200l14.81054,24.68262a16.00024,16.00024,0,0,0,27.43946,0L156.5293,200H215.999A16.01853,16.01853,0,0,0,232,184V56A16.01833,16.01833,0,0,0,216,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatCenteredDots = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.001,40h-176a16.01833,16.01833,0,0,0-16,16V183.999a16.01833,16.01833,0,0,0,16,16L99.4707,200l14.81055,24.68262a16.00023,16.00023,0,0,0,27.43945,0L156.53027,200H216a16.01854,16.01854,0,0,0,16.001-16V56A16.01833,16.01833,0,0,0,216.001,40ZM80.00049,132.00049a12,12,0,1,1,12-12A12,12,0,0,1,80.00049,132.00049Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128.00049,132.00049Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176.00049,132.00049Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M149.67005,195.88358l-14.80962,24.68269a8,8,0,0,1-13.71989,0l-14.80963-24.68272a8,8,0,0,0-6.85994-3.884H40.00049a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8.00006,8l-59.47038-.00041A8,8,0,0,0,149.67005,195.88358Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "12"
        }), React.createElement("circle", {
          cx: "80",
          cy: "120",
          r: "12"
        }), React.createElement("circle", {
          cx: "176",
          cy: "120",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatCenteredText = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V183.999a16.01833,16.01833,0,0,0,16,16L99.46973,200l14.81054,24.68262a16.00024,16.00024,0,0,0,27.43946,0L156.5293,200H215.999A16.01853,16.01853,0,0,0,232,184V56A16.01833,16.01833,0,0,0,216,40ZM160,143.999H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96.00049",
          y1: "103.99951",
          x2: "160.00049",
          y2: "103.99951",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96.00049",
          y1: "135.99951",
          x2: "160.00049",
          y2: "135.99951",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M149.66907,195.88358l-14.80961,24.68269a8,8,0,0,1-13.71989,0l-14.80964-24.68272a8,8,0,0,0-6.85994-3.884H39.99951a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8l-59.47039-.00041A8,8,0,0,0,149.66907,195.88358Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128.00146,24.002A104.02442,104.02442,0,0,0,36.814,178.041l-8.55468,29.91406a16.00544,16.00544,0,0,0,19.78125,19.78125l29.91406-8.54688A104.00785,104.00785,0,1,0,128.00146,24.002Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatCircleDots = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128.00146,24.00781A104.01819,104.01819,0,0,0,36.814,178.03906l-8.55468,29.90625a15.995,15.995,0,0,0,19.78125,19.78125l29.91406-8.53125a104.00785,104.00785,0,1,0,50.04687-195.1875ZM80.00049,140a12,12,0,1,1,12-12A12,12,0,0,1,80.00049,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128.00049,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176.00049,140Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "80",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "176",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatCircleText = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128.00146,23.99316A104.03063,104.03063,0,0,0,36.814,178.04l-8.55468,29.90625a15.995,15.995,0,0,0,19.78125,19.78125l29.91406-8.53125A104.01366,104.01366,0,1,0,128.00146,23.99316Zm32,128h-64a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32h-64a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatDots = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.002,47.99316h-176a16.01583,16.01583,0,0,0-16,16V222.82129a15.97593,15.97593,0,0,0,26.29688,12.25l31.75781-26.70313,133.94531-.375a16.01581,16.01581,0,0,0,16-16v-128A16.01582,16.01582,0,0,0,216.002,47.99316ZM80.001,140.001a12,12,0,1,1,12-12A12,12,0,0,1,80.001,140.001Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128.001,140.001Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176.001,140.001Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "80",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "176",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatTeardrop = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132,23.99219a100.113,100.113,0,0,0-100,100v84.33349a15.68449,15.68449,0,0,0,15.667,15.66651H132a100,100,0,0,0,0-200Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatTeardropDots = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132,23.99219a100.113,100.113,0,0,0-100,100v84.33349a15.68449,15.68449,0,0,0,15.667,15.66651H132a100,100,0,0,0,0-200Zm-48.00195,116.001a12,12,0,1,1,12-12A12,12,0,0,1,83.99805,139.99316Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,131.99805,139.99316Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,179.99805,139.99316Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "132",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "84",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "180",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatTeardropText = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132,23.99219a100.113,100.113,0,0,0-100,100v84.33349a15.68449,15.68449,0,0,0,15.667,15.66651H132a100,100,0,0,0,0-200Zm27.99805,128h-60a8,8,0,0,1,0-16h60a8,8,0,0,1,0,16Zm0-32h-60a8,8,0,0,1,0-16h60a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132.00018,215.99219H47.66667A7.66667,7.66667,0,0,1,40,208.32552V123.992a91.99981,91.99981,0,0,1,91.99982-91.99981H132a92,92,0,0,1,92,92v.00018A91.99982,91.99982,0,0,1,132.00018,215.99219Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "100.00049",
          y1: "111.99219",
          x2: "160.00049",
          y2: "111.99219",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "100.00049",
          y1: "143.99219",
          x2: "160.00049",
          y2: "143.99219",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatText = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.002,48.002h-176a16.02085,16.02085,0,0,0-16,16V222.82227a15.8614,15.8614,0,0,0,9.25,14.50781,16.11272,16.11272,0,0,0,6.79688,1.51562,15.86972,15.86972,0,0,0,10.25-3.77343l31.75-26.69532,133.95312-.375a16.02083,16.02083,0,0,0,16-16v-128A16.02084,16.02084,0,0,0,216.002,48.002Zm-56,104h-64a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32h-64a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96.00049",
          y1: "112",
          x2: "160.00049",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96.00049",
          y1: "144",
          x2: "160.00049",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChats = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,96.00049a16.01833,16.01833,0,0,0-16-16H184v-32a16.01833,16.01833,0,0,0-16-16H40a16.01833,16.01833,0,0,0-16,16v128a7.99978,7.99978,0,0,0,13.0293,6.22119L72,153.95032l.001,30.05017a16.01833,16.01833,0,0,0,16,16h93.58789l37.38281,30.22119a7.99979,7.99979,0,0,0,13.0293-6.22119ZM189.44727,185.7793a7.99922,7.99922,0,0,0-5.0293-1.77881H88.001l-.001-32h80a16.01833,16.01833,0,0,0,16-16v-40h32l.001,111.24512Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M71.5834,144.00049l-39.58291,32v-128a8,8,0,0,1,8-8h128a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80.00049,144.00048v40a8,8,0,0,0,8,8h96.41709l39.58291,32v-128a8,8,0,0,0-8-8h-40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatsCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M230.53955,189.7666A80.01439,80.01439,0,0,0,169.56543,72.58691a80.00141,80.00141,0,1,0-144.105,69.17969l-6.18457,21.6499a13.99955,13.99955,0,0,0,17.30566,17.30909l21.65235-6.186a79.84121,79.84121,0,0,0,28.18994,8.88367,80.03721,80.03721,0,0,0,111.34326,39.11584l21.65137,6.18653A14.00007,14.00007,0,0,0,236.7251,211.418Zm-15.4873-5.10791a8.00114,8.00114,0,0,0-.81641,6.28711l6.11621,21.40625-21.40625-6.11572a8.00193,8.00193,0,0,0-6.28613.8164,64.03376,64.03376,0,0,1-88.33985-23.48608,79.90524,79.90524,0,0,0,70.37549-93.85889,64.02222,64.02222,0,0,1,40.35694,94.95093Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M34.0714,140.74858a71.96979,71.96979,0,1,1,25.18031,25.1802l.00017-.00075-24.86742,7.105a6,6,0,0,1-7.41747-7.41747l7.105-24.86742Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M92.059,175.89247a72.04349,72.04349,0,0,0,104.68926,38.03631l-.00017-.00075,24.86742,7.105a6,6,0,0,0,7.41747-7.41747l-7.105-24.86742.00057.00046A72.01951,72.01951,0,0,0,163.93781,80.10585",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChatsTeardrop = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M169.56592,72.5788A79.99487,79.99487,0,0,0,16,103.99219v66a14.01573,14.01573,0,0,0,14,14H86.667a80.1557,80.1557,0,0,0,73.333,48h66a14.01573,14.01573,0,0,0,14-14v-66A79.96635,79.96635,0,0,0,169.56592,72.5788ZM224,215.99219H160a64.14151,64.14151,0,0,1-55.67871-32.43335,79.90546,79.90546,0,0,0,70.37451-93.859A63.99067,63.99067,0,0,1,224,151.99219Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M96.00014,175.99219H30a6,6,0,0,1-6-6V103.992A71.99985,71.99985,0,0,1,95.99986,31.99219H96a72,72,0,0,1,72,72v.00014A71.99986,71.99986,0,0,1,96.00014,175.99219Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M92.098,175.99521a72.0298,72.0298,0,0,0,67.9019,47.997H226a6,6,0,0,0,6-6V151.992a72.00294,72.00294,0,0,0-68.06587-71.8942",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCheck = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "216 72.005 104 184 48 128.005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCheckCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm49.53125,85.78906-58.67187,56a8.02441,8.02441,0,0,1-11.0625,0l-29.32813-28a8.00675,8.00675,0,0,1,11.0625-11.57812l23.79687,22.72656,53.14063-50.72656a8.00675,8.00675,0,0,1,11.0625,11.57812Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "172 104 113.333 160 84 132",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCheckSquare = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.00146,32h-160a16.01582,16.01582,0,0,0-16,16V208a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16V48A16.01581,16.01581,0,0,0,208.00146,32ZM177.5249,109.78125l-58.67187,56a7.98451,7.98451,0,0,1-11.04688,0l-29.32812-28a7.99571,7.99571,0,1,1,11.04687-11.5625l23.80469,22.71875L166.478,98.21875a7.99571,7.99571,0,1,1,11.04687,11.5625Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "172 104 113.333 160 84 132",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCheckSquareOffset = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M203.99951,36.00012h-152a16.01834,16.01834,0,0,0-16,16v91.27246a8,8,0,0,0,16,0V52.00012h152v152H135.63525a8,8,0,0,0,0,16h68.36426a16.01833,16.01833,0,0,0,16-16v-152A16.01833,16.01833,0,0,0,203.99951,36.00012Z"
        }), React.createElement("path", {
          d: "M133.65674,146.34338a8.00121,8.00121,0,0,0-11.31445,0L63.99951,204.68664,37.65674,178.34338a8.00018,8.00018,0,1,0-11.31445,11.31348l32,32a8.00062,8.00062,0,0,0,11.31445,0l64-64A8,8,0,0,0,133.65674,146.34338Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M43.99951,143.27273V52a8,8,0,0,1,8-8h152a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8h-68.3641",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "128 152 64 216 32 184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconChecks = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M153.65674,89.65686l-87.999,88a8.00062,8.00062,0,0,1-11.31347,0l-44.001-43.99805a7.99983,7.99983,0,0,1,11.3125-11.31445l38.34473,38.3418,82.3418-82.34375a8.00052,8.00052,0,0,1,11.31445,11.31445Zm92-11.31445a8.003,8.003,0,0,0-11.31445,0l-82.3418,82.34375-17.71778-17.71582a7.99983,7.99983,0,0,0-11.3125,11.31445l23.374,23.37207a8.00062,8.00062,0,0,0,11.31347,0l87.999-88A8.00121,8.00121,0,0,0,245.65674,78.34241Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "148 84 60 172 16 128.002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "240 84 152 172 128.627 148.628",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "104"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCircleDashed = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M65.77441,54.46033a8.00119,8.00119,0,0,1,0,11.31445,87.95677,87.95677,0,0,0-22.78955,39.4375,7.99995,7.99995,0,1,1-15.45849-4.127,103.97686,103.97686,0,0,1,26.93457-46.625A8.00178,8.00178,0,0,1,65.77441,54.46033Zm-22.77587,96.3164A7.99983,7.99983,0,1,0,27.544,154.91736,103.97631,103.97631,0,0,0,54.45508,201.556a7.99984,7.99984,0,0,0,11.30273-11.32422A87.96258,87.96258,0,0,1,42.99854,150.77673Zm107.7749,62.24219a87.94957,87.94957,0,0,1-45.54981-.01758,8.00007,8.00007,0,1,0-4.14062,15.45508,103.98087,103.98087,0,0,0,53.8457.01367,8.00008,8.00008,0,0,0-4.15527-15.45117Zm72.03418-67.89746a7.99909,7.99909,0,0,0-9.79248,5.666,87.951,87.951,0,0,1-22.78955,39.4375,8.00018,8.00018,0,0,0,11.31347,11.31445,103.97037,103.97037,0,0,0,26.93457-46.625A8.00058,8.00058,0,0,0,222.80762,145.12146ZM213.001,105.224a8.00006,8.00006,0,1,0,15.45507-4.14063A103.9608,103.9608,0,0,0,201.54492,54.4447a7.99984,7.99984,0,0,0-11.30273,11.32422A87.94691,87.94691,0,0,1,213.001,105.224ZM105.22656,42.98084a87.94957,87.94957,0,0,1,45.54981.01757A8.00006,8.00006,0,1,0,154.917,27.54334a104.009,104.009,0,0,0-53.8457-.01368,8.00008,8.00008,0,0,0,4.15527,15.45118Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M35.25567,103.14925a95.55835,95.55835,0,0,1,24.86208-43.0315",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M60.10646,195.89357a95.55822,95.55822,0,0,1-24.83534-43.04694",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152.85078,220.74432a95.55827,95.55827,0,0,1-49.69741-.01544",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M220.74433,152.85075a95.55835,95.55835,0,0,1-24.86208,43.0315",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M195.89354,60.10643a95.55822,95.55822,0,0,1,24.83534,43.04694",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M103.14922,35.25568a95.55827,95.55827,0,0,1,49.69741.01544",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCircleHalf = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24ZM40,128a88.11715,88.11715,0,0,1,80-87.63257V215.63257A88.11715,88.11715,0,0,1,40,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.99998",
          y1: "48.00584",
          x2: "222.85577",
          y2: "142.86163",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128.00002",
          y1: "104.00588",
          x2: "206.81368",
          y2: "182.81953",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128.00002",
          y1: "160.00588",
          x2: "177.97522",
          y2: "209.98108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCircleHalfTilt = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M201.53906,54.46094A103.99994,103.99994,0,1,0,54.46094,201.53906,103.99994,103.99994,0,1,0,201.53906,54.46094ZM65.77539,65.77441a88.08476,88.08476,0,0,1,118.52368-5.38794L60.38086,184.30579A87.98425,87.98425,0,0,1,65.77539,65.77441Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "195.88225",
          y1: "60.11775",
          x2: "60.11775",
          y2: "195.88225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "142.00291",
          y1: "113.99705",
          x2: "208.43906",
          y2: "180.4332",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "114.00294",
          y1: "141.99708",
          x2: "180.44043",
          y2: "208.43457",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "86.00586",
          y1: "170",
          x2: "139.33798",
          y2: "223.33212",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "170.00001",
          y1: "86.00001",
          x2: "223.33246",
          y2: "139.33246",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCircleWavy = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,128c0,10.44238-7.51074,18.27441-14.1377,25.18457-3.77246,3.93359-7.67285,8-9.14648,11.56348-1.35449,3.27343-1.43652,8.69629-1.51562,13.93945-.14747,9.75879-.31446,20.81934-8.0044,28.50879-7.68945,7.68945-18.75,7.85644-28.5083,8.00391-5.24414.0791-10.667.16113-13.94043,1.51562-3.5625,1.47363-7.62988,5.374-11.5625,9.14648C146.27441,232.48926,138.44238,240,127.99951,240c-10.44238,0-18.27392-7.51074-25.18408-14.1377-3.93311-3.77246-8-7.67285-11.56348-9.14648-3.27295-1.35449-8.69531-1.43652-13.93945-1.51562-9.75879-.14747-20.81934-.31446-28.50879-8.00391s-7.85644-18.75-8.00391-28.50879c-.0791-5.24316-.16113-10.666-1.51562-13.93945-1.47363-3.56348-5.374-7.62989-9.14648-11.56348C23.51074,146.27441,16,138.44238,16,128s7.51074-18.27441,14.1377-25.18457c3.77246-3.93359,7.67285-8,9.14648-11.56348,1.35449-3.27343,1.43652-8.69629,1.51562-13.93945.14747-9.75879.31446-20.81934,8.0044-28.50879,7.68945-7.68945,18.75-7.85644,28.5083-8.00391,5.24414-.0791,10.667-.16113,13.94043-1.51562,3.5625-1.47363,7.62988-5.374,11.5625-9.14648C109.72559,23.51074,117.55762,16,128.00049,16c10.44238,0,18.27392,7.51074,25.18408,14.1377,3.93311,3.77246,8,7.67285,11.56348,9.14648,3.27295,1.35449,8.69531,1.43652,13.93945,1.51562,9.75879.14747,20.81934.31446,28.50879,8.00391s7.85644,18.75,8.00391,28.50879c.0791,5.24316.16113,10.666,1.51562,13.93945,1.47363,3.56348,5.374,7.62989,9.14648,11.56348C232.48926,109.72559,240,117.55762,240,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCircleWavyCheck = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M225.8623,102.81543c-3.77246-3.93359-7.67285-8-9.14648-11.56348-1.35449-3.27343-1.43652-8.69531-1.51562-13.93945-.14747-9.75879-.31446-20.81934-8.00391-28.50879s-18.75-7.85644-28.50879-8.00391c-5.24414-.0791-10.666-.16113-13.93945-1.51562-3.5625-1.47363-7.62989-5.374-11.56348-9.14648C146.27539,23.51074,138.44238,16,128,16s-18.27441,7.51074-25.18457,14.1377c-3.93359,3.77246-8,7.67285-11.56348,9.14648-3.27343,1.35449-8.69531,1.43652-13.93945,1.51562-9.75879.14747-20.81934.31446-28.50879,8.00391s-7.85644,18.75-8.00391,28.50879c-.0791,5.24414-.16113,10.666-1.51562,13.93945-1.47363,3.5625-5.374,7.62989-9.14648,11.56348C23.51074,109.72461,16,117.55762,16,128s7.51074,18.27441,14.1377,25.18457c3.77246,3.93359,7.67285,8,9.14648,11.56348,1.35449,3.27343,1.43652,8.69531,1.51562,13.93945.14747,9.75879.31446,20.81934,8.00391,28.50879s18.75,7.85644,28.50879,8.00391c5.24414.0791,10.666.16113,13.93945,1.51562,3.5625,1.47363,7.62989,5.374,11.56348,9.14648C109.72461,232.48926,117.55762,240,128,240s18.27441-7.51074,25.18457-14.1377c3.93359-3.77246,8-7.67285,11.56348-9.14648,3.27343-1.35449,8.69531-1.43652,13.93945-1.51562,9.75879-.14747,20.81934-.31446,28.50879-8.00391s7.85644-18.75,8.00391-28.50879c.0791-5.24414.16113-10.666,1.51562-13.93945,1.47363-3.5625,5.374-7.62989,9.14648-11.56348C232.48926,146.27539,240,138.44238,240,128S232.48926,109.72559,225.8623,102.81543Zm-48.33886,6.97168-58.667,56a7.99978,7.99978,0,0,1-11.04688,0l-29.333-28a7.99994,7.99994,0,1,1,11.04688-11.57422L113.333,148.94043l53.14355-50.72754a7.99994,7.99994,0,1,1,11.04688,11.57422Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "172 104 113.333 160 84 132",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCircleWavyQuestion = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M225.8623,102.81543c-3.77246-3.93359-7.67285-8-9.14648-11.56348-1.35449-3.27343-1.43652-8.69531-1.51562-13.93945-.14747-9.75879-.31446-20.81934-8.00391-28.50879s-18.75-7.85644-28.50879-8.00391c-5.24414-.0791-10.666-.16113-13.93945-1.51562-3.5625-1.47363-7.62989-5.374-11.56348-9.14648C146.27539,23.51074,138.44238,16,128,16s-18.27441,7.51074-25.18457,14.1377c-3.93359,3.77246-8,7.67285-11.56348,9.14648-3.27343,1.35449-8.69531,1.43652-13.93945,1.51562-9.75879.14747-20.81934.31446-28.50879,8.00391s-7.85644,18.75-8.00391,28.50879c-.0791,5.24414-.16113,10.666-1.51562,13.93945-1.47363,3.5625-5.374,7.62989-9.14648,11.56348C23.51074,109.72461,16,117.55762,16,128s7.51074,18.27441,14.1377,25.18457c3.77246,3.93359,7.67285,8,9.14648,11.56348,1.35449,3.27343,1.43652,8.69531,1.51562,13.93945.14747,9.75879.31446,20.81934,8.00391,28.50879s18.75,7.85644,28.50879,8.00391c5.24414.0791,10.666.16113,13.93945,1.51562,3.5625,1.47363,7.62989,5.374,11.56348,9.14648C109.72461,232.48926,117.55762,240,128,240s18.27441-7.51074,25.18457-14.1377c3.93359-3.77246,8-7.67285,11.56348-9.14648,3.27343-1.35449,8.69531-1.43652,13.93945-1.51562,9.75879-.14747,20.81934-.31446,28.50879-8.00391s7.85644-18.75,8.00391-28.50879c.0791-5.24414.16113-10.666,1.51562-13.93945,1.47363-3.5625,5.374-7.62989,9.14648-11.56348C232.48926,146.27539,240,138.44238,240,128S232.48926,109.72559,225.8623,102.81543ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm7.999-48.89063v.89551a8,8,0,0,1-16,0v-8a8.00039,8.00039,0,0,1,8-8,20,20,0,1,0-20-20,8,8,0,0,1-16,0,36,36,0,1,1,44,35.10449Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "180",
          r: "12"
        }), React.createElement("path", {
          d: "M127.9995,144.0045v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCircleWavyWarning = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M225.8623,102.81543c-3.77246-3.93359-7.67285-8-9.14648-11.56348-1.35449-3.27343-1.43652-8.69531-1.51562-13.93945-.14747-9.75879-.31446-20.81934-8.00391-28.50879s-18.75-7.85644-28.50879-8.00391c-5.24414-.0791-10.666-.16113-13.93945-1.51562-3.5625-1.47363-7.62989-5.374-11.56348-9.14648C146.27539,23.51074,138.44238,16,128,16s-18.27441,7.51074-25.18457,14.1377c-3.93359,3.77246-8,7.67285-11.56348,9.14648-3.27343,1.35449-8.69531,1.43652-13.93945,1.51562-9.75879.14747-20.81934.31446-28.50879,8.00391s-7.85644,18.75-8.00391,28.50879c-.0791,5.24414-.16113,10.666-1.51562,13.93945-1.47363,3.5625-5.374,7.62989-9.14648,11.56348C23.51074,109.72461,16,117.55762,16,128s7.51074,18.27441,14.1377,25.18457c3.77246,3.93359,7.67285,8,9.14648,11.56348,1.35449,3.27343,1.43652,8.69531,1.51562,13.93945.14747,9.75879.31446,20.81934,8.00391,28.50879s18.75,7.85644,28.50879,8.00391c5.24414.0791,10.666.16113,13.93945,1.51562,3.5625,1.47363,7.62989,5.374,11.56348,9.14648C109.72461,232.48926,117.55762,240,128,240s18.27441-7.51074,25.18457-14.1377c3.93359-3.77246,8-7.67285,11.56348-9.14648,3.27343-1.35449,8.69531-1.43652,13.93945-1.51562,9.75879-.14747,20.81934-.31446,28.50879-8.00391s7.85644-18.75,8.00391-28.50879c.0791-5.24414.16113-10.666,1.51562-13.93945,1.47363-3.5625,5.374-7.62989,9.14648-11.56348C232.48926,146.27539,240,138.44238,240,128S232.48926,109.72559,225.8623,102.81543ZM119.999,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8.00049,104a12,12,0,1,1,12-12A12,12,0,0,1,127.99951,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M54.46089,201.53911c-9.204-9.204-3.09935-28.52745-7.78412-39.85C41.82037,149.95168,24,140.50492,24,127.99963,24,115.4945,41.82047,106.048,46.67683,94.31079c4.68477-11.32253-1.41993-30.6459,7.78406-39.8499s28.52746-3.09935,39.85-7.78412C106.04832,41.82037,115.49508,24,128.00037,24c12.50513,0,21.95163,17.82047,33.68884,22.67683,11.32253,4.68477,30.6459-1.41993,39.8499,7.78406s3.09935,28.52746,7.78412,39.85C214.17963,106.04832,232,115.49508,232,128.00037c0,12.50513-17.82047,21.95163-22.67683,33.68884-4.68477,11.32253,1.41993,30.6459-7.78406,39.8499s-28.52745,3.09935-39.85,7.78412C149.95168,214.17963,140.50492,232,127.99963,232c-12.50513,0-21.95163-17.82047-33.68884-22.67683C82.98826,204.6384,63.66489,210.7431,54.46089,201.53911Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "172",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCirclesFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "76",
          cy: "76",
          r: "44"
        }), React.createElement("circle", {
          cx: "180",
          cy: "76",
          r: "44"
        }), React.createElement("circle", {
          cx: "76",
          cy: "180",
          r: "44"
        }), React.createElement("circle", {
          cx: "180",
          cy: "180",
          r: "44"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "180",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCirclesThree = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "68",
          r: "48"
        }), React.createElement("circle", {
          cx: "188",
          cy: "172",
          r: "48"
        }), React.createElement("circle", {
          cx: "68",
          cy: "172",
          r: "48"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "68",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "68",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCirclesThreePlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "76",
          cy: "76",
          r: "44"
        }), React.createElement("circle", {
          cx: "180",
          cy: "76",
          r: "44"
        }), React.createElement("circle", {
          cx: "76",
          cy: "180",
          r: "44"
        }), React.createElement("path", {
          d: "M208,172H188V152a8,8,0,0,0-16,0v20H152a8,8,0,0,0,0,16h20v20a8,8,0,0,0,16,0V188h20a8,8,0,0,0,0-16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "180",
          y1: "152",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "180",
          x2: "152",
          y2: "180",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconClipboard = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,32H163.73877a47.91437,47.91437,0,0,0-71.47754,0H56A16.01833,16.01833,0,0,0,40,48V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,200,32Zm-72,0a32.03667,32.03667,0,0,1,32,32H96A32.03667,32.03667,0,0,1,128,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconClipboardText = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,32H163.73877a47.91437,47.91437,0,0,0-71.47754,0H56A16.01833,16.01833,0,0,0,40,48V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,200,32Zm-72,0a32.03667,32.03667,0,0,1,32,32H96A32.03667,32.03667,0,0,1,128,32Zm32,128H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "152",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "120",
          x2: "160",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M160.00194,40H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H95.99783",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconClock = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm56,112H128a7.99541,7.99541,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconClockAfternoon = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm56,112H147.31348l25.9414,25.94141a7.99983,7.99983,0,0,1-11.31347,11.31347l-39.59766-39.59765c-.18652-.18653-.36328-.38282-.53076-.58692-.07373-.08984-.1377-.18457-.20654-.27636-.0879-.1167-.17823-.23145-.25977-.353-.07471-.11182-.13916-.22754-.208-.34229-.06494-.10937-.13379-.21582-.19385-.32861-.0625-.1167-.11572-.23731-.17187-.35693-.05566-.11719-.11426-.23243-.16406-.353-.04785-.11572-.08643-.23389-.12842-.35108-.04639-.12841-.0957-.25585-.13574-.38769-.03565-.11816-.06153-.23779-.0918-.35693-.03369-.13379-.0708-.26563-.09814-.40186-.02686-.1377-.04346-.27637-.063-.41553-.01758-.11963-.04-.23681-.05176-.3584q-.03808-.38232-.03906-.7666L120,128l.001-.022q.00145-.38452.03906-.7666c.01172-.12159.03418-.23877.05176-.3584.01953-.13916.03613-.27783.063-.41553.02734-.13623.06445-.26807.09814-.40186.03027-.11914.05615-.23876.0918-.35693.04-.13183.08935-.25928.13574-.38769.042-.11719.08057-.23536.12842-.35108.0498-.1206.1084-.23584.16406-.353.05615-.11962.10937-.24023.17187-.35693.06006-.11279.12891-.21924.19385-.32861.06885-.11475.1333-.23047.208-.34229.08154-.12158.17187-.23633.25977-.353.06884-.09179.13281-.18652.20654-.27636a8.04468,8.04468,0,0,1,1.1167-1.1167c.09179-.0752.188-.14014.28174-.21094.11474-.08594.22705-.1748.34668-.25439.11425-.07666.23242-.14258.3496-.21241.10694-.064.21143-.13134.32129-.18994.11963-.064.24268-.11816.36475-.17578.11475-.0542.22754-.11133.34473-.16015.11914-.04932.24072-.08887.36132-.13184.12549-.04541.249-.09326.37745-.13233.12207-.03662.24609-.064.36914-.09472.12988-.03272.25732-.06885.38965-.09522.14306-.02832.28808-.04541.43261-.06591.11377-.01612.22608-.03809.34131-.04932q.39477-.03956.7915-.04H184a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "167.59798",
          y1: "167.59798",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconClockClockwise = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,80v43.38116l37.56934,21.69062a8,8,0,1,1-8,13.85644l-41.56934-24c-.064-.03692-.12109-.0805-.18359-.11889-.13575-.08362-.271-.16779-.40088-.2591-.10352-.07232-.20215-.14892-.30127-.22534-.10205-.0788-.20362-.15765-.30127-.24115-.11182-.09479-.21778-.19342-.32276-.29333-.0791-.07532-.15771-.15064-.23388-.22913-.10694-.11017-.2085-.22351-.30811-.339-.06933-.08026-.13769-.16083-.2041-.24377-.0918-.1156-.1792-.23352-.26416-.35352-.06738-.09473-.1333-.19019-.19629-.2879-.07226-.11194-.14062-.22547-.207-.34058-.06592-.11438-.12988-.22986-.19043-.34778-.05322-.10418-.10352-.20941-.15186-.31561-.061-.13287-.11914-.26685-.17333-.4035-.03907-.09986-.0752-.20063-.11036-.30194-.0498-.14252-.09668-.28589-.13818-.432-.03027-.10687-.05664-.21454-.083-.32257-.0332-.13928-.06543-.27881-.09131-.42084-.02392-.12842-.0415-.25757-.05908-.38714-.0166-.12226-.0332-.244-.04394-.368-.01416-.16015-.01954-.3208-.02442-.48187C120.00879,128.14313,120,128.07269,120,128V80a8,8,0,0,1,16,0Zm91.228-27.67529a7.99962,7.99962,0,0,0-8.71826,1.73437L204.1665,68.40222l-8.28466-8.28454a95.9551,95.9551,0,1,0,0,135.76464,7.99983,7.99983,0,1,0-11.31348-11.31347,80.00009,80.00009,0,1,1,0-113.1377l8.28467,8.28467L178.50977,94.05908a7.99981,7.99981,0,0,0,5.65673,13.65674h40a7.99977,7.99977,0,0,0,8-8v-40A8.00014,8.00014,0,0,0,227.228,52.32471Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "169.56922",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "184.167 99.716 224.167 99.716 224.167 59.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M190.2254,190.2254a88,88,0,1,1,0-124.4508l33.94112,33.94113",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconClockCounterClockwise = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,80v43.38116l37.56934,21.69062a8,8,0,1,1-8,13.85644l-41.56934-24c-.064-.03692-.12109-.0805-.18359-.11889-.13575-.08362-.271-.16779-.40088-.2591-.10352-.07232-.20215-.14892-.30127-.22534-.10205-.0788-.20362-.15765-.30127-.24115-.11182-.09479-.21778-.19342-.32276-.29333-.0791-.07532-.15771-.15064-.23388-.22913-.10694-.11017-.2085-.22351-.30811-.339-.06933-.08026-.13769-.16083-.2041-.24377-.0918-.1156-.1792-.23352-.26416-.35352-.06738-.09473-.1333-.19019-.19629-.2879-.07226-.11194-.14062-.22547-.207-.34058-.06592-.11438-.12988-.22986-.19043-.34778-.05322-.10418-.10352-.20941-.15185-.31561-.061-.13287-.11915-.26685-.17334-.4035-.03907-.09986-.0752-.20063-.11036-.30194-.0498-.14252-.09668-.28589-.13818-.432-.03027-.10687-.05664-.21454-.083-.32257-.0332-.13928-.06543-.27881-.09131-.42084-.02392-.12842-.0415-.25757-.05908-.38714-.0166-.12226-.0332-.244-.04394-.368-.01416-.16015-.01953-.3208-.02442-.48187C120.00879,128.14313,120,128.07269,120,128V80a8,8,0,0,1,16,0Zm59.88184-19.88232a96.10782,96.10782,0,0,0-135.76416,0L51.833,68.4021l-14.34278-14.343A7.99981,7.99981,0,0,0,23.8335,59.71582v40a7.99977,7.99977,0,0,0,8,8h40a7.99981,7.99981,0,0,0,5.65673-13.65674L63.147,79.71576l8.28467-8.28461a80.00025,80.00025,0,1,1,0,113.13721,8.00035,8.00035,0,0,0-11.314,11.31445A96.0001,96.0001,0,0,0,195.88184,60.11768Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "169.56922",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "71.833 99.716 31.833 99.716 31.833 59.716",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconClosedCaptioning = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM96,148a19.85259,19.85259,0,0,0,14.28613-6.00293,7.99956,7.99956,0,0,1,11.42774,11.19727,36,36,0,1,1,0-50.38868,7.99956,7.99956,0,0,1-11.42774,11.19727A20.00012,20.00012,0,1,0,96,148Zm72,0a19.85259,19.85259,0,0,0,14.28613-6.00293,7.99956,7.99956,0,0,1,11.42774,11.19727,36,36,0,1,1,0-50.38868,7.99956,7.99956,0,0,1-11.42774,11.19727A20.00012,20.00012,0,1,0,168,148Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M116,147.59582a28,28,0,1,1,.00011-39.19153",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M188,147.59582a28,28,0,1,1,.00011-39.19153",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloud = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160,40A88.102,88.102,0,0,0,81.28711,88.6709l-.00537-.00049A87.464,87.464,0,0,0,71.98828,128a8,8,0,0,1-16,0,103.43561,103.43561,0,0,1,7.78-39.45264A63.99161,63.99161,0,0,0,72,216h88a88,88,0,0,0,0-176Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudArrowDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160.001,40A88.102,88.102,0,0,0,81.28809,88.6709l-.00538-.00049A87.46336,87.46336,0,0,0,71.98926,128a8,8,0,0,1-16,0,103.43674,103.43674,0,0,1,7.78-39.45264A63.99161,63.99161,0,0,0,72.001,216h88a88,88,0,0,0,0-176ZM191.5918,163.71582l-33.937,33.937a7.95865,7.95865,0,0,1-.59205.5354c-.08374.06885-.17224.12818-.258.19312-.12256.09253-.24317.18725-.3711.273-.10766.07177-.2196.134-.32983.20019-.11316.06812-.22412.13892-.34082.20142-.11523.06152-.23377.11377-.35132.16919-.11877.05639-.23584.11548-.35766.166-.11451.04737-.23169.08545-.34778.12744-.13.04688-.25843.09668-.39136.13672-.11694.0354-.23572.06128-.35376.09107-.1344.03393-.26721.07153-.40418.09863-.13891.02759-.27929.044-.41931.064-.11816.01684-.23437.03955-.35412.05127-.26245.02587-.52588.03979-.78931.03979s-.52685-.01392-.78931-.03979c-.11975-.01172-.236-.03443-.35412-.05127-.14-.02-.2804-.03638-.41931-.064-.137-.0271-.26978-.0647-.40418-.09863-.118-.02979-.23681-.05567-.35376-.09107-.13293-.04-.26135-.08984-.39136-.13672-.11608-.042-.23327-.08007-.34777-.12744-.12183-.05053-.2389-.10962-.35767-.166-.11755-.05542-.23608-.10767-.35132-.16919-.1167-.0625-.22766-.1333-.34082-.20142-.11023-.06616-.22217-.12842-.32983-.20019-.12793-.0857-.24854-.18042-.3711-.273-.08581-.06494-.17431-.12427-.258-.19312a7.95651,7.95651,0,0,1-.592-.5354l-33.937-33.937A7.99984,7.99984,0,1,1,123.71,152.40234l20.28418,20.28418V112a8,8,0,0,1,16,0v60.68652l20.28418-20.28418a7.99984,7.99984,0,1,1,11.31348,11.31348Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "118.059 174.059 152 208 185.941 174.059",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "128",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M96,208H72A56,56,0,1,1,85.91924,97.74352",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,128a80,80,0,1,1,144.00241,48.00459",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudArrowUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160.001,40A88.102,88.102,0,0,0,81.28809,88.6709l-.00538-.00049A87.46336,87.46336,0,0,0,71.98926,128a8,8,0,0,1-16,0,103.43674,103.43674,0,0,1,7.78-39.45264A63.99161,63.99161,0,0,0,72.001,216h88a88,88,0,0,0,0-176ZM191.5918,151.59766a7.99945,7.99945,0,0,1-11.31348,0l-20.28418-20.28418V192a8,8,0,0,1-16,0V131.31348L123.71,151.59766a7.99984,7.99984,0,1,1-11.31348-11.31348l33.937-33.937a7.95651,7.95651,0,0,1,.592-.5354c.08374-.06885.17224-.12818.258-.19312.12256-.09253.24317-.18725.3711-.273.10718-.07153.2185-.1333.32837-.19922.11377-.06836.22534-.13964.34277-.20263.11353-.06055.23022-.11182.34583-.16651.12072-.05737.23986-.11767.36389-.16894.11157-.04614.22583-.08325.33911-.124.13281-.04834.26416-.09888.40014-.14014.1128-.03394.22718-.0586.34107-.08765.13867-.0354.27612-.074.4176-.1018.12976-.02588.26087-.04053.3916-.05982.12744-.0188.25305-.04272.38233-.05518.232-.02294.465-.03271.69812-.0354.02978-.00024.05871-.00439.08862-.00439s.05884.00415.08862.00439c.23316.00269.46607.01246.69812.0354.12928.01246.25489.03638.38233.05518.13074.01929.26184.03394.3916.05982.14148.02783.27893.0664.4176.1018.11389.029.22827.05371.34107.08765.136.04126.26733.0918.40014.14014.11328.04077.22754.07788.33911.124.124.05127.24317.11157.3639.16894.1156.05469.2323.106.34582.16651.11743.063.229.13427.34277.20263.10987.06592.2212.12769.32837.19922.12793.0857.24854.18042.3711.273.08581.06494.17431.12427.258.19312a7.95865,7.95865,0,0,1,.59205.5354l33.937,33.937A7.99915,7.99915,0,0,1,191.5918,151.59766Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M96,207.98437H72A56,56,0,1,1,85.91924,97.7279",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,127.98437A80,80,0,1,1,224.00241,175.989",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "118.059 161.926 152 127.984 185.941 161.926",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "207.98437",
          x2: "152",
          y2: "127.98437",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudCheck = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160.001,40A88.102,88.102,0,0,0,81.28809,88.6709l-.00538-.00049A87.46336,87.46336,0,0,0,71.98926,128a8,8,0,0,1-16,0,103.43674,103.43674,0,0,1,7.78-39.45264A63.99161,63.99161,0,0,0,72.001,216h88a88,88,0,0,0,0-176Zm37.65576,81.65674-48,48a7.99945,7.99945,0,0,1-11.31348,0l-24-24a7.99984,7.99984,0,0,1,11.31348-11.31348L144,152.68652l42.34326-42.34326a7.99984,7.99984,0,0,1,11.31348,11.31348Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,1,1,85.91924,97.74352",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192 116 144 164 120 140",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudFog = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,224a8.00008,8.00008,0,0,1-8,8H104a8,8,0,0,1,0-16h56A8.00008,8.00008,0,0,1,168,224Zm-40-32a8.00008,8.00008,0,0,0-8-8H72a8,8,0,0,0,0,16h48A8.00008,8.00008,0,0,0,128,192Zm56-8H160a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM156,16A76.13113,76.13113,0,0,0,85.03711,64.7832l-.00537-.001A76.1764,76.1764,0,0,0,80,92a8,8,0,0,1-16,0,92.24056,92.24056,0,0,1,4.17639-27.41064A52.00137,52.00137,0,0,0,76,168h80a76,76,0,0,0,0-152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "120",
          y1: "192",
          x2: "72",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "192",
          x2: "160",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "224",
          x2: "104",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudLightning = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M134.564,168l-15.75,24h35.43116a8.00016,8.00016,0,0,1,6.68847,12.38916l-26.25,40a8,8,0,1,1-13.377-8.77832L139.42627,208H103.99512a8.00017,8.00017,0,0,1-6.68848-12.38916L115.42627,168H75.99512A52.0014,52.0014,0,0,1,68.16479,64.59033,91.68713,91.68713,0,0,0,63.99512,92a8,8,0,0,0,16,0,75.62312,75.62312,0,0,1,5.03723-27.2168l.007-.01758A76.00126,76.00126,0,1,1,155.99512,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "128 240 154.25 200 104 200 130.25 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudMoon = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M156,72a76.16623,76.16623,0,0,0-12.356,1.012A71.97744,71.97744,0,0,0,88.16846,9.8252a7.9997,7.9997,0,0,0-9.58741,9.58691A56.33865,56.33865,0,0,1,80,32,56.06322,56.06322,0,0,1,24,88a56.39592,56.39592,0,0,1-12.59082-1.418,8.00013,8.00013,0,0,0-9.585,9.58789A72.18778,72.18778,0,0,0,34.11353,141.2312,51.96571,51.96571,0,0,0,76,224h80a76,76,0,0,0,0-152ZM21.36816,103.95215Q22.68287,104.0005,24,104A72.08124,72.08124,0,0,0,96,32q0-1.3374-.04932-2.67285a55.64963,55.64963,0,0,1,31.98267,48.05249A76.41925,76.41925,0,0,0,85.03711,120.7832,52.31117,52.31117,0,0,0,76,120a51.69716,51.69716,0,0,0-30.02808,9.58643A56.254,56.254,0,0,1,21.36816,103.95215Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M46.99,138.92889A64.12919,64.12919,0,0,1,9.6218,94.37955l.00023-.001A64.0566,64.0566,0,0,0,86.37854,17.622l.00084-.00019A64.02478,64.02478,0,0,1,136,80q0,1.51431-.06961,3.01174",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudRain = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160.93359,204.38916l-26.25,40a8,8,0,1,1-13.377-8.77832l26.25-40a8,8,0,1,1,13.377,8.77832ZM155.99512,16A76.1302,76.1302,0,0,0,85.03931,64.76562l-.007.01758A75.62312,75.62312,0,0,0,79.99512,92a8,8,0,0,1-16,0,91.68713,91.68713,0,0,1,4.16967-27.40967A52.0014,52.0014,0,0,0,75.99512,168h39.43115L92.05664,203.61084a8,8,0,1,0,13.37695,8.77832L134.564,168h21.43116a76,76,0,0,0,0-152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "240",
          x2: "154.25007",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "98.74999",
          y1: "208",
          x2: "130.25007",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M53.91943,34.61865a7.99991,7.99991,0,1,0-11.83886,10.7627L81.32349,88.54858c-.02.0398-.04187.07862-.06177.11841A64.00311,64.00311,0,1,0,72,216h88a87.30213,87.30213,0,0,0,31.79883-5.92847l10.28174,11.30982a7.99991,7.99991,0,0,0,11.83886-10.7627Z"
        }), React.createElement("path", {
          d: "M160,40a87.31991,87.31991,0,0,0-52.10938,17.08057,8.00024,8.00024,0,0,0-1.17773,11.8247L213.76074,186.65771a8.00079,8.00079,0,0,0,5.91944,2.61866h.03466A7.99883,7.99883,0,0,0,225.646,186.606,88.00035,88.00035,0,0,0,160,40Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M193.8943,200.486A79.69516,79.69516,0,0,1,160,208H72A56,56,0,1,1,85.91924,97.74352",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M112.63246,63.52392a80.0033,80.0033,0,0,1,107.0479,117.75254",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,128A79.62931,79.62931,0,0,1,91.06793,87.375",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudSnow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M175.99512,196a12,12,0,1,1-12-12A12.01375,12.01375,0,0,1,175.99512,196Zm-100-12a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,75.99512,184Zm40,16a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,115.99512,200Zm-48,24a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,67.99512,224Zm88,0a12,12,0,1,0,12,12A12.01375,12.01375,0,0,0,155.99512,224Zm0-208A76.1302,76.1302,0,0,0,85.03931,64.76562l-.007.01758A75.62312,75.62312,0,0,0,79.99512,92a8,8,0,0,1-16,0,91.68713,91.68713,0,0,1,4.16967-27.40967A52.0014,52.0014,0,0,0,75.99512,168h80a76,76,0,0,0,0-152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "76",
          cy: "196",
          r: "12"
        }), React.createElement("circle", {
          cx: "116",
          cy: "212",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "196",
          r: "12"
        }), React.createElement("circle", {
          cx: "68",
          cy: "236",
          r: "12"
        }), React.createElement("circle", {
          cx: "156",
          cy: "236",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCloudSun = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M156,72a75.81,75.81,0,0,0-20.23584,2.73853,55.73208,55.73208,0,0,0-9.41089-11.57911l9.48413-13.54419A8.00015,8.00015,0,0,0,122.731,40.4375l-9.48413,13.54419A55.868,55.868,0,0,0,86.251,48.01953L83.37451,31.70605A7.99987,7.99987,0,1,0,67.61768,34.4834l2.87475,16.30371A55.397,55.397,0,0,0,47.17651,65.635L33.61426,56.13867A8.00027,8.00027,0,0,0,24.4375,69.24609l13.55981,9.49463a55.39532,55.39532,0,0,0-5.98669,26.98535l-16.305,2.87452a8.00079,8.00079,0,0,0,1.37988,15.87988,8.12832,8.12832,0,0,0,1.39844-.12207l16.31079-2.87573a55.95086,55.95086,0,0,0,5.85571,12.42749A51.96741,51.96741,0,0,0,76,224h80a76,76,0,0,0,0-152ZM48.62964,111.09448c-.00879-.05713-.01123-.11352-.02124-.17065-.011-.0625-.02954-.12158-.042-.18335A39.72794,39.72794,0,0,1,55.12793,81.186c.0354-.04834.07642-.08985.11084-.13916.03857-.05518.06909-.11329.106-.16895a39.72789,39.72789,0,0,1,25.48584-16.2395c.07422-.011.148-.01612.22216-.029.06983-.01221.136-.033.20508-.04688a39.95749,39.95749,0,0,1,29.17383,6.28857c.16138.13282.32336.26514.49756.38721.12671.08887.26294.15161.39282.23193a39.78776,39.78776,0,0,1,9.26489,9.31006,76.44756,76.44756,0,0,0-35.5498,40.00293A52.31117,52.31117,0,0,0,76,120a51.67572,51.67572,0,0,0-22.07556,4.93262A40.03451,40.03451,0,0,1,48.62964,111.09448Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,1,1,14.30583-85.62208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "79.6638",
          y1: "56.73022",
          x2: "75.49625",
          y2: "33.09483",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48.68557",
          y1: "76.45789",
          x2: "29.02592",
          y2: "62.69205",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.73022",
          y1: "112.31237",
          x2: "17.09483",
          y2: "116.47993",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "115.51829",
          y1: "64.68557",
          x2: "129.28412",
          y2: "45.02592",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M51.64386,135.35374A48.008,48.008,0,1,1,131.83232,84.4235",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconClub = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,148a52.00505,52.00505,0,0,1-80.459,43.52539l10.6538,34.08789A7.99984,7.99984,0,0,1,154.55908,236H101.44092a7.99954,7.99954,0,0,1-7.63526-10.38672L104.45459,191.542a51.7046,51.7046,0,0,1-29.9624,8.43653c-27.72657-.78516-50.377-24.00489-50.4917-51.75977A51.99976,51.99976,0,0,1,76,96q2.02881,0,4.04883.15625a52.00294,52.00294,0,1,1,95.89648,0,53.33621,53.33621,0,0,1,5.46387-.1377A51.70261,51.70261,0,0,1,232,148Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M112.51708,179.15431a47.97767,47.97767,0,1,1-25.30276-77.83722l-.00069.00287a48,48,0,1,1,81.57046.00366l-.00718-.00443a48.00575,48.00575,0,1,1-25.29289,77.8364L160,232H96Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCode = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "64 88 16 128 64 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192 88 240 128 192 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCodeSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M93.97949,58.68555a7.99976,7.99976,0,0,0-11.29443-.665l-72,64a8.00054,8.00054,0,0,0,0,11.959l72,64a8.00018,8.00018,0,0,0,10.62988-11.959L28.0415,128,93.31494,69.97949A8,8,0,0,0,93.97949,58.68555Z"
        }), React.createElement("path", {
          d: "M245.31494,122.02051l-72-64a8.00018,8.00018,0,0,0-10.62988,11.959L227.9585,128l-65.27344,58.02051a8.00018,8.00018,0,0,0,10.62988,11.959l72-64a8.00054,8.00054,0,0,0,0-11.959Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "88 64 16 128 88 192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "168 64 240 128 168 192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCoffee = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,56V24a8,8,0,0,1,16,0V56a8,8,0,0,1-16,0Zm40,8a8.00008,8.00008,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8.00008,8.00008,0,0,0,120,64Zm32,0a8.00008,8.00008,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8.00008,8.00008,0,0,0,152,64Zm96,56v8a40.04613,40.04613,0,0,1-37.50781,39.91455A96.65441,96.65441,0,0,1,183.46387,208H208a8,8,0,0,1,0,16H156.8208c-.0376.00049-.07568.00586-.11279.00586-.02832,0-.05615-.00537-.08447-.00586H83.15869c-.04541-.001-.09033.00146-.13574,0H32a8,8,0,0,1,0-16H56.53613A96.31957,96.31957,0,0,1,24,136V88a8.00008,8.00008,0,0,1,8-8H208A40.04521,40.04521,0,0,1,248,120Zm-16,0a24.03806,24.03806,0,0,0-16-22.624V136a95.32337,95.32337,0,0,1-1.20312,15.01367A24.039,24.039,0,0,0,232,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "88",
          y1: "24",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120",
          y1: "24",
          x2: "120",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "216",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M83.29651,216.0038A88.01441,88.01441,0,0,1,32,136V88H208v48a88.0144,88.0144,0,0,1-51.29712,80.00408",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208,88h0a32,32,0,0,1,32,32V128a32,32,0,0,1-32,32h-3.37846",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCoin = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.57812,63.84473C186.84668,53.47852,159.3291,48,128,48S69.15332,53.47852,48.42188,63.84473C27.81738,74.14746,16,88.7832,16,104v48c0,15.2168,11.81738,29.85254,32.42188,40.15527C69.15332,202.52148,96.6709,208,128,208s58.84668-5.47852,79.57812-15.84473C228.18262,181.85254,240,167.2168,240,152V104C240,88.7832,228.18262,74.14746,207.57812,63.84473ZM120,159.86328V191.855c-18.98486-.62207-35.02637-3.42822-48-7.49414V153.04541A203.76361,203.76361,0,0,0,120,159.86328Zm16,0a203.76361,203.76361,0,0,0,48-6.81787v31.31543c-12.97363,4.06592-29.01514,6.87207-48,7.49414ZM32,152V133.53076a82.6098,82.6098,0,0,0,16.42188,10.62451c2.43164,1.21582,4.96484,2.3584,7.57812,3.43848v30.43359C40.17334,170.16455,32,160.294,32,152Zm168,26.02734V147.59375c2.61328-1.08008,5.14648-2.22266,7.57812-3.43848A82.6098,82.6098,0,0,0,224,133.53076V152C224,160.294,215.82666,170.16455,200,178.02734Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("ellipse", {
          cx: "128",
          cy: "104",
          rx: "104",
          ry: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "192",
          y1: "142.10679",
          x2: "192",
          y2: "190.10744",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "142.10679",
          x2: "64",
          y2: "190.10721",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconColumns = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M120,48V208a16.01833,16.01833,0,0,1-16,16H64a16.01833,16.01833,0,0,1-16-16V48A16.01833,16.01833,0,0,1,64,32h40A16.01833,16.01833,0,0,1,120,48Zm72-16H152a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h40a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,192,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "-4",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(212 44) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "84",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCommand = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M180,144H160V112h20a36,36,0,1,0-36-36V96H112V76a36,36,0,1,0-36,36H96v32H76a36,36,0,1,0,36,36V160h32v20a36,36,0,1,0,36-36ZM160,76a20,20,0,1,1,20,20H160ZM56,76a20,20,0,0,1,40,0V96H76A20.0226,20.0226,0,0,1,56,76ZM96,180a20,20,0,1,1-20-20H96Zm16-68h32v32H112Zm68,88a20.0226,20.0226,0,0,1-20-20V160h20a20,20,0,0,1,0,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M180,48h.00006A27.99994,27.99994,0,0,1,208,75.99994V76a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48,48H76a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,76.00006,104H76A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
          transform: "translate(152 152) rotate(180)",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,152h28a28,28,0,0,1,28,28v.00006A27.99994,27.99994,0,0,1,180.00006,208H180a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M76,152h.00006A27.99994,27.99994,0,0,1,104,179.99994V180a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
          transform: "translate(152 360) rotate(-180)",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCompass = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M127.99975,24a104,104,0,1,0,104,104A104.11791,104.11791,0,0,0,127.99975,24Zm52.34961,62.124-28.09472,62.14209a7.99954,7.99954,0,0,1-4.13868,4.05713L88.71948,177.7793A7.99971,7.99971,0,0,1,78.2146,167.27539l25.45507-59.39746a8.00275,8.00275,0,0,1,4.043-4.13086L169.74878,75.5459A8,8,0,0,1,180.34936,86.124Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "144.965 144.971 173.059 82.828 111.024 111.029 85.568 170.426 144.965 144.971",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconComputerTower = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,24H64A16.01833,16.01833,0,0,0,48,40V216a16.01833,16.01833,0,0,0,16,16H192a16.01833,16.01833,0,0,0,16-16V40A16.01833,16.01833,0,0,0,192,24ZM128,192a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,128,192Zm32-80H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "160",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "104",
          x2: "96",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "128",
          cy: "180",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCookie = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M225.94092,114.89844a15.91968,15.91968,0,0,0-13.46094-3.085,23.99389,23.99389,0,0,1-29.27832-23.14063,15.94771,15.94771,0,0,0-15.87354-15.875A23.99268,23.99268,0,0,1,144.187,43.51953a16.01308,16.01308,0,0,0-15.562-19.51367c-.21729-.001-.43018-.00195-.647-.00195A104,104,0,1,0,231.99463,127.3623v-.001A15.97461,15.97461,0,0,0,225.94092,114.89844ZM75.51465,99.51465a12.0001,12.0001,0,1,1,0,16.9707A12.00062,12.00062,0,0,1,75.51465,99.51465Zm24.9707,72.9707a12.0001,12.0001,0,1,1,0-16.9707A12.00062,12.00062,0,0,1,100.48535,172.48535Zm27.0293-40a12.0001,12.0001,0,1,1,16.9707,0A12.00019,12.00019,0,0,1,127.51465,132.48535Zm36.9707,48a12.0001,12.0001,0,1,1,0-16.9707A12.00062,12.00062,0,0,1,164.48535,180.48535Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.9944,127.41159a95.69791,95.69791,0,0,1-28.17312,68.53158c-36.94566,36.88079-97.30608,37.29538-134.72958.89956a95.99643,95.99643,0,0,1,67.48515-164.8372,8.01374,8.01374,0,0,1,7.80464,9.7612,31.99345,31.99345,0,0,0,30.85987,39.031,8.02776,8.02776,0,0,1,7.96088,7.96088,31.99346,31.99346,0,0,0,39.03035,30.86A8.01158,8.01158,0,0,1,223.9944,127.41159Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "156",
          cy: "172",
          r: "12"
        }), React.createElement("circle", {
          cx: "92",
          cy: "164",
          r: "12"
        }), React.createElement("circle", {
          cx: "84",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "136",
          cy: "124",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCookingPot = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M88,48V16a8,8,0,0,1,16,0V48a8,8,0,0,1-16,0Zm40,8a8.00039,8.00039,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8.00039,8.00039,0,0,0,128,56Zm32,0a8.00039,8.00039,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8.00039,8.00039,0,0,0,160,56Zm94.3999,35.2002a7.99886,7.99886,0,0,0-11.1997-1.6001L224,104V88a16.01833,16.01833,0,0,0-16-16H48A16.01833,16.01833,0,0,0,32,88v16L12.7998,89.6001a7.9998,7.9998,0,0,0-9.5996,12.7998L32,124v60a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V124l28.7998-21.6001A7.9993,7.9993,0,0,0,254.3999,91.2002Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "16",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "16",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48,80H208a8,8,0,0,1,8,8v96a24,24,0,0,1-24,24H64a24,24,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "248",
          y1: "96",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "8",
          y1: "96",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCopy = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99414,31.99316h-128a8.0004,8.0004,0,0,0-8,8v40.001h-40.001a8.0004,8.0004,0,0,0-8,8v128a8.0004,8.0004,0,0,0,8,8h128a8.00039,8.00039,0,0,0,8-8v-40.001h40.001a8.00039,8.00039,0,0,0,8-8v-128A8.0004,8.0004,0,0,0,215.99414,31.99316Zm-8,128h-32.001v-71.999a8.00039,8.00039,0,0,0-8-8h-71.999v-32.001h112Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "168 167.993 216 167.993 216 39.993 88 39.993 88 87.993",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "39.99902",
          y: "87.99414",
          width: "128",
          height: "128",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCopySimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M215.99365,31.99414H71.98682a8,8,0,1,0,0,16H207.99365v136.001a8,8,0,0,0,16,0V39.99414A8.00008,8.00008,0,0,0,215.99365,31.99414Z"
        }), React.createElement("rect", {
          x: "31.98682",
          y: "63.99512",
          width: "160.00586",
          height: "160",
          rx: "8"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "215.993 183.995 215.993 39.994 71.986 39.994",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "39.98633",
          y: "71.99512",
          width: "144.00586",
          height: "144",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCopyright = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,20A108,108,0,1,0,236,128,108.12249,108.12249,0,0,0,128,20Zm0,196a88,88,0,1,1,88-88A88.09957,88.09957,0,0,1,128,216Zm0-160a72,72,0,1,0,72,72A72.08124,72.08124,0,0,0,128,56Zm.00293,103.99512a31.76384,31.76384,0,0,0,25.60254-12.79981,8,8,0,0,1,12.791,9.61182,47.99976,47.99976,0,1,1,0-57.62451,8,8,0,0,1-12.791,9.61181,32.001,32.001,0,1,0-25.60254,51.20069Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M160.00112,152.00142a40,40,0,1,1-.00029-48.013",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCornersIn = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,96V48a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8.00038,8.00038,0,0,1,208,104H160A8.00008,8.00008,0,0,1,152,96ZM96,152H48a8.00038,8.00038,0,0,0-5.65723,13.65674l48,48A8.0001,8.0001,0,0,0,104,208V160A8.00008,8.00008,0,0,0,96,152ZM99.06152,40.60889a7.99989,7.99989,0,0,0-8.71875,1.73437l-48,48A8.00038,8.00038,0,0,0,48,104H96a8.00008,8.00008,0,0,0,8-8V48A8.00015,8.00015,0,0,0,99.06152,40.60889ZM208,152H160a8.00008,8.00008,0,0,0-8,8v48a8.00018,8.00018,0,0,0,13.65723,5.65674l48-48A8.00038,8.00038,0,0,0,208,152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "208 96 160 96 160 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "48 160 96 160 96 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "160 208 160 160 208 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 48 96 96 48 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCornersOut = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,48V88a8.00018,8.00018,0,0,1-13.65723,5.65674l-40-40A8.00037,8.00037,0,0,1,168,40h40A8.00008,8.00008,0,0,1,216,48ZM53.65723,162.34326A8.0001,8.0001,0,0,0,40,168v40a8.00039,8.00039,0,0,0,8,8H88a8.00038,8.00038,0,0,0,5.65723-13.65674Zm157.40429-1.73437a8.00026,8.00026,0,0,0-8.71875,1.73437l-40,40A8.00037,8.00037,0,0,0,168,216h40a8.00039,8.00039,0,0,0,8-8V168A8.00065,8.00065,0,0,0,211.06152,160.60889ZM88,40H48a8.00008,8.00008,0,0,0-8,8V88a8.00018,8.00018,0,0,0,13.65723,5.65674l40-40A8.00038,8.00038,0,0,0,88,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCpu = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,144H216V112h16a8,8,0,0,0,0-16H216V56a16.01833,16.01833,0,0,0-16-16H160V24a8,8,0,0,0-16,0V40H112V24a8,8,0,0,0-16,0V40H56A16.01833,16.01833,0,0,0,40,56V96H24a8,8,0,0,0,0,16H40v32H24a8,8,0,0,0,0,16H40v40a16.01833,16.01833,0,0,0,16,16H96v16a8,8,0,0,0,16,0V216h32v16a8,8,0,0,0,16,0V216h40a16.01833,16.01833,0,0,0,16-16V160h16a8,8,0,0,0,0-16Zm-68,12a8.00039,8.00039,0,0,1-8,8H100a8.00039,8.00039,0,0,1-8-8V100a8.00039,8.00039,0,0,1,8-8h56a8.00039,8.00039,0,0,1,8,8Zm-56-48h40v40H108Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "100",
          y: "100",
          width: "56",
          height: "56",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "48",
          y: "48",
          width: "160",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "208",
          y1: "104",
          x2: "232",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "152",
          x2: "232",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24",
          y1: "104",
          x2: "48",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24",
          y1: "152",
          x2: "48",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "208",
          x2: "104",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "24",
          x2: "104",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCreditCard = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,48H32A16.01833,16.01833,0,0,0,16,64V96.73633c-.00049.03906-.00586.07715-.00586.11621s.00537.07715.00586.11621V192a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,224,48ZM135.99414,176h-16a8,8,0,0,1,0-16h16a8,8,0,1,1,0,16Zm64,0h-32a8,8,0,0,1,0-16h32a8,8,0,1,1,0,16ZM32,88.85254V64H224l.002,24.85254Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "167.99414",
          y1: "168",
          x2: "199.99414",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "119.99414",
          y1: "168",
          x2: "135.99414",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "23.99414",
          y1: "96.85228",
          x2: "231.99412",
          y2: "96.85228",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCrop = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240.00244,192.001a8.00039,8.00039,0,0,1-8,8h-32v32a8,8,0,0,1-16,0v-32h-120a8.00039,8.00039,0,0,1-8-8V72h-32a8,8,0,0,1,0-16h32V24a8,8,0,1,1,16,0V184.001h160A8.00039,8.00039,0,0,1,240.00244,192.001ZM95.99365,72h88.00879v88.001a8,8,0,0,0,16,0V64a8.00008,8.00008,0,0,0-8-8H95.99365a8,8,0,0,0,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "63.99414",
          y1: "64",
          x2: "24.00244",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "64.002 24 64.002 192.001 232.002 192.001",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192.002 160.001 192.002 64 95.994 64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "192.00244",
          y1: "232.00098",
          x2: "192.00244",
          y2: "192.00098",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCrosshair = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M236,120H223.66406A96.15352,96.15352,0,0,0,136,32.33618V20a8,8,0,0,0-16,0V32.33618A96.15352,96.15352,0,0,0,32.33594,120H20a8,8,0,0,0,0,16H32.33594A96.15352,96.15352,0,0,0,120,223.66382V236a8,8,0,0,0,16,0V223.66382A96.15352,96.15352,0,0,0,223.66406,136H236a8,8,0,0,0,0-16Zm-40,16h11.59912A80.14164,80.14164,0,0,1,136,207.59912V196a8,8,0,0,0-16,0v11.59912A80.14164,80.14164,0,0,1,48.40088,136H60a8,8,0,0,0,0-16H48.40088A80.14164,80.14164,0,0,1,120,48.40088V60a8,8,0,0,0,16,0V48.40088A80.14164,80.14164,0,0,1,207.59912,120H196a8,8,0,0,0,0,16Z"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "40"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "20",
          x2: "128",
          y2: "60",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "20",
          y1: "128",
          x2: "60",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "236",
          x2: "128",
          y2: "196",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "236",
          y1: "128",
          x2: "196",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCrosshairSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,28A100,100,0,1,0,228,128,100.113,100.113,0,0,0,128,28Zm8,183.60938V180a8,8,0,0,0-16,0v31.60938A84.13251,84.13251,0,0,1,44.39062,136H76a8,8,0,0,0,0-16H44.39062A84.13249,84.13249,0,0,1,120,44.39063V76a8,8,0,0,0,16,0V44.39063A84.13247,84.13247,0,0,1,211.60937,120H180a8,8,0,0,0,0,16h31.60937A84.13249,84.13249,0,0,1,136,211.60938Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "92",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "76",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "220",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCrown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M238.72754,73.53516a15.90424,15.90424,0,0,0-16.70508-2.29981l-50.584,22.48242L141.98633,40.70312a15.999,15.999,0,0,0-27.97266,0L84.56055,93.7168,33.96875,71.23145A16.00031,16.00031,0,0,0,11.89551,89.51172l25.44531,108.333a15.83567,15.83567,0,0,0,7.4082,10.09179,16.15491,16.15491,0,0,0,12.49317,1.65137,265.89708,265.89708,0,0,1,141.46875-.01367,16.15265,16.15265,0,0,0,12.4873-1.65137,15.83531,15.83531,0,0,0,7.40821-10.084L244.0957,89.52051A15.90513,15.90513,0,0,0,238.72754,73.53516Zm-70.77149,88.98046a7.9897,7.9897,0,0,1-8.793,7.11915,298.37472,298.37472,0,0,0-62.32618,0,8,8,0,0,1-1.67382-15.91211,314.358,314.358,0,0,1,65.67382,0A7.99917,7.99917,0,0,1,167.95605,162.51562Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M95.99993,161.6787a305.83767,305.83767,0,0,1,64.00009,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCrownSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M238.72754,73.53516a15.90424,15.90424,0,0,0-16.70508-2.29981l-50.584,22.48242L141.98633,40.70312a15.999,15.999,0,0,0-27.97266,0L84.56055,93.7168,33.96875,71.23145A16.00031,16.00031,0,0,0,11.89551,89.51172l25.44531,108.333a15.83567,15.83567,0,0,0,7.4082,10.09179,16.15491,16.15491,0,0,0,12.49317,1.65137,265.89708,265.89708,0,0,1,141.46875-.01367,16.15265,16.15265,0,0,0,12.4873-1.65137,15.83531,15.83531,0,0,0,7.40821-10.084L244.0957,89.52051A15.90513,15.90513,0,0,0,238.72754,73.53516Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M45.12859,196.01674a8.01266,8.01266,0,0,0,9.97356,5.86223,273.90053,273.90053,0,0,1,145.746-.0138,8.01268,8.01268,0,0,0,9.97132-5.85941l25.48872-108.3169a8,8,0,0,0-11.03641-9.143L174.688,101.02754a8,8,0,0,1-10.24237-3.42535l-29.4524-53.01433a8,8,0,0,0-13.98652,0L91.55434,97.60219A8,8,0,0,1,81.312,101.02754L30.72054,78.54246a8,8,0,0,0-11.03717,9.13973Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCube = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.92236,70.81226c-.0249-.04541-.04345-.09229-.06933-.13746-.01123-.01953-.02442-.03662-.03565-.0559a15.989,15.989,0,0,0-5.97314-5.8855l-88-49.5a16.09272,16.09272,0,0,0-15.68848,0l-88,49.5A15.99092,15.99092,0,0,0,26.168,70.64575c-.01563.0271-.03369.05127-.04883.07862-.02441.0437-.042.08886-.06543.13256A15.98294,15.98294,0,0,0,24,78.67871v98.64258a16.02048,16.02048,0,0,0,8.15576,13.94531l88.00049,49.5a15.97122,15.97122,0,0,0,7.24463,2.02222c.17871.01343.35693.03052.53906.032.02393.00049.04785.00049.07178.00049.25146,0,.499-.01465.74463-.03735a15.97135,15.97135,0,0,0,7.08789-2.01734l88-49.5A16.02048,16.02048,0,0,0,232,177.32129V78.67871A15.98584,15.98584,0,0,0,229.92236,70.81226ZM128.91016,118.821,48.37891,73.96558,128,29.17871l79.74365,44.856ZM216,177.32129l-79.87891,44.93188.78711-89.57421L216,87.74561Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,177.32117V78.67873a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67873v98.64244a8,8,0,0,0,4.07791,6.97261l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32117Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "222.897 74.626 128.949 128 33.108 74.617",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128.94915",
          y1: "127.99996",
          x2: "128.01036",
          y2: "234.82127",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyBtc = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M170.4834,115.70117A43.973,43.973,0,0,0,144,40.18994V24a8,8,0,0,0-16,0V39.999l-16-.00146V24a8,8,0,0,0-16,0V39.99658l-16.00488-.00146h-16.001a8,8,0,0,0,0,16h8v136h-8a8,8,0,0,0,0,16h15.999L96,207.99609V224a8,8,0,0,0,16,0V207.99707l16,.00147V224a8,8,0,0,0,16,0V207.99951L152,208a48.00015,48.00015,0,0,0,18.4834-92.29883ZM168,84a28.03146,28.03146,0,0,1-28,28H87.99414V55.99609l15.95215.001c.01807.00049.03564.00293.05371.00293s.03564-.00244.05371-.00293l31.94043.00244L136,56l.00586-.00049L140,56A28.03146,28.03146,0,0,1,168,84ZM152.001,192l-64.00684-.00391V128H152a32,32,0,0,1,.001,64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,120h72a40,40,0,0,1,0,80l-72.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "63.99414",
          y1: "47.99512",
          x2: "79.99414",
          y2: "47.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "63.99414",
          y1: "199.99512",
          x2: "79.99414",
          y2: "199.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136",
          y1: "48",
          x2: "136",
          y2: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "224",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136",
          y1: "224",
          x2: "136",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyCircleDollar = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm12,152h-4v8a8,8,0,0,1-16,0v-8H104a8,8,0,0,1,0-16h36a12,12,0,0,0,0-24H116a28,28,0,0,1,0-56h4V72a8,8,0,0,1,16,0v8h16a8,8,0,0,1,0,16H116a12,12,0,0,0,0,24h24a28,28,0,0,1,0,56Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyCny = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56,64a8.00008,8.00008,0,0,1,8-8H192a8,8,0,0,1,0,16H64A8.00008,8.00008,0,0,1,56,64ZM216,168a8.00039,8.00039,0,0,0-8,8v16H176a16.01833,16.01833,0,0,1-16-16V128h48a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16H96v8a56.0629,56.0629,0,0,1-56,56,8,8,0,0,0,0,16,72.08124,72.08124,0,0,0,72-72v-8h32v48a32.03667,32.03667,0,0,0,32,32h40a8.00039,8.00039,0,0,0,8-8V176A8.00039,8.00039,0,0,0,216,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "120",
          x2: "208",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,120v56a24,24,0,0,0,24,24h40V176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M104,120v16a64,64,0,0,1-64,64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyDollar = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,120H136V56h8a32.03635,32.03635,0,0,1,32,32,8,8,0,0,0,16,0,48.054,48.054,0,0,0-48-48h-8V24a8,8,0,0,0-16,0V40H108a48,48,0,0,0,0,96h12v64H104a32.03635,32.03635,0,0,1-32-32,8,8,0,0,0-16,0,48.054,48.054,0,0,0,48,48h16v16a8,8,0,0,0,16,0V216h16a48,48,0,0,0,0-96Zm-32,0H108a32,32,0,0,1,0-64h12Zm32,80H136V136h16a32,32,0,0,1,0,64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyDollarSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,168a48.054,48.054,0,0,1-48,48H136v16a8,8,0,0,1-16,0V216H104a48.054,48.054,0,0,1-48-48,8,8,0,0,1,16,0,32.03635,32.03635,0,0,0,32,32h48a32,32,0,0,0,0-64H108a48,48,0,0,1,0-96h12V24a8,8,0,0,1,16,0V40h8a48.054,48.054,0,0,1,48,48,8,8,0,0,1-16,0,32.03635,32.03635,0,0,0-32-32H108a32,32,0,0,0,0,64h44A48.054,48.054,0,0,1,200,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyEur = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192.56934,189.25488a7.99974,7.99974,0,0,1-.001,11.314A80.00019,80.00019,0,0,1,56.40088,152H40a8,8,0,0,1,0-16H56V120H40a8,8,0,0,1,0-16H56.40088A80.00019,80.00019,0,0,1,192.56836,55.43115a7.99984,7.99984,0,1,1-11.3125,11.31446A63.98841,63.98841,0,0,0,72.51758,104H136a8,8,0,0,1,0,16H72v16h48a8,8,0,0,1,0,16H72.51758a63.98841,63.98841,0,0,0,108.73828,37.25439A8.00093,8.00093,0,0,1,192.56934,189.25488Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M186.91167,194.91171A72,72,0,0,1,64,144V112A72,72,0,0,1,186.91167,61.08829",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "112",
          x2: "136",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "144",
          x2: "120",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyGbp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,208a8.00008,8.00008,0,0,1-8,8H56a8,8,0,0,1,0-16,28.03146,28.03146,0,0,0,28-28V140H56a8,8,0,0,1,0-16H84V84a52,52,0,0,1,88.76953-36.76953A8.00018,8.00018,0,0,1,161.45508,58.544,35.99961,35.99961,0,0,0,100,84v40h36a8,8,0,0,1,0,16H100v32a43.79772,43.79772,0,0,1-10.083,28H184A8.00008,8.00008,0,0,1,192,208Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("line", {
          x1: "56",
          y1: "132",
          x2: "136",
          y2: "132",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,75.11269-31.11271",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        })));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyInr = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,80a8.00039,8.00039,0,0,1-8,8H167.85156c.08789,1.32373.14844,2.65454.14844,4a60.06812,60.06812,0,0,1-60,60H92.69238l72.68946,66.08008a8.0006,8.0006,0,0,1-10.76368,11.83984l-88-80A8.0004,8.0004,0,0,1,72,136h36a44.04978,44.04978,0,0,0,44-44c0-1.34912-.0708-2.68164-.18994-4H72a8,8,0,0,1,0-16h75.17188A44.03678,44.03678,0,0,0,108,48H72a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16H148.73535a60.16006,60.16006,0,0,1,15.82422,24H200A8.00039,8.00039,0,0,1,208,80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "72",
          y1: "80",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72",
          y1: "40",
          x2: "200",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M108,40a52,52,0,0,1,0,104H72l88,80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyJpy = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M206.19141,53.06592,144.88184,128H176a8,8,0,0,1,0,16H136v16h40a8,8,0,0,1,0,16H136v40a8,8,0,0,1-16,0V176H80a8,8,0,0,1,0-16h40V144H80a8,8,0,0,1,0-16h31.11816L49.80859,53.06592A7.99982,7.99982,0,1,1,62.19141,42.93408L128,123.3667l65.80859-80.43262a7.99982,7.99982,0,1,1,12.38282,10.13184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "80",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("g", null, React.createElement("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "200 48 128 136 56 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        })));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyKrw = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,128H217.88525l21.52686-52.98926a8.00025,8.00025,0,0,0-14.82422-6.02148L200.61523,128H159.38477L135.41211,68.98926a8.00039,8.00039,0,0,0-14.82422,0L96.61523,128H55.38477L31.41211,68.98926a8.00025,8.00025,0,0,0-14.82422,6.02148L38.11475,128H16a8,8,0,0,0,0,16H44.61475l23.97314,59.01074a8.00039,8.00039,0,0,0,14.82422,0L107.38477,144h41.23046l23.97266,59.01074a8.00039,8.00039,0,0,0,14.82422,0L211.38525,144H240a8,8,0,0,0,0-16ZM76,178.74512,61.88477,144H90.11523ZM113.88477,128,128,93.25488,142.11523,128ZM180,178.74512,165.88477,144h28.23046Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "24 72 76 200 128 72 180 200 232 72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCurrencyRub = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M148,152a60,60,0,0,0,0-120H88a8.00039,8.00039,0,0,0-8,8v96H56a8,8,0,0,0,0,16H80v16H56a8,8,0,0,0,0,16H80v32a8,8,0,0,0,16,0V184h48a8,8,0,0,0,0-16H96V152ZM96,48h52a44,44,0,0,1,0,88H96Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "56",
          y1: "176",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,216V40h60a52,52,0,0,1,0,104H56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconCursor = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M150.54443,139.22559l55.83594-20.30469a15.99964,15.99964,0,0,0,.15039-30.01758L51.29346,30.68945A15.99937,15.99937,0,0,0,30.69482,51.28906v-.00049L88.90869,206.52588a15.85524,15.85524,0,0,0,14.97656,10.38232h.084a15.86,15.86,0,0,0,14.957-10.53222L139.23047,150.54l63.11767,63.11719a8.00053,8.00053,0,0,0,11.31446-11.31446Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M38.18466,48.47939l58.21413,155.2377a8,8,0,0,0,15.009-.075L134.729,139.50856a8,8,0,0,1,4.78441-4.7844l64.13348-23.32127a8,8,0,0,0,.07505-15.009L48.48428,38.17977A8,8,0,0,0,38.18466,48.47939Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136.59053",
          y1: "136.58564",
          x2: "208.00488",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDatabase = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24C74.168,24,32,48.59814,32,80v96c0,31.40186,42.168,56,96,56s96-24.59814,96-56V80C224,48.59814,181.832,24,128,24Zm80,104c0,9.61719-7.875,19.42871-21.60547,26.918C170.92822,163.354,150.18994,168,128,168s-42.92822-4.646-58.39453-13.082C55.875,147.42871,48,137.61719,48,128V111.35645C65.05994,126.3208,94.234,136,128,136s62.94006-9.6792,80-24.64355Zm-21.60547,74.918C170.92822,211.354,150.19043,216,128,216s-42.92822-4.646-58.39453-13.082C55.875,195.42871,48,185.61719,48,176V159.35645C65.05994,174.3208,94.234,184,128,184s62.94006-9.6792,80-24.64355V176C208,185.61719,200.125,195.42871,186.39453,202.918Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("ellipse", {
          cx: "128",
          cy: "80",
          rx: "88",
          ry: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M40,80v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M40,128v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDesktop = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,40H48A24.0275,24.0275,0,0,0,24,64V176a24.0275,24.0275,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24.0275,24.0275,0,0,0,24-24V64A24.0275,24.0275,0,0,0,208,40Zm0,144H48a8.00917,8.00917,0,0,1-8-8V160H216v16A8.00917,8.00917,0,0,1,208,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDesktopTower = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M120,80V184a8.00008,8.00008,0,0,1-8,8H96v16h16a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H80V192H32A24.0275,24.0275,0,0,1,8,168V96A24.0275,24.0275,0,0,1,32,72h80A8.00008,8.00008,0,0,1,120,80ZM248,48V208a16.01833,16.01833,0,0,1-16,16H152a16.01833,16.01833,0,0,1-16-16V48a16.01833,16.01833,0,0,1,16-16h80A16.01833,16.01833,0,0,1,248,48ZM204,180a12,12,0,1,0-12,12A12.01343,12.01343,0,0,0,204,180Zm20-76a8.00008,8.00008,0,0,0-8-8H168a8,8,0,0,0,0,16h48A8.00008,8.00008,0,0,0,224,104Zm0-32a8.00008,8.00008,0,0,0-8-8H168a8,8,0,0,0,0,16h48A8.00008,8.00008,0,0,0,224,72Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "216",
          x2: "64",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "72",
          x2: "176",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "104",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "144",
          y: "40",
          width: "96",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "88",
          y1: "184",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "192",
          cy: "180",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDeviceMobile = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,16H80A24.0275,24.0275,0,0,0,56,40V216a24.0275,24.0275,0,0,0,24,24h96a24.0275,24.0275,0,0,0,24-24V40A24.0275,24.0275,0,0,0,176,16ZM80,32h96a8.00917,8.00917,0,0,1,8,8v8H72V40A8.00917,8.00917,0,0,1,80,32Zm96,192H80a8.00917,8.00917,0,0,1-8-8v-8H184v8A8.00917,8.00917,0,0,1,176,224Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "64",
          y: "24",
          width: "128",
          height: "208",
          rx: "16",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "64",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "200",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDeviceMobileCamera = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,16H80A24.0275,24.0275,0,0,0,56,40V216a24.0275,24.0275,0,0,0,24,24h96a24.0275,24.0275,0,0,0,24-24V40A24.0275,24.0275,0,0,0,176,16ZM128,72a12,12,0,1,1,12-12A12,12,0,0,1,128,72Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "128",
          cy: "60",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDeviceMobileSpeaker = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,16H80A24.0275,24.0275,0,0,0,56,40V216a24.0275,24.0275,0,0,0,24,24h96a24.0275,24.0275,0,0,0,24-24V40A24.0275,24.0275,0,0,0,176,16ZM160,64H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "96",
          y1: "56",
          x2: "160",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDeviceTablet = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,24H64A24.0275,24.0275,0,0,0,40,48V208a24.0275,24.0275,0,0,0,24,24H192a24.0275,24.0275,0,0,0,24-24V48A24.0275,24.0275,0,0,0,192,24ZM64,40H192a8.00917,8.00917,0,0,1,8,8v8H56V48A8.00917,8.00917,0,0,1,64,40ZM192,216H64a8.00917,8.00917,0,0,1-8-8v-8H200v8A8.00917,8.00917,0,0,1,192,216Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "48",
          y1: "64",
          x2: "208",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "192",
          x2: "208",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDeviceTabletCamera = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,24H64A24.0275,24.0275,0,0,0,40,48V208a24.0275,24.0275,0,0,0,24,24H192a24.0275,24.0275,0,0,0,24-24V48A24.0275,24.0275,0,0,0,192,24ZM128,80a12,12,0,1,1,12-12A12,12,0,0,1,128,80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "128",
          cy: "68",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDeviceTabletSpeaker = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,24H64A24.0275,24.0275,0,0,0,40,48V208a24.0275,24.0275,0,0,0,24,24H192a24.0275,24.0275,0,0,0,24-24V48A24.0275,24.0275,0,0,0,192,24ZM160,72H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDiamond = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M236,139.31348,139.31348,236a16.01779,16.01779,0,0,1-22.627,0L20,139.31348a16.01779,16.01779,0,0,1,0-22.627L116.68652,20a16.01779,16.01779,0,0,1,22.627,0L236,116.68652A16.01779,16.01779,0,0,1,236,139.31348Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "51.63247",
          y: "51.63247",
          width: "152.73506",
          height: "152.73506",
          rx: "8",
          transform: "translate(-53.01934 128) rotate(-45)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDiceFive = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM92,176a12,12,0,1,1,12-12A12,12,0,0,1,92,176Zm0-72a12,12,0,1,1,12-12A12,12,0,0,1,92,104Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,164,176Zm0-72a12,12,0,1,1,12-12A12,12,0,0,1,164,104Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "92",
          cy: "92",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "92",
          r: "12"
        }), React.createElement("circle", {
          cx: "92",
          cy: "164",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "164",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDiceFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM100,168a12,12,0,1,1,12-12A12,12,0,0,1,100,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,100,112Zm56,56a12,12,0,1,1,12-12A12,12,0,0,1,156,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,156,112Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "100",
          cy: "100",
          r: "12"
        }), React.createElement("circle", {
          cx: "156",
          cy: "100",
          r: "12"
        }), React.createElement("circle", {
          cx: "100",
          cy: "156",
          r: "12"
        }), React.createElement("circle", {
          cx: "156",
          cy: "156",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDiceOne = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM128,140a12,12,0,1,1,12-12A12,12,0,0,1,128,140Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDiceSix = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM92,184a12,12,0,1,1,12-12A12,12,0,0,1,92,184Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,92,140Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,92,96Zm72,88a12,12,0,1,1,12-12A12,12,0,0,1,164,184Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,164,140Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,164,96Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "92",
          cy: "84",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "84",
          r: "12"
        }), React.createElement("circle", {
          cx: "92",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "92",
          cy: "172",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "172",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDiceThree = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32ZM92,104a12,12,0,1,1,12-12A12,12,0,0,1,92,104Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,164,176Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "92",
          cy: "92",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "164",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDiceTwo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,32H64A32.03667,32.03667,0,0,0,32,64V192a32.03667,32.03667,0,0,0,32,32H192a32.03667,32.03667,0,0,0,32-32V64A32.03667,32.03667,0,0,0,192,32Zm-84,88a12,12,0,1,1,12-12A12,12,0,0,1,108,120Zm40,40a12,12,0,1,1,12-12A12,12,0,0,1,148,160Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "108",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "148",
          cy: "148",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDisc = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188.29883,43.31128a8.00224,8.00224,0,0,0-1.35889-.94751,103.67838,103.67838,0,1,0,1.35889.94751ZM128,152a24,24,0,1,1,24-24A24.0275,24.0275,0,0,1,128,152Zm88-24c0,2.47168-.10791,4.91833-.30859,7.339l-47.71875-8.41419a39.84182,39.84182,0,0,0-10.95777-26.41552l27.77808-39.671A87.83762,87.83762,0,0,1,216,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "195.88225",
          y1: "60.11775",
          x2: "150.62742",
          y2: "105.37258",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDiscordLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M247.29492,169.80862,213.32129,56.56252A15.953,15.953,0,0,0,204.084,46.35744l-.53759.16309.54931-.1919a185.84371,185.84371,0,0,0-34.53515-10.30712,8.00026,8.00026,0,1,0-3.12012,15.69336q6.72656,1.3374,13.18457,3.14746a7.97792,7.97792,0,0,1-4.46045,15.07714,188.85309,188.85309,0,0,0-93.26074-.18359,7.99484,7.99484,0,0,1-5.56592-14.87305l.03418.01172q6.4541-1.80762,13.20068-3.15185a8.00026,8.00026,0,0,0-3.12011-15.69336A185.88539,185.88539,0,0,0,51.917,46.35647a15.95771,15.95771,0,0,0-9.23828,10.20507L8.70508,169.80862a16.09028,16.09028,0,0,0,4.88672,16.72656c.95459.83008,1.9331,1.645,2.92529,2.45166.02344.019.04346.041.06689.06006,16.23047,13.166,37.50342,23.22461,61.51856,29.08691a7.99977,7.99977,0,0,0,3.79492-15.543,160.72734,160.72734,0,0,1-31.33789-11.0664l.06592.00488a7.99746,7.99746,0,0,1,8.59912-13.24219C78.21,186.74367,102.063,192,128,192s49.80664-5.26269,68.792-13.71924a7.997,7.997,0,0,1,8.58252,13.24854l.06592-.00488a160.72734,160.72734,0,0,1-31.33789,11.0664,7.99978,7.99978,0,1,0,3.79492,15.543c24.01514-5.8623,45.28809-15.9209,61.51856-29.08691.02441-.01953.04492-.042.06884-.062h.00049c.99121-.80615,1.96973-1.62109,2.92383-2.45068A16.09062,16.09062,0,0,0,247.29492,169.80862ZM96,156a12,12,0,1,1,12-12A12,12,0,0,1,96,156Zm64,0a12,12,0,1,1,12-12A12,12,0,0,1,160,156Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "96",
          cy: "144.00002",
          r: "12"
        }), React.createElement("circle", {
          cx: "160",
          cy: "144.00002",
          r: "12"
        }), React.createElement("path", {
          d: "M74.4017,80A175.32467,175.32467,0,0,1,128,72a175.32507,175.32507,0,0,1,53.59754,7.99971",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M181.59717,176.00041A175.32523,175.32523,0,0,1,128,184a175.32505,175.32505,0,0,1-53.59753-7.99971",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M155.04392,182.08789l12.02517,24.05047a7.96793,7.96793,0,0,0,8.99115,4.20919c24.53876-5.99927,45.69294-16.45908,61.10024-29.85086a8.05225,8.05225,0,0,0,2.47192-8.38971L205.65855,58.86074a8.02121,8.02121,0,0,0-4.62655-5.10908,175.85294,175.85294,0,0,0-29.66452-9.18289,8.01781,8.01781,0,0,0-9.31925,5.28642l-7.97318,23.91964",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M100.95624,182.08757l-12.02532,24.0508a7.96794,7.96794,0,0,1-8.99115,4.20918c-24.53866-5.99924-45.69277-16.459-61.10006-29.85069a8.05224,8.05224,0,0,1-2.47193-8.38972L50.34158,58.8607a8.0212,8.0212,0,0,1,4.62655-5.1091,175.85349,175.85349,0,0,1,29.66439-9.18283,8.0178,8.0178,0,0,1,9.31924,5.28642l7.97318,23.91964",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "96",
          cy: "144.00002",
          r: "12"
        }), React.createElement("circle", {
          cx: "160",
          cy: "144.00002",
          r: "12"
        }), React.createElement("path", {
          d: "M74.4017,80A175.32467,175.32467,0,0,1,128,72a175.32507,175.32507,0,0,1,53.59754,7.99971",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M181.59717,176.00041A175.32523,175.32523,0,0,1,128,184a175.32505,175.32505,0,0,1-53.59753-7.99971",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M155.04392,182.08789l12.02517,24.05047a7.96793,7.96793,0,0,0,8.99115,4.20919c24.53876-5.99927,45.69294-16.45908,61.10024-29.85086a8.05225,8.05225,0,0,0,2.47192-8.38971L205.65855,58.86074a8.02121,8.02121,0,0,0-4.62655-5.10908,175.85294,175.85294,0,0,0-29.66452-9.18289,8.01781,8.01781,0,0,0-9.31925,5.28642l-7.97318,23.91964",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M100.95624,182.08757l-12.02532,24.0508a7.96794,7.96794,0,0,1-8.99115,4.20918c-24.53866-5.99924-45.69277-16.459-61.10006-29.85069a8.05224,8.05224,0,0,1-2.47193-8.38972L50.34158,58.8607a8.0212,8.0212,0,0,1,4.62655-5.1091,175.85349,175.85349,0,0,1,29.66439-9.18283,8.0178,8.0178,0,0,1,9.31924,5.28642l7.97318,23.91964",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDivide = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,128a8.00008,8.00008,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8.00008,8.00008,0,0,1,224,128ZM128,80a16,16,0,1,0-16-16A16.01833,16.01833,0,0,0,128,80Zm0,96a16,16,0,1,0,16,16A16.01833,16.01833,0,0,0,128,176Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "64",
          r: "16"
        }), React.createElement("circle", {
          cx: "128",
          cy: "192",
          r: "16"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDog = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M104,140a12,12,0,1,1-12-12A12,12,0,0,1,104,140Zm60-12a12,12,0,1,0,12,12A12,12,0,0,0,164,128Zm68.72656,15.959a16.26177,16.26177,0,0,1-6.72363,1.47657A15.60358,15.60358,0,0,1,216,141.7915V184a40.04552,40.04552,0,0,1-40,40H80a40.04552,40.04552,0,0,1-40-40V141.7915a15.60358,15.60358,0,0,1-10.00293,3.644,16.254,16.254,0,0,1-6.72363-1.47657,15.76942,15.76942,0,0,1-9.12012-17.521l16.418-87.56592A16.00071,16.00071,0,0,1,50.17871,26.29834L104.98535,40h46.0293l54.80664-13.70166a15.99961,15.99961,0,0,1,19.60644,12.57227L241.84668,126.438A15.76942,15.76942,0,0,1,232.72656,143.959ZM200,184V122.04L148.11133,56H107.88867L56,122.04V184a24.0275,24.0275,0,0,0,24,24h40V195.314l-13.65723-13.65722a8.00018,8.00018,0,0,1,11.31446-11.31348L128,180.68652l10.34277-10.34326a8.00018,8.00018,0,0,1,11.31446,11.31348L136,195.314V208h40A24.0275,24.0275,0,0,0,200,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "140",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "140",
          r: "12"
        }), React.createElement("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,48l55.76169-13.94042a8,8,0,0,1,9.80326,6.28683l16.41859,87.56583c1.54221,8.22509-8.98332,12.99712-14.15352,6.41688Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M104,48,48.23831,34.05958A8,8,0,0,0,38.435,40.34641L22.01646,127.91224c-1.54221,8.22509,8.98332,12.99712,14.15352,6.41688Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "48",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208,119.27273V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.27273",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDoor = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,216H208V40a16.01833,16.01833,0,0,0-16-16H64A16.01833,16.01833,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-68-76a12,12,0,1,1,12-12A12,12,0,0,1,164,140Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "24",
          y1: "224",
          x2: "232",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "156",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDotsNine = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "60",
          cy: "60",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "60",
          r: "12"
        }), React.createElement("circle", {
          cx: "196",
          cy: "60",
          r: "12"
        }), React.createElement("circle", {
          cx: "60",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "196",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "60",
          cy: "196",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "196",
          r: "12"
        }), React.createElement("circle", {
          cx: "196",
          cy: "196",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDotsSix = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "60",
          cy: "92",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "92",
          r: "12"
        }), React.createElement("circle", {
          cx: "196",
          cy: "92",
          r: "12"
        }), React.createElement("circle", {
          cx: "60",
          cy: "164",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "164.0001",
          r: "12"
        }), React.createElement("circle", {
          cx: "196",
          cy: "164",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDotsSixVertical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "92",
          cy: "60",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "60",
          r: "12"
        }), React.createElement("circle", {
          cx: "92",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "92",
          cy: "196",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "196",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDotsThree = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "192",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "64",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDotsThreeCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24ZM80,140a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,80,140Zm48,0a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,128,140Zm48,0a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,176,140Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "176",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "80",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDotsThreeCircleVertical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,128A104,104,0,1,0,128,232,104.12041,104.12041,0,0,0,232,128ZM116,80a12,12,0,1,1,12,12A12.0006,12.0006,0,0,1,116,80Zm0,48a12,12,0,1,1,12,12A12.0006,12.0006,0,0,1,116,128Zm0,48a12,12,0,1,1,12,12A12.0006,12.0006,0,0,1,116,176Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "80",
          r: "12"
        }), React.createElement("circle", {
          cx: "128",
          cy: "176",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDotsThreeOutline = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M156,128a28,28,0,1,1-28-28A28.02769,28.02769,0,0,1,156,128ZM48,100a28,28,0,1,0,28,28A28.02769,28.02769,0,0,0,48,100Zm160,0a28,28,0,1,0,28,28A28.02769,28.02769,0,0,0,208,100Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "48",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "208",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDotsThreeOutlineVertical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M156,128a28,28,0,1,1-28-28A28.02769,28.02769,0,0,1,156,128ZM128,76a28,28,0,1,0-28-28A28.02769,28.02769,0,0,0,128,76Zm0,104a28,28,0,1,0,28,28A28.02769,28.02769,0,0,0,128,180Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDotsThreeVertical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "58",
          r: "20"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "20"
        }), React.createElement("circle", {
          cx: "128",
          cy: "198",
          r: "20"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDownload = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M122.34326,133.65723c.02588.02588.05469.04785.08106.07324.16211.15771.32861.31152.50341.45508.09766.08008.20118.15039.30176.22558.1084.08106.21485.165.32764.24073.11621.07812.2373.1455.35693.21679.10449.0625.20655.12793.31446.18555.12011.06445.24414.11914.36669.17676.11426.0542.22657.11084.34327.15967.11816.04882.23925.08837.35937.13134.126.04541.251.09375.37988.13282.11963.03613.24122.063.36231.09326.13184.0332.26269.07031.397.09716.13965.02735.28028.04395.42041.064.11817.01709.23389.03906.353.05078.26269.02588.52588.04.78955.04s.52686-.01416.78955-.04c.11914-.01172.23486-.03369.353-.05078.14013-.02.28076-.03662.42041-.064.13428-.02685.26513-.064.397-.09716.12109-.03028.24268-.05713.36231-.09326.1289-.03907.2539-.08741.37988-.13282.12012-.043.24121-.08252.35937-.13134.1167-.04883.229-.10547.34327-.15967.12255-.05762.24658-.11231.36669-.17676.10791-.05762.21-.12305.31446-.18555.11963-.07129.24072-.13867.35693-.21679.11279-.07569.21924-.15967.32764-.24073.10058-.07519.2041-.1455.30176-.22558.17822-.14649.34765-.30225.51269-.46338.023-.023.04883-.042.07178-.06494l48-48a8.00018,8.00018,0,1,0-11.31348-11.31446L136,108.68652V24a8,8,0,0,0-16,0v84.68652L85.65674,74.34277A8.00018,8.00018,0,0,0,74.34326,85.65723Z"
        }), React.createElement("path", {
          d: "M224,120H169.94141L144.9707,144.9707a24.00066,24.00066,0,0,1-33.9414,0L86.05859,120H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V136A16.01833,16.01833,0,0,0,224,120Zm-35.99951,60a12,12,0,1,1,12-12A12,12,0,0,1,188.00049,180Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "80 80 128 128 176 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188",
          cy: "168",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDownloadSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80.34375,115.668A8,8,0,0,1,86,102.01074h34V40a8,8,0,0,1,16,0v62.01074h34a8,8,0,0,1,5.65625,13.65723l-42,41.98926a7.99945,7.99945,0,0,1-11.3125,0ZM216,144a8.00039,8.00039,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V152A8.00039,8.00039,0,0,0,216,144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "86 110.011 128 152 170 110.011",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "151.97057",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDribbbleLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M86.26123,32.74414a103.85849,103.85849,0,0,1,100.148,9.25537,153.22442,153.22442,0,0,1-44.543,40.48438A169.26114,169.26114,0,0,0,86.26123,32.74414Zm41.31543,57.28955A152.978,152.978,0,0,0,69.4624,42.09863a104.382,104.382,0,0,0-41.543,57.561A151.8095,151.8095,0,0,0,64,103.99805,151.0488,151.0488,0,0,0,127.57666,90.03369Zm104.22119,31.65772a103.76547,103.76547,0,0,0-32.88965-69.689,169.34119,169.34119,0,0,1-48.39453,43.94092,167.29388,167.29388,0,0,1,13.542,29.89746,168.13983,168.13983,0,0,1,67.74219-4.14941Zm-63.33008,19.53125a167.82141,167.82141,0,0,1,4.44922,38.46972,168.65237,168.65237,0,0,1-6.084,44.77832,104.24218,104.24218,0,0,0,64.68213-86.65185,152.38875,152.38875,0,0,0-63.04737,3.40381Zm-19.64062-10.45459a151.39932,151.39932,0,0,0-12.3916-27.20557A166.974,166.974,0,0,1,64,119.99805a167.82812,167.82812,0,0,1-39.23633-4.6377,103.89032,103.89032,0,0,0,35.958,91.88281A168.9649,168.9649,0,0,1,148.82715,130.76807ZM73.78369,216.72021a103.93363,103.93363,0,0,0,74.58447,13.27051,152.66635,152.66635,0,0,0,8.54883-50.29834,151.825,151.825,0,0,0-3.73291-33.46289A152.89185,152.89185,0,0,0,73.78369,216.72021Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M71.0247,205.27116a159.91145,159.91145,0,0,1,136.98116-77.27311q8.09514,0,15.99054.78906",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M188.0294,53.09083A159.68573,159.68573,0,0,1,64.00586,111.99805a160.8502,160.8502,0,0,1-30.15138-2.83671",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M85.93041,41.68508a159.92755,159.92755,0,0,1,78.99267,138.00723,160.35189,160.35189,0,0,1-4.73107,38.77687",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDrop = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M174.03662,47.75049a254.574,254.574,0,0,0-41.44873-38.3042,7.99885,7.99885,0,0,0-9.17578,0,254.574,254.574,0,0,0-41.44873,38.3042C54.51074,79.3208,40,112.60352,40,144a88,88,0,0,0,176,0C216,112.60352,201.48926,79.3208,174.03662,47.75049Zm9.17578,105.646a55.85216,55.85216,0,0,1-45.76562,45.7085,8,8,0,1,1-2.6543-15.77832,39.8386,39.8386,0,0,0,32.64453-32.604,8.00019,8.00019,0,0,1,15.77539,2.67382Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M136.11987,191.216a47.923,47.923,0,0,0,39.20472-39.1564",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconDropHalf = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,224a80,80,0,0,0,80-80c0-72-80-128-80-128Z"
        }), React.createElement("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.99999",
          y1: "63.99999",
          x2: "208",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.99999",
          y1: "111.99999",
          x2: "198.26945",
          y2: "182.26945",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("g", null, React.createElement("line", {
          x1: "127.99999",
          y1: "159.99999",
          x2: "176.00281",
          y2: "208.00281",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.99999",
          y1: "159.99999",
          x2: "176.00281",
          y2: "208.00281",
          fill: "#231f20"
        })));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEar = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188,152a28,28,0,0,1-56,0c0-15.67969,9.31152-23.66113,16.79346-30.07422C155.95068,115.791,160,111.93457,160,104a32,32,0,0,0-64,0,8,8,0,0,1-16,0,48,48,0,0,1,96,0c0,15.67969-9.31152,23.66113-16.79346,30.07422C152.04932,140.209,148,144.06543,148,152a12,12,0,0,0,24,0,8,8,0,0,1,16,0ZM128,16a88.09957,88.09957,0,0,0-88,88c0,33.49512,12.45557,45.50488,22.46387,55.15527C70.32227,166.73242,76,172.207,76,188a52.00105,52.00105,0,0,0,92.10742,33.09863,8,8,0,1,0-12.33594-10.18945A36.001,36.001,0,0,1,92,188c0-22.5918-9.7915-32.0332-18.43018-40.36328C64.53418,138.9248,56,130.69629,56,104a72,72,0,0,1,144,0,8,8,0,0,0,16,0A88.09957,88.09957,0,0,0,128,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84a80,80,0,0,1,160,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEarSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.91943,210.61816a8.00024,8.00024,0,0,1-11.83886,10.76368L164.1604,179.66943A27.8785,27.8785,0,0,1,132,152a34.92369,34.92369,0,0,1,.68823-6.94971L95.9668,104.65674A7.99677,7.99677,0,0,1,80,104a47.77032,47.77032,0,0,1,2.22388-14.46045L64.5011,70.04443A71.47341,71.47341,0,0,0,56,104c0,26.69629,8.53418,34.9248,17.56982,43.63672C82.2085,155.9668,92,165.4082,92,188a36.001,36.001,0,0,0,63.77148,22.90918,8,8,0,1,1,12.33594,10.18945A52.00105,52.00105,0,0,1,76,188c0-15.793-5.67773-21.26758-13.53613-28.84473C52.45557,149.50488,40,137.49512,40,104a87.3043,87.3043,0,0,1,13.206-46.37988L42.08057,45.38184A8.00024,8.00024,0,1,1,53.91943,34.61816L69.2439,51.4751l.04455.04883L97.25708,82.28955l.02832.03125L172.736,165.31641l.01026.01123ZM91.08594,42.169A72.01834,72.01834,0,0,1,200,104a8,8,0,0,0,16,0A88.01954,88.01954,0,0,0,82.87012,28.43848,8.0004,8.0004,0,0,0,91.08594,42.169Zm67.186,83.23828a8.00079,8.00079,0,0,0,11.20069-1.59571A31.86061,31.86061,0,0,0,176,104a48.02849,48.02849,0,0,0-63.56982-45.416,7.99955,7.99955,0,1,0,5.1875,15.13477A32.03087,32.03087,0,0,1,160,104a15.97942,15.97942,0,0,1-3.32324,10.20605A8.00086,8.00086,0,0,0,158.272,125.40723Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M91.42886,87.7719A39.8604,39.8604,0,0,0,88,104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M86.97786,35.304A80.01863,80.01863,0,0,1,208,104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M161.93948,216.0039A44.00107,44.00107,0,0,1,84,188c0-41.49014-36-28-36-84A79.63961,79.63961,0,0,1,63.34376,56.87833",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M163.07477,119.00866A23.8953,23.8953,0,0,0,168,104a40.02881,40.02881,0,0,0-52.976-37.8483",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M166.89165,170.78091A20.01341,20.01341,0,0,1,140,152a24.94024,24.94024,0,0,1,1.58781-9.05283",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEject = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M35.61523,134.41724a15.79789,15.79789,0,0,1,2.90039-17.26978l77.72657-84.20532h.001a15.99956,15.99956,0,0,1,23.51368,0l77.72851,84.20532A16.0003,16.0003,0,0,1,205.72852,144H50.27148A15.79772,15.79772,0,0,1,35.61523,134.41724ZM208,160H48a16.01833,16.01833,0,0,0-16,16v24a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V176A16.01833,16.01833,0,0,0,208,160Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M122.12157,38.3683,44.39345,122.57376A8,8,0,0,0,50.27188,136H205.72812a8,8,0,0,0,5.87843-13.42624L133.87843,38.3683A8,8,0,0,0,122.12157,38.3683Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "108",
          y: "100",
          width: "40",
          height: "176",
          rx: "8",
          transform: "translate(-60 316) rotate(-90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEjectSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M26.36035,158.87646a15.86839,15.86839,0,0,1,2.0293-16.96582L115.582,34.59668a15.99968,15.99968,0,0,1,24.83594.00049l87.19238,107.313A16.00008,16.00008,0,0,1,215.19238,168H40.80762A15.87032,15.87032,0,0,1,26.36035,158.87646ZM224,200H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M121.79109,39.64174,34.59885,146.95526A8,8,0,0,0,40.80776,160H215.19224a8,8,0,0,0,6.20891-13.04474L134.20891,39.64174A8,8,0,0,0,121.79109,39.64174Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "208",
          x2: "32",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEnvelope = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.99023,55.80933q-.00511-.22192-.02246-.44312-.01391-.18054-.03564-.35864c-.01709-.13819-.03858-.27564-.063-.41309-.022-.124-.0459-.24707-.07324-.36889-.02979-.13038-.064-.25953-.1001-.38843-.03467-.12329-.07031-.24536-.11035-.366-.042-.126-.08887-.25-.13721-.374-.0459-.11865-.09326-.23609-.14453-.35156-.05469-.12207-.11377-.24195-.17432-.36158-.05761-.11352-.11669-.22583-.17919-.33618-.06543-.114-.13428-.22607-.20508-.33765-.07178-.11254-.14551-.2229-.22266-.33154-.07226-.10229-.148-.20263-.22558-.30224-.0879-.11206-.17872-.221-.272-.32813-.04394-.05054-.082-.10425-.12744-.154-.03857-.042-.08105-.07764-.1206-.11865-.0962-.10108-.19629-.198-.29786-.29395-.09423-.08887-.189-.177-.28662-.26074-.09619-.082-.19531-.15967-.29541-.23731-.10937-.085-.21826-.16919-.33105-.24755-.09766-.06812-.19873-.13135-.29932-.19507-.11914-.0752-.23779-.15015-.35986-.21851-.10645-.05957-.21582-.11352-.32471-.16821-.1206-.0603-.24023-.1211-.36328-.175-.11963-.05274-.24219-.09863-.36475-.14551-.11767-.04492-.23486-.09057-.354-.12964-.12939-.04272-.26172-.07837-.39355-.1145-.11866-.03223-.23633-.0647-.35547-.09131-.13184-.02954-.26563-.05273-.39991-.07568-.12646-.02149-.25293-.04248-.38037-.05786-.12646-.01538-.2539-.02564-.38232-.03491-.13965-.01026-.2793-.01832-.41943-.02125C224.1123,48.00732,224.05713,48,224,48H32c-.05371,0-.10547.00708-.15918.00806-.14746.00293-.29492.01123-.44189.02221-.12159.00928-.24219.0188-.36182.03321-.13428.01611-.26758.03808-.40137.06128-.12744.022-.25488.0437-.37988.07177-.126.02808-.25.06226-.375.09644-.126.03467-.25195.0686-.37549.10913-.125.041-.248.08862-.37158.136-.1167.04492-.23389.08886-.34815.13891-.12744.05591-.252.1189-.377.18189-.105.05273-.21.10424-.312.16137-.125.07007-.24707.147-.36914.22437-.09766.062-.19629.12353-.291.1897-.11474.07959-.22558.165-.33642.25146-.09864.07642-.19629.15308-.291.23413-.09863.08423-.19385.17285-.28955.26294-.10107.09522-.20019.1919-.29639.29224-.03906.04126-.082.07715-.1206.11914-.04541.0498-.0835.10351-.12744.154-.09326.10718-.18408.21607-.272.32813-.07763.09961-.15332.2-.22558.30224-.07715.10864-.15088.219-.22266.33154-.0708.11158-.13965.22364-.20508.33765-.0625.11035-.12158.22266-.17919.33618-.06055.11963-.11963.23951-.17432.36158-.05127.11547-.09863.23291-.14453.35156-.04834.124-.09522.248-.13721.374-.04.12061-.07568.24268-.11035.366-.03613.1289-.07031.25805-.1001.38843-.02734.12182-.05127.24487-.07324.36889-.02441.13745-.0459.2749-.063.41309q-.022.17834-.03564.35864-.01758.22156-.02246.44312C24.0083,55.87329,24,55.93555,24,56V192a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56C232,55.93555,231.9917,55.87329,231.99023,55.80933ZM40,74.18628l58.70605,53.814L40,181.814ZM52.56738,192l57.97852-53.14673,12.04785,11.04395a8.00113,8.00113,0,0,0,10.8125,0L145.45459,138.853,203.43311,192ZM157.294,128l58.70751-53.81519.00782,107.63672Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "110.54541",
          y1: "128.00013",
          x2: "34.4668",
          y2: "197.73926",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "221.53418",
          y1: "197.73926",
          x2: "145.45424",
          y2: "127.99964",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEnvelopeOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.99512,95.92334a7.926,7.926,0,0,0-.22608-1.8147c-.0166-.06909-.03759-.13672-.05615-.20532q-.09154-.33618-.2124-.666c-.03028-.08129-.061-.16186-.09326-.24218-.0835-.20459-.17725-.40625-.27832-.606-.03955-.07764-.07618-.15625-.11768-.23267-.11914-.21679-.25146-.429-.39307-.63745-.03125-.04614-.05761-.09521-.08984-.14062l-.01465-.023a8.19273,8.19273,0,0,0-.55469-.6897c-.04345-.04834-.0913-.09228-.13574-.13965-.16845-.17944-.34228-.35083-.52344-.51172-.061-.05371-.124-.10473-.18652-.15673q-.27686-.23071-.56933-.43311c-.03711-.02563-.06934-.05591-.10645-.08081l-96-64a8.00131,8.00131,0,0,0-8.875,0l-96,64c-.03613.02393-.06689.05322-.102.07764q-.29736.20508-.57666.43847c-.061.05078-.12256.10035-.18164.15284-.18311.16235-.35889.3352-.52832.5166-.04346.0459-.08985.08886-.13233.13574a8.114,8.114,0,0,0-.55517.69043l-.01465.023c-.03223.04541-.05859.09448-.08984.14062-.14161.2085-.27393.42066-.39307.63745-.0415.07642-.07813.155-.11768.23267-.10107.19971-.19482.40137-.27832.606-.03222.08032-.063.16089-.09326.24218q-.12157.33-.2124.666c-.01856.0686-.03955.13623-.05615.20532a7.926,7.926,0,0,0-.22608,1.8147C24.00439,95.94922,24,95.97412,24,96V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V96C232,95.97412,231.99561,95.94922,231.99512,95.92334ZM40,111.52881l56.72266,40.44092L40,192.03662ZM113.08594,160h29.82812L199.543,200H56.45752Zm46.1914-8.03027L216,111.52881v80.50732Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "110.54541",
          y1: "152.00008",
          x2: "34.4668",
          y2: "205.73921",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "221.53418",
          y1: "205.73921",
          x2: "145.45424",
          y2: "151.99959",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "224 96 145.455 152 110.545 152 32 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEnvelopeSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.99121,55.80933q-.00513-.22192-.02246-.44312-.01392-.18054-.03564-.35864c-.01709-.13819-.03858-.27564-.063-.41284-.022-.12427-.0459-.24756-.07325-.36963-.02978-.12989-.064-.25855-.0996-.38721-.03467-.12353-.07081-.24634-.11133-.36743-.04151-.12549-.08789-.24927-.13623-.3728-.04639-.1189-.09375-.23682-.14551-.35279-.0542-.12133-.11279-.24072-.17334-.35986-.05811-.11426-.11719-.2273-.18066-.33814-.06446-.11328-.13282-.2246-.20362-.33544-.07178-.11329-.146-.22461-.22363-.334-.07227-.10156-.147-.20117-.22461-.30029-.08838-.11255-.1792-.22193-.273-.32959-.04394-.05029-.08154-.10376-.12695-.15332-.03858-.042-.08106-.07764-.12012-.11841-.09668-.10107-.19678-.19849-.29834-.29443-.09424-.08887-.189-.17676-.28662-.26026-.09619-.08227-.19531-.15991-.29541-.23755-.10938-.085-.21826-.16919-.33106-.24755-.09765-.06812-.19873-.13135-.29931-.19507-.11914-.0752-.23779-.15015-.35938-.21851-.10693-.05981-.21679-.11377-.32666-.16894-.11963-.05982-.23877-.12012-.36084-.17383-.12109-.05347-.2456-.1001-.37011-.14771-.11475-.0437-.2295-.08838-.3462-.12671-.1333-.04394-.269-.08081-.40527-.11767-.11426-.031-.228-.0625-.34326-.08838-.13574-.03027-.27344-.0542-.41162-.07764-.12256-.02075-.24414-.041-.36719-.05615-.13135-.01611-.26318-.02661-.396-.03613-.13476-.00977-.26953-.01758-.40429-.02051-.05908-.00122-.1167-.00879-.17578-.00879h-192c-.05469,0-.10743.00708-.16211.0083-.14551.00293-.29.011-.43506.022-.12354.009-.2461.0188-.36768.03345-.13281.01611-.26465.03784-.39648.06055-.12891.02221-.25781.04443-.38477.07251-.124.02783-.24609.06152-.36914.09521-.12793.03491-.25586.06958-.38135.11084-.124.04053-.24511.08765-.36718.13428-.11768.04541-.23584.0896-.35108.14014-.127.05566-.25146.11865-.37646.18139-.105.05274-.21.10449-.312.16187-.12549.07007-.24756.147-.36963.22436-.09766.06177-.1958.123-.29053.18921-.11475.07984-.22607.16553-.33691.2522-.09864.07642-.19629.15283-.29053.23364-.09863.08423-.19385.17285-.28906.2627-.10157.09546-.20069.19238-.29737.293-.03906.041-.08154.07666-.12011.11865-.04541.04956-.083.103-.127.15332-.09375.10766-.18457.217-.27295.32959-.07763.09912-.15234.19873-.22461.30029-.07763.10938-.15185.2207-.22363.334-.0708.11084-.13916.22216-.20361.33544-.06348.11084-.12256.22388-.18067.33814-.06054.11914-.11914.23853-.17334.35986-.05175.116-.09912.23389-.1455.35279-.04834.12353-.09473.24731-.13623.3728-.04053.12109-.07666.2439-.11133.36743-.03565.12866-.06983.25732-.09961.38721-.02735.12207-.05127.24536-.07324.36963-.02442.1372-.0459.27465-.063.41284q-.022.17834-.03565.35864-.01758.22156-.02246.44312c-.00146.064-.00976.12622-.00976.19067V192a16.01833,16.01833,0,0,0,16,16h176a16.01833,16.01833,0,0,0,16-16V56C232.001,55.93555,231.99268,55.87329,231.99121,55.80933ZM216.001,192h-176V74.18652l82.59375,75.71094a8.0018,8.0018,0,0,0,10.8125,0l82.59521-75.7124.0083,117.81445Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEnvelopeSimpleOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.99512,95.92334a7.928,7.928,0,0,0-.22608-1.81494c-.0166-.06885-.03759-.13672-.05615-.20508q-.09154-.33618-.2124-.666c-.03028-.08154-.061-.16162-.09326-.24218-.0835-.20459-.17725-.40625-.27832-.606-.03955-.07764-.07618-.15625-.11768-.23242-.11914-.21729-.25146-.4292-.39307-.6377-.03125-.04638-.05761-.09521-.08984-.14062l-.01465-.023a8.1872,8.1872,0,0,0-.55469-.68945c-.04345-.04883-.0913-.09278-.13574-.13965-.16845-.17969-.34228-.35108-.52344-.51172-.061-.0542-.124-.105-.18652-.15723q-.27686-.23-.56933-.4331c-.03711-.02539-.06934-.05567-.10645-.08057l-96-64a8.00131,8.00131,0,0,0-8.875,0l-96,64c-.03613.02393-.06689.05322-.102.07764q-.29736.20508-.57666.43847c-.061.05078-.12256.10059-.18164.15284-.18311.1621-.35889.335-.52832.5166-.04346.0459-.08985.08886-.13233.13574a8.114,8.114,0,0,0-.55517.69043l-.01465.023c-.03223.04541-.05859.09424-.08984.14062-.14161.2085-.27393.42041-.39307.6377-.0415.07617-.07813.15478-.11768.23242-.10107.19971-.19482.40137-.27832.606-.03222.08056-.063.16064-.09326.24218q-.12157.33033-.2124.666c-.01856.06836-.03955.13623-.05615.20508a7.928,7.928,0,0,0-.22608,1.81494C24.00439,95.94922,24,95.97412,24,96V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V96C232,95.97412,231.99561,95.94922,231.99512,95.92334ZM40,200V111.52881l65.90137,46.98486A8.00118,8.00118,0,0,0,110.5459,160h34.9082a8.00118,8.00118,0,0,0,4.64453-1.48633L216,111.52881V200Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "224 96 145.455 152 110.545 152 32 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEquals = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M216,152H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M40,104H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEraser = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.001,207.833H130.34375l34.72949-34.72949.0166-.01465.01465-.0166,56.55371-56.55274a24.02962,24.02962,0,0,0,0-33.94141L176.40332,37.32324a24.0007,24.0007,0,0,0-33.94141,0L85.90283,93.88232l-.01025.00928-.00928.01026L29.32422,150.46094a24.00066,24.00066,0,0,0,0,33.9414l37.08887,37.08789a8.00232,8.00232,0,0,0,5.65722,2.34278H216.001a8,8,0,0,0,0-16ZM153.77637,48.6377a7.99708,7.99708,0,0,1,11.3125,0l45.25488,45.25488a8.00888,8.00888,0,0,1,0,11.31347l-50.91113,50.91114L102.86475,99.54932Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "91.55018",
          y1: "99.54921",
          x2: "159.43243",
          y2: "167.43146",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216.00049,215.83348H72.07L34.98164,178.74517a16,16,0,0,1,0-22.62742L148.11873,42.98066a16,16,0,0,1,22.62741,0L216.001,88.2355a16,16,0,0,1,0,22.62742L111.03042,215.83347",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconExport = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,88H120V35.3103L91.65625,63.64648A7.99983,7.99983,0,1,1,80.34375,52.332l42-41.98926a8.00063,8.00063,0,0,1,11.3125,0l42,41.98926a7.99983,7.99983,0,1,1-11.3125,11.31445L136,35.3103Zm64,0H136v40a8,8,0,0,1-16,0V88H56a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V104A16.01833,16.01833,0,0,0,200,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "86 57.989 128 16 170 57.989",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "16.02943",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEye = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M247.31055,124.75061c-.35157-.79-8.81934-19.57617-27.65332-38.41113C194.57324,61.25256,162.87793,47.99182,128,47.99182S61.42676,61.25256,36.34277,86.33948c-18.834,18.835-27.30175,37.62109-27.65332,38.41113a8.00282,8.00282,0,0,0,0,6.49805c.35157.791,8.82032,19.57226,27.6543,38.40429C61.42773,194.734,93.12207,207.99182,128,207.99182S194.57227,194.734,219.65625,169.653c18.834-18.832,27.30273-37.61328,27.6543-38.40429A8.00282,8.00282,0,0,0,247.31055,124.75061ZM128,92.00061a36,36,0,1,1-36,36A36.04061,36.04061,0,0,1,128,92.00061Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128.00061",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEyeClosed = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M211.50122,129.23535a147.78919,147.78919,0,0,0,18.72144-19.333,7.99973,7.99973,0,0,0-12.44532-10.05468,128.72532,128.72532,0,0,1-21.28466,20.9541c-.05372.03808-.103.08008-.15528.11963A109.58952,109.58952,0,0,1,128,144a109.59068,109.59068,0,0,1-68.35156-23.08887c-.061-.04638-.11841-.0957-.18115-.14062A128.70627,128.70627,0,0,1,38.22168,99.84766a7.99972,7.99972,0,1,0-12.44531,10.05468,147.761,147.761,0,0,0,18.68188,19.29834l-19.49731,33.77a7.99959,7.99959,0,1,0,13.85547,8l18.49-32.02539a123.57956,123.57956,0,0,0,35.24438,16.28174l-5.81445,32.978a8.00124,8.00124,0,0,0,6.49023,9.26758,8.12,8.12,0,0,0,1.39844.12207,8.00272,8.00272,0,0,0,7.86914-6.61231l5.71729-32.42724a136.26072,136.26072,0,0,0,39.4873.01367l5.71826,32.42724a8.00278,8.00278,0,0,0,7.86914,6.61133,8.13106,8.13106,0,0,0,1.39942-.12207,8.00173,8.00173,0,0,0,6.48925-9.26855l-5.813-32.96436a123.56028,123.56028,0,0,0,35.28808-16.27832l18.38233,31.83838a7.99959,7.99959,0,0,0,13.85547-8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "201.14971",
          y1: "127.30467",
          x2: "223.95961",
          y2: "166.81257",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "154.18201",
          y1: "149.26298",
          x2: "161.29573",
          y2: "189.60689",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "101.72972",
          y1: "149.24366",
          x2: "94.61483",
          y2: "189.59423",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "54.80859",
          y1: "127.27241",
          x2: "31.88882",
          y2: "166.97062",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M31.99943,104.87509C48.81193,125.68556,79.63353,152,128,152c48.36629,0,79.18784-26.31424,96.00039-47.12468",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEyeSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M247.31055,124.75842c-.35157-.79-8.81934-19.57519-27.65332-38.41113C194.57324,61.26038,162.87793,47.99963,128,47.99963a133.97063,133.97063,0,0,0-21.99512,1.793,8.00028,8.00028,0,0,0-4.60254,13.27246L202.69336,174.485a8.00126,8.00126,0,0,0,11.25781.57715c22.8125-20.43359,32.93946-42.86035,33.35938-43.80566A8.00282,8.00282,0,0,0,247.31055,124.75842Z"
        }), React.createElement("path", {
          d: "M53.91992,34.6178A8.0006,8.0006,0,1,0,42.08008,45.38147l19.24121,21.165c-36.321,22.291-51.93628,56.648-52.63184,58.21191a8.00282,8.00282,0,0,0,0,6.49805c.35157.791,8.82032,19.57226,27.6543,38.4043,25.084,25.081,56.77832,38.33886,91.65625,38.33886a126.97091,126.97091,0,0,0,52.06567-10.834l22.01441,24.21582a8.0006,8.0006,0,0,0,11.83984-10.76367ZM128,164.00012a35.98594,35.98594,0,0,1-29.52319-56.582l47.20459,51.9248A35.78086,35.78086,0,0,1,128,164.00012Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "40.00122",
          x2: "208",
          y2: "216.00122",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M154.9071,157.599a40.00028,40.00028,0,0,1-53.8142-59.19562",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M73.99446,68.59479C33.22519,89.24034,16,128.00122,16,128.00122s32,71.99219,112,71.99219a118.0238,118.0238,0,0,0,53.99756-12.59461",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208.60953,169.10059C230.41132,149.57342,240,128.00122,240,128.00122S208,55.99341,128,55.99341a125.31923,125.31923,0,0,0-20.68221,1.68414",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M135.52737,88.709a40.02411,40.02411,0,0,1,32.29785,35.52874",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconEyedropper = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.99658,67.50391a35.73557,35.73557,0,0,0-11.26172-25.66114c-14.01806-13.2705-36.71875-12.771-50.60254,1.11328L140.18408,64.90479a24.02939,24.02939,0,0,0-33.15429.75195L100,72.68652a16.01779,16.01779,0,0,0,0,22.627l2.05908,2.05908L51.71533,147.71582a40.15638,40.15638,0,0,0-11.01074,35.771l-9.78271,22.40869a13.66329,13.66329,0,0,0,2.87744,15.21728,15.915,15.915,0,0,0,11.27929,4.70313,16.077,16.077,0,0,0,6.43555-1.353l20.999-9.16748a40.15391,40.15391,0,0,0,35.771-11.01123l50.34326-50.34326L160.68652,156a16.01779,16.01779,0,0,0,22.627,0l7.02978-7.02979a24.02843,24.02843,0,0,0,.752-33.15429l22.36036-22.36035A35.71726,35.71726,0,0,0,223.99658,67.50391ZM96.9707,192.9707a24.09567,24.09567,0,0,1-23.1914,6.21436,8.0052,8.0052,0,0,0-5.26416.39746L47.044,208.95605l9.37353-21.47119a8.00234,8.00234,0,0,0,.39746-5.26416,24.0986,24.0986,0,0,1,6.21436-23.1914L113.37256,108.686l33.9414,33.9414Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M179.799,115.799l4.88728,4.88728a16,16,0,0,1,0,22.62742l-7.02944,7.02944a8,8,0,0,1-11.3137,0l-60.6863-60.6863a8,8,0,0,1,0-11.3137l7.02944-7.02944a16,16,0,0,1,22.62742,0l4.8873,4.8873,27.58813-27.58813c10.78822-10.78822,28.36591-11.4491,39.44579-.96065A28.00039,28.00039,0,0,1,207.799,87.799Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M158.62742,142.62742l-56,56a31.98729,31.98729,0,0,1-30.91154,8.28721L48.31361,217.131A8,8,0,0,1,39.456,215.456h0a5.74381,5.74381,0,0,1-1.20256-6.35955l10.832-24.81212a31.9873,31.9873,0,0,1,8.28715-30.91177l56-56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFaceMask = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,72h-1.03125a16.03948,16.03948,0,0,0-9.501-9.43311l-80-29.0913a16.02485,16.02485,0,0,0-10.93554,0l-80,29.09082A16.04022,16.04022,0,0,0,33.03125,72H32A32.03635,32.03635,0,0,0,0,104v24a32.03635,32.03635,0,0,0,32,32h5.19678c6.561,14.38086,19.25537,26.99854,37.63183,37.20752,21.02246,11.67871,43.52491,16.96045,49.91944,18.30029a15.72388,15.72388,0,0,0,6.50293,0c6.3955-1.33984,28.898-6.62158,49.92041-18.30029,18.37646-10.209,31.0708-22.82666,37.63183-37.20752H224a32.03635,32.03635,0,0,0,32-32V104A32.03635,32.03635,0,0,0,224,72ZM32,144a16.01833,16.01833,0,0,1-16-16V104A16.01833,16.01833,0,0,1,32,88v48a58.66962,58.66962,0,0,0,.55273,8Zm136,8H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm72,8a16.01833,16.01833,0,0,1-16,16h-.55273A58.66962,58.66962,0,0,0,224,136V88a16.01833,16.01833,0,0,1,16,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,136c0,51.50493-74.43964,69.17367-86.39,71.67832a7.80809,7.80809,0,0,1-3.21992,0C114.43964,205.17367,40,187.50493,40,136V77.60342a8,8,0,0,1,5.26606-7.51835l80-29.09091a8,8,0,0,1,5.46788,0l80,29.09091A8,8,0,0,1,216,77.60342Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "144",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M213.40982,152H224a24,24,0,0,0,24-24V104a24,24,0,0,0-24-24h-8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M42.59121,152H32A24,24,0,0,1,8,128V104A24,24,0,0,1,32,80h8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFacebookLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24a104.0018,104.0018,0,0,0-8,207.69531V152.00094H96a8,8,0,0,1,0-16h24v-24a32.03667,32.03667,0,0,1,32-32h16a8,8,0,0,1,0,16H152a16.01833,16.01833,0,0,0-16,16v24h24a8,8,0,0,1,0,16H136v79.69434A104.0018,104.0018,0,0,0,128,24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,88.00094H152a24,24,0,0,0-24,24v112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "144.00094",
          x2: "160",
          y2: "144.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFactory = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,207.9834H224V136c0-.04785-.00635-.09375-.00708-.14111-.00269-.14307-.01147-.28662-.02173-.43116-.00976-.13769-.021-.2749-.0376-.41064-.00634-.0498-.00659-.09863-.01367-.14844L208.90137,29.73633A16.08054,16.08054,0,0,0,193.06152,16h-18.123a16.08053,16.08053,0,0,0-15.83985,13.7373l-11.55908,80.91749L108.7998,81.6001A7.99978,7.99978,0,0,0,96,88v32L44.7998,81.6001A7.99978,7.99978,0,0,0,32,88V207.9834H16a8,8,0,0,0,0,16H39.6665c.11158.00439.221.0166.3335.0166s.22192-.01221.3335-.0166h175.333c.11158.00439.22095.0166.3335.0166s.22192-.01221.3335-.0166H240a8,8,0,0,0,0-16ZM100,184H72a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Zm84,0H156a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Zm-13.333-56-8.52832-6.39648L174.93848,32h18.123l13.71411,96Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "80",
          y1: "176",
          x2: "108",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "148",
          y1: "176",
          x2: "176",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "215.98316",
          x2: "240",
          y2: "215.98316",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216,136,200.98123,30.86863A8,8,0,0,0,193.06164,24H174.93836a8,8,0,0,0-7.91959,6.86863l-13.47038,94.29266",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFaders = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128.00098",
          y1: "120",
          x2: "128.0011",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128.0011",
          y1: "40",
          x2: "128.00098",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200.00098",
          y1: "200",
          x2: "200.00181",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200.00181",
          y1: "40",
          x2: "200.00098",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224.00098",
          y1: "168",
          x2: "176.00098",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56.00098",
          y1: "168",
          x2: "56.00039",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56.00039",
          y1: "40",
          x2: "56.00098",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32.00098",
          y1: "136",
          x2: "80.00098",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152.00098",
          y1: "88",
          x2: "104.00098",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFadersHorizontal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "135.99902",
          y1: "171.99304",
          x2: "39.99902",
          y2: "171.99317",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "215.99902",
          y1: "171.99317",
          x2: "167.99902",
          y2: "171.99304",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "71.99902",
          y1: "83.99304",
          x2: "39.99902",
          y2: "83.99246",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "215.99902",
          y1: "83.99246",
          x2: "103.99902",
          y2: "83.99304",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "103.99902",
          y1: "59.99304",
          x2: "103.99902",
          y2: "107.99304",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "167.99902",
          y1: "195.99304",
          x2: "167.99902",
          y2: "147.99304",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFastForward = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M253.20605,128a15.9352,15.9352,0,0,1-7.34765,13.459l-89.20606,57.34668A16.00057,16.00057,0,0,1,132,185.34668V142.65381L44.65234,198.80566A16.00057,16.00057,0,0,1,20,185.34668V70.65332a16.00057,16.00057,0,0,1,24.65234-13.459L132,113.34619V70.65332a16.00057,16.00057,0,0,1,24.65234-13.459L245.8584,114.541A15.9352,15.9352,0,0,1,253.20605,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M241.532,121.27057,152.32606,63.9239A8,8,0,0,0,140,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L241.532,134.72943A8,8,0,0,0,241.532,121.27057Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M129.532,121.27057,40.32606,63.9239A8,8,0,0,0,28,70.65332V185.34668a8,8,0,0,0,12.32606,6.72942L129.532,134.72943A8,8,0,0,0,129.532,121.27057Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFastForwardCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm56.58789,110.55371-40,28A8.00015,8.00015,0,0,1,132,156V128a7.99968,7.99968,0,0,1-3.41211,6.55371l-40,28A8.00015,8.00015,0,0,1,76,156V100a8.00015,8.00015,0,0,1,12.58789-6.55371l40,28A7.99968,7.99968,0,0,1,132,128V100a8.00015,8.00015,0,0,1,12.58789-6.55371l40,28a8,8,0,0,1,0,13.10742Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "80 160 128 128 80 96 80 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "144 160 192 128 144 96 144 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFigmaLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M186.61523,94.00049A41.97934,41.97934,0,0,0,162,18.001H94A41.97934,41.97934,0,0,0,69.38477,94.00049a41.93894,41.93894,0,0,0,.00048,67.99939A41.9892,41.9892,0,1,0,136,195.99951V160.948a41.97356,41.97356,0,1,0,50.61523-66.94751ZM188,60.001a26.02916,26.02916,0,0,1-25.98047,25.99951L162,86l-.03857.001L136,86V34.001h26A26.02947,26.02947,0,0,1,188,60.001ZM162,154a25.99952,25.99952,0,0,1-.03857-51.999H162l.019-.00049A25.99976,25.99976,0,0,1,162,154Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "162",
          cy: "128",
          r: "34",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,94V26.00089H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,161.99911V94H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,94V26.00089h34a34,34,0,0,1,0,68Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,161.99911v34.00044A34,34,0,1,1,94,162Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFile = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM152,88V43.31348L196.68555,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200.00039,224H55.99961A7.99981,7.99981,0,0,1,48,216V40a7.99981,7.99981,0,0,1,7.99961-8l96.00312,0L208,88V216A7.99981,7.99981,0,0,1,200.00039,224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 32 152 88 208.008 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFileArrowDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 32 152 88 208.008 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "100 156 128 184 156 156",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFileArrowUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,71.38184a8,8,0,0,1-11.31348,0L136,139.31348V184a8,8,0,0,1-16,0V139.31348l-14.34326,14.34326a8,8,0,0,1-11.31348-11.314l28-28c.02588-.02606.05469-.04767.08106-.0733.16211-.15784.32861-.31128.50341-.455.09766-.08032.20118-.15039.30176-.22534.1084-.08111.21485-.1654.32764-.241.11621-.07794.2373-.1455.35693-.21667.10449-.06244.20655-.12817.31446-.18585.12011-.06439.24414-.119.36669-.17676.11426-.05389.22657-.1109.34327-.15942.11816-.049.23925-.08838.35937-.13135.126-.04541.251-.09387.37988-.133.11963-.03613.24122-.06262.36231-.09308.13184-.03338.26269-.07037.397-.097.13965-.02765.28028-.044.42041-.06415.11817-.01691.23389-.03925.353-.051C127.47314,112.014,127.73633,112,128,112s.52686.014.78955.03986c.11914.01171.23486.034.353.051.14013.02014.28076.0365.42041.06415.13428.02667.26513.06366.397.097.12109.03046.24268.057.36231.09308.1289.03913.2539.08759.37988.133.12012.043.24121.0824.35937.13135.1167.04852.229.10553.34327.15942.12255.0578.24658.11237.36669.17676.10791.05768.21.12341.31446.18585.11963.07117.24072.13873.35693.21667.11279.07557.21924.15986.32764.241.10058.075.2041.145.30176.22534.17822.1463.34765.30237.51269.46326.023.02283.04883.04193.07178.06506l28,28A7.99974,7.99974,0,0,1,161.65674,153.65674ZM152,88V43.31348L196.68555,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 32 152 88 208.008 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "100 148 128 120 156 148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFileDotted = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,224a8.00039,8.00039,0,0,1-8,8H55.99219a16.01833,16.01833,0,0,1-16-16V184a8,8,0,0,1,16,0v32H72A8.00039,8.00039,0,0,1,80,224ZM80,24H55.99219a16.01833,16.01833,0,0,0-16,16V64a8,8,0,0,0,16,0V40H80a8,8,0,0,0,0-16ZM216.00781,88a7.9698,7.9698,0,0,0-2.4248-5.731L157.65723,26.34277c-.0542-.05407-.11426-.10089-.16944-.15326-.1333-.126-.26611-.25268-.4082-.36932-.06738-.05566-.14014-.10364-.20947-.15686-.13819-.1062-.27539-.21356-.41992-.31079-.05811-.03882-.11963-.07129-.17872-.10858-.1621-.10279-.3247-.20478-.49462-.2959-.04248-.02271-.08692-.04059-.12989-.0625-.18945-.09747-.38135-.19141-.57959-.2738-.02832-.01191-.05859-.02045-.0874-.03205-.2124-.08539-.42725-.16492-.64844-.23218-.02978-.00909-.06054-.01452-.09033-.02325-.21875-.06384-.43994-.12225-.666-.16742-.07032-.0141-.14209-.0202-.21241-.03241-.18652-.032-.373-.06518-.564-.08411A7.98793,7.98793,0,0,0,152,24H120a8,8,0,0,0,0,16h24V88a8.00039,8.00039,0,0,0,8,8h48v40a8,8,0,0,0,16,0V88.15942C216.001,88.106,216.00781,88.05383,216.00781,88ZM208,168a8.00039,8.00039,0,0,0-8,8v40h-8a8,8,0,0,0,0,16h8a16.01833,16.01833,0,0,0,16-16V176A8.00039,8.00039,0,0,0,208,168ZM48,152a8.00039,8.00039,0,0,0,8-8V104a8,8,0,0,0-16,0v40A8.00039,8.00039,0,0,0,48,152Zm104,64H112a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M72,224.00005H55.99219a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "120 32 152 32 208 88 208 136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M47.99219,64V40a8,8,0,0,1,8-8L80,32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 32 152 88 208.008 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208,176v40a8,8,0,0,1-8,8h-8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "104",
          x2: "48",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "224",
          x2: "152",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFileMinus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM152,160H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-72V43.31348L196.68555,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 32 152 88 208.008 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFilePdf = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.58936,90.2749,157.65723,34.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,32H55.99219a16.00008,16.00008,0,0,0-16,16v88a7.99989,7.99989,0,0,0,8,8H208a7.99989,7.99989,0,0,0,8-8V96.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,90.2749ZM152,96V51.31348L196.68555,96ZM64,160H48a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32H56V176h8a8,8,0,0,1,0,16Zm60-32H112a8.00039,8.00039,0,0,0-8,8v48a8.00039,8.00039,0,0,0,8,8h12a32,32,0,0,0,0-64Zm0,48h-4V176h4a16,16,0,0,1,0,32Zm92-40a8.00039,8.00039,0,0,1-8,8H188v12h16a8,8,0,0,1,0,16H188v12a8,8,0,0,1-16,0V168a8.00039,8.00039,0,0,1,8-8h28A8.00039,8.00039,0,0,1,216,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M47.99219,136V48a8,8,0,0,1,8-8L152,40l56,56v40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 40 152 96 208.008 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M124,216a24,24,0,0,0,0-48H112v48Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 168 180 168 180 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "204",
          y1: "196",
          x2: "180",
          y2: "196",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFilePlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM152,160H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Zm0-72V43.31348L196.68555,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 32 152 88 208.008 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFileSearch = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM165.44971,189.45605a8.00061,8.00061,0,0,1-11.31348,0l-10.98511-10.9851a35.95132,35.95132,0,1,1,11.32093-11.307l10.97766,10.97766A8.00032,8.00032,0,0,1,165.44971,189.45605ZM152,88V43.31348L196.68555,88Z"
        }), React.createElement("path", {
          d: "M123.99414,128.00977a19.98432,19.98432,0,1,0,14.14209,5.84863A19.93593,19.93593,0,0,0,123.99414,128.00977Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 32 152 88 208.008 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "143.79313",
          y1: "167.79899",
          x2: "159.79313",
          y2: "183.79899",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "123.99414",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFileText = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749ZM160,176H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm-8-56V43.31348L196.68555,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200.00039,224H55.99961A7.99981,7.99981,0,0,1,48,216V40a7.99981,7.99981,0,0,1,7.99961-8l96.00312,0L208,88V216A7.99981,7.99981,0,0,1,200.00039,224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 32 152 88 208.008 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "136",
          x2: "160",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "168",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFileX = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-55.96192,88.06836A7.99984,7.99984,0,1,1,146.314,181.65674L127.9707,163.31348l-18.34326,18.34326A7.99984,7.99984,0,1,1,98.314,170.34326L116.65723,152,98.314,133.65674a7.99984,7.99984,0,1,1,11.31348-11.31348l18.34326,18.34326L146.314,122.34326a7.99984,7.99984,0,1,1,11.31348,11.31348L139.28418,152ZM152,88V43.31348L196.68555,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 32 152 88 208.008 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFiles = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.65723,66.34326l-40-40A8.00076,8.00076,0,0,0,168,24H88A16.01833,16.01833,0,0,0,72,40V56H56A16.01833,16.01833,0,0,0,40,72V216a16.01833,16.01833,0,0,0,16,16H168a16.01833,16.01833,0,0,0,16-16V200h16a16.01833,16.01833,0,0,0,16-16V72A8.00035,8.00035,0,0,0,213.65723,66.34326ZM136,192H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm64,24H184V104a8.00035,8.00035,0,0,0-2.34277-5.65674l-40-40A8.00076,8.00076,0,0,0,136,56H88V40h76.68652L200,75.314Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8l80,0,40,40V216A8,8,0,0,1,168,224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,64V40a8,8,0,0,1,8-8l80,0,40,40V184a8,8,0,0,1-8,8H176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "152",
          x2: "136",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "184",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFilmStrip = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,64h24V56a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,56v8H48a8,8,0,0,1,0,16H24v96H48a8,8,0,0,1,0,16H24v8a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16v-8H208a8,8,0,0,1,0-16h24V80H208a8,8,0,0,1,0-16ZM108,192H88a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Zm0-112H88a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Zm60,112H148a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Zm0-112H148a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "204",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "204",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "80",
          x2: "52",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "176",
          x2: "52",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "92",
          y1: "80",
          x2: "108",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "92",
          y1: "176",
          x2: "108",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "148",
          y1: "80",
          x2: "164",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "148",
          y1: "176",
          x2: "164",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFingerprint = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M128.00586,24.00842a104.11791,104.11791,0,0,0-104,104A87.786,87.786,0,0,1,19,157.34241a8.00025,8.00025,0,1,0,15.08594,5.332,103.74958,103.74958,0,0,0,5.91992-34.666,88,88,0,0,1,176,0,282.27848,282.27848,0,0,1-5.29,54.45313,7.99962,7.99962,0,1,0,15.69727,3.09375,298.25279,298.25279,0,0,0,5.59277-57.54688A104.11791,104.11791,0,0,0,128.00586,24.00842Z"
        }), React.createElement("path", {
          d: "M93.00977,84.2887A8.00025,8.00025,0,0,0,83.00195,71.80432,71.69909,71.69909,0,0,0,56.00586,128.0094,118.80142,118.80142,0,0,1,43.52637,181.361,7.99964,7.99964,0,1,0,57.85254,188.484,134.64637,134.64637,0,0,0,72.00586,128.0094,55.77314,55.77314,0,0,1,93.00977,84.2887Z"
        }), React.createElement("path", {
          d: "M128.00586,120.0094a8.00039,8.00039,0,0,0-8,8A184.12954,184.12954,0,0,1,97.03418,217.11a7.99993,7.99993,0,1,0,13.99219,7.75977,200.16824,200.16824,0,0,0,24.97949-96.86035A8.00039,8.00039,0,0,0,128.00586,120.0094Z"
        }), React.createElement("path", {
          d: "M128.00586,88.0094a40.04583,40.04583,0,0,0-40,40,8,8,0,0,0,16,0,24,24,0,0,1,48,0,214.09658,214.09658,0,0,1-20.51074,91.99512,8,8,0,1,0,14.47265,6.82226,229.98738,229.98738,0,0,0,22.03809-98.81738A40.04583,40.04583,0,0,0,128.00586,88.0094Z"
        }), React.createElement("path", {
          d: "M94.39648,152.16858a8.00778,8.00778,0,0,0-9.43066,6.249,150.78976,150.78976,0,0,1-17.2041,45.4375,8.00031,8.00031,0,1,0,13.85937,7.9961,166.73312,166.73312,0,0,0,19.02442-50.252A7.99971,7.99971,0,0,0,94.39648,152.16858Z"
        }), React.createElement("path", {
          d: "M128.00586,56.0094a72.92874,72.92874,0,0,0-8.99121.55664A8.00012,8.00012,0,1,0,120.99707,72.443a56.70946,56.70946,0,0,1,7.00879-.43359,56.0629,56.0629,0,0,1,56,56,251.41194,251.41194,0,0,1-1.919,31.00879,8,8,0,1,0,15.877,1.98047,267.59018,267.59018,0,0,0,2.042-32.98926A72.08124,72.08124,0,0,0,128.00586,56.0094Z"
        }), React.createElement("path", {
          d: "M185.93555,184.26135a7.99377,7.99377,0,0,0-9.74121,5.75293c-1.46485,5.68848-3.15332,11.39063-5.01856,16.94824a7.9999,7.9999,0,1,0,15.168,5.0918c1.9873-5.91992,3.78613-11.99316,5.34473-18.05176A7.999,7.999,0,0,0,185.93555,184.26135Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M50.68905,184.92207a127.4728,127.4728,0,0,0,13.31718-56.913A63.88065,63.88065,0,0,1,88.0059,78.04632",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128.00623,128.009a191.13407,191.13407,0,0,1-23.97573,92.98042",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M96.00623,128.009a32,32,0,0,1,64,0A223.13818,223.13818,0,0,1,138.731,223.41536",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M218.56486,184.00845a289.42035,289.42035,0,0,0,5.441-56,96,96,0,0,0-192,0,95.845,95.845,0,0,1-5.46267,32.00025",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M92.80577,160.00843a158.95129,158.95129,0,0,1-18.1147,47.84483",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M120.00621,64.50418a64.051,64.051,0,0,1,72,63.50485,258.52451,258.52451,0,0,1-1.98054,31.99945",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M183.94126,192.00844q-2.2851,8.87835-5.18116,17.5",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFingerprintSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M175.98242,120.0094a8.00039,8.00039,0,0,0-8,8,230.70455,230.70455,0,0,1-17.333,88.15527,8.00032,8.00032,0,1,0,14.79883,6.084,246.6394,246.6394,0,0,0,18.53418-94.23926A8.00039,8.00039,0,0,0,175.98242,120.0094Z"
        }), React.createElement("path", {
          d: "M127.98242,88.0094a40.06442,40.06442,0,0,1,29.81445,13.333,8.00032,8.00032,0,1,0,11.92188-10.67188A56.00093,56.00093,0,0,0,71.98242,128.0094,136.088,136.088,0,0,1,55.00586,193.861a7.99993,7.99993,0,1,0,13.99219,7.75977A152.12935,152.12935,0,0,0,87.98242,128.0094,40.04583,40.04583,0,0,1,127.98242,88.0094Z"
        }), React.createElement("path", {
          d: "M69.31738,62.41467A7.99966,7.99966,0,1,0,58.64746,50.4928a104.15766,104.15766,0,0,0-34.665,77.5166,87.28655,87.28655,0,0,1-7.97558,36.66308,7.9997,7.9997,0,1,0,14.541,6.67383,103.15936,103.15936,0,0,0,9.43457-43.33691A88.1429,88.1429,0,0,1,69.31738,62.41467Z"
        }), React.createElement("path", {
          d: "M127.98242,24.0094a103.7636,103.7636,0,0,0-34.667,5.91992,8.00025,8.00025,0,0,0,5.332,15.08594,88.06652,88.06652,0,0,1,117.335,82.99414,281.58357,281.58357,0,0,1-6.93847,62.22851,8.00013,8.00013,0,1,0,15.60351,3.541,297.64323,297.64323,0,0,0,7.335-65.76953A104.11791,104.11791,0,0,0,127.98242,24.0094Z"
        }), React.createElement("path", {
          d: "M113.89844,200.73889a8.00188,8.00188,0,0,0-10.60742,3.93359c-1.92676,4.19727-4.044,8.38086-6.291,12.43555a7.99945,7.99945,0,1,0,13.99219,7.75781c2.44336-4.40625,4.74511-8.95507,6.83984-13.51953A7.999,7.999,0,0,0,113.89844,200.73889Z"
        }), React.createElement("path", {
          d: "M127.9707,120.00842a8.00039,8.00039,0,0,0-8,8,184.6862,184.6862,0,0,1-5.79687,46.00586,8.00008,8.00008,0,1,0,15.49512,3.98828,200.70138,200.70138,0,0,0,6.30175-49.99414A8.00039,8.00039,0,0,0,127.9707,120.00842Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176.00586,128.009a239.296,239.296,0,0,1-17.934,91.1974",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M163.78085,96.006a48.00042,48.00042,0,0,0-83.775,32.003,143.35045,143.35045,0,0,1-17.98008,69.73221",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M96.00524,37.47183A96.06708,96.06708,0,0,1,224.00586,128.009a288.94587,288.94587,0,0,1-7.13641,63.99948",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M23.30117,168.00907a95.64559,95.64559,0,0,0,8.70469-40A95.76078,95.76078,0,0,1,64.00561,56.45385",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M110.58455,208.009q-3.04225,6.62844-6.56532,12.97841",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M127.99414,128.00842a192.34737,192.34737,0,0,1-6.0489,48.00023",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFinnTheHuman = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,140a12,12,0,1,1-12-12A12.01343,12.01343,0,0,1,176,140ZM92,128a12,12,0,1,0,12,12A12.01343,12.01343,0,0,0,92,128ZM240,64v80a72.08124,72.08124,0,0,1-72,72H88a72.08124,72.08124,0,0,1-72-72V64a32.00221,32.00221,0,0,1,62.98779-8h98.02442A32.00221,32.00221,0,0,1,240,64Zm-40,72a31.99971,31.99971,0,0,0-32-32H88a32,32,0,0,0-32,32v8a32.00034,32.00034,0,0,0,32,32h80a32,32,0,0,0,32-32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "56",
          y: "104.00002",
          width: "144",
          height: "72",
          rx: "32",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64,64,0,0,1-64,64H88a64,64,0,0,1-64-64Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "140",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "140",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFire = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M197.12793,66.60449c-13.07471-20.82129-29.90967-38.67578-44.65332-53.39355a7.99863,7.99863,0,0,0-12.87451,2.22168L108.74951,80.21875,76.47363,58.70117a7.99925,7.99925,0,0,0-11.104,2.23438C45.88135,90.31348,36,116.915,36,140a92,92,0,0,0,184,0C220,115.12207,212.51855,91.11426,197.12793,66.60449Zm-9.8335,82.61621a59.69692,59.69692,0,0,1-50.07275,50.07422,8.11543,8.11543,0,0,1-1.231.09473,8.00055,8.00055,0,0,1-1.21142-15.90723,44.31739,44.31739,0,0,0,36.70263-36.70312,7.99993,7.99993,0,1,1,15.8125,2.4414Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M179.3884,148.00007a52.03842,52.03842,0,0,1-43.388,43.38828",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72.03592,65.35733C56.59774,88.63059,44,115.21513,44,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L112,92,72.037,65.358Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFireSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M219.88159,140a92,92,0,0,1-184,0c0-23.085,9.88135-49.68652,29.36963-79.06445a7.99925,7.99925,0,0,1,11.104-2.23438L108.6311,80.21875l30.85059-64.78613a7.99863,7.99863,0,0,1,12.87451-2.22168c14.74365,14.71777,31.57861,32.57226,44.65332,53.39355C212.40014,91.11426,219.88159,115.12207,219.88159,140Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M71.91751,65.35733C56.47932,88.63059,43.88159,115.21513,43.88159,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L111.88159,92l-39.963-26.642Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFirstAid = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,104v48a16.01833,16.01833,0,0,1-16,16H168v48a16.01833,16.01833,0,0,1-16,16H104a16.01833,16.01833,0,0,1-16-16V168H40a16.01833,16.01833,0,0,1-16-16V104A16.01833,16.01833,0,0,1,40,88H88V40a16.01833,16.01833,0,0,1,16-16h48a16.01833,16.01833,0,0,1,16,16V88h48A16.01833,16.01833,0,0,1,232,104Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFirstAidKit = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.00781,64H176V56a24.0275,24.0275,0,0,0-24-24H104A24.0275,24.0275,0,0,0,80,56v8H40.00781a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h176a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216.00781,64ZM96,56a8.00917,8.00917,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8v8H96Zm60,96H136v20a8,8,0,0,1-16,0V152H100a8,8,0,0,1,0-16h20V116a8,8,0,0,1,16,0v20h20a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "116",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "156",
          y1: "144",
          x2: "100",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFish = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,76a12,12,0,1,1-12-12A12,12,0,0,1,168,76Zm37.708,83.49292c-20.42774,25.95142-53.21875,40.1106-97.51758,42.12524L87.374,251.10205A7.99987,7.99987,0,0,1,80.00293,256c-.16016,0-.32129-.00488-.48242-.01416a8.0008,8.0008,0,0,1-7.21289-5.78809l-14.7793-51.72949L5.79785,183.6543a8.00035,8.00035,0,0,1-.89941-15.06543l49.46094-20.80152c2.02539-44.28955,16.19042-77.074,42.14355-97.49829,41.11816-32.35791,99.376-22.94629,116.251-19.29A16.03051,16.03051,0,0,1,225.001,43.24487C228.65723,60.12231,238.07031,118.3811,205.708,159.49292Zm3.65625-112.85986C194.2168,43.35449,142.02148,34.82642,106.39844,62.8623a78.69585,78.69585,0,0,0-10.38086,9.83619A40.03964,40.03964,0,0,0,136,112a8.00024,8.00024,0,0,1,8,8,40.039,40.039,0,0,0,39.29077,39.98193,78.64492,78.64492,0,0,0,9.845-10.38549C221.17383,113.978,212.64551,61.78223,209.36426,46.63306Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "156",
          cy: "76",
          r: "12"
        }), React.createElement("path", {
          d: "M186.30284,167.94573Q185.15821,167.99979,184,168a48,48,0,0,1-48-48A48,48,0,0,1,88,72q0-1.16456.05488-2.31579",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M62.177,153.17849,8,175.96316,64,192l16,56,22.8003-54.20045v.00009c138.35934-3.2851,120.00626-122.89746,114.38209-148.8602a7.98721,7.98721,0,0,0-6.1218-6.12182C185.099,33.19376,65.49508,14.84213,62.17691,153.17849Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFishSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,76a12,12,0,1,1-12-12A12,12,0,0,1,168,76Zm30.166,91.978c-26.47168,26.41015-68.41309,37.40625-125.05957,32.89013q2.40673,17.75244,6.709,37.42237a8.0002,8.0002,0,1,1-15.63086,3.41894q-4.894-22.377-7.40723-42.52148-20.12549-2.51661-42.48828-7.40967a8,8,0,1,1,3.42188-15.62988q19.64795,4.30077,37.38965,6.70947c-4.501-56.63525,6.502-98.55469,32.91113-125.02148C129.00684,16.752,193.83984,26.90332,212.73242,30.99414a16.05936,16.05936,0,0,1,12.27246,12.273C229.0957,62.16064,239.24805,126.99023,198.166,167.978Zm11.20117-121.3252c-15.00171-3.26269-62.22412-10.852-97.31543,12.15283a87.969,87.969,0,0,0,85.14136,85.13916C220.20068,108.85791,212.61182,61.63721,209.36719,46.65283Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "156",
          cy: "76",
          r: "12"
        }), React.createElement("path", {
          d: "M16,183.96316C247.8414,234.71183,223.79084,75.46765,217.18687,44.9601a8.01954,8.01954,0,0,0-6.147-6.147C180.5321,32.20917,21.28468,8.15854,72,240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M201.34694,151.99061A96.0002,96.0002,0,0,1,104.00959,54.639",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFlag = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M219.57764,40.84924a7.99605,7.99605,0,0,0-8.37793.75489c-28.29981,21.22558-52.28223,10.94726-80.04883-.95313-28.24414-12.10449-60.25488-25.81934-95.95117.95313-.04737.0354-.08838.07568-.13428.11181-.11084.08692-.21777.17676-.32373.26929-.09912.08667-.19727.17407-.291.26465-.0874.08423-.17138.17138-.25488.25952-.1001.10547-.19873.21142-.292.32129-.0708.08349-.1377.16968-.20508.25586-.09277.11865-.18457.23779-.26953.36084-.06348.09082-.12158.18457-.18115.27807-.07715.12232-.1543.24439-.22461.37036-.06006.10694-.11475.217-.16992.32715-.05811.1167-.11719.23291-.16944.35181-.05566.126-.105.25513-.15429.38428-.04151.10913-.0835.218-.12012.32861-.04541.137-.084.27661-.12207.417-.03028.11084-.06055.22119-.08594.33325-.03027.13526-.05518.27271-.07861.41065-.02149.12524-.042.25024-.05762.37646-.01514.12427-.02588.24927-.03564.37525-.01075.14575-.01856.2915-.022.43774-.001.05615-.0083.11035-.0083.16651v168a8,8,0,0,0,16,0V172.13879c26.92334-18.16259,50.13623-8.22973,76.84863,3.21924,16.26368,6.96973,33.7754,14.47559,52.52247,14.47461,13.80859,0,28.2871-4.07226,43.42871-15.42773a8.00094,8.00094,0,0,0,3.20019-6.40039v-120A8.00023,8.00023,0,0,0,219.57764,40.84924Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "216.00452",
          x2: "40",
          y2: "48.00452",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M39.99951,168.00452c64-48,112,48,176,0v-120c-64,48-112-48-176,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFlagBanner = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M230.24694,163.00293A8,8,0,0,1,223.99988,176H48v40a8,8,0,1,1-16,0V48a8.00039,8.00039,0,0,1,8-8H223.99988a8,8,0,0,1,6.24706,12.99707L186.245,108Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFlame = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M173.793,51.48242a220.94852,220.94852,0,0,0-41.67676-34.34277,8.00334,8.00334,0,0,0-8.23242,0A220.94852,220.94852,0,0,0,82.207,51.48242C54.59473,80.47559,40,112.4668,40,144a88,88,0,0,0,176,0C216,112.4668,201.40527,80.47559,173.793,51.48242ZM96,184c0-27.67285,22.52637-47.27734,31.999-54.29688C137.48193,136.72949,160,156.332,160,184a32,32,0,0,1-64,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFlashlight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184.00244,16h-112a16.01833,16.01833,0,0,0-16,16V77.333a16.10105,16.10105,0,0,0,3.2002,9.60058l20.7998,27.7334V224a16.01833,16.01833,0,0,0,16,16h64a16.01833,16.01833,0,0,0,16-16l-.001-109.334,20.80274-27.7334a16.10719,16.10719,0,0,0,3.19824-9.59961V32A16.01833,16.01833,0,0,0,184.00244,16Zm-48,136a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0ZM71.99805,56l-.00537-24H184.00244l.00049,24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M72.00244,24h112a8,8,0,0,1,8,8V77.33333a8,8,0,0,1-1.6,4.8l-20.8,27.73334a8,8,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8h-64a8,8,0,0,1-8-8V114.66667a8,8,0,0,0-1.6-4.8l-20.8-27.73334a8,8,0,0,1-1.6-4.8V32A8,8,0,0,1,72.00244,24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128.00244",
          y1: "120",
          x2: "128.00244",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64.00244",
          y1: "64",
          x2: "192.00244",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFlask = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.59033,199.76855,160,93.78418V40h8a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16h8V93.78418l-40.17285,66.955c-.044.07067-.08643.1416-.12793.2135L32.40967,199.76807A15.99968,15.99968,0,0,0,46.12988,224H209.87012a15.99944,15.99944,0,0,0,13.72021-24.23145Zm-113.87109-97.752A15.99829,15.99829,0,0,0,112,93.78418V40h32V93.78418a15.99947,15.99947,0,0,0,2.28027,8.23193l38.86328,64.77222c-13.10742,7.11157-31.4458,5.11572-53.56591-5.9436-14.25293-7.127-32.667-13.52124-50.31055-11.4076Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M104,32V93.78413a7.99992,7.99992,0,0,1-1.14006,4.116L39.26958,203.884A8,8,0,0,0,46.12952,216h163.741a8,8,0,0,0,6.85994-12.116L153.14006,97.90009A7.99992,7.99992,0,0,1,152,93.78413V32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "32",
          x2: "168",
          y2: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M62.61682,164.96456C74.44058,156.34675,94.73752,151.36876,128,168c35.70432,17.85216,56.4696,10.80591,67.852,1.08577",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFloppyDisk = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M219.31445,79.99963,176.001,36.68811a15.88944,15.88944,0,0,0-11.31446-4.68848H48a16.01833,16.01833,0,0,0-16,16v160a16.01833,16.01833,0,0,0,16,16H79.82617c.05835.00122.11524.00879.17383.00879s.11548-.00757.17383-.00879h95.65234c.05835.00122.11524.00879.17383.00879s.11548-.00757.17383-.00879H208a16.01833,16.01833,0,0,0,16-16V91.31409A15.898,15.898,0,0,0,219.31445,79.99963ZM208,91.31409V207.99963H184V152.00842a16.01833,16.01833,0,0,0-16-16H88a16.01833,16.01833,0,0,0-16,16v55.99121H48v-160l116.68555.001L208,91.31409v-.001l8,.001ZM160,72.0094a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8.00039,8.00039,0,0,1,160,72.0094Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,91.31371V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.68629a8,8,0,0,1,5.65686,2.34315l43.3137,43.3137A8,8,0,0,1,216,91.31371Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,216.00842v-64a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "72.00903",
          x2: "96",
          y2: "72.00903",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFloppyDiskBack = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,31.99963H168V80.0094a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h56V31.99963H91.31348A15.89171,15.89171,0,0,0,80,36.68616L36.68555,79.99963A15.898,15.898,0,0,0,32,91.31409V207.99963a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16v-160A16.01833,16.01833,0,0,0,208,31.99963ZM128,176a28,28,0,1,1,28-28A28.0316,28.0316,0,0,1,128,176Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40,91.31371V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.31371a8,8,0,0,0-5.65686,2.34315l-43.3137,43.3137A8,8,0,0,0,40,91.31371Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128.0059",
          cy: "148.009",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 80.009 160 80.009 160 40.009",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFlowArrow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M245.81592,85.48145c-.0542.0581-.10205.11914-.15869.17578l-40,40a8.00053,8.00053,0,0,1-11.31446-11.31446L220.68652,88H176a40.04584,40.04584,0,0,0-40,40,56.0629,56.0629,0,0,1-56,56h-.90723a36,36,0,1,1,0-16H80a40.04584,40.04584,0,0,0,40-40,56.0629,56.0629,0,0,1,56-56h44.68652L194.34277,45.65723a8.00053,8.00053,0,0,1,11.31446-11.31446l40,40c.05664.05664.10449.11768.15869.17578.12549.13282.251.26514.36719.40625.0913.11084.17138.22706.25537.3418.07031.09522.14453.188.21093.28662.085.12647.15918.25782.23584.38819.05567.09423.11524.186.167.2832.06933.12891.12841.26172.18994.39355.04931.10547.10205.209.147.31641.05225.127.09522.25586.14063.38477.042.11816.0874.23437.124.355.03906.1289.06787.25976.10058.39013.03077.12305.06543.24414.09034.36914.02978.15186.04834.30469.06933.45752.01465.106.03516.20948.0459.3169a8.02276,8.02276,0,0,1,0,1.584c-.01074.10742-.03125.21094-.0459.3169-.021.15283-.03955.30566-.06933.45752-.02491.125-.05957.24609-.09034.36914-.03271.13037-.06152.26123-.10058.39013-.03662.12061-.082.23682-.124.355-.04541.12891-.08838.25782-.14063.38477-.04492.10742-.09766.21094-.147.31641-.06153.13183-.12061.26464-.18994.39355-.05176.09717-.11133.189-.167.2832-.07666.13037-.15087.26172-.23584.38819-.0664.09863-.14062.1914-.21093.28662-.084.11474-.16407.231-.25537.3418C246.06689,85.21631,245.94141,85.34863,245.81592,85.48145Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "44",
          cy: "176",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "200 40 240 80 200 120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,176h8.00005a48,48,0,0,0,48-48V128A48,48,0,0,1,176,80h64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFlower = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.35352,132.82324A57.99826,57.99826,0,0,0,196.93994,128a58.016,58.016,0,0,0,11.41406-4.82324,36,36,0,1,0-36.00048-62.35352,58.00132,58.00132,0,0,0-9.88331,7.47266A58.01937,58.01937,0,0,0,164,56a36,36,0,0,0-72,0,58.01145,58.01145,0,0,0,1.52979,12.29541A58.01465,58.01465,0,0,0,83.646,60.82227a36.00017,36.00017,0,0,0-35.99952,62.35449A57.99826,57.99826,0,0,0,59.06006,128,58.016,58.016,0,0,0,47.646,132.82324a36,36,0,0,0,36.00048,62.35352,58.00132,58.00132,0,0,0,9.88331-7.47266A58.01937,58.01937,0,0,0,92,200a36,36,0,0,0,72,0,58.01145,58.01145,0,0,0-1.52979-12.29541,58.01465,58.01465,0,0,0,9.88379,7.47314,36.00017,36.00017,0,0,0,35.99952-62.35449ZM128,152a24,24,0,1,1,24-24A24.02687,24.02687,0,0,1,128,152Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M115.02821,103.18241C107.70283,87.77847,100,68.588,100,56a28,28,0,0,1,56,0c0,12.588-7.70285,31.7785-15.02823,47.18245",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M100.02144,126.8251c-17.00289-1.358-37.47372-4.28238-48.37527-10.57639a28,28,0,0,1,28-48.49742c10.90156,6.294,23.66957,22.56011,33.34708,36.606",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M112.99323,151.64269c-9.67751,14.04594-22.44551,30.312-33.34706,36.606a28,28,0,0,1-28-48.49742c10.90156-6.294,31.37241-9.21839,48.37532-10.5764",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M140.97179,152.81759C148.29717,168.22153,156,187.412,156,200a28,28,0,0,1-56,0c0-12.588,7.70285-31.7785,15.02823-47.18245",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M155.97856,129.1749c17.00289,1.358,37.47372,4.28238,48.37527,10.57639a28,28,0,0,1-28,48.49742c-10.90156-6.294-23.66957-22.56011-33.34708-36.606",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M143.00677,104.35731c9.67751-14.04594,22.44551-30.312,33.34706-36.606a28,28,0,0,1,28,48.49742c-10.90156,6.294-31.37241,9.21839-48.37532,10.5764",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFlowerLotus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M250.47559,121.28906a15.82032,15.82032,0,0,0-9.84375-7.47558,80.056,80.056,0,0,0-27.957-1.85254,85.73919,85.73919,0,0,0-2.53125-40.8252,15.96177,15.96177,0,0,0-18.54394-10.706,82.56127,82.56127,0,0,0-26.1582,10.74511,94.07116,94.07116,0,0,0-27.84034-34.36816,15.94439,15.94439,0,0,0-19.20361.001A94.06121,94.06121,0,0,0,90.55859,71.1748,82.56738,82.56738,0,0,0,64.40234,60.42969a15.96626,15.96626,0,0,0-18.54589,10.707A85.73054,85.73054,0,0,0,43.3252,111.96a80.01629,80.01629,0,0,0-27.957,1.85352,15.957,15.957,0,0,0-11.3955,19.73828c3.53808,12.65332,14.36767,36.70508,47.13769,55.626C83.67676,207.979,112.45654,208,127.94629,208c.01562,0,.03027.00195.0459.00195L128,208.00146l.00781.00049c.01563,0,.03028-.00195.0459-.00195,15.48975,0,44.26953-.021,76.83594-18.82324,32.77-18.91992,43.59961-42.97168,47.13769-55.625A15.81809,15.81809,0,0,0,250.47559,121.28906ZM128.03027,49.62793C137.64258,56.80469,160,78.02832,160,120s-22.35742,63.19531-31.96826,70.37109a.0448.0448,0,0,1-.06348,0C118.355,183.19238,96,161.96875,96,120,96,78.02832,118.35742,56.80469,128.03027,49.62793ZM19.3418,129.31152a66.43813,66.43813,0,0,1,28.34814-.57763,123.02667,123.02667,0,0,0,9.669,20.91259,138.33271,138.33271,0,0,0,33.27295,38.52344,121.79948,121.79948,0,0,1-31.52149-12.84863C31.25732,159.23926,22.26367,139.54883,19.3418,129.31152Zm177.54785,46.00879a121.79928,121.79928,0,0,1-31.521,12.84912,138.33687,138.33687,0,0,0,33.27246-38.523,123.02667,123.02667,0,0,0,9.66895-20.91259,67.45364,67.45364,0,0,1,28.30908.50927C233.73633,139.54883,224.74268,159.23926,196.88965,175.32031Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,200c16,0,42.45589-.1803,72.88973-17.75129s40.28225-39.5825,43.43363-50.85144a7.95859,7.95859,0,0,0-5.67818-9.83489c-7.38178-1.89206-20.12947-3.60238-36.52927.288",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M53.88184,121.84985c-16.39872-3.88969-29.14558-2.17944-36.527-.28747a7.95859,7.95859,0,0,0-5.67818,9.83489c3.15138,11.26894,12.99979,33.28046,43.43363,50.85144S112,200,128,200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,200s40-21.81818,40-80c0-45.58443-24.55378-68.84723-35.18644-76.78386a8.03282,8.03282,0,0,0-9.62712,0C112.55378,51.15277,88,74.41557,88,120,88,178.18182,128,200,128,200Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,200c11.99027-2.55021,44.33-20.78184,63.71281-54.35383S206.32158,85.26679,202.535,73.60781a7.99178,7.99178,0,0,0-9.27184-5.3531,77.437,77.437,0,0,0-31.35645,15.135",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M94.09282,83.38935a77.43686,77.43686,0,0,0-31.356-15.13464,7.99178,7.99178,0,0,0-9.27184,5.3531c-3.78659,11.659-8.56062,38.46637,10.82218,72.03836S116.00973,197.44979,128,200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolder = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,71.99805h-84.6875l-27.3125-27.3125a15.8907,15.8907,0,0,0-11.3125-4.6875H39.99512a16.01581,16.01581,0,0,0-16,16V200.61523a15.404,15.404,0,0,0,15.39062,15.38282h177.5a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176-16h52.6875l16,16H39.99512Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderMinus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,71.99805h-84.6875l-27.3125-27.3125a15.8907,15.8907,0,0,0-11.3125-4.6875H39.99512a16.01581,16.01581,0,0,0-16,16V200.61523a15.404,15.404,0,0,0,15.39062,15.38282h177.5a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176-16h52.6875l16,16H39.99512Zm112,96.00195h-48a8,8,0,1,1,0-16h48a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderNotch = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,71.99805H130.65625L102.917,51.19336a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16h176a16.01583,16.01583,0,0,0,16-16v-112A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176-8H93.33887l21.32617,15.999-21.3418,16.001H39.99512Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderNotchMinus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,71.99805H130.65625L102.917,51.19336a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16h176a16.01583,16.01583,0,0,0,16-16v-112A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176,24v-32H93.33887l21.32617,15.999-21.3418,16.001ZM151.99707,156h-48a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "103.99707",
          y1: "148",
          x2: "151.99707",
          y2: "148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderNotchOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M241.88037,110.64453A16.03934,16.03934,0,0,0,228.90039,104H216V88a16.01833,16.01833,0,0,0-16-16H130.667l-27.7334-20.7998A16.10323,16.10323,0,0,0,93.333,48H40A16.01833,16.01833,0,0,0,24,64V208a8.06184,8.06184,0,0,0,.04541.8457c.00293.02735.00928.0542.0127.08155a7.86829,7.86829,0,0,0,.13818.81543c.01562.07226.03711.14306.05517.21484.05665.22559.12159.44775.19727.665.02734.07812.05566.15527.08545.23242q.126.33033.28076.64551c.03076.064.05908.12842.09229.1914a7.98135,7.98135,0,0,0,1.01318,1.49952c.06055.07129.12451.13769.1875.20654.14063.15381.28662.30176.43945.44434.07276.06787.145.13525.22022.20068.17187.14844.3501.28808.53418.42187.05469.04.10693.084.16308.12207a7.91673,7.91673,0,0,0,.77246.47168c.0254.01368.05225.02442.07764.0376a7.86248,7.86248,0,0,0,.73779.33594c.07129.02832.14405.05322.2168.07959q.31715.11572.64649.20459c.085.023.16894.04541.25439.06543.21875.05127.44092.09131.666.124.08154.01221.16259.02783.24462.0376A8.04614,8.04614,0,0,0,32,216H208a8.00117,8.00117,0,0,0,7.58984-5.47021l28.48926-85.47022A16.03873,16.03873,0,0,0,241.88037,110.64453ZM93.333,64l27.7334,20.7998A16.10323,16.10323,0,0,0,130.667,88H200v16H146.42188a15.9479,15.9479,0,0,0-8.875,2.6875L117.57812,120H69.416a15.92344,15.92344,0,0,0-14.85547,10.05762L40,166.45947V64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,208l29.98845-74.97113A8,8,0,0,1,69.41626,128h48.16153a8,8,0,0,0,4.43761-1.3436l19.9692-13.3128A8,8,0,0,1,146.42221,112h82.47838a8,8,0,0,1,7.58947,10.52982L208,208Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderNotchPlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,71.99805H130.65625L102.917,51.19336a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16h176a16.01583,16.01583,0,0,0,16-16v-112A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176,24v-32H93.33887l21.32617,15.999-21.3418,16.001ZM151.99707,156h-16v16a8,8,0,0,1-16,0V156h-16a8,8,0,0,1,0-16h16V124a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8.02352,8.02352,0,0,1-8-8V104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M93.33333,104H32V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6L128,80,98.13333,102.4A8,8,0,0,1,93.33333,104Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "103.99707",
          y1: "148",
          x2: "151.99707",
          y2: "148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.99707",
          y1: "124",
          x2: "127.99707",
          y2: "172",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M241.88037,110.64453A16.03934,16.03934,0,0,0,228.90039,104H216V88a16.01833,16.01833,0,0,0-16-16H130.667l-27.7334-20.7998A16.10323,16.10323,0,0,0,93.333,48H40A16.01833,16.01833,0,0,0,24,64V208c0,.05127.00684.10059.00781.15137.002.1123.00977.22412.0166.33642.01172.19043.02832.37891.05274.56592q.02051.15234.04639.30371c.03515.20459.07861.40576.1289.605.021.08252.04.16553.064.24756.06836.23877.14843.47217.23779.70117.0166.042.02978.08545.04687.12793a7.867,7.867,0,0,0,.39014.81592c.01563.02881.03467.05566.05078.084q.1919.33912.41553.65625c.019.02686.0332.05567.05225.08252.03564.04883.07763.09082.11377.13916.12255.16163.24951.31885.38378.47022.06836.07764.13672.1543.20752.22851.14161.14844.29.29.44287.42725.064.05713.125.11768.19043.17285a7.94692,7.94692,0,0,0,.69581.52832l.01953.01172a7.96822,7.96822,0,0,0,.73632.43311c.064.0332.12989.0625.19483.09375.19971.09765.40332.18847.61182.26953.0791.03027.1582.05859.23828.08691q.30176.1062.61377.188c.08447.02246.168.04541.25293.06494.21386.04883.43164.08643.65185.11817.0791.01123.15674.02685.23633.03613A8.06189,8.06189,0,0,0,32,216H208a8.00117,8.00117,0,0,0,7.58984-5.47021l28.48926-85.47022A16.039,16.039,0,0,0,241.88037,110.64453ZM93.333,64l27.7334,20.7998A16.10323,16.10323,0,0,0,130.667,88H200v16H69.76611a15.98037,15.98037,0,0,0-15.1792,10.94043L40,158.70166V64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,208l30.17661-90.52982A8,8,0,0,1,69.76607,112H228.90059a8,8,0,0,1,7.58947,10.52982L208,208Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderPlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,71.99805h-84.6875l-27.3125-27.3125a15.8907,15.8907,0,0,0-11.3125-4.6875H39.99512a16.01581,16.01581,0,0,0-16,16V200.61523a15.404,15.404,0,0,0,15.39062,15.38282h177.5a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805Zm-176-16h52.6875l16,16H39.99512Zm112,96.00195h-16v16a8,8,0,1,1-16,0V152h-16a8,8,0,1,1,0-16h16V120a8,8,0,1,1,16,0v16h16a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.88889,208H39.38462A7.40633,7.40633,0,0,1,32,200.61538V80H216a8,8,0,0,1,8,8V200.88889A7.11111,7.11111,0,0,1,216.88889,208Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.68629a8,8,0,0,1,5.65686,2.34315L128,80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,71.99805H130.667l-27.75-20.80469a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16H216.88574a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderSimpleMinus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,71.99805H130.667l-27.75-20.80469a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16H216.88574a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805ZM151.99414,152h-48a8,8,0,0,1,0-16h48a8,8,0,1,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolderSimplePlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99512,71.99805H130.667l-27.75-20.80469a16.07363,16.07363,0,0,0-9.57812-3.19531H39.99512a16.01581,16.01581,0,0,0-16,16v136a16.01582,16.01582,0,0,0,16,16H216.88574a15.13062,15.13062,0,0,0,15.10938-15.10938V87.99805A16.01582,16.01582,0,0,0,215.99512,71.99805ZM152,152H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,88V200.88889A7.11111,7.11111,0,0,1,216.88889,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFolders = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,64H154.667l-27.7334-20.7998A16.10323,16.10323,0,0,0,117.333,40H72A16.01833,16.01833,0,0,0,56,56V72H40A16.01833,16.01833,0,0,0,24,88V200a16.01833,16.01833,0,0,0,16,16H192.88867A15.12831,15.12831,0,0,0,208,200.88867V184h16.88867A15.12831,15.12831,0,0,0,240,168.88867V80A16.01833,16.01833,0,0,0,224,64Zm0,104H208V112a16.01833,16.01833,0,0,0-16-16H122.667L94.93359,75.2002A16.10323,16.10323,0,0,0,85.333,72H72V56h45.333l27.7334,20.7998A16.10323,16.10323,0,0,0,154.667,80H224Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,112v88.88889A7.11111,7.11111,0,0,1,192.88889,208H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,112v88.88889A7.11111,7.11111,0,0,1,192.88889,208H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M64,80V56a8,8,0,0,1,8-8h45.33333a8,8,0,0,1,4.8,1.6l27.73334,20.8a8,8,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.88889A7.11111,7.11111,0,0,1,224.88889,176H200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFootball = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M225.98,56.31055a32.13113,32.13113,0,0,0-26.29-26.29053c-31.35058-5.30908-90.43652-7.72363-133.915,35.75439-43.478,43.478-41.064,102.56446-35.75488,133.915a32.13113,32.13113,0,0,0,26.29,26.29053,200.74409,200.74409,0,0,0,33.27637,2.83984c31.082,0,69.78955-7.74511,100.63867-38.59423C233.70361,146.74756,231.28906,87.66113,225.98,56.31055Zm-166.998,153.894a16.11587,16.11587,0,0,1-13.18652-13.18652,184.687,184.687,0,0,1-2.68555-30.59473l46.48267,46.48291A185.002,185.002,0,0,1,58.98193,210.20459ZM165.65674,101.65674,150.6272,116.68652l8.97046,8.97022a8,8,0,0,1-11.31348,11.314L139.31372,128l-11.314,11.314,8.97045,8.97022a7.99983,7.99983,0,1,1-11.31347,11.31348l-8.97046-8.97022-15.02954,15.0293a7.99984,7.99984,0,0,1-11.31348-11.31348l15.02954-15.02978-8.97046-8.97022a8,8,0,0,1,11.31348-11.314L116.68628,128l11.314-11.314-8.97045-8.97022a7.99983,7.99983,0,1,1,11.31347-11.31348l8.97046,8.97022,15.02954-15.0293a7.99984,7.99984,0,0,1,11.31348,11.31348Zm.75024-58.563a185.0087,185.0087,0,0,1,30.61109,2.70166,16.11531,16.11531,0,0,1,13.18652,13.18652,184.687,184.687,0,0,1,2.68555,30.59473Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184.56854,184.56854c-41.52913,41.52913-99.19529,38.21906-126.92237,33.52363a24.07744,24.07744,0,0,1-19.73834-19.73834c-4.69543-27.72708-8.0055-85.39324,33.52363-126.92237S170.62675,33.2124,198.35383,37.90783a24.07744,24.07744,0,0,1,19.73834,19.73834C222.7876,85.37325,226.09767,143.03941,184.56854,184.56854Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "124.68629",
          y1: "102.05887",
          x2: "153.94113",
          y2: "131.31371",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "102.05887",
          y1: "124.68629",
          x2: "131.31371",
          y2: "153.94113",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "148.22436",
          y1: "36.22436",
          x2: "219.77587",
          y2: "107.77587",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "36.22399",
          y1: "148.22399",
          x2: "107.77612",
          y2: "219.77612",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconForkKnife = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M127.98877,79.77539c-.00439-.14453-.00977-.28906-.022-.43457-.01221-.146-.03028-.29-.04981-.43359-.01074-.07422-.01367-.14795-.02588-.22266l-8-48a8,8,0,1,0-15.78222,2.63086L110.55615,72H92V32a8,8,0,0,0-16,0V72H57.44385l6.44726-38.68457a8,8,0,1,0-15.78222-2.63086l-8,48c-.01221.07471-.01514.14844-.02588.22266-.01953.14355-.0376.28759-.04981.43359-.0122.14551-.01758.29-.022.43457C40.00928,79.85059,40,79.92432,40,80c0,.07129.00488.14111.00537.21191.00147.04932.00147.09815.00391.147A44.06056,44.06056,0,0,0,76,123.25781V224a8,8,0,0,0,16,0V123.25781a44.06056,44.06056,0,0,0,35.99072-42.89892c.00244-.04883.00244-.09766.00391-.147C127.99512,80.14111,128,80.07129,128,80,128,79.92432,127.99072,79.85059,127.98877,79.77539Z"
        }), React.createElement("path", {
          d: "M211.99268,31.8584c-.00245-.165-.01172-.33008-.02491-.49561-.00879-.1123-.019-.22363-.03271-.33447-.01709-.13818-.03858-.27637-.063-.41455-.02441-.13916-.05127-.27686-.08252-.41309-.02539-.10839-.05371-.2163-.0835-.32422-.04443-.16064-.09228-.31884-.14648-.47509-.01514-.04492-.0249-.09033-.041-.13526-.01806-.04834-.041-.09326-.05957-.14111q-.09081-.23511-.19531-.46191-.06738-.148-.14062-.292-.09888-.19335-.208-.38037c-.06445-.11181-.13037-.22168-.19971-.32959-.06592-.10156-.13476-.20019-.20508-.29883-.08447-.11914-.17041-.23584-.26123-.34912-.0664-.08349-.13574-.16406-.20507-.24463-.1001-.11523-.20166-.229-.30762-.33789-.07422-.07617-.15137-.14941-.22852-.22265-.10644-.10156-.21386-.20117-.32568-.29639-.08984-.07666-.18311-.14892-.27637-.22168-.10449-.08105-.20947-.16162-.31787-.23779-.11084-.07764-.2251-.15039-.33984-.22217-.09717-.061-.19434-.12256-.29444-.1792-.13037-.07422-.26367-.14258-.39843-.20947-.09229-.0459-.18409-.0918-.27832-.13428-.14161-.06348-.28565-.12109-.43165-.17676-.09667-.03662-.19287-.07324-.2915-.10644-.13965-.04737-.28174-.08887-.4248-.12842-.11426-.03174-.228-.06152-.34327-.08838-.12695-.02881-.25537-.05371-.38427-.07666-.14063-.02539-.28076-.04687-.42285-.06445-.10889-.01319-.21827-.02393-.32862-.03321q-.24535-.01977-.49365-.0249C204.10352,24.00684,204.05273,24,204,24c-.04834,0-.0957.00635-.14355.00732-.16407.00293-.32813.01172-.49268.02491-.11279.00879-.22461.019-.33594.03271-.13818.01709-.27588.03858-.41406.063-.13916.02441-.27686.05127-.41309.083-.10839.0249-.2163.05322-.32422.083-.16064.04394-.31884.09228-.47509.14648-.04492.01514-.09033.0249-.13526.041-.09863.03613-.1958.0791-.29394.11572-.03711.01513-.0752.02832-.11231.04394-20.60986,7.74561-37.11474,33.0293-49.05713,75.17823a398.22183,398.22183,0,0,0-11.75683,59.32812A8.00051,8.00051,0,0,0,148,168h48v56a8,8,0,0,0,16,0V32C212,31.95215,211.99365,31.90625,211.99268,31.8584Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "84",
          y1: "32",
          x2: "84",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "84",
          y1: "116",
          x2: "84",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M112,32l8,48a36,36,0,0,1-72,0l8-48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M204,160H148S160,48,204,32V224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFrameCorners = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM88,192H56a8.00008,8.00008,0,0,1-8-8V152a8,8,0,0,1,16,0v24H88a8,8,0,0,1,0,16Zm120-88a8,8,0,0,1-16,0V80H168a8,8,0,0,1,0-16h32a8.00008,8.00008,0,0,1,8,8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "160 80 192 80 192 112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 176 64 176 64 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFramerLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,100V32a8.00008,8.00008,0,0,0-8-8H56a8,8,0,0,0-5.49316,13.81592L107.87793,92H56a8.00008,8.00008,0,0,0-8,8v68a7.99941,7.99941,0,0,0,2.50684,5.81592l72,68A7.99984,7.99984,0,0,0,136,236V176h64a8,8,0,0,0,5.49316-13.81592L148.12207,108H200A8.00008,8.00008,0,0,0,208,100Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFunnel = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M228.54736,49.52637A15.80639,15.80639,0,0,0,213.91553,40H42.08447A16.00043,16.00043,0,0,0,30.24561,66.76367L96,139.09277v77.959a15.99388,15.99388,0,0,0,24.875,13.3125l31.99951-21.332A15.96822,15.96822,0,0,0,160,195.71875v-56.625l65.75488-72.331A15.80708,15.80708,0,0,0,228.54736,49.52637Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M42.08441,48H213.91559a8,8,0,0,1,5.91952,13.38138l-65.75463,72.33009A8,8,0,0,0,152,139.09285v56.62568a8,8,0,0,1-3.5624,6.6564l-32,21.33334A8,8,0,0,1,104,217.05186v-77.959a8,8,0,0,0-2.08048-5.38138L36.16489,61.38138A8,8,0,0,1,42.08441,48Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconFunnelSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M192,120H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M232,72H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M152,168H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24",
          y1: "80",
          x2: "232",
          y2: "80",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "176",
          x2: "152",
          y2: "176",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGameController = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M247.45752,181.74316c-.00781-.04394-.01611-.08789-.02441-.13183L231.08252,97.18848c-.01221-.06348-.0321-.123-.0459-.186a60.08639,60.08639,0,0,0-59.01855-49.26221h-.02344L84.00439,48A59.86832,59.86832,0,0,0,24.90625,97.58887c-.0127.07226-.02441.14551-.03516.21777L8.57715,181.60547c-.00879.0459-.01709.0918-.02539.13769A36.00238,36.00238,0,0,0,69.45752,213.457q.21753-.2168.416-.44726l40.729-45.02442,34.84961-.13916,40.67139,45.14893q.20361.2373.42822.46191a36.00125,36.00125,0,0,0,60.90576-31.71387ZM104,116H96v8a8,8,0,0,1-16,0v-8H72a8,8,0,0,1,0-16h8V92a8,8,0,0,1,16,0v8h8a8,8,0,0,1,0,16Zm40-8a8.00008,8.00008,0,0,1,8-8h32a8,8,0,0,1,0,16H152A8.00008,8.00008,0,0,1,144,108Zm71.47754,99.69141a20.03371,20.03371,0,0,1-17.45606-5.39453l-31.11169-34.53614,5.10828-.02051a60.00525,60.00525,0,0,0,50.94067-28.34961l8.75269,45.19239A20.02155,20.02155,0,0,1,215.47754,207.69141Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "152",
          y1: "108",
          x2: "184",
          y2: "108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72",
          y1: "108",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "92",
          x2: "88",
          y2: "124",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M172.01831,55.7398,84.00446,56A52.01509,52.01509,0,0,0,32.78594,98.96873l.00852.00156-16.3644,84.16289A28.00192,28.00192,0,0,0,63.80532,207.796l-.00165-.00173L107.03924,160l64.97907-.2602a52,52,0,0,0,0-104Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M223.22831,98.71009l16.351,84.42309A28.00192,28.00192,0,0,1,192.204,207.796l.00166-.00173L149,159.832",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGasPump = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240.9707,69.65625l-19.314-19.31348a8.00018,8.00018,0,1,0-11.31348,11.31446l19.313,19.3125A7.94757,7.94757,0,0,1,232,86.62695V168a8,8,0,0,1-16,0V128a24.0275,24.0275,0,0,0-24-24H176V56a24.0275,24.0275,0,0,0-24-24H72A24.0275,24.0275,0,0,0,48,56V208H32a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16H176V120h16a8.00917,8.00917,0,0,1,8,8v40a24,24,0,0,0,48,0V86.62695A23.84506,23.84506,0,0,0,240.9707,69.65625ZM144,120H80a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "216",
          x2: "192",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.62741a16,16,0,0,0-4.68629-11.3137L216,56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136",
          y1: "112",
          x2: "88",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGauge = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.07227,144.95117a8.00019,8.00019,0,0,1-4.14161-15.45508l22.95557-6.15088A112.20282,112.20282,0,0,0,136,48.28271V72a8,8,0,0,1-16,0V48.29443c-45.14648,3.23975-83.01074,33.69385-97.582,75.13233l22.65137,6.06933a8.0002,8.0002,0,1,1-4.14161,15.45508L18.18945,138.8584A114.064,114.064,0,0,0,16,161.12891V184a16.01833,16.01833,0,0,0,16,16H87.22314L165.48389,98.00879a8.00009,8.00009,0,0,1,12.69384,9.74023L107.39062,200H224a16.01833,16.01833,0,0,0,16-16V160a113.2326,113.2326,0,0,0-1.99658-21.19336Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M24,184V161.12886C24,103.65,70.15361,56.19953,127.63214,56.00066A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "27.54371",
          y1: "133.08282",
          x2: "58.45334",
          y2: "141.36503",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "228.45629",
          y1: "133.08282",
          x2: "197.54666",
          y2: "141.36503",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "103.44553",
          y1: "192.00001",
          x2: "171.83082",
          y2: "102.87856",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGear = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M234.80957,150.40576l-14.87793-19.835c.02246-1.75244.0044-3.62207-.02148-5.11377l14.89257-19.856a8.0008,8.0008,0,0,0,1.32422-6.88476,111.46438,111.46438,0,0,0-10.95068-26.46094,7.99971,7.99971,0,0,0-5.80615-3.93457l-24.48731-3.49707q-1.7981-1.90282-3.70312-3.70361l-3.4961-24.47657a8.00016,8.00016,0,0,0-3.93261-5.80419,111.45413,111.45413,0,0,0-26.45313-10.96729,8.00181,8.00181,0,0,0-6.88818,1.32275L130.62207,36.0376c-1.74414-.04834-3.49316-.04834-5.2373,0l-19.7793-14.83545a8.003,8.003,0,0,0-6.88526-1.32373A111.45813,111.45813,0,0,0,72.25928,30.82861a8.00164,8.00164,0,0,0-3.93506,5.80616L64.82764,61.12158q-1.90211,1.79809-3.70362,3.7041L36.64746,68.32129a7.99959,7.99959,0,0,0-5.8042,3.93213A111.45433,111.45433,0,0,0,19.876,98.70752a7.99838,7.99838,0,0,0,1.32324,6.88769l14.87793,19.835c-.02246,1.75244-.0044,3.62207.02148,5.11377l-14.89258,19.856a8.00086,8.00086,0,0,0-1.32421,6.88477,111.46455,111.46455,0,0,0,10.95068,26.46094,7.99971,7.99971,0,0,0,5.80615,3.93457L61.126,191.17725q1.7981,1.90283,3.70312,3.70361l3.4961,24.47656a8.00016,8.00016,0,0,0,3.93261,5.8042,111.45413,111.45413,0,0,0,26.45313,10.96729,7.9997,7.9997,0,0,0,6.88818-1.32276l19.7876-14.84277c1.74414.04932,3.49316.04932,5.2373,0l19.7793,14.83545a7.99882,7.99882,0,0,0,6.88525,1.32373,111.45806,111.45806,0,0,0,26.46094-10.9502,8.00161,8.00161,0,0,0,3.93506-5.80615l3.50488-24.54541c1.25489-1.22363,2.56348-2.5581,3.60059-3.63135l24.57129-3.50976a7.99959,7.99959,0,0,0,5.8042-3.93213,111.45433,111.45433,0,0,0,10.96728-26.4541A7.9984,7.9984,0,0,0,234.80957,150.40576ZM128.00391,172a44,44,0,1,1,44-44A44.04978,44.04978,0,0,1,128.00391,172Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M183.66087,65.08649a84.52233,84.52233,0,0,1,7.2522,7.2521l27.32234,3.90156A103.36981,103.36981,0,0,1,228.39912,100.801L211.84465,122.8728s.20824,6.83942.00065,10.2547l16.561,22.07863a103.36931,103.36931,0,0,1-10.18033,24.554l-27.31288,3.90133s-4.689,4.98345-7.25071,7.25163l-3.90155,27.32234A103.36971,103.36971,0,0,1,155.2,228.39912l-22.07039-16.55388a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561a103.36914,103.36914,0,0,1-24.554-10.18033l-3.90076-27.31148a84.521,84.521,0,0,1-7.2522-7.25211l-27.32235-3.90155A103.37009,103.37009,0,0,1,27.60186,155.2l16.55447-22.07178s-.20824-6.83942-.00066-10.2547l-16.561-22.07863A103.37,103.37,0,0,1,37.775,76.24087l27.31149-3.90076a84.52233,84.52233,0,0,1,7.2521-7.2522l3.90156-27.32235A103.37019,103.37019,0,0,1,100.801,27.60186l22.0704,16.55388a84.523,84.523,0,0,1,10.25609-.00007l22.07863-16.561a103.37014,103.37014,0,0,1,24.554,10.18033Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGearSix = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M237.46191,104.26611a8.00135,8.00135,0,0,0-3.93554-5.29687L209.75049,85.77051c-1.31592-2.55078-2.75391-5.04639-4.29981-7.46094l.458-27.2124a8.00049,8.00049,0,0,0-2.62158-6.05811A111.13811,111.13811,0,0,0,162.17773,21.3418a8.00131,8.00131,0,0,0-6.55468.75927l-23.31836,13.9917c-2.86865-.13672-5.75-.13916-8.61133-.00683L100.35547,22.08252a8.003,8.003,0,0,0-6.55762-.75879A111.15557,111.15557,0,0,0,52.7207,45.07715a8.00055,8.00055,0,0,0-2.61963,6.05664l.45752,27.18994c-1.55078,2.41455-2.99365,4.90869-4.31152,7.4541l-23.7959,13.21a8.0003,8.0003,0,0,0-3.93555,5.29932,111.13522,111.13522,0,0,0,.03223,47.45068,8.00135,8.00135,0,0,0,3.93555,5.29688L46.25928,170.2334c1.31592,2.55078,2.7539,5.04639,4.2998,7.46094l-.458,27.2124a8.00053,8.00053,0,0,0,2.62159,6.0581A111.13809,111.13809,0,0,0,93.832,234.66211a8.00177,8.00177,0,0,0,6.55469-.75928l23.31836-13.9917c2.86816.13623,5.749.13867,8.61133.00684l23.33789,14.00342a8.00237,8.00237,0,0,0,6.55761.75879,111.15549,111.15549,0,0,0,41.07715-23.75342,8.00052,8.00052,0,0,0,2.61963-6.05664l-.45752-27.18994c1.55078-2.41455,2.99365-4.9087,4.31153-7.45411l23.79589-13.21a8.0002,8.0002,0,0,0,3.93555-5.29931A111.13527,111.13527,0,0,0,237.46191,104.26611ZM172.0049,128.002a44,44,0,1,1-44-44A44.04972,44.04972,0,0,1,172.0049,128.002Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128.00098",
          cy: "128.00195",
          r: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M197.40626,80.65057a83.91174,83.91174,0,0,1,6.28744,10.91L229.64,105.964a103.88962,103.88962,0,0,1,.03183,44.05764L203.71112,164.433a83.912,83.912,0,0,1-6.30466,10.90011l.49943,29.67182a103.88959,103.88959,0,0,1-38.13912,22.05638l-25.46093-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.2669,227.04288a103.88979,103.88979,0,0,1-38.171-22.00126l.49974-29.68828a83.91052,83.91052,0,0,1-6.28743-10.91005L26.362,150.0399a103.88962,103.88962,0,0,1-.03182-44.05764L52.29083,91.5709a83.9124,83.9124,0,0,1,6.30466-10.9001L58.09606,50.999A103.88973,103.88973,0,0,1,96.23518,28.94259l25.46094,15.27693a83.91075,83.91075,0,0,1,12.5921.00995L159.73505,28.961a103.88943,103.88943,0,0,1,38.171,22.00126Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGenderFemale = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,96a80,80,0,1,0-88,79.59912V200H88a8,8,0,0,0,0,16h32v24a8,8,0,0,0,16,0V216h32a8,8,0,0,0,0-16H136V175.59912A80.1104,80.1104,0,0,0,208,96ZM64,96a64,64,0,1,1,64,64A64.07239,64.07239,0,0,1,64,96Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "208",
          x2: "168",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGenderIntersex = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.96008,23.20947c-.01111-.11377-.03271-.22412-.04858-.33642-.02063-.146-.038-.29248-.06677-.4375-.02588-.13086-.06214-.2583-.09449-.38721-.03112-.124-.05835-.24854-.09545-.37158-.03846-.12647-.08594-.24854-.13038-.37256-.04394-.12256-.08435-.24609-.13427-.3667-.04785-.11523-.104-.22559-.157-.33838-.05835-.124-.11364-.249-.17871-.3706-.05774-.10791-.12353-.21-.186-.31495-.07105-.11914-.13867-.24023-.21655-.35644-.07593-.11328-.16065-.22022-.242-.3291-.0747-.1001-.14429-.20264-.22436-.3003-.1521-.18505-.31372-.36181-.48169-.53271-.0166-.01709-.0304-.03564-.04712-.05225-.01929-.01953-.04077-.03515-.0603-.05468-.16846-.165-.34253-.32422-.525-.47413-.09424-.07763-.19372-.145-.29053-.21728-.1123-.084-.22229-.1709-.339-.249-.11242-.0752-.229-.14063-.34423-.20948-.10913-.06494-.21582-.1333-.32813-.19384-.115-.06153-.23328-.11329-.35058-.16895-.11963-.05664-.23755-.11621-.36036-.167-.11071-.0459-.22387-.08252-.33618-.123-.13415-.04883-.267-.09961-.40429-.1416-.1084-.03223-.21851-.05615-.32789-.084-.14331-.03663-.28515-.07666-.43151-.10547-.12085-.02393-.2428-.03711-.36451-.05567-.13659-.02051-.27136-.04541-.41-.05908-.2019-.01953-.40442-.02588-.60693-.03076C208.11768,16.00781,208.05981,16,208,16H168a8,8,0,0,0,0,16h20.686L164.2522,56.43359A67.97437,67.97437,0,1,0,112,175.51367V196H88a8,8,0,0,0,0,16h24v20a8,8,0,0,0,16,0V212h24a8,8,0,0,0,0-16H128V175.51367A67.9301,67.9301,0,0,0,175.09692,68.2168L200,43.314V64a8,8,0,0,0,16,0V24.00244C216,23.73779,215.98608,23.47314,215.96008,23.20947ZM120,160a52,52,0,1,1,52-52A52.059,52.059,0,0,1,120,160Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "120",
          cy: "108",
          r: "60",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "204",
          x2: "152",
          y2: "204",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "168 24 208 24 208 64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "164.37913",
          y1: "67.62087",
          x2: "208",
          y2: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGenderMale = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.96008,39.20947c-.01111-.11377-.03271-.22412-.04858-.33642-.02063-.146-.038-.29248-.06677-.4375-.02588-.13086-.06214-.2583-.09449-.38721-.03112-.124-.05835-.24854-.09545-.37158-.03846-.12647-.08594-.24854-.13038-.37256-.04394-.12256-.08435-.24609-.13427-.3667-.04785-.11523-.104-.22559-.157-.33838-.05835-.124-.11364-.249-.17871-.3706-.05774-.10791-.12353-.21-.186-.315-.07105-.11914-.13867-.24023-.21655-.35644-.07593-.11328-.16065-.22022-.242-.3291-.0747-.1001-.14429-.20264-.22436-.3003-.1521-.185-.31372-.36181-.48169-.53271-.0166-.01709-.0304-.03564-.04712-.05225-.019-.019-.04-.03466-.05908-.05322-.16895-.16553-.34351-.32568-.52662-.47607-.0913-.07471-.1875-.14014-.28125-.21-.1156-.08692-.22888-.17627-.34924-.25684-.10754-.07227-.21936-.13428-.32971-.2002-.114-.06884-.22595-.14013-.34363-.20312-.109-.05811-.22131-.10742-.3324-.16016-.12573-.06006-.24975-.12207-.37915-.17578-.10327-.04248-.209-.07666-.31372-.11474-.1416-.05176-.2821-.10547-.42736-.14942-.09778-.02978-.197-.05029-.29554-.07617-.15417-.04-.30737-.08252-.46484-.11328-.10376-.02051-.20874-.03174-.31323-.04785-.15284-.02393-.30445-.05127-.46021-.06641-.15869-.01562-.31787-.01807-.477-.02441C216.20215,32.01172,216.10254,32,216,32H168a8,8,0,0,0,0,16h28.68591L154.62817,90.05762a80.001,80.001,0,1,0,11.31385,11.314L208,59.314V88a8,8,0,0,0,16,0V40.00244C224,39.73779,223.98608,39.47314,223.96008,39.20947Zm-74.7052,158.04541a63.96974,63.96974,0,1,1,0-90.50976A64.07169,64.07169,0,0,1,149.25488,197.25488Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "104",
          cy: "152",
          r: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "154.91169",
          y1: "101.08831",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGenderNeuter = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,104a80,80,0,1,0-88,79.59912V232a8,8,0,0,0,16,0V183.59912A80.1104,80.1104,0,0,0,208,104Zm-80,64a64,64,0,1,1,64-64A64.07239,64.07239,0,0,1,128,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGenderNonbinary = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,88.42383V59.01465l23.25049,15.625a7.99987,7.99987,0,1,0,8.9248-13.2793L142.34253,44l25.83276-17.36035a7.99987,7.99987,0,1,0-8.9248-13.2793L128,34.36133l-31.25049-21.001a7.99987,7.99987,0,1,0-8.9248,13.2793L113.65747,44,87.82471,61.36035a7.99987,7.99987,0,1,0,8.9248,13.2793L120,59.01465V88.42383a76,76,0,1,0,16,0ZM128,224a60,60,0,1,1,60-60A60.06812,60.06812,0,0,1,128,224Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "164",
          r: "68",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "163.71281",
          y1: "68",
          x2: "92.28719",
          y2: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "92.28719",
          y1: "68",
          x2: "163.71281",
          y2: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "44.00003",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGenderTransgender = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.96008,39.20947c-.01111-.11377-.03271-.22412-.04858-.33642-.02063-.146-.038-.29248-.06677-.4375-.02588-.13086-.06214-.2583-.09449-.38721-.03112-.124-.05835-.24854-.09545-.37158-.03846-.12647-.08594-.24854-.13038-.37256-.04394-.12256-.08435-.24609-.13427-.3667-.04785-.11523-.104-.22559-.157-.33838-.05835-.124-.11364-.249-.17871-.3706-.05774-.10791-.12353-.21-.186-.315-.07105-.11914-.13867-.24023-.21655-.35644-.07593-.11328-.16065-.22022-.242-.3291-.0747-.1001-.14429-.20264-.22436-.3003-.1521-.185-.31372-.36181-.48169-.53271-.0166-.01709-.0304-.03564-.04712-.05225-.01929-.01953-.04077-.03515-.0603-.05468-.16846-.165-.34253-.32422-.525-.47413-.09424-.07763-.19372-.145-.29053-.21728-.1123-.084-.22229-.1709-.339-.249-.11242-.0752-.229-.14063-.34423-.20948-.10913-.06494-.21582-.1333-.32813-.19384-.115-.06153-.23328-.11329-.35058-.16895-.11963-.05664-.23755-.11621-.36036-.167-.11071-.0459-.22387-.08252-.33618-.12305-.13415-.04883-.267-.09961-.40429-.1416-.1084-.03223-.21851-.05615-.32789-.084-.14331-.03663-.28515-.07666-.43151-.10547-.12085-.02393-.2428-.03711-.36451-.05567-.13659-.02051-.27136-.04541-.41-.05908-.2019-.01953-.40442-.02588-.60693-.03076C216.11768,32.00781,216.05981,32,216,32H168a8,8,0,0,0,0,16h28.686L168,76.686,149.65674,58.34277a8.00018,8.00018,0,0,0-11.31348,11.31446L156.686,88l-15.75293,15.75293a71.99442,71.99442,0,1,0,11.31567,11.3125L168,99.314l18.34326,18.34327a8.00018,8.00018,0,0,0,11.31348-11.31446L179.314,88,208,59.314V88a8,8,0,0,0,16,0V40.00244C224,39.73779,223.98608,39.47314,223.96008,39.20947ZM135.59814,199.59766A55.99961,55.99961,0,1,1,152,160,56.06457,56.06457,0,0,1,135.59814,199.59766Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "96",
          cy: "160",
          r: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "141.25483",
          y1: "114.74517",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "64",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGhost = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24.00006A96.10871,96.10871,0,0,0,32,120v95.99994a7.9995,7.9995,0,0,0,13.06543,6.19141l24.26758-19.855,24.26855,19.855a8,8,0,0,0,10.13184,0L128,202.33638l24.2666,19.855a7.99878,7.99878,0,0,0,10.13184,0l24.26855-19.855,24.26758,19.855A7.9995,7.9995,0,0,0,224,215.99994V120A96.10871,96.10871,0,0,0,128,24.00006ZM100,128a12,12,0,1,1,12-12A12,12,0,0,1,100,128Zm56,0a12,12,0,1,1,12-12A12,12,0,0,1,156,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "100",
          cy: "116",
          r: "12"
        }), React.createElement("circle", {
          cx: "156",
          cy: "116",
          r: "12"
        }), React.createElement("path", {
          d: "M216,216l-29.33333-24-29.33334,24L128,192,98.66667,216,69.33333,192,40,216V120a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGif = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M136,64a8.00039,8.00039,0,0,0-8,8V184a8,8,0,0,0,16,0V72A8.00039,8.00039,0,0,0,136,64Z"
        }), React.createElement("path", {
          d: "M228,64H180a8.00039,8.00039,0,0,0-8,8V184a8,8,0,0,0,16,0V136h28a8,8,0,0,0,0-16H188V80h40a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M96,120H72a8,8,0,0,0,0,16H88v16a24,24,0,0,1-48,0V104a24.00492,24.00492,0,0,1,47.24512-6.00586,7.99961,7.99961,0,1,0,15.49414-3.98828A40.00446,40.00446,0,0,0,24,104v48a40,40,0,0,0,80,0V128A8.00039,8.00039,0,0,0,96,120Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "136",
          y1: "72",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "228 72 180 72 180 184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,128H96v24a32,32,0,0,1-64,0V104a32.0045,32.0045,0,0,1,62.99185-8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGift = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,72H181.03271a31.99968,31.99968,0,0,0-47.37646-42.91162A30.99155,30.99155,0,0,0,128,37.2998a31.01227,31.01227,0,0,0-5.65723-8.21191A31.99948,31.99948,0,0,0,74.96729,72H40A16.01817,16.01817,0,0,0,24,88v32a16.01817,16.01817,0,0,0,16,16v64a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V136a16.01817,16.01817,0,0,0,16-16V88A16.01817,16.01817,0,0,0,216,72ZM144.96973,40.4021a16.00019,16.00019,0,1,1,22.62793,22.62744c-4.94043,4.94116-19.22559,7.71582-31.25684,8.6294C137.25488,59.62671,140.0293,45.34277,144.96973,40.4021Zm-56.56836,0a16.0194,16.0194,0,0,1,22.62793-.00024c4.9414,4.94116,7.71582,19.22631,8.62988,31.25683-12.03223-.91382-26.31641-3.68848-31.25684-8.62915A16.01925,16.01925,0,0,1,88.40137,40.4021ZM216,120H136v72a8,8,0,0,1-16,0V120H40V88h80v32h16V88h80l.00977,31.99951Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "80",
          width: "192",
          height: "48",
          rx: "7.99999",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M173.25483,68.68629C161.94113,80,128,80,128,80s0-33.94113,11.31371-45.25483a24,24,0,0,1,33.94112,33.94112Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M82.74517,68.68629C94.05887,80,128,80,128,80s0-33.94113-11.31371-45.25483A24,24,0,0,0,82.74517,68.68629Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGitBranch = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.00049,67.99756a36,36,0,1,0-44,35.09289v.9076a16.01865,16.01865,0,0,1-16,16l-72.001.00146a31.80375,31.80375,0,0,0-15.999,4.29444v-21.2035a36,36,0,1,0-16,0V152.9071a36,36,0,1,0,16,0v-.90759a16.01844,16.01844,0,0,1,15.999-16l72.001-.00146a32.0373,32.0373,0,0,0,32-32v-.9076A36.05514,36.05514,0,0,0,224.00049,67.99756Zm-176,0a20,20,0,1,1,20,20A20.0226,20.0226,0,0,1,48.00049,67.99756ZM88.00049,188a20,20,0,1,1-20-20A20.0226,20.0226,0,0,1,88.00049,188Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188",
          cy: "67.99756",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "68",
          cy: "67.99756",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M68,160v-8.00018a23.99955,23.99955,0,0,1,23.99951-23.99909l72.001-.00146A23.99955,23.99955,0,0,0,188,104.00018V96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGitCommit = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248.00244,120H187.45312a59.98446,59.98446,0,0,0-118.90136,0H8.00244a8,8,0,0,0,0,16H68.55176a59.98446,59.98446,0,0,0,118.90136,0h60.54932a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128.00244",
          cy: "128",
          r: "52",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "8.00244",
          y1: "128",
          x2: "76.00244",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "180.00244",
          y1: "128",
          x2: "248.00244",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGitDiff = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M204.002,152.907l-.00146-33.02612a55.63313,55.63313,0,0,0-16.40137-39.5957L163.31445,56h20.686a8,8,0,0,0,0-16h-40c-.14893,0-.29444.01416-.44141.02222-.11133.0061-.22314.00622-.334.017-.17188.01648-.33985.046-.50879.07325-.08789.01428-.17725.02331-.26514.04052-.168.033-.33105.0774-.49512.12073-.08837.02319-.17773.042-.26562.06824-.15283.046-.30078.10229-.44971.1571-.09717.03589-.1958.06739-.29248.10718-.13428.05542-.26318.12-.39355.1825-.10694.0509-.21485.098-.31934.15393-.1206.06421-.23486.1372-.35107.20727-.1084.06494-.21826.12586-.32373.19641-.11768.079-.229.16675-.34229.25159-.09668.07239-.19629.13965-.29.2168-.1499.123-.291.25586-.43115.3894-.05029.04773-.10449.08936-.15381.13867-.05957.05945-.10986.12415-.167.18506-.12207.12964-.24512.2583-.3584.396-.09424.115-.17773.236-.26514.355-.06689.09106-.13769.179-.20068.273-.0874.13037-.16406.26538-.24268.39941-.05322.09058-.11084.17871-.16064.27149-.07129.13281-.13184.26928-.19482.405-.04737.10168-.09864.20117-.14161.30517-.05419.13013-.09814.26318-.145.39551-.04052.1145-.085.22729-.12011.34424-.04.13208-.06983.26611-.103.3999-.02978.11987-.06348.238-.08789.36011-.03076.15429-.04981.31006-.07129.4657-.01416.10327-.03418.20459-.04443.30908q-.03955.39752-.04.79736V88a8,8,0,0,0,16,0V67.31482l24.28418,24.28479a39.731,39.731,0,0,1,11.71582,28.28125l.00146,33.02637a35.99994,35.99994,0,1,0,16-.00025Z"
        }), React.createElement("path", {
          d: "M112.00244,160a8.00039,8.00039,0,0,0-8,8v20.68555L79.71728,164.40039a39.73582,39.73582,0,0,1-11.71582-28.28125l-.001-33.02624a35.99974,35.99974,0,1,0-16,.00012l.001,33.0271a55.63733,55.63733,0,0,0,16.40137,39.59472L92.688,200H72.00244a8,8,0,1,0,0,16h40c.26367,0,.52734-.014.78955-.03992.11817-.01159.23242-.03369.34912-.05041.1416-.02027.28418-.03687.42481-.0647.13281-.02637.26123-.06274.3916-.0957.123-.03076.24658-.05786.36816-.09473.12647-.03833.24854-.08569.37207-.13.12305-.04395.24659-.0846.36768-.13465.11328-.047.22168-.10217.332-.15405.127-.05957.2544-.116.37842-.18237.10205-.05481.19922-.11731.29834-.17627.12549-.07422.25146-.14527.37353-.22681.10352-.06946.20069-.14722.30078-.22119.10987-.0813.22168-.158.32813-.24561.144-.11792.27881-.246.41406-.37353.05518-.05249.11475-.09851.169-.15283.05664-.0564.10449-.11792.15869-.17554.12549-.13281.251-.26538.36719-.40649.09131-.11072.17138-.22718.25537-.34156.07031-.0957.14453-.188.21094-.28686.085-.12659.15917-.25782.23583-.38806.05567-.09436.11524-.18616.167-.28309.06933-.12915.12842-.26184.18994-.39379.04931-.10547.10205-.20874.147-.31665.05225-.12647.09522-.25562.14063-.38428.042-.11817.0874-.2345.124-.35523.03906-.1289.06787-.25976.10059-.39013.03076-.12305.06543-.24414.09033-.36939.02978-.15137.04834-.30444.06933-.457.01465-.106.03516-.21.0459-.31714q.03956-.39769.04-.79712V168A8.00039,8.00039,0,0,0,112.00244,160Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "196.00244",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M196.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L144,48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "144 88 144 48 184 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "60",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M60,96l.00163,40.11889a48,48,0,0,0,14.05888,33.93918L112.00244,208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "112.002 168 112.002 208 72.002 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGitFork = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.00049,67.99756a36,36,0,1,0-44,35.09289v.9076a16.01865,16.01865,0,0,1-16,16l-72,.00146a15.99994,15.99994,0,0,1-16-16v-.90906a36,36,0,1,0-16,0v.90906a31.99909,31.99909,0,0,0,32,32L120.002,135.999l-.001,16.908a35.99993,35.99993,0,1,0,16,.00019l.001-16.90857,27.99854-.00055a32.0373,32.0373,0,0,0,32-32v-.9076A36.05514,36.05514,0,0,0,224.00049,67.99756ZM148.00049,188a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148.00049,188Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188",
          cy: "67.99756",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "68",
          cy: "67.99756",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M68,95.99756v8.002a24,24,0,0,0,24.00049,24l72-.00146a24,24,0,0,0,23.99951-24V95.99756",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128.00244",
          y1: "128",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGitMerge = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M187.99268,104a36.04766,36.04766,0,0,0-35.77247,32h-21.748a39.89636,39.89636,0,0,1-30.72949-14.39258L82.51123,100.93005a35.99422,35.99422,0,1,0-22.52148,2.16285v49.8142a36,36,0,1,0,16,0V118.09668l11.46191,13.75293A55.84986,55.84986,0,0,0,130.47217,152h23.585a35.99769,35.99769,0,1,0,33.93555-48ZM87.98975,188a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,87.98975,188Zm100.00293-28a20,20,0,1,1,20-20A20.02229,20.02229,0,0,1,187.99268,160Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188.00244",
          cy: "140",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M160.00244,144H130.482a48,48,0,0,1-36.87462-17.27115L68,96v64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGitPullRequest = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M104.00049,68a36,36,0,1,0-44,35.0929v49.8142a36,36,0,1,0,16,0V103.0929A36.05516,36.05516,0,0,0,104.00049,68Zm-16,120a20,20,0,1,1-20-20A20.0226,20.0226,0,0,1,88.00049,188Z"
        }), React.createElement("path", {
          d: "M196.002,152.907l-.00146-33.02563a55.63508,55.63508,0,0,0-16.40137-39.59619L155.31445,56h20.686a8,8,0,0,0,0-16h-40c-.01563,0-.03028.00226-.0459.00232-.24756.0014-.49463.01318-.74121.03747-.12842.01252-.25293.0362-.3794.05469-.13086.01929-.2622.03418-.39257.05994-.145.02862-.28516.068-.42725.10431-.11035.02826-.22168.052-.33057.085-.14013.04224-.2749.0943-.41162.14386-.10937.03961-.21972.07538-.32763.12-.12745.05268-.24952.11432-.37354.17328-.11279.05347-.22656.10328-.33691.16236-.11914.0636-.23243.13574-.34766.20508-.1084.0653-.21875.12652-.3252.19751-.12353.08264-.23974.17443-.35839.26367-.09082.06823-.18409.1311-.27246.20361-.1875.15381-.36622.31714-.53907.487-.01562.0152-.03222.02783-.04785.04315-.02051.02051-.0376.04321-.05762.06391-.16357.16711-.32177.33941-.47021.52032-.083.10059-.15527.20648-.23193.31006-.07862.10571-.16065.20862-.23438.3183-.08057.12072-.15088.24591-.22461.36993-.05957.1-.12207.19757-.17724.30036-.06788.12591-.125.25531-.18506.384-.05078.1084-.10547.21466-.15137.32568-.05127.12463-.09326.25189-.13867.37848-.04248.11987-.08887.238-.126.36047-.03857.12775-.06738.25757-.09912.38678-.03125.124-.06592.24622-.09131.37244-.02978.15088-.04785.30328-.06933.45544-.01465.10645-.03516.21094-.0459.31867q-.03955.39752-.04.79706V88a8,8,0,0,0,16,0V67.31415l24.28418,24.28448a39.73874,39.73874,0,0,1,11.71582,28.28321l.00146,33.02533a36.00007,36.00007,0,1,0,16-.00019Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188.00244",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M188.00244,160l-.00163-40.11889a48,48,0,0,0-14.05888-33.93918L136,48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "136 88 136 48 176 48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGithubLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,224a8.00039,8.00039,0,0,1-8,8,32.03667,32.03667,0,0,1-32-32v-8a16.01833,16.01833,0,0,0-16-16H156v40a16.01833,16.01833,0,0,0,16,16,8,8,0,0,1,0,16,32.03667,32.03667,0,0,1-32-32V176H116v40a32.03667,32.03667,0,0,1-32,32,8,8,0,0,1,0-16,16.01833,16.01833,0,0,0,16-16V176H88a16.01833,16.01833,0,0,0-16,16v8a32.03667,32.03667,0,0,1-32,32,8,8,0,0,1,0-16,16.01833,16.01833,0,0,0,16-16v-8a31.9949,31.9949,0,0,1,14.78076-26.95068A55.951,55.951,0,0,1,48,120v-8a58.0419,58.0419,0,0,1,7.69482-28.32031A59.73551,59.73551,0,0,1,61.07178,36,7.99908,7.99908,0,0,1,68,32a59.74952,59.74952,0,0,1,48.00732,23.999L139.99219,56A59.74792,59.74792,0,0,1,188,32a7.99908,7.99908,0,0,1,6.92822,4,59.73339,59.73339,0,0,1,5.37647,47.67969A58.04124,58.04124,0,0,1,208,112v8a55.951,55.951,0,0,1-22.78076,45.04932A31.9949,31.9949,0,0,1,200,192v8a16.01833,16.01833,0,0,0,16,16A8.00039,8.00039,0,0,1,224,224Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M84,240a24,24,0,0,0,24-24V168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M172,240a24,24,0,0,1-24-24V168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,168h16a24,24,0,0,1,24,24v8a24,24,0,0,0,24,24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M104,168H88a24,24,0,0,0-24,24v8a24,24,0,0,1-24,24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M111.825,63.99934A51.9599,51.9599,0,0,0,68,40a51.90058,51.90058,0,0,0-3.48841,44.7036A49.25789,49.25789,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.25769,49.25769,0,0,0-8.5116-27.29639A51.90061,51.90061,0,0,0,188,40a51.95992,51.95992,0,0,0-43.82535,23.99983Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGitlabLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M238.28027,152.50246,210.95068,50.01662a12.00021,12.00021,0,0,0-22.83056-1.12109L167.45605,104H88.544L67.87988,48.89651a12.00012,12.00012,0,0,0-22.831,1.12109L17.71973,152.50246a16.03981,16.03981,0,0,0,6.35254,17.27783l94.82031,65.64454a15.91589,15.91589,0,0,0,7.093,2.69336c.22131.03808.44567.05517.67065.0747.09387.00781.1875.01514.28149.02149.13526.00683.26807.03076.40406.03076.06445,0,.12939-.00733.19409-.00879.15478.00439.30932.01709.46411.01709s.30933-.0127.46411-.01709c.0647.00146.12964.00879.19409.00879.13587,0,.26831-.02393.40345-.03076q.1419-.00952.2832-.02149c.22436-.02.44812-.03662.66882-.0747a15.91868,15.91868,0,0,0,7.09375-2.69336l94.82031-65.64454A16.03981,16.03981,0,0,0,238.28027,152.50246ZM33.17969,156.625,42.94617,120H77.45605l34.07544,90.86865Zm111.28882,54.24365L178.544,120h34.50988l9.76648,36.625Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("g", null, React.createElement("polyline", {
          points: "128.659 230.243 173 112 219.2 112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "36.8 112 83 112 83 112 127.341 230.243",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        })));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGitlabLogoSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.92773,169.78029l-94.82031,65.64454a16.07612,16.07612,0,0,1-18.21484,0L24.07227,169.78029a16.03981,16.03981,0,0,1-6.35254-17.27783L45.04883,50.0176a12.00012,12.00012,0,0,1,22.831-1.12109L88.544,104h78.9121l20.66407-55.10449a12.00021,12.00021,0,0,1,22.83056,1.12109l27.32959,102.48584A16.03981,16.03981,0,0,1,231.92773,169.78029Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M83,112h90l22.61071-60.29524a4,4,0,0,1,7.61026.37384l27.32935,102.4851a8,8,0,0,1-3.1762,8.63883l-94.82044,65.64492a8,8,0,0,1-9.10736,0L28.62588,163.20255a8,8,0,0,1-3.1762-8.63883L52.779,52.07862a4,4,0,0,1,7.61026-.37384Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGlobe = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M225.86035,163.20862a7.94949,7.94949,0,0,0,.373-1.05676,104.00629,104.00629,0,0,0-.01026-68.33094,7.96,7.96,0,0,0-.35546-1.00793A104.17669,104.17669,0,0,0,128.042,24.00086L128,23.96423l-.042.03663A104.17672,104.17672,0,0,0,30.13623,92.80164a7.94362,7.94362,0,0,0-.36475,1.03454,104.00383,104.00383,0,0,0,.01319,68.36658,7.975,7.975,0,0,0,.34179.968,104.17624,104.17624,0,0,0,97.83057,68.8291l.043.0376.043-.0376A104.1768,104.1768,0,0,0,225.86035,163.20862ZM128,45.559a110.409,110.409,0,0,1,25.52246,42.44141H102.47754A110.409,110.409,0,0,1,128,45.559ZM102.478,168.00037H153.522A110.41425,110.41425,0,0,1,128,210.44177,110.41425,110.41425,0,0,1,102.478,168.00037Zm-4.18848-16a126.93369,126.93369,0,0,1,0-48h59.4209a126.93369,126.93369,0,0,1,0,48Zm75.73877-48h38.645a88.23665,88.23665,0,0,1,0,48h-38.645a147.05417,147.05417,0,0,0,0-48Zm32.34375-16H170.40771A127.43992,127.43992,0,0,0,146.2749,41.91406,88.31787,88.31787,0,0,1,206.37207,88.00037ZM146.27441,214.08679a127.44456,127.44456,0,0,0,24.13282-46.08642h35.96484A88.31753,88.31753,0,0,1,146.27441,214.08679Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "37.46679",
          y1: "96",
          x2: "218.53174",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "37.47057",
          y1: "160",
          x2: "218.53448",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.42294",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGlobeHemisphereEast = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.4873,169.18066a7.96262,7.96262,0,0,0,.49805-1.166A103.91753,103.91753,0,0,0,187.772,42.94336a8.06306,8.06306,0,0,0-1.13965-.79053A103.94567,103.94567,0,0,0,42.61768,187.31152c.04.07129.07324.145.11572.21582a7.9667,7.9667,0,0,0,.80664,1.08985A103.847,103.847,0,0,0,191.2627,210.48242a7.98,7.98,0,0,0,1.40283-1.0957A104.572,104.572,0,0,0,223.4873,169.18066ZM61.48,185.55664l3.91345-2.362A16.00133,16.00133,0,0,0,73.126,169.585l.18967-33.81841a8.0001,8.0001,0,0,1,1.25578-4.2583L88.60582,109.513a8,8,0,0,1,11.43777-2.17522l12.78356,9.26186a15.95634,15.95634,0,0,0,11.53418,2.89844l31.48144-4.26367a15.99269,15.99269,0,0,0,9.94971-5.38477L187.94873,84.25A15.92874,15.92874,0,0,0,191.833,73.01074l-.2793-5.813a87.914,87.914,0,0,1,21.28272,84.187l-15.93116-14.57032a16.05451,16.05451,0,0,0-16.939-2.96777l-30.45166,12.65723a15.99852,15.99852,0,0,0-9.68738,12.44255l-2.38489,16.19612a15.98468,15.98468,0,0,0,11.76807,17.80762l21.4585,5.63085,3.98828,3.9961A87.85932,87.85932,0,0,1,61.48,185.55664Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M49.58637,183.394l11.67782-7.04953a8,8,0,0,0,3.86546-6.80393l.2028-36.12908a7.99993,7.99993,0,0,1,1.25581-4.2583L86.43083,98.05553a8,8,0,0,1,11.43769-2.17521l19.6558,14.24066a8,8,0,0,0,5.76724,1.44922l31.48043-4.2633a8,8,0,0,0,4.97543-2.69227l22.15711-25.60081a8,8,0,0,0,1.94172-5.61949L182.678,49.09089",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M187.06688,203.68283l-10.73163-10.75292a8,8,0,0,0-3.6318-2.08674L151.245,185.21189a8,8,0,0,1-5.884-8.90337l2.38477-16.19606a8,8,0,0,1,4.84416-6.22191l30.45053-12.65666a8,8,0,0,1,8.46961,1.48392l24.8944,22.768",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGlobeHemisphereWest = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.59668,173.31348A103.97882,103.97882,0,0,0,154.84473,27.51953c-.18018-.05615-.36231-.10449-.5459-.14795A103.90813,103.90813,0,0,0,60.3916,49.041a7.94439,7.94439,0,0,0-1.33545,1.168A103.94993,103.94993,0,0,0,128,232c.73584,0,1.46875-.0127,2.20117-.02783.01807,0,.03613.00244.05371.00244.03516,0,.06885-.00391.10352-.0044A104.12933,104.12933,0,0,0,220.96387,174.585l.01465-.02148A7.967,7.967,0,0,0,221.59668,173.31348ZM216,128a87.57766,87.57766,0,0,1-5.53125,30.70654L164.06836,130.168a15.90244,15.90244,0,0,0-6.24365-2.22656l-22.81836-3.07618a16.10781,16.10781,0,0,0-15.32178,6.81446h-8.543l-3.80469-7.86035A16.00216,16.00216,0,0,0,96.295,115.14608l-6.5655-1.41073,2.51745-5.97658a8,8,0,0,1,7.37265-4.89451H115.6543a16.02745,16.02745,0,0,0,7.73437-1.99414l12.24317-6.76074a16.03672,16.03672,0,0,0,2.99609-2.1377l26.91064-24.33789a15.90675,15.90675,0,0,0,4.4336-16.96289A88.07506,88.07506,0,0,1,216,128ZM40,128a87.46223,87.46223,0,0,1,9.46094-39.665l10.42334,27.82031a15.93042,15.93042,0,0,0,11.6206,10.02735l5.5127,1.18506.04541.00976,12.05371,2.591a8,8,0,0,1,5.51942,4.33553l2.10451,4.34726a16.00022,16.00022,0,0,0,14.40146,9.02849H112.251l-7.69532,17.26758a15.98365,15.98365,0,0,0,2.86622,17.375l16.05,17.36021a8,8,0,0,1,1.98025,6.95l-1.791,9.25958A88.10889,88.10889,0,0,1,40,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M214.16458,170.37222l-54.28632-33.38846a7.99993,7.99993,0,0,0-3.12236-1.114l-22.81867-3.07595a8,8,0,0,0-8.37592,4.67178l-13.69878,30.73831a8,8,0,0,0,1.433,8.68736l18.79995,20.33464a8,8,0,0,1,1.98022,6.9502l-3.8294,19.79638",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M64.95216,55.60635,56.00794,76.75607a8,8,0,0,0-.12321,5.92293l11.49086,30.66819a8,8,0,0,0,5.81037,5.01448l21.42993,4.60592a8,8,0,0,1,5.5197,4.3358l3.80564,7.862a8,8,0,0,0,7.20075,4.51442h13.43256",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152.45823,35.14852l9.33366,16.7184a8,8,0,0,1-1.6191,9.83314L133.26192,86.0376a8.00033,8.00033,0,0,1-1.49868,1.06968l-12.24176,6.76034a8,8,0,0,1-3.86737.9969H94.30873a8,8,0,0,0-7.37259,4.89437l-8.32721,19.76833",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGlobeSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,128.00037A104.11767,104.11767,0,0,0,128.042,24.00086L128,23.96423l-.042.03663a103.99952,103.99952,0,0,0-.001,207.999l.043.0376.043-.0376A104.11763,104.11763,0,0,0,232,128.00037Zm-16.36768-8h-39.853c-1.5918-29.637-12.01123-57.01758-29.5044-78.08643A88.1919,88.1919,0,0,1,215.63232,120.00037Zm-119.37353,16h63.48242C157.93164,164.75623,146.44678,191.703,128,210.44177,109.55322,191.703,98.06836,164.75623,96.25879,136.00037Zm0-16C98.06836,91.24353,109.55322,64.29675,128,45.559c18.44678,18.73779,29.93164,45.68457,31.74121,74.44141Zm50.01562,94.08642c17.49317-21.06933,27.9126-48.45044,29.50489-78.08642h39.853A88.19181,88.19181,0,0,1,146.27441,214.08679Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.42294",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGlobeStand = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "95.99316",
          r: "80"
        }), React.createElement("path", {
          d: "M207.19629,175.18945A8.00052,8.00052,0,0,0,195.88184,163.875,95.99942,95.99942,0,1,1,60.11816,28.11133,8.00052,8.00052,0,0,0,48.80371,16.79688,112.00314,112.00314,0,0,0,120,207.71v16.2832H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V207.71A111.16718,111.16718,0,0,0,207.19629,175.18945Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "95.99353",
          r: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M201.53911,169.53264A104,104,0,0,1,54.46089,22.45443",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "231.99353",
          x2: "160",
          y2: "231.99353",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "199.99353",
          x2: "128",
          y2: "231.99353",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGoogleLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm0,184A80,80,0,1,1,184.56836,71.43164a7.99984,7.99984,0,1,1-11.31348,11.31348A63.99718,63.99718,0,1,0,191.50244,136H128a8,8,0,0,1,0-16h72a8.00008,8.00008,0,0,1,8,8A80.09041,80.09041,0,0,1,128,208Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,128h88a88,88,0,1,1-25.77461-62.2254",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGooglePlayLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.63476,114.18213l-167.7832-96.04a15.98949,15.98949,0,0,0-16.123.0459,15.66312,15.66312,0,0,0-7.915,13.66846v192.2871a15.66312,15.66312,0,0,0,7.915,13.66846,15.98874,15.98874,0,0,0,16.12305.0459l167.7832-96.04a15.76194,15.76194,0,0,0,0-27.63574ZM144,139.31348l18.85644,18.85644L74.666,208.64746ZM74.65478,47.34082,162.85742,97.8291,144,116.68652ZM177.24707,149.93359,155.31348,128l21.93457-21.93408L215.56738,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M39.8134,224.14386a8.01831,8.01831,0,0,0,12.06378,6.771L219.71391,134.8442a7.763,7.763,0,0,0,0-13.6884L51.87718,25.08518a8.01831,8.01831,0,0,0-12.06378,6.771Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "42.23444",
          y1: "26.23444",
          x2: "175.91527",
          y2: "159.91527",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "42.23498",
          y1: "229.76502",
          x2: "175.91497",
          y2: "96.08503",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGraduationCap = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M180,209.59229a118.30523,118.30523,0,0,0,16-8.4668V240a8,8,0,0,1-16,0ZM120.94141,92.23535a7.99969,7.99969,0,0,0,3.29394,10.82324L171.00049,128,188,118.93359,131.76465,88.94141A7.99776,7.99776,0,0,0,120.94141,92.23535Zm130.82324-3.29394-120-64a7.99984,7.99984,0,0,0-7.5293,0l-120,64a7.99956,7.99956,0,0,0,0,14.11718L28,115.73315v49.721a16.05975,16.05975,0,0,0,3.19434,9.59326C39.11914,185.59277,69.51953,220,128,220a128.69017,128.69017,0,0,0,52-10.45557V132.7998L171.00049,128,128,150.93359,39.83643,103.91284l-.05713-.03052L25,96,128,41.06641,231,96l-14.7793,7.88232-.05713.03052L188,118.93359l3.76465,2.00782A8.10305,8.10305,0,0,1,196,128v73.06665a110.42518,110.42518,0,0,0,28.80469-26.01831A16.05929,16.05929,0,0,0,228,165.4541v-49.721l23.76465-12.67456a7.99956,7.99956,0,0,0,0-14.11718Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "8 96 128 32 248 96 128 160 8 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "188 240 188 128 128 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M220,110.93333v54.5208a7.95694,7.95694,0,0,1-1.58951,4.78692C211.67382,179.20536,183.2529,212,128,212s-83.67382-32.79464-90.41049-41.75895A7.95694,7.95694,0,0,1,36,165.45413v-54.5208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconGridFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M204,36H52A16.01833,16.01833,0,0,0,36,52V204a16.01833,16.01833,0,0,0,16,16H204a16.01833,16.01833,0,0,0,16-16V52A16.01833,16.01833,0,0,0,204,36Zm.00439,92H128V52h76ZM52,128h76v76H52Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "212",
          y1: "128",
          x2: "44",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHand = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188,40a27.82979,27.82979,0,0,0-12,2.707V36a27.99792,27.99792,0,0,0-54.64209-8.60278A27.992,27.992,0,0,0,80,52v75.41016l-6.999-12.12354a28.00028,28.00028,0,0,0-48.6709,27.69629C56.77832,211.39941,78.39355,240,128,240a88.09957,88.09957,0,0,0,88-88V68A28.03146,28.03146,0,0,0,188,40Zm12,112a72.08124,72.08124,0,0,1-72,72c-20.17871,0-34.22656-5.45459-46.97461-18.23828-12.499-12.53369-24.77246-32.78565-42.36426-69.90137q-.13916-.293-.30175-.57422a12.00011,12.00011,0,0,1,20.78515-11.99951l21.92774,37.97949a7.9997,7.9997,0,0,0,14.92773-4V52a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v84a8,8,0,0,0,16,0V68a12,12,0,0,1,24,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.18278,0-64-24-96.56854-92.71349a20,20,0,1,1,34.641-20L88,157.26608V52a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,120V36a20,20,0,0,0-40,0v84",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandFist = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,80H184V64a31.97943,31.97943,0,0,0-56-21.13208A31.97443,31.97443,0,0,0,72.20508,60.4231,31.978,31.978,0,0,0,24,88v40a104,104,0,0,0,208,0V112A32.03635,32.03635,0,0,0,200,80ZM152,48a16.01833,16.01833,0,0,1,16,16V80H136V64A16.01833,16.01833,0,0,1,152,48ZM88,64a16,16,0,0,1,32,0v40a16,16,0,0,1-32,0V64ZM40,88a16,16,0,0,1,32,0v16a16,16,0,0,1-32,0Zm88,128a88.10627,88.10627,0,0,1-87.9209-84.249A31.94065,31.94065,0,0,0,80,125.13208a31.92587,31.92587,0,0,0,44.58057,3.34595,32.23527,32.23527,0,0,0,11.79443,11.4414A47.906,47.906,0,0,0,120,176a8,8,0,0,0,16,0,32.03635,32.03635,0,0,1,32-32,8,8,0,0,0,0-16H152a16.01833,16.01833,0,0,1-16-16V96h64a16.01833,16.01833,0,0,1,16,16v16A88.09957,88.09957,0,0,1,128,216Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,64a24,24,0,0,1,48,0V88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,176a40,40,0,0,1,40-40H152a24,24,0,0,1-24-24V96a8,8,0,0,1,8-8h64a24,24,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandGrabbing = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188,80a27.82885,27.82885,0,0,0-13.35791,3.39716A27.97426,27.97426,0,0,0,128,72.43066,27.9817,27.9817,0,0,0,80,92v16H68a28.03146,28.03146,0,0,0-28,28v16a88,88,0,0,0,176,0V108A28.03146,28.03146,0,0,0,188,80Zm12,72a72,72,0,0,1-144,0V136a12.01343,12.01343,0,0,1,12-12H80v24a8,8,0,0,0,16,0V92a12,12,0,0,1,24,0v32a8,8,0,0,0,16,0V92a12,12,0,0,1,24,0v32a8,8,0,0,0,16,0V108a12,12,0,0,1,24,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,124V92a20,20,0,0,0-40,0v56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,124V92a20,20,0,0,0-40,0v32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,148V116H68a20,20,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandPalm = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188,84a27.83152,27.83152,0,0,0-12,2.707V52a27.992,27.992,0,0,0-41.35791-24.60278A27.99792,27.99792,0,0,0,80,36v6.707A27.991,27.991,0,0,0,40,68v84a88,88,0,0,0,176,0V112A28.03146,28.03146,0,0,0,188,84Zm12,68a72,72,0,0,1-144,0V68a12,12,0,0,1,24,0v44a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V52a12,12,0,0,1,24,0v72.6665A48.07871,48.07871,0,0,0,120,172a8,8,0,0,0,16,0,32.03635,32.03635,0,0,1,32-32,8.00008,8.00008,0,0,0,8-8V112a12,12,0,0,1,24,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,104V52a20,20,0,0,1,40,0v80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,112V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandPointing = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188,84a27.82842,27.82842,0,0,0-14.6416,4.145A27.97776,27.97776,0,0,0,136,74.707V36a28,28,0,0,0-56,0v91.41016l-6.999-12.12354a28.00028,28.00028,0,0,0-48.6709,27.69629C56.77832,211.39941,78.39355,240,128,240a88.09957,88.09957,0,0,0,88-88V112A28.03146,28.03146,0,0,0,188,84Zm12,68a72.08124,72.08124,0,0,1-72,72c-20.17871,0-34.22656-5.45459-46.97461-18.23828-12.499-12.53369-24.77246-32.78565-42.36426-69.90137q-.13916-.293-.30175-.57422a12.00011,12.00011,0,0,1,20.78515-11.99951l21.92774,37.97949a7.9997,7.9997,0,0,0,14.92773-4V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0v12a8,8,0,0,0,16,0,12,12,0,0,1,24,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,104V36a20,20,0,0,0-40,0V157.26608L66.07247,119.28651a20,20,0,1,0-34.641,20C64,208,83.81722,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,112V100a20,20,0,0,0-40,0v4",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandSoap = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184,96.80469V88a32.03667,32.03667,0,0,0-32-32H136V32h32a8.00917,8.00917,0,0,1,8,8,8,8,0,0,0,16,0,24.0275,24.0275,0,0,0-24-24H104a8,8,0,0,0,0,16h16V56H104A32.03667,32.03667,0,0,0,72,88v8.80469A40.06815,40.06815,0,0,0,40,136v80a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V136A40.06815,40.06815,0,0,0,184,96.80469ZM104,72h48a16.01833,16.01833,0,0,1,16,16v8H88V88A16.01833,16.01833,0,0,1,104,72Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,104V88a24,24,0,0,1,24-24h48a24,24,0,0,1,24,24v16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,40a16,16,0,0,0-16-16H104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandWaving = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M220.20312,103.98828l-19.999-34.64062a28.02682,28.02682,0,0,0-47.29834-1.92243l-17.34326-30.04a27.99212,27.99212,0,0,0-48.11328-.63549A28.003,28.003,0,0,0,44.4248,71.5293l3.35352,5.80877A27.991,27.991,0,0,0,25.7832,119.24219l42,72.74609a87.99976,87.99976,0,1,0,152.41992-88ZM213.54,166.62354A72,72,0,0,1,81.63965,183.98828l-42-72.7456A11.99994,11.99994,0,0,1,60.42383,99.24219l22,38.10547a8.01625,8.01625,0,0,0,.55566.82623c.05274.07.1084.13617.16309.204q.23657.2926.4956.5578c.0586.0603.11621.12207.17627.1803a8.00346,8.00346,0,0,0,.72412.62359l.01758.012a8.0088,8.0088,0,0,0,.76807.50262c.07519.04346.15088.08325.22705.12421q.31714.17148.64844.313c.07373.03149.1455.06524.22021.09454a8.05256,8.05256,0,0,0,.88867.29571c.01953.00519.03955.00782.05909.01288a8.05171,8.05171,0,0,0,.85449.16712c.08545.01226.1709.02105.25683.03058q.36036.03992.72412.04675c.05274.001.1045.01019.15723.01019.02539,0,.05127-.0047.07666-.00494a7.94421,7.94421,0,0,0,.93018-.05963c.0249-.00318.0498-.00965.0747-.01307a7.93311,7.93311,0,0,0,.84131-.16473c.08985-.0224.17823-.049.26758-.07465q.33692-.09659.66748-.22454c.08692-.03351.17383-.06482.26026-.10157a7.95946,7.95946,0,0,0,3.80175-11.35833l-22-38.106-.00293-.00519L58.28027,63.52881A12.00012,12.00012,0,0,1,79.06543,51.5293l7.9834,13.82818.01562.02826,26,45.03369a8,8,0,1,0,13.85645-8l-25.999-45.03369a12.00023,12.00023,0,1,1,20.78515-12l29.99756,51.95752.00244.0044,6.3291,10.96338a48.025,48.025,0,0,0-10.9707,60.998,7.99959,7.99959,0,1,0,13.85547-8,32.00043,32.00043,0,0,1,11.71387-43.71289,7.96868,7.96868,0,0,0,.66992-.43329c.18017-.12921.34961-.26849.51562-.41009.03174-.02692.06641-.05048.09766-.07788.19092-.16761.37109-.344.543-.52668l.01611-.01586q.25928-.27687.48779-.575l.01758-.02087c.14453-.1886.27783-.384.4043-.5835.01318-.021.02832-.0404.0415-.06152.11377-.18286.21533-.37158.31348-.5622.022-.04248.04736-.08258.06885-.12548.0874-.17847.16308-.36206.2373-.54621.02344-.05877.05225-.115.07471-.17444.08056-.215.14892-.43408.21094-.655.0083-.03028.0205-.059.0288-.08942.00782-.02966.01172-.05988.01954-.0896.05664-.22278.10742-.44714.145-.67419.01171-.06977.01513-.14.0249-.2099.02636-.18915.05224-.3783.06494-.56922.00391-.05823.00146-.11633.00391-.17456.00927-.20325.01611-.40661.00976-.61078-.00146-.03888-.00732-.07739-.00879-.11621-.01025-.2218-.02588-.44366-.05469-.66522-.00341-.02515-.00976-.04981-.01318-.07489-.03271-.23193-.07275-.46344-.126-.69373-.00683-.02783-.0166-.05481-.02294-.08252-.05469-.22387-.11573-.4469-.19043-.66772-.022-.06525-.05127-.12811-.0752-.19281-.06641-.18012-.13184-.36029-.21191-.53735a7.98085,7.98085,0,0,0-.36475-.7121l-10-17.3208a12.00012,12.00012,0,0,1,20.78516-11.99951l20,34.64062A71.53255,71.53255,0,0,1,213.54,166.62354ZM87.668,244.56152a7.999,7.999,0,0,1-11.13281,2.01563,118.949,118.949,0,0,1-35.46289-38.58643,7.99959,7.99959,0,1,1,13.85546-8,103.08083,103.08083,0,0,0,30.72461,33.438A8.00009,8.00009,0,0,1,87.668,244.56152ZM168,30.99268A8.00009,8.00009,0,0,1,176,23h.00781A60.21143,60.21143,0,0,1,227.9541,53.00439a8.00044,8.00044,0,1,1-13.85742,8A44.16357,44.16357,0,0,0,175.99219,39,8,8,0,0,1,168,30.99268Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M119.99332,106.41921l-26-45.03332a20,20,0,0,1,34.641-20l40,69.282",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M89.35231,133.34742l-38-65.81793a20,20,0,1,1,34.641-20l34,58.88972",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M153.99332,165.30894a40,40,0,0,1,14.641-54.641l-10-17.32051a20,20,0,1,1,34.641-20l20,34.641a80,80,0,1,1-138.56406,80l-42-72.74613a20,20,0,0,1,34.641-20l22,38.10512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M81.09415,240.0027A111.54975,111.54975,0,0,1,48,203.99065",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,31A51.97065,51.97065,0,0,1,221.0258,57.00434",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandbag = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M238.96387,206.2334,224.74219,78.23291A15.98372,15.98372,0,0,0,208.83984,64h-33.519a47.99073,47.99073,0,0,0-94.6416,0h-33.519A15.98375,15.98375,0,0,0,31.25781,78.2334l-14.22168,128A16.00031,16.00031,0,0,0,32.93848,224h190.123a16.00031,16.00031,0,0,0,15.90235-17.7666ZM95.99219,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0ZM97.0127,64a32.00443,32.00443,0,0,1,61.9746,0Zm78.97949,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandbagSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M238.96387,206.2334,224.74219,78.23291A15.98372,15.98372,0,0,0,208.83984,64h-33.519a47.99073,47.99073,0,0,0-94.6416,0h-33.519A15.98375,15.98375,0,0,0,31.25781,78.2334l-14.22168,128A16.00031,16.00031,0,0,0,32.93848,224h190.123a16.00031,16.00031,0,0,0,15.90235-17.7666ZM128,40a32.05773,32.05773,0,0,1,30.9873,24H97.0127A32.05773,32.05773,0,0,1,128,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.83966,72H47.16034a8,8,0,0,0-7.95107,7.11655l-14.22222,128A8,8,0,0,0,32.93812,216H223.06188a8,8,0,0,0,7.95107-8.88345l-14.22222-128A8,8,0,0,0,208.83966,72Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandsClapping = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M190.251,69.68652a23.9764,23.9764,0,0,0-41.56055.01514L133.07422,42.65332a23.97141,23.97141,0,0,0-41.8042.45459A24.00171,24.00171,0,0,0,49.90137,64.916a23.98424,23.98424,0,0,0-17.28614,35.7373L36.23,106.91455A23.98051,23.98051,0,0,0,15.4375,142.90234l37,64.08594a77.99184,77.99184,0,0,0,140.75391-12.09082A78.372,78.372,0,0,0,207.251,99.13184Zm-37.2627,155.459a66.077,66.077,0,0,1-90.1582-24.15723l-37-64.08594a12.00023,12.00023,0,0,1,20.78515-12l.001.00122,23.999,41.56812a6.00012,6.00012,0,1,0,10.39258-6l-38-65.81836a11.99981,11.99981,0,1,1,20.78418-12l38,65.81836a6.00012,6.00012,0,0,0,10.39258-6l-30-51.96143v-.00048a11.99981,11.99981,0,1,1,20.78418-12l42,72.74609a6.00012,6.00012,0,0,0,10.39258-6L139.36182,117.5437l-.00049-.00073a11.99981,11.99981,0,0,1,20.78418-12l17,29.44531a65.999,65.999,0,0,1-24.15723,90.15723Zm13.9209-199.97266,4.1416-15.4541a6.00029,6.00029,0,0,1,11.5918,3.10547l-4.1416,15.4541a6.00029,6.00029,0,0,1-11.5918-3.10547Zm26.06152,9.85352,9.17774-13.10645a6.00007,6.00007,0,0,1,9.83008,6.88281l-9.17774,13.10645a6.00007,6.00007,0,0,1-9.83008-6.88281Zm41.10938,18.82519L220.97363,63.0293a6.00007,6.00007,0,0,1-6.88281-9.83008l13.10645-9.17774a6.00007,6.00007,0,0,1,6.88281,9.83008Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M51.81106,121.9021a18,18,0,1,0-31.17691,18l37,64.08588a72,72,0,0,0,124.70766-72l-17-29.44487a18,18,0,0,0-31.17692,18",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M106.988,145.47132l-38-65.81793a18,18,0,0,0-31.17692,18l38,65.81793",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M150.16489,148.25593l-42-72.74614a18,18,0,0,0-31.17691,18",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M99.04433,67.71252,88.70079,49.797a18,18,0,1,0-31.17691,18L59.867,71.85533",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M188.03672,191.515a72.02623,72.02623,0,0,0,14.0179-89.38343l-17-29.44486a18,18,0,1,0-31.17691,18",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M156.22161,94.74648l-28.3439-49.09309a18,18,0,0,0-31.17692,18",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176.84663",
          y1: "11.27112",
          x2: "172.70552",
          y2: "26.72593",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "207.06334",
          y1: "25.3614",
          x2: "197.88611",
          y2: "38.46784",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "230.6386",
          y1: "48.93666",
          x2: "217.53216",
          y2: "58.11389",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHandshake = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M119.76074,214.80176a7.98886,7.98886,0,0,1-9.70117,5.82031l-30.13965-7.53418a16.0992,16.0992,0,0,1-6.61719-3.44727L50.752,190.03809a8,8,0,0,1,10.4961-12.07618l22.55273,19.60352,30.13965,7.53516A7.99856,7.99856,0,0,1,119.76074,214.80176Zm132.60156-95.2461a15.88206,15.88206,0,0,1-8.0664,9.38428L221.02783,140.574l-14.94678,17.48553c-.05224.061-.10937.11725-.16308.17664-.04932.05413-.09815.10785-.14844.16034-.03808.03985-.07324.08245-.1123.12152l-36.79688,36.79834a16.0981,16.0981,0,0,1-11.35058,4.67968,15.8477,15.8477,0,0,1-3.84473-.47265L95.708,185.03418a15.9025,15.9025,0,0,1-5.97559-2.918L35.7041,139.86829l-24-12.00013a16.0014,16.0014,0,0,1-7.02734-21.7163L29.26953,59.05469A16.07985,16.07985,0,0,1,50.6084,52.1499l22.375,11.18744L121.65527,49.148a16.01609,16.01609,0,0,1,11.07325.78271l32.99707,14.93067H182.1123l23.28028-11.63965A16.07317,16.07317,0,0,1,226.73047,60.127l24.59277,47.09619A15.87906,15.87906,0,0,1,252.3623,119.55566Zm-64.63916,34.26886-31.6499-23.01788L148,136.86133a40.20558,40.20558,0,0,1-48,0l-5.4209-4.06543a16.00034,16.00034,0,0,1-1.71387-24.11328L132,69.54785a16.1947,16.1947,0,0,1,1.8335-1.55548l-7.69971-3.48407L77.41016,78.71265,50.17432,130.872,99.58887,169.5127l57.957,14.48925Zm18.68311-20.76959-27.25439-52.1936h-15.1294l-.02734.002c-.0127,0-.02491-.00189-.03711-.002H143.31348l-39.13379,39.13476,5.41992,4.06543a24.1254,24.1254,0,0,0,28.80078,0l12.79981-9.60009a7.99783,7.99783,0,0,1,9.50488-.06983l38.019,27.65027Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240.71765,121.78477,216,134.14359l-32-61.282,24.9693-12.48465a8,8,0,0,1,10.66912,3.45246l24.59293,47.097A8,8,0,0,1,240.71765,121.78477Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M40,133.0718,15.28235,120.713a8,8,0,0,1-3.5137-10.85838l24.59293-47.097A8,8,0,0,1,47.0307,59.30511L72,71.78976Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216,134.14359l-16,18.718L163.20286,189.6587a8,8,0,0,1-7.59714,2.10429L97.64881,177.27376a7.99992,7.99992,0,0,1-2.98764-1.45911L40,133.0718",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,152.86156l-44-32-12.8,9.6a32,32,0,0,1-38.4,0L99.37926,126.396a8,8,0,0,1-.85685-12.05686l39.13444-39.13444a8,8,0,0,1,5.65686-2.34315H184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72.57437,71.78976l51.32-14.96153a8,8,0,0,1,5.537.39169L164,72.86156",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M112,212.86156,81.86056,205.3267a7.99993,7.99993,0,0,1-3.308-1.7233L56,184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHardDrive = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,64H32A16.01833,16.01833,0,0,0,16,80v96a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,224,64Zm-35.99951,76a12,12,0,1,1,12-12A12,12,0,0,1,188.00049,140Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "112",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "188",
          cy: "128",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHardDrives = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M208,40H48A16.01833,16.01833,0,0,0,32,56v48a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,208,40ZM180.00049,92a12,12,0,1,1,12-12A12,12,0,0,1,180.00049,92Z"
        }), React.createElement("path", {
          d: "M208,136H48a16.01833,16.01833,0,0,0-16,16v48a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V152A16.01833,16.01833,0,0,0,208,136Zm-27.99951,52a12,12,0,1,1,12-12A12,12,0,0,1,180.00049,188Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "64",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "40",
          y: "48",
          width: "176",
          height: "64",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "180",
          cy: "80",
          r: "12"
        }), React.createElement("circle", {
          cx: "180",
          cy: "176",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,88H175.40381l8.46728-46.56934a8.00005,8.00005,0,1,0-15.74218-2.86132L159.1416,88H111.40381l8.46728-46.56934a8.00005,8.00005,0,1,0-15.74218-2.86132L95.1416,88H43.63672a8,8,0,0,0,0,16h48.5957l-8.72754,48H32a8,8,0,0,0,0,16H80.59619l-8.46728,46.56934a8.00005,8.00005,0,1,0,15.74218,2.86132L96.8584,168h47.73779l-8.46728,46.56934a8.00005,8.00005,0,1,0,15.74218,2.86132L160.8584,168h51.50488a8,8,0,1,0,0-16h-48.5957l8.72754-48H224a8,8,0,0,0,0-16Zm-76.49512,64H99.76758l8.72754-48h47.7373Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "43.63636",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "40",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "160",
          x2: "212.36376",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHashStraight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,152H168V104h48a8,8,0,0,0,0-16H168V40a8,8,0,0,0-16,0V88H104V40a8,8,0,0,0-16,0V88H40a8,8,0,0,0,0,16H88v48H40a8,8,0,0,0,0,16H88v48a8,8,0,0,0,16,0V168h48v48a8,8,0,0,0,16,0V168h48a8,8,0,0,0,0-16Zm-112,0V104h48v48Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "40",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHeadlights = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160,80a8.00039,8.00039,0,0,1,8-8h72a8,8,0,0,1,0,16H168A8.00039,8.00039,0,0,1,160,80Zm80,88H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0-64H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,32H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM128,48H88.90381C44.61914,48,8.32715,83.61621,8.002,127.39453A79.99987,79.99987,0,0,0,88,208h40a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,128,48Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "168",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "176",
          x2: "240",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "112",
          x2: "240",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "144",
          x2: "240",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,200a72.00008,72.00008,0,0,1-71.998-72.54593C16.29634,87.75464,49.20335,56,88.90387,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHeadphones = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M202.7207,62.1875A103.28167,103.28167,0,0,0,129.46289,32c-.24414,0-.49121.001-.73535.00244A104.00025,104.00025,0,0,0,24,136v56a24.0275,24.0275,0,0,0,24,24H64a24.0275,24.0275,0,0,0,24-24V152a24.0275,24.0275,0,0,0-24-24H40.35547A88.01928,88.01928,0,0,1,128.668,48.00244c.041.00049.07812.00049.11914,0A88.01738,88.01738,0,0,1,217.10059,128H193.45605a24.0275,24.0275,0,0,0-24,24v40a24.0275,24.0275,0,0,0,24,24h16a24.0275,24.0275,0,0,0,24-24V136A103.28343,103.28343,0,0,0,202.7207,62.1875Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M225.45581,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136A96.0001,96.0001,0,0,0,128.7279,40.0027,96.00009,96.00009,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHeadset = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M233.45605,128v80a40.04551,40.04551,0,0,1-40,40H136a8,8,0,0,1,0-16h57.45605a24.0275,24.0275,0,0,0,24-24v-1.376a23.89418,23.89418,0,0,1-8,1.376h-16a24.0275,24.0275,0,0,1-24-24V144a24.0275,24.0275,0,0,1,24-24h23.64454a88.01738,88.01738,0,0,0-88.31348-79.99756c-.041.00049-.07813.00049-.11914,0A88.01928,88.01928,0,0,0,40.35547,120H64a24.0275,24.0275,0,0,1,24,24v40a24.0275,24.0275,0,0,1-24,24H48a24.0275,24.0275,0,0,1-24-24V128A104.00025,104.00025,0,0,1,128.72754,24.00244c.24414-.00146.49121-.00244.73535-.00244A104.00007,104.00007,0,0,1,233.45605,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M225.45581,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128A96.0001,96.0001,0,0,0,128.7279,32.0027,96.00009,96.00009,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M225.45581,184v24a32,32,0,0,1-32,32H136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHeart = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176.02344,32a59.85506,59.85506,0,0,0-48,23.95947A60.02029,60.02029,0,0,0,20.02344,92c0,71.86279,99.84082,128.6001,104.09082,130.98a8.00089,8.00089,0,0,0,7.81836,0A317.34027,317.34027,0,0,0,183.375,185.44629C218.30957,154.00488,236.02344,122.56494,236.02344,92A60.06812,60.06812,0,0,0,176.02344,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,216S28,160,28,92A52.00881,52.00881,0,0,1,128.00008,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228,92C228,160,128,216,128,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHeartStraight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.627,51.90625a59.54956,59.54956,0,0,0-43.0625-19.89063,60.69786,60.69786,0,0,0-43.98437,17.55469L128.002,59.14844l-7.5-7.49219c-23.32812-23.35156-61.29687-25.3125-84.57812-4.29687a59.974,59.974,0,0,0-2.34375,87.07031l83.10937,83.10937a16.013,16.013,0,0,0,22.625,0l81.03125-81.03125C243.68945,113.15625,245.61133,75.20312,224.627,51.90625Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M133.65683,211.88227l81.0323-81.0322c19.9104-19.91038,22.84784-52.666,4.00583-73.59029a52.0026,52.0026,0,0,0-75.46451-2.02934L127.99994,70.46082,114.85007,57.3109C94.93972,37.40047,62.18409,34.463,41.25979,53.305a52.00261,52.00261,0,0,0-2.02934,75.46452l83.11268,83.11272A8,8,0,0,0,133.65683,211.88227Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHeartbeat = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,32a59.85506,59.85506,0,0,0-48,23.95947A60.02029,60.02029,0,0,0,20,92a85.2156,85.2156,0,0,0,4.92969,28H67.71875l13.625-20.4375a7.99959,7.99959,0,0,1,13.3125,0L120,137.57764l9.34375-14.01514A7.99943,7.99943,0,0,1,136,120h24a8,8,0,0,1,0,16H140.28125l-13.625,20.4375a7.99959,7.99959,0,0,1-13.3125,0L88,118.42236,78.65625,132.4375A7.99943,7.99943,0,0,1,72,136H31.98389c26.65088,49.81006,88.77392,85.11328,92.10693,86.98a8.00089,8.00089,0,0,0,7.81836,0,317.34027,317.34027,0,0,0,51.44238-37.53369C218.28613,154.00488,236,122.56494,236,92A60.06812,60.06812,0,0,0,176,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "32 128 72 128 88 104 120 152 136 128 160 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M28.11427,95.99348Q28.00077,94.004,28,92A52.00881,52.00881,0,0,1,128.00008,71.965l-.00019.00008A52.00881,52.00881,0,0,1,228,92c0,68-100,124-100,124s-39.94466-22.369-69.34251-55.99891",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHexagon = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M219.87305,66.73828l-84-47.478a16.08654,16.08654,0,0,0-15.7461,0l-84,47.47852A16.0255,16.0255,0,0,0,28,80.668V175.332a16.02688,16.02688,0,0,0,8.127,13.92969l84,47.478a16.08782,16.08782,0,0,0,15.7461,0l84-47.47852A16.0255,16.0255,0,0,0,228,175.332V80.668A16.02688,16.02688,0,0,0,219.87305,66.73828Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M220,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87292,0l-84,47.47826A8,8,0,0,0,36,80.66772v94.66456a8,8,0,0,0,4.06354,6.96451l84,47.47826a8,8,0,0,0,7.87292,0l84-47.47826A8,8,0,0,0,220,175.33228Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHighlighterCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M201.53906,54.46094A103.99994,103.99994,0,1,0,54.46094,201.53906,103.99994,103.99994,0,1,0,201.53906,54.46094ZM96,209.9989V152h64v57.9989a88.31824,88.31824,0,0,1-64,0Zm94.22461-19.77429A88.78305,88.78305,0,0,1,176,201.76886V152a16.01833,16.01833,0,0,0-16-16V72a8,8,0,0,0-11.57812-7.15527l-48,24A7.99967,7.99967,0,0,0,96,96v40a16.01833,16.01833,0,0,0-16,16v49.76886a88.78631,88.78631,0,0,1-14.22461-11.54425,88,88,0,1,1,124.44922,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "104 144 104 96 152 72 152 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,215.29789V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.29789",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHorse = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M202.053,54.97754A103.25514,103.25514,0,0,0,128.00009,24h-8a8.00009,8.00009,0,0,0-8,8V59.52979L11.80743,121.18652a8.00038,8.00038,0,0,0-2.29591,11.49317L23.29867,151.7959a31.8353,31.8353,0,0,0,31.338,12.82324c13.6514-2.31055,38.5919-4.23193,61.52457,6.19092L90.02246,207.40479a87.94472,87.94472,0,0,1-20.68657-13.81055A8.00032,8.00032,0,0,0,58.664,205.51611,103.66177,103.66177,0,0,0,128.01279,232q1.043,0,2.0879-.02051A104.001,104.001,0,0,0,202.053,54.97754ZM124,112a12,12,0,1,1,12-12A12,12,0,0,1,124,112Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,120a48,48,0,0,1-48,48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M63.99958,199.555a95.66337,95.66337,0,0,0,65.94315,24.42575c51.479-1.01726,93.33139-43.12958,94.04775-94.61366A96.00033,96.00033,0,0,0,128,32h-8V64L16,128l13.78709,19.11608a24.02393,24.02393,0,0,0,23.51449,9.61538c17.46763-2.95714,48.06093-4.71406,74.69861,11.26833L128,168,92.76585,217.32781",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "124",
          cy: "100",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHourglass = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,75.64392V40.0033a16.02084,16.02084,0,0,0-16-16H72a16.02084,16.02084,0,0,0-16,16v36a16.08093,16.08093,0,0,0,6.40625,12.79687l52.26563,39.20313L62.39844,167.20642A16.07348,16.07348,0,0,0,56,180.0033v36a16.02085,16.02085,0,0,0,16,16H184a16.02085,16.02085,0,0,0,16-16V180.36267a16.033,16.033,0,0,0-6.35937-12.76562l-52.377-39.59375,52.377-39.59375A16.05549,16.05549,0,0,0,200,75.64392Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHourglassHigh = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,75.64111V40a16.01833,16.01833,0,0,0-16-16H72A16.01833,16.01833,0,0,0,56,40V76a16.07553,16.07553,0,0,0,6.3999,12.7998L114.667,128l-52.2666,39.2002A16.07459,16.07459,0,0,0,56,180v36a16.01833,16.01833,0,0,0,16,16H184a16.01833,16.01833,0,0,0,16-16V180.35889a16.08452,16.08452,0,0,0-6.352-12.76416L141.2666,128l52.38184-39.59473A16.08547,16.08547,0,0,0,200,75.64111ZM184,40V63.99561H72V40Zm0,176H72V180l55.98145-41.98584L184,180.35889Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "63.99548",
          x2: "192",
          y2: "63.99548",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHourglassLow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,75.64111V40a16.01833,16.01833,0,0,0-16-16H72A16.01833,16.01833,0,0,0,56,40V76a16.07589,16.07589,0,0,0,6.3999,12.7998L114.667,128l-52.2666,39.2002a16.06134,16.06134,0,0,0-6.34814,11.92236A7.943,7.943,0,0,0,56,180v36a16.01833,16.01833,0,0,0,16,16H184a16.01833,16.01833,0,0,0,16-16V180.35889a8.04861,8.04861,0,0,0-.05273-.89307,16.06854,16.06854,0,0,0-6.29932-11.87061L141.2666,128l52.38184-39.595A16.08467,16.08467,0,0,0,200,75.64111ZM82.59717,172.052l45.38428-34.03784,45.36572,34.29248ZM184,75.64136l-56.01855,42.34448L72,76V40H184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "192",
          y1: "180.3588",
          x2: "64",
          y2: "180",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHourglassMedium = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M193.64844,88.40527A16.08547,16.08547,0,0,0,200,75.64111V40a16.01833,16.01833,0,0,0-16-16H72A16.01833,16.01833,0,0,0,56,40V76a16.07553,16.07553,0,0,0,6.3999,12.7998l18.127,13.59522.00048.00049L114.6665,128,62.40039,167.2002A16.07459,16.07459,0,0,0,56,180v36a16.01833,16.01833,0,0,0,16,16H184a16.01833,16.01833,0,0,0,16-16V180.35889a16.08452,16.08452,0,0,0-6.352-12.76416L141.2666,128l22.70459-17.16211ZM72,40H184V75.6416l-5.76025,4.354H77.32764L72,76ZM184,180.35889V216H72V180l48-36v23.99561a8,8,0,0,0,16,0V144.07568Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,128,67.2,82.4A8,8,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6412a8,8,0,0,1-3.17594,6.38188L128,128h0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,128,67.2,173.6A8,8,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.3588a8,8,0,0,0-3.17594-6.38188L128,128h0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "74.66065",
          y1: "87.99548",
          x2: "180.92301",
          y2: "87.99548",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "167.99548",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHourglassSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M139.31543,127.99854,208,59.31348A15.9999,15.9999,0,0,0,196.68652,32H59.31348A15.9999,15.9999,0,0,0,48,59.31348l68.68457,68.688L48,196.68652A15.9999,15.9999,0,0,0,59.31348,224h137.373A15.9999,15.9999,0,0,0,208,196.68652Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHourglassSimpleHigh = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M139.31543,127.99854l50.34082-50.34107.001-.00122L208,59.31348A15.9999,15.9999,0,0,0,196.68652,32H59.31348A15.9999,15.9999,0,0,0,48,59.31348l68.68457,68.688L48,196.68652A15.9999,15.9999,0,0,0,59.31348,224h137.373A15.9999,15.9999,0,0,0,208,196.68652Zm57.36621-79.99366L180.68652,64H75.31982L59.32031,48ZM59.31836,207.99512l68.67969-68.67969L196.67969,208Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72",
          y1: "72",
          x2: "184",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHourglassSimpleLow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M139.31543,127.99854,208,59.31348A15.9999,15.9999,0,0,0,196.68652,32H59.31348A15.9999,15.9999,0,0,0,48,59.31348l68.68457,68.688L48,196.68652A15.9999,15.9999,0,0,0,59.31348,224h137.373A15.9999,15.9999,0,0,0,208,196.68652ZM59.32031,48l137.36133.00488L128.002,116.68457Zm68.67774,91.31543L156.68115,168H99.31348Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "176",
          x2: "80",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHourglassSimpleMedium = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M139.31543,127.99854l34.34082-34.34107.001-.00122L208,59.31348A15.9999,15.9999,0,0,0,196.68652,32H59.31348A15.9999,15.9999,0,0,0,48,59.31348l68.68457,68.688L48,196.68652A15.9999,15.9999,0,0,0,59.31348,224h137.373A15.9999,15.9999,0,0,0,208,196.68652Zm57.36621-79.99366L172.68652,72H83.31934l-23.999-24ZM59.31836,207.99512,120,147.31348V168a8,8,0,0,0,16,0V147.31775L196.67969,208Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M59.31371,40H196.68629a8,8,0,0,1,5.65686,13.65685L128,128,53.65685,53.65685A8,8,0,0,1,59.31371,40Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M59.31371,216H196.68629a8,8,0,0,0,5.65686-13.65685L128,128,53.65685,202.34315A8,8,0,0,0,59.31371,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "80",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHouse = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M218.76367,103.7002,138.75684,30.96436a15.93657,15.93657,0,0,0-21.52637.00146L37.2373,103.69971A16.03108,16.03108,0,0,0,32,115.53857l0,92.09522a16.47275,16.47275,0,0,0,4.01066,10.96174A15.91729,15.91729,0,0,0,48.002,223.999H95.96484a8,8,0,0,0,8-8V167.9917a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8V215.999a8,8,0,0,0,8,8h48.05731a15.40625,15.40625,0,0,0,7.53406-1.85584A16.08415,16.08415,0,0,0,224,207.999v-92.46A16.03567,16.03567,0,0,0,218.76367,103.7002Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M151.99414,207.99263v-48.001a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v48.001a8,8,0,0,1-7.999,8l-47.99414.00632a8,8,0,0,1-8.001-8v-92.4604a8,8,0,0,1,2.61811-5.91906l79.9945-72.73477a8,8,0,0,1,10.76339-.00036l80.0055,72.73509A8,8,0,0,1,216,115.53887V207.999a8,8,0,0,1-8.001,8l-48.00586-.00632A8,8,0,0,1,151.99414,207.99263Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHouseLine = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M239.9707,208h-16V115.53882A16.03729,16.03729,0,0,0,218.73437,103.7L138.72754,30.96484a15.93607,15.93607,0,0,0-21.52637.001L37.207,103.7a16.034,16.034,0,0,0-5.23633,11.83862V208h-16a8,8,0,1,0,0,16h224a8,8,0,0,0,0-16Zm-88.00586-.0083h-8V208h-32v-.0083h-8v-48a8.00009,8.00009,0,0,1,8-8h32a8.00008,8.00008,0,0,1,8,8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,216V115.53887a8,8,0,0,0-2.6185-5.91942L133.376,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477A8,8,0,0,0,40,115.53855V216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M151.99414,215.99158v-56a8,8,0,0,0-8-8h-32a8,8,0,0,0-8,8v56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconHouseSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M218.76465,103.70117l-.001-.001L138.75684,30.96484a15.93607,15.93607,0,0,0-21.52637.001L37.23633,103.7002A16.03346,16.03346,0,0,0,32,115.53857V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V115.53906A16.03466,16.03466,0,0,0,218.76465,103.70117Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.3815,109.61945,133.376,36.88436a8,8,0,0,0-10.76339.00036l-79.9945,72.73477A8,8,0,0,0,40,115.53855V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.53887A8,8,0,0,0,213.3815,109.61945Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconIdentificationBadge = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,24H56A16.01833,16.01833,0,0,0,40,40V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V40A16.01833,16.01833,0,0,0,200,24ZM96,48h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm84.80713,150.39258a8.00059,8.00059,0,0,1-11.20117-1.5918,52.0088,52.0088,0,0,0-83.21143.00195,8,8,0,0,1-12.793-9.60937,67.80944,67.80944,0,0,1,27.428-21.68237,40,40,0,1,1,53.94141-.00037,67.81238,67.81238,0,0,1,27.427,21.68079A8.00016,8.00016,0,0,1,180.80713,198.39258ZM152,136a24,24,0,1,1-24-24A24.0275,24.0275,0,0,1,152,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "136",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M79.998,191.99792a60.00877,60.00877,0,0,1,96.004-.00225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconIdentificationCard = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM125.08643,175.74512a8.00256,8.00256,0,0,1-9.74219-5.75293,24.01011,24.01011,0,0,0-46.48779.00146,8.00008,8.00008,0,1,1-15.49512-3.98828,39.896,39.896,0,0,1,16.36023-23.16162,32.00008,32.00008,0,1,1,44.75793,0,39.89755,39.89755,0,0,1,16.35987,23.15918A8.00051,8.00051,0,0,1,125.08643,175.74512ZM192,152H152a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Zm0-32H152a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Z"
        }), React.createElement("circle", {
          cx: "92.10059",
          cy: "120",
          r: "16"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "152",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92.10043",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M61.10869,167.99952a32.01032,32.01032,0,0,1,61.98292-.00215",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "48.00005",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconImage = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168.001,100.00017v.00341a12.00175,12.00175,0,1,1,0-.00341ZM232,56V200a16.01835,16.01835,0,0,1-16,16H40a16.01835,16.01835,0,0,1-16-16V56A16.01835,16.01835,0,0,1,40,40H216A16.01835,16.01835,0,0,1,232,56Zm-15.9917,108.6936L216,56H40v92.68575L76.68652,112.0002a16.01892,16.01892,0,0,1,22.62793,0L144.001,156.68685l20.68554-20.68658a16.01891,16.01891,0,0,1,22.62793,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M32,167.99982l50.343-50.343a8,8,0,0,1,11.31371,0l44.68629,44.6863a8,8,0,0,0,11.31371,0l20.68629-20.6863a8,8,0,0,1,11.31371,0L223.99982,184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "156",
          cy: "100",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconImageSquare = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "99.99951",
          cy: "92",
          r: "12"
        }), React.createElement("path", {
          d: "M208.00049,31.99963h-160a16.01833,16.01833,0,0,0-16,16V175.97369l-.001.0307.001,31.99524a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16v-160A16.01834,16.01834,0,0,0,208.00049,31.99963Zm-28.68653,80a16.019,16.019,0,0,0-22.62792,0l-44.68555,44.68653L91.314,135.99963a16.02161,16.02161,0,0,0-22.62792,0L48.00049,156.68457V47.99963h160l.00586,92.6922Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M215.99982,159.99982l-42.343-42.343a8,8,0,0,0-11.3137,0l-44.6863,44.6863a8,8,0,0,1-11.3137,0l-20.6863-20.6863a8,8,0,0,0-11.3137,0L40,176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "100",
          cy: "92",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconInfinity = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248,128a55.99955,55.99955,0,0,1-95.59766,39.59766q-.17137-.17139-.332-.35254L92.11963,99.55225a40,40,0,1,0,0,56.8955l8.519-9.61914a8,8,0,1,1,11.97754,10.6084l-8.68652,9.80811q-.16041.1809-.332.35254a56,56,0,1,1,0-79.19532q.17137.17139.332.35254l59.95068,67.69287a40,40,0,1,0,0-56.8955l-8.519,9.61914A8,8,0,0,1,143.38379,98.563l8.68652-9.80811q.16041-.1809.332-.35254A56,56,0,0,1,248,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M106.62747,152.1329l-8.68634,9.80823a48,48,0,1,1,0-67.88226l60.11774,67.88226a48,48,0,1,0,0-67.88226l-8.68634,9.80823",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconInfo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", {
          opacity: "0.1"
        }, React.createElement("rect", {
          x: "0.00195",
          width: "256",
          height: "256",
          fill: "none"
        })), React.createElement("path", {
          d: "M128.00146,23.99963a104,104,0,1,0,104,104A104.11791,104.11791,0,0,0,128.00146,23.99963ZM126.002,72a12,12,0,1,1-12,12A12,12,0,0,1,126.002,72Zm9.99951,111.99963h-8a8.0004,8.0004,0,0,1-8-8v-48a8,8,0,1,1,0-16h8a8.00039,8.00039,0,0,1,8,8v48a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", {
          opacity: "0.1"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "120 120 128 120 128 176 136 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "126",
          cy: "84",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconInstagramLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "32"
        }), React.createElement("path", {
          d: "M172,28H84A56.06353,56.06353,0,0,0,28,84v88a56.06353,56.06353,0,0,0,56,56h88a56.06353,56.06353,0,0,0,56-56V84A56.06353,56.06353,0,0,0,172,28ZM128,176a48,48,0,1,1,48-48A48.05436,48.05436,0,0,1,128,176Zm52-88a12,12,0,1,1,12-12A12,12,0,0,1,180,88Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "48",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "180",
          cy: "75.99998",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconIntersect = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M174.63477,81.36523a79.99168,79.99168,0,1,0-93.26954,93.26954,79.99168,79.99168,0,1,0,93.26954-93.26954ZM32,96A64.00385,64.00385,0,0,1,157.98779,80.05127,80.06522,80.06522,0,0,0,80.051,157.98779,64.1144,64.1144,0,0,1,32,96ZM160,224a64.11421,64.11421,0,0,1-61.98779-48.05127A80.06522,80.06522,0,0,0,175.949,98.01221,64.00389,64.00389,0,0,1,160,224Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "96",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "160",
          cy: "160",
          r: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "122.51701",
          y1: "98.51701",
          x2: "157.48457",
          y2: "133.48457",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "98.51562",
          y1: "122.51562",
          x2: "133.48323",
          y2: "157.48323",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconJeep = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,88H226.93848l-6.03809-42.26465A16.07879,16.07879,0,0,0,205.06152,32H50.93848A16.08053,16.08053,0,0,0,35.09863,45.7373L29.06128,88H16a8,8,0,0,0,0,16H28V208a16.01833,16.01833,0,0,0,16,16H68a16.01833,16.01833,0,0,0,16-16V184h20V128a8,8,0,0,1,16,0v56h16V128a8,8,0,0,1,16,0v56h20v24a16.01833,16.01833,0,0,0,16,16h24a16.01833,16.01833,0,0,0,16-16V104h12a8,8,0,0,0,0-16ZM72,144a12,12,0,1,1,12-12A12,12,0,0,1,72,144Zm112,0a12,12,0,1,1,12-12A12,12,0,0,1,184,144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "96",
          x2: "240",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "128",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "128",
          x2: "112",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M220,176H36V96.00005l7.01877-49.13142A8,8,0,0,1,50.93836,40H205.06164a8,8,0,0,1,7.91959,6.86863L220,96.00005Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "72",
          cy: "132",
          r: "12"
        }), React.createElement("circle", {
          cx: "184",
          cy: "132",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconKey = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160.00244,16A80.05817,80.05817,0,0,0,83.91357,120.77539L26.34521,178.34277A8.00235,8.00235,0,0,0,24.00244,184v40a8.00039,8.00039,0,0,0,8,8h40a8.00039,8.00039,0,0,0,8-8V208h16a8.00039,8.00039,0,0,0,8-8V184h16a8.00235,8.00235,0,0,0,5.65723-2.34277l9.56738-9.56836A80.00922,80.00922,0,1,0,160.00244,16ZM180,92a16,16,0,1,1,16-16A16.00016,16.00016,0,0,1,180,92Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M93.16866,122.8328a71.93648,71.93648,0,1,1,40.0009,40.001l.00062-.00149L120.00244,176h-24v24h-24v24h-40V184l61.168-61.168Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "180",
          cy: "76",
          r: "4",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18",
          opacity: "0.5"
        }), React.createElement("circle", {
          cx: "180",
          cy: "76",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconKeyReturn = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40Zm-32,96a8.00039,8.00039,0,0,1-8,8H99.314l10.34327,10.34277a8.00053,8.00053,0,0,1-11.31446,11.31446l-24-24c-.05664-.05664-.10449-.11768-.15869-.17578-.12549-.13282-.251-.26514-.36719-.40625-.0913-.11084-.17138-.22706-.25537-.3418-.07031-.09522-.14453-.188-.21093-.28662-.085-.12647-.15918-.25782-.23584-.38819-.05567-.09423-.11524-.186-.167-.2832-.06933-.12891-.12841-.26172-.18994-.39355-.04931-.10547-.10205-.209-.147-.31641-.05225-.12695-.09522-.25586-.14063-.38477-.042-.11816-.0874-.23437-.124-.355-.03906-.1289-.06787-.25976-.10058-.39013-.03077-.12305-.06543-.24414-.09034-.36914-.02978-.15186-.04834-.30469-.06933-.45752-.01465-.106-.03516-.20948-.0459-.3169a8.02276,8.02276,0,0,1,0-1.584c.01074-.10742.03125-.21094.0459-.3169.021-.15283.03955-.30566.06933-.45752.02491-.125.05957-.24609.09034-.36914.03271-.13037.06152-.26123.10058-.39013.03662-.12061.082-.23682.124-.355.04541-.12891.08838-.25782.14063-.38477.04492-.10742.09766-.21094.147-.31641.06153-.13183.12061-.26464.18994-.39355.05176-.09717.11133-.189.167-.2832.07666-.13037.15087-.26172.23584-.38819.0664-.09863.14062-.1914.21093-.28662.084-.11474.16407-.231.25537-.3418.11622-.14111.2417-.27343.36719-.40625.0542-.0581.10205-.11914.15869-.17578l24-24a8.00053,8.00053,0,0,1,11.31446,11.31446L99.314,128H168V104a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176 104 176 136 80 136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "104 112 80 136 104 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconKeyboard = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.51465,47.51465H32.48535a16.99025,16.99025,0,0,0-16.9707,16.9707v127.0293a16.99025,16.99025,0,0,0,16.9707,16.9707h191.0293a16.99025,16.99025,0,0,0,16.9707-16.9707V64.48535A16.99025,16.99025,0,0,0,223.51465,47.51465ZM64,168H56a8,8,0,0,1,0-16h8a8,8,0,0,1,0,16Zm96,0H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm40,0h-8a8,8,0,0,1,0-16h8a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8.48528",
          strokeWidth: "16.97056",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "56",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "96",
          x2: "200",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "160",
          x2: "64",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "160",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "192",
          y1: "160",
          x2: "200",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconKnife = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.79883,32.2002a28.05536,28.05536,0,0,0-39.667.06933L18.27441,210.41211a8,8,0,0,0,3.92676,13.38281,155.06019,155.06019,0,0,0,34.957,4.00293c33.4209-.001,66.877-10.86914,98.32813-32.1748,31.74512-21.50391,50.14551-45.79981,50.91406-46.82325a8.00114,8.00114,0,0,0-.74316-10.457L186.919,119.60547l44.97753-47.90332A28.03445,28.03445,0,0,0,231.79883,32.2002ZM189.207,144.52148a225.51045,225.51045,0,0,1-43.10351,38.13184c-34.46973,23.23145-69.999,32.665-105.83887,28.13477l106.29492-108.915,23.30176,23.30175q.208.22852.43847.44434l.082.07617Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M146.49075,90.49075,200,144s-72,96-176,72L197.85786,37.85786a20,20,0,1,1,28.28427,28.28427l-50.3665,53.64542",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLamp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M241.22559,152.80762A15.95794,15.95794,0,0,1,227.86768,160H208v32a8,8,0,0,1-16,0V160H136v48h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V160H28.13232a15.99943,15.99943,0,0,1-14.706-22.30273l41.14258-96A15.98283,15.98283,0,0,1,69.27539,32H186.72461a15.98283,15.98283,0,0,1,14.70654,9.69727l41.14258,96A15.95836,15.95836,0,0,1,241.22559,152.80762Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M69.27517,40H186.72483a8,8,0,0,1,7.35316,4.84865l41.14286,96A8,8,0,0,1,227.86769,152H28.13231a8,8,0,0,1-7.35316-11.15135l41.14286-96A8,8,0,0,1,69.27517,40Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "216",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "152",
          x2: "200",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLaptop = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,168h-8V72a24.0275,24.0275,0,0,0-24-24H56A24.0275,24.0275,0,0,0,32,72v96H24a8.00008,8.00008,0,0,0-8,8v16a24.0275,24.0275,0,0,0,24,24H216a24.0275,24.0275,0,0,0,24-24V176A8.00008,8.00008,0,0,0,232,168ZM112,72h32a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16ZM224,192a8.00917,8.00917,0,0,1-8,8H40a8.00917,8.00917,0,0,1-8-8v-8H224Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "88",
          x2: "112",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLayout = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM40,56H216l.00269,40.00012L216,96H40ZM216,200H112V112H216l.00391-.00024L216.00977,200Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLeaf = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M223.98633,39.53027a8.00074,8.00074,0,0,0-7.5166-7.5166C140.15625,27.521,79.05371,50.53076,52.99756,93.55322A87.32048,87.32048,0,0,0,40.21191,142.687c.56861,15.95679,5.22315,32.06415,13.824,47.96326l100.30737-100.307a7.99984,7.99984,0,0,1,11.31348,11.31348L65.34961,201.96429c15.89893,8.60053,32.00647,13.25525,47.96338,13.8238,1.11719.04,2.22705.05957,3.33545.05957a87.1861,87.1861,0,0,0,45.79834-12.84473C205.46924,176.94629,228.47461,115.83447,223.98633,39.53027Z"
        }), React.createElement("path", {
          d: "M57.14014,196.11621c-1.09119-1.8186-2.11719-3.64123-3.10425-5.46594l-19.69263,19.6925a8.00018,8.00018,0,0,0,11.31348,11.31446l19.69287-19.69294c-1.82446-.98693-3.647-2.01287-5.46533-3.10394A7.99592,7.99592,0,0,1,57.14014,196.11621Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "160",
          y1: "96",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLifebuoy = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M202.16064,200.833a103.80643,103.80643,0,0,0,0-145.666,7.39654,7.39654,0,0,0-1.32666-1.32666,103.80639,103.80639,0,0,0-145.668,0A7.39654,7.39654,0,0,0,53.83936,55.167a103.80643,103.80643,0,0,0,0,145.666,8.09893,8.09893,0,0,0,.62158.70605,8.01767,8.01767,0,0,0,.70556.6211,103.80643,103.80643,0,0,0,145.667,0,8.01767,8.01767,0,0,0,.70556-.6211A8.09893,8.09893,0,0,0,202.16064,200.833ZM96,128a32,32,0,1,1,32,32A32.03667,32.03667,0,0,1,96,128Zm88.28076-67.59521L155.7876,88.898a47.83822,47.83822,0,0,0-55.5752,0L71.71924,60.40479a87.81956,87.81956,0,0,1,112.56152,0ZM71.71924,195.59521l28.49316-28.49316a47.83822,47.83822,0,0,0,55.5752,0l28.49316,28.49316a87.81956,87.81956,0,0,1-112.56152,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "99.71573",
          y1: "99.71573",
          x2: "60.11775",
          y2: "60.11775",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "156.28427",
          y1: "99.71573",
          x2: "195.88225",
          y2: "60.11775",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "156.28427",
          y1: "156.28427",
          x2: "195.88225",
          y2: "195.88225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "99.71573",
          y1: "156.28427",
          x2: "60.11775",
          y2: "195.88225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLightbulb = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176.00244,232a8.00039,8.00039,0,0,1-8,8h-80a8,8,0,1,1,0-16h80A8.00039,8.00039,0,0,1,176.00244,232Zm40-128a87.54306,87.54306,0,0,1-33.6416,69.208,16.23078,16.23078,0,0,0-6.3584,12.76758V192a16.01833,16.01833,0,0,1-16,16h-64a16.01833,16.01833,0,0,1-16-16v-6.03125A16.01813,16.01813,0,0,0,73.773,173.30957a87.57621,87.57621,0,0,1-33.76953-68.81445c-.2627-47.66211,38.26367-87.34961,85.88183-88.47071A88.00123,88.00123,0,0,1,216.00244,104Zm-32.78808-9.39648a55.85,55.85,0,0,0-45.76465-45.708,7.99953,7.99953,0,1,0-2.6543,15.77734A39.83978,39.83978,0,0,1,167.439,97.27734a8.00261,8.00261,0,0,0,7.87793,6.66407,8.103,8.103,0,0,0,1.34668-.11329A8,8,0,0,0,183.21436,94.60352Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M78.7037,167.0114a79.86051,79.86051,0,0,1-30.70248-62.55993C47.76161,61.08915,82.72,25.04306,126.071,24.02272a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02422a8,8,0,0,1-8,7.99988H95.99984a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.7037,167.0114Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M136.12232,56.784A47.923,47.923,0,0,1,175.327,95.94041",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLightbulbFilament = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,232a8.00008,8.00008,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8.00008,8.00008,0,0,1,176,232Zm40-128a87.54352,87.54352,0,0,1-33.64209,69.208A16.2351,16.2351,0,0,0,176,185.97656V192a16.01833,16.01833,0,0,1-16,16H96a16.01833,16.01833,0,0,1-16-16v-6.03125a16.02005,16.02005,0,0,0-6.23-12.65918,87.57531,87.57531,0,0,1-33.76856-68.81445c-.26318-47.66211,38.2627-87.34961,85.88086-88.47071A88.0021,88.0021,0,0,1,216,104Zm-50.34326,2.34277a8.00182,8.00182,0,0,0-11.31348,0L128,132.68652l-26.34326-26.34375a8.00018,8.00018,0,0,0-11.31348,11.31446L120,147.314V184a8,8,0,0,0,16,0V147.314l29.65674-29.65673A8.00034,8.00034,0,0,0,165.65674,106.34277Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "96 112 128 144 160 112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M78.70372,167.0114a79.86047,79.86047,0,0,1-30.70247-62.55993C47.76163,61.08915,82.72,25.04306,126.071,24.02272a80.00322,80.00322,0,0,1,51.34165,142.89737,24.288,24.288,0,0,0-9.4124,19.05581l-.00009,6.02423a8,8,0,0,1-8,7.99987H95.99986a8,8,0,0,1-8-7.99986l-.0001-6.0311A24.10047,24.10047,0,0,0,78.70372,167.0114Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLightning = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.78857,118.16406a8.00125,8.00125,0,0,0-4.97949-5.6626L153.17871,90.89014l14.666-73.3291a8.00018,8.00018,0,0,0-13.69336-7.02735l-112,120a7.99995,7.99995,0,0,0,3.03955,12.94922l57.63037,21.61133-14.666,73.3291a7.99991,7.99991,0,0,0,13.69336,7.02734l112-120A8.00057,8.00057,0,0,0,215.78857,118.16406Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "96 239.992 112 159.992 48 135.992 160 15.992 144 95.992 208 119.992 96 239.992",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLightningSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M53.91943,34.61475A7.99991,7.99991,0,1,0,42.08057,45.37744l39.24072,43.1648-39.16992,41.968a8.00053,8.00053,0,0,0,3.03955,12.94922l57.63037,21.61133-14.666,73.3291a7.99991,7.99991,0,0,0,13.69336,7.02735l61.85083-66.26892,38.38111,42.21911a7.99991,7.99991,0,1,0,11.83886-10.76269Z"
        }), React.createElement("path", {
          d: "M179.76562,149.25928a8.00013,8.00013,0,0,0,5.86719,2.61865h.05225a8.00073,8.00073,0,0,0,5.84863-2.5415l22.31494-23.90918a7.99994,7.99994,0,0,0-3.03955-12.94922L153.17871,90.8667l14.666-73.3291a8.00018,8.00018,0,0,0-13.69336-7.02735l-45.894,49.17237a8.00006,8.00006,0,0,0-.0708,10.83984Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "39.99609",
          x2: "208",
          y2: "215.99609",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "163.777 167.351 96 239.969 112 159.969 48 135.969 92.198 88.614",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "114.106 65.141 160 15.969 144 95.969 208 119.969 185.685 143.878",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLineSegment = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M214.62793,86.62695a32.0716,32.0716,0,0,1-38.88245,4.94141L91.56836,175.74561a32.00172,32.00172,0,1,1-50.19629-6.37256l.00049-.001a32.05731,32.05731,0,0,1,38.88208-4.94043l84.177-84.17725a32.00172,32.00172,0,1,1,50.19629,6.37256Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "64",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "192",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "175.02944",
          y1: "80.97056",
          x2: "80.97056",
          y2: "175.02944",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLineSegments = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M238.62793,78.62695A31.90289,31.90289,0,0,1,216,87.98438a32.23919,32.23919,0,0,1-7.64124-.91846l-26.629,49.45312c.30212.27979.60412.55957.8977.853a32.00038,32.00038,0,1,1-50.1958,6.37354l-20.17749-20.17774a32.157,32.157,0,0,1-23.89526,3.49805L61.72974,176.519c.30212.27979.60412.55957.8977.853a32.00038,32.00038,0,1,1-45.25537.001l.00049-.001a32.0127,32.0127,0,0,1,30.269-8.43848l26.62866-49.45214c-.302-.28028-.60412-.56006-.8977-.85352a32.03718,32.03718,0,0,1-.00049-45.25488l.00049-.001a32.00216,32.00216,0,0,1,50.1958,38.88232l20.177,20.17725a32.12466,32.12466,0,0,1,23.89624-3.498L194.27026,79.481c-.30212-.27979-.60412-.55957-.8977-.853a32.03718,32.03718,0,0,1-.00049-45.25488l.00049-.001a32.00021,32.00021,0,0,1,45.25537,45.25488Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "40",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "96",
          cy: "96",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "160",
          cy: "160",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "216",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "84.61991",
          y1: "117.13444",
          x2: "51.37906",
          y2: "178.86746",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "143.02941",
          y1: "143.02941",
          x2: "112.97057",
          y2: "112.97057",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "204.62096",
          y1: "77.1325",
          x2: "171.37906",
          y2: "138.86746",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLink = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M122.34315,71.43146l19.799-19.799a44,44,0,1,1,62.22539,62.22539l-28.28427,28.28428a44,44,0,0,1-62.2254,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M133.65685,184.56854l-19.799,19.799a44,44,0,1,1-62.22539-62.22539l28.28427-28.28428a44,44,0,0,1,62.2254,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLinkBreak = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "95.99951",
          y1: "72",
          x2: "95.99951",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "159.99951",
          y1: "208",
          x2: "159.99951",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "71.99951",
          y1: "96",
          x2: "47.99951",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "207.99951",
          y1: "160",
          x2: "183.99951",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M71.02944,128.402,59.71573,139.71573a40,40,0,0,0,56.56854,56.56854L127.598,184.97056",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184.97056,127.598l11.31371-11.31371a40,40,0,0,0-56.56854-56.56854L128.402,71.02944",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLinkSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M156.27783,88.39258,88.396,156.27441a8.00053,8.00053,0,0,0,11.31445,11.31446L167.59229,99.707a8.00053,8.00053,0,1,0-11.31446-11.31445Z"
        }), React.createElement("path", {
          d: "M139.30518,173.25293,111.021,201.53711a39.99918,39.99918,0,1,1-56.56739-56.56738l28.28418-28.28418a8.00053,8.00053,0,1,0-11.31445-11.31446L43.13916,133.65527a56.00023,56.00023,0,0,0,79.19629,79.19629l28.28418-28.28418a8.00052,8.00052,0,0,0-11.31445-11.31445Z"
        }), React.createElement("path", {
          d: "M212.8501,43.14062a56.002,56.002,0,0,0-79.19629,0L105.36963,71.4248a8.00053,8.00053,0,0,0,11.31445,11.31446l28.28418-28.28418a39.99918,39.99918,0,0,1,56.56738,56.56738l-28.28418,28.28418a8.00053,8.00053,0,0,0,11.31446,11.31445l28.28418-28.28418A56.06459,56.06459,0,0,0,212.8501,43.14062Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "94.05511",
          y1: "161.93204",
          x2: "161.93736",
          y2: "94.04979",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLinkSimpleBreak = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M139.30713,173.25293,111.023,201.53711a39.99918,39.99918,0,0,1-56.56738-56.56738l28.28418-28.28418a8.00053,8.00053,0,0,0-11.31446-11.31446L43.14111,133.65527a56.00023,56.00023,0,0,0,79.19629,79.19629l28.28418-28.28418a8.00052,8.00052,0,1,0-11.31445-11.31445Z"
        }), React.createElement("path", {
          d: "M212.85205,43.14062a56.002,56.002,0,0,0-79.19629,0L105.37158,71.4248A8.00053,8.00053,0,1,0,116.686,82.73926l28.28417-28.28418a39.99918,39.99918,0,0,1,56.56739,56.56738l-28.28418,28.28418a8.00052,8.00052,0,0,0,11.31445,11.31445l28.28418-28.28418A56.06457,56.06457,0,0,0,212.85205,43.14062Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M144.96473,178.9102l-28.28427,28.28427a48,48,0,0,1-67.88225-67.88225L77.08248,111.028",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M178.91069,144.96424,207.195,116.68a48,48,0,0,0-67.88225-67.88225L111.02844,77.082",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLinkSimpleHorizontal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M71.97266,127.99219a8.00009,8.00009,0,0,0,8,8h96a8,8,0,0,0,0-16h-96A8.00008,8.00008,0,0,0,71.97266,127.99219Z"
        }), React.createElement("path", {
          d: "M103.96582,167.99609h-40a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16h-40a56,56,0,0,0,0,112h40a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M191.97266,71.99609h-40a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80h-40a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "80",
          y1: "127.99219",
          x2: "176",
          y2: "127.99219",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M103.99316,175.99609h-40a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,175.99609h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLinkSimpleHorizontalBreak = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M103.99316,167.99609h-40a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16h-40a56,56,0,0,0,0,112h40a8,8,0,1,0,0-16Z"
        }), React.createElement("path", {
          d: "M192,71.99609H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M103.99316,175.99609h-40a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,175.99609h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLinkedinLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M212,28H44A16.01817,16.01817,0,0,0,28,44V212a16.01833,16.01833,0,0,0,16,16H212a16.01833,16.01833,0,0,0,16-16V44A16.01817,16.01817,0,0,0,212,28ZM96,176.001a8,8,0,1,1-16,0v-64a8,8,0,0,1,16,0ZM88,92a12,12,0,1,1,12-12A12,12,0,0,1,88,92Zm96,84.001a8,8,0,1,1-16,0v-36a20,20,0,0,0-40,0v36a8,8,0,1,1-16,0v-64a7.99729,7.99729,0,0,1,15.79492-1.77857A35.98125,35.98125,0,0,1,184,140.001Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "120",
          y1: "112.00094",
          x2: "120",
          y2: "176.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "112.00094",
          x2: "88",
          y2: "176.00094",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M120,140.00094a28,28,0,1,1,56,0v36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "88",
          cy: "79.99998",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconList = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconListBullets = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "88",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88.00614",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88.00614",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "44",
          cy: "64",
          r: "12"
        }), React.createElement("circle", {
          cx: "44",
          cy: "128",
          r: "12"
        }), React.createElement("circle", {
          cx: "44",
          cy: "192",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconListDashes = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96.00614",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96.00614",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "64",
          x2: "56",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.00614",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.00614",
          y1: "192",
          x2: "56",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconListNumbers = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "104",
          y1: "128",
          x2: "215.99902",
          y2: "128",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "64",
          x2: "215.99902",
          y2: "64",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "103.99902",
          y1: "192",
          x2: "215.99902",
          y2: "192",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "40 60 56 52 56 107.994",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M41.10018,152.55059A14.00226,14.00226,0,1,1,65.609,165.82752L40,200H68",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconListPlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "192",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "192",
          x2: "232",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLock = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,80H172V52a44,44,0,0,0-88,0V80H48A16.01833,16.01833,0,0,0,32,96V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,208,80Zm-80.00586,84a12,12,0,1,1,12-12A12,12,0,0,1,127.99414,164ZM156,80H100V52a28,28,0,0,1,56,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "152",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLockKey = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "127.99414",
          cy: "140",
          r: "12"
        }), React.createElement("path", {
          d: "M207.99414,80h-36V52a44,44,0,1,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99414,80Zm-72,86.82935V184a8,8,0,1,1-16,0V166.82935a28,28,0,1,1,16,0Zm20-86.82935h-56V52a28,28,0,1,1,56,0Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "127.99414",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.99414",
          y1: "160",
          x2: "127.99414",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "39.99414",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M91.99414,88V52a36,36,0,1,1,72,0V88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLockKeyOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "127.99414",
          cy: "140",
          r: "12"
        }), React.createElement("path", {
          d: "M207.99414,80h-108V52a28,28,0,1,1,56,0,8,8,0,0,0,16,0,44,44,0,1,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99414,80Zm-72,86.82935V184a8,8,0,1,1-16,0V166.82935a28,28,0,1,1,16,0Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "127.99414",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.99414",
          y1: "160",
          x2: "127.99414",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "39.99414",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M91.99414,88V52a36,36,0,1,1,72,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLockLaminated = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.96484,80h-36V52a44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.96484,80Zm-108-28a28,28,0,0,1,56,0V80h-56Zm84,140h-112a8,8,0,1,1,0-16h112a8,8,0,0,1,0,16Zm0-32h-112a8,8,0,1,1,0-16h112a8,8,0,0,1,0,16Zm0-32h-112a8,8,0,1,1,0-16h112a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "39.99414",
          y1: "120",
          x2: "215.99414",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "39.99414",
          y1: "152",
          x2: "215.99414",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "39.99414",
          y1: "184",
          x2: "215.99414",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "39.99414",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M91.99414,88V52a36,36,0,1,1,72,0V88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLockLaminatedOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99463,80h-108V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99463,80ZM183.99268,192H71.99463a8,8,0,0,1,0-16H183.99268a8,8,0,0,1,0,16Zm0-32H71.99463a8,8,0,0,1,0-16H183.99268a8,8,0,0,1,0,16Zm0-32H71.99463a8,8,0,0,1,0-16H183.99268a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "39.99414",
          y1: "120",
          x2: "215.99414",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "39.99414",
          y1: "152",
          x2: "215.99414",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "39.99414",
          y1: "184",
          x2: "215.99414",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "39.99414",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M91.99414,88V52a36,36,0,1,1,72,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLockOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16.01833,16.01833,0,0,0,32,96V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,208,80Zm-80.00586,84a12,12,0,1,1,12-12A12,12,0,0,1,127.99414,164Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "152",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLockSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99463,80h-36V52a44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99463,80Zm-108-28a28,28,0,0,1,56,0V80h-56Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "39.99414",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M91.99414,88V52a36,36,0,1,1,72,0V88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconLockSimpleOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99463,80h-108V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.99463,80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "39.99414",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M91.99414,88V52a36,36,0,1,1,72,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMagicWand = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248,152a8.00008,8.00008,0,0,1-8,8H224v16a8,8,0,0,1-16,0V160H192a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8.00008,8.00008,0,0,1,248,152ZM64,68H76V80a8,8,0,0,0,16,0V68h12a8,8,0,0,0,0-16H92V40a8,8,0,0,0-16,0V52H64a8,8,0,0,0,0,16ZM184,192h-8v-8a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0v-8h8a8,8,0,0,0,0-16Zm-2.34619-74.33984L75.31445,224a16.02252,16.02252,0,0,1-22.62793.001L32,203.31348a15.99888,15.99888,0,0,1,.001-22.62793L180.68555,32a16.02162,16.02162,0,0,1,22.62793-.001L224,52.68652a15.99888,15.99888,0,0,1-.001,22.62793l-42.33886,42.33887-.00293.00342ZM155.314,80,176,100.686,212.68555,64l.001-.001.00684-.00732L192,43.31348Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "216",
          y1: "128",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "192",
          y1: "152",
          x2: "240",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "84",
          y1: "40",
          x2: "84",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "60",
          x2: "104",
          y2: "60",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "184",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "200",
          x2: "184",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "14.86292",
          y: "105.37258",
          width: "226.27417",
          height: "45.25483",
          rx: "8",
          transform: "translate(-53.01934 128) rotate(-45)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "144",
          y1: "80",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMagnet = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M206.9541,50.24707A87.40283,87.40283,0,0,0,144.58789,24.001C144.47461,24,144.36426,24,144.252,24A87.41952,87.41952,0,0,0,82,49.80957L48.30078,83.92084l-.001.001-.00146.00147L15.89746,116.7207a16.03806,16.03806,0,0,0,.06836,22.55957l28.65332,28.65332a15.889,15.889,0,0,0,11.3125,4.68653h.0957a15.88936,15.88936,0,0,0,11.35157-4.81836l32.0205-32.77661.002-.00171.00293-.003,33.57226-34.36518a16.07987,16.07987,0,0,1,22.374-.18847,15.58821,15.58821,0,0,1,4.72558,11.19629,16.88015,16.88015,0,0,1-4.84472,11.99316l-34.10694,33.07623-.00732.00678-.00391.004L88.2627,188.60156a15.99983,15.99983,0,0,0-.17579,22.79981l28.6543,28.65429a16.052,16.052,0,0,0,22.5166.10938l32.957-32.31885.00489-.00439.00293-.0033,33.55273-32.903C240.22363,140.48633,240.75293,84.55176,206.9541,50.24707ZM55.93359,156.61914,27.2793,127.96582l26.71191-27.03827L82.49512,129.4314Zm72.12207,72.12207L99.40137,200.08789l27.28711-26.46283,28.50439,28.50421Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M127.28929,95.02944a24.00012,24.00012,0,0,1,33.60985-.325c9.693,9.33217,9.46338,25.13406-.0509,34.64834L93.83171,194.34449a8,8,0,0,0-.08742,11.3998L122.3982,234.3982a8,8,0,0,0,11.25812.055l66.46192-65.17456C231.30992,138.087,232.21531,87.284,201.25572,55.862a80.00007,80.00007,0,0,0-113.56441-.43051l-66.103,66.91189a8,8,0,0,0,.03429,11.27921l28.65427,28.65427a8,8,0,0,0,11.37925-.0663Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "126.77456",
          y1: "162.39696",
          x2: "166.56227",
          y2: "202.18467",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "53.95657",
          y1: "89.57897",
          x2: "93.74372",
          y2: "129.36612",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMagnetStraight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,40H160a16.01833,16.01833,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16.01833,16.01833,0,0,0,96,40H56A16.01833,16.01833,0,0,0,40,56v88a87.99955,87.99955,0,0,0,87.99512,88c.22265,0,.44726-.001.6709-.00195,48.15625-.35743,87.334-40.28321,87.334-89.002V56A16.01833,16.01833,0,0,0,200,40Zm0,16V96H160V56ZM96,56V96H56V56Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "96",
          x2: "104",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v86.9957c0,44.11169-35.28293,80.675-79.39341,81.00205A80.00008,80.00008,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMagnifyingGlass = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M175.99609,116a60,60,0,1,1-60-60A60.06812,60.06812,0,0,1,175.99609,116Zm53.65137,113.65771a8.0006,8.0006,0,0,1-11.31445,0l-43.2229-43.2229a92.11513,92.11513,0,1,1,11.31445-11.31347l43.2229,43.2229A8,8,0,0,1,229.64746,229.65771ZM115.99609,192a76,76,0,1,0-76-76A76.08614,76.08614,0,0,0,115.99609,192Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "175.39356",
          y1: "175.40039",
          x2: "223.99414",
          y2: "224.00098",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMagnifyingGlassMinus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.64746,218.34131l-43.2229-43.22284a92.11145,92.11145,0,1,0-11.31445,11.31341l43.2229,43.22291a8.00018,8.00018,0,0,0,11.31445-11.31348ZM147.99609,124h-64a8,8,0,1,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "116",
          cy: "115.99707",
          r: "84",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "175.39356",
          y1: "175.39747",
          x2: "223.99414",
          y2: "223.99805",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMagnifyingGlassPlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.64746,218.34033l-43.2229-43.22284a92.11133,92.11133,0,1,0-11.31445,11.31342l43.2229,43.2229a8.00018,8.00018,0,1,0,11.31445-11.31348ZM147.99609,124h-24v24a8,8,0,0,1-16,0V124h-24a8,8,0,1,1,0-16h24V84a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "116",
          y1: "84",
          x2: "116",
          y2: "148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "116",
          cy: "115.99609",
          r: "84",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "175.39356",
          y1: "175.39649",
          x2: "223.99414",
          y2: "223.99707",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMapPin = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M127.99414,15.9971a88.1046,88.1046,0,0,0-88,88c0,75.29688,80,132.17188,83.40625,134.55469a8.023,8.023,0,0,0,9.1875,0c3.40625-2.38281,83.40625-59.25781,83.40625-134.55469A88.10459,88.10459,0,0,0,127.99414,15.9971ZM128,72a32,32,0,1,1-32,32A31.99909,31.99909,0,0,1,128,72Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMapPinLine = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M199.99975,224h-49.4602a266.47606,266.47606,0,0,0,23.49731-23.75049c27.45215-31.5708,41.96289-64.853,41.96289-96.24951a88,88,0,0,0-176,0c0,31.39648,14.51075,64.67871,41.96289,96.24951A266.476,266.476,0,0,0,105.46,224H55.99975a8,8,0,0,0,0,16h144a8,8,0,0,0,0-16ZM128,72a32,32,0,1,1-32,32A31.99971,31.99971,0,0,1,128,72Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMapTrifold = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M228.9226,49.69434a7.99952,7.99952,0,0,0-6.86328-1.45557L160.93066,63.521,99.57788,32.84448c-.01758-.00879-.03613-.01416-.054-.0227a8.0283,8.0283,0,0,0-.86059-.363c-.05152-.01831-.10425-.03125-.156-.04858q-.36695-.12121-.7456-.207c-.082-.01855-.16407-.03515-.24659-.051q-.35778-.06921-.72338-.105c-.06934-.00708-.13843-.01709-.208-.02222a7.93012,7.93012,0,0,0-.94019-.01684l-.02392.00219a7.97484,7.97484,0,0,0-.8833.09571c-.1001.01611-.19874.03857-.29834.05859-.12623.0249-.25245.04273-.37867.07422l-64,16A7.99985,7.99985,0,0,0,23.99975,56V200a8.00045,8.00045,0,0,0,9.94043,7.76123L95.06909,192.479l61.35254,30.67627c.03637.01807.0747.03.11133.04761q.32482.15673.66308.28442c.04175.01563.08277.0337.125.04883a7.95445,7.95445,0,0,0,.81494.24146c.04273.01025.08545.01782.12818.02734q.36034.0802.72925.12671c.05078.00659.10131.01392.15234.01929a7.29318,7.29318,0,0,0,1.89233-.02222c.11182-.01465.22144-.04248.33277-.06177.18994-.0332.37939-.05835.56933-.10571l64-16A8,8,0,0,0,231.99975,200V56A7.99871,7.99871,0,0,0,228.9226,49.69434ZM151.99975,203.05566l-48-24V52.94434l48,24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "96 184 32 200 32 56 96 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "160 216 96 184 96 40 160 72 160 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "160 72 224 56 224 200 160 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMarkerCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M201.53906,54.46094A103.99994,103.99994,0,1,0,54.46094,201.53906,103.99994,103.99994,0,1,0,201.53906,54.46094ZM88,206.37012V176h80v30.37012A88.38031,88.38031,0,0,1,88,206.37012ZM104,136h43.78662c.01514.00006.03027.00195.04541.00195.01148,0,.02344-.00189.03491-.00195H152v24H104Zm86.22461,54.22559c-2.0022,2.00225-4.08447,3.87616-6.22461,5.64471V176a16.01833,16.01833,0,0,0-16-16V136a16.01128,16.01128,0,0,0-13.7356-15.82068L143.60156,73.2998a15.99991,15.99991,0,0,0-31.20312-.00048l-10.66284,46.88A16.01132,16.01132,0,0,0,88,136v24a16.01833,16.01833,0,0,0-16,16v19.8703c-2.14014-1.76855-4.22241-3.64246-6.22461-5.64471a88,88,0,1,1,124.44922,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,211.16115V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.16442",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M147.83843,136,135.83184,78.36837c-1.769-8.49116-13.89469-8.49116-15.66368,0L108.16157,136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMartini = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M237.65723,45.65674A8.0001,8.0001,0,0,0,232,32H24a8.0001,8.0001,0,0,0-5.65723,13.65674L120,147.314V208H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V147.314ZM212.68652,48l-16,16H59.31348l-16-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "24 40 232 40 128 144 24 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "144",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "72",
          x2: "200",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMathOperations = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M104,176H80V152a8,8,0,0,0-16,0v24H40a8,8,0,0,0,0,16H64v24a8,8,0,0,0,16,0V192h24a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M104,64H40a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M152,176.06641h64a8,8,0,0,0,0-16H152a8,8,0,0,0,0,16Z"
        }), React.createElement("path", {
          d: "M216,191.93359H152a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M154.34326,101.65674a7.99945,7.99945,0,0,0,11.31348,0L184,83.31348l18.34326,18.34326a7.99984,7.99984,0,1,0,11.31348-11.31348L195.3136,72l18.34314-18.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L184,60.68652,165.65674,42.34326a7.99984,7.99984,0,0,0-11.31348,11.31348L172.6864,72,154.34326,90.34326A7.99915,7.99915,0,0,0,154.34326,101.65674Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "184",
          x2: "104",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72",
          y1: "152",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "72",
          x2: "40",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "168.0664",
          x2: "152",
          y2: "168.0664",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "199.9336",
          x2: "152",
          y2: "199.9336",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "96",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMedal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "127.99414",
          cy: "96",
          r: "56"
        }), React.createElement("path", {
          d: "M127.99414,8A87.96624,87.96624,0,0,0,72,163.8374V240a7.99951,7.99951,0,0,0,11.57812,7.15527l44.415-22.21093,44.42969,22.21142A8,8,0,0,0,184,240V163.82764A87.96617,87.96617,0,0,0,127.99414,8Zm0,160a72,72,0,1,1,72-72A72.08124,72.08124,0,0,1,127.99414,168Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "127.99414",
          cy: "96",
          r: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "127.99414",
          cy: "96",
          r: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "176 159.995 176 240 127.993 216 80 240 80 160.002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMediumLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,128c0,37.49512-28.71,68-64,68S8,165.49514,8,128,36.71,60,72,60,136,90.5049,136,128Zm48-64c-5.68262,0-16.39941,2.76074-24.32373,21.251C154.72607,96.8008,152,111.98342,152,128s2.72607,31.19922,7.67627,42.749C167.60059,189.23928,178.31738,192,184,192s16.39941-2.76074,24.32373-21.251C213.27393,159.19924,216,144.01662,216,128s-2.72607-31.19922-7.67627-42.749C200.39941,66.76076,189.68262,64,184,64Zm56,0a8.00039,8.00039,0,0,0-8,8V184a8,8,0,0,0,16,0V72A8.00039,8.00039,0,0,0,240,64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("ellipse", {
          cx: "72",
          cy: "128",
          rx: "56",
          ry: "60",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("ellipse", {
          cx: "184",
          cy: "128",
          rx: "24",
          ry: "55.99999",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "240",
          y1: "72.00003",
          x2: "240",
          y2: "184.00001",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMegaphone = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M16.0001 120.742C16.0001 108.012 21.0572 95.8031 30.059 86.8014C39.0607 77.7996 51.2697 72.7425 64.0001 72.7425H104C104.5 72.7425 156.4 72.0425 205.7 30.6425C208.037 28.6703 210.893 27.4137 213.926 27.0235C216.959 26.6333 220.04 27.126 222.8 28.4425C225.576 29.7048 227.924 31.7482 229.558 34.3232C231.192 36.8982 232.041 39.8932 232 42.9425V198.542C232.041 201.592 231.192 204.587 229.558 207.162C227.924 209.737 225.576 211.78 222.8 213.042C220.667 214.023 218.348 214.535 216 214.542C212.237 214.567 208.587 213.256 205.7 210.842C167.8 179.042 128.5 171.242 112 169.342V204.442C112.01 207.074 111.366 209.666 110.127 211.988C108.888 214.309 107.092 216.286 104.9 217.742L93.9001 225.142C91.7342 226.513 89.2835 227.369 86.7356 227.647C84.1877 227.924 81.6101 227.615 79.2001 226.742C76.8073 225.813 74.6752 224.318 72.986 222.385C71.2968 220.452 70.1008 218.138 69.5001 215.642L57.6001 168.342C46.0945 166.752 35.5501 161.061 27.9068 152.315C20.2635 143.569 16.0353 132.357 16.0001 120.742V120.742ZM85.0001 211.742L96.0001 204.442V168.742H74.2001L85.0001 211.742ZM64.0001 152.742H96.0001V88.7425H64.0001C55.5132 88.7425 47.3738 92.1139 41.3727 98.1151C35.3715 104.116 32.0001 112.256 32.0001 120.742C32.0001 129.229 35.3715 137.369 41.3727 143.37C47.3738 149.371 55.5132 152.742 64.0001 152.742Z",
          fill: "currentColor"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M104 80.7434V204.443C104.012 205.773 103.688 207.084 103.059 208.255C102.43 209.426 101.515 210.42 100.4 211.143L89.3997 218.443C88.334 219.155 87.1131 219.6 85.8396 219.741C84.5661 219.883 83.2773 219.716 82.0816 219.255C80.8859 218.795 79.8184 218.054 78.9688 217.094C78.1193 216.135 77.5125 214.986 77.1997 213.743L63.9997 160.743",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "18",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), React.createElement("path", {
          d: "M64 160.744C53.3913 160.744 43.2172 156.529 35.7157 149.028C28.2143 141.527 24 131.352 24 120.744C24 110.135 28.2143 99.9609 35.7157 92.4594C43.2172 84.958 53.3913 80.7437 64 80.7437H104C104 80.7437 158.5 80.7437 210.9 36.8437C212.065 35.8792 213.481 35.265 214.981 35.0723C216.482 34.8795 218.006 35.1162 219.377 35.7548C220.749 36.3934 221.911 37.4077 222.729 38.6802C223.547 39.9526 223.988 41.4309 224 42.9437V198.544C223.988 200.056 223.547 201.535 222.729 202.807C221.911 204.08 220.749 205.094 219.377 205.733C218.006 206.371 216.482 206.608 214.981 206.415C213.481 206.222 212.065 205.608 210.9 204.644C158.5 160.744 104 160.744 104 160.744H64Z",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "18",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMegaphoneSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M220.47461,86.64062,138.395,62.70068l-.05127-.01513L44.47363,35.30664A15.99966,15.99966,0,0,0,23.99414,50.667V189.333A16.0247,16.0247,0,0,0,39.94922,205.3457a16.16154,16.16154,0,0,0,4.52539-.65234L128,180.332V192a16.01833,16.01833,0,0,0,16,16h32a16.01833,16.01833,0,0,0,16-16V161.665l28.47363-8.30469A16.0825,16.0825,0,0,0,231.99414,138V102A16.08075,16.08075,0,0,0,220.47461,86.64062ZM176,192H144V175.665l32-9.333Zm39.99414-54-34.35352,10.01953-.02832.0083L144,158.99805V81.00146L215.99414,102Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M31.99414,50.66667V189.33333a8,8,0,0,0,10.24,7.68l176-51.33333a8,8,0,0,0,5.76-7.68V102a8,8,0,0,0-5.76-7.68l-176-51.33333A8,8,0,0,0,31.99414,50.66667Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,155.665V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.335",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMessengerLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104.02809,104.02809,0,0,0,36.811,178.041l-8.54737,29.915a16.00023,16.00023,0,0,0,19.77979,19.78027l29.916-8.54639A104.00746,104.00746,0,1,0,128,24Zm53.65674,93.65674-32,32a7.99945,7.99945,0,0,1-11.31348,0L112,123.3135,85.65674,149.65676a7.99984,7.99984,0,1,1-11.31348-11.31348l32-32a8,8,0,0,1,11.31348,0L144,132.68654l26.34326-26.34326a7.99984,7.99984,0,0,1,11.31348,11.31348Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M45.42853,176.99811A95.95978,95.95978,0,1,1,79.00228,210.5717l.00023-.001L45.84594,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "80 144 112 112 144 144 176 112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMicrophone = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M127.99414,175.99609a48.05083,48.05083,0,0,0,48-47.99218V63.99609a48,48,0,1,0-96,0v64A48.05249,48.05249,0,0,0,127.99414,175.99609Z"
        }), React.createElement("path", {
          d: "M200.43164,128.05078a8.07828,8.07828,0,0,0-8.82812,7.07813,64.00856,64.00856,0,0,1-127.21875-.00782,8.09865,8.09865,0,0,0-8.82813-7.07031,8.01056,8.01056,0,0,0-7.07812,8.83594A79.60051,79.60051,0,0,0,119.99414,207.251v24.74511a8,8,0,1,0,16,0V207.252a79.577,79.577,0,0,0,71.51563-70.373A8.00321,8.00321,0,0,0,200.43164,128.05078Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M127.99991,24H128a40,40,0,0,1,40,40v64a40,40,0,0,1-40,40h-.00008A39.99991,39.99991,0,0,1,88,128.00009V63.99991A39.99991,39.99991,0,0,1,127.99991,24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M199.56055,136.00017a72.00715,72.00715,0,0,1-143.12111-.00011",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMicrophoneSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M213.91992,210.61816l-160-176A8.0006,8.0006,0,1,0,42.08008,45.38184L80,87.09375V128a47.9902,47.9902,0,0,0,73.91211,40.39685l10.875,11.96252A63.99208,63.99208,0,0,1,64.39062,135.12109a7.9996,7.9996,0,0,0-15.90234,1.75782A79.83705,79.83705,0,0,0,120,207.59692V232a8,8,0,0,0,16,0V207.59082a79.72,79.72,0,0,0,39.62012-15.31506l26.46,29.10608a8.0006,8.0006,0,1,0,11.83984-10.76368Z"
        }), React.createElement("path", {
          d: "M162.08008,129.81055A8.0004,8.0004,0,0,0,176,124.42871V64A48.0045,48.0045,0,0,0,87.15527,38.77539a8.00113,8.00113,0,0,0,.88379,9.59082Z"
        }), React.createElement("path", {
          d: "M192.165,161.665a7.99262,7.99262,0,0,0,10.36426-4.53613,79.61568,79.61568,0,0,0,4.98242-20.25,7.9996,7.9996,0,0,0-15.90235-1.75782,63.67417,63.67417,0,0,1-3.98046,16.17969A7.99991,7.99991,0,0,0,192.165,161.665Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176.42693,181.28138A72.00558,72.00558,0,0,1,56.43944,136.00006",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M154.90249,157.60205A39.85421,39.85421,0,0,1,128.00009,168H128a40,40,0,0,1-40-40V84.00214",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M93.95906,42.98434A39.97457,39.97457,0,0,1,128,24h.00008A39.99991,39.99991,0,0,1,168,63.99991V124.4291",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M199.56055,136.00017a71.54827,71.54827,0,0,1-4.48193,18.2151",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMinus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40 128.18H216",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "18",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMinusCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm40,112H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMoney = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,56H24A16.01833,16.01833,0,0,0,8,72V184a16.01833,16.01833,0,0,0,16,16H232a16.01833,16.01833,0,0,0,16-16V72A16.01833,16.01833,0,0,0,232,56ZM74.95947,184,24,140.32056V115.67944L74.95947,72H181.04053l50.96338,43.68262.002,24.63281L181.04053,184ZM168,128a40,40,0,1,1-40-40A40.04584,40.04584,0,0,1,168,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "64",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "192",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "64",
          x2: "16",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "192",
          x2: "16",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMonitor = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("rect", {
          x: "24",
          y: "40.0002",
          width: "208",
          height: "160",
          rx: "24"
        }), React.createElement("path", {
          d: "M160,216.0002H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMonitorPlay = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,224a8.00008,8.00008,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8.00008,8.00008,0,0,1,168,224ZM232,64V176a24.0275,24.0275,0,0,1-24,24H48a24.0275,24.0275,0,0,1-24-24V64A24.02734,24.02734,0,0,1,48,40H208A24.02734,24.02734,0,0,1,232,64Zm-68,56a8.00014,8.00014,0,0,0-3.70508-6.74927l-44-28A7.99989,7.99989,0,0,0,104,92v56a7.99991,7.99991,0,0,0,12.29492,6.74927l44-28A8.00014,8.00014,0,0,0,164,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "160 120 112 88 112 152 160 120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMoon = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.30762,150.29346a8.00288,8.00288,0,0,0-10.01416-5.28955A84.03122,84.03122,0,0,1,111.01514,41.6377a8.00207,8.00207,0,0,0-9.96582-9.96192,100.01386,100.01386,0,1,0,123.29,123.2207A8.0018,8.0018,0,0,0,224.30762,150.29346Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMoonStars = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M240,80H224V64a8,8,0,0,0-16,0V80H192a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V96h16a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M152,48h8v8a8,8,0,0,0,16,0V48h8a8,8,0,0,0,0-16h-8V24a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16Z"
        }), React.createElement("path", {
          d: "M216.457,144.64941a7.985,7.985,0,0,0-2.15576.35254A84.0314,84.0314,0,0,1,111.01514,41.6377a8.00171,8.00171,0,0,0-9.96485-9.96192A100.01377,100.01377,0,1,0,224.33936,154.89746a8.00114,8.00114,0,0,0-7.88233-10.24805Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "240",
          y1: "88",
          x2: "192",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "24",
          x2: "168",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216.66238,152.64951A92.03175,92.03175,0,0,1,103.35039,39.338l.00255.00078A92.01376,92.01376,0,1,0,216.66147,152.64624Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMouse = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M148,24H108A64.07239,64.07239,0,0,0,44,88v80a64.07239,64.07239,0,0,0,64,64h40a64.07239,64.07239,0,0,0,64-64V88A64.07239,64.07239,0,0,0,148,24Zm48,64v16H136V40h12A48.05468,48.05468,0,0,1,196,88ZM108,40h12v64H60V88A48.05468,48.05468,0,0,1,108,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "52",
          y1: "112",
          x2: "204",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "112",
          x2: "128.00007",
          y2: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMouseSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M148,24H108A64.07207,64.07207,0,0,0,44,88v80a64.07207,64.07207,0,0,0,64,64h40a64.07207,64.07207,0,0,0,64-64V88A64.07207,64.07207,0,0,0,148,24Zm-12,88a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "128",
          y1: "112",
          x2: "128.00007",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMusicNote = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M210.29883,56.3374l-80-24A7.99991,7.99991,0,0,0,120,40V87.82031q-.0044.1831,0,.36573v60.07519A47.97353,47.97353,0,1,0,136,184V98.75195l69.70117,20.91065A7.99991,7.99991,0,0,0,216,112V64A7.99972,7.99972,0,0,0,210.29883,56.3374Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "128 184 128 40 208 64 208 112 128 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMusicNoteSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M210.29883,56.3374l-80-24A7.99991,7.99991,0,0,0,120,40V148.26123A47.97353,47.97353,0,1,0,136,184V50.75244L205.70117,71.6626a8,8,0,1,0,4.59766-15.3252Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "128 184 128 40 208 64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMusicNotes = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M212.916,25.69144a7.896,7.896,0,0,0-6.85938-1.45313l-128,32a7.99686,7.99686,0,0,0-6.0625,7.75782v110.0957a35.98113,35.98113,0,1,0,16,29.9043V110.23831l112-28v59.85352a35.98113,35.98113,0,1,0,16,29.9043v-140A8.01525,8.01525,0,0,0,212.916,25.69144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "80",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconMusicNotesSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M212.92285,25.69434a7.99949,7.99949,0,0,0-6.86328-1.45557l-128,32A7.99964,7.99964,0,0,0,72,64V174.0835A35.98908,35.98908,0,1,0,88,204V70.24609l112-28V142.0835A35.98908,35.98908,0,1,0,216,172V32A7.99874,7.99874,0,0,0,212.92285,25.69434Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNavigationArrow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M219.4873,88.43359,50.18457,29.82812A15.99955,15.99955,0,0,0,29.83105,50.18164l58.6045,169.30371A15.75666,15.75666,0,0,0,103.53516,230.251c.09863,0,.19922-.001.29785-.00293a15.76424,15.76424,0,0,0,15.01465-11.292l23.55566-76.55468L218.96,118.8457a16.00021,16.00021,0,0,0,.52734-30.41211Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M37.39014,47.56448l58.605,169.30343a8,8,0,0,0,15.20612-.2642l23.5556-76.5557a8,8,0,0,1,5.29355-5.29355l76.5557-23.5556a8,8,0,0,0,.2642-15.20612L47.56692,37.3877A8,8,0,0,0,37.39014,47.56448Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNewspaper = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,48H56A16.01833,16.01833,0,0,0,40,64V184a8,8,0,0,1-16,0V88A8,8,0,0,0,8,88v96.10645A24.02715,24.02715,0,0,0,32,208H208a24.0275,24.0275,0,0,0,24-24V64A16.01833,16.01833,0,0,0,216,48ZM176,152H96a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,200a16,16,0,0,1-16-16V88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNewspaperClipping = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M72,104h32v48H72ZM232,56V216a7.99951,7.99951,0,0,1-11.57812,7.15527L192,208.94434l-28.42188,14.21093a8.00049,8.00049,0,0,1-7.15624,0L128,208.94434,99.57812,223.15527a7.99634,7.99634,0,0,1-7.15624,0L64,208.94434,35.57812,223.15527A7.99951,7.99951,0,0,1,24,216V56A16.01833,16.01833,0,0,1,40,40H216A16.01833,16.01833,0,0,1,232,56ZM120,96a8.00039,8.00039,0,0,0-8-8H64a8.00039,8.00039,0,0,0-8,8v64a8.00039,8.00039,0,0,0,8,8h48a8.00039,8.00039,0,0,0,8-8Zm80,48a8.00039,8.00039,0,0,0-8-8H144a8,8,0,0,0,0,16h48A8.00039,8.00039,0,0,0,200,144Zm0-32a8.00039,8.00039,0,0,0-8-8H144a8,8,0,0,0,0,16h48A8.00039,8.00039,0,0,0,200,112Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "64",
          y: "96",
          width: "48",
          height: "64",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNote = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "160",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "215.276 159.992 160 159.992 160 215.272",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNoteBlank = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H156.68652A15.89354,15.89354,0,0,0,168,219.31348L219.31348,168A15.89557,15.89557,0,0,0,224,156.68652V48A16.01833,16.01833,0,0,0,208,32ZM160,204.68652V159.99219h44.69458Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M156.68629,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.68629a8,8,0,0,1-2.34315,5.65686l-51.3137,51.3137A8,8,0,0,1,156.68629,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "215.281 159.992 160 159.992 160 215.272",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNotePencil = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.99414,120v88a16.01833,16.01833,0,0,1-16,16h-160a16.01833,16.01833,0,0,1-16-16V48a16.01833,16.01833,0,0,1,16-16h88a8,8,0,0,1,0,16h-88V208h160V120a8,8,0,0,1,16,0Zm5.65723-50.34326-96,96A8.00076,8.00076,0,0,1,127.99414,168h-32a8.00039,8.00039,0,0,1-8-8V128a8.00035,8.00035,0,0,1,2.34277-5.65674l96-96a8.00034,8.00034,0,0,1,11.31446,0l32,32A8,8,0,0,1,229.65137,69.65674ZM212.68066,64,191.99414,43.31348,179.30811,56l20.68628,20.68652Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "128 160 96 160 96 128 192 32 224 64 128 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "56",
          x2: "200",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNotebook = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM80,208H48V48H80Zm96-56H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "112",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "80",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNotepad = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,32.00586H184v-8a8,8,0,1,0-16,0v8H136v-8a8,8,0,1,0-16,0v8H88v-8a8,8,0,0,0-16,0v8H56a16.01833,16.01833,0,0,0-16,16v152a32.03667,32.03667,0,0,0,32,32H184a32.03667,32.03667,0,0,0,32-32v-152A16.01833,16.01833,0,0,0,200,32.00586Zm-40,136H96a8,8,0,1,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,1,1,0-16h64a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "128.00586",
          x2: "160",
          y2: "128.00586",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "160.00586",
          x2: "160",
          y2: "160.00586",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,40.00586H200a8,8,0,0,1,8,8v152a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24v-152A8,8,0,0,1,56,40.00586Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "24.00586",
          x2: "80",
          y2: "56.00586",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "24.00586",
          x2: "128",
          y2: "56.00586",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "24.00586",
          x2: "176",
          y2: "56.00586",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNotification = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,128v80a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V56A16.01833,16.01833,0,0,1,48,40h80a8,8,0,0,1,0,16H48V208H200V128a8,8,0,0,1,16,0ZM196,24a36,36,0,1,0,36,36A36.04061,36.04061,0,0,0,196,24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "196",
          cy: "60",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleEight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm24.03125,150.04688a33.99637,33.99637,0,1,1-48.0625-48.09375,30.89828,30.89828,0,0,1,3.10645-2.50782c-.0918-.08984-.20313-.15136-.29395-.24218a29.98907,29.98907,0,0,1,.01563-42.42188c11.29687-11.3125,31.09375-11.32812,42.42187.01563a29.98907,29.98907,0,0,1-.01562,42.42187c-.08594.08594-.19141.14355-.27833.22852a30.83759,30.83759,0,0,1,3.12208,2.52148,33.98762,33.98762,0,0,1-.01563,48.07813Z"
        }), React.createElement("path", {
          d: "M137.89063,111.90625a14,14,0,1,0-19.79688-.01562A14.318,14.318,0,0,0,137.89063,111.90625Z"
        }), React.createElement("path", {
          d: "M128,132a17.99808,17.99808,0,0,0-12.73437,30.71875,18.43509,18.43509,0,0,0,25.45312.01563A18,18,0,0,0,128,132Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleFive = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24ZM123.88184,116.002A35.99912,35.99912,0,1,1,98.35449,177.4668a7.99985,7.99985,0,1,1,11.291-11.33594,20.20173,20.20173,0,0,0,28.47461-.001,19.91646,19.91646,0,0,0-.001-28.25976,20.20412,20.20412,0,0,0-28.47461.001,7.99971,7.99971,0,0,1-13.541-6.95214l7.835-48.20215A8.00076,8.00076,0,0,1,111.835,76H152a8,8,0,0,1,0,16H118.63965L114.542,117.21094A36.413,36.413,0,0,1,123.88184,116.002Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,84H111.83477L104,132.20232a27.99935,27.99935,0,1,1,0,39.5969",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm28,152a8,8,0,0,1-16,0V152H100a7.99995,7.99995,0,0,1-7.54395-10.66211l23.998-68A7.99987,7.99987,0,1,1,131.542,78.66211L111.30664,136H140V112a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "123.998 76 100 144 148 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleNine = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M148,112a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,112Zm84,16A104,104,0,1,1,128,24,104.11791,104.11791,0,0,1,232,128Zm-68-16a36,36,0,1,0-36,36q.91626,0,1.82129-.04639l-16.68945,27.94385a8.00015,8.00015,0,1,0,13.73632,8.20508l32.249-53.99512c.09668-.16162.178-.32812.262-.49365A35.76587,35.76587,0,0,0,164,112Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152.24871",
          y1: "126.00466",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleOne = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm12,152a8,8,0,0,1-16,0V98.94434l-11.56348,7.70605a8.00008,8.00008,0,1,1-8.873-13.31445l24-15.99317A8.00039,8.00039,0,0,1,140,84Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "108 99.993 132 84 132 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleSeven = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm31.58984,62.53027-32,96a8.0005,8.0005,0,1,1-15.17968-5.06054L140.90039,92H104a8,8,0,0,1,0-16h48a8.00022,8.00022,0,0,1,7.58984,10.53027Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleSix = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M148,144a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,144Zm84-16A104,104,0,1,1,128,24,104.11791,104.11791,0,0,1,232,128Zm-68,16a36.04061,36.04061,0,0,0-36-36q-.917,0-1.82324.04639l16.6914-27.94385a8.00015,8.00015,0,0,0-13.73632-8.20508l-32.249,53.98926c-.11157.18652-.20776.37793-.30224.56982A35.99384,35.99384,0,1,0,164,144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "103.75129",
          y1: "129.98956",
          x2: "136",
          y2: "76",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "144",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleThree = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm21.458,153.45605a35.99982,35.99982,0,0,1-50.91113,0,8.00052,8.00052,0,0,1,11.31445-11.31445A19.99959,19.99959,0,1,0,124.00293,132a8,8,0,0,1-6.55469-12.58691l19.1875-27.4209H103.99707a8,8,0,0,1,0-16h48a8,8,0,0,1,6.55469,12.58691L137.5332,118.61816A36.019,36.019,0,0,1,149.458,177.45605Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M103.99683,83.99216h48L124.00317,124a28,28,0,1,1-19.799,47.799",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleTwo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm24,143.99414a8,8,0,0,1,0,16H104.31738c-.10644.00391-.21289.00684-.31836.00684a8.00343,8.00343,0,0,1-6.30175-12.93164L141.37012,112.794a16.00416,16.00416,0,1,0-28.11621-15.01954A8,8,0,1,1,98.51758,91.542a32.00411,32.00411,0,1,1,56.01269,30.35547c-.07324.1084-.14843.21484-.22754.31934l-34.30566,45.77734Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberCircleZero = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("ellipse", {
          cx: "128",
          cy: "128",
          rx: "24",
          ry: "40"
        }), React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm0,160c-27.63281,0-40-28.125-40-56s12.36719-56,40-56,40,28.125,40,56S155.63281,184,128,184Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberEight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M175.90234,130.00049a68.12024,68.12024,0,0,0-16.36377-11.356,58.78324,58.78324,0,0,0,9.83643-7.43994,53.63156,53.63156,0,0,0,0-79.0752,61.13213,61.13213,0,0,0-82.75,0,53.63156,53.63156,0,0,0,0,79.0752,58.76231,58.76231,0,0,0,9.83667,7.43994,68.1188,68.1188,0,0,0-16.364,11.35645,61.93012,61.93012,0,0,0,0,91.332,70.79516,70.79516,0,0,0,95.80468-.00049,61.93012,61.93012,0,0,0,0-91.332ZM97.57617,99.53955a37.63752,37.63752,0,0,1,0-55.74609,45.13922,45.13922,0,0,1,60.84766,0,37.63752,37.63752,0,0,1,0,55.74609,45.13783,45.13783,0,0,1-60.84766,0Zm67.375,110.12842a54.80089,54.80089,0,0,1-73.90234.00049,45.936,45.936,0,0,1,0-68.00293,54.80089,54.80089,0,0,1,73.90234-.00049,45.936,45.936,0,0,1,0,68.00293Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M178.76923,71.66667a46.108,46.108,0,0,1-14.87,33.70542,53.13546,53.13546,0,0,1-71.79854,0,45.63467,45.63467,0,0,1,0-67.41085,53.13546,53.13546,0,0,1,71.79854,0A46.108,46.108,0,0,1,178.76923,71.66667Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M188,175.66667a54.49122,54.49122,0,0,1-17.57359,39.83368,62.79644,62.79644,0,0,1-84.85282,0,53.93188,53.93188,0,0,1,0-79.66737,62.79644,62.79644,0,0,1,84.85282,0A54.49124,54.49124,0,0,1,188,175.66667Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberFive = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M165.17383,122.73535a64.11724,64.11724,0,0,1-90.81836,90.53174,7.99968,7.99968,0,1,1,11.28906-11.3374,47.99883,47.99883,0,1,0,0-67.85645,7.99971,7.99971,0,0,1-13.541-6.95215L87.77344,30.7168A8.00076,8.00076,0,0,1,95.66992,24H176a8,8,0,0,1,0,16H102.47461l-11.501,70.75537a64.53171,64.53171,0,0,1,74.2002,11.98Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,32H95.66955L80,128.40465a55.99871,55.99871,0,1,1,0,79.19378",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M180,96V224a8,8,0,0,1-16,0V168H76a8.00033,8.00033,0,0,1-7.54395-10.66211l47.99707-136a7.99988,7.99988,0,0,1,15.0879,5.32422L87.30664,152H164V96a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "123.997 24 76 160 172 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "172",
          y1: "96",
          x2: "172",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberNine = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24a64,64,0,1,0,19.38452,124.99121l-42.49585,70.896a7.99956,7.99956,0,1,0,13.72266,8.22558L182.68848,121.2124c.02881-.04736.05664-.095.08545-.14233l.57666-.96216c.10473-.17456.19409-.354.28393-.533A63.95216,63.95216,0,0,0,128,24Zm41.18115,88.62769-.22778.37988a48.6994,48.6994,0,1,1,.22778-.37988Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "176.48933",
          y1: "115.99533",
          x2: "111.75",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "88",
          r: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberOne = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M131.99574,232a8.00252,8.00252,0,0,1-8.00427-8.00045V46.95129l-35.54531,23.691A8.00167,8.00167,0,1,1,79.56448,57.3298L127.55489,25.344A8.0046,8.0046,0,0,1,140,32.00038V223.99955A8.00252,8.00252,0,0,1,131.99574,232Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "84 63.986 132 32 132 224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSeven = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M112.001,240a8.00547,8.00547,0,0,1-7.59082-10.53164L164.90043,47.99985H80A7.99993,7.99993,0,1,1,80,32h96a8,8,0,0,1,7.58984,10.52969l-64,191.99819A8.00469,8.00469,0,0,1,112.001,240Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "80 40 176 40 112 232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSix = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,104a63.75508,63.75508,0,0,0-19.49121,3.04492l42.36035-70.9436a8.00043,8.00043,0,0,0-13.73828-8.20288L72.6416,135.90332c-.10449.17529-.19385.355-.28369.53442A63.97854,63.97854,0,1,0,128,104Zm0,112a47.97612,47.97612,0,0,1-41.15674-72.67017l.17749-.29736A47.99419,47.99419,0,1,1,128,216Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "79.51067",
          y1: "140.00467",
          x2: "144",
          y2: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "168",
          r: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareEight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M137.89062,111.90625a14,14,0,1,0-19.79687-.01562A14.318,14.318,0,0,0,137.89062,111.90625Z"
        }), React.createElement("path", {
          d: "M128,132a17.99808,17.99808,0,0,0-12.73438,30.71875,18.43511,18.43511,0,0,0,25.45313.01563A18,18,0,0,0,128,132Z"
        }), React.createElement("path", {
          d: "M208,32H48A16.02085,16.02085,0,0,0,32,48V208a16.02085,16.02085,0,0,0,16,16H208a16.02085,16.02085,0,0,0,16-16V48A16.02085,16.02085,0,0,0,208,32ZM152.03125,174.04688a33.99637,33.99637,0,1,1-48.0625-48.09375,30.89715,30.89715,0,0,1,3.10645-2.50782c-.0918-.08984-.20313-.15136-.29395-.24218a29.98908,29.98908,0,0,1,.01562-42.42188c11.29688-11.3125,31.09375-11.32812,42.42188.01563a29.98906,29.98906,0,0,1-.01563,42.42187c-.08593.08594-.1914.14355-.27832.22852a30.83637,30.83637,0,0,1,3.12207,2.52148,33.98761,33.98761,0,0,1-.01562,48.07813Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M150,102a22,22,0,1,1-6.44365-15.55635A21.93114,21.93114,0,0,1,150,102Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M154,150a26,26,0,1,1-7.61522-18.38478A25.91866,25.91866,0,0,1,154,150Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareFive = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM123.88184,112.002A35.99912,35.99912,0,1,1,98.35449,173.4668a7.99985,7.99985,0,1,1,11.291-11.33594,20.20173,20.20173,0,0,0,28.47461-.001,19.91646,19.91646,0,0,0-.001-28.25976,20.20412,20.20412,0,0,0-28.47461.001,7.99971,7.99971,0,0,1-13.541-6.95214l7.835-48.20215A8.00076,8.00076,0,0,1,111.835,72H152a8,8,0,0,1,0,16H118.63965L114.542,113.21094A36.413,36.413,0,0,1,123.88184,112.002Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,80H111.83477L104,128.20232a27.99935,27.99935,0,1,1,0,39.5969",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM156,176a8,8,0,0,1-16,0V152H100a8.00052,8.00052,0,0,1-7.54395-10.6626l23.998-68A8,8,0,0,1,131.542,78.6626L111.30664,136H140V112a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "123.998 76 100 144 148 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareNine = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M148,112a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,112Zm76-64V208a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V48A16.01833,16.01833,0,0,1,48,32H208A16.01833,16.01833,0,0,1,224,48Zm-60,64a36,36,0,1,0-36,36q.91626,0,1.82129-.04614l-16.68945,27.9436a8.00015,8.00015,0,1,0,13.73632,8.20508l32.249-53.99512c.09668-.16162.178-.32812.262-.49341A35.76746,35.76746,0,0,0,164,112Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "152.24871",
          y1: "126.00466",
          x2: "120",
          y2: "180.00001",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareOne = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.02085,16.02085,0,0,0,32,48V208a16.02085,16.02085,0,0,0,16,16H208a16.02085,16.02085,0,0,0,16-16V48A16.02085,16.02085,0,0,0,208,32ZM139.99219,175.99219a8,8,0,0,1-16,0V98.95313l-11.54688,7.69531a7.99982,7.99982,0,1,1-8.875-13.3125l23.98438-15.99219A7.99941,7.99941,0,0,1,139.99219,84Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "108 99.993 132 84 132 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareSeven = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM159.58984,86.53027l-32,96a8.0005,8.0005,0,1,1-15.17968-5.06054L140.90039,92H104a8,8,0,0,1,0-16h48a8.00022,8.00022,0,0,1,7.58984,10.53027Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareSix = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M148,148a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,148ZM224,48V208a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V48A16.01833,16.01833,0,0,1,48,32H208A16.01833,16.01833,0,0,1,224,48ZM164,148a36.04061,36.04061,0,0,0-36-36q-.91517,0-1.81909.04614l16.68823-27.95141a8,8,0,0,0-13.73828-8.20118L96.88574,129.90137c-.06152.103-.11035.20984-.16675.31445A35.99282,35.99282,0,1,0,164,148Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "103.75534",
          y1: "134.00234",
          x2: "136",
          y2: "79.99421",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareThree = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM149.457,177.45654a35.9963,35.9963,0,0,1-50.90723,0,8.00018,8.00018,0,0,1,11.31446-11.31347,19.99683,19.99683,0,1,0,14.13965-34.13868,7.99971,7.99971,0,0,1-6.55469-12.58642L136.63281,92H104a8,8,0,0,1,0-16h47.99414a7.99973,7.99973,0,0,1,6.55469,12.58643L137.5332,118.62305A36.01783,36.01783,0,0,1,149.457,177.45654Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M104,84h47.99366l-27.99,40.00455a27.99773,27.99773,0,1,1-19.79638,47.79511",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareTwo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM152,167.99414a8,8,0,0,1,0,16H104.31738c-.10644.0044-.21191.00635-.31836.00635a8.00251,8.00251,0,0,1-6.30078-12.93164L141.37012,112.793a16.0039,16.0039,0,1,0-28.11621-15.01856A8,8,0,1,1,98.51758,91.542a32.00411,32.00411,0,1,1,56.01269,30.35547c-.07324.10791-.14843.21436-.22754.31836l-34.30566,45.77832Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M105.886,94.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L104,176v-.00575h48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberSquareZero = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("ellipse", {
          cx: "128",
          cy: "128",
          rx: "24",
          ry: "40"
        }), React.createElement("path", {
          d: "M208,32H48A16.02085,16.02085,0,0,0,32,48V208a16.02085,16.02085,0,0,0,16,16H208a16.02085,16.02085,0,0,0,16-16V48A16.02085,16.02085,0,0,0,208,32ZM128,184c-27.63281,0-40-28.125-40-56s12.36719-56,40-56,40,28.125,40,56S155.63281,184,128,184Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberThree = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184,168.00488a63.99178,63.99178,0,0,1-109.24219,45.251,8,8,0,0,1,11.31446-11.313,47.994,47.994,0,1,0,33.93554-81.93408,7.99947,7.99947,0,0,1-6.55469-12.58594L160.626,40H80a8,8,0,0,1,0-16h95.9873A7.99946,7.99946,0,0,1,182.542,36.58594l-48.28125,69.00683A64.055,64.055,0,0,1,184,168.00488Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,32h95.98733l-55.97994,80.0091a55.99545,55.99545,0,1,1-39.59275,95.59021",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberTwo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184,223.98828a8.00008,8.00008,0,0,1-8,8H80.43555q-.21827.01245-.43653.01221a8.00346,8.00346,0,0,1-6.26757-12.9751l87.54687-116.82178a40.00778,40.00778,0,1,0-70.1377-37.771A8,8,0,1,1,76.4043,58.2002a56.00758,56.00758,0,1,1,98.02734,53.11523c-.07324.1084-.14844.21484-.22754.31934L96.001,215.98828H176A8.00039,8.00039,0,0,1,184,223.98828Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M83.77207,61.31625a48.00774,48.00774,0,1,1,84.03029,45.521v0L80,224v-.01149h96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNumberZero = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,240c-25.75977,0-46.99219-12.57129-61.40039-36.35474C54.60547,183.848,48,156.98334,48,128c0-28.98566,6.60547-55.8512,18.59961-75.64771C81.00781,28.57043,102.24023,16,128,16s46.99219,12.57043,61.40039,36.35229C201.39453,72.1488,208,99.01434,208,128c0,28.98334-6.60547,55.848-18.59961,75.64526C174.99219,227.42871,153.75977,240,128,240Zm0-208c-44.21094,0-64,48.2157-64,96s19.78906,96,64,96,64-48.2157,64-96S172.21094,32,128,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("ellipse", {
          cx: "128",
          cy: "128",
          rx: "72",
          ry: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNut = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M219.87207,66.73877l-84-47.478a16.08529,16.08529,0,0,0-15.74609,0l-84,47.478a16.0253,16.0253,0,0,0-8.127,13.92871v94.665a16.0253,16.0253,0,0,0,8.127,13.92871l84,47.478a16.08113,16.08113,0,0,0,15.74609,0l84-47.478a16.02529,16.02529,0,0,0,8.12695-13.92871v-94.665A16.02529,16.02529,0,0,0,219.87207,66.73877ZM127.999,164a36,36,0,1,1,36-36A36.04074,36.04074,0,0,1,127.999,164Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M220,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87292,0l-84,47.47826A8,8,0,0,0,36,80.66772v94.66456a8,8,0,0,0,4.06354,6.96451l84,47.47826a8,8,0,0,0,7.87292,0l84-47.47826A8,8,0,0,0,220,175.33228Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconNyTimesLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M183.92969,148a12,12,0,1,1-12-12A12,12,0,0,1,183.92969,148Zm29.40576,17.28711A88.006,88.006,0,0,1,93.26221,224.87793a7.95208,7.95208,0,0,1-1.15674-.50684,88.23576,88.23576,0,0,1-51.48218-69.30615l-.00439-.03857A88.47326,88.47326,0,0,1,39.92969,144a87.47889,87.47889,0,0,1,14.0874-47.707A36.02189,36.02189,0,0,1,70,28a8.00159,8.00159,0,0,1,3.478.79541L187.68457,83.92969A20.0004,20.0004,0,0,0,186,44a8,8,0,0,1,0-16,36,36,0,0,1,0,72,8.00156,8.00156,0,0,1-3.478-.79541L126.25781,72.04248a72.06449,72.06449,0,0,0-70.25952,69.2544L92.0946,122.04541l.053-.02832L124.165,104.94141A8,8,0,0,1,135.92969,112V215.54541a71.8116,71.8116,0,0,0,61.87841-54.11719,7.99984,7.99984,0,1,1,15.52735,3.85889ZM119.92969,125.3335l-16,8.5332v78.00488a71.4173,71.4173,0,0,0,16,3.67334ZM64.36792,83.20215A88.16232,88.16232,0,0,1,101.459,60.0708L68.31543,44.07031a20.00737,20.00737,0,0,0-3.94751,39.13184ZM87.92969,203.833V142.3999L57.43481,158.66406A72.1802,72.1802,0,0,0,87.92969,203.833Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "171.92969",
          cy: "148",
          r: "12"
        }), React.createElement("path", {
          d: "M205.57177,163.35784A80.00853,80.00853,0,1,1,127.92969,64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M67.24858,91.86653A28.00107,28.00107,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "48.589 154.315 127.93 112 127.93 224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "95.92969",
          y1: "129.06667",
          x2: "95.92969",
          y2: "217.34317",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconOctagon = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M227.3125,80.23438,175.76562,28.6875A16.11511,16.11511,0,0,0,164.45312,24H91.54687a16.11515,16.11515,0,0,0-11.3125,4.6875L28.6875,80.23438A16.11511,16.11511,0,0,0,24,91.54688v72.90625a16.11515,16.11515,0,0,0,4.6875,11.3125L80.23437,227.3125A16.11515,16.11515,0,0,0,91.54687,232h72.90625a16.11511,16.11511,0,0,0,11.3125-4.6875l51.54688-51.54687A16.11515,16.11515,0,0,0,232,164.45313V91.54688A16.11511,16.11511,0,0,0,227.3125,80.23438Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPackage = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.927,70.82178c-.02612-.04883-.04639-.09864-.07373-.147-.01172-.0205-.02612-.03906-.03809-.05957a15.98449,15.98449,0,0,0-5.97168-5.88183l-87.999-49.5a16.09525,16.09525,0,0,0-15.68848,0L32.155,64.73389A15.99355,15.99355,0,0,0,26.168,70.646c-.01539.02685-.03394.05127-.04908.07861-.02441.04346-.042.08887-.06543.13281a15.9818,15.9818,0,0,0-2.05371,7.82129v98.64258A16.02109,16.02109,0,0,0,32.156,191.2666l88.001,49.50049a15.97809,15.97809,0,0,0,7.23486,2.02148c.18189.01416.363.03077.54834.03272h.07227c.25195,0,.50049-.01465.74658-.0376a15.95877,15.95877,0,0,0,7.08447-2.01709l88-49.5a16.01817,16.01817,0,0,0,8.15625-13.94531V78.67871A15.98036,15.98036,0,0,0,229.927,70.82178ZM127.99975,29.17871l79.74366,44.856-30.62061,17.396L96.43969,46.93115Zm.91016,89.64258L48.37866,73.96582,80.03833,56.15723l80.76513,44.54492Zm7.21167,103.43164.78686-89.57373,32.11377-18.24463v38.07617a8,8,0,0,0,16,0v-47.166l30.97754-17.59864v89.5752Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,177.32122V78.67878a8,8,0,0,0-4.07791-6.9726l-88-49.5a8,8,0,0,0-7.84418,0l-88,49.5A8,8,0,0,0,32,78.67878v98.64244a8,8,0,0,0,4.07791,6.9726l88,49.5a8,8,0,0,0,7.84418,0l88-49.5A8,8,0,0,0,224,177.32122Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "177.022 152.511 177.022 100.511 80 47",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "222.897 74.627 128.949 128 33.108 74.617",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128.94915",
          y1: "128",
          x2: "128.01036",
          y2: "234.82131",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaintBrush = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.9707,23.0293c-21.30468,0-45.23242,11.74316-71.11914,34.90234-18.04687,16.146-33.54394,34.64258-44.27978,48.69922A59.99965,59.99965,0,0,0,32,164c0,31.21094-16.23926,45.12109-17.041,45.78809A8,8,0,0,0,20,224H92a60.00007,60.00007,0,0,0,57.36914-77.57227c14.05664-10.73535,32.55371-26.23193,48.7002-44.28027C221.22852,76.26172,232.9707,52.334,232.9707,31.0293A8.00039,8.00039,0,0,0,224.9707,23.0293ZM124.44189,113.56689c2.8628-3.66259,6.29053-7.91308,10.1753-12.49218a76.22114,76.22114,0,0,1,20.3081,20.3081c-4.5791,3.88477-8.82959,7.3125-12.49267,10.1753A60.4544,60.4544,0,0,0,124.44189,113.56689Zm42.54883-2.86718a92.19891,92.19891,0,0,0-21.69043-21.69043c19.60987-21.18408,45.98389-44.37354,70.79834-49.10791C211.36426,64.71631,188.1748,91.08984,166.99072,110.69971Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M112.40713,116.15918c19.194-25.86782,68.02669-85.12974,112.56343-85.12974,0,44.53626-59.26065,93.36835-85.12891,112.56282",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M132.9608,90.6464a84.40058,84.40058,0,0,1,32.3928,32.3928",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaintBrushBroad = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,24H72A40.04552,40.04552,0,0,0,32,64v72a24.0275,24.0275,0,0,0,24,24h46.77588l-6.69531,46.86816A7.97979,7.97979,0,0,0,96,208a32,32,0,0,0,64,0,7.97979,7.97979,0,0,0-.08057-1.13184L153.22412,160H200a24.0275,24.0275,0,0,0,24-24V32A8.00008,8.00008,0,0,0,216,24ZM72,40H176V80a8,8,0,0,0,16,0V40h16v64H48V64A24.0275,24.0275,0,0,1,72,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M102.776,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2241a8,8,0,0,0-7.9196,9.13137L152,208a24,24,0,0,1-48,0l6.69555-46.86862A8,8,0,0,0,102.776,152Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "32",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaintBrushHousehold = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M230.627,25.37207a32.03909,32.03909,0,0,0-45.2539,0c-.10254.10156-.20117.207-.29785.31348L130.17383,86.85938l-9.20313-9.20313a24.00066,24.00066,0,0,0-33.9414,0L10.34277,154.34277a8.00122,8.00122,0,0,0,0,11.31446l80,80a8.00181,8.00181,0,0,0,11.31446,0l76.68652-76.68653a24.00066,24.00066,0,0,0,0-33.9414l-9.20313-9.20215L230.31445,70.9248c.10645-.09668.21192-.19531.31348-.29785A32.03761,32.03761,0,0,0,230.627,25.37207ZM96,228.68652,81.87842,214.56494l25.53467-25.53369A8.00053,8.00053,0,0,0,96.09863,177.7168L70.564,203.25049,53.87842,186.56494l25.53467-25.53369A8.00053,8.00053,0,0,0,68.09863,149.7168L42.564,175.25049,27.31348,160,72,115.31445,140.68555,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "72",
          y1: "104",
          x2: "151.99999",
          y2: "183.99999",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "101.75578",
          y1: "183.37379",
          x2: "70.56478",
          y2: "214.56478",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "73.75578",
          y1: "155.37379",
          x2: "42.56478",
          y2: "186.56478",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M136.12716,92.20308l54.90228-61.17364a24,24,0,1,1,33.94112,33.94112l-61.17364,54.90228a8,8,0,0,0-.31342,11.61065l9.20279,9.2028a16,16,0,0,1,0,22.62742L96,240,16,160,92.68629,83.31371a16,16,0,0,1,22.62742,0l9.2028,9.2028A8,8,0,0,0,136.12716,92.20308Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaintBucket = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M256,204a28,28,0,0,1-56,0c0-23.042,21.42969-44.74365,22.34277-45.65625a7.99945,7.99945,0,0,1,11.31446,0C234.57031,159.25635,256,180.958,256,204ZM132.48535,124.49121a12.0001,12.0001,0,1,0-16.9707.00049A12.01451,12.01451,0,0,0,132.48535,124.49121Zm98.47949-1.00684a8.00033,8.00033,0,0,0-2.34277-5.65673L121.1377,10.34326a8.00122,8.00122,0,0,0-11.31446,0L69.73682,50.4292l40.949,40.949a27.99954,27.99954,0,1,1-11.31421,11.31372L58.42285,61.74316l-44.7666,44.76661a24.029,24.029,0,0,0,0,33.94091l84.85742,84.85694a23.99952,23.99952,0,0,0,33.94141,0l96.167-96.16651A8.00034,8.00034,0,0,0,230.96484,123.48437ZM43.51465,24.207A8.00018,8.00018,0,0,0,32.2002,35.52051L58.42285,61.74316l11.314-11.314Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M222.9646,123.48437,126.79808,219.6509a16,16,0,0,1-22.62741,0l-84.857-84.857a16,16,0,0,1,0-22.62742L115.48023,16Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "124",
          cy: "116.00586",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208,204c0-19.99414,20-40,20-40s20,20.00586,20,40a20,20,0,0,1-40,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "109.85786",
          y1: "101.86372",
          x2: "37.85786",
          y2: "29.86372",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaintRoller = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248,104v49.96582a16.06941,16.06941,0,0,1-11.60352,15.38477L135.999,198.03418,136,232a8,8,0,0,1-16,0V198.03418a16.06941,16.06941,0,0,1,11.60352-15.38477L232.001,153.96582,232,104H216v24a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V104H16a8,8,0,0,1,0-16H32V64A16.01833,16.01833,0,0,1,48,48H200a16.01833,16.01833,0,0,1,16,16V88h16A16.01833,16.01833,0,0,1,248,104Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "56",
          width: "168",
          height: "80",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M208,96h24a8,8,0,0,1,8,8v49.96559a8,8,0,0,1-5.80223,7.69219L133.80223,190.34222A8,8,0,0,0,128,198.03441V232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "96",
          x2: "16",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPalette = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200.772,53.88965A103.28,103.28,0,0,0,127.99756,24q-.53247,0-1.06543.00488a104.01647,104.01647,0,0,0-33.57227,202.084A32.00105,32.00105,0,0,0,136,195.90234V192a16.01833,16.01833,0,0,1,16-16h46.20947a31.81973,31.81973,0,0,0,31.20508-24.87207,104.49414,104.49414,0,0,0,2.58154-24.01953A103.2063,103.2063,0,0,0,200.772,53.88965ZM88.96667,164.39209A12,12,0,1,1,93.359,148,11.99983,11.99983,0,0,1,88.96667,164.39209ZM93.359,108a12,12,0,1,1-4.39234-16.39258A12,12,0,0,1,93.359,108ZM128,88a12,12,0,1,1,12-12A12,12,0,0,1,128,88Zm51.03333,24.39209A12,12,0,1,1,183.42566,96,11.99981,11.99981,0,0,1,179.03333,112.39209Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.61367,149.35463a96.28545,96.28545,0,0,0,2.38287-22.17837c-.44383-52.82934-44.1551-95.70346-96.98364-95.17129a96.01642,96.01642,0,0,0-30.989,186.54089A24.002,24.002,0,0,0,128,195.90236V192a24,24,0,0,1,24-24h46.20931A23.99131,23.99131,0,0,0,221.61367,149.35463Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "76",
          r: "12"
        }), React.createElement("circle", {
          cx: "82.96668",
          cy: "102",
          r: "12"
        }), React.createElement("circle", {
          cx: "82.96668",
          cy: "154",
          r: "12"
        }), React.createElement("circle", {
          cx: "173.03332",
          cy: "102",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaperPlane = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M236.43432,201.4707l-94.59179-168.915a16.00119,16.00119,0,0,0-27.92188,0L19.32885,201.47021A16.00042,16.00042,0,0,0,38.67065,224.356l81.21094-29.00391V120a8,8,0,1,1,16,0v75.352L217.09253,224.356a16.171,16.171,0,0,0,5.44531.95117,16.02221,16.02221,0,0,0,13.89648-23.83643Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M120.90154,36.46437,26.30921,205.37925A8,8,0,0,0,35.98,216.822l89.211-31.86106a8,8,0,0,1,5.38138,0l89.211,31.86106a8,8,0,0,0,9.67074-11.44277L134.86164,36.46437A8,8,0,0,0,120.90154,36.46437Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.88159",
          y1: "184",
          x2: "127.88159",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaperPlaneRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.44434,114.03906,54.5293,19.44727A16.00042,16.00042,0,0,0,31.64355,38.78906L60.64746,120H136a8,8,0,0,1,0,16H60.64746L31.64355,217.21094a16.0398,16.0398,0,0,0,15.041,21.4082,16.039,16.039,0,0,0,7.8457-2.06641l168.91309-94.59179a16.00165,16.00165,0,0,0,.001-27.92188Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M219.53563,121.02,50.62075,26.42762A8,8,0,0,0,39.178,36.09836l31.86106,89.211a8,8,0,0,1,0,5.38138L39.178,219.90164a8,8,0,0,0,11.44277,9.67074l168.91488-94.59233A8,8,0,0,0,219.53563,121.02Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaperPlaneTilt = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.73633,32.26367a16.01051,16.01051,0,0,0-15.65723-4.085L21.751,80.73242a15.9995,15.9995,0,0,0-2.50586,29.8584l77.93359,36.916,53.28223-53.28223a8.00052,8.00052,0,0,1,11.31445,11.31445l-53.28223,53.28223,36.916,77.93359a15.85235,15.85235,0,0,0,14.41406,9.15235q.687,0,1.38379-.05762A15.86994,15.86994,0,0,0,175.26758,234.249L227.82129,47.9209A16.0173,16.0173,0,0,0,223.73633,32.26367Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M210.25072,35.878,23.923,88.432a8,8,0,0,0-1.253,14.9295l85.61084,40.5525a8.00008,8.00008,0,0,1,3.80521,3.80521L152.63852,233.33a8,8,0,0,0,14.9295-1.253L220.122,45.74928A8,8,0,0,0,210.25072,35.878Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "110.86292",
          y1: "145.13708",
          x2: "156.11775",
          y2: "99.88225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaperclip = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M159.99414,79.99512,76.68629,164.68629a16,16,0,0,0,22.62742,22.62742L198.62156,86.62253A32,32,0,1,0,153.36672,41.3677L54.05887,142.05887a48,48,0,0,0,67.88226,67.88226l82.053-81.946",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPaperclipHorizontal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M78,143.99968H190A15.99984,15.99984,0,0,0,190,112H46c-17.23852,0-31.2131,14.32689-31.2131,32S28.76146,176,46,176H191.99414a48,48,0,1,0,0-96h-112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPath = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,168a32.05794,32.05794,0,0,0-30.9873,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97.0127A32.0015,32.0015,0,1,0,200,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "200",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPause = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,48V208a16.01833,16.01833,0,0,1-16,16H164a16.01833,16.01833,0,0,1-16-16V48a16.01833,16.01833,0,0,1,16-16h36A16.01833,16.01833,0,0,1,216,48ZM92,32H56A16.01833,16.01833,0,0,0,40,48V208a16.01833,16.01833,0,0,0,16,16H92a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,92,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "156",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "48",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPauseCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24ZM112,160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPawPrint = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,108a28,28,0,1,1-28-28A28.03146,28.03146,0,0,1,240,108ZM72,108a28,28,0,1,0-28,28A28.03146,28.03146,0,0,0,72,108ZM92,88A28,28,0,1,0,64,60,28.03146,28.03146,0,0,0,92,88Zm72,0a28,28,0,1,0-28-28A28.03146,28.03146,0,0,0,164,88Zm23.0918,60.84473a35.3317,35.3317,0,0,1-16.8418-21.124,43.99839,43.99839,0,0,0-84.5-.00439,35.2806,35.2806,0,0,1-16.7998,21.105,40.00718,40.00718,0,0,0,34.57226,72.05176,64.08634,64.08634,0,0,1,48.86524-.03711,40.0067,40.0067,0,0,0,34.7041-71.99121Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "212",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "44",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "164",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M183.23572,155.85352a43.541,43.541,0,0,1-20.667-25.90381l-.00092.001a35.9985,35.9985,0,0,0-69.13562,0l-.00092-.001a43.541,43.541,0,0,1-20.667,25.90381,32.00736,32.00736,0,0,0,27.72266,57.61767,72.51938,72.51938,0,0,1,55.02612,0,32.00679,32.00679,0,0,0,27.72266-57.61767Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPeace = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.6377,186.938a104,104,0,1,0-171.2754,0,8.09637,8.09637,0,0,0,.44532.71387c.12011.17163.25537.32543.38623.48461a103.91407,103.91407,0,0,0,169.61279-.001c.13086-.15894.26563-.31226.38574-.48364A8.09637,8.09637,0,0,0,213.6377,186.938ZM216,128a87.46128,87.46128,0,0,1-11.63916,43.70215L136,123.8352V40.36743A88.117,88.117,0,0,1,216,128ZM120,40.36743V123.8352L51.63916,171.70215A87.96692,87.96692,0,0,1,120,40.36743Zm-59.16162,144.426L120,143.36816v72.26441A87.90216,87.90216,0,0,1,60.83838,184.79346ZM136,215.63257V143.36816l59.16162,41.4253A87.90216,87.90216,0,0,1,136,215.63257Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "206.6386",
          y2: "183.06334",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "49.3614",
          y2: "183.06334",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M228.68652,88A15.89427,15.89427,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.953,15.953,0,0,0-3.56836,5.4458,7.95719,7.95719,0,0,0-.27149.75976A16.00722,16.00722,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H92.68652a16.00666,16.00666,0,0,0,5.15869-.86377c.23829-.07324.47388-.15674.70582-.25244A15.94661,15.94661,0,0,0,104,219.31348l83.666-83.666,3.4746,13.89844-36.79785,36.79736a8.00018,8.00018,0,0,0,11.31446,11.31348l40-40a8.00081,8.00081,0,0,0,2.10351-7.59717l-6.90136-27.60547L223.999,99.31445A15.895,15.895,0,0,0,228.68652,88ZM192,108.68555,147.314,64,168,43.31348,212.68555,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "160 192 200 152 192 120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.50826",
          y1: "160.50826",
          x2: "95.49177",
          y2: "215.49177",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPenNib = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232.00586,92.68994l-68.68652-68.6875a16.02162,16.02162,0,0,0-22.62793.001L115.57349,49.12158l-58.053,21.77a16.045,16.045,0,0,0-10.165,12.35108L26.58887,207.83984a4,4,0,0,0,6.77417,3.48584l55.08423-55.08545a32.0378,32.0378,0,1,1,11.311,11.31543L44.667,222.64893a4,4,0,0,0,3.48609,6.77392l124.61352-20.769a16.0433,16.0433,0,0,0,12.35059-10.16406l21.77-58.05371,25.11767-25.11817a15.99888,15.99888,0,0,0,.001-22.62793Zm-32,31.99951-68.686-68.686,20.686-20.68653,68.68555,68.68653Z"
        }), React.createElement("circle", {
          cx: "116.00586",
          cy: "140.00342",
          r: "16"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "116",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32.00586",
          y1: "224.00342",
          x2: "101.85786",
          y2: "154.14214",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32.00586,224.00342l139.44573-23.241a8,8,0,0,0,6.17544-5.08216l22.37883-59.67688-80-80L60.329,78.38225a8,8,0,0,0-5.08217,6.17544Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200.00586,136.00342,226.349,109.66027a8,8,0,0,0,0-11.31371l-68.6863-68.68629a8,8,0,0,0-11.3137,0L120.00586,56.00342",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPenNibStraight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128.00586",
          cy: "132.00342",
          r: "16"
        }), React.createElement("path", {
          d: "M218.56445,123.89014,192.00586,70.13477V32.00342a16,16,0,0,0-16-16h-96a16,16,0,0,0-16,16V70.13477L37.44678,123.89062a15.944,15.944,0,0,0,1.45947,16.57276l73.87832,100.35748a4,4,0,0,0,7.22129-2.37135V162.99072a32,32,0,1,1,16,0v75.45864a4,4,0,0,0,7.2213,2.37133L217.105,140.4624A15.94312,15.94312,0,0,0,218.56445,123.89014ZM176.00586,64.00342h-96v-32h96Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128.00587",
          y1: "152.00342",
          x2: "128.00587",
          y2: "248.00342",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128.00587",
          cy: "132.00342",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72.00586,72.00342v-40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72.00586,72.00342l-27.3866,55.43077a8,8,0,0,0,.72977,8.28632l82.65684,112.28291,82.65647-112.28335a8,8,0,0,0,.72976-8.28628L184.00586,72.00342Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPencil = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,76.68652,179.314,32a15.99948,15.99948,0,0,0-22.62744,0L130.34473,58.3418l-.00147.00146-.00146.00147L36.687,151.99951A15.89429,15.89429,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H92.68652A15.89438,15.89438,0,0,0,104,219.31348l120.00049-120A16.01823,16.01823,0,0,0,224,76.68652Zm-32,32L147.31372,64,168,43.31348,212.68652,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "95.48882",
          y1: "215.48882",
          x2: "40.5088",
          y2: "160.5088",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPencilCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M201.53906,54.46094A103.99994,103.99994,0,1,0,54.46094,201.53906,103.99994,103.99994,0,1,0,201.53906,54.46094ZM128,170.86786a31.92926,31.92926,0,0,0-32.31274-9.76618L110.96484,128h34.07032l15.27758,33.10168A31.92926,31.92926,0,0,0,128,170.86786Zm40,35.50226a87.94109,87.94109,0,0,1-32,9.21777V192a16,16,0,0,1,32,0Zm22.22461-16.14453c-2.0022,2.00225-4.08447,3.87616-6.22461,5.64471V176a7.99689,7.99689,0,0,0-.73633-3.35254l-48-104c-.00683-.01477-.0166-.02759-.02344-.0423a8.0006,8.0006,0,0,0-.4956-.89727c-.03858-.06073-.07959-.1186-.11987-.1781a7.94887,7.94887,0,0,0-.54834-.72388c-.03052-.03559-.05835-.07337-.08936-.1084a7.95215,7.95215,0,0,0-.73462-.727c-.04346-.03778-.08935-.0719-.1333-.1087a7.96445,7.96445,0,0,0-.69189-.51453c-.06617-.044-.13086-.08893-.19825-.131a8.07167,8.07167,0,0,0-.87646-.48l-.0166-.00665c-.0232-.01069-.04785-.01813-.07129-.02863a8.04837,8.04837,0,0,0-.88355-.33075c-.08471-.02649-.16992-.05-.25561-.07367a7.93969,7.93969,0,0,0-.87573-.1922c-.04273-.00677-.08423-.01715-.1272-.02325a7.93122,7.93122,0,0,0-1.04224-.07538C128.05322,64.00555,128.0271,64,128,64c-.04321,0-.08472.00854-.12769.00922a7.97635,7.97635,0,0,0-.905.06549c-.0564.00732-.11353.0108-.16944.01935a8.00689,8.00689,0,0,0-.97119.21307c-.083.02344-.16357.05127-.24561.07733a8.01776,8.01776,0,0,0-.7644.28619c-.06616.02869-.1333.05365-.19849.08405a8.00888,8.00888,0,0,0-.87207.47528c-.05517.03473-.10742.07288-.16186.10889a7.946,7.946,0,0,0-.69946.5202c-.04883.04047-.09864.07874-.14624.12036a7.92641,7.92641,0,0,0-.73365.7262c-.02563.02893-.04809.06042-.07324.08972a7.92917,7.92917,0,0,0-.55127.72778c-.04736.06989-.09424.13928-.1394.21088a8.01437,8.01437,0,0,0-.50464.91345l-22.1543,48-.00244.006-25.84326,55.994A7.99689,7.99689,0,0,0,72,176v19.8703c-2.14014-1.76855-4.22241-3.64246-6.22461-5.64471a88,88,0,1,1,124.44922,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "176 211.161 176 176 128 72 80 176 80 211.164",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,192a24,24,0,0,1,48,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,224V192a24,24,0,0,0-48,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "102.15385",
          y1: "128",
          x2: "153.84615",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPencilLine = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "216 216 96 216 40.509 160.509",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPencilSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,76.68652,179.314,32a15.99948,15.99948,0,0,0-22.62744,0L130.34473,58.3418l-.00147.00146-.00146.00147L36.687,151.99951A15.89429,15.89429,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H92.68652A15.89438,15.89438,0,0,0,104,219.31348l120.00049-120A16.01823,16.01823,0,0,0,224,76.68652Zm-32,32L147.31372,64,168,43.31348,212.68652,88Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPercent = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M205.65674,61.65674l-144,144a7.99984,7.99984,0,0,1-11.31348-11.31348l144-144a7.99984,7.99984,0,0,1,11.31348,11.31348ZM50.54443,101.45581A36.0403,36.0403,0,1,1,76,111.98315,35.76294,35.76294,0,0,1,50.54443,101.45581ZM56,76A20,20,0,1,0,90.14209,61.85791v-.00024A20,20,0,0,0,56,76ZM216,180a36.00012,36.00012,0,1,1-10.54443-25.45581A35.76281,35.76281,0,0,1,216,180Zm-16,0a20.00016,20.00016,0,1,0-5.85791,14.14209A19.86721,19.86721,0,0,0,200,180Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "76",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPerson = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "127.88745",
          cy: "44",
          r: "36"
        }), React.createElement("path", {
          d: "M211.67456,139.51367,172.34448,88.94629a7.93269,7.93269,0,0,0-.65723-.74512A27.81868,27.81868,0,0,0,151.88745,80h-48a27.81872,27.81872,0,0,0-19.79981,8.20117,7.93259,7.93259,0,0,0-.65722.74512L44.09936,139.51416A20.00055,20.00055,0,0,0,72.37378,167.7876l14.09961-10.96729-19.832,62.64014a20.00009,20.00009,0,0,0,36.23731,16.897l25.00879-39.35937,25.00879,39.35937a20.00007,20.00007,0,0,0,36.2373-16.897l-19.832-62.64014,14.09961,10.96729a20.00035,20.00035,0,0,0,28.27344-28.27393Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "127.88745",
          cy: "44",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M153.91044,134.715,188.657,161.74012a12,12,0,1,0,16.97056-16.97057l-39.598-50.91169A19.93738,19.93738,0,0,0,151.88746,88h-48a19.93739,19.93739,0,0,0-14.14213,5.85786l-39.598,50.91169A12,12,0,1,0,67.1179,161.74012L101.86446,134.715,74.13088,222.3089a12,12,0,0,0,21.75139,10.14284l32.0052-50.37108h0l32.0052,50.37108A12,12,0,0,0,181.644,222.3089Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPersonSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M95.8877,48a32,32,0,1,1,32,32A32.03635,32.03635,0,0,1,95.8877,48Zm132.22851,73.13965C226.40527,120.11328,185.5542,96,128,96S29.59473,120.11328,27.88379,121.13965a8.00047,8.00047,0,0,0,8.23242,13.7207c.36133-.21686,34.9165-20.59765,83.88379-22.676v36.77447L58.02051,218.68555a7.99985,7.99985,0,1,0,11.959,10.6289L128,164.042l58.02051,65.27246a7.99985,7.99985,0,1,0,11.959-10.6289L136,148.95886V112.18567c48.769,2.08642,83.5293,22.46252,83.88379,22.67468a8.00047,8.00047,0,0,0,8.23242-13.7207Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "127.88745",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "64 224 128 152 192 224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,128s40-24,96-24,96,24,96,24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPersonSimpleRun = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M120,56a32,32,0,1,1,32,32A32.03667,32.03667,0,0,1,120,56Zm104,77.551a7.99494,7.99494,0,0,0-11.71338-7.08265l-.00146-.00256.11621-.05957c-.06348.03027-6.48926,3.05566-18.22754,1.85059-11.165-1.13965-29.46582-6.4043-53.24463-25.00684-14.99365-11.73047-38.3457-24.65918-64.44092-19.63672C60.7041,86.65039,51.563,94.75879,50.57227,95.67383a7.99984,7.99984,0,0,0,10.80957,11.7959c1.07714-.96436,25.82421-22.34973,64.61084,4.636a149.52,149.52,0,0,1-21.84522,44.39148c-.02588.03552-.05273.06946-.07812.10559-.77246,1.05445-1.56006,2.104-2.374,3.14331C82.8125,183.85742,59.63184,194.71777,32.7959,192.04A7.99965,7.99965,0,1,0,31.2041,207.96q4.87208.4878,9.50195.48145c32.63331,0,56.58155-17.4513,73.14649-38.29175C133.30127,175.27991,168,190.28955,168,232a8,8,0,0,0,16,0c0-24.65332-10.08008-45.35254-29.15039-59.85938a104.37686,104.37686,0,0,0-31.29541-15.8081,165.70877,165.70877,0,0,0,16.08447-34.14417c25.72168,17.94129,46.18653,22.30079,59.99414,22.29993,12.4209-.001,19.458-3.52539,20.082-3.85254l-.00146-.0022A7.99461,7.99461,0,0,0,224,133.551Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "152",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,101.551s32-29.551,80,8c50.46853,39.48219,80,24,80,24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M135.07558,108.83476C130.73311,129.2401,101.55844,206.95584,32,200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M110.64453,161.16016C128.46874,164.96875,176,180,176,232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPersonSimpleWalk = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M120,48a32,32,0,1,1,32,32A32.03667,32.03667,0,0,1,120,48Zm88,88c-28.49561,0-41.65088-14.13086-55.57861-29.09277-3.52686-3.78809-7.17383-7.70606-10.99366-11.2334-37.2207-34.374-96.57617,24.16113-99.085,26.66894a8.00019,8.00019,0,0,0,11.31055,11.31739A165.05558,165.05558,0,0,1,84.21191,110.501c14.32227-8.15454,26.27442-11.08594,35.71534-8.79737l-17.69483,40.698-.02441.05567L64.66309,228.81055a8.00018,8.00018,0,1,0,14.67382,6.3789l33.59327-77.26538L144,180.11719V232a8,8,0,0,0,16,0V176a8.00054,8.00054,0,0,0-3.3501-6.50977L119.45312,142.9209,133.6084,110.364c2.33789,2.33814,4.67285,4.83619,7.10205,7.44556C154.89111,133.042,172.53906,152,208,152a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "152",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48,128s56-56,88-26.449C153.94081,118.11882,168,144,208,144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "130.51056",
          y1: "97.4257",
          x2: "72",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 232 152 176 109.536 145.668",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPhone = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.97168,158.42676l-46.83789-20.07324a15.95139,15.95139,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.02839,16.02839,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPhoneCall = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M221.97168,158.42676l-46.83789-20.07324a15.95139,15.95139,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.02839,16.02839,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
        }), React.createElement("path", {
          d: "M157.35156,47.72852a72.12078,72.12078,0,0,1,50.91992,50.91992,7.99975,7.99975,0,0,0,15.457-4.13086,88.16381,88.16381,0,0,0-62.2461-62.2461,7.99975,7.99975,0,0,0-4.13086,15.457Z"
        }), React.createElement("path", {
          d: "M149.06738,78.64551a40.06626,40.06626,0,0,1,28.28711,28.28711,7.99975,7.99975,0,0,0,15.457-4.13086,56.10589,56.10589,0,0,0-39.61328-39.61328,7.99975,7.99975,0,0,0-4.13086,15.457Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M159.41743,40A80.14832,80.14832,0,0,1,216,96.58261",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M151.13313,70.91728a48.089,48.089,0,0,1,33.94958,33.9496",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPhoneDisconnect = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M229.82422,90.17578c-56.14551-56.14355-147.501-56.14648-203.64844.001a56.07211,56.07211,0,0,0-4.69043,73.87695,16.03254,16.03254,0,0,0,18.55078,4.99707L87.35059,150.125a15.94917,15.94917,0,0,0,9.74609-11.71875l5.90527-29.51172a76.51611,76.51611,0,0,1,49.67676-.10937v.00195l6.21094,29.73828a15.963,15.963,0,0,0,9.7207,11.584l47.35254,18.9414a16.03618,16.03618,0,0,0,18.55273-4.99805A56.07343,56.07343,0,0,0,229.82422,90.17578Z"
        }), React.createElement("path", {
          d: "M216,192H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M155.371,101.25063a84.3478,84.3478,0,0,0-55.10429.12547,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,161.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,136,136,0,0,1,192.333,0,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-47.35377-18.94151a8,8,0,0,1-4.85991-5.79231L160.51024,107.151A7.9287,7.9287,0,0,0,155.371,101.25063Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "200",
          x2: "216",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPhoneIncoming = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M221.97168,158.42676l-46.83789-20.07324a15.94874,15.94874,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.036,16.036,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
        }), React.createElement("path", {
          d: "M152.08594,97.10889c.021.15283.03955.30566.06933.45752.02491.125.05957.24609.09034.36914.03271.13037.06152.26123.10058.39013.03662.12061.082.23682.124.355.04541.12891.08838.25782.14063.38477.04492.10742.09766.21094.147.31641.06153.13183.12061.26464.18994.39355.05176.09717.11133.189.167.2832.07666.13037.15087.26172.23584.38819.0664.09863.14062.1914.21093.28662.084.11474.16407.231.25537.3418.11622.14111.2417.27343.36719.40625.0542.0581.10205.11914.15869.17578.0542.0542.11377.10058.16895.15283.13525.12744.27.25537.41406.37353.10645.08789.21826.16455.32813.24561.10009.07422.19726.15185.30078.22119.12207.08154.248.15234.37353.22656.09912.05909.19629.12159.29834.17627.124.0669.25147.12305.37842.18262.11035.05176.21875.10693.332.15381.1211.05029.24463.09082.36768.13476.12353.04444.2456.0918.37207.13038.12158.03662.24512.06347.36816.09472.13037.03272.25879.06885.3916.09522.14063.02832.28321.04492.42481.06494.1167.0166.231.03857.34912.05029.26221.02588.52588.04.78955.04h40a8,8,0,0,0,0-16H179.31445l34.34278-34.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L168,76.68555V56a8,8,0,0,0-16,0V95.99512c0,.26562.01367.53174.04.79687C152.05078,96.89941,152.07129,97.00293,152.08594,97.10889Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "160 56 160 96 200 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPhoneOutgoing = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M221.97168,158.42676l-46.83789-20.07324a15.95139,15.95139,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.02839,16.02839,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
        }), React.createElement("path", {
          d: "M160,104a7.97772,7.97772,0,0,0,5.65723-2.34277L200,67.31445V88a8,8,0,0,0,16,0V48.00488c0-.26562-.01367-.53174-.04-.79687-.01074-.10742-.03125-.21094-.0459-.3169-.021-.15283-.03955-.30566-.06933-.45752-.02491-.125-.05957-.24609-.09034-.36914-.03271-.13037-.06152-.26123-.10058-.39013-.03662-.12061-.082-.23682-.124-.355-.04541-.12891-.08838-.25782-.14063-.38477-.04492-.10742-.09766-.21094-.147-.31641-.06153-.13183-.12061-.26464-.18994-.39355-.05176-.09717-.11133-.189-.167-.2832-.07666-.13037-.15087-.26172-.23584-.38819-.0664-.09863-.14062-.1914-.21093-.28662-.084-.11474-.16407-.231-.25537-.3418-.11622-.14111-.2417-.27343-.36719-.40625-.0542-.0581-.10205-.11914-.15869-.17578-.05323-.05322-.11133-.09863-.166-.1499-.13623-.12891-.27246-.25781-.417-.377-.10449-.08545-.21436-.16065-.32178-.24024-.10254-.07617-.20166-.15527-.3081-.22656-.11817-.0791-.24073-.148-.36231-.22021-.10351-.06153-.2041-.12647-.31055-.1836-.11865-.063-.24023-.1167-.36084-.17334-.11669-.05517-.23144-.11328-.35107-.16308-.1123-.04639-.22754-.084-.3418-.125-.13281-.04834-.26367-.09864-.39941-.13965-.10938-.0332-.2207-.05713-.33106-.08545-.14257-.03613-.2832-.07568-.42822-.10449-.12158-.02393-.24414-.0376-.3667-.05567-.13574-.02051-.27-.04541-.4082-.05908-.20215-.01953-.40479-.02637-.60742-.03076C208.11768,40.00781,208.05957,40,208,40H168a8,8,0,0,0,0,16h20.68555L154.34277,90.34277A8,8,0,0,0,160,104Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPhoneSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M120.8877,108.28271c-.01416-.01562-.02832-.03173-.043-.04736l-31.083-34.19092c-.01611-.01855-.03272-.03613-.04883-.0542l-35.793-39.37207A8.0006,8.0006,0,1,0,42.08008,45.38184L70.03857,76.13623a142.75371,142.75371,0,0,0-43.86279,30.04053,56.07211,56.07211,0,0,0-4.69043,73.87695,16.03254,16.03254,0,0,0,18.55078,4.99707L87.35059,166.125a15.94917,15.94917,0,0,0,9.74609-11.71875l5.90527-29.51172a76.1958,76.1958,0,0,1,9.07422-2.51709l90.00391,99.0044a8.0006,8.0006,0,1,0,11.83984-10.76368Z"
        }), React.createElement("path", {
          d: "M229.82422,106.17578a144.20418,144.20418,0,0,0-109.73633-41.96A8.00053,8.00053,0,0,0,114.60547,77.585l94.36035,103.79883a8.0075,8.0075,0,0,0,2.94824,2.04687l4.04883,1.62012a16.03429,16.03429,0,0,0,18.55273-4.99805A56.07343,56.07343,0,0,0,229.82422,106.17578Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M114.9947,113.69328a83.97034,83.97034,0,0,0-14.728,3.68282,7.92755,7.92755,0,0,0-5.1169,5.95455l-5.89824,29.5076a8,8,0,0,1-4.87369,5.85972L37.06532,177.623a7.97345,7.97345,0,0,1-9.2595-2.47378,48.00881,48.00881,0,0,1,4.02766-63.31573,135.45028,135.45028,0,0,1,51.9466-32.47622",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M120.52563,72.20427a135.66,135.66,0,0,1,103.64089,39.62921,48.00881,48.00881,0,0,1,4.02766,63.31573,7.97345,7.97345,0,0,1-9.2595,2.47378l-4.04895-1.61958",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPhoneX = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M221.97168,158.42676l-46.83789-20.07324a15.94874,15.94874,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.03093,16.03093,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z"
        }), React.createElement("path", {
          d: "M154.34277,101.65723a8.00181,8.00181,0,0,0,11.31446,0L184,83.31445l18.34277,18.34278a8.00053,8.00053,0,0,0,11.31446-11.31446L195.31445,72l18.34278-18.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L184,60.68555,165.65723,42.34277a8.00053,8.00053,0,0,0-11.31446,11.31446L172.68555,72,154.34277,90.34277A8.00122,8.00122,0,0,0,154.34277,101.65723Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.47629,124.81528a84.34782,84.34782,0,0,0,39.05334,38.8759,7.92754,7.92754,0,0,0,7.8287-.59231L164.394,146.40453a8,8,0,0,1,7.58966-.69723l46.837,20.073A7.97345,7.97345,0,0,1,223.619,174.077,48.00882,48.00882,0,0,1,176,216,136,136,0,0,1,40,80,48.00882,48.00882,0,0,1,81.923,32.381a7.97345,7.97345,0,0,1,8.29668,4.79823L110.31019,84.0571a8,8,0,0,1-.65931,7.53226L93.01449,117.00909A7.9287,7.9287,0,0,0,92.47629,124.81528Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "48",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPhosphorLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M142,24H68c-.06836,0-.13477.00855-.20264.01026-.16162.004-.32275.01056-.48486.02447-.11377.00971-.22607.02387-.33838.03833-.14307.0185-.28613.039-.42871.06543-.13232.02429-.26221.05359-.39209.08435-.11865.02826-.23682.05725-.35449.09113-.15088.04315-.29883.09216-.4458.14386-.09668.034-.19287.06769-.28907.10565-.16113.06366-.31787.134-.47363.20764-.05566.02625-.11279.046-.168.07361-.03027.0152-.05761.03412-.08789.04968-.14795.0766-.2915.15979-.43408.24512-.0918.05481-.18457.10828-.27393.16626-.11572.07574-.22607.15729-.33789.23871-.10644.07776-.21435.15423-.3164.23657-.084.06811-.16309.14117-.24463.21258-.11719.10267-.23438.20472-.34473.31336-.06543.06445-.12549.13342-.18847.20007-.11426.12036-.228.2403-.3335.36682-.064.07611-.12158.15693-.18213.23542-.09424.12188-.18945.24267-.27637.36926-.07129.10406-.13476.21338-.20166.321-.06591.10669-.13427.21155-.19482.321-.0752.13513-.14111.27551-.2085.41528-.04248.08838-.08838.17493-.12744.26471-.0664.15186-.123.30841-.18017.465-.03125.08538-.06543.16943-.09375.25586-.04834.14813-.08741.2998-.127.45159-.02685.10328-.05664.20563-.07959.31-.02832.13-.04931.26233-.07129.39453-.02246.134-.04541.2674-.06152.40259-.01221.10742-.01855.21619-.02637.32483-.01269.16376-.023.32745-.0249.49225C60.00488,31.93187,60,31.96537,60,32V164a74.08385,74.08385,0,0,0,74,74,8.00008,8.00008,0,0,0,8-8V172a74,74,0,0,0,0-148ZM126,130.11137,80.94434,40H126ZM76.55176,172H126v49.4502A58.12735,58.12735,0,0,1,76.55176,172ZM142,156V40a58,58,0,0,1,0,116Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("line", {
          x1: "68",
          y1: "32",
          x2: "134",
          y2: "164",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "68",
          y: "32",
          width: "66",
          height: "132",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M134,164v66a66,66,0,0,1-66-66",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M134,164h8a66,66,0,0,0,0-132h-8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        })));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPictureInPicture = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,48H40A16.01833,16.01833,0,0,0,24,64V192a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,216,48ZM40,64H216l.00439,56H144a16.01833,16.01833,0,0,0-16,16v56H40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M136,200V136a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPill = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.65723,42.34326a53.25535,53.25535,0,0,0-75.31446,0l-96,96a53.255,53.255,0,0,0,75.31446,75.31348l96-96A53.31558,53.31558,0,0,0,213.65723,42.34326Zm-11.31446,64L160,148.68628,107.31348,96l42.34375-42.34326a37.25465,37.25465,0,0,1,52.68554,52.68652Zm-12.10351-23.416a7.99946,7.99946,0,0,1-.19629,11.312l-24.416,23.584a7.99966,7.99966,0,1,1-11.11523-11.50781l24.416-23.584A7.99843,7.99843,0,0,1,190.23926,82.92725Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "14.86292",
          y: "82.74517",
          width: "226.27417",
          height: "90.50967",
          rx: "45.25479",
          transform: "translate(-53.01934 128) rotate(-45)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160.06933",
          y1: "112.06932",
          x2: "184.48528",
          y2: "88.48528",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPinterestLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,128a104.02405,104.02405,0,0,1-132.74316,99.957l9.8164-39.26513A50.31473,50.31473,0,0,0,136,196c35.29,0,64-30.50488,64-68A72,72,0,1,0,61.2373,155.00393,8.00011,8.00011,0,0,0,76.06836,149,56.00735,56.00735,0,1,1,184,128c0,28.67285-21.53271,52-48,52-10.49072,0-17.78076-3.66064-22.75049-8.01269l14.51172-58.04688a8.00012,8.00012,0,0,0-15.52246-3.88086L84.17822,222.30178A103.99416,103.99416,0,1,1,232,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "120",
          y1: "88.00002",
          x2: "88",
          y2: "224.00002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M61.54451,156.55327A80.00347,80.00347,0,1,1,208,112c0,44.18278-32,72-64,72s-41.63152-21.06651-41.63152-21.06651",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPizza = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M239.30908,79.9873a16.03867,16.03867,0,0,0-4.22119-21.63085,184.07289,184.07289,0,0,0-214.17578,0A16.03867,16.03867,0,0,0,16.69092,79.9873h.00049l97.81,153.70166a15.99973,15.99973,0,0,0,26.99708,0l58.41259-91.79052c.01807-.0293.0376-.05811.05567-.08789ZM23.44043,75.69238ZM128,225.09912,95.54053,174.09155a36.00171,36.00171,0,1,0-37.55469-59.0144L47.40723,98.45361a135.99256,135.99256,0,0,1,161.18554,0L191.30127,125.626a35.99008,35.99008,0,0,0-38.64453,60.7268Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M23.44054,75.69239a8.02578,8.02578,0,0,1,2.13281-10.834,176.07221,176.07221,0,0,1,204.85329,0,8.02577,8.02577,0,0,1,2.13281,10.834L134.74929,229.394a8,8,0,0,1-13.49858,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M36.74566,96.60039a144.01884,144.01884,0,0,1,182.50866,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M164.31747,182.93292a28.00353,28.00353,0,1,1,28.82269-45.29368",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M57.89918,129.84281A28.00328,28.00328,0,1,1,84,168q-.91436,0-1.81448-.05785",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPlaceholder = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32ZM187.31348,187.31445a8.00061,8.00061,0,0,1-11.31348,0L68.68652,80A8.00018,8.00018,0,0,1,80,68.68555L187.31348,176A8.00032,8.00032,0,0,1,187.31348,187.31445Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "42.34314",
          y1: "42.34314",
          x2: "213.65687",
          y2: "213.65687",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPlanet = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.251,115.99854A96.03076,96.03076,0,0,1,128,224a95.50329,95.50329,0,0,1-57.96045-19.52515C94.58984,198.321,123.48145,186.03418,152,169.56934,180.542,153.09009,205.645,134.196,223.251,115.99854ZM245.7793,60c-5.46875-9.47119-20.31592-18.42773-59.82373-8.47852A95.94717,95.94717,0,0,0,32,128a96.48271,96.48271,0,0,0,.748,11.99414C4.41748,169.2085,4.75488,186.5332,10.2207,196c3.69336,6.39746,11.875,12.78809,29.81348,12.78809a117.6895,117.6895,0,0,0,25.47559-3.23243c1.49121-.33447,3.0039-.69824,4.52978-1.08081a96.84991,96.84991,0,0,1-14.24219-13.27978c-18.65527,3.31811-29.31591.96924-31.72021-3.19507-1.501-2.59961-.6582-7.48535,2.31152-13.4043a83.04134,83.04134,0,0,1,10.74121-15.61841,96.04543,96.04543,0,0,0,18.66748,32.21778q2.97071-.52845,6.20948-1.25171c23.94628-5.37207,53.06543-17.5293,81.99316-34.23047s54.01514-35.84082,70.6416-53.89258q2.27271-2.46827,4.228-4.79883a96.04556,96.04556,0,0,0-18.668-32.21752A83.29551,83.29551,0,0,1,219.1543,63.2998c6.61328.38672,11.26758,2.09961,12.76855,4.7002,2.40186,4.15967-.88428,14.54932-13.05322,29.02148a95.19186,95.19186,0,0,1,4.38135,18.97706c1.07959-1.11548,2.1372-2.229,3.15918-3.33838C251.69678,85.20508,250.90039,68.86914,245.7793,60Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184.17224,60.25854c27.75785-7.55343,48.54608-6.88109,54.679,3.74146C249.897,83.1317,209.22146,127.29479,148,162.641S28.19444,211.1317,17.14875,192c-6.13187-10.6207,3.67551-28.95548,24.08867-49.21359",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPlay = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232.3125,114.34375,88.34375,26.35937A15.99781,15.99781,0,0,0,64,40.00781V215.99219a16.00521,16.00521,0,0,0,24.34375,13.64843L232.3125,141.65625a16.00727,16.00727,0,0,0,0-27.3125Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M228.14833,121.17381,84.1717,33.18517A8,8,0,0,0,72,40.01136V215.98864a8,8,0,0,0,12.1717,6.82619l143.97663-87.98864A8,8,0,0,0,228.14833,121.17381Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPlayCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36.4375,110.65625-48,32A7.99612,7.99612,0,0,1,104,160V96a7.99612,7.99612,0,0,1,12.4375-6.65625l48,32a7.99959,7.99959,0,0,1,0,13.3125Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPlaylist = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,64a8.00008,8.00008,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8.00008,8.00008,0,0,1,32,64Zm8,72H160a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm72,48H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm130.29883-67.6626-40-12A7.99991,7.99991,0,0,0,192,112v52.30518A31.98859,31.98859,0,1,0,208,192V122.75244l29.70117,8.91016a8,8,0,1,0,4.59766-15.3252Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "192",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "176",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "200 192 200 112 240 124",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPlusCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,23.99805a104,104,0,1,0,104,104A104.12041,104.12041,0,0,0,128,23.99805Zm40,112H136v32a8,8,0,1,1-16,0v-32H88a8,8,0,0,1,0-16h32v-32a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPlusMinus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M205.65674,50.34326a8,8,0,0,0-11.31348,0l-144,144a7.99984,7.99984,0,1,0,11.31348,11.31348l144-144A7.99915,7.99915,0,0,0,205.65674,50.34326Z"
        }), React.createElement("path", {
          d: "M64,112a8,8,0,0,0,16,0V80h32a8,8,0,0,0,0-16H80V32a8,8,0,0,0-16,0V64H32a8,8,0,0,0,0,16H64Z"
        }), React.createElement("path", {
          d: "M224,176H144a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "72",
          x2: "112",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72",
          y1: "32",
          x2: "72",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPokerChip = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M202.16064,200.833a103.80643,103.80643,0,0,0,0-145.666,7.39654,7.39654,0,0,0-1.32666-1.32666,103.80639,103.80639,0,0,0-145.668,0A7.39654,7.39654,0,0,0,53.83936,55.167a103.80643,103.80643,0,0,0,0,145.666,7.39012,7.39012,0,0,0,1.32714,1.3269,103.80581,103.80581,0,0,0,145.667,0,7.39012,7.39012,0,0,0,1.32714-1.3269ZM40.36768,136h24.1499a63.6708,63.6708,0,0,0,12.95605,31.21216l-17.06884,17.0686A87.60592,87.60592,0,0,1,40.36768,136ZM60.40479,71.71924l17.06884,17.0686A63.6708,63.6708,0,0,0,64.51758,120H40.36768A87.60592,87.60592,0,0,1,60.40479,71.71924ZM215.63232,120h-24.1499a63.6708,63.6708,0,0,0-12.95605-31.21216l17.06884-17.0686A87.60592,87.60592,0,0,1,215.63232,120ZM167.21191,77.47339A63.66789,63.66789,0,0,0,136,64.51782V40.36743a87.60765,87.60765,0,0,1,48.28076,20.03736ZM120,64.51782A63.66789,63.66789,0,0,0,88.78809,77.47339L71.71924,60.40479A87.60765,87.60765,0,0,1,120,40.36743ZM88.78809,178.52661A63.66789,63.66789,0,0,0,120,191.48218v24.15039a87.60765,87.60765,0,0,1-48.28076-20.03736ZM136,191.48218a63.66789,63.66789,0,0,0,31.21191-12.95557l17.06885,17.0686A87.60765,87.60765,0,0,1,136,215.63257Zm42.52637-24.27A63.6708,63.6708,0,0,0,191.48242,136h24.1499a87.60592,87.60592,0,0,1-20.03711,48.28076Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88.40202",
          y1: "88.40202",
          x2: "60.11775",
          y2: "60.11775",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88.40202",
          y1: "167.59798",
          x2: "60.11775",
          y2: "195.88225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "167.59798",
          y1: "167.59798",
          x2: "195.88225",
          y2: "195.88225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "167.59798",
          y1: "88.40202",
          x2: "195.88225",
          y2: "60.11775",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPolygon = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M230.62744,49.37207a32.03673,32.03673,0,0,0-45.25488,0l-.00049.001a31.9114,31.9114,0,0,0-5.15478,6.75781l-28.24256-7.70215A31.978,31.978,0,0,0,97.37256,25.37207l-.00049.001a32.056,32.056,0,0,0-5.75415,37.4082L57.68018,93.3252a32.05378,32.05378,0,0,0-40.30762,4.04687l-.00049.001a32.00105,32.00105,0,0,0,42.88257,47.40039l70.03247,51.35791A32.00685,32.00685,0,1,0,177.855,181.44727l27.38355-77.58692c.91882.07861,1.84.124,2.76147.124a31.98463,31.98463,0,0,0,22.62744-54.61231Zm-67.866,126.7666a31.96846,31.96846,0,0,0-23.0166,7.0874l-70.032-51.35742a32.15784,32.15784,0,0,0-1.33081-26.6499L102.31982,74.6748a31.98394,31.98394,0,0,0,45.46289-10.80566l28.24256,7.70215a31.91307,31.91307,0,0,0,14.11951,26.98144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "120",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "40",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "160",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "208",
          cy: "72",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184.84844",
          y1: "65.68594",
          x2: "143.15155",
          y2: "54.31406",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "102.16099",
          y1: "64.05511",
          x2: "57.83902",
          y2: "103.94489",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "59.35636",
          y1: "134.19466",
          x2: "140.64365",
          y2: "193.80534",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "167.98938",
          y1: "185.36342",
          x2: "200.01089",
          y2: "94.6358",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPower = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,23.99988a104,104,0,1,0,104,104A104.11786,104.11786,0,0,0,128,23.99988Zm-8.00781,32.00293a8,8,0,0,1,16,0v60a8,8,0,1,1-16,0ZM128,207.99988A79.98292,79.98292,0,0,1,83.53516,61.52136a8,8,0,1,1,8.91357,13.28711,63.99978,63.99978,0,1,0,71.08838-.00976,8,8,0,0,1,8.91016-13.28955A79.98322,79.98322,0,0,1,128,207.99988Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "127.99219",
          y1: "48.00288",
          x2: "127.99219",
          y2: "124.00288",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176.00189,54.23268a88,88,0,1,1-96.00346-.00021",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPrescription = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M183.31348,188l22.34326-22.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L172,176.68652l-41.71289-41.71277A52.0008,52.0008,0,0,0,120,32H72a8.00008,8.00008,0,0,0-8,8V192a8,8,0,0,0,16,0V136h28.68652l52,52-22.34326,22.34326a7.99984,7.99984,0,1,0,11.31348,11.31348L172,199.31348l22.34326,22.34326a7.99984,7.99984,0,0,0,11.31348-11.31348ZM80,48h40a36,36,0,0,1,0,72H80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M72,128h48a44,44,0,0,0,0-88H72V192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "128",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "160",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPresentation = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16.01833,16.01833,0,0,0,24,56V176a16.01833,16.01833,0,0,0,16,16H79.35547L57.75293,219.00293a7.99979,7.99979,0,1,0,12.49414,9.99414L99.84473,192h56.31054l29.59766,36.99707a7.99979,7.99979,0,0,0,12.49414-9.99414L176.64453,192H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPresentationChart = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16.01833,16.01833,0,0,0,24,56V176a16.01833,16.01833,0,0,0,16,16H79.35547L57.75293,219.00293a7.99979,7.99979,0,1,0,12.49414,9.99414L99.84473,192h56.31054l29.59766,36.99707a7.99979,7.99979,0,0,0,12.49414-9.99414L176.64453,192H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM104,144a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "120",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "88",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPrinter = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M210.66064,72h-10.6665V40a8.00008,8.00008,0,0,0-8-8h-128a8.00008,8.00008,0,0,0-8,8V72H45.32764c-13.96875,0-25.3335,10.7666-25.3335,24v80a8.00008,8.00008,0,0,0,8,8h28v36a8.00008,8.00008,0,0,0,8,8h128a8.00008,8.00008,0,0,0,8-8V184h28a8.00008,8.00008,0,0,0,8-8V96C235.99414,82.7666,224.62939,72,210.66064,72ZM71.99414,48h112V72h-112Zm112,164h-112V160h112Zm4-84a12,12,0,1,1,12-12A12,12,0,0,1,187.99414,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "63.994 80 63.994 40 191.994 40 191.994 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "63.99414",
          y: "152",
          width: "128",
          height: "68",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M63.99414,176h-36V96c0-8.83656,7.7604-16,17.33333-16H210.66081c9.57293,0,17.33333,7.16344,17.33333,16v80h-36",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188",
          cy: "116",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconProhibit = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,128.00012a71.6357,71.6357,0,0,1-15.78027,44.90527L83.09424,71.78039A71.94387,71.94387,0,0,1,200,128.00012Zm-144,0a71.94342,71.94342,0,0,0,116.90576,56.21924L71.78027,83.09436A71.63607,71.63607,0,0,0,56,128.00012Zm180,0a108,108,0,1,1-108-108A108.12249,108.12249,0,0,1,236,128.00012Zm-20,0a88,88,0,1,0-88,88A88.09957,88.09957,0,0,0,216,128.00012Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128.00049",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "60.11824",
          y1: "60.11775",
          x2: "195.88274",
          y2: "195.88225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconProhibitInset = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128.00049,24.00452a104,104,0,1,0,104,104A104.12041,104.12041,0,0,0,128.00049,24.00452Zm22.62742,137.94112L94.05936,105.3771a8,8,0,0,1,11.31371-11.31371l56.56854,56.56854a8,8,0,1,1-11.3137,11.31371Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128.00049",
          cy: "128.00452",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "99.71622",
          y1: "99.72024",
          x2: "156.28476",
          y2: "156.28879",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconProjectorScreen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,64V48a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,48V64A16.01833,16.01833,0,0,0,40,80v96H32a8,8,0,0,0,0,16h88v17.37622a24,24,0,1,0,16,0V192h88a8,8,0,0,0,0-16h-8V80A16.01833,16.01833,0,0,0,232,64ZM128,240a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,128,240ZM40,48H216l.00977,16H40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconProjectorScreenChart = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,64V48a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,48V64A16.01833,16.01833,0,0,0,40,80v96H32a8,8,0,0,0,0,16h88v17.37622a24,24,0,1,0,16,0V192h88a8,8,0,0,0,0-16h-8V80A16.01833,16.01833,0,0,0,232,64ZM104,144a8,8,0,0,1-16,0V128a8,8,0,0,1,16,0Zm24,96a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,128,240Zm8-96a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0ZM40,64V48H216l.00977,16H40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "128",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "112",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPushPin = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.999,107.31445,173.47168,165.8418c4.55664,12.67968,6.44531,33.88965-13.18945,59.98584a15.96991,15.96991,0,0,1-11.64649,6.33007q-.5625.03955-1.124.03956a16.0039,16.0039,0,0,1-11.31934-4.69141L88,179.314,53.65723,213.65674a8.00018,8.00018,0,0,1-11.31446-11.31348L76.686,168,28.2959,119.60986a16.01339,16.01339,0,0,1,1.2832-23.78613C55.00488,75.312,79.34082,79.35205,89.99316,82.69287L148.68555,24l.001-.001a16.02135,16.02135,0,0,1,22.627,0L232,84.68652a15.99888,15.99888,0,0,1-.001,22.62793Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M154.34315,29.65685,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167C162.28278,209.86184,175.46546,186.93092,164,164l62.34315-62.34315a8,8,0,0,0,0-11.3137l-60.6863-60.6863A8,8,0,0,0,154.34315,29.65685Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPushPinSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,176a8.00008,8.00008,0,0,1-8,8H200.02393l-.0337.00146L199.95752,184H136v56a8,8,0,0,1-16,0V184H56.04248l-.03271.00146L55.97607,184H40a8,8,0,0,1,0-16h9.28857L70.46484,48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16h-6.46484l21.17627,120H216A8.00008,8.00008,0,0,1,224,176Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "176",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "176",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "40",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPushPinSimpleSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.38184,221.91943a8.00088,8.00088,0,0,1-11.30176-.53808L168.09717,184H136v56a8,8,0,0,1-16,0V184H56.1543c-.04883.001-.09668.00146-.14453.00146-.04883,0-.09668-.00048-.14551-.00146H40a8,8,0,0,1,0-16h9.28809L66.2373,71.95459,42.08008,45.38135a8.00027,8.00027,0,0,1,11.83984-10.7627l75.21729,82.739,48.41943,53.261.002.00293,36.36133,39.99707A8.00084,8.00084,0,0,1,213.38184,221.91943Zm-22.88672-60.85254a8,8,0,0,0,13.79785-6.77148L185.53516,48H192a8,8,0,0,0,0-16H91.19922a8.00042,8.00042,0,0,0-7.94043,7.54443c-.01367.24073-.0166.48194-.00879.72217a7.97263,7.97263,0,0,0,2.09863,5.13916Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "91.24627",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "40",
          x2: "196.41513",
          y2: "155.68575",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "171.63638",
          y1: "176",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "176",
          x2: "74.79803",
          y2: "69.47783",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPushPinSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.91992,210.61865a8.00027,8.00027,0,0,1-11.83984,10.7627l-26.42334-29.06543c-2.45459,14.17285-9.88623,26.21582-15.37451,33.51123a15.96882,15.96882,0,0,1-11.64649,6.33056q-.5625.03955-1.124.03956a16.0039,16.0039,0,0,1-11.31934-4.69141L88,179.314,53.65723,213.65674a8.00018,8.00018,0,0,1-11.31446-11.31348L76.686,168,28.2959,119.60986a16.01339,16.01339,0,0,1,1.2832-23.78613c16.17676-13.05029,31.90967-16.16064,43.96-15.8374l-31.459-34.605a8.00027,8.00027,0,0,1,11.83984-10.7627ZM232,84.68652,171.31348,23.999A16.02162,16.02162,0,0,0,148.68555,24L110.71,61.97607a8.00034,8.00034,0,0,0-.26269,11.03809l68.57128,75.42871a8.00133,8.00133,0,0,0,5.7295,2.61621c.06347.00147.12695.00244.19043.00244a8.00139,8.00139,0,0,0,5.65722-2.34326L231.999,107.31445A15.99888,15.99888,0,0,0,232,84.68652Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M93.71428,90.28572,92,92S64.256,78.128,34.60125,102.05044a8.01406,8.01406,0,0,0-.64838,11.90243L141.84933,221.84933a7.99324,7.99324,0,0,0,12.04036-.83167c7.60268-10.10523,19.13532-29.87219,12.71834-50.549",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184.9386,143.0614l41.40455-41.40455a8,8,0,0,0,0-11.3137l-60.6863-60.6863a8,8,0,0,0-11.3137,0l-37.976,37.976",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconPuzzlePiece = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M165.78027,224.001,207.99951,224a16.018,16.018,0,0,0,16-16L224,170.34863a7.99966,7.99966,0,0,0-11.05957-7.3916A23.25464,23.25464,0,0,1,204,164.72754c-13.2334,0-24-11.09277-24-24.72754s10.7666-24.72754,24-24.72754a23.25464,23.25464,0,0,1,8.94043,1.77051A7.99966,7.99966,0,0,0,224,109.65137L223.99951,72A16.01812,16.01812,0,0,0,207.999,56l-36.21728.001A36.60975,36.60975,0,0,0,171.99951,52a36,36,0,0,0-72,0,36.60975,36.60975,0,0,0,.21778,4.001L63.99951,56a16.018,16.018,0,0,0-16,16L48,104.21777A36.47481,36.47481,0,0,0,43.99951,104a36,36,0,0,0,0,72A36.47481,36.47481,0,0,0,48,175.78223L47.99951,208A16.01791,16.01791,0,0,0,63.999,224l42.22071.001h0"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M63.99986,216a8,8,0,0,1-8-8.00009l.00053-42.69468a28,28,0,1,1,0-50.61044L55.99988,72.0001A8,8,0,0,1,64,64l46.69456.00053a27.99993,27.99993,0,1,1,50.61031,0L207.99939,64a8,8,0,0,1,8.00007,7.9999L216,114.69478a28,28,0,1,0,0,50.61044l-.00053,42.69487a8,8,0,0,1-8,7.9999Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconQrCode = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("rect", {
          x: "40.00244",
          y: "40",
          width: "80",
          height: "80",
          rx: "16"
        }), React.createElement("rect", {
          x: "40.00244",
          y: "136",
          width: "80",
          height: "80",
          rx: "16"
        }), React.createElement("rect", {
          x: "136.00244",
          y: "40",
          width: "80",
          height: "80",
          rx: "16"
        }), React.createElement("path", {
          d: "M144.00244,184a8.00039,8.00039,0,0,0,8-8V144a8,8,0,0,0-16,0v32A8.00039,8.00039,0,0,0,144.00244,184Z"
        }), React.createElement("path", {
          d: "M208.00244,152h-24v-8a8,8,0,0,0-16,0v56h-24a8,8,0,1,0,0,16h32a8.00039,8.00039,0,0,0,8-8V168h24a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M208.00244,184a8.00039,8.00039,0,0,0-8,8v16a8,8,0,0,0,16,0V192A8.00039,8.00039,0,0,0,208.00244,184Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "48.00244",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "48.00244",
          y: "144",
          width: "64",
          height: "64",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "144.00244",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "144.00244",
          y1: "144",
          x2: "144.00244",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "144.002 208 176.002 208 176.002 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176.00244",
          y1: "160",
          x2: "208.00244",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208.00244",
          y1: "192",
          x2: "208.00244",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconQuestion = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128.00146,23.99963a104,104,0,1,0,104,104A104.11791,104.11791,0,0,0,128.00146,23.99963ZM128.002,192a12,12,0,1,1,12-12A12,12,0,0,1,128.002,192Zm7.99951-48.891v.89551a8,8,0,1,1-16,0v-8a8.0004,8.0004,0,0,1,8-8,20,20,0,1,0-20-20,8,8,0,0,1-16,0,36,36,0,1,1,44,35.10449Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "180",
          r: "12"
        }), React.createElement("path", {
          d: "M127.9995,144.0045v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconQueue = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,64a8.00008,8.00008,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8.00008,8.00008,0,0,1,32,64Zm104,56H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm108.24023-30.78418-64-40A8.00044,8.00044,0,0,0,168,120v80a8.00043,8.00043,0,0,0,12.24023,6.78418l64-40a8.00062,8.00062,0,0,0,0-13.56836Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "192",
          x2: "136",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "240 160 176 200 176 120 240 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconQuotes = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M116,72v88a48.05436,48.05436,0,0,1-48,48,8,8,0,0,1,0-16,32.036,32.036,0,0,0,32-32v-8H40a16.01833,16.01833,0,0,1-16-16V72A16.01833,16.01833,0,0,1,40,56h60A16.01833,16.01833,0,0,1,116,72ZM216,56H156a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16h60v8a32.036,32.036,0,0,1-32,32,8,8,0,0,0,0,16,48.05436,48.05436,0,0,0,48-48V72A16.01833,16.01833,0,0,0,216,56Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRadical = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M72,208a7.99963,7.99963,0,0,1-7.49072-5.19092l-48-128a8.00011,8.00011,0,0,1,14.98144-5.61816L72,177.21582l40.50928-108.0249A7.99963,7.99963,0,0,1,120,64H232a7.99977,7.99977,0,0,1,8,8V96a8,8,0,0,1-16,0V80H125.544L79.49072,202.80908A7.99963,7.99963,0,0,1,72,208Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "232 96 232 72 120 72 72 200 24 72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRadio = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,72H86.509l107.7898-32.33691a8.00047,8.00047,0,0,0-4.59766-15.32618l-160,48-.022.00782c-.21753.06591-.4292.144-.63818.22729-.04.01587-.082.02808-.12159.04444-.1792.075-.35229.16174-.5249.249-.06665.03369-.13672.06225-.20239.09765-.06421.03467-.12378.07642-.187.1128a7.95455,7.95455,0,0,0-2.10157,1.7511c-.02563.03039-.05444.05786-.07983.08862-.08984.10925-.16992.22546-.25366.33923-.071.096-.14624.18836-.21289.2876-.03638.05432-.06665.11231-.10181.1676a7.94225,7.94225,0,0,0-.989,2.27381c-.03443.1322-.074.26269-.102.39685-.00782.03869-.01123.07885-.0188.11767-.043.22473-.07984.451-.10352.68006-.00146.01342-.00122.0271-.00244.04052-.02515.25391-.03857.50977-.03882.76734L24,80V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V88A16.01833,16.01833,0,0,0,216,72ZM96,184H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm72,52a28,28,0,1,1,28-28A28.03209,28.03209,0,0,1,168,172Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "80",
          x2: "192",
          y2: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "160",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "112",
          x2: "96",
          y2: "112",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "144",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRainbow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184,168v16a8,8,0,0,1-16,0V168a40,40,0,0,0-80,0v16a8,8,0,0,1-16,0V168a56,56,0,0,1,112,0ZM128,80a88.09957,88.09957,0,0,0-88,88v16a8,8,0,0,0,16,0V168a72,72,0,0,1,144,0v16a8,8,0,0,0,16,0V168A88.09957,88.09957,0,0,0,128,80Zm0-32A120.13623,120.13623,0,0,0,8,168v16a8,8,0,0,0,16,0V168a104,104,0,0,1,208,0v16a8,8,0,0,0,16,0V168A120.13623,120.13623,0,0,0,128,48Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,184V168a48,48,0,0,0-96,0v16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M208,184V168a80,80,0,0,0-160,0v16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M240,184V168a112,112,0,0,0-224,0v16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRainbowCloud = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248,160a48.054,48.054,0,0,1-48,48H152c-17.645,0-32-14.75391-32-32.88867s14.355-32.88867,32-32.88867a31.5421,31.5421,0,0,1,3.33545.17578A48.00491,48.00491,0,0,1,248,160ZM112,72a87.53238,87.53238,0,0,1,61.34814,24.91016,8.00027,8.00027,0,0,0,11.15528-11.47071A104.00011,104.00011,0,0,0,8,160v16a8,8,0,0,0,16,0V160A88.09957,88.09957,0,0,1,112,72Zm0,32a55.55123,55.55123,0,0,1,33.12842,10.84473A7.99959,7.99959,0,1,0,154.605,101.9541,72.00452,72.00452,0,0,0,40,160v16a8,8,0,0,0,16,0V160A56.06322,56.06322,0,0,1,112,104Zm15.20508,26.71289a7.99944,7.99944,0,0,0-5.936-9.63086A40.02529,40.02529,0,0,0,72,160v16a8,8,0,0,0,16,0V160a24.02909,24.02909,0,0,1,29.57373-23.35156A7.99553,7.99553,0,0,0,127.20508,130.71289Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,200c-13.25483,0-24-11.14314-24-24.88889s10.74517-24.88889,24-24.88889a23.18816,23.18816,0,0,1,8.81117,1.73087l-.00141-.0003A40.00363,40.00363,0,1,1,200,200Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M16,176V160A96.00006,96.00006,0,0,1,178.92582,91.17453",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48,176V160a64.00543,64.00543,0,0,1,101.86674-51.60093",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,176V160a32.02814,32.02814,0,0,1,39.42145-31.135",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconReceipt = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V208a8,8,0,0,0,11.57812,7.15527L64,200.94434l28.42188,14.21093a8.00257,8.00257,0,0,0,7.15624,0L128,200.94434l28.42188,14.21093a8.00049,8.00049,0,0,0,7.15624,0L192,200.94434l28.42188,14.21093A8,8,0,0,0,232,208V56A16.01833,16.01833,0,0,0,216,40ZM180,144H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "76",
          y1: "104",
          x2: "180",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "76",
          y1: "136",
          x2: "180",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRecord = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.09957,88.09957,0,0,1,128,216Z"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "72"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "64",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRectangle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "24.00781",
          y: "40",
          width: "208",
          height: "176",
          rx: "16"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRecycle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M236.76758,203.98145a23.75493,23.75493,0,0,1-20.791,12.01074H160V232a8.00052,8.00052,0,0,1-13.6582,5.65625l-24-24.00781a8.0018,8.0018,0,0,1,.00195-11.31446l24-23.99218A8.00042,8.00042,0,0,1,160,184v15.99219h55.97656a8.00079,8.00079,0,0,0,6.92383-12.00781l-23.95117-41.37793a8.00013,8.00013,0,1,1,13.84766-8.01563l23.95117,41.37793A23.75534,23.75534,0,0,1,236.76758,203.98145ZM88,199.99219H40.02344a8.00079,8.00079,0,0,1-6.92383-12.00781L61.062,139.67554l13.894,8.02173a7.99907,7.99907,0,0,0,11.72657-9l-8.792-32.78907a7.99883,7.99883,0,0,0-9.79882-5.65429L35.31445,109.043a7.99934,7.99934,0,0,0-1.92773,14.6543l13.81836,7.978L19.252,179.96875a24.00019,24.00019,0,0,0,20.77149,36.02344H88a8,8,0,0,0,0-16ZM128,32a7.86145,7.86145,0,0,1,6.92383,3.99219l27.95361,48.2937-13.81982,7.97876a7.9999,7.9999,0,0,0,1.92871,14.65527l32.77832,8.78809a7.99309,7.99309,0,0,0,9.79883-5.65625l8.791-32.78809a8,8,0,0,0-11.72754-8.999l-13.89306,8.021L148.77148,27.97656a24.00073,24.00073,0,0,0-41.543,0L83.27832,69.35449A8.00013,8.00013,0,0,0,97.126,77.37012l23.95019-41.37793A7.86145,7.86145,0,0,1,128,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "152 232 128 207.992 152 184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "194.627 75.192 185.836 107.981 153.058 99.192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "78.956 140.769 70.164 107.981 37.386 116.769",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,207.99231h87.97627A16,16,0,0,0,229.82386,183.977l-23.95094-41.37884",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M70.1643,107.98084,26.17616,183.977a16.00005,16.00005,0,0,0,13.84762,24.01535H87.99992",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M185.83571,107.98085,141.84757,31.98472a16,16,0,0,0-27.69514,0L90.20239,73.362",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRedditLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M248,104a31.99228,31.99228,0,0,0-52.9375-24.19043c-16.75439-8.90112-36.76172-14.279-57.666-15.52539l5.19581-31.17578,21.83105,3.3584a24.00409,24.00409,0,1,0,2.43506-15.814l-29.64209-4.56006a7.996,7.996,0,0,0-9.10742,6.5918l-6.91309,41.478c-21.83887.94165-42.813,6.37891-60.2583,15.647a31.99266,31.99266,0,0,0-42.59229,47.74024A59.04669,59.04669,0,0,0,16,144c0,21.93457,12.042,42.35156,33.90723,57.48926C70.875,216.00588,98.60938,224,128,224s57.125-7.99414,78.09277-22.51074C227.958,186.35158,240,165.93459,240,144a59.01726,59.01726,0,0,0-2.3457-16.44922A32.17163,32.17163,0,0,0,248,104ZM72,132a16,16,0,1,1,16,16A16.01833,16.01833,0,0,1,72,132Zm92.69629,51.10938a80.122,80.122,0,0,1-73.39209,0,8,8,0,0,1,7.34033-14.2168,64.09433,64.09433,0,0,0,58.71094,0,8.00008,8.00008,0,0,1,7.34082,14.2168ZM168,148a16,16,0,1,1,16-16A16.01833,16.01833,0,0,1,168,148Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "188",
          cy: "32.00002",
          r: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M161.026,176.00058a72.17425,72.17425,0,0,1-66.05159.0002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "128 72 136 24 172.185 29.567",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M59.408,89.87843C77.71654,78.7483,101.71994,72,128,72s50.28346,6.7483,68.592,17.87843l-.00129.00213a24.002,24.002,0,1,1,31.61564,34.788l.002-.00083A51.61606,51.61606,0,0,1,232,144c0,39.7645-46.56239,72-104,72S24,183.7645,24,144a51.61624,51.61624,0,0,1,3.79162-19.3323l.00206.00082a24.00228,24.00228,0,1,1,31.61564-34.788Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "88",
          cy: "132",
          r: "16"
        }), React.createElement("circle", {
          cx: "168",
          cy: "132",
          r: "16"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRepeat = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M24,128A72.08124,72.08124,0,0,1,96,56h96V40a8.0001,8.0001,0,0,1,13.65723-5.65674l24,24a8,8,0,0,1,0,11.31348l-24,24A8.0001,8.0001,0,0,1,192,88V72H96a56.06322,56.06322,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8.00039,8.00039,0,0,0-8,8,56.06322,56.06322,0,0,1-56,56H64V168a8.0001,8.0001,0,0,0-13.65723-5.65674l-24,24a8,8,0,0,0,0,11.31348l24,24A8.0001,8.0001,0,0,0,64,216V200h96a72.08124,72.08124,0,0,0,72-72A8.00039,8.00039,0,0,0,224,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,128A64,64,0,0,1,96,64H224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,128a64,64,0,0,1-64,64H32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRepeatOnce = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M24,128A72.08124,72.08124,0,0,1,96,56h96V40a8.0001,8.0001,0,0,1,13.65723-5.65674l24,24a8,8,0,0,1,0,11.31348l-24,24A8.0001,8.0001,0,0,1,192,88V72H96a56.06322,56.06322,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8.00039,8.00039,0,0,0-8,8,56.06322,56.06322,0,0,1-56,56H64V168a8.0001,8.0001,0,0,0-13.65723-5.65674l-24,24a8,8,0,0,0,0,11.31348l24,24A8.0001,8.0001,0,0,0,64,216V200h96a72.08124,72.08124,0,0,0,72-72A8.00039,8.00039,0,0,0,224,120Zm-92,40a8.00039,8.00039,0,0,0,8-8V104a7.99986,7.99986,0,0,0-11.5752-7.15674l-16,7.99268a8.00006,8.00006,0,0,0,7.1504,14.31347l4.4248-2.21V152A8.00039,8.00039,0,0,0,132,160Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,128A64,64,0,0,1,96,64H224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,128a64,64,0,0,1-64,64H32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "116 111.993 132 104 132 152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRewind = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M10.1416,114.541,99.34766,57.19434A16.00057,16.00057,0,0,1,124,70.65332v42.69287l87.34766-56.15185A16.00057,16.00057,0,0,1,236,70.65332V185.34668a15.99914,15.99914,0,0,1-24.65234,13.459L124,142.65381v42.69287a15.99914,15.99914,0,0,1-24.65234,13.459L10.1416,141.459a16.0005,16.0005,0,0,1,0-26.918Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M14.468,121.27057,103.67394,63.9239A8,8,0,0,1,116,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L14.468,134.72943A8,8,0,0,1,14.468,121.27057Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M126.468,121.27057,215.67394,63.9239A8,8,0,0,1,228,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L126.468,134.72943A8,8,0,0,1,126.468,121.27057Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRewindCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M24,128A104,104,0,1,0,128,24,104.11791,104.11791,0,0,0,24,128Zm44,0a7.99968,7.99968,0,0,1,3.41211-6.55371l40-28A8.00015,8.00015,0,0,1,124,100v28a7.99968,7.99968,0,0,1,3.41211-6.55371l40-28A8.00015,8.00015,0,0,1,180,100v56a8,8,0,0,1-12.58789,6.55371l-40-28A7.99968,7.99968,0,0,1,124,128v28a8,8,0,0,1-12.58789,6.55371l-40-28A7.99968,7.99968,0,0,1,68,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "176 160 128 128 176 96 176 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "112 160 64 128 112 96 112 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRobot = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,48H136V16a8,8,0,0,0-16,0V48H56A32.03635,32.03635,0,0,0,24,80V192a32.03635,32.03635,0,0,0,32,32H200a32.03635,32.03635,0,0,0,32-32V80A32.03635,32.03635,0,0,0,200,48ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm28,76H92a16,16,0,0,1,0-32h8Zm40,0H116V152h24Zm24,0h-8V152h8a16,16,0,0,1,0,32Zm8-64a12,12,0,1,1,12-12A12,12,0,0,1,172,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "160",
          rx: "24",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "72",
          y: "144",
          width: "112",
          height: "40",
          rx: "19.99998",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "148",
          y1: "144",
          x2: "148",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "108",
          y1: "144",
          x2: "108",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "84",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "172",
          cy: "108",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRocket = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M144,216H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M219.62891,143.85889l-30.23658-36.28418a124.52267,124.52267,0,0,0-7.98022-34.8833c-11.61719-30.21192-32.15625-49.999-43.36523-59.10547a16.07708,16.07708,0,0,0-20.07813-.0669C106.61328,22.61621,85.81055,42.38867,74.07617,72.605A122.76188,122.76188,0,0,0,65.979,108.32861L36.37109,143.85889A16.10066,16.10066,0,0,0,33.043,157.57275l12.36328,55.63282a15.98523,15.98523,0,0,0,25.61328,9.023L98.80566,200h58.38868l27.78515,22.22852a15.91184,15.91184,0,0,0,9.96485,3.51709,16.0905,16.0905,0,0,0,5.34668-.91944,15.90581,15.90581,0,0,0,10.30273-11.62012L222.957,157.57373A16.102,16.102,0,0,0,219.62891,143.85889Zm-158.60352,65.876-12.36328-55.6333,17.92651-21.5122q3.40906,28.0371,19.14038,57.38281ZM128,108a12,12,0,1,1,12-12A12,12,0,0,1,128,108Zm66.97461,101.73486-24.74976-19.7998q15.53064-29.55175,18.74341-57.87695l18.36963,22.04345Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "144",
          y1: "224",
          x2: "112",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M122.97053,19.76275C103.97814,34.97686,40.45429,95.77187,96,192h64c54.39078-96.16-8.20388-156.9371-26.9971-172.20489A7.98387,7.98387,0,0,0,122.97053,19.76275Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M73.86661,111.36007,42.51644,148.98028a8,8,0,0,0-1.66373,6.85692l12.36292,55.63314a8,8,0,0,0,12.80706,4.51151L96,192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M181.53142,110.63771l31.95214,38.34257a8,8,0,0,1,1.66373,6.85692l-12.36292,55.63314a8,8,0,0,1-12.80706,4.51151L160,192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "96",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRocketLaunch = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M96.58887,176.979a8.00118,8.00118,0,0,0-10.12012,5.06006C79.916,201.69775,58.57422,207.78613,46.332,209.669c1.88281-12.24854,7.97168-33.58594,27.62988-40.13819a8.00027,8.00027,0,1,0-5.06054-15.1792c-16.36035,5.45362-28.37891,18.45069-34.75782,37.58692a92.73335,92.73335,0,0,0-4.65332,26.57129,8.00041,8.00041,0,0,0,8,8,92.73569,92.73569,0,0,0,26.57129-4.65332c19.13575-6.37842,32.13282-18.39747,37.58692-34.75782A8.001,8.001,0,0,0,96.58887,176.979Z"
        }), React.createElement("path", {
          d: "M227.6123,41.82031A15.879,15.879,0,0,0,214.17871,28.3877c-11.28613-1.68409-40.62109-2.51319-69.209,26.07324l-8.97046,8.9707H74.74512a15.90118,15.90118,0,0,0-11.31446,4.686L31.08887,100.46a16.00008,16.00008,0,0,0,8.17675,27.00244l39.53492,7.90723,41.82983,41.82959,7.90674,39.53516a15.99768,15.99768,0,0,0,27.00391,8.17578l32.34179-32.34229a15.8955,15.8955,0,0,0,4.68555-11.313V120l8.9707-8.9707C230.127,82.44141,229.29688,53.10645,227.6123,41.82031ZM74.74512,79.43164h45.25439l-39.884,39.88379-37.71216-7.542ZM176.56836,181.25488l-32.3418,32.3418-7.54223-37.71191,39.884-39.88428Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M94.05887,184.56854c-11.3137,33.94113-56.56854,33.94113-56.56854,33.94113s0-45.25484,33.94113-56.56854",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M195.88225,105.37258,128,173.25483,82.74517,128l67.88225-67.88225c25.70415-25.70415,51.40829-25.45342,62.37042-23.81787a7.96343,7.96343,0,0,1,6.70228,6.70228C221.33567,53.96429,221.5864,79.66843,195.88225,105.37258Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184.56854,116.68629v64.56854a8,8,0,0,1-2.34314,5.65686l-32.34176,32.34176a8,8,0,0,1-13.5015-4.08793L128,173.25483",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M139.31371,71.43146H74.74517a8,8,0,0,0-5.65686,2.34314L36.74655,106.11636a8,8,0,0,0,4.08793,13.5015L82.74517,128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRows = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,152v40a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V152a16.01833,16.01833,0,0,1,16-16H208A16.01833,16.01833,0,0,1,224,152ZM208,48H48A16.01833,16.01833,0,0,0,32,64v40a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V64A16.01833,16.01833,0,0,0,208,48Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "40",
          y: "56",
          width: "176",
          height: "56",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRss = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M98.90576,157.08752a71.531,71.531,0,0,1,21.08838,50.91211,8,8,0,0,1-16,0,56.00027,56.00027,0,0,0-56-56,8,8,0,1,1,0-16A71.53147,71.53147,0,0,1,98.90576,157.08752ZM47.99414,87.99963a8,8,0,1,0,0,16,104.00183,104.00183,0,0,1,104,104,8,8,0,0,0,16,0,120.00093,120.00093,0,0,0-120-120Zm118.794,1.20606A166.90561,166.90561,0,0,0,47.99414,39.99963a8,8,0,0,0,0,16,151.00491,151.00491,0,0,1,107.48047,44.52051,151.00328,151.00328,0,0,1,44.51953,107.47949,8,8,0,0,0,16,0A166.90191,166.90191,0,0,0,166.78809,89.20569ZM51.99414,191.99963a12,12,0,1,0,12,12A12.01344,12.01344,0,0,0,51.99414,191.99963Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M48,144a64,64,0,0,1,64,64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48,96A112,112,0,0,1,160,208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M48,48A160,160,0,0,1,208,208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "52",
          cy: "204",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRssSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99414,199.99963a8,8,0,0,1-16,0c0-79.40234-64.59814-144-144-144a8,8,0,0,1,0-16C144.21826,39.99963,215.99414,111.775,215.99414,199.99963Zm-160-88a8,8,0,1,0,0,16,72.08124,72.08124,0,0,1,72,72,8,8,0,0,0,16,0A88.09957,88.09957,0,0,0,55.99414,111.99963Zm0,76a12,12,0,1,0,12,12A12.01344,12.01344,0,0,0,55.99414,187.99963Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56,48A152,152,0,0,1,208,200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,120a80,80,0,0,1,80,80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "56",
          cy: "200",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconRuler = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,76.68652,179.31348,23.999A16.02162,16.02162,0,0,0,156.68555,24L132,48.686l37.65723,37.65722a8.00018,8.00018,0,0,1-11.31446,11.31348L120.686,60,96,84.686l37.65723,37.65722a8.00018,8.00018,0,0,1-11.31446,11.31348L84.686,96,60,120.686l37.65723,37.65722a8.00018,8.00018,0,0,1-11.31446,11.31348L48.686,132,24.001,156.68555A15.99888,15.99888,0,0,0,24,179.31348L76.68652,232.001A16.02252,16.02252,0,0,0,99.31445,232L232,99.31348a15.9989,15.9989,0,0,0,0-22.627Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "26.17662",
          y: "82.74517",
          width: "203.64675",
          height: "90.50967",
          rx: "8",
          transform: "translate(-53.01934 128) rotate(-45)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "132",
          y1: "60",
          x2: "164",
          y2: "92",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "96",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "60",
          y1: "132",
          x2: "92",
          y2: "164",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconScales = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M239.42773,133.0293l-32-80c-.0122-.03076-.03076-.05762-.04345-.08838a7.94631,7.94631,0,0,0-.481-.98145c-.01465-.02441-.03125-.04687-.0459-.07129a7.93042,7.93042,0,0,0-.5708-.82275c-.04443-.05615-.08691-.11328-.13281-.168a7.96437,7.96437,0,0,0-.71143-.75635c-.0459-.04248-.09472-.08007-.1416-.12158a8.00092,8.00092,0,0,0-.69189-.54639c-.06787-.04785-.13428-.09765-.20362-.144a8.16785,8.16785,0,0,0-.87256-.50146c-.06787-.03321-.13769-.06153-.20654-.09278a7.92639,7.92639,0,0,0-.82617-.32519c-.06494-.02149-.12842-.0459-.19434-.06592a8.04279,8.04279,0,0,0-1.0249-.23584c-.06445-.01025-.12939-.0166-.19385-.02588a7.97774,7.97774,0,0,0-.99365-.07519C200.062,48.00684,200.03174,48,200,48c-.01221,0-.02393.00293-.03613.00293a7.87125,7.87125,0,0,0-1.07032.081c-.08789.01221-.17382.02881-.26074.044-.123.02148-.24511.03516-.36816.0625L136,62.02686V40a8,8,0,0,0-16,0V65.58252L54.26465,80.19043c-.16553.03662-.32373.0874-.48438.13379-.06933.02-.14013.03564-.209.05762a7.95224,7.95224,0,0,0-.97656.38378c-.05762.02735-.1128.05762-.16944.08643a7.92974,7.92974,0,0,0-.81787.47022c-.04394.0288-.08935.05517-.13281.085a7.96988,7.96988,0,0,0-.82764.65381c-.04834.04345-.09326.08984-.14062.13476a8.08693,8.08693,0,0,0-.63086.66992c-.04053.04834-.0835.09375-.123.14356a8.00617,8.00617,0,0,0-.58935.84961c-.041.06787-.07862.1372-.11768.20605a8.00524,8.00524,0,0,0-.45752.93262c-.00439.01123-.01123.02051-.01562.03174l-.00977.0249-.01416.03467L16.57227,165.0293A7.99723,7.99723,0,0,0,16,168c0,23.3125,24.53516,32,40,32s40-8.6875,40-32a7.99723,7.99723,0,0,0-.57227-2.9707L66.92334,93.76758,120,81.97314V208H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16H136V78.41748l50.94531-11.32129-26.373,65.93311A7.99723,7.99723,0,0,0,160,136c0,23.3125,24.53516,32,40,32s40-8.6875,40-32A7.99723,7.99723,0,0,0,239.42773,133.0293ZM32.61621,168,56,109.541,79.38379,168Zm144-32L200,77.541,223.38379,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "216",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "88",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M24,168c0,17.67311,20,24,32,24s32-6.32689,32-24L56,88Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,136c0,17.67311,20,24,32,24s32-6.32689,32-24L200,56Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconScissors = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M157.73193,113.13086a8.00047,8.00047,0,0,1,2.085-11.12012l67.66553-46.29785A8.00013,8.00013,0,0,1,236.51758,68.918l-67.66553,46.29785a7.99794,7.99794,0,0,1-11.12012-2.085Zm80.87061,85.07129a7.99794,7.99794,0,0,1-11.12012,2.085l-91.4826-62.59351L93.49408,166.77686a36.034,36.034,0,1,1-9.05035-13.19458l37.38867-25.582-37.3891-25.582a35.84637,35.84637,0,1,1,9.0506-13.19458L236.51758,187.082A8.00047,8.00047,0,0,1,238.60254,198.20215ZM80,180a20,20,0,1,0-5.85791,14.1416A19.86692,19.86692,0,0,0,80,180ZM74.14209,90.1416a20,20,0,1,0-28.28418,0A19.86692,19.86692,0,0,0,74.14209,90.1416Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "60",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "60",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136",
          y1: "128",
          x2: "83.10669",
          y2: "164.19016",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "232",
          y1: "62.31579",
          x2: "164.33455",
          y2: "108.6132",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "232",
          y1: "193.68421",
          x2: "83.10611",
          y2: "91.80944",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconScreencast = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M31.99414,184a8,8,0,0,0,0,16,8.00917,8.00917,0,0,1,8,8,8,8,0,0,0,16,0A24.02718,24.02718,0,0,0,31.99414,184Z"
        }), React.createElement("path", {
          d: "M31.99414,152a8,8,0,0,0,0,16,40.04552,40.04552,0,0,1,40,40,8,8,0,0,0,16,0A56.06322,56.06322,0,0,0,31.99414,152Z"
        }), React.createElement("path", {
          d: "M31.99414,120a8,8,0,0,0,0,16,72.08124,72.08124,0,0,1,72,72,8,8,0,0,0,16,0A88.09957,88.09957,0,0,0,31.99414,120Z"
        }), React.createElement("path", {
          d: "M215.99414,40h-176a16.01833,16.01833,0,0,0-16,16V96a8.00008,8.00008,0,0,0,8,8,104.11791,104.11791,0,0,1,104,104,8.00008,8.00008,0,0,0,8,8h72a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,215.99414,40Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M31.99414,96V56a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8h-72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M31.99414,192a16,16,0,0,1,16,16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M31.99414,160a48,48,0,0,1,48,48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M31.99414,128a80,80,0,0,1,80,80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconScribbleLoop = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M246.14551,154.87842c-1.24219-1.49072-22.92774-27.03711-59.82129-41.3501C184.21387,95.708,177.43262,79.4668,166.709,66.91113,151.6709,49.30566,129.98633,40,104,40,52.47559,40,18.89453,86.18408,17.49023,88.1499A8.00013,8.00013,0,0,0,30.50293,97.46C30.80078,97.04541,60.8125,56,104,56c21.16113,0,38.63867,7.36621,50.542,21.30273a69.15627,69.15627,0,0,1,14.69629,30.792A136.9288,136.9288,0,0,0,136,104c-26.06055,0-47.93848,6.80957-63.26758,19.69189-13.55957,11.39551-21.33691,27.27149-21.33691,43.55665a47.58841,47.58841,0,0,0,13.87207,34.05468C74.92871,210.918,88.32227,216,104,216c25.22266,0,46.68848-9.97607,62.0752-28.84961,12.21484-14.98291,19.65136-35.09668,20.79882-55.90185,29.38184,13.26708,46.73145,33.57617,46.98047,33.873a7.99987,7.99987,0,1,0,12.291-10.24316ZM104,200c-25.28613,0-36.60449-16.44922-36.60449-32.75146C67.39551,144.49219,88.86426,120,136,120a120.00113,120.00113,0,0,1,35.0293,5.27344c0,.10937.001.22021.001.32959C171.03027,162.57373,148.00586,200,104,200Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSelection = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,40a7.99977,7.99977,0,0,1-8,8H112a8,8,0,0,1,0-16h32A7.99977,7.99977,0,0,1,152,40Zm-8,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V71.99951a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,71.99951a7.99977,7.99977,0,0,0-8,8v32a8,8,0,0,0,16,0v-32A7.99977,7.99977,0,0,0,216,103.99951Zm0,72a7.99977,7.99977,0,0,0-8,8V208H184a8,8,0,0,0,0,16h24a16.01833,16.01833,0,0,0,16-16V183.99951A7.99977,7.99977,0,0,0,216,175.99951Zm-176-24a7.99977,7.99977,0,0,0,8-8v-32a8,8,0,1,0-16,0v32A7.99977,7.99977,0,0,0,40,151.99951ZM72,208H48V183.99951a8,8,0,0,0-16,0V208a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM72,32H48A16.01833,16.01833,0,0,0,32,48V71.99951a8,8,0,0,0,16,0V48H72a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V71.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "143.99963",
          x2: "216",
          y2: "111.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V183.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "111.99963",
          x2: "40",
          y2: "143.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V183.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V71.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSelectionAll = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M104,40a8.00008,8.00008,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8.00008,8.00008,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,72a8.00008,8.00008,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8.00008,8.00008,0,0,0,216,104Zm0,72a8.00008,8.00008,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16.01833,16.01833,0,0,0,16-16V184A8.00008,8.00008,0,0,0,216,176ZM40,152a8.00008,8.00008,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8.00008,8.00008,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8.00008,8.00008,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,48V72A8.00008,8.00008,0,0,0,40,80ZM176,184H80a8.00008,8.00008,0,0,1-8-8V80a8.00008,8.00008,0,0,1,8-8h96a8.00008,8.00008,0,0,1,8,8v96A8.00008,8.00008,0,0,1,176,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V71.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "143.99963",
          x2: "216",
          y2: "111.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V183.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "111.99963",
          x2: "40",
          y2: "143.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V183.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V71.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSelectionBackground = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,56V48A16.01833,16.01833,0,0,1,96,32h8a8,8,0,0,1,0,16H96v8a8,8,0,0,1-16,0Zm64-8h16a8,8,0,0,0,0-16H144a8,8,0,0,0,0,16Zm64-16h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,56a8.00008,8.00008,0,0,0-8,8v16a8,8,0,0,0,16,0V96A8.00008,8.00008,0,0,0,216,88Zm-40.001,7.99414v112a16.01833,16.01833,0,0,1-16,16h-112a16.01833,16.01833,0,0,1-16-16v-112a16.01833,16.01833,0,0,1,16-16h112A16.01833,16.01833,0,0,1,175.999,95.99414Zm-16,0h-112v112h112ZM216,144a8.00008,8.00008,0,0,0-8,8v8h-8a8,8,0,0,0,0,16h8a16.01833,16.01833,0,0,0,16-16v-8A8.00008,8.00008,0,0,0,216,144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "39.99902",
          y: "87.99414",
          width: "128",
          height: "128",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "160",
          y1: "40",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,40h8a8,8,0,0,1,8,8v7.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "111.99963",
          x2: "216",
          y2: "95.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,168h8a8,8,0,0,0,8-8v-8.00037",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M104,40H96a8,8,0,0,0-8,8v7.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSelectionForeground = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M64,216a8.00008,8.00008,0,0,1-8,8H48a16.01833,16.01833,0,0,1-16-16v-8a8,8,0,0,1,16,0v8h8A8.00008,8.00008,0,0,1,64,216Zm48-8H96a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16ZM40,168a8.00008,8.00008,0,0,0,8-8V144a8,8,0,0,0-16,0v16A8.00008,8.00008,0,0,0,40,168Zm128,24a8.00008,8.00008,0,0,0-8,8v8h-8a8,8,0,0,0,0,16h8a16.01833,16.01833,0,0,0,16-16v-8A8.00008,8.00008,0,0,0,168,192Zm0-80a8.00008,8.00008,0,0,0,8-8V96a16.01833,16.01833,0,0,0-16-16h-8a8,8,0,0,0,0,16h8v8A8.00008,8.00008,0,0,0,168,112ZM56,80H48A16.01833,16.01833,0,0,0,32,96v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16ZM207.999,31.99414h-112a16.01833,16.01833,0,0,0-16,16V88a8.00009,8.00009,0,0,0,8,8H112a8,8,0,0,0,0-16H95.999V47.99414h112v112H176V144a8,8,0,0,0-16,0v24a8.00008,8.00008,0,0,0,8,8c.03918,0,.0769-.00537.116-.00586H207.999a16.01833,16.01833,0,0,0,16-16v-112A16.01833,16.01833,0,0,0,207.999,31.99414Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56,216H48a8,8,0,0,1-8-8v-8.00037",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "88",
          x2: "88",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "167.99963",
          x2: "168",
          y2: "143.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "159.99963",
          x2: "40",
          y2: "143.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,216h8a8,8,0,0,0,8-8v-8.00037",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,88h8a8,8,0,0,1,8,8v7.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M56,88H48a8,8,0,0,0-8,8v7.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,167.99414h39.999a8,8,0,0,0,8-8v-112a8,8,0,0,0-8-8h-112a8,8,0,0,0-8,8V88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSelectionInverse = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,216a8.00008,8.00008,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8.00008,8.00008,0,0,1,152,216ZM40,152a8.00008,8.00008,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8.00008,8.00008,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM224,48a16.01833,16.01833,0,0,0-16-16H48a15.9167,15.9167,0,0,0-10.66406,4.106,7.68793,7.68793,0,0,0-1.23023,1.23022A15.917,15.917,0,0,0,32,48V72a8,8,0,0,0,16,0V59.31348L196.68555,208H184a8,8,0,0,0,0,16h24a15.9162,15.9162,0,0,0,10.66284-4.105,7.68852,7.68852,0,0,0,1.23145-1.2312A15.917,15.917,0,0,0,224,208Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "111.99963",
          x2: "40",
          y2: "143.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V183.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V71.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "42.3432",
          y1: "42.3432",
          x2: "213.65681",
          y2: "213.65681",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSelectionPlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M148,48a7.99977,7.99977,0,0,1-8,8H116a8,8,0,0,1,0-16h24A7.99977,7.99977,0,0,1,148,48Zm-8,152H116a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM180,56h20V76a8,8,0,0,0,16,0V56a16.01833,16.01833,0,0,0-16-16H180a8,8,0,0,0,0,16Zm28,51.99951a7.99977,7.99977,0,0,0-8,8v24a8,8,0,0,0,16,0v-24A7.99977,7.99977,0,0,0,208,107.99951Zm-160,40a7.99977,7.99977,0,0,0,8-8v-24a8,8,0,1,0-16,0v24A7.99977,7.99977,0,0,0,48,147.99951ZM76,200H56V180a8,8,0,0,0-16,0v20a16.01833,16.01833,0,0,0,16,16H76a8,8,0,0,0,0-16ZM76,40H56A16.01833,16.01833,0,0,0,40,56V76a8,8,0,0,0,16,0V56H76a8,8,0,0,0,0-16ZM236,200H216V180a8,8,0,0,0-16,0v20H180a8,8,0,0,0,0,16h20v20a8,8,0,0,0,16,0V216h20a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "140",
          y1: "48",
          x2: "116",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "116",
          y1: "208",
          x2: "140",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M180,48h20a8.00011,8.00011,0,0,1,8,8.00012V76",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "139.99963",
          x2: "208",
          y2: "115.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "115.99963",
          x2: "48",
          y2: "139.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M76.00006,208.00006H56a8,8,0,0,1-8-7.99992v-20.0002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M76,48H56a8.00011,8.00011,0,0,0-8,8.00012V76",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "180",
          x2: "208",
          y2: "236",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "236",
          y1: "208",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSelectionSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M104,40a7.99977,7.99977,0,0,1,8-8h32a8,8,0,0,1,0,16H112A7.99977,7.99977,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V71.99951a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,71.99951a7.99977,7.99977,0,0,0-8,8v32a8,8,0,0,0,16,0v-32A7.99977,7.99977,0,0,0,216,103.99951Zm-176,48a7.99977,7.99977,0,0,0,8-8v-32a8,8,0,1,0-16,0v32A7.99977,7.99977,0,0,0,40,151.99951ZM72,208H48V184a8,8,0,0,0-16,0v24a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM53.91943,34.61865a7.99991,7.99991,0,1,0-11.83886,10.7627l160,176.00049a8.00024,8.00024,0,1,0,11.83886-10.76368Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V71.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "216",
          y1: "143.99963",
          x2: "216",
          y2: "111.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "111.99963",
          x2: "40",
          y2: "143.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V183.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShare = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65723,109.65723l-48,48A8.00066,8.00066,0,0,1,168,152V112a87.94718,87.94718,0,0,0-85.22852,65.99414,7.99961,7.99961,0,0,1-15.49414-3.98828A103.9414,103.9414,0,0,1,168,96V56a8.00066,8.00066,0,0,1,13.65723-5.65723l48,48A8.00122,8.00122,0,0,1,229.65723,109.65723ZM192,208H40V88a8,8,0,0,0-16,0V208a16.01833,16.01833,0,0,0,16,16H192a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M192,216H40a8,8,0,0,1-8-8V88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M75.0245,175.99967A96.04041,96.04041,0,0,1,168,104h56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShareNetwork = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,160a39.87518,39.87518,0,0,0-28.61768,12.09277L101.28467,142.4585a39.85174,39.85174,0,0,0,0-28.917l46.09765-29.63427a39.94957,39.94957,0,1,0-8.667-13.44947L92.61719,100.09229a40,40,0,1,0,0,55.81542l46.09814,29.63453A39.99342,39.99342,0,1,0,176,160Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "64",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "176",
          cy: "200",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "176",
          cy: "56",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "149.08436",
          y1: "73.30291",
          x2: "90.91323",
          y2: "110.69864",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "90.9132",
          y1: "145.30134",
          x2: "149.08428",
          y2: "182.69704",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShield = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.00146,40h-160a16.02085,16.02085,0,0,0-16,16v58.66406c0,89.46094,75.82032,119.125,91.03125,124.16406a15.45824,15.45824,0,0,0,9.9375,0c15.20313-5.03906,91.03125-34.69531,91.03125-124.16406V56A16.02084,16.02084,0,0,0,208.00146,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShieldCheck = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.00146,40h-160a16.02085,16.02085,0,0,0-16,16v58.66406c0,89.46094,75.82032,119.125,91.03125,124.16406a15.45824,15.45824,0,0,0,9.9375,0c15.20313-5.03906,91.03125-34.69531,91.03125-124.16406V56A16.02084,16.02084,0,0,0,208.00146,40ZM177.5249,109.78906l-58.67187,56a8.00489,8.00489,0,0,1-11.04688,0l-29.32812-28A8.00135,8.00135,0,1,1,89.5249,126.21094l23.80469,22.72656L166.478,98.21094a8.00135,8.00135,0,1,1,11.04687,11.57812Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "172 104 113.333 160 84 132",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShieldCheckered = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99463,39.99512h-160a16.018,16.018,0,0,0-16,16v58.667c0,89.458,75.82617,119.125,91.02588,124.16406a15.48947,15.48947,0,0,0,9.94775,0c15.2002-5.03906,91.02637-34.70605,91.02637-124.16406v-58.667A16.018,16.018,0,0,0,207.99463,39.99512Zm-80.00244,183.623C115.27393,219.38965,55.67285,196.00488,48.67383,128H128V55.99512h79.99463v58.667A130.11069,130.11069,0,0,1,207.31592,128H128v95.61548Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.62051",
          y1: "128",
          x2: "215.36996",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "231.64356",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShieldChevron = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99951,40.00012h-160a16.01818,16.01818,0,0,0-16,16v58.66651c0,89.45312,75.82617,119.12451,91.02637,124.16406a15.48361,15.48361,0,0,0,9.94726.00049c15.2002-5.04,91.02637-34.71143,91.02637-124.16455V56.00012A16.01817,16.01817,0,0,0,207.99951,40.00012Zm-160,16h160v58.66651c0,17.68237-3.39453,32.69653-8.79639,45.4104L132.5874,113.44617a8.00131,8.00131,0,0,0-9.17578,0L56.79541,160.077c-5.40137-12.71387-8.7959-27.728-8.7959-45.4104Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "202.402 172.082 128 120 53.597 172.082",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShieldPlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99463,39.99512h-160a16.018,16.018,0,0,0-16,16v58.667c0,89.458,75.82617,119.125,91.02588,124.16406a15.48947,15.48947,0,0,0,9.94775,0c15.2002-5.03906,91.02637-34.70605,91.02637-124.16406v-58.667A16.018,16.018,0,0,0,207.99463,39.99512ZM160,136H136v24a8,8,0,0,1-16,0V136H96a8,8,0,0,1,0-16h24V96a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M39.99463,114.66215V55.99548a8,8,0,0,1,8-8h160a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57059a7.54755,7.54755,0,0,1-4.9124,0C111.30065,226.51231,39.99463,198.67748,39.99463,114.66215Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShieldSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M227.87939,237.9209a8,8,0,0,1-11.30078-.541L187.4165,205.28613a147.318,147.318,0,0,1-54.44238,33.54492,15.49078,15.49078,0,0,1-9.94824,0c-15.2002-5.04-91.02637-34.71289-91.02637-124.16406V56a15.98851,15.98851,0,0,1,7.48242-13.52026L27.57861,29.37988a8,8,0,0,1,11.8418-10.75976l21.7998,23.99121.00879.00879L193.45654,188.13965l.01563.019,34.94824,38.46143A7.9992,7.9992,0,0,1,227.87939,237.9209Zm-28.2705-66.80274a8.00083,8.00083,0,0,0,13.208-2.07812c7.41993-16.376,11.18262-34.66992,11.18262-54.37305V56a16.01833,16.01833,0,0,0-16-16H98.54443a8.00019,8.00019,0,0,0-5.92089,13.37988Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M187.53527,193.51968c-21.56883,24.54405-48.85178,34.98988-57.07907,37.71757a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667V56a8,8,0,0,1,8-8h7.30776",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M98.54466,48H208a8,8,0,0,1,8,8v58.66667c0,20.0838-4.07475,36.95719-10.47061,51.07187",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShieldWarning = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99951,40h-160a16.01833,16.01833,0,0,0-16,16v58.667c0,89.45313,75.82617,119.124,91.02637,124.16406a15.48781,15.48781,0,0,0,9.94726,0c15.2002-5.04,91.02637-34.71093,91.02637-124.16406V56A16.01833,16.01833,0,0,0,207.99951,40Zm-88,56a8,8,0,1,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,127.99951,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40,114.66667V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.66667c0,84.01533-71.306,111.85016-85.5438,116.57058a7.54755,7.54755,0,0,1-4.9124,0C111.306,226.51683,40,198.682,40,114.66667Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "172",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShoppingBag = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40Zm-88,96A48.054,48.054,0,0,1,80,88a8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0A48.054,48.054,0,0,1,128,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M168,88a40,40,0,0,1-80,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShoppingBagOpen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40ZM128,160a48.054,48.054,0,0,1-48-48,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0A48.054,48.054,0,0,1,128,160ZM40,72V56H216l.001,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "32",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,112a40,40,0,0,1-80,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShoppingCart = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.87109,65.43115l-12.15722,66.86231A23.98711,23.98711,0,0,1,188.10156,152H72.13135l4.36377,24H184a24.01161,24.01161,0,1,1-22.624,16H102.624a24.00309,24.00309,0,1,1-40.85986-7.57666L34.05078,32H16a8,8,0,0,1,0-16H34.05078A15.9918,15.9918,0,0,1,49.793,29.13818L54.67676,56H216a8.00076,8.00076,0,0,1,7.87109,9.43115Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184,184H69.81818L41.92162,30.56892A8,8,0,0,0,34.05066,24H16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "80",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "184",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M62.54543,144H188.10132a16,16,0,0,0,15.74192-13.13783L216,64H48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShoppingCartSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M96,216a16,16,0,1,1-16-16A16.00016,16.00016,0,0,1,96,216Zm88-16a16,16,0,1,0,16,16A16.00016,16.00016,0,0,0,184,200ZM228.10059,67.18262A7.99866,7.99866,0,0,0,221.71387,64H48.32031L40.207,35.604A16.06984,16.06984,0,0,0,24.82227,24H8A8,8,0,0,0,8,40H24.82227l9.73046,34.05469c.02637.09863.05372.19677.084.29443l26.35547,92.24365A24.10087,24.10087,0,0,0,84.06836,184h95.86328a24.101,24.101,0,0,0,23.07617-17.40674l26.39844-92.39551A8.00023,8.00023,0,0,0,228.10059,67.18262Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "80",
          cy: "216",
          r: "16"
        }), React.createElement("circle", {
          cx: "184",
          cy: "216",
          r: "16"
        }), React.createElement("path", {
          d: "M42.28575,72H221.71429l-26.39873,92.39554A16,16,0,0,1,179.93118,176H84.06882a16,16,0,0,1-15.38438-11.60446L32.51492,37.80223A8,8,0,0,0,24.82273,32H8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShower = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M72,228a12,12,0,1,1-12-12A12,12,0,0,1,72,228Zm16-40a12,12,0,1,0,12,12A12,12,0,0,0,88,188Zm-60-4a12,12,0,1,0,12,12A12,12,0,0,0,28,184Zm40-16a12,12,0,1,0-12,12A12,12,0,0,0,68,168ZM248,32H219.31348A15.89354,15.89354,0,0,0,208,36.68652L180.15576,64.53027,54.01855,85.55322a16.00028,16.00028,0,0,0-8.6831,27.09619l98.01514,98.01465a15.99969,15.99969,0,0,0,27.09619-8.68261l21.023-126.13721v-.00049L219.31348,48H248a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "60",
          cy: "228",
          r: "12"
        }), React.createElement("circle", {
          cx: "88",
          cy: "200",
          r: "12"
        }), React.createElement("circle", {
          cx: "28",
          cy: "196",
          r: "12"
        }), React.createElement("circle", {
          cx: "56",
          cy: "168",
          r: "12"
        }), React.createElement("path", {
          d: "M248,40H219.31371a8,8,0,0,0-5.65686,2.34315L184,72,55.334,93.44433a8,8,0,0,0-4.34166,13.548l98.01532,98.01532a8,8,0,0,0,13.548-4.34166L184,72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShuffle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M237.65723,178.34277a8.00122,8.00122,0,0,1,0,11.31446l-24,24A8.00066,8.00066,0,0,1,200,208V191.98584a72.13911,72.13911,0,0,1-57.65332-30.13721L100.63379,103.4502A56.11029,56.11029,0,0,0,55.06445,80H32a8,8,0,0,1,0-16H55.06445a72.14126,72.14126,0,0,1,58.58887,30.15137l41.71289,58.39843A56.0996,56.0996,0,0,0,200,175.97168V160a8.00065,8.00065,0,0,1,13.65723-5.65723Zm-94.64356-71.36132a7.99621,7.99621,0,0,0,11.15918-1.86036l1.19336-1.67089A56.0996,56.0996,0,0,1,200,80.02832V96a8.00053,8.00053,0,0,0,13.65723,5.65723l24-24a8.00122,8.00122,0,0,0,0-11.31446l-24-24A8.00065,8.00065,0,0,0,200,48V64.01416a72.13911,72.13911,0,0,0-57.65332,30.13721l-1.19336,1.6709A7.9986,7.9986,0,0,0,143.01367,106.98145Zm-30.02734,42.0371a7.99642,7.99642,0,0,0-11.15918,1.86036l-1.19336,1.67089A56.11029,56.11029,0,0,1,55.06445,176H32a8,8,0,0,0,0,16H55.06445a72.14126,72.14126,0,0,0,58.58887-30.15137l1.19336-1.6709A7.9986,7.9986,0,0,0,112.98633,149.01855Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,72H55.06445a64,64,0,0,1,52.079,26.80076l41.7132,58.39848A64,64,0,0,0,200.93555,184H232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M147.66275,100.47214l1.19385-1.67138A64,64,0,0,1,200.93555,72H232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,184H55.06445a64,64,0,0,0,52.079-26.80076l1.19384-1.67138",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShuffleAngular = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M237.65723,178.34277a8.00122,8.00122,0,0,1,0,11.31446l-24,24A8.00066,8.00066,0,0,1,200,208V192H172.11719a16.03,16.03,0,0,1-13.01953-6.7002L83.88281,79.999,32,80a8,8,0,0,1,0-16H83.88281a16.03,16.03,0,0,1,13.01953,6.7002L172.11719,176.001,200,176.00049V160a8.00065,8.00065,0,0,1,13.65723-5.65723Zm-94.64551-71.36035a7.99822,7.99822,0,0,0,11.16015-1.85937L172.11719,80H200V96a8.00053,8.00053,0,0,0,13.65723,5.65723l24-24a8.00122,8.00122,0,0,0,0-11.31446l-24-24A8.00065,8.00065,0,0,0,200,48V64H172.11719a16.03166,16.03166,0,0,0-13.01953,6.69922L141.15234,95.82227A8.00057,8.00057,0,0,0,143.01172,106.98242Zm-30.02344,42.03516a7.99913,7.99913,0,0,0-11.16016,1.85937L83.88281,176H32a8,8,0,0,0,0,16H83.88281a16.03166,16.03166,0,0,0,13.01953-6.69922l17.94532-25.12305A8.00057,8.00057,0,0,0,112.98828,149.01758Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,72H83.88306a8,8,0,0,1,6.50986,3.35009l75.21416,105.29982A8,8,0,0,0,172.11694,184H232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M147.66242,100.47261l17.94466-25.12252A8,8,0,0,1,172.11694,72H232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32,184H83.88306a8,8,0,0,0,6.50986-3.35009l17.94466-25.12252",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconShuffleSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,48V88a8.00018,8.00018,0,0,1-13.65723,5.65674L188,79.314l-31.71582,31.71583a8.00035,8.00035,0,0,1-11.31445-11.314L176.68579,68l-14.343-14.34326A8.00038,8.00038,0,0,1,168,40h40A8.00008,8.00008,0,0,1,216,48Zm-4.93848,112.60889a8.00113,8.00113,0,0,0-8.71875,1.73437L188,176.686,53.65723,42.34326A8.00018,8.00018,0,1,0,42.34277,53.65674L176.686,188l-14.34327,14.34326A8.00038,8.00038,0,0,0,168,216h40a8.00008,8.00008,0,0,0,8-8V168A8.00015,8.00015,0,0,0,211.06152,160.60889ZM99.71582,144.97021l-57.373,57.373a8.00018,8.00018,0,0,0,11.31446,11.31348l57.373-57.37256a8.00035,8.00035,0,0,0-11.31445-11.314Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "48",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "150.62718",
          y1: "105.37282",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "208",
          x2: "105.37282",
          y2: "150.62718",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSignIn = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M141.65723,133.65625l-41.98828,42A8.00033,8.00033,0,0,1,86.01074,170V136H24a8,8,0,0,1,0-16H86.01074V86A8.00033,8.00033,0,0,1,99.669,80.34375l41.98828,42A7.99974,7.99974,0,0,1,141.65723,133.65625ZM192,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h56a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,192,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "94.011 170 136 128 94.011 86",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24",
          y1: "128",
          x2: "135.97057",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSignOut = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.65723,133.65625l-41.98828,42A8.00033,8.00033,0,0,1,166.01074,170V136H104a8,8,0,0,1,0-16h62.01074V86A8.00033,8.00033,0,0,1,179.669,80.34375l41.98828,42A7.99974,7.99974,0,0,1,221.65723,133.65625ZM104,208H48V48h56a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16h56a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "174.011 86 216 128 174.011 170",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "128",
          x2: "215.97057",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSimCard = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M213.65723,82.34277l-56-56A8.00235,8.00235,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88A8.00235,8.00235,0,0,0,213.65723,82.34277ZM200,216H55.99219V40h92.69433L200,91.314l.00977,124.68555Z"
        }), React.createElement("path", {
          d: "M176,112H80a8.00039,8.00039,0,0,0-8,8v72a8.00039,8.00039,0,0,0,8,8h96a8.00039,8.00039,0,0,0,8-8V120A8.00039,8.00039,0,0,0,176,112Zm-56,64a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,224.00005H55.99219a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8L152,32l56,56v128A8,8,0,0,1,200,224.00005Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "80",
          y: "120",
          width: "96",
          height: "72",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "112",
          y1: "152",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "152",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSketchLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", {
          id: "Raw"
        }, React.createElement("path", {
          d: "M247.98926,103.783c-.00488-.16467-.01074-.3291-.02539-.49317-.00977-.11059-.02442-.21948-.03907-.32873-.01806-.14075-.03808-.28088-.064-.42053-.022-.11878-.04736-.23584-.07471-.35254-.02978-.12793-.062-.25488-.09814-.38147q-.05054-.17909-.10938-.35437c-.041-.12146-.08545-.24146-.13232-.36133-.04492-.1156-.09131-.23022-.1416-.34314-.05225-.1178-.10987-.23328-.168-.349-.05567-.10986-.11133-.21924-.17139-.32593-.063-.11181-.13183-.22119-.20068-.33056-.0669-.10572-.1333-.21143-.20459-.31385-.07178-.1029-.14942-.20275-.22656-.303-.07911-.10242-.15772-.20472-.24121-.3031-.02491-.02955-.04639-.061-.07178-.09034l-56-64A8.001,8.001,0,0,0,184,32H72a8.001,8.001,0,0,0-6.02051,2.73193l-56,64c-.02539.0293-.04687.06079-.07178.09034-.08349.09838-.1621.20068-.24121.3031-.07714.10022-.15478.20007-.22656.303-.07129.10242-.13769.20813-.20459.31385-.06885.10937-.13769.21875-.20068.33056-.06006.10669-.11572.21607-.17139.32593-.0581.11572-.11572.2312-.168.349-.05029.11292-.09668.22754-.1416.34314-.04687.11987-.09131.23987-.13232.36133q-.05861.17541-.10938.35437c-.03613.12659-.06836.25354-.09814.38147-.02735.1167-.05274.23376-.07471.35254-.02588.13965-.0459.27978-.064.42053-.01465.10925-.0293.21814-.03907.32873-.01465.16407-.02051.3285-.02539.49317-.002.07275-.01074.1438-.01074.217,0,.02014.00293.03955.00293.05957.00146.197.01416.39355.02978.58984.00538.06238.00538.126.01172.18775q.03882.3717.1128.73938c.022.11.05322.21643.07959.32483.03369.13684.06445.27392.10547.40918.03515.11779.07861.23169.11914.347.04345.12293.085.24622.13476.36731.0459.11267.09815.22168.14942.33155.05517.12011.11035.23986.17236.35754.05566.1062.1167.20886.17676.31213.06689.1145.13379.22876.207.34058.06689.10266.13867.20166.21.3009.07617.10535.15234.21033.23389.31275.07959.09961.16308.19519.24707.29089.0542.06177.10253.12683.15869.18726l112,120c.11377.12158.2373.2312.35742.345.05615.0531.1084.10937.1665.16089a7.99282,7.99282,0,0,0,.81006.634c.06348.0437.13037.08154.19531.12329a7.94976,7.94976,0,0,0,.7295.416c.081.041.16113.08325.24414.12146a8.02746,8.02746,0,0,0,.96045.37487c.04736.0149.09716.02417.145.03809a7.97556,7.97556,0,0,0,.89062.20349c.09424.01624.18848.03137.28369.04419a7.12355,7.12355,0,0,0,2.13184,0c.09521-.01282.18945-.028.28369-.04419a7.97556,7.97556,0,0,0,.89062-.20349c.04786-.01392.09766-.02319.145-.03809a8.02746,8.02746,0,0,0,.96045-.37487c.083-.03821.16309-.08045.24414-.12146a7.94976,7.94976,0,0,0,.7295-.416c.06494-.04175.13183-.07959.19531-.12329a7.99282,7.99282,0,0,0,.81006-.634c.0581-.05152.11035-.10779.1665-.16089.12012-.11377.24365-.22339.35742-.345l112-120c.05616-.06031.10449-.12525.15821-.187.08447-.0957.168-.1914.24755-.29113.08155-.10242.15772-.2074.23389-.31275.07129-.09924.14307-.19824.21-.3009.07324-.11182.14014-.22608.207-.34058.06006-.10327.1211-.20593.17676-.31213.062-.11768.11719-.23743.17236-.35754.05127-.10987.10352-.21888.14942-.33155.0498-.12109.09131-.24438.13476-.36731.04053-.11535.084-.22925.11914-.347.041-.13526.07178-.27234.10547-.40918.02637-.1084.05762-.21485.07959-.32483q.074-.3673.1128-.73938c.00634-.06177.00634-.12537.01172-.18775.01562-.19629.02832-.39282.02978-.58984,0-.02.00293-.03943.00293-.05957C248,103.92676,247.99121,103.85571,247.98926,103.783ZM75.62988,48h36.15137L74.96289,96H33.63037ZM34.40967,112h39.1289l30.53418,74.63892Zm117.51758,74.63892L182.46143,112h39.1289ZM181.03711,96,144.21875,48h36.15137l41.99951,48Z"
        })), React.createElement("g", {
          id: "Flat"
        }, React.createElement("path", {
          d: "M247.98926,103.783c-.00488-.16467-.01074-.3291-.02539-.49317-.00977-.11059-.02442-.21948-.03907-.32873-.01806-.14075-.03808-.28088-.064-.42053-.022-.11878-.04736-.23584-.07471-.35254-.02978-.12793-.062-.25488-.09814-.38147q-.05054-.17909-.10938-.35437c-.041-.12146-.08545-.24146-.13232-.36133-.04492-.1156-.09131-.23022-.1416-.34314-.05225-.1178-.10987-.23328-.168-.349-.05567-.10986-.11133-.21924-.17139-.32593-.063-.11181-.13183-.22119-.20068-.33056-.0669-.10572-.1333-.21143-.20459-.31385-.07178-.1029-.14942-.20275-.22656-.303-.07911-.10242-.15772-.20472-.24121-.3031-.02491-.02955-.04639-.061-.07178-.09034l-56-64A8.001,8.001,0,0,0,184,32H72a8.001,8.001,0,0,0-6.02051,2.73193l-56,64c-.02539.0293-.04687.06079-.07178.09034-.08349.09838-.1621.20068-.24121.3031-.07714.10022-.15478.20007-.22656.303-.07129.10242-.13769.20813-.20459.31385-.06885.10937-.13769.21875-.20068.33056-.06006.10669-.11572.21607-.17139.32593-.0581.11572-.11572.2312-.168.349-.05029.11292-.09668.22754-.1416.34314-.04687.11987-.09131.23987-.13232.36133q-.05861.17541-.10938.35437c-.03613.12659-.06836.25354-.09814.38147-.02735.1167-.05274.23376-.07471.35254-.02588.13965-.0459.27978-.064.42053-.01465.10925-.0293.21814-.03907.32873-.01465.16407-.02051.3285-.02539.49317-.002.07275-.01074.1438-.01074.217,0,.02014.00293.03955.00293.05957.00146.197.01416.39355.02978.58984.00538.06238.00538.126.01172.18775q.03882.3717.1128.73938c.022.11.05322.21643.07959.32483.03369.13684.06445.27392.10547.40918.03515.11779.07861.23169.11914.347.04345.12293.085.24622.13476.36731.0459.11267.09815.22168.14942.33155.05517.12011.11035.23986.17236.35754.05566.1062.1167.20886.17676.31213.06689.1145.13379.22876.207.34058.06689.10266.13867.20166.21.3009.07617.10535.15234.21033.23389.31275.07959.09961.16308.19519.24707.29089.0542.06177.10253.12683.15869.18726l112,120c.11377.12158.2373.2312.35742.345.05615.0531.1084.10937.1665.16089a7.99282,7.99282,0,0,0,.81006.634c.06348.0437.13037.08154.19531.12329a7.94976,7.94976,0,0,0,.7295.416c.081.041.16113.08325.24414.12146a8.02746,8.02746,0,0,0,.96045.37487c.04736.0149.09716.02417.145.03809a7.97556,7.97556,0,0,0,.89062.20349c.09424.01624.18848.03137.28369.04419a7.12355,7.12355,0,0,0,2.13184,0c.09521-.01282.18945-.028.28369-.04419a7.97556,7.97556,0,0,0,.89062-.20349c.04786-.01392.09766-.02319.145-.03809a8.02746,8.02746,0,0,0,.96045-.37487c.083-.03821.16309-.08045.24414-.12146a7.94976,7.94976,0,0,0,.7295-.416c.06494-.04175.13183-.07959.19531-.12329a7.99282,7.99282,0,0,0,.81006-.634c.0581-.05152.11035-.10779.1665-.16089.12012-.11377.24365-.22339.35742-.345l112-120c.05616-.06031.10449-.12525.15821-.187.08447-.0957.168-.1914.24755-.29113.08155-.10242.15772-.2074.23389-.31275.07129-.09924.14307-.19824.21-.3009.07324-.11182.14014-.22608.207-.34058.06006-.10327.1211-.20593.17676-.31213.062-.11768.11719-.23743.17236-.35754.05127-.10987.10352-.21888.14942-.33155.0498-.12109.09131-.24438.13476-.36731.04053-.11535.084-.22925.11914-.347.041-.13526.07178-.27234.10547-.40918.02637-.1084.05762-.21485.07959-.32483q.074-.3673.1128-.73938c.00634-.06177.00634-.12537.01172-.18775.01562-.19629.02832-.39282.02978-.58984,0-.02.00293-.03943.00293-.05957C248,103.92676,247.99121,103.85571,247.98926,103.783ZM75.62988,48h36.15137L74.96289,96H33.63037ZM34.40967,112h39.1289l30.53418,74.63892Zm117.51758,74.63892L182.46143,112h39.1289ZM181.03711,96,144.21875,48h36.15137l41.99951,48Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "72 40 184 40 240 104 128 224 16 104 72 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "177.091 104 128 224 78.909 104 128 40 177.091 104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSkipBack = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56,32a8.00008,8.00008,0,0,1,8,8v73.73535l119.65723-73.124A16.0002,16.0002,0,0,1,208,54.26465v147.4707a16.004,16.004,0,0,1-24.34375,13.65283L64,142.26416V216a8,8,0,0,1-16,0V40A8.00008,8.00008,0,0,1,56,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M67.17024,121.17374,187.8284,47.4382A8,8,0,0,1,200,54.26445v147.4711a8,8,0,0,1-12.1716,6.82625L67.17024,134.82625A8,8,0,0,1,67.17024,121.17374Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSkipBackCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,136a7.99975,7.99975,0,0,1-12.4375,6.65625L108,137.61426V160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0v22.38574l43.5625-29.042A7.99612,7.99612,0,0,1,164,96Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "108 128 156 96 156 160 108 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "100",
          y1: "96",
          x2: "100",
          y2: "160",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSkipForward = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,40V216a8,8,0,0,1-16,0V142.26416l-119.65625,73.124A16.00029,16.00029,0,0,1,48,201.73535V54.26465A16.0002,16.0002,0,0,1,72.34277,40.61133L192,113.73535V40a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188.82976,121.17374,68.1716,47.4382A8,8,0,0,0,56,54.26445v147.4711a8,8,0,0,0,12.1716,6.82625l120.65816-73.73555A8,8,0,0,0,188.82976,121.17374Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSkipForwardCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,136a8,8,0,0,1-16,0V137.61426l-43.5625,29.042A7.99612,7.99612,0,0,1,92,160V96a7.99612,7.99612,0,0,1,12.4375-6.65625L148,118.38574V96a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "148 128 100 96 100 160 148 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "156",
          y1: "96",
          x2: "156",
          y2: "160",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSlackLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.13184,128A31.97762,31.97762,0,0,0,184,76.30522V56a31.97939,31.97939,0,0,0-56-21.132A31.97768,31.97768,0,0,0,76.30518,72H56a31.97928,31.97928,0,0,0-21.13184,56A31.97763,31.97763,0,0,0,72,179.69487V200a31.97939,31.97939,0,0,0,56,21.132A31.97768,31.97768,0,0,0,179.69482,184H200a31.97928,31.97928,0,0,0,21.13184-56ZM88,56a16,16,0,0,1,32,0V72H104A16.01833,16.01833,0,0,1,88,56ZM40,104A16.01833,16.01833,0,0,1,56,88h48a16.01833,16.01833,0,0,1,16,16v16H56A16.01833,16.01833,0,0,1,40,104Zm128,96a16,16,0,0,1-32,0V184h16A16.01833,16.01833,0,0,1,168,200Zm32-32H152a16.01833,16.01833,0,0,1-16-16V136h64a16,16,0,0,1,0,32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,56.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80a24,24,0,0,1,24-24Z",
          transform: "translate(184.00005 24.00003) rotate(90)",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,80H104a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,32.00007h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24Z",
          transform: "translate(304 160.00011) rotate(180)",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,128V104a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,104.00005h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
          transform: "translate(23.99995 328.00003) rotate(-90)",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M128,176h24a24,24,0,0,1,24,24v0a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152a24,24,0,0,1,24-24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,128v24a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24v0a24,24,0,0,1,24-24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSliders = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M135.99707,65.376V39.99988a8,8,0,0,0-16,0V65.376a23.995,23.995,0,0,0,0,45.2478v105.3761a8,8,0,0,0,16,0V110.62378a23.995,23.995,0,0,0,0-45.2478Z"
        }), React.createElement("path", {
          d: "M223.99707,167.99988a24.03744,24.03744,0,0,0-16-22.6239l.001-105.3761a8,8,0,1,0-16,0l-.001,105.3761a23.995,23.995,0,0,0,0,45.2478l.001,25.3761a8,8,0,0,0,16,0l-.001-25.37622A24.03728,24.03728,0,0,0,223.99707,167.99988Z"
        }), React.createElement("path", {
          d: "M63.99707,113.376l-.00049-73.3761a8,8,0,0,0-16,0l.00049,73.3761a23.995,23.995,0,0,0,0,45.2478l-.00049,57.3761a8,8,0,1,0,16,0l.00049-57.3761a23.995,23.995,0,0,0,0-45.2478Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128.00098",
          y1: "108",
          x2: "128.0011",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128.0011",
          y1: "40",
          x2: "128.00098",
          y2: "68",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128.00098",
          cy: "88",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200.00098",
          y1: "188",
          x2: "200.00181",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200.00181",
          y1: "40",
          x2: "200.00098",
          y2: "148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "200.00098",
          cy: "168",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56.00098",
          y1: "156",
          x2: "56.00039",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56.00039",
          y1: "40",
          x2: "56.00098",
          y2: "116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "56.00098",
          cy: "136",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSlidersHorizontal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M215.99951,163.99353H194.8291a27.99567,27.99567,0,0,0-53.65918,0H39.99951a8,8,0,0,0,0,16H141.16992a27.99567,27.99567,0,0,0,53.65918,0h21.17041a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M39.999,91.99255l37.1709.001a27.99567,27.99567,0,0,0,53.65918,0l85.17041-.001a8,8,0,0,0,0-16l-85.17041.001a27.99567,27.99567,0,0,0-53.65918,0L40,75.99255h-.00049a8,8,0,0,0-.00049,16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "147.99951",
          y1: "171.99353",
          x2: "39.99951",
          y2: "171.99365",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "215.99951",
          y1: "171.99365",
          x2: "187.99951",
          y2: "171.99353",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "167.99951",
          cy: "171.99353",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "83.99951",
          y1: "83.99353",
          x2: "39.99951",
          y2: "83.99294",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "215.99951",
          y1: "83.99294",
          x2: "123.99951",
          y2: "83.99353",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "103.99951",
          cy: "83.99353",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSmiley = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,92,96Zm84.50488,60.00293a56.01609,56.01609,0,0,1-97.00976.00049,8.00016,8.00016,0,1,1,13.85058-8.01074,40.01628,40.01628,0,0,0,69.30957-.00049,7.99974,7.99974,0,1,1,13.84961,8.01074Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "108",
          r: "12"
        }), React.createElement("path", {
          d: "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSmileyBlank = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24ZM92,120a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,92,120Zm72,0a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,164,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "108",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSmileyMeh = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,92,96Zm76,72H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm-4-48a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,164,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "160",
          x2: "168",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "108",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSmileyNervous = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm88.99756,82.24707a8.00032,8.00032,0,0,1-11.24463-1.24951L160,164.80615l-9.75293,12.19141a8.00025,8.00025,0,0,1-12.49414,0L128,164.80615l-9.75293,12.19141a8.00025,8.00025,0,0,1-12.49414,0L96,164.80615l-9.75293,12.19141a8.00009,8.00009,0,0,1-12.49414-9.99512l16-20a8.00025,8.00025,0,0,1,12.49414,0L112,159.19385l9.75293-12.19141a8.00025,8.00025,0,0,1,12.49414,0L144,159.19385l9.75293-12.19141a8.00025,8.00025,0,0,1,12.49414,0l16,20A8.00036,8.00036,0,0,1,180.99756,178.24707Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "108",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSmileySad = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12.0006,12.0006,0,0,1,92,96Zm81.58545,86.9248a7.99636,7.99636,0,0,1-10.93018-2.91943,40.01579,40.01579,0,0,0-69.30957-.00049,8.00016,8.00016,0,0,1-13.85058-8.01074,56.0156,56.0156,0,0,1,97.00976.00049A7.99915,7.99915,0,0,1,173.58545,182.9248Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "92",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "108",
          r: "12"
        }), React.createElement("path", {
          d: "M169.58,176a48.016,48.016,0,0,0-83.15966-.00055",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSmileySticker = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24a104,104,0,1,0,30.56543,203.43359,7.99683,7.99683,0,0,0,3.30859-1.99072l63.57032-63.57324a7.99548,7.99548,0,0,0,1.99072-3.30859A104.07559,104.07559,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.50488,60.00269a56.01585,56.01585,0,0,1-97.00976.00048,8.00016,8.00016,0,0,1,13.85058-8.01074,40.016,40.016,0,0,0,69.30957-.00049,7.99975,7.99975,0,1,1,13.84961,8.01075Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M156.21732,219.78606a95.898,95.898,0,1,1,63.57-63.573Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "108",
          r: "12"
        }), React.createElement("circle", {
          cx: "164",
          cy: "108",
          r: "12"
        }), React.createElement("path", {
          d: "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSmileyWink = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.50488,60.00293a56.01609,56.01609,0,0,1-97.00976.00049,8.00016,8.00016,0,0,1,13.85058-8.01074,40.01628,40.01628,0,0,0,69.30957-.00049,7.99974,7.99974,0,1,1,13.84961,8.01074ZM180,116H148a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "92",
          cy: "108",
          r: "12"
        }), React.createElement("line", {
          x1: "152",
          y1: "108",
          x2: "176",
          y2: "108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSmileyXEyes = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm-18.34375,98.34375a7.99915,7.99915,0,1,1-11.3125,11.3125L88,123.3125,77.65625,133.65625a7.99915,7.99915,0,0,1-11.3125-11.3125L76.6875,112,66.34375,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125L88,100.6875,98.34375,90.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L99.3125,112ZM128,192a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,128,192Zm61.65625-69.65625a7.99915,7.99915,0,1,1-11.3125,11.3125L168,123.3125l-10.34375,10.34375a7.99915,7.99915,0,0,1-11.3125-11.3125L156.6875,112l-10.34375-10.34375a7.99915,7.99915,0,0,1,11.3125-11.3125L168,100.6875l10.34375-10.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L179.3125,112Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "96",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "128",
          x2: "152",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "96",
          x2: "72",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "128",
          x2: "72",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "180",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSnapchatLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M242.95264,194.51565c-7.17285,6.73242-17.44434,7.418-26.50684,8.02343-5.77881.38575-11.75391.78418-15.24658,2.707-3.37012,1.85546-6.84522,6.61914-10.20557,11.22558-5.40674,7.41113-11.53418,15.81152-21.2373,18.29395-9.356,2.39648-18.584-1.90625-26.72608-5.70118C137.688,226.57424,132.16357,224,128,224c-4.16309,0-9.6875,2.57422-15.02979,5.06445-6.51074,3.03321-13.71728,6.39161-21.126,6.39161a22.48462,22.48462,0,0,1-5.59961-.69043c-9.70361-2.48243-15.83154-10.88282-21.23877-18.29493-3.36035-4.60546-6.835-9.36914-10.20459-11.2246-3.49268-1.92286-9.46826-2.32129-15.24658-2.707-9.0625-.60546-19.334-1.291-26.50684-8.02343a7.99944,7.99944,0,0,1,2.085-13.07911c.27149-.13085,12.46192-6.085,24.44629-21.32324a107.03319,107.03319,0,0,0,17.35156-32.72558l-19.90136-7.96a7.99977,7.99977,0,0,1,5.9414-14.85547L61.023,111.793A163.22264,163.22264,0,0,0,64,80a64,64,0,0,1,128,0,163.22264,163.22264,0,0,0,2.977,31.793l18.05176-7.2207a8,8,0,0,1,5.94238,14.85547l-19.90137,7.96093a107.023,107.023,0,0,0,17.35157,32.72461c12.05957,15.334,24.32763,21.2666,24.45019,21.3252a8.021,8.021,0,0,1,2.08106,13.07715Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M18.52262,188.68274S72,163.9473,72,80a56,56,0,0,1,112,0c0,83.94728,53.47772,108.6824,53.47772,108.6824-9.25514,8.68693-28.93167,3.38673-40.13691,9.55547-11.03868,6.077-17.07266,25.58078-29.56764,28.77765C155.6908,230.10684,141.04586,216,128,216s-27.6905,14.10686-39.77275,11.01563C75.73218,223.81879,69.69808,204.315,58.65931,198.238,47.45415,192.06928,27.77771,197.36958,18.52262,188.68274Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "189.3256",
          y1: "122.66978",
          x2: "216",
          y2: "112.00002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "66.67601",
          y1: "122.67043",
          x2: "40",
          y2: "112.00002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSnowflake = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M223.938,149.14551a7.99991,7.99991,0,0,1-5.65723,9.79785l-25.05713,6.71387,6.71436,25.05664a8.00007,8.00007,0,1,1-15.45508,4.14062l-7.927-29.58374L136,141.856V188.686l21.65674,21.65673a8.00018,8.00018,0,0,1-11.31348,11.31446L128,203.31348l-18.34326,18.34375a8.00018,8.00018,0,0,1-11.31348-11.31446L120,188.686V141.856L79.44409,165.27075l-7.927,29.58374A8.00007,8.00007,0,1,1,56.062,190.71387l6.71436-25.05664-25.05713-6.71387a8.00007,8.00007,0,1,1,4.14062-15.45508L71.44458,151.415,112.00073,128,71.44458,104.585l-29.58472,7.92676a8.00007,8.00007,0,1,1-4.14062-15.45508l25.05713-6.71387L56.062,65.28613a8.00007,8.00007,0,1,1,15.45508-4.14062l7.927,29.58374L120,114.144V67.314L98.34326,45.65723a8.00018,8.00018,0,0,1,11.31348-11.31446L128,52.68652l18.34326-18.34375a8.00018,8.00018,0,1,1,11.31348,11.31446L136,67.314V114.144l40.55591-23.41479,7.927-29.58374A8.00007,8.00007,0,1,1,199.938,65.28613l-6.71436,25.05664,25.05713,6.71387a8.00007,8.00007,0,1,1-4.14062,15.45508L184.55542,104.585,143.99927,128l40.55615,23.415,29.58472-7.92676A8.00062,8.00062,0,0,1,223.938,149.14551Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "104 40 128 64 152 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "104 216 128 192 152 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72.57437",
          y1: "96",
          x2: "183.42563",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "39.79 104.785 72.574 96 63.79 63.215",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "192.21 192.785 183.426 160 216.21 151.215",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "72.57437",
          y1: "160",
          x2: "183.42563",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "63.79 192.785 72.574 160 39.79 151.215",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "216.21 104.785 183.426 96 192.21 63.215",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSoccerBall = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.76978,134.8335a8.01081,8.01081,0,0,0,.07861-1.23633Q231.99652,130.81689,232,128a103.4965,103.4965,0,0,0-22.96765-65.10937,7.99721,7.99721,0,0,0-1.39539-1.69776,104.47716,104.47716,0,0,0-41.09863-29.78662,7.94558,7.94558,0,0,0-1.14416-.44824,103.96223,103.96223,0,0,0-74.78968.00049,7.97953,7.97953,0,0,0-1.14245.44775A104.47726,104.47726,0,0,0,48.36353,61.19238a7.99972,7.99972,0,0,0-1.39612,1.69825A103.49872,103.49872,0,0,0,24,128q0,2.81982.1521,5.60352A7.99281,7.99281,0,0,0,24.23,134.8291a103.303,103.303,0,0,0,15.69409,48.41211,7.99155,7.99155,0,0,0,1.05615,1.64307,104.37857,104.37857,0,0,0,60.27588,43.62353c.10743.03565.21851.05762.32752.08887a104.21832,104.21832,0,0,0,52.82971.00049c.11011-.03125.22241-.05371.33093-.08936a104.38026,104.38026,0,0,0,60.27552-43.62353,7.99155,7.99155,0,0,0,1.05615-1.64307A103.30408,103.30408,0,0,0,231.76978,134.8335ZM68.53931,117.0918l13.1676,4.27832,12.738,39.2041L86.30713,171.7749l-34.6377-.01806a87.36716,87.36716,0,0,1-11.15771-34.2793Zm118.92151,0,28.02746,20.38574a87.36716,87.36716,0,0,1-11.15771,34.2793l-34.6377.01806-8.13782-11.20068,12.738-39.2041Zm5.73291-48.13819L182.51624,101.875l-13.16749,4.27832L136,81.92383V68.07861l28.04492-20.353A88.44244,88.44244,0,0,1,193.19373,68.95361ZM91.95532,47.72559,120,68.07861V81.92383L86.65125,106.15332,73.48376,101.875,62.8064,68.95361A88.44288,88.44288,0,0,1,91.95532,47.72559Zm18.02539,166.4165-10.72937-32.9624,8.13782-11.20117h41.22168l8.13782,11.20117-10.72925,32.9624a88.31128,88.31128,0,0,1-36.0387,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "128 86 88.056 115.021 103.313 161.979 152.687 161.979 167.944 115.021 128 86",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "86",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "163.016 38.587 128 64 92.984 38.587",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "67.13238",
          y1: "108.22291",
          x2: "88.05563",
          y2: "115.02129",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "53.784 67.067 67.132 108.223 32.143 133.672",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "90.38174",
          y1: "179.77709",
          x2: "103.31302",
          y2: "161.97871",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "47.116 179.754 90.382 179.777 103.773 220.918",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "165.61826",
          y1: "179.77709",
          x2: "152.68698",
          y2: "161.97871",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152.227 220.919 165.618 179.777 208.884 179.754",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "188.86762",
          y1: "108.22291",
          x2: "167.94437",
          y2: "115.02129",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "223.857 133.673 188.868 108.223 202.216 67.068",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSortAscending = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.65527,173.65759l-39.999,39.99317a8,8,0,0,1-11.313,0l-40-40A8.00037,8.00037,0,0,1,144,159.99353h.001l31.999.00293V111.99353a8,8,0,0,1,16,0v48.00391l32,.00293a7.99976,7.99976,0,0,1,5.65527,13.65722ZM119.999,119.99353H48a8,8,0,0,0,0,16h71.999a8,8,0,1,0,0-16Zm-71.999-48H183.999a8,8,0,0,0,0-16H48a8,8,0,1,0,0,16Zm56,112H48a8,8,0,0,0,0,16h56a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "144 167.994 184 207.994 223.999 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "111.99347",
          x2: "184",
          y2: "207.99347",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "127.99353",
          x2: "119.99902",
          y2: "127.99353",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "63.99353",
          x2: "183.99902",
          y2: "63.99353",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "191.99353",
          x2: "104",
          y2: "191.99353",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSortDescending = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.39062,91.04724A7.99937,7.99937,0,0,1,224,95.9867l-32,.00268v48.00415a8,8,0,0,1-16,0V95.99085l-31.999.00268a8.00037,8.00037,0,0,1-5.65772-13.65723l40-40a8.00122,8.00122,0,0,1,11.313,0l39.999,39.99317A8.00019,8.00019,0,0,1,231.39062,91.04724ZM48,135.99353h71.999a8,8,0,1,0,0-16H48a8,8,0,0,0,0,16Zm0-64h55.999a8,8,0,0,0,0-16H48a8,8,0,1,0,0,16Zm135.999,112H48a8,8,0,0,0,0,16H183.999a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "144 87.994 184 47.994 223.999 87.987",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "184",
          y1: "143.99359",
          x2: "184",
          y2: "47.99359",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "127.99353",
          x2: "119.99902",
          y2: "127.99353",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "63.99353",
          x2: "103.99902",
          y2: "63.99353",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "191.99353",
          x2: "183.99902",
          y2: "191.99353",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpade = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,140a55.99915,55.99915,0,0,1-81.90137,49.64941l11.94092,35.82129A7.99929,7.99929,0,0,1,154.4502,236H101.5498a7.99966,7.99966,0,0,1-7.58935-10.53027l11.94092-35.82032A55.99915,55.99915,0,0,1,24,140C24,86.42676,121.68555,23.292,125.84375,20.63086a3.9978,3.9978,0,0,1,4.3125,0C134.31445,23.292,232,86.42676,232,140Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24S228,88,228,140a52.00142,52.00142,0,0,1-85.37486,39.87791L160,232H96l17.37486-52.12209A52.00142,52.00142,0,0,1,28,140C28,88,128,24,128,24Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSparkle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.8584,144a15.85626,15.85626,0,0,1-10.46778,15.01367l-52.16015,19.2168-19.2168,52.16015a16.00075,16.00075,0,0,1-30.02734,0l-19.2168-52.16015-52.16015-19.2168a16.00075,16.00075,0,0,1,0-30.02734l52.16015-19.2168,19.2168-52.16015a16.00075,16.00075,0,0,1,30.02734,0l19.2168,52.16015,52.16015,19.2168A15.85626,15.85626,0,0,1,208.8584,144ZM152,48h16V64a8,8,0,0,0,16,0V48h16a8,8,0,0,0,0-16H184V16a8,8,0,0,0-16,0V32H152a8,8,0,0,0,0,16Zm88,32h-8V72a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M138.72355,175.46465l-19.21681,52.1599a8,8,0,0,1-15.01348,0l-19.21681-52.1599a8,8,0,0,0-4.7411-4.7411l-52.1599-19.21681a8,8,0,0,1,0-15.01348l52.1599-19.21681a8,8,0,0,0,4.7411-4.7411l19.21681-52.1599a8,8,0,0,1,15.01348,0l19.21681,52.1599a8,8,0,0,0,4.7411,4.7411l52.1599,19.21681a8,8,0,0,1,0,15.01348l-52.1599,19.21681A8,8,0,0,0,138.72355,175.46465Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "16",
          x2: "176",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "72",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "240",
          y1: "88",
          x2: "208",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerHigh = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M224.56836,71.43935a8.00053,8.00053,0,0,0-11.31445,11.31446,63.99788,63.99788,0,0,1,0,90.50976A8.00053,8.00053,0,0,0,224.56836,184.578a80.00148,80.00148,0,0,0,0-113.13868Z"
        }), React.createElement("path", {
          d: "M155.51465,24.82217a7.99448,7.99448,0,0,0-8.42578.87207l-69.834,54.31445H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224.00869v-192A7.9997,7.9997,0,0,0,155.51465,24.82217ZM32,96.00869H71.9707v64H32Z"
        }), React.createElement("path", {
          d: "M184.96973,99.72549a7.99913,7.99913,0,0,0,.001,11.31347,23.99832,23.99832,0,0,1,0,33.93946,7.99983,7.99983,0,1,0,11.3125,11.31445,39.99719,39.99719,0,0,0,0-56.56836A7.99825,7.99825,0,0,0,184.96973,99.72549Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M218.88231,77.08831a72,72,0,0,1,0,101.82338",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M190.59793,105.37258a32,32,0,0,1,0,45.25484",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerLow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M155.51465,24.81927a7.99655,7.99655,0,0,0-8.42578.87207l-69.834,54.31445H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31446A7.99958,7.99958,0,0,0,160,224.00579v-192A7.9997,7.9997,0,0,0,155.51465,24.81927ZM32,96.00579H71.9707v64H32Z"
        }), React.createElement("path", {
          d: "M196.2832,99.72161a7.99984,7.99984,0,0,0-11.3125,11.31446,23.99831,23.99831,0,0,1,0,33.93945A7.99983,7.99983,0,1,0,196.2832,156.29a39.99719,39.99719,0,0,0,0-56.56836Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M190.59793,105.37258a32,32,0,0,1,0,45.25484",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerNone = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M155.51465,24.81637a7.99655,7.99655,0,0,0-8.42578.87207L77.25488,80.0029H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224.0029v-192A7.99972,7.99972,0,0,0,155.51465,24.81637ZM32,96.0029H71.9707v64H32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerSimpleHigh = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M155.50977,24.80957a7.993,7.993,0,0,0-8.42188.875L77.24414,79.99707h-45.25a16.01583,16.01583,0,0,0-16,16v64a16.01583,16.01583,0,0,0,16,16h45.25l69.84375,54.3125a7.99451,7.99451,0,0,0,12.90625-6.3125v-192A7.99374,7.99374,0,0,0,155.50977,24.80957Z"
        }), React.createElement("path", {
          d: "M191.99414,96a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8.00039,8.00039,0,0,0,191.99414,96Z"
        }), React.createElement("path", {
          d: "M223.99414,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,223.99414,80Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "191.9707",
          y1: "104",
          x2: "191.9707",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "223.9707",
          y1: "88",
          x2: "223.9707",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerSimpleLow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M155.50977,24.80957a7.993,7.993,0,0,0-8.42188.875L77.24414,79.99707h-45.25a16.01583,16.01583,0,0,0-16,16v64a16.01583,16.01583,0,0,0,16,16h45.25l69.84375,54.3125a7.99451,7.99451,0,0,0,12.90625-6.3125v-192A7.99374,7.99374,0,0,0,155.50977,24.80957Z"
        }), React.createElement("path", {
          d: "M191.99414,96a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8.00039,8.00039,0,0,0,191.99414,96Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "191.9707",
          y1: "104",
          x2: "191.9707",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerSimpleNone = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M155.50977,24.8096a7.993,7.993,0,0,0-8.42188.875L77.24414,79.9971h-45.25a16.01583,16.01583,0,0,0-16,16v64a16.01582,16.01582,0,0,0,16,16h45.25l69.84375,54.3125a7.99451,7.99451,0,0,0,12.90625-6.3125v-192A7.99375,7.99375,0,0,0,155.50977,24.8096Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerSimpleSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M191.97656,160a8.00039,8.00039,0,0,0,8-8V104a8,8,0,0,0-16,0v48A8.00039,8.00039,0,0,0,191.97656,160Z"
        }), React.createElement("path", {
          d: "M223.97656,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,1,0,16,0V88A8.00039,8.00039,0,0,0,223.97656,80Z"
        }), React.createElement("path", {
          d: "M53.91992,34.61813A8.0006,8.0006,0,1,0,42.08008,45.3818L73.55127,80H32A16.01833,16.01833,0,0,0,16,96v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224V175.09372l42.08008,46.28808a8.0006,8.0006,0,1,0,11.83984-10.76367Z"
        }), React.createElement("path", {
          d: "M146.08008,112.2109A8.0004,8.0004,0,0,0,160,106.82907V32a7.99958,7.99958,0,0,0-12.91113-6.31446L107.23926,56.67965a7.99966,7.99966,0,0,0-1.00879,11.69629Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "191.97656",
          y1: "104",
          x2: "191.97656",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "223.97656",
          y1: "88",
          x2: "223.97656",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "112.15 62.994 152 32 152 106.829",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.63636",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerSimpleX = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M155.50977,24.80957a7.993,7.993,0,0,0-8.42188.875L77.24414,79.99707h-45.25a16.01583,16.01583,0,0,0-16,16v64a16.01583,16.01583,0,0,0,16,16h45.25l69.84375,54.3125a7.99451,7.99451,0,0,0,12.90625-6.3125v-192A7.99374,7.99374,0,0,0,155.50977,24.80957Z"
        }), React.createElement("path", {
          d: "M227.30664,127.99707l18.34375-18.34375a7.99915,7.99915,0,0,0-11.3125-11.3125l-18.34375,18.34375L197.65039,98.34082a7.99915,7.99915,0,0,0-11.3125,11.3125l18.34375,18.34375-18.34375,18.34375a7.99915,7.99915,0,1,0,11.3125,11.3125l18.34375-18.34375,18.34375,18.34375a7.99915,7.99915,0,0,0,11.3125-11.3125Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "239.99997",
          y1: "104",
          x2: "191.99997",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "239.99997",
          y1: "152",
          x2: "191.99997",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M53.91992,34.61813A8.0006,8.0006,0,1,0,42.08008,45.3818L73.55371,80.0029H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445-.00537-.01123.00439.00342a7.99451,7.99451,0,0,0,12.90625-6.3125V175.08737l42.08594,46.29443a8.0006,8.0006,0,1,0,11.83984-10.76367ZM71.9707,160.0029H32v-64H71.9707Z"
        }), React.createElement("path", {
          d: "M146.08008,112.2109A8.0004,8.0004,0,0,0,160,106.82907V32.01169a7.99958,7.99958,0,0,0-12.91113-6.31446L107.24512,56.68649a7.99966,7.99966,0,0,0-1.00879,11.69629Z"
        }), React.createElement("path", {
          d: "M224.544,71.44235a7.99983,7.99983,0,1,0-11.3125,11.31445,63.99908,63.99908,0,0,1,0,90.50879A7.99983,7.99983,0,1,0,224.544,184.58a79.99795,79.99795,0,0,0,0-113.13769Z"
        }), React.createElement("path", {
          d: "M191.97656,128.01169a23.83779,23.83779,0,0,1-7.02929,16.96972,7.99984,7.99984,0,1,0,11.3125,11.31446,39.99957,39.99957,0,0,0,.001-56.56934A8.00052,8.00052,0,0,0,184.94629,111.041,23.84269,23.84269,0,0,1,191.97656,128.01169Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M218.88817,77.0999a72,72,0,0,1,0,101.82337",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "79.99414",
          y1: "88.01159",
          x2: "79.99414",
          y2: "168.01159",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M190.60379,105.38417a32,32,0,0,1,0,45.25483",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152,154.4v69.61162l-72-56H32a8,8,0,0,1-8-8v-64a8,8,0,0,1,8-8H80L86.82274,82.705",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "112.156 63.001 152 32.012 152 106.829",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpeakerX = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M155.51465,24.81348a7.99448,7.99448,0,0,0-8.42578.87207L77.25488,80H32A16.01833,16.01833,0,0,0,16,96v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224V32A7.9997,7.9997,0,0,0,155.51465,24.81348ZM32,96H71.9707v64H32Z"
        }), React.createElement("path", {
          d: "M227.31445,128l18.34278-18.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L216,116.68555,197.65723,98.34277a8.00053,8.00053,0,0,0-11.31446,11.31446L204.68555,128l-18.34278,18.34277a8.00053,8.00053,0,0,0,11.31446,11.31446L216,139.31445l18.34277,18.34278a8.00053,8.00053,0,0,0,11.31446-11.31446Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "239.99997",
          y1: "104",
          x2: "191.99997",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "239.99997",
          y1: "152",
          x2: "191.99997",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpinner = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.25488,58.74512a7.97769,7.97769,0,0,0,5.65723-2.34278l22.62695-22.62695a8.00052,8.00052,0,1,0-11.31445-11.31445l-22.627,22.627a8,8,0,0,0,5.65722,13.65723ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.08789,47.59766a8.00052,8.00052,0,0,0-11.31445,11.31445l22.627,22.62695a8.00052,8.00052,0,1,0,11.31445-11.31445ZM128,184a8.00039,8.00039,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8.00039,8.00039,0,0,0,128,184ZM77.08789,167.59766l-22.62695,22.627a8.00052,8.00052,0,0,0,11.31445,11.31445l22.62695-22.62695a8.00052,8.00052,0,0,0-11.31445-11.31445ZM72,128a8.00039,8.00039,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8.00039,8.00039,0,0,0,72,128ZM65.77539,54.46094A8.00052,8.00052,0,0,0,54.46094,65.77539l22.627,22.62695A8.00052,8.00052,0,0,0,88.40234,77.08789Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "195.88225",
          y1: "60.11775",
          x2: "173.25483",
          y2: "82.74517",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "195.88225",
          y1: "195.88225",
          x2: "173.25483",
          y2: "173.25483",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "60.11775",
          y1: "195.88225",
          x2: "82.74517",
          y2: "173.25483",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "60.11775",
          y1: "60.11775",
          x2: "82.74517",
          y2: "82.74517",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpinnerGap = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm88,88H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.08789,47.59766a8.00052,8.00052,0,0,0-11.31445,11.31445l22.627,22.62695a8.00052,8.00052,0,1,0,11.31445-11.31445ZM128,184a8.00039,8.00039,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8.00039,8.00039,0,0,0,128,184ZM77.08789,167.59766l-22.62695,22.627a8.00052,8.00052,0,0,0,11.31445,11.31445l22.62695-22.62695a8.00052,8.00052,0,0,0-11.31445-11.31445ZM72,128a8.00039,8.00039,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8.00039,8.00039,0,0,0,72,128ZM65.77539,54.46094A8.00052,8.00052,0,0,0,54.46094,65.77539l22.627,22.62695A8.00052,8.00052,0,0,0,88.40234,77.08789Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "195.88225",
          y1: "195.88225",
          x2: "173.25483",
          y2: "173.25483",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "60.11775",
          y1: "195.88225",
          x2: "82.74517",
          y2: "173.25483",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "60.11775",
          y1: "60.11775",
          x2: "82.74517",
          y2: "82.74517",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSpotifyLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.1179,104.1179,0,0,0,128,24Zm28.624,144.65722a8.00058,8.00058,0,0,1-10.73633,3.56641,39.98258,39.98258,0,0,0-35.85156.04,7.99966,7.99966,0,1,1-7.20117-14.28711,55.97479,55.97479,0,0,1,50.22217-.05566A7.99977,7.99977,0,0,1,156.624,168.65719Zm14.79737-28.30664a8.00153,8.00153,0,0,1-10.76221,3.49024,71.9412,71.9412,0,0,0-65.40234.042,7.99976,7.99976,0,1,1-7.29-14.24219,87.94,87.94,0,0,1,79.96484-.05176A7.9994,7.9994,0,0,1,171.42139,140.35055Zm14.82666-28.36426a8.00037,8.00037,0,0,1-10.77246,3.458,104.1903,104.1903,0,0,0-95.03614.04492,8,8,0,1,1-7.3291-14.22265,120.19311,120.19311,0,0,1,109.68066-.05274A7.99973,7.99973,0,0,1,186.24805,111.98629Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("g", null, React.createElement("path", {
          d: "M179.1333,108.32931a112.19069,112.19069,0,0,0-102.3584.04859",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M164.29541,136.71457a79.94058,79.94058,0,0,0-72.68359.04736",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M149.47217,165.07248a47.97816,47.97816,0,0,0-43.03662.04736",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        })));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSquare = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "32",
          width: "192",
          height: "192",
          rx: "16"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSquareHalf = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M204,36H52A16.01833,16.01833,0,0,0,36,52V204a16.01833,16.01833,0,0,0,16,16H204a16.01833,16.01833,0,0,0,16-16V52A16.01833,16.01833,0,0,0,204,36ZM52,52h76V204H52Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "139.99414",
          y1: "44",
          x2: "212",
          y2: "116.00586",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.99998",
          y1: "88.00584",
          x2: "212",
          y2: "172.00586",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "127.99998",
          y1: "144.00584",
          x2: "195.99414",
          y2: "212",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSquareLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32Zm0,176H48V48H208l.01025,159.99951ZM168,96v64a7.99977,7.99977,0,0,1-8,8H96a7.99977,7.99977,0,0,1-8-8V96a7.99977,7.99977,0,0,1,8-8h64A7.99977,7.99977,0,0,1,168,96Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40.00002",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "96",
          y: "96.00002",
          width: "64",
          height: "64",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSquaresFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "80",
          height: "80",
          rx: "8"
        }), React.createElement("rect", {
          x: "136",
          y: "40",
          width: "80",
          height: "80",
          rx: "8"
        }), React.createElement("rect", {
          x: "40",
          y: "136",
          width: "80",
          height: "80",
          rx: "8"
        }), React.createElement("rect", {
          x: "136",
          y: "136",
          width: "80",
          height: "80",
          rx: "8"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "48",
          y: "48",
          width: "64",
          height: "64",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "144",
          y: "48",
          width: "64",
          height: "64",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "48",
          y: "144",
          width: "64",
          height: "64",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "144",
          y: "144",
          width: "64",
          height: "64",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStack = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M219.96875,169.08984,128,222.73828,36.03125,169.08984a8.00008,8.00008,0,0,0-8.0625,13.82032l96,56a8.00059,8.00059,0,0,0,8.0625,0l96-56a8.00008,8.00008,0,0,0-8.0625-13.82032Z"
        }), React.createElement("path", {
          d: "M219.96875,121.08984,128,174.73828,36.03125,121.08984a8.00008,8.00008,0,0,0-8.0625,13.82032l96,56a8.00059,8.00059,0,0,0,8.0625,0l96-56a8.00008,8.00008,0,0,0-8.0625-13.82032Z"
        }), React.createElement("path", {
          d: "M27.96875,86.91016l96,56a8.00059,8.00059,0,0,0,8.0625,0l96-56a8.00016,8.00016,0,0,0,0-13.82032l-96-56a8.00059,8.00059,0,0,0-8.0625,0l-96,56a8.00016,8.00016,0,0,0,0,13.82032Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "32 176 128 232 224 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "32 128 128 184 224 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "32 80 128 136 224 80 128 24 32 80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStackSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M12.03125,110.94629l112,64a8.00091,8.00091,0,0,0,7.9375,0l112-64a8.00024,8.00024,0,0,0,0-13.89258l-112-64a8.00411,8.00411,0,0,0-7.9375,0l-112,64a8.00024,8.00024,0,0,0,0,13.89258Z"
        }), React.createElement("path", {
          d: "M236.03125,137.05371,128,198.78613,19.96875,137.05371a8.00012,8.00012,0,0,0-7.9375,13.89258l112,64a8.00091,8.00091,0,0,0,7.9375,0l112-64a8.00012,8.00012,0,0,0-7.9375-13.89258Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "16 104 128 168 240 104 128 40 16 104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "16 144 128 208 240 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStar = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M239.166,97.41117A16.37036,16.37036,0,0,0,224.63477,86.044l-59.39063-4.15625L143.21289,26.41117A16.33117,16.33117,0,0,0,127.99414,15.9971h-.01562A16.324,16.324,0,0,0,112.791,26.41117L90.43164,82.208,31.36914,86.044A16.37036,16.37036,0,0,0,16.83789,97.41117a16.68222,16.68222,0,0,0,5.15625,18.0625l45.4375,38.40625L53.916,207.044a18.37492,18.37492,0,0,0,7.01562,19.51562,17.83088,17.83088,0,0,0,20.0625.625l46.875-29.69531c.0625-.04687.125-.07812.26563,0l50.4375,31.95313a16.14026,16.14026,0,0,0,18.20312-.5625,16.64744,16.64744,0,0,0,6.35938-17.67969L188.77539,153.1221l45.23438-37.64843A16.68222,16.68222,0,0,0,239.166,97.41117Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M132.41106,190.73266l50.43543,31.95385c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-14.57192-57.32241a8.75742,8.75742,0,0,1,2.83756-8.87589l45.2273-37.64345c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-59.06388-3.83326a8.41836,8.41836,0,0,1-7.24792-5.3506l-22.02834-55.473a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475A8.21431,8.21431,0,0,1,132.41106,190.73266Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStarFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240.58984,128a15.84794,15.84794,0,0,1-10.53125,15.03711l-63.81543,23.206-23.206,63.81543a16.001,16.001,0,0,1-30.07422,0L89.75684,166.24316l-63.81543-23.206a16.001,16.001,0,0,1,0-30.07422L89.75684,89.75684l23.20605-63.81543a16.001,16.001,0,0,1,30.07422,0l23.206,63.81543,63.81543,23.20605A15.84794,15.84794,0,0,1,240.58984,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M158.72416,163.50856l-23.20581,63.816a8,8,0,0,1-15.0367,0l-23.20581-63.816a8,8,0,0,0-4.7844-4.7844l-63.816-23.20581a8,8,0,0,1,0-15.0367l63.816-23.20581a8,8,0,0,0,4.7844-4.7844l23.20581-63.816a8,8,0,0,1,15.0367,0l23.20581,63.816a8,8,0,0,0,4.7844,4.7844l63.816,23.20581a8,8,0,0,1,0,15.0367l-63.816,23.20581A8,8,0,0,0,158.72416,163.50856Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStarHalf = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M233.99609,115.47754l-8.71777,7.25586A7.99993,7.99993,0,0,1,215.042,110.43652l8.71778-7.25586a.645.645,0,0,0,.18652-.81054c-.11328-.34766-.23242-.35547-.34668-.36231l-11.54688-.749a8.00016,8.00016,0,0,1,1.03516-15.9668l11.54785.749A16.36187,16.36187,0,0,1,239.16016,97.418,16.65646,16.65646,0,0,1,233.99609,115.47754Zm-60.93652,42.34277,3.31445,13.03516a7.99972,7.99972,0,0,0,15.50586-3.94336l-3.31347-13.0332a.77056.77056,0,0,1,.20117-.75684l10.03222-8.34961a8.00006,8.00006,0,0,0-10.23437-12.29883l-10.03223,8.34961A16.81494,16.81494,0,0,0,173.05957,157.82031ZM186.17383,91.5625a8.00082,8.00082,0,0,0-7.46485-8.50195L165.57227,82.208a.453.453,0,0,1-.33008-.32031L143.21289,26.416a16.31771,16.31771,0,0,0-30.42578-.001L90.75781,81.88965a.45394.45394,0,0,1-.3291.31836L31.36328,86.041A16.36063,16.36063,0,0,0,16.83984,97.418a16.65646,16.65646,0,0,0,5.16407,18.05957l45.22851,37.64453a.77256.77256,0,0,1,.20215.75586L53.9209,207.03711a18.3696,18.3696,0,0,0,6.999,19.5166A17.79837,17.79837,0,0,0,81,227.18555l46.87012-29.69532a.23765.23765,0,0,1,.12939-.042h.00244a.24439.24439,0,0,1,.12793.042l11.5166,7.29688a7.99982,7.99982,0,1,0,8.5625-13.51563l-11.5166-7.29687c-.22656-.14356-.46-.273-.69238-.4043V51.60425L150.37109,87.792A16.49953,16.49953,0,0,0,164.53516,98.1748l13.13672.85254A8.00533,8.00533,0,0,0,186.17383,91.5625Zm14.18945,108.72461a7.99972,7.99972,0,0,0-15.50586,3.94336l2.77442,10.91113a.64731.64731,0,0,1-.05274.59473.82311.82311,0,0,1-.30566.2666.61873.61873,0,0,1-.14551-.07422l-9.82617-6.22461a7.99982,7.99982,0,0,0-8.5625,13.51563l9.82519,6.22461a16.16285,16.16285,0,0,0,18.23047-.57227,16.63644,16.63644,0,0,0,6.34278-17.67285Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "24.00002",
          x2: "128",
          y2: "189.44779",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M220.16021,116.58462l8.71741-7.25565c5.94268-4.9462,2.87542-14.80876-4.75965-15.30428l-11.54749-.74944",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184.12661,168.88422l-3.31385-13.03591a8.75742,8.75742,0,0,1,2.83756-8.87589l10.032-8.34985",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M178.19035,91.044l-13.13626-.85254a8.41836,8.41836,0,0,1-7.24792-5.3506L152.7071,72.00006,135.77783,29.36778a8.31887,8.31887,0,0,0-15.55566,0L98.19383,84.84083a8.41836,8.41836,0,0,1-7.24792,5.3506L31.882,94.02469c-7.63507.49552-10.70233,10.35808-4.75965,15.30428l45.2273,37.64345a8.75742,8.75742,0,0,1,2.83756,8.87589L61.6734,209.00846c-2.29566,9.03056,7.30952,16.32036,15.04583,11.41895l46.86971-29.69475a8.21431,8.21431,0,0,1,8.82212,0l11.51649,7.29638",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M173.021,216.46145l9.82554,6.22506c6.44693,4.08451,14.45124-1.99032,12.53819-9.51579l-2.774-10.91217",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSticker = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,32H88A56.0629,56.0629,0,0,0,32,88v80a56.0629,56.0629,0,0,0,56,56h48a8.0151,8.0151,0,0,0,2.53027-.41016c26.23243-8.74511,76.31446-58.82714,85.05957-85.05957A8.0151,8.0151,0,0,0,224,136V88A56.0629,56.0629,0,0,0,168,32ZM136,207.42236V176a40.04584,40.04584,0,0,1,40-40h31.42236C198.15991,157.55176,157.55176,198.16016,136,207.42236Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M136,216V184a48,48,0,0,1,48-48h32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStop = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "14.90918"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "52",
          y: "52",
          width: "152",
          height: "152",
          rx: "6.90909",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStopCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm32,128a8.00008,8.00008,0,0,1-8,8H104a8.00008,8.00008,0,0,1-8-8V104a8.00008,8.00008,0,0,1,8-8h48a8.00008,8.00008,0,0,1,8,8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStorefront = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.98975,95.79919c-.00293-.11914-.00953-.23779-.01807-.35705-.0127-.1836-.03149-.36475-.0564-.5448-.0144-.10315-.02881-.20581-.04712-.30872-.03784-.21142-.08545-.41894-.13964-.62426-.01416-.05372-.02076-.10853-.03614-.16211L217.35059,43.604A16.06985,16.06985,0,0,0,201.96582,32H54.03418A16.06971,16.06971,0,0,0,38.64941,43.60449L24.30762,93.80225c-.01538.05358-.022.10839-.03614.16211-.05419.20532-.1018.41284-.13964.62426-.01831.10291-.03272.20557-.04712.30872-.02491.18-.0437.3612-.0564.5448-.00854.11926-.01514.23791-.01807.35705C24.00854,95.86658,24,95.93213,24,96v16a39.96242,39.96242,0,0,0,16,31.978V208a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V143.978A39.96242,39.96242,0,0,0,232,112V96C232,95.93213,231.99146,95.86658,231.98975,95.79919ZM40,104H88v8a23.98436,23.98436,0,0,1-35.12427,21.256,7.98438,7.98438,0,0,0-1.813-1.05774A23.99623,23.99623,0,0,1,40,112Zm112,8a24,24,0,0,1-48,0v-8h48Zm52.93213,20.20166a7.97469,7.97469,0,0,0-1.80176,1.05115A23.98441,23.98441,0,0,1,168,112v-8h48v8A23.99664,23.99664,0,0,1,204.93213,132.20166Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M48,139.58816V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.58972",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M54.03441,40H201.96559a8,8,0,0,1,7.69219,5.80223L224,96H32L46.34222,45.80223A8,8,0,0,1,54.03441,40Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M96,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M160,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M224,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStripeLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01817,16.01817,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01817,16.01817,0,0,0,208,32ZM128,184c-24.71045,0-44.06738-14.05615-44.06738-32a8,8,0,0,1,16,0c0,7.56787,11.52685,16,28.06738,16,13.27539,0,28.06738-6.5708,28.06738-16,0-9.60376-12.1958-13.44092-30.80224-18.19849-8.70606-2.22631-17.709-4.52856-24.75733-8.25024C90.83887,120.44558,85.936,113.1946,85.936,104c0-18.24292,18.08349-32,42.064-32,17.16748,0,31.917,7.16382,38.49219,18.69556a8.00006,8.00006,0,0,1-13.89942,7.92529C148.91406,92.169,139.26074,88,128,88c-14.61523,0-26.064,7.02808-26.064,16,0,6.81152,10.80664,10.08447,27.293,14.30005,19.08545,4.88037,42.83838,10.95435,42.83838,33.7C172.06738,169.94387,152.71045,184,128,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M91.93248,152c0,13.25484,16.148,24,36.06752,24s36.06752-10.74516,36.06752-24c0-32-70.13129-20-70.13129-48,0-13.25483,14.14423-24,34.06377-24,14.93966,0,26.6307,6.04416,31.54249,14.65811",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40.00002",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconStudent = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M226.52979,56.41016l-96-32a8.00672,8.00672,0,0,0-5.05958,0L29.6239,56.35889l-.00976.00341-.14393.04786c-.02819.00927-.053.02465-.08105.03442a7.91407,7.91407,0,0,0-1.01074.42871c-.03748.019-.07642.03516-.11353.05469a7.97333,7.97333,0,0,0-.93139.58325c-.06543.04688-.129.09522-.19288.144a8.08459,8.08459,0,0,0-.81872.71119c-.0238.02416-.04443.05053-.06787.0747a8.0222,8.0222,0,0,0-.661.783c-.04163.05567-.08472.10986-.12476.16675a8.00177,8.00177,0,0,0-.56714.92993c-.02588.04981-.04809.10083-.073.15112a7.97024,7.97024,0,0,0-.40515.97608c-.01062.03149-.0238.06128-.03405.093a7.95058,7.95058,0,0,0-.26282,1.08544c-.01331.07666-.02405.15308-.035.23A8.02888,8.02888,0,0,0,24,64v80a8,8,0,0,0,16,0V75.09985L73.58521,86.29492a63.9717,63.9717,0,0,0,20.42944,87.89746,95.88087,95.88087,0,0,0-46.48389,37.4375,7.9997,7.9997,0,1,0,13.40235,8.73828,80.023,80.023,0,0,1,134.1333,0,7.99969,7.99969,0,1,0,13.40234-8.73828,95.87941,95.87941,0,0,0-46.4834-37.43725,63.972,63.972,0,0,0,20.42944-87.89771l44.115-14.70508a8.0005,8.0005,0,0,0,0-15.17968ZM128,168A47.99154,47.99154,0,0,1,89.34875,91.54932l36.12146,12.04052a8.00672,8.00672,0,0,0,5.05958,0l36.12146-12.04052A47.99154,47.99154,0,0,1,128,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "32",
          y1: "64",
          x2: "32",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M54.23194,215.99924a88.02249,88.02249,0,0,1,147.53587-.00038",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "224 64 128 96 32 64 128 32 224 64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M169.33686,82.22033a56,56,0,1,1-82.67374,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSuitcase = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,64H175.99219V56a24.0275,24.0275,0,0,0-24-24h-48a24.0275,24.0275,0,0,0-24,24v8H40A16.01833,16.01833,0,0,0,24,80V208a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216,64ZM95.99219,80h64V208h-64Zm0-24a8.00916,8.00916,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8v8h-64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSuitcaseSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216.0006,64H175.99429V56a24.027,24.027,0,0,0-23.9991-24H103.997A24.027,24.027,0,0,0,79.9979,56v8H40.00721a16.018,16.018,0,0,0-15.9994,16v79.84521c-.001.05225-.00781.10254-.00781.15479s.00684.10254.00781.15479V208a16.018,16.018,0,0,0,15.9994,16H216.0006A16.018,16.018,0,0,0,232,208V80A16.018,16.018,0,0,0,216.0006,64ZM95.9973,56a8.009,8.009,0,0,1,7.9997-8h47.99819a8.009,8.009,0,0,1,7.9997,8v8H95.9973ZM216.0006,80l.00586,72H40.00721V80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "160",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSun = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "68"
        }), React.createElement("path", {
          d: "M128,44a8.00008,8.00008,0,0,0,8-8V16a8,8,0,0,0-16,0V36A8.00008,8.00008,0,0,0,128,44Z"
        }), React.createElement("path", {
          d: "M57.28955,68.603A7.99984,7.99984,0,1,0,68.603,57.28955L54.46094,43.14746A7.99984,7.99984,0,1,0,43.14746,54.46094Z"
        }), React.createElement("path", {
          d: "M44,128a8.00008,8.00008,0,0,0-8-8H16a8,8,0,0,0,0,16H36A8.00008,8.00008,0,0,0,44,128Z"
        }), React.createElement("path", {
          d: "M57.28955,187.397,43.14746,201.53906a7.99984,7.99984,0,1,0,11.31348,11.31348L68.603,198.71045A7.99984,7.99984,0,1,0,57.28955,187.397Z"
        }), React.createElement("path", {
          d: "M128,212a8.00008,8.00008,0,0,0-8,8v20a8,8,0,0,0,16,0V220A8.00008,8.00008,0,0,0,128,212Z"
        }), React.createElement("path", {
          d: "M198.71045,187.397A7.99984,7.99984,0,1,0,187.397,198.71045l14.14209,14.14209a7.99984,7.99984,0,1,0,11.31348-11.31348Z"
        }), React.createElement("path", {
          d: "M240,120H220a8,8,0,0,0,0,16h20a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M193.05371,70.94629a7.97507,7.97507,0,0,0,5.65674-2.34326l14.14209-14.14209a7.99984,7.99984,0,1,0-11.31348-11.31348L187.397,57.28955a7.99976,7.99976,0,0,0,5.65674,13.65674Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "62.94618",
          y1: "62.94618",
          x2: "48.80404",
          y2: "48.80404",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "36",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "62.94618",
          y1: "193.05382",
          x2: "48.80404",
          y2: "207.19596",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "193.05382",
          y1: "193.05382",
          x2: "207.19596",
          y2: "207.19596",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "220",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "193.05382",
          y1: "62.94618",
          x2: "207.19596",
          y2: "48.80404",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSunDim = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "68"
        }), React.createElement("path", {
          d: "M128,44a7.99993,7.99993,0,0,0,8-8V28a8,8,0,0,0-16,0v8A7.99993,7.99993,0,0,0,128,44Z"
        }), React.createElement("path", {
          d: "M57.28906,68.603A8,8,0,1,0,68.603,57.28955l-5.65674-5.657A7.99983,7.99983,0,1,0,51.63281,62.946Z"
        }), React.createElement("path", {
          d: "M36,120H28a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M57.28955,187.397l-5.65674,5.65674a7.99984,7.99984,0,1,0,11.31348,11.31348l5.65674-5.65674A7.99984,7.99984,0,0,0,57.28955,187.397Z"
        }), React.createElement("path", {
          d: "M128,212a7.99977,7.99977,0,0,0-8,8v8a8,8,0,0,0,16,0v-8A7.99977,7.99977,0,0,0,128,212Z"
        }), React.createElement("path", {
          d: "M198.71045,187.397A7.99984,7.99984,0,0,0,187.397,198.71045l5.65674,5.65674a7.99984,7.99984,0,0,0,11.31348-11.31348Z"
        }), React.createElement("path", {
          d: "M228,120h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M193.05371,70.94629a7.977,7.977,0,0,0,5.65723-2.34326l5.65625-5.657a7.99983,7.99983,0,1,0-11.31348-11.31347l-5.65674,5.657a7.99988,7.99988,0,0,0,5.65674,13.65674Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "62.94618",
          y1: "62.94618",
          x2: "57.28932",
          y2: "57.28932",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "36",
          y1: "128",
          x2: "28",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "62.94618",
          y1: "193.05382",
          x2: "57.28932",
          y2: "198.71068",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "228",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "193.05382",
          y1: "193.05382",
          x2: "198.71068",
          y2: "198.71068",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "220",
          y1: "128",
          x2: "228",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "193.05382",
          y1: "62.94618",
          x2: "198.71068",
          y2: "57.28932",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSunHorizon = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M77.74854,43.58691a8.00009,8.00009,0,0,1,14.78222-6.123l7.65332,18.47754a8.00009,8.00009,0,1,1-14.78222,6.123ZM21.46387,108.53027l18.47754,7.65332a7.99964,7.99964,0,1,0,6.123-14.78125L27.58691,93.749a7.99964,7.99964,0,1,0-6.123,14.78125ZM213,116.79492a7.97082,7.97082,0,0,0,3.05859-.61133l18.47754-7.65332a7.99964,7.99964,0,1,0-6.123-14.78125l-18.47754,7.65332A8.001,8.001,0,0,0,213,116.79492ZM160.14551,66.39355a7.99266,7.99266,0,0,0,10.45263-4.3291l7.65332-18.47754a8.00009,8.00009,0,0,0-14.78222-6.123l-7.65332,18.47754A7.99929,7.99929,0,0,0,160.14551,66.39355ZM240,152H195.52319a68,68,0,1,0-135.04638,0H16a8,8,0,0,0,0,16H185.81812l.02905.00195L185.87085,168H240a8,8,0,0,0,0-16Zm-32,40H48a8,8,0,0,0,0,16H208a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "92.79312",
          y1: "59.00308",
          x2: "85.13946",
          y2: "40.52549",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "43.00308",
          y1: "108.79312",
          x2: "24.52549",
          y2: "101.13946",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "212.99692",
          y1: "108.79312",
          x2: "231.47451",
          y2: "101.13946",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "163.20688",
          y1: "59.00308",
          x2: "170.86054",
          y2: "40.52549",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "240",
          y1: "160",
          x2: "16",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "200",
          x2: "48",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M70.157,160.00035a60,60,0,1,1,115.686-.00008",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSwap = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,47.99316v104a16.01833,16.01833,0,0,1-16,16H112V184a8.00018,8.00018,0,0,1-13.65674,5.65723l-24-24a7.98872,7.98872,0,0,1-1.36011-1.822c-.00622-.01124-.01367-.022-.01977-.03333-.10376-.192-.19556-.38843-.28259-.58655-.01892-.04309-.04114-.08435-.05921-.12768-.07483-.179-.13794-.36121-.19922-.54407-.0227-.06751-.04944-.13318-.07043-.20154-.0531-.17383-.09436-.34985-.13538-.52624-.01867-.08045-.04223-.15882-.05859-.24012-.03809-.19043-.06348-.38232-.08765-.57446-.00879-.06934-.023-.137-.02978-.20691-.02637-.26575-.04053-.53235-.04041-.79907L72,159.99316c0-.025.00342-.04907.00366-.07409.00244-.23572.0127-.47132.03577-.70606.01526-.15759.043-.31128.06726-.46618.01587-.09986.02612-.20032.04565-.29969.03565-.18139.083-.358.13062-.53479.01953-.072.03418-.145.05566-.21655.05591-.18652.123-.3678.1919-.54834.02331-.06116.04248-.12329.06738-.184.07739-.18884.16553-.37146.25659-.55286.02527-.05041.04688-.10229.07324-.15222.1084-.20459.22706-.40222.35218-.59582.0155-.024.02844-.04907.04431-.073a8.02882,8.02882,0,0,1,1.09057-1.31836l23.92847-23.92847A8.00037,8.00037,0,0,1,112,136v15.99316h96v-104H96v8a8,8,0,0,1-16,0v-8a16.01833,16.01833,0,0,1,16-16H208A16.01833,16.01833,0,0,1,224,47.99316ZM168,192a8.00008,8.00008,0,0,0-8,8v8H48V104h96v15.99316a8.00018,8.00018,0,0,0,13.65674,5.65723l23.92847-23.92847a8.0284,8.0284,0,0,0,1.09057-1.31836c.01587-.02392.02881-.049.04431-.073.12512-.19361.24378-.39124.35218-.59583.02648-.05017.04809-.10217.0736-.15283.09095-.18091.17884-.36316.256-.55164.02539-.06176.04492-.12524.06872-.1875.06848-.17968.13513-.35986.1908-.54541.02148-.07153.03613-.14453.05566-.21655.04761-.17676.095-.35339.13062-.53479.01953-.09936.02978-.19983.04565-.29968.02429-.15491.052-.3086.06726-.46619.02307-.23474.03333-.47034.03577-.70605C183.99658,96.04907,184,96.025,184,96l-.00012-.00208c.00012-.26672-.014-.53332-.04041-.79907-.00683-.06994-.021-.13757-.02978-.20691-.02417-.19214-.04956-.384-.08765-.57446-.01636-.0813-.03992-.15967-.05859-.24011-.041-.17639-.08228-.35242-.13538-.52625-.02087-.06787-.04748-.13305-.06995-.20019-.06152-.1836-.12475-.36634-.2-.5459-.01782-.04248-.0393-.08252-.05786-.12463-.08716-.1991-.17944-.39637-.28369-.58912-.0061-.01135-.01355-.02209-.01977-.03332a7.9885,7.9885,0,0,0-1.36011-1.822l-24-24A8.00037,8.00037,0,0,0,144,71.99316V88H48a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16H160a16.01833,16.01833,0,0,0,16-16v-8A8.00008,8.00008,0,0,0,168,192Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M80,159.99316H208a8,8,0,0,0,8-8v-104a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "104 136 80 160 104 184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "152 119.993 176 95.993 152 71.993",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSwatches = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M228.16846,152.95605,209.01514,100.334a16.0165,16.0165,0,0,0-20.50733-9.56347l-59.94262,21.81738,11.0769-62.82031a16.00057,16.00057,0,0,0-12.97852-18.53613L71.51514,21.50879A15.99894,15.99894,0,0,0,52.979,34.48633L28.792,171.65918a45.288,45.288,0,0,0,7.74365,33.9834A43.299,43.299,0,0,0,71.937,223.99707h.00342c.02014,0,.03955.00293.05957.00293H212a16.01833,16.01833,0,0,0,16-16V164.27759A15.91483,15.91483,0,0,0,228.16846,152.95605ZM72,192a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,72,192Zm140,16H123.71875L212,175.86841Zm-98.54736-13.29053a43.46748,43.46748,0,0,0,1.8789-7.06885l10.02552-56.85791L193.98,105.80566l19.15332,52.623Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M36.67036,173.04838,60.85763,35.87558a8,8,0,0,1,9.26764-6.48928l55.14924,9.7243a8,8,0,0,1,6.48927,9.26765L107.453,186.25133a36.00022,36.00022,0,0,1-41.01188,29.317C46.4984,212.4439,33.16509,192.92775,36.67036,173.04838Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M118.28071,124.84457,191.244,98.2881a8,8,0,0,1,10.2537,4.78138l19.15313,52.62278a8,8,0,0,1-4.78138,10.25371l-131.557,47.88282",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M219.99977,162.53273v45.467a8,8,0,0,1-8,8h-140",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "72",
          cy: "180",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconSword = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M221.65723,34.34326A8.00246,8.00246,0,0,0,216,32h-.02539l-63.79883.20117A8.00073,8.00073,0,0,0,146.0332,35.106L75.637,120.32275,67.31348,111.999A16.02162,16.02162,0,0,0,44.68555,112L32.001,124.68555A15.99888,15.99888,0,0,0,32,147.31348l20.88672,20.88769L22.94531,198.14258a16.01777,16.01777,0,0,0,.001,22.62695l12.28418,12.28418a16.00007,16.00007,0,0,0,22.62793,0L87.79883,203.1123,108.68652,224.001A16.02251,16.02251,0,0,0,131.31445,224L143.999,211.31445A15.99888,15.99888,0,0,0,144,188.68652l-8.32324-8.32324,85.21679-70.39648a8.00125,8.00125,0,0,0,2.90528-6.14258L224,40.02539A8.001,8.001,0,0,0,221.65723,34.34326Zm-13.84668,65.67822-83.49829,68.97706L111.314,156l54.34327-54.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L100,144.686,87.00195,131.6875,155.97852,48.189l51.99609-.16357Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "76.201 132.201 152.201 40.201 216 40 215.799 103.799 123.799 179.799",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "100",
          y1: "156",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M82.14214,197.45584,52.201,227.397a8,8,0,0,1-11.31371,0L28.603,215.11268a8,8,0,0,1,0-11.31371l29.94113-29.94112a8,8,0,0,0,0-11.31371L37.65685,141.65685a8,8,0,0,1,0-11.3137l12.6863-12.6863a8,8,0,0,1,11.3137,0l76.6863,76.6863a8,8,0,0,1,0,11.3137l-12.6863,12.6863a8,8,0,0,1-11.3137,0L93.45584,197.45584A8,8,0,0,0,82.14214,197.45584Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTShirt = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M245.39844,61.29932,195.96924,33.0542c-.01953-.01123-.04-.019-.05957-.03027-.15833-.08887-.32215-.16846-.48694-.24659-.07752-.03686-.15393-.07763-.23206-.11181-.14917-.06494-.30322-.12012-.45691-.176-.09912-.03638-.19726-.07666-.29724-.10888-.11938-.03809-.24243-.06714-.36425-.09986-.13868-.03735-.27662-.07739-.41614-.10693-.08631-.01807-.17493-.0293-.26209-.04468-.1781-.03149-.35583-.06226-.53442-.08154-.07031-.00757-.142-.00928-.21265-.0149-.19653-.01586-.39282-.02856-.58911-.02978-.01953,0-.03833-.00293-.05786-.00293H160a7.99977,7.99977,0,0,0-8,8,24,24,0,0,1-48,0,7.99977,7.99977,0,0,0-8-8H64c-.02576,0-.05054.00366-.07629.00391-.16809.00146-.33606.01318-.50428.02539-.09814.00708-.19726.01025-.29443.02075-.15137.0166-.302.0437-.453.06909-.11365.019-.2284.03394-.34046.05786-.11706.0249-.23291.05933-.34936.08985-.14331.03735-.28736.072-.42749.11694-.08545.02759-.16931.0625-.25415.09326-.16724.05982-.334.12012-.49573.19067-.07251.03174-.14343.06983-.21545.10376-.16907.08008-.33692.16163-.49927.25269-.01953.011-.0398.0188-.05933.03L10.60107,61.29932A16.00794,16.00794,0,0,0,4.229,82.34668l18.4043,36.80811A15.91231,15.91231,0,0,0,36.94434,128H56v80a16.01833,16.01833,0,0,0,16,16H184a16.01833,16.01833,0,0,0,16-16V128h19.05566a15.91146,15.91146,0,0,0,14.31055-8.84473l18.40527-36.80908A16.00784,16.00784,0,0,0,245.39844,61.29932ZM36.94434,112,18.54,75.19092,56,53.7854V112Zm182.11132,0H200V53.7854l37.46045,21.406Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M192,120h27.05573a8,8,0,0,0,7.15542-4.42229l18.40439-36.80878a8,8,0,0,0-3.18631-10.52366L192,40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M64,120H36.94427a8,8,0,0,1-7.15542-4.42229L11.38446,78.76893a8,8,0,0,1,3.18631-10.52366L64,40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTable = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224.00586,48h-192a7.99977,7.99977,0,0,0-8,8V192a16.01833,16.01833,0,0,0,16,16h176a16.01833,16.01833,0,0,0,16-16V56A7.99977,7.99977,0,0,0,224.00586,48Zm-184,64h40v32h-40Zm56,0H216.01l.00244,32H96.00586Zm-56,48h40v32h-40Zm176,32h-120V160H216.01367l.00244,31.99951Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88.00008",
          y1: "104",
          x2: "88.00008",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTag = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,126.8623,135.54785,22.41016a15.95972,15.95972,0,0,0-14.45215-4.376L40.44043,34.165A8.00261,8.00261,0,0,0,34.165,40.44043L18.03418,121.0957a15.97009,15.97009,0,0,0,4.376,14.45215L126.86133,239.999a16.00006,16.00006,0,0,0,22.6289.001L239.999,149.49121A16.00007,16.00007,0,0,0,240,126.8623ZM83.99414,96a12,12,0,1,1,12-12A12,12,0,0,1,83.99414,96Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M122.66459,25.8792,42.0101,42.0101,25.8792,122.66459a8,8,0,0,0,2.1878,7.22578L132.51977,234.34315a8,8,0,0,0,11.31371,0l90.50967-90.50967a8,8,0,0,0,0-11.31371L129.89037,28.067A8,8,0,0,0,122.66459,25.8792Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "84",
          cy: "84",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTagChevron = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M235.7041,136.86719l-42.667,64h0a15.96753,15.96753,0,0,1-13.3125,7.124H24.00586a7.99977,7.99977,0,0,1-6.65625-12.4375L62.39062,128,17.34912,60.42871a8.00013,8.00013,0,0,1,6.65674-12.4375H179.72461a15.96734,15.96734,0,0,1,13.3125,7.125l42.667,64A15.96086,15.96086,0,0,1,235.7041,136.86719Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M186.38079,196.42923l42.66667-64a8,8,0,0,0,0-8.87521l-42.66667-64a8,8,0,0,0-6.6564-3.5624H24.00586L69.0477,123.56221a8,8,0,0,1-.00048,8.8752L24.00586,199.99162H179.72439A8,8,0,0,0,186.38079,196.42923Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTagSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M246.65625,123.56213l-45.624-68.43652a15.9687,15.9687,0,0,0-13.31348-7.126H40a16.01833,16.01833,0,0,0-16,16v128a16.01833,16.01833,0,0,0,16,16H187.71875a15.96649,15.96649,0,0,0,13.31348-7.125l-.001.001,45.625-68.43848A7.99771,7.99771,0,0,0,246.65625,123.56213Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M194.37493,196.43765,240,128,194.37493,59.56244a8,8,0,0,0-6.6564-3.56239H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.71853A8,8,0,0,0,194.37493,196.43765Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTarget = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M211.2002,79.3916a8.00051,8.00051,0,0,0-3.77051,10.667,88.0876,88.0876,0,1,1-23.13037-29.67187l-22.769,22.76855a55.99686,55.99686,0,0,0-73.1333,84.438l.0044.00488.00537.00489a56.00035,56.00035,0,0,0,95.50244-42.79737,8.0002,8.0002,0,1,0-15.97461.90821,40.01415,40.01415,0,0,1-61.99805,35.66357l23.94922-23.94922,37.71289-37.7124.00489-.00537,62.05371-62.05371a8.00036,8.00036,0,0,0-11.31446-11.314L195.667,49.01855a104.00214,104.00214,0,0,0-141.206,152.52051A104.01636,104.01636,0,0,0,221.86719,83.16211,7.99983,7.99983,0,0,0,211.2002,79.3916Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "224",
          y2: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M195.88225,60.11775a95.90539,95.90539,0,1,0,18.76606,26.49271",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M161.94113,94.05887a47.99886,47.99886,0,1,0,13.98107,31.20092",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTelegramLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.25586,31.73635a15.9634,15.9634,0,0,0-16.29-2.76758L30.40869,101.47365a15.99988,15.99988,0,0,0,2.7124,30.58106L80,141.43069V199.9844a15.99415,15.99415,0,0,0,27.31348,11.31347L133.25684,185.355l39.376,34.65088a15.86863,15.86863,0,0,0,10.51709,4.00293,16.15674,16.15674,0,0,0,4.96338-.78711,15.86491,15.86491,0,0,0,10.68457-11.65332L236.41162,47.43557A15.96073,15.96073,0,0,0,231.25586,31.73635ZM183.20215,207.99416,100.81006,135.4883l118.64453-85.687Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M88,134.87236l89.91726,79.12718a8,8,0,0,0,13.08288-4.21869L228.61385,45.64829a8,8,0,0,0-10.72308-9.233L33.33393,108.91975a8,8,0,0,0,1.35629,15.29065Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "134.87236",
          x2: "224.11223",
          y2: "36.56908",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M132.90708,174.39059l-31.25023,31.25023A8,8,0,0,1,88,199.984v-65.1116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTelevision = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,64H147.31445l34.34278-34.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L128,60.68652,85.65723,18.34277A8.00053,8.00053,0,0,0,74.34277,29.65723L108.68555,64H40A16.01833,16.01833,0,0,0,24,80V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216,64Zm0,136H160V80h56l.00977,120Zm-16-84a12,12,0,1,1-12-12A12,12,0,0,1,200,116Zm0,48a12,12,0,1,1-12-12A12,12,0,0,1,200,164Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188",
          cy: "116",
          r: "12"
        }), React.createElement("circle", {
          cx: "188",
          cy: "164",
          r: "12"
        }), React.createElement("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTelevisionSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,80V200a16.01833,16.01833,0,0,1-16,16H40a16.01833,16.01833,0,0,1-16-16V80A16.01833,16.01833,0,0,1,40,64h68.68555L74.34277,29.65723A8.00053,8.00053,0,0,1,85.65723,18.34277L128,60.68652l42.34277-42.34375a8.00053,8.00053,0,0,1,11.31446,11.31446L147.31445,64H216A16.01833,16.01833,0,0,1,232,80Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTennisBall = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,136.041c2.53906,0,5.07721.125,7.6087.34277a103.89367,103.89367,0,0,1-95.22107,95.2793A87.855,87.855,0,0,1,224,136.041Zm-73.53906,14.41992A103.31914,103.31914,0,0,1,224,120q3.85537,0,7.66394.27734a103.91077,103.91077,0,0,0-96-96,103.79931,103.79931,0,0,1-30.12488,81.26172A103.31914,103.31914,0,0,1,32,136q-3.85546,0-7.66394-.27734a103.91077,103.91077,0,0,0,96,96A103.79931,103.79931,0,0,1,150.46094,150.46094ZM94.22559,94.22559a87.83528,87.83528,0,0,0,25.38678-69.88868,103.89355,103.89355,0,0,0-95.221,95.2793A87.83194,87.83194,0,0,0,94.22559,94.22559Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M127.83333,32.00018a96,96,0,0,1-95.83212,95.83315",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M223.99982,128.16667a96,96,0,0,0-95.83315,95.83212",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTerminal = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M120,128a8.00063,8.00063,0,0,0-2.68506-5.97949l-72-64a8.00018,8.00018,0,0,0-10.62988,11.959L99.9585,128,34.68506,186.02051a8.00018,8.00018,0,0,0,10.62988,11.959l72-64A8.00063,8.00063,0,0,0,120,128Z"
        }), React.createElement("path", {
          d: "M215.99414,184h-96a8,8,0,0,0,0,16h96a8,8,0,1,0,0-16Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "40 64 112 128 40 192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "119.99414",
          y1: "192",
          x2: "215.99414",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTerminalWindow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.51465,39.51465H40.48535a16.99025,16.99025,0,0,0-16.9707,16.9707v143.0293a16.99025,16.99025,0,0,0,16.9707,16.9707h175.0293a16.99025,16.99025,0,0,0,16.9707-16.9707V56.48535A16.99025,16.99025,0,0,0,215.51465,39.51465Zm-94.51758,94.73242-40,32a7.99979,7.99979,0,1,1-9.99414-12.49414L103.19336,128,71.00293,102.24707a7.99979,7.99979,0,1,1,9.99414-12.49414l40,32a7.99943,7.99943,0,0,1,0,12.49414ZM179.99414,168h-40a8,8,0,0,1,0-16h40a8,8,0,1,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "80 96 120 128 80 160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "135.99414",
          y1: "160",
          x2: "175.99414",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8.48528",
          strokeWidth: "16.97056",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTestTube = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M237.65674,86.34326l-60-60a8.00063,8.00063,0,0,0-11.314,0L62.39453,130.29193l-.01172.01129-26.04,26.04a44.76956,44.76956,0,0,0,63.314,63.31348L177.605,141.70868l.0127-.01288,34.70361-34.70361,22.2085-7.40283a7.9996,7.9996,0,0,0,3.127-13.2461Zm-32.18653,6.06738a8.00221,8.00221,0,0,0-3.12744,1.93262l-35.59814,35.59821c-2.148,1.51983-17.895,11.53961-43.167-1.09674-10.99854-5.49964-20.811-7.63062-29.18116-7.92743L172,43.314l45.19043,45.19Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,100,94,214A36.7695,36.7695,0,0,1,42,214L42,214A36.7695,36.7695,0,0,1,42,162L172,32l60,60Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M68,136s20-16,52,0,52,0,52,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextAa = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M137.86572,148.20361l-.01416-.02685L87.07031,52.25684a8.00006,8.00006,0,0,0-14.14062,0L22.14844,148.17676l-.01416.02685L.92969,188.25684a8,8,0,0,0,14.14062,7.48632L33.99316,160h92.01368l18.92285,35.74316a8,8,0,0,0,14.14062-7.48632ZM42.46387,144,80,73.09766,117.53613,144ZM208,94.90039a42.22159,42.22159,0,0,0-29.63867,11.80469,7.9999,7.9999,0,1,0,11.26758,11.35937A26.12387,26.12387,0,0,1,208,110.90039c13.2334,0,24,8.97168,24,20v7.21973a42.75745,42.75745,0,0,0-24-7.21973c-22.05566,0-40,16.14941-40,36s17.94434,36,40,36a42.65985,42.65985,0,0,0,24.67236-7.6958A7.9985,7.9985,0,0,0,248,192V130.90039C248,111.0498,230.05566,94.90039,208,94.90039Zm0,92c-13.2334,0-24-8.97168-24-20s10.7666-20,24-20,24,8.97168,24,20S221.2334,186.90039,208,186.90039Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "152 192 80 56 8 192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("ellipse", {
          cx: "208",
          cy: "166.9",
          rx: "32",
          ry: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M183.9948,112.38439A34.03967,34.03967,0,0,1,208,102.9c17.67311,0,32,12.536,32,28V192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "130.82351",
          y1: "152",
          x2: "29.17645",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextAlignCenter = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64",
          y1: "108",
          x2: "192",
          y2: "108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.00307",
          y1: "148",
          x2: "215.99693",
          y2: "148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "64.00307",
          y1: "188",
          x2: "191.99693",
          y2: "188",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextAlignJustify = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.00614",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.00614",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextAlignLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40",
          y1: "108",
          x2: "168",
          y2: "108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.00614",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.00614",
          y1: "188",
          x2: "168",
          y2: "188",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextAlignRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "40.00614",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88.00614",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextBolder = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M64,120h88a40,40,0,0,1,0,80l-88.00586-.00488v-152L140,48a36,36,0,0,1,0,72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextH = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,56V200a8,8,0,0,1-16,0V136H64v64a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v64H192V56a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "56",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "56",
          x2: "200",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextHFive = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0ZM211.88184,140.002a36.413,36.413,0,0,0-9.33985,1.209L206.63965,116H240a8,8,0,0,0,0-16H199.835a8.00076,8.00076,0,0,0-7.89648,6.7168l-7.835,48.20215a7.99971,7.99971,0,0,0,13.541,6.95214,20.20412,20.20412,0,0,1,28.47461-.001,19.91646,19.91646,0,0,1,.001,28.25976,20.20173,20.20173,0,0,1-28.47461.001,7.99985,7.99985,0,1,0-11.291,11.33594A36.05843,36.05843,0,1,0,211.88184,140.002Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M240,108H199.83477L192,156.20232a27.99935,27.99935,0,1,1,0,39.5969",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextHFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm84,72a8.00039,8.00039,0,0,0-8,8v24H199.30664L219.542,102.66211a7.99987,7.99987,0,1,0-15.08789-5.32422l-23.99805,68A7.99995,7.99995,0,0,0,188,176h40v24a8,8,0,0,0,16,0V136A8.00039,8.00039,0,0,0,236,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "211.998 100 188 168 236 168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "236",
          y1: "136",
          x2: "236",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextHOne = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm71.77539,44.94727a7.99755,7.99755,0,0,0-8.21191.3955l-24,15.99317a8.00008,8.00008,0,1,0,8.873,13.31445L212,122.94434V200a8,8,0,0,0,16,0V108A7.99932,7.99932,0,0,0,223.77539,100.94727Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "196 123.993 220 108 220 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextHSix = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0ZM252,168a36,36,0,1,1-67.41943-17.54346c.09448-.19189.19067-.3833.30224-.56982l32.249-53.98926a8.00015,8.00015,0,1,1,13.73632,8.20508l-16.6914,27.94385Q215.08276,132.001,216,132A36.04061,36.04061,0,0,1,252,168Zm-16,0a20,20,0,1,0-20,20A20.02229,20.02229,0,0,0,236,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "191.75129",
          y1: "153.98956",
          x2: "224",
          y2: "100",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "216",
          cy: "168",
          r: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextHThree = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm85.459,94.54492a35.92878,35.92878,0,0,0-11.92578-7.92676l21.01856-30.03906a8,8,0,0,0-6.55469-12.58691h-48a8,8,0,0,0,0,16h32.63867l-19.1875,27.4209A8,8,0,0,0,212.00293,156a20,20,0,1,1-14.1416,34.1416,8.00052,8.00052,0,0,0-11.31445,11.31445,35.99995,35.99995,0,1,0,50.9121-50.91113Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M191.99683,107.99216h48L212.00317,148a28,28,0,1,1-19.799,47.799",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextHTwo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm88,135.99414H207.99707l34.30566-45.77734c.07911-.1045.1543-.21094.22754-.31934A32.00406,32.00406,0,1,0,186.51758,115.542a8,8,0,1,0,14.73633,6.23242A16.00416,16.00416,0,1,1,229.37012,136.794l-43.67285,58.27539A8.00367,8.00367,0,0,0,191.999,208.001c.10547,0,.21192-.00293.31836-.00684H240a8,8,0,0,0,0-16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M193.886,118.65812a24.00387,24.00387,0,1,1,42.01514,22.7605v0L192,200v-.00575h48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextItalic = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M199.99414,55.99512a8.00008,8.00008,0,0,1-8,8H157.76l-42.6665,128h28.90063a8,8,0,0,1,0,16H104.02307l-.028.002-.02735-.002H63.99414a8,8,0,0,1,0-16H98.22827l42.66651-128H111.99414a8,8,0,0,1,0-16h80A8.00008,8.00008,0,0,1,199.99414,55.99512Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "151.99414",
          y1: "55.99512",
          x2: "103.99414",
          y2: "199.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "63.99414",
          y1: "199.99512",
          x2: "143.99414",
          y2: "199.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "111.99414",
          y1: "55.99512",
          x2: "191.99414",
          y2: "55.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextStrikethrough = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,128a7.99977,7.99977,0,0,1-8,8H175.93091C185.11755,143.11133,192,153.20166,192,168c0,13.33936-7.01465,25.6958-19.75244,34.79395C160.32568,211.31006,144.61133,216,128,216S95.67432,211.31006,83.75244,202.794C71.01465,193.6958,64,181.33936,64,168a8,8,0,0,1,16,0c0,17.3457,21.98145,32,48,32s48-14.6543,48-32c0-14.85425-10.54053-23.58228-38.76587-32H40a8,8,0,0,1,0-16h98.239c.03028-.00049.06055.00024.0907,0H216A7.99977,7.99977,0,0,1,224,128ZM76.33252,104.00488a8.00573,8.00573,0,0,0,7.60254-10.49609A17.42935,17.42935,0,0,1,83.11133,88c0-18.24316,19.29785-32,44.88867-32,19.5,0,36.11768,8.25195,42.33643,21.02246a7.99984,7.99984,0,1,0,14.38476-7.00488C175.70557,51.502,153.97119,40,128,40,93.2876,40,67.11133,60.63574,67.11133,88a33.60555,33.60555,0,0,0,1.62158,10.49707A8.00289,8.00289,0,0,0,76.33252,104.00488Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("g", null, React.createElement("path", {
          d: "M76.334,96.00294A25.48209,25.48209,0,0,1,75.11111,88c0-22.09139,21.96094-40,52.88889-40,23.77865,0,42.25677,10.58606,49.529,25.52014",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M72,168c0,22.09139,25.07205,40,56,40s56-17.90861,56-40c0-23.76634-21.62275-32.97043-45.59723-40.00076",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        })));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextT = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M207.99414,47.99512h-160a8.00008,8.00008,0,0,0-8,8v32a8,8,0,0,0,16,0v-24h64v128h-24a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16h-24v-128h64v24a8,8,0,1,0,16,0v-32A8.00008,8.00008,0,0,0,207.99414,47.99512Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "127.99414",
          y1: "55.99512",
          x2: "127.99414",
          y2: "199.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "47.994 87.995 47.994 55.995 207.994 55.995 207.994 87.995",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "95.99414",
          y1: "199.99512",
          x2: "159.99414",
          y2: "199.99512",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTextUnderline = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M64,56v64a64,64,0,0,0,128,0V56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconThermometer = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M212,52a28,28,0,1,0,28,28A28.03146,28.03146,0,0,0,212,52Zm0,40a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,212,92Zm-52,51.27441V48a40,40,0,0,0-80,0v95.27441a60,60,0,1,0,80,0ZM120,24a24.02718,24.02718,0,0,1,24,24V80H96V48A24.02718,24.02718,0,0,1,120,24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "212",
          cy: "80",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconThermometerCold = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M244.90576,77.71973l-19.96167,6.48632,12.33716,16.98047a8,8,0,1,1-12.94434,9.4043L212,93.61035l-12.33691,16.98047a7.99995,7.99995,0,0,1-12.94434-9.4043l12.33716-16.98047-19.96167-6.48632a8,8,0,1,1,4.94433-15.2168L204,68.98877V48a8,8,0,0,1,16,0V68.98877l19.96143-6.48584a8,8,0,1,1,4.94433,15.2168ZM180,188A60,60,0,1,1,80,143.27441V48a40,40,0,0,1,80,0v95.27441A59.61666,59.61666,0,0,1,180,188ZM96,48v56h48V48a24,24,0,0,0-48,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "212",
          y1: "48",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "181.56619",
          y1: "70.11146",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "193.19087",
          y1: "105.88854",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "230.80913",
          y1: "105.88854",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "242.43381",
          y1: "70.11146",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconThermometerHot = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M160,143.27441V48a40,40,0,0,0-80,0v95.27441a60,60,0,1,0,80,0ZM120,24a24.02718,24.02718,0,0,1,24,24v8H96V48A24.02718,24.02718,0,0,1,120,24Zm58.05908,61.65723a8.00034,8.00034,0,0,1,0-11.31446,27.99923,27.99923,0,0,1,39.59766,0,12.01214,12.01214,0,0,0,16.9707,0,8.00018,8.00018,0,0,1,11.31348,11.31446,27.99923,27.99923,0,0,1-39.59766,0,12.01214,12.01214,0,0,0-16.9707,0A8.00182,8.00182,0,0,1,178.05908,85.65723Zm67.88184,28.68554a8.00034,8.00034,0,0,1,0,11.31446,27.99923,27.99923,0,0,1-39.59766,0,12.01214,12.01214,0,0,0-16.9707,0,8.00018,8.00018,0,0,1-11.31348-11.31446,27.99923,27.99923,0,0,1,39.59766,0,12.01214,12.01214,0,0,0,16.9707,0A8.00182,8.00182,0,0,1,245.94092,114.34277Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M240.28427,80A20,20,0,0,1,212,80a20,20,0,0,0-28.28427,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M240.28427,120A20,20,0,0,1,212,120a20,20,0,0,0-28.28427,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconThermometerSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M168,143.27441V48a40,40,0,0,0-80,0v95.27441a60,60,0,1,0,80,0ZM128,24a24.02718,24.02718,0,0,1,24,24V80H104V48A24.02718,24.02718,0,0,1,128,24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M96,147.02548V48a32,32,0,0,1,64,0v99.02548l.00787-.01006a52,52,0,1,1-64.01574,0Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconThumbsDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M237.68457,157.02344l-12-96.00049A24.03944,24.03944,0,0,0,201.86914,40H31.99414a16.01833,16.01833,0,0,0-16,16v88a16.01833,16.01833,0,0,0,16,16H75.0498l37.78907,75.57764A7.99869,7.99869,0,0,0,119.99414,240a40.04552,40.04552,0,0,0,40-40V184h53.875a24.00051,24.00051,0,0,0,23.81543-26.97656ZM71.99414,144h-40V56h40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M31.99414,48h48a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M79.99414,152l40,80a32,32,0,0,0,32-32V176h61.87549a16,16,0,0,0,15.87644-17.98456l-12-96A16,16,0,0,0,201.86963,48H79.99414",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconThumbsUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.86133,80.11621A24.01156,24.01156,0,0,0,213.86914,72h-53.875V56a40.04552,40.04552,0,0,0-40-40,7.99869,7.99869,0,0,0-7.15527,4.42236L75.0498,96H31.99414a16.01833,16.01833,0,0,0-16,16v88a16.01833,16.01833,0,0,0,16,16h169.875a24.03945,24.03945,0,0,0,23.81543-21.02344l12-96A24.01444,24.01444,0,0,0,231.86133,80.11621ZM31.99414,112h40v88h-40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M31.99414,104h48a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0h-48a8,8,0,0,1-8-8V112A8,8,0,0,1,31.99414,104Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M79.99414,104l40-80a32,32,0,0,1,32,32V80h61.87549a16,16,0,0,1,15.87644,17.98456l-12,96A16,16,0,0,1,201.86963,208H79.99414",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTicket = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M227.19141,104.48A16.04032,16.04032,0,0,0,240,88.80957V64a16.01833,16.01833,0,0,0-16-16H32A16.01833,16.01833,0,0,0,16,64V88.80957A16.04032,16.04032,0,0,0,28.80859,104.48a24.00818,24.00818,0,0,1,0,47.04A16.04032,16.04032,0,0,0,16,167.19043V192a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V167.19043A16.04032,16.04032,0,0,0,227.19141,151.52a24.00818,24.00818,0,0,1,0-47.04ZM32,167.19824a40.00306,40.00306,0,0,0,0-78.38867V64H88V192H32Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M24,167.19024a7.98836,7.98836,0,0,1,6.39917-7.83019,32.00785,32.00785,0,0,0,0-62.7201A7.98836,7.98836,0,0,1,24,88.80976V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.80976A7.98836,7.98836,0,0,1,225.60083,96.64a32.00785,32.00785,0,0,0,0,62.7201A7.98836,7.98836,0,0,1,232,167.19024V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTiktokLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,84v40a7.99977,7.99977,0,0,1-8,8,103.32406,103.32406,0,0,1-48.00049-11.70752L176,156A76,76,0,1,1,86.59766,81.17971,7.99952,7.99952,0,0,1,96,89.05569l-.00049,41.63916a7.99971,7.99971,0,0,1-4.56689,7.22607A20.00272,20.00272,0,1,0,120,156V28a7.99977,7.99977,0,0,1,8-8h40a7.99977,7.99977,0,0,1,8,8,48.05436,48.05436,0,0,0,48,48A7.99977,7.99977,0,0,1,232,84Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M167.99955,105.98292A95.56434,95.56434,0,0,0,224,124V84a56,56,0,0,1-56-56l-40,0V156a28,28,0,1,1-40.00062-25.30518L88,89.05549A68.00535,68.00535,0,1,0,168,156Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTimer = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M104,16h48a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16Z"
        }), React.createElement("path", {
          d: "M128,32a96,96,0,1,0,96,96A96.10874,96.10874,0,0,0,128,32Zm45.25488,62.05859-39.59765,39.59815a8.00018,8.00018,0,0,1-11.31446-11.31348l39.59815-39.59814a8,8,0,1,1,11.314,11.31347Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "167.59798",
          y2: "88.40202",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "8",
          x2: "152",
          y2: "8",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconToggleLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144ZM80,168a40,40,0,1,1,40-40A40.04552,40.04552,0,0,1,80,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "16.00006",
          y: "64",
          width: "223.99987",
          height: "128",
          rx: "63.99994",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "80",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconToggleRight = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,112a40,40,0,1,1,40-40A40.00006,40.00006,0,0,1,176,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "16.00006",
          y: "64",
          width: "223.99987",
          height: "128",
          rx: "63.99994",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "176",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconToiletPaper = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184,120a7.99993,7.99993,0,0,1-8,8H160a8,8,0,0,1,0-16h16A7.99993,7.99993,0,0,1,184,120Zm56,0v88a16.01833,16.01833,0,0,1-16,16H112a16.01833,16.01833,0,0,1-16-16V186.34595C87.37219,200.36914,76.1825,208,64,208c-13.87256,0-26.459-9.89209-35.43945-27.854C20.46045,163.94678,16,142.58643,16,120c0-22.58667,4.46045-43.947,12.56055-60.14624C37.541,41.89185,50.12744,32,64,32H192c13.87256,0,26.459,9.89185,35.43945,27.85376C235.53955,76.053,240,97.41333,240,120ZM76,120a12,12,0,1,0-12,12A12,12,0,0,0,76,120Zm148,8H208a8,8,0,0,1,0-16h15.79443C221.84131,73.89966,206.16479,48,192,48H92.12109a73.18268,73.18268,0,0,1,7.31836,11.85376C106.57593,74.126,110.88281,92.40625,111.80762,112H128a8,8,0,0,1,0,16H112v80H224Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "64",
          cy: "120",
          r: "12"
        }), React.createElement("ellipse", {
          cx: "64",
          cy: "120",
          rx: "40",
          ry: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.18278-17.90861-80-40-80H64",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "120",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "120",
          x2: "176",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "208",
          y1: "120",
          x2: "232",
          y2: "120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTote = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M234.9834,69.3291A16.01892,16.01892,0,0,0,223.06152,64H175.3208a47.99073,47.99073,0,0,0-94.6416,0H32.93848A16.00031,16.00031,0,0,0,17.03613,81.7666L31.25781,209.76709A15.98372,15.98372,0,0,0,47.16016,224H208.83984a15.98375,15.98375,0,0,0,15.90235-14.2334l14.22168-128A16.01871,16.01871,0,0,0,234.9834,69.3291ZM95.99219,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0ZM97.0127,64a32.00443,32.00443,0,0,1,61.9746,0Zm78.97949,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconToteSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M234.9834,69.3291A16.01892,16.01892,0,0,0,223.06152,64H175.3208a47.99073,47.99073,0,0,0-94.6416,0H32.93848A16.00031,16.00031,0,0,0,17.03613,81.7666L31.25781,209.76709A15.98372,15.98372,0,0,0,47.16016,224H208.83984a15.98375,15.98375,0,0,0,15.90235-14.2334l14.22168-128A16.01871,16.01871,0,0,0,234.9834,69.3291ZM128,40a32.05773,32.05773,0,0,1,30.9873,24H97.0127A32.05773,32.05773,0,0,1,128,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.83966,216H47.16034a8,8,0,0,1-7.95107-7.11655l-14.22222-128A8,8,0,0,1,32.93812,72H223.06188a8,8,0,0,1,7.95107,8.88345l-14.22222,128A8,8,0,0,1,208.83966,216Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTrafficSign = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M244,116.68555,139.31445,12.001A15.99888,15.99888,0,0,0,116.68652,12L11.999,116.68652A16.02163,16.02163,0,0,0,12,139.31445L116.68555,243.999a15.99888,15.99888,0,0,0,22.62793.001L244.001,139.31348A16.02163,16.02163,0,0,0,244,116.68555ZM175.999,120.022q-.00145.38379-.03906.7666c-.01172.12061-.03418.2378-.05127.35694-.02.13965-.03613.27929-.064.41748-.02637.13525-.06348.26611-.09717.39892-.03027.12012-.05664.24073-.09277.35987-.03956.13037-.0879.25586-.13379.3833-.04248.11914-.08155.23877-.13038.356-.04882.11767-.106.23-.16015.34472-.05762.12256-.11182.2461-.17627.36572-.05762.10791-.12354.21-.186.31495-.0708.11914-.13867.24023-.2163.35644-.07618.11328-.16065.22022-.24219.3291-.07471.1001-.144.20264-.22412.3003-.14893.18115-.30762.35449-.47168.522-.02.02051-.03711.04248-.05713.063l-24,24a8.00018,8.00018,0,0,1-11.31348-11.31446L148.686,128H112a16.01833,16.01833,0,0,0-16,16v8a8,8,0,0,1-16,0v-8a32.03667,32.03667,0,0,1,32-32h36.686l-10.34278-10.34277a8.00018,8.00018,0,0,1,11.31348-11.31446l24,24c.02.02051.03711.04248.05713.063.16406.16748.32275.34082.47168.522.08007.09766.14941.2002.22412.3003.08154.10888.166.21582.24219.3291.07763.11621.1455.2373.2163.35644.0625.105.12842.207.186.31495.06445.11962.11865.24316.17627.36572.0542.11474.11133.22705.16015.34472.04883.11719.0879.23682.13038.356.04589.12744.09423.25293.13379.3833.03613.11914.0625.23975.09277.35987.03369.13281.0708.26367.09717.39892.02783.13819.04394.27783.064.41748.01709.11914.03955.23633.05127.35694q.03809.38232.03906.7666L176,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "144 144 168 120 144 96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "45.97561",
          y: "45.97561",
          width: "164.04877",
          height: "164.04877",
          rx: "8",
          transform: "translate(-53.01934 128) rotate(-45)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M88,152v-8a24,24,0,0,1,24-24h56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTrain = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M188,24H68A32.03667,32.03667,0,0,0,36,56V184a32.03667,32.03667,0,0,0,32,32H79.99976L65.59961,235.2002a8.00019,8.00019,0,0,0,12.80078,9.5996L100.00024,216h55.99952l21.59985,28.7998a8.00019,8.00019,0,0,0,12.80078-9.5996L176.00024,216H188a32.03667,32.03667,0,0,0,32-32V56A32.03667,32.03667,0,0,0,188,24ZM84,184a12,12,0,1,1,12-12A12,12,0,0,1,84,184Zm36-64H52V80h68Zm52,64a12,12,0,1,1,12-12A12,12,0,0,1,172,184Zm32-64H136V80h68Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "44",
          y1: "72",
          x2: "212",
          y2: "72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "84",
          cy: "172",
          r: "12"
        }), React.createElement("circle", {
          cx: "172",
          cy: "172",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTrainRegional = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M160,80H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"
        }), React.createElement("path", {
          d: "M223.99023,119.85681q-.00732-.37884-.05078-.76166c-.011-.09741-.02295-.194-.03759-.291-.012-.07855-.01661-.15656-.03077-.23529-.03271-.18048-.08007-.35437-.124-.52967-.01221-.04766-.01636-.09668-.0293-.14416l-.033-.12073-.00122-.00421L201.3252,35.79A16.03362,16.03362,0,0,0,185.88965,24H70.11035A16.03362,16.03362,0,0,0,54.6748,35.79L32.31665,117.76892l-.002.00733-.03247.11877c-.0127.047-.01685.09546-.02881.14264-.04444.17578-.09155.35022-.12451.53119-.01416.07873-.0188.15674-.03077.23529-.01464.097-.02661.1936-.03759.291q-.044.38316-.05078.76166c-.00123.06708-.00611.13373-.00562.20081a7.94859,7.94859,0,0,0,.06567.98889c.00269.0202.00757.0401.0105.06036a7.95052,7.95052,0,0,0,.18115.89508c.00879.03406.01148.06909.02076.103L54.6748,204.209A16.03394,16.03394,0,0,0,70.11035,216h9.88941L65.59961,235.2002a8.00019,8.00019,0,0,0,12.80078,9.5996L100.00024,216h55.99952l21.59985,28.7998a8.00019,8.00019,0,0,0,12.80078-9.5996L176.00024,216h9.88941a16.03394,16.03394,0,0,0,15.43555-11.791l22.39257-82.104c.00928-.03394.012-.069.02076-.103a7.95052,7.95052,0,0,0,.18115-.89508c.00293-.02026.00781-.04016.0105-.06036a7.94859,7.94859,0,0,0,.06567-.98889C223.99634,119.99054,223.99146,119.92389,223.99023,119.85681ZM136,192a8,8,0,0,1-16,0V152a8,8,0,0,1,16,0Zm-8-64.13135L50.0127,113.68927,70.10645,40h115.7832l20.09717,73.68933Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M70.11037,32H185.88963a8,8,0,0,1,7.71811,5.89506L216,120l-22.39226,82.10494A8,8,0,0,1,185.88963,208H70.11037a8,8,0,0,1-7.71811-5.89506L40,120,62.39226,37.89506A8,8,0,0,1,70.11037,32Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "40 120 128 136 216 120",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "88",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTrainSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M188,24H68A32.03667,32.03667,0,0,0,36,56V184a32.03667,32.03667,0,0,0,32,32H79.99976L65.59961,235.2002a8.00019,8.00019,0,0,0,12.80078,9.5996L100.00024,216h55.99952l21.59985,28.7998a8.00019,8.00019,0,0,0,12.80078-9.5996L176.00024,216H188a32.03667,32.03667,0,0,0,32-32V56A32.03667,32.03667,0,0,0,188,24Zm0,176H68a16.01833,16.01833,0,0,1-16-16V136H204v48A16.01833,16.01833,0,0,1,188,200Z"
        }), React.createElement("circle", {
          cx: "84",
          cy: "172",
          r: "12"
        }), React.createElement("circle", {
          cx: "172",
          cy: "172",
          r: "12"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("circle", {
          cx: "84",
          cy: "172",
          r: "12"
        }), React.createElement("circle", {
          cx: "172",
          cy: "172",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTranslate = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M239.13184,212.42188l-56-112a8.0001,8.0001,0,0,0-14.31055,0L147.12378,143.817a88.01219,88.01219,0,0,1-47.15234-16.89991A103.63932,103.63932,0,0,0,127.67187,64h24.30469a8,8,0,0,0,0-16h-56V32a8,8,0,0,0-16,0V48h-56a8,8,0,0,0,0,16h87.63257a87.71326,87.71326,0,0,1-23.64038,52.34106A87.6285,87.6285,0,0,1,68.98682,85.332a7.99985,7.99985,0,1,0-15.083,5.33789A103.55961,103.55961,0,0,0,75.9856,126.93945,87.52745,87.52745,0,0,1,23.97656,144a8,8,0,0,0,0,16,103.48476,103.48476,0,0,0,64.01331-22.09045A104.14165,104.14165,0,0,0,139.43115,159.202l-26.60986,53.21985a8.00006,8.00006,0,0,0,14.31055,7.15625L140.9209,192h70.11133l13.78906,27.57813a8.00006,8.00006,0,0,0,14.31055-7.15625ZM148.9209,176l27.05566-54.11133L203.03223,176Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "232 216 176 104 120 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "136",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "32",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "24",
          y1: "56",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M120,56a96,96,0,0,1-96,96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M61.46882,88.00088a96.03987,96.03987,0,0,0,90.52532,63.9658",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTrash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M215.99609,48H176V40a24.02718,24.02718,0,0,0-24-24H104A24.02718,24.02718,0,0,0,80,40v8H39.99609a8,8,0,0,0,0,16h8V208a16.01833,16.01833,0,0,0,16,16h128a16.01833,16.01833,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM112,168a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm0-120H96V40a8.00917,8.00917,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "215.99609",
          y1: "56",
          x2: "39.99609",
          y2: "56.00005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "104",
          x2: "152",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTrashSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,56a8.00008,8.00008,0,0,1-8,8h-8V208a16.01833,16.01833,0,0,1-16,16H64a16.01833,16.01833,0,0,1-16-16V64H40a8,8,0,0,1,0-16H216A8.00008,8.00008,0,0,1,224,56ZM88.00391,32h80a8,8,0,0,0,0-16h-80a8,8,0,0,0,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "215.99609",
          y1: "56",
          x2: "39.99609",
          y2: "56.00005",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "24",
          x2: "168",
          y2: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTray = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.00293,32h-160a16.01833,16.01833,0,0,0-16,16V159.88379c-.00049.03906-.00586.07715-.00586.11621s.00537.07715.00586.11621V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208.00293,32Zm0,176h-160V168l28.68066-.001,19.31446,19.31641A15.89834,15.89834,0,0,0,107.31055,192h41.373a15.89606,15.89606,0,0,0,11.31348-4.68652L179.31055,168h28.6997l.00245,40Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M39.99414,160H76.68043a8,8,0,0,1,5.65686,2.34315l19.3137,19.3137A8,8,0,0,0,107.30785,184h41.37258a8,8,0,0,0,5.65686-2.34315l19.3137-19.3137A8,8,0,0,1,179.30785,160h36.68629",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTree = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M128.02637,187.875c-.02246-.01562-.03028-.01562-.05274,0A72.19779,72.19779,0,0,1,120,192.49219V232a8,8,0,0,0,16,0V192.4917a72.33623,72.33623,0,0,1-7.97266-4.6167Z"
        }), React.createElement("path", {
          d: "M198.10059,62.5957a76.0256,76.0256,0,0,0-140.1958-.002A72.26145,72.26145,0,0,0,16,127.7998c-.10547,38.81739,31.36035,71.19629,70.14453,72.17676A71.65658,71.65658,0,0,0,120,192.49219V156.94434L76.42236,135.15527a7.99984,7.99984,0,1,1,7.15528-14.31054L120,139.05566V88a8,8,0,0,1,16,0v27.05566l36.42236-18.21093a7.99984,7.99984,0,1,1,7.15528,14.31054L136,132.94434V192.4917A71.52878,71.52878,0,0,0,167.99707,200q.92871,0,1.86035-.02344c38.78418-.98144,70.25-33.36133,70.14258-72.18066A72.26158,72.26158,0,0,0,198.10059,62.5957Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "152",
          x2: "80",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M132.476,181.2265a63.99546,63.99546,0,1,0,62.27163-111.367A7.98712,7.98712,0,0,1,190.7243,65.693a68.02876,68.02876,0,0,0-125.44861,0,7.98711,7.98711,0,0,1-4.02328,4.16655,63.99621,63.99621,0,1,0,62.27159,111.367A8.03193,8.03193,0,0,1,132.476,181.2265Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTreeEvergreen = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.18652,195.51465A7.9997,7.9997,0,0,1,224,200H136v40a8,8,0,0,1-16,0V200H32a7.99958,7.99958,0,0,1-6.31445-12.91113L71.64258,128H48a8.00019,8.00019,0,0,1-6.34082-12.87793l80-104a8,8,0,0,1,12.68164,0l80,104A8.00019,8.00019,0,0,1,208,128H184.35742l45.957,59.08887A7.99813,7.99813,0,0,1,231.18652,195.51465Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTreeStructure = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M156,92V80H144a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16h12V164a16.01833,16.01833,0,0,1,16-16h40a16.01833,16.01833,0,0,1,16,16v40a16.01833,16.01833,0,0,1-16,16H172a16.01833,16.01833,0,0,1-16-16V192H144a32.03635,32.03635,0,0,1-32-32V136H84v8a16.01833,16.01833,0,0,1-16,16H36a16.01833,16.01833,0,0,1-16-16V112A16.01833,16.01833,0,0,1,36,96H68a16.01833,16.01833,0,0,1,16,16v8h28V96a32.03635,32.03635,0,0,1,32-32h12V52a16.01833,16.01833,0,0,1,16-16h40a16.01833,16.01833,0,0,1,16,16V92a16.01833,16.01833,0,0,1-16,16H172A16.01833,16.01833,0,0,1,156,92Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "24",
          y: "100",
          width: "56",
          height: "56",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "160",
          y: "40",
          width: "64",
          height: "64",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("rect", {
          x: "160",
          y: "152",
          width: "64",
          height: "64",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "80",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M160,184H144a24,24,0,0,1-24-24V96a24,24,0,0,1,24-24h16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTrendDown = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240.00244,136v64a8.00008,8.00008,0,0,1-8,8h-64a8.00038,8.00038,0,0,1-5.65723-13.65674L188.68848,168l-52.686-52.686-34.34277,34.34278a8.00122,8.00122,0,0,1-11.31446,0l-72-72A8.00018,8.00018,0,1,1,29.65967,66.34326L96.00244,132.686l34.34277-34.34278a8.00122,8.00122,0,0,1,11.31446,0L200.00244,156.686l26.34277-26.34278A8.0001,8.0001,0,0,1,240.00244,136Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "232.002 200 136.002 104 96.002 144 24.002 72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "232.002 136 232.002 200 168.002 200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTrendUp = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240.00244,56v64a8.00018,8.00018,0,0,1-13.65723,5.65674L200.00244,99.314l-58.34277,58.34278a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.314,29.65967,189.65674a8.00018,8.00018,0,0,1-11.31446-11.31348l72-72a8.00122,8.00122,0,0,1,11.31446,0L136.00244,140.686,188.68848,88,162.34521,61.65674A8.00038,8.00038,0,0,1,168.00244,48h64A8.00008,8.00008,0,0,1,240.00244,56Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "232.002 56 136.002 152 96.002 112 24.002 184",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "232.002 120 232.002 56 168.002 56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTriangle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M236.74219,187.96875,148.77344,35.97656a24.00413,24.00413,0,0,0-41.54688,0h.00781L19.25781,187.96875a23.9925,23.9925,0,0,0,20.76563,36.02344H215.97656a23.9925,23.9925,0,0,0,20.76563-36.02344Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTrophy = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M232,64H208V56a16.01833,16.01833,0,0,0-16-16H64A16.01833,16.01833,0,0,0,48,56v8H23.87305a16.01833,16.01833,0,0,0-16,16V96a40.04583,40.04583,0,0,0,40,40H51.917c9.64258,29.93658,36.14258,52.34668,68.083,55.58276V216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V191.60626A80.12,80.12,0,0,0,204.34521,136H208a40.04584,40.04584,0,0,0,40-40V80A16.01833,16.01833,0,0,0,232,64ZM47.87305,120a24.0275,24.0275,0,0,1-24-24V80H48v31.0957A81.777,81.777,0,0,0,48.499,120ZM232,96a24.0275,24.0275,0,0,1-24,24h-.39209q.39037-3.96176.39209-8V80h24Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M56,56v55.09613c0,39.70052,31.75464,72.60753,71.45407,72.90185A72.00008,72.00008,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M198.21561,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M57.964,128H47.87289a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTruck = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M247.99682,119.94092c-.00073-.084-.00952-.168-.01269-.252-.00855-.22216-.02271-.44287-.04907-.66015-.01148-.09424-.02808-.188-.04322-.28223-.03393-.21631-.07568-.4292-.12695-.63965-.02051-.08447-.0415-.16845-.06494-.25293q-.10035-.36108-.23364-.708c-.0149-.03858-.02344-.07862-.03882-.11719l-.04956-.12354-.01075-.02734-13.928-34.82031A15.92368,15.92368,0,0,0,218.58374,72h-34.584V64a8.00039,8.00039,0,0,0-8-8h-152a16.01833,16.01833,0,0,0-16,16V184a16.01833,16.01833,0,0,0,16,16h13.0127a32.00444,32.00444,0,0,0,61.97461,0h58.02539a32.00444,32.00444,0,0,0,61.97461,0h13.01269a16.01833,16.01833,0,0,0,16-16V120C247.99975,119.98,247.99682,119.96094,247.99682,119.94092ZM183.99975,88h34.584l9.59961,24h-44.1836Zm-160-16h144v64h-144Zm44,136a16,16,0,1,1,16-16A16.01833,16.01833,0,0,1,67.99975,208Zm120,0a16,16,0,1,1,16-16A16.01833,16.01833,0,0,1,187.99975,208Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240,120H176V80h42.58374a8,8,0,0,1,7.42781,5.02887Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "68",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "164",
          y1: "192",
          x2: "92",
          y2: "192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.21508",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M176,171.21508V120h64v64a8,8,0,0,1-8,8H212",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTwitchLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V192a16.01833,16.01833,0,0,0,16,16H64v32a7.99949,7.99949,0,0,0,13.12109,6.14551L122.89648,208h42.207a16.03033,16.03033,0,0,0,10.24316-3.709l42.896-35.7461A15.958,15.958,0,0,0,224,156.253V48A16.01833,16.01833,0,0,0,208,32ZM128,136a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M165.1036,200H122.8964a8,8,0,0,0-5.12148,1.85423L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.253a8,8,0,0,1-2.87852,6.14577l-42.89641,35.747A8,8,0,0,1,165.1036,200Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "168",
          y1: "88.00002",
          x2: "168",
          y2: "136.00002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "120",
          y1: "88.00002",
          x2: "120",
          y2: "136.00002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconTwitterLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M245.65723,77.65674l-30.16407,30.16455C209.4707,177.70215,150.53809,232,80,232c-14.52441,0-26.49414-2.30273-35.57764-6.84473-7.33056-3.665-10.33349-7.59912-11.07861-8.71777a8,8,0,0,1,3.84717-11.92822c.25732-.09717,23.84814-9.15772,39.09521-26.40869a109.574,109.574,0,0,1-24.72656-24.355c-13.708-18.60352-28.206-50.91114-19.43066-99.17676a8.00023,8.00023,0,0,1,13.52832-4.22559c.35254.35156,33.64209,33.1709,74.3374,43.772L120,87.99609a48.31863,48.31863,0,0,1,48.6084-47.99267,48.11329,48.11329,0,0,1,40.96875,23.99609L240,64a8.0001,8.0001,0,0,1,5.65723,13.65674Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,88.00288a40.00668,40.00668,0,0,1,76.67148-16.00327L240,72l-32.26239,32.2625A128.00746,128.00746,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,87.9862,48Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUmbrella = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M239.61328,126.62988A112.0108,112.0108,0,0,0,128.00684,24h-.01368A112.0108,112.0108,0,0,0,16.38672,126.62988,16.02123,16.02123,0,0,0,32.33447,144H120v56a32,32,0,0,0,64,0,8,8,0,0,0-16,0,16,16,0,0,1-32,0V144h87.66553a16.02123,16.02123,0,0,0,15.94775-17.37012ZM32.332,127.95215a95.97942,95.97942,0,0,1,75.85645-85.874C96.47266,58.05713,81.84521,86.12988,80.16553,128H32.33447ZM175.83447,128c-1.67968-41.87012-16.30713-69.94287-28.023-85.92188A95.96509,95.96509,0,0,1,223.66553,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,136c0-72,40-104,40-104s40,32,40,104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUmbrellaSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M235.42676,138.83984A16.02871,16.02871,0,0,1,223.66553,144H136v56a16,16,0,0,0,32,0,8,8,0,0,1,16,0,32,32,0,0,1-64,0V144H32.33447a16.02123,16.02123,0,0,1-15.94775-17.37012,112.00665,112.00665,0,0,1,223.22656,0A16.11107,16.11107,0,0,1,235.42676,138.83984Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M32.33457,136a8.021,8.021,0,0,1-7.97506-8.70945,104.00633,104.00633,0,0,1,207.281,0A8.021,8.021,0,0,1,223.66543,136Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUpload = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M85.65674,77.65723,120,43.31348V128a8,8,0,0,0,16,0V43.31348l34.34326,34.34375a8.00018,8.00018,0,0,0,11.31348-11.31446l-48-48c-.023-.02246-.04785-.0415-.0708-.064-.165-.16113-.33545-.31787-.51416-.46485-.09619-.07861-.19776-.14746-.29639-.22119-.11035-.08252-.21826-.168-.333-.24511-.11377-.07618-.23242-.14209-.34912-.21192-.10742-.06445-.2124-.13183-.32324-.19092-.11572-.062-.23535-.11425-.35352-.17041-.11865-.05615-.23584-.11523-.35742-.166-.11181-.0459-.22558-.083-.33887-.12354-.1333-.04834-.26513-.09961-.40185-.14062-.10889-.0332-.21973-.05664-.33008-.085-.14258-.03662-.28369-.07617-.42969-.105-.12109-.02393-.24365-.0376-.36523-.05567-.13623-.0205-.271-.04541-.40918-.05908-.20215-.01953-.40479-.02637-.60742-.03076C128.11768,16.00781,128.05957,16,128,16s-.11768.00781-.17676.00879c-.20263.00439-.40527.01123-.60742.03076-.13818.01367-.27295.03858-.40918.05908-.12158.01807-.24414.03174-.36523.05567-.146.02881-.28711.06836-.42969.105-.11035.02832-.22119.05176-.33008.085-.13672.041-.26855.09228-.40185.14062-.11329.04053-.22706.07764-.33887.12354-.12158.05078-.23877.10986-.35742.166-.11817.05616-.2378.1084-.35352.17041-.11084.05909-.21582.12647-.32324.19092-.1167.06983-.23535.13574-.34912.21192-.11475.07714-.22266.16259-.333.24511-.09863.07373-.2002.14258-.29639.22119-.17578.14454-.34277.29834-.50537.457-.02588.0249-.0542.04638-.07959.07177l-48,48A8.00018,8.00018,0,0,0,85.65674,77.65723Z"
        }), React.createElement("path", {
          d: "M224,120H152v8a24,24,0,0,1-48,0v-8H32a16.01833,16.01833,0,0,0-16,16v64a16.01833,16.01833,0,0,0,16,16H224a16.01833,16.01833,0,0,0,16-16V136A16.01833,16.01833,0,0,0,224,120Zm-35.99951,60a12,12,0,1,1,12-12A12,12,0,0,1,188.00049,180Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "80 72 128 24 176 72",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "188",
          cy: "168",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUploadSimple = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M78.60889,85.0498A7.99881,7.99881,0,0,1,80.34375,76.332l42-41.98926a8.00063,8.00063,0,0,1,11.3125,0l42,41.98926A8,8,0,0,1,170,89.98926H136V152a8,8,0,0,1-16,0V89.98926H86A7.999,7.999,0,0,1,78.60889,85.0498ZM216,144a8.00039,8.00039,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V152A8.00039,8.00039,0,0,0,216,144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polyline", {
          points: "86 81.989 128 40 170 81.989",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "40.02943",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUser = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.93652,211.98633a120.48718,120.48718,0,0,0-67.12-54.14258,72.00007,72.00007,0,1,0-73.63294,0,120.48813,120.48813,0,0,0-67.11865,54.14062,7.99981,7.99981,0,0,0,6.92432,12.00635l194.023.002a7.99957,7.99957,0,0,0,6.92431-12.00635Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "96",
          r: "64",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M30.989,215.99064a112.03731,112.03731,0,0,1,194.02311.002",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "44"
        }), React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm65.75806,162.41016a79.70266,79.70266,0,0,0-24.43091-22.97461,59.83641,59.83641,0,0,1-82.6543,0A79.7048,79.7048,0,0,0,62.2417,186.41016a88.00015,88.00015,0,1,1,131.51636,0Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserCircleGear = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm103.17676-2a7.99671,7.99671,0,0,1-10.92822,2.92822l-4.66822-2.69531A24.0036,24.0036,0,0,1,208,78.624V84a8,8,0,0,1-16,0V78.624a24.0036,24.0036,0,0,1-7.58032-4.39111l-4.66822,2.69531a8,8,0,0,1-8-13.85644l4.65687-2.68872a23.72829,23.72829,0,0,1,0-8.76612l-4.65687-2.68872a8,8,0,0,1,8-13.85644l4.66822,2.69531A24.0036,24.0036,0,0,1,192,33.376V28a8,8,0,0,1,16,0v5.376a24.0036,24.0036,0,0,1,7.58032,4.39111l4.66822-2.69531a8,8,0,1,1,8,13.85644l-4.65687,2.68872a23.72829,23.72829,0,0,1,0,8.76612l4.65687,2.68872A8.00037,8.00037,0,0,1,231.17676,74ZM200,64a8,8,0,1,0-8-8A8.00917,8.00917,0,0,0,200,64Zm22.37012,44.5564a7.99991,7.99991,0,0,0-6.99512,8.89209A89.40475,89.40475,0,0,1,216,128a87.63852,87.63852,0,0,1-22.24194,58.41064,79.70677,79.70677,0,0,0-24.431-22.97485,59.83657,59.83657,0,0,1-82.65418-.00024A79.7048,79.7048,0,0,0,62.2417,186.41016,87.9498,87.9498,0,0,1,128,40c2.72656,0,5.477.126,8.1748.37427a8.00012,8.00012,0,0,0,1.4668-15.93286C134.4585,24.14844,131.21436,24,128,24A103.95123,103.95123,0,0,0,57.81982,204.68091a7.93384,7.93384,0,0,0,1.32544,1.18921,103.78418,103.78418,0,0,0,137.71155-.002,7.935,7.935,0,0,0,1.31983-1.18383A103.74663,103.74663,0,0,0,232,128a105.40092,105.40092,0,0,0-.73828-12.44849A8,8,0,0,0,222.37012,108.5564Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "200",
          cy: "56",
          r: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "28",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "186.14359",
          y1: "48",
          x2: "175.75129",
          y2: "42",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "186.14359",
          y1: "64",
          x2: "175.75129",
          y2: "70",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "72",
          x2: "200",
          y2: "84",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "213.85641",
          y1: "64",
          x2: "224.24871",
          y2: "70",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "213.85641",
          y1: "48",
          x2: "224.24871",
          y2: "42",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M223.31831,116.5001A96.987,96.987,0,0,1,224,128a96,96,0,1,1-96-96q4.50554,0,8.90843.40785",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserCircleMinus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,76a44,44,0,1,1-44,44A43.99983,43.99983,0,0,1,128,76Zm48-12h48a8,8,0,0,0,0-16H176a8,8,0,0,0,0,16Zm39.87158,24.457a8.00076,8.00076,0,0,0-4.87695,10.209,88.016,88.016,0,0,1-17.23645,87.74414,79.7044,79.7044,0,0,0-24.431-22.97461,59.83641,59.83641,0,0,1-82.6543,0A79.70345,79.70345,0,0,0,62.2417,186.41016,87.9498,87.9498,0,0,1,128,40a89.04252,89.04252,0,0,1,13.8877,1.08838,7.99994,7.99994,0,0,0,2.5039-15.80274A104.08275,104.08275,0,0,0,24,128a103.74716,103.74716,0,0,0,33.81934,76.68066,7.94507,7.94507,0,0,0,1.32629,1.18946,103.784,103.784,0,0,0,137.71252-.00293,7.94633,7.94633,0,0,0,1.31678-1.18115A104.0138,104.0138,0,0,0,226.08008,93.334,8.00062,8.00062,0,0,0,215.87158,88.457Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M218.5374,96A95.90174,95.90174,0,1,1,143.13974,33.187",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserCirclePlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,76a44,44,0,1,1-44,44A43.99983,43.99983,0,0,1,128,76Zm48-12h16V80a8,8,0,0,0,16,0V64h16a8,8,0,0,0,0-16H208V32a8,8,0,0,0-16,0V48H176a8,8,0,0,0,0,16Zm45.56006,40.95605a8.00039,8.00039,0,0,0-6.64893,9.15381A89.00044,89.00044,0,0,1,216,128a87.63672,87.63672,0,0,1-22.24182,58.41016,79.7044,79.7044,0,0,0-24.431-22.97461,59.83641,59.83641,0,0,1-82.6543,0A79.70345,79.70345,0,0,0,62.2417,186.41016,87.9498,87.9498,0,0,1,128,40a89.02966,89.02966,0,0,1,13.89062,1.08887,7.99994,7.99994,0,1,0,2.50391-15.80274A104.0826,104.0826,0,0,0,24,128a103.74716,103.74716,0,0,0,33.81934,76.68066,7.94507,7.94507,0,0,0,1.32629,1.18946,103.784,103.784,0,0,0,137.71252-.00293,7.94633,7.94633,0,0,0,1.31678-1.18115A103.74751,103.74751,0,0,0,232,128a105.04749,105.04749,0,0,0-1.28613-16.39453A7.99752,7.99752,0,0,0,221.56006,104.95605Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M63.79905,199.37405a72.02812,72.02812,0,0,1,128.40177-.00026",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M222.81257,112.85778a95.9029,95.9029,0,1,1-79.67019-79.67033",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserFocus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M224,48V76a8,8,0,0,1-16,0V48H180a8,8,0,0,1,0-16h28A16.01833,16.01833,0,0,1,224,48Zm-8,124a8.00008,8.00008,0,0,0-8,8v28H180a8,8,0,0,0,0,16h28a16.01833,16.01833,0,0,0,16-16V180A8.00008,8.00008,0,0,0,216,172ZM76,208H48V180a8,8,0,0,0-16,0v28a16.01833,16.01833,0,0,0,16,16H76a8,8,0,0,0,0-16ZM40,84a8.00008,8.00008,0,0,0,8-8V48H76a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,48V76A8.00008,8.00008,0,0,0,40,84Zm61.06079,57.54077a67.94605,67.94605,0,0,0-33.21313,30.72095A7.99956,7.99956,0,0,0,74.92041,184H181.07959a7.99956,7.99956,0,0,0,7.07275-11.73828,67.94605,67.94605,0,0,0-33.21313-30.72095,40,40,0,1,0-53.87842,0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M180,40h28a8,8,0,0,1,8,8V75.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M180,216h28a8,8,0,0,0,8-8V179.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M76,216H48a8,8,0,0,1-8-8V179.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M76,40H48a8,8,0,0,0-8,8V75.99963",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M74.92057,175.99964a60.02261,60.02261,0,0,1,106.15892.00009",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserGear = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M199.91748,194.85156a8.00007,8.00007,0,0,1-6.125,13.14649H22.208a8.00007,8.00007,0,0,1-6.125-13.14649,119.8892,119.8892,0,0,1,55.77441-37.29339,68,68,0,1,1,72.28516,0A119.89061,119.89061,0,0,1,199.91748,194.85156ZM251.17676,154a7.99606,7.99606,0,0,1-10.92822,2.92822l-4.66822-2.69519A23.999,23.999,0,0,1,228,158.6239V164a8,8,0,0,1-16,0v-5.3761a23.999,23.999,0,0,1-7.58032-4.39087l-4.66822,2.69519a8,8,0,0,1-8-13.85644l4.65674-2.68866a23.73636,23.73636,0,0,1,0-8.76624l-4.65674-2.68866a8,8,0,1,1,8-13.85644l4.66822,2.69519A23.999,23.999,0,0,1,212,113.3761V108a8,8,0,0,1,16,0v5.3761a23.999,23.999,0,0,1,7.58032,4.39087l4.66822-2.69519a8,8,0,1,1,8,13.85644l-4.65674,2.68866a23.73636,23.73636,0,0,1,0,8.76624l4.65674,2.68866A8.00032,8.00032,0,0,1,251.17676,154ZM220,144a8,8,0,1,0-8-8A8.00917,8.00917,0,0,0,220,144Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "220",
          cy: "136",
          r: "16",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "220",
          y1: "120",
          x2: "220",
          y2: "108",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "206.14359",
          y1: "128",
          x2: "195.75129",
          y2: "122",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "206.14359",
          y1: "144",
          x2: "195.75129",
          y2: "150",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "220",
          y1: "152",
          x2: "220",
          y2: "164",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "233.85641",
          y1: "144",
          x2: "244.24871",
          y2: "150",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "233.85641",
          y1: "128",
          x2: "244.24871",
          y2: "122",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserList = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M144,80a8.00008,8.00008,0,0,1,8-8h96a8,8,0,0,1,0,16H152A8.00008,8.00008,0,0,1,144,80Zm104,40H152a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,48H176a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM109.11,142.13013a48,48,0,1,0-58.22,0,71.90424,71.90424,0,0,0-40.62146,47.87573A8,8,0,0,0,18.01611,200H141.98389a8,8,0,0,0,7.74756-9.99414A71.90424,71.90424,0,0,0,109.11,142.13013Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "80",
          cy: "104",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "80",
          x2: "248",
          y2: "80",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "152",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "176",
          x2: "248",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M18.01628,192a64.02064,64.02064,0,0,1,123.96743,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserMinus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M256,136a7.99977,7.99977,0,0,1-8,8H200a8,8,0,0,1,0-16h48A7.99977,7.99977,0,0,1,256,136ZM144.1427,157.55811a68,68,0,1,0-72.2854,0,119.88787,119.88787,0,0,0-55.77478,37.29394,8.00012,8.00012,0,0,0,6.12549,13.146l171.58447.00049a8.00012,8.00012,0,0,0,6.12549-13.146A119.88993,119.88993,0,0,0,144.1427,157.55811Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserPlus = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M256,136a7.99977,7.99977,0,0,1-8,8H232v16a8,8,0,0,1-16,0V144H200a8,8,0,0,1,0-16h16V112a8,8,0,0,1,16,0v16h16A7.99977,7.99977,0,0,1,256,136ZM144.1427,157.55811a68,68,0,1,0-72.2854,0,119.88787,119.88787,0,0,0-55.77478,37.29394,8.00012,8.00012,0,0,0,6.12549,13.146l171.58447.00049a8.00012,8.00012,0,0,0,6.12549-13.146A119.88993,119.88993,0,0,0,144.1427,157.55811Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "112",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M22.208,199.99785a112.00725,112.00725,0,0,1,171.58459.00066",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserRectangle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "44"
        }), React.createElement("path", {
          d: "M216,40H40A16.01833,16.01833,0,0,0,24,56V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40Zm0,160H201.32227a80.03059,80.03059,0,0,0-32.05469-36.50757,59.83658,59.83658,0,0,1-82.53516,0A80.03059,80.03059,0,0,0,54.67773,200H40V56H216l.01025,143.99951Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M60.09854,207.99545a72.02945,72.02945,0,0,1,135.80292,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUserSquare = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "44"
        }), React.createElement("path", {
          d: "M208,32H48A16.01833,16.01833,0,0,0,32,48V208a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16V48A16.01833,16.01833,0,0,0,208,32Zm0,176h-3.67322a80.44452,80.44452,0,0,0-26.069-38.24561,79.23073,79.23073,0,0,0-8.98218-6.26953,59.83684,59.83684,0,0,1-82.55126,0,79.23073,79.23073,0,0,0-8.98218,6.26953A80.44452,80.44452,0,0,0,51.67322,208H48V48H208l.01025,159.99951Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("path", {
          d: "M57.78418,215.99979a72.02025,72.02025,0,0,1,140.43164,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUsers = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M121.19873,157.94751a59.99994,59.99994,0,1,0-66.39661,0A96.21448,96.21448,0,0,0,9.45459,192.791a8.0002,8.0002,0,0,0,6.542,12.60546l144.0044-.00537a7.99991,7.99991,0,0,0,6.54052-12.606A96.21491,96.21491,0,0,0,121.19873,157.94751Z"
        }), React.createElement("path", {
          d: "M248.06348,192.78516a96.214,96.214,0,0,0-45.34327-34.83765A60.00088,60.00088,0,0,0,153.24707,50.23535a8,8,0,0,0-4.251,12.47852,75.83151,75.83151,0,0,1,3.84082,84.88623,8,8,0,0,0,2.04493,10.60107,113.20643,113.20643,0,0,1,8.74365,7.2146c.14429.15674.28979.31275.44873.46021a112.03418,112.03418,0,0,1,25.479,34.90527,7.99971,7.99971,0,0,0,7.24951,4.61523l44.72071-.00537a8.0001,8.0001,0,0,0,6.54-12.606Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "88.00033",
          cy: "108",
          r: "52",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M155.41251,57.937A52.00595,52.00595,0,1,1,169.52209,160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M15.99613,197.39669a88.01736,88.01736,0,0,1,144.00452-.00549",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M169.52209,160a87.89491,87.89491,0,0,1,72.00032,37.3912",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUsersFour = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M25.60059,115.19336A67.8103,67.8103,0,0,1,53.0293,93.51074a40,40,0,1,1,53.9414,0A67.30469,67.30469,0,0,1,128,107.81421a67.29094,67.29094,0,0,1,21.0293-14.30347,40,40,0,1,1,53.9414,0,67.81009,67.81009,0,0,1,27.42676,21.68067,7.99981,7.99981,0,1,1-12.79248,9.60937,52.0088,52.0088,0,0,0-83.21143.00195c-.01318.01758-.0288.032-.042.04932a7.86941,7.86941,0,0,1-.5166.60791c-.05957.064-.1206.12476-.18213.18628q-.21019.20983-.43847.406c-.08838.07666-.17725.15185-.26807.22387-.04785.03784-.09082.07959-.13965.11646-.09131.06836-.1875.12524-.28076.18921-.10156.07007-.20166.14184-.30615.20654-.16358.10181-.33155.19238-.5.281-.084.04419-.165.0935-.25.13452a7.94481,7.94481,0,0,1-1.62012.57348c-.08057.01905-.16211.0315-.24365.0481-.19434.03979-.38916.07544-.58545.10034-.11035.01416-.22071.02295-.33106.03272-.16552.01416-.33056.02417-.49609.02807-.06738.00171-.13477.01148-.20215.01148-.0459,0-.09082-.00977-.13623-.01075a8.03172,8.03172,0,0,1-1.03027-.08081c-.09424-.01391-.187-.03637-.28076-.05371a7.99507,7.99507,0,0,1-.83692-.2019c-.09424-.02832-.18945-.05078-.2832-.08276a8.00518,8.00518,0,0,1-.96045-.40381c-.09326-.04615-.18555-.09375-.27783-.14405a7.8885,7.8885,0,0,1-.92823-.58471c-.021-.01538-.04443-.02539-.06494-.041-.1167-.0874-.22168-.18408-.332-.27637-.064-.0542-.13037-.10473-.19287-.16088-.166-.1482-.32129-.304-.47266-.4629-.02636-.02807-.05468-.054-.08056-.08251a7.99527,7.99527,0,0,1-.61231-.74,52.00276,52.00276,0,0,0-83.1084.13085,8,8,0,1,1-12.793-9.60937ZM202.9707,197.51074a40,40,0,1,0-53.9414,0A67.29094,67.29094,0,0,0,128,211.81421a67.30469,67.30469,0,0,0-21.0293-14.30347,40,40,0,1,0-53.9414,0,67.8103,67.8103,0,0,0-27.42871,21.68262,8,8,0,0,0,6.39648,12.80469l95.97266-.002.02734.002,96.00439-.002a7.9996,7.9996,0,0,0,6.396-12.80468A67.81009,67.81009,0,0,0,202.9707,197.51074Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "80",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M31.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "80",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M31.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "176",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M127.99717,223.99792a60.00878,60.00878,0,0,1,96.004-.00225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "176",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M127.99717,119.99792a60.00878,60.00878,0,0,1,96.004-.00225",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconUsersThree = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M63.99805,140.002a7.99955,7.99955,0,0,1-8,8h-.00049l-44.00147-.0039a8,8,0,0,1-6.3955-12.80469A67.81463,67.81463,0,0,1,33.02783,113.5127,39.99241,39.99241,0,1,1,99.29492,76.50293a7.99971,7.99971,0,0,1-3.78515,8.37695,64.36027,64.36027,0,0,0-27.85889,33.7959A63.645,63.645,0,0,0,63.99805,140.002Zm186.39941-4.81054a67.81009,67.81009,0,0,0-27.42676-21.68067A39.99246,39.99246,0,1,0,156.70361,76.5a8.00092,8.00092,0,0,0,3.78467,8.37695,64.367,64.367,0,0,1,27.85938,33.79688A63.64448,63.64448,0,0,1,192,140a8.00039,8.00039,0,0,0,8.001,8l44.001-.00391a8,8,0,0,0,6.39551-12.80468ZM157.16162,178.0896a48,48,0,1,0-58.32324,0,71.66776,71.66776,0,0,0-35.59522,34.40454A7.9997,7.9997,0,0,0,70.43457,223.999H185.56543a8.00017,8.00017,0,0,0,7.19141-11.50488A71.66776,71.66776,0,0,0,157.16162,178.0896Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "140",
          r: "40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M196,116a59.909,59.909,0,0,1,48.00114,23.99567",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M11.99717,139.99792A59.909,59.909,0,0,1,60,116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M70.4343,215.9991a64.02584,64.02584,0,0,1,115.13125-.00031",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M60,116A32,32,0,1,1,91.437,77.99243",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M164.56291,77.993A32.0027,32.0027,0,1,1,196,116",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconVibrate = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("rect", {
          x: "71.99951",
          y: "32",
          width: "112",
          height: "192",
          rx: "24"
        }), React.createElement("path", {
          d: "M208.00244,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,208.00244,80Z"
        }), React.createElement("path", {
          d: "M240.00244,96a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8.00039,8.00039,0,0,0,240.00244,96Z"
        }), React.createElement("path", {
          d: "M47.99951,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,47.99951,80Z"
        }), React.createElement("path", {
          d: "M15.99951,96a8.00039,8.00039,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8.00039,8.00039,0,0,0,15.99951,96Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("rect", {
          x: "40",
          y: "80",
          width: "176",
          height: "96",
          rx: "16",
          transform: "translate(256) rotate(90)",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }), React.createElement("line", {
          x1: "208.00244",
          y1: "88",
          x2: "208.00244",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "240.00244",
          y1: "104",
          x2: "240.00244",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "48",
          y1: "88",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "16",
          y1: "104",
          x2: "16",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconVideoCamera = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M176,92v96a16.01833,16.01833,0,0,1-16,16H48A40.04584,40.04584,0,0,1,8,164V68A16.01833,16.01833,0,0,1,24,52H136A40.04584,40.04584,0,0,1,176,92Zm68.01562-18.91895a8.00341,8.00341,0,0,0-7.98437-.02734l-40,22.85742A8,8,0,0,0,192,102.85742v50.28516a8,8,0,0,0,4.03125,6.94629l40,22.85742A8.0003,8.0003,0,0,0,248,176V80A7.99807,7.99807,0,0,0,244.01562,73.08105Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "184 112 240 80 240 176 184 144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconVideoCameraSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M229.91992,226.61816a8.0006,8.0006,0,0,1-11.83984,10.76368l-42.34229-46.57618A16.01483,16.01483,0,0,1,160,204H48A40.04584,40.04584,0,0,1,8,164V68A16.01833,16.01833,0,0,1,24,52H49.55127l-20.562-22.61816A8.0006,8.0006,0,0,1,40.8291,18.61816Zm14.0957-153.53711a8.00341,8.00341,0,0,0-7.98437-.02734l-40,22.85742A8,8,0,0,0,192,102.85742v50.28516a8,8,0,0,0,4.03125,6.94629l40,22.85742A8.0003,8.0003,0,0,0,248,176V80A7.99807,7.99807,0,0,0,244.01562,73.08105Zm-81.93554,55.12989A8.0004,8.0004,0,0,0,176,122.8291V92a40.04584,40.04584,0,0,0-40-40H110.88281a8.00036,8.00036,0,0,0-5.91992,13.38184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "240 176 184 144 184 112 240 80 240 176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "34.9091",
          y1: "24",
          x2: "224",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M110.8827,60H152a32,32,0,0,1,32,32v52",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M184,188a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68a8,8,0,0,1,8-8H67.63637",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconVoicemail = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M200,72a55.96339,55.96339,0,0,0-39.13867,96H95.13867A55.96225,55.96225,0,1,0,56,184H200a56,56,0,0,0,0-112ZM16,128a40,40,0,1,1,40,40A40.04584,40.04584,0,0,1,16,128Zm184,40a40,40,0,1,1,40-40A40.04584,40.04584,0,0,1,200,168Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "56",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "200",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "56",
          y1: "176",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconVolleyball = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M231.97754,127.55615A103.99094,103.99094,0,1,0,37.93311,180a105.72542,105.72542,0,0,0,6.46447,9.87012,7.95641,7.95641,0,0,0,.54554.74316,103.21348,103.21348,0,0,0,56.1394,37.84277,104.55745,104.55745,0,0,0,27.08643,3.58887,104.02475,104.02475,0,0,0,94.95739-62.12109,7.99045,7.99045,0,0,0,.86658-2.03223,104.79039,104.79039,0,0,0,7.97668-39.29053c.01478-.19921.0304-.39795.0304-.60107C232,127.8501,231.98572,127.7041,231.97754,127.55615ZM44.52612,155.88037A88.18268,88.18268,0,0,1,77.26184,56.11914l17.12708,29.665a104.19392,104.19392,0,0,0-49.8628,70.09619Zm32.74121,43.99121A87.25645,87.25645,0,0,1,58.90808,182.4873a88.00774,88.00774,0,0,1,43.48059-82.84716L118.76245,128Zm132.3877-39.2251a88.01249,88.01249,0,0,1-93.40991,3.71387L132.6189,136h82.96142A88.7146,88.7146,0,0,1,209.655,160.64648ZM181.36572,120a104.1963,104.1963,0,0,0-35.68689-78.15527A87.80467,87.80467,0,0,1,215.60864,120Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "44.86156",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "211.13844",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "128",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M116.57865,32.65643a96.043,96.043,0,0,1,56.4788,95.34363",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M51.14073,185.563a96.04294,96.04294,0,0,1,54.3306-96.58389",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M216.28063,165.7806a96.04293,96.04293,0,0,1-110.80941,1.24026",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWall = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M136,92h96V56a8.00008,8.00008,0,0,0-8-8H136Z"
        }), React.createElement("rect", {
          x: "184",
          y: "108",
          width: "48",
          height: "44"
        }), React.createElement("rect", {
          x: "88",
          y: "108",
          width: "80",
          height: "44"
        }), React.createElement("rect", {
          x: "24",
          y: "108",
          width: "48",
          height: "44"
        }), React.createElement("path", {
          d: "M136,168v40h88a8.00008,8.00008,0,0,0,8-8V168Z"
        }), React.createElement("path", {
          d: "M120,92V48H32a8.00008,8.00008,0,0,0-8,8V92Z"
        }), React.createElement("path", {
          d: "M120,168H24v32a8.00008,8.00008,0,0,0,8,8h88Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "80",
          y1: "152",
          x2: "80",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "176",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWallet = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M216,72H56a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H56A24.0275,24.0275,0,0,0,32,64V192a24.0275,24.0275,0,0,0,24,24H216a16.01833,16.01833,0,0,0,16-16V88A16.01833,16.01833,0,0,0,216,72Zm-36,84a12,12,0,1,1,12-12A12,12,0,0,1,180,156Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64v0A16,16,0,0,1,56,48H192",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "180",
          cy: "144",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWarning = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M236.74414,187.96585l-87.96875-152a24.012,24.012,0,0,0-41.54687,0v.00782L19.25977,187.96585a23.9982,23.9982,0,0,0,20.76562,36.02344H215.97852a23.9982,23.9982,0,0,0,20.76562-36.02344Zm-116.75-83.96875a8,8,0,1,1,16,0v40a8,8,0,1,1-16,0ZM128,192a12,12,0,1,1,12-12A12.00059,12.00059,0,0,1,128,192Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M114.15243,39.98472,26.17616,191.977a16.00005,16.00005,0,0,0,13.84762,24.01535H215.97625A16,16,0,0,0,229.82386,191.977L141.84757,39.98472A16,16,0,0,0,114.15243,39.98472Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "180",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWarningCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24.00012a104,104,0,1,0,104,104A104.11759,104.11759,0,0,0,128,24.00012Zm-8,56a8,8,0,1,1,16,0v56a8,8,0,1,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184.00012Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "172",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWarningOctagon = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M227.3125,80.23438,175.76562,28.6875A16.11511,16.11511,0,0,0,164.45312,24H91.54687a16.11515,16.11515,0,0,0-11.3125,4.6875L28.6875,80.23438A16.11511,16.11511,0,0,0,24,91.54688v72.90625a16.11515,16.11515,0,0,0,4.6875,11.3125L80.23437,227.3125A16.11515,16.11515,0,0,0,91.54687,232h72.90625a16.11511,16.11511,0,0,0,11.3125-4.6875l51.54688-51.54687A16.11515,16.11515,0,0,0,232,164.45313V91.54688A16.11511,16.11511,0,0,0,227.3125,80.23438ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,128,184Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M164.45079,32H91.54921a8,8,0,0,0-5.65686,2.34315l-51.5492,51.5492A8,8,0,0,0,32,91.54921v72.90158a8,8,0,0,0,2.34315,5.65686l51.5492,51.5492A8,8,0,0,0,91.54921,224h72.90158a8,8,0,0,0,5.65686-2.34315l51.5492-51.5492A8,8,0,0,0,224,164.45079V91.54921a8,8,0,0,0-2.34315-5.65686l-51.5492-51.5492A8,8,0,0,0,164.45079,32Z",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "172",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWatch = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M175.29687,63.53107l-6.23339-34.38556A15.99062,15.99062,0,0,0,153.31982,16H102.68018A15.99062,15.99062,0,0,0,86.93652,29.14551l-6.2334,34.38556a79.89661,79.89661,0,0,0,0,128.93786l6.2334,34.38556A15.99062,15.99062,0,0,0,102.68018,240h50.63964a15.99062,15.99062,0,0,0,15.74366-13.14551l6.23339-34.38556a79.8966,79.8966,0,0,0,0-128.93786ZM102.68018,32h50.64013l3.90723,21.55316a79.69216,79.69216,0,0,0-58.45508,0Zm50.63964,192H102.67969l-3.90723-21.55316a79.69216,79.69216,0,0,0,58.45508,0ZM168,136H128a8.00008,8.00008,0,0,1-8-8V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "72",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "128 88 128 128 168 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,68.12774l6.80838-37.55481A8,8,0,0,1,102.68007,24h50.63985a8,8,0,0,1,7.87169,6.57294L168,68.128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M88,187.87226l6.80838,37.55481A8,8,0,0,0,102.68007,232h50.63985a8,8,0,0,0,7.87169-6.57294L168,187.872",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWaves = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M33.74609,76.96289a7.98611,7.98611,0,0,1,1.25635-11.21A81.79682,81.79682,0,0,1,64.05957,52.23926c16.16406-4.042,41.14941-5.04785,68.37793,13.10449,42.333,28.22363,77.12891,1.53906,78.58887.38965a8.00032,8.00032,0,0,1,9.97119,12.51367,81.79682,81.79682,0,0,1-29.05713,13.51367,81.324,81.324,0,0,1-19.71484,2.4375c-14.04053,0-30.87207-3.68164-48.66309-15.542-42.333-28.22266-77.12842-1.53906-78.58887-.38965A8.01729,8.01729,0,0,1,33.74609,76.96289ZM211.02637,121.7334c-1.46,1.14941-36.25586,27.833-78.58887-.38965-27.22852-18.15137-52.21387-17.14844-68.37793-13.10449a81.79682,81.79682,0,0,0-29.05713,13.51367,8.00032,8.00032,0,0,0,9.97119,12.51367c1.46045-1.14941,36.25586-27.834,78.58887.38965,17.791,11.86035,34.62256,15.542,48.66309,15.542a83.50512,83.50512,0,0,0,48.772-15.95117,8.00032,8.00032,0,0,0-9.97119-12.51367Zm0,56c-1.46,1.15039-36.25586,27.832-78.58887-.38965-27.22852-18.15332-52.21387-17.14746-68.37793-13.10449a81.79682,81.79682,0,0,0-29.05713,13.51367,8.00032,8.00032,0,0,0,9.97119,12.51367c1.46045-1.15039,36.25586-27.835,78.58887.38965,17.791,11.86035,34.62256,15.542,48.66309,15.542a83.50512,83.50512,0,0,0,48.772-15.95117,8.00032,8.00032,0,0,0-9.97119-12.51367Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M40,72s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M40,128s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M40,184s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWhatsappLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M128.00049,24a104.0281,104.0281,0,0,0-91.189,154.041l-8.54687,29.915A15.99944,15.99944,0,0,0,48.044,227.73635l29.916-8.54688A104.00728,104.00728,0,1,0,128.00049,24ZM152.125,192c-.0293.02344-.084,0-.126,0A87.99949,87.99949,0,0,1,64,103.876,36.01385,36.01385,0,0,1,100,68,14.92643,14.92643,0,0,1,112.93066,75.503l11.69092,20.46094a16.01674,16.01674,0,0,1-.17187,16.16992l-7.11084,11.85156a40.03607,40.03607,0,0,0,14.67627,14.67676l11.85107-7.11133a16.01883,16.01883,0,0,1,16.17041-.17285l20.45947,11.69141A14.9238,14.9238,0,0,1,188,156,36.01427,36.01427,0,0,1,152.125,192Z"
        }), React.createElement("path", {
          d: "M136.4502,154.6592a7.99584,7.99584,0,0,1-7.397.43652,56.03179,56.03179,0,0,1-28.14892-28.14843,7.99972,7.99972,0,0,1,.43652-7.39746l9.38867-15.64844L99.36328,84.00979A19.99027,19.99027,0,0,0,80,103.89748,72.00036,72.00036,0,0,0,152,176h.10254a19.99027,19.99027,0,0,0,19.88769-19.36328l-19.8916-11.36621Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M45.429,176.99811A95.95978,95.95978,0,1,1,79.00277,210.5717l.00023-.001L45.84643,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152.11369,183.99992a80,80,0,0,1-80.11361-80.11361A27.97622,27.97622,0,0,1,100,76h0a6.89265,6.89265,0,0,1,5.98451,3.47295l11.69105,20.45931a8,8,0,0,1-.086,8.08508l-9.38907,15.64844h0a48.18239,48.18239,0,0,0,24.13373,24.13373l0,0,15.64841-9.389a8,8,0,0,1,8.08508-.086l20.45931,11.691A6.89265,6.89265,0,0,1,180,156v0A28.081,28.081,0,0,1,152.11369,183.99992Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWheelchair = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M247.47729,185.47021a7.99737,7.99737,0,0,0-10.12012-5.05957l-17.417,5.80567-28.89746-57.79395A7.99979,7.99979,0,0,0,183.88745,124h-80V104h56a8,8,0,0,0,0-16h-56V62.629a24,24,0,1,0-16,0V89.81421a71.99395,71.99395,0,1,0,87.86133,74.678,7.99953,7.99953,0,1,0-15.96875-.98438,56.001,56.001,0,1,1-71.89258-57.16644V132a8.00008,8.00008,0,0,0,8,8h83.05566l29.78906,59.57764a7.9934,7.9934,0,0,0,9.68555,4.01172l24-8A8.00045,8.00045,0,0,0,247.47729,185.47021Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "95.88745",
          cy: "40",
          r: "20",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polyline", {
          points: "95.887 60 95.887 132 183.887 132 215.887 196 239.887 188",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M167.76447,164.00014A64.001,64.001,0,1,1,103.88745,96h56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWifiHigh = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M246.86034,80.49665a15.72068,15.72068,0,0,0-6.209-10.91944C174.34325,19.50788,81.71141,19.49665,15.39061,69.54548a15.73529,15.73529,0,0,0-6.21142,10.936,16.27674,16.27674,0,0,0,3.76074,12.27393L115.85985,214.05768a15.95117,15.95117,0,0,0,12.17383,5.65528A15.77638,15.77638,0,0,0,140.081,214.127L243.12206,92.6822A16.16767,16.16767,0,0,0,246.86034,80.49665Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M25.06379,98.17952a146.68225,146.68225,0,0,1,205.8568,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "200",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWifiLow = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M246.84081,80.49756a15.76545,15.76545,0,0,0-6.231-10.95215c-66.30273-50.03516-158.9165-50.03516-225.22021,0l-.00049.00049a15.73787,15.73787,0,0,0-6.21045,10.936,16.28081,16.28081,0,0,0,3.76074,12.27344l102.86035,121.231a16.15644,16.15644,0,0,0,3.97534,3.38556,15.97543,15.97543,0,0,0,8.25709,2.29852h.00048a15.84564,15.84564,0,0,0,10.90992-4.34833,16.03046,16.03046,0,0,0,1.198-1.26544L243.09227,92.71729A16.20974,16.20974,0,0,0,246.84081,80.49756Zm-15.94873,1.86816-47.10327,55.516a95.96888,95.96888,0,0,0-111.57813-.00012L25.14013,82.4043a.23245.23245,0,0,1-.05958-.12744c60.625-45.71192,145.28174-45.69922,205.85694-.01954A.138.138,0,0,1,230.89208,82.36572Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "200",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWifiMedium = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M240.60352,69.55179C174.33789,19.52054,81.71289,19.50492,15.416,69.53617a15.67919,15.67919,0,0,0-6.23438,10.9375,16.20384,16.20384,0,0,0,3.76563,12.28125L115.791,213.98148a16.04165,16.04165,0,0,0,12.21875,5.6875h.01562a15.846,15.846,0,0,0,12.10938-5.60938v-.00781L243.10352,92.708a16.264,16.264,0,0,0,3.73437-12.22656A15.76645,15.76645,0,0,0,240.60352,69.55179ZM25.00977,82.333h0l.01562-.01562C25.02539,82.32523,25.02539,82.32523,25.00977,82.333ZM204.48242,113.4971A127.38716,127.38716,0,0,0,187.502,102.81156c-.2539-.13575-.50781-.26953-.76562-.40235a127.88589,127.88589,0,0,0-17.78711-7.57129c-.50195-.17089-1.00781-.3164-1.51367-.48144a127.931,127.931,0,0,0-18.42188-4.5625c-.53125-.08985-1.0664-.13086-1.60156-.21387a119.8284,119.8284,0,0,0-38.80859-.00293c-.53711.083-1.07813.126-1.61524.21582a127.94763,127.94763,0,0,0-18.40039,4.55567c-.50781.165-1.01562.3125-1.51953.48437a128.124,128.124,0,0,0-17.76563,7.55762c-.26367.13672-.52343.27441-.78515.41308a127.2435,127.2435,0,0,0-16.96094,10.666l-.002.001L25.10352,82.27054c60.625-45.71875,145.26562-45.6875,205.79687.09375Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M58.97857,132.12064a98.75415,98.75415,0,0,1,138.02724,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "200",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWifiNone = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,219.70508a15.90814,15.90814,0,0,1-12.14014-5.64844L12.8999,92.709a16.182,16.182,0,0,1-3.71826-12.206,15.97026,15.97026,0,0,1,6.208-10.95752c66.30371-50.03418,158.91748-50.03516,225.22119,0a15.97226,15.97226,0,0,1,6.20752,10.957A16.18377,16.18377,0,0,1,243.10059,92.708L140.14014,214.05664A15.90814,15.90814,0,0,1,128,219.70508ZM25.084,82.27441a.12788.12788,0,0,0,.01612.083l102.89844,121.2749L230.8999,82.35693a.16373.16373,0,0,0,.01074-.11767C170.36279,36.57764,85.709,36.563,25.084,82.27441Zm-.05664.04248ZM20.2085,75.93115h0Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "200",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWifiSlash = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M53.86491,34.61787A8.0029,8.0029,0,0,0,42.01886,45.38155l4.63294,5.093A185.51021,185.51021,0,0,0,15.31272,69.55151,15.73558,15.73558,0,0,0,9.097,80.48806a16.27045,16.27045,0,0,0,3.76351,12.27248L115.78283,213.99217a16.0416,16.0416,0,0,0,12.24131,5.6836,15.86724,15.86724,0,0,0,12.11428-5.61329l26.70577-31.4561,35.27175,38.77545a8.0029,8.0029,0,0,0,11.846-10.76369Z"
        }), React.createElement("path", {
          d: "M246.90336,80.50173a15.766,15.766,0,0,0-6.23425-10.95022,187.8405,187.8405,0,0,0-148.037-34.211A7.99849,7.99849,0,0,0,88.207,48.5798L181.6035,151.25965a8.00587,8.00587,0,0,0,5.923,2.61915c.04593,0,.09136,0,.13729-.001a8.007,8.007,0,0,0,5.967-2.82325l49.5227-58.33212A16.20333,16.20333,0,0,0,246.90336,80.50173Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M107.12984,57.47077a148.358,148.358,0,0,1,20.86235-1.46787,145.90176,145.90176,0,0,1,102.9284,42.17662",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M25.06379,98.17952A145.88673,145.88673,0,0,1,72.42537,66.8671",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M152.11967,106.95874a97.88568,97.88568,0,0,1,44.88614,25.1619",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M58.97857,132.12064a97.89874,97.89874,0,0,1,49.03639-26.105",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M92.91969,166.06177a50.81565,50.81565,0,0,1,67.576-2.317",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "200",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWifiX = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("g", null, React.createElement("path", {
          d: "M211.30223,79.99421,229.645,61.65143A8.00018,8.00018,0,1,0,218.33153,50.337L199.98827,68.68024,181.645,50.337a8.00018,8.00018,0,1,0-11.31348,11.31445L188.6743,79.99421,170.33153,98.337A8.00018,8.00018,0,0,0,181.645,109.65143l18.34326-18.34326,18.34326,18.34326A8.00018,8.00018,0,0,0,229.645,98.337Z"
        }), React.createElement("path", {
          d: "M199.98827,113.93561l-7.03113,7.03125a24.00024,24.00024,0,0,1-33.93933-33.9436l7.02905-7.029-7.0299-7.03a24.03027,24.03027,0,0,1,4.60974-37.55127A187.51454,187.51454,0,0,0,15.39061,69.54548a15.73529,15.73529,0,0,0-6.21142,10.936,16.27674,16.27674,0,0,0,3.76074,12.27393L115.85985,214.05768a15.95117,15.95117,0,0,0,12.17383,5.65528A15.77638,15.77638,0,0,0,140.081,214.127l74.647-87.97925a23.97614,23.97614,0,0,1-7.71021-5.18262Z"
        })));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M92.91969,166.06177a50.7769,50.7769,0,0,1,70.145,0",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M25.06379,98.17952A145.90174,145.90174,0,0,1,127.99219,56.0029a148.757,148.757,0,0,1,16.01524.86162",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M58.97857,132.12064a98.11506,98.11506,0,0,1,69.01362-28.11774,99.87589,99.87589,0,0,1,16.02985,1.28855",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("circle", {
          cx: "128",
          cy: "200",
          r: "12"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWind = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184,184a32.00415,32.00415,0,0,1-62.01855,11.10449,8.00013,8.00013,0,1,1,15.00585-5.55273A16.00278,16.00278,0,1,0,152,168H40a8,8,0,0,1,0-16H152A32.03635,32.03635,0,0,1,184,184Zm-64-80A32,32,0,1,0,89.98145,60.89551a8.00013,8.00013,0,1,0,15.00585,5.55273A16.00278,16.00278,0,1,1,120,88H24a8,8,0,0,0,0,16Zm88-32a32.13165,32.13165,0,0,0-30.01855,20.89551,8.00013,8.00013,0,1,0,15.00585,5.55273A16.00278,16.00278,0,1,1,208,120H32a8,8,0,0,0,0,16H208a32,32,0,0,0,0-64Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M129.48449,192.32854A24.00285,24.00285,0,1,0,152,160H40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M97.48449,63.67146A24.00285,24.00285,0,1,1,120,96H24",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M185.48449,95.67146A24.00285,24.00285,0,1,1,208,128H32",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWindowsLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M112,144v51.63672a7.9983,7.9983,0,0,1-9.43115,7.87061l-64-11.63623A8.00019,8.00019,0,0,1,32,184V144a8.00008,8.00008,0,0,1,8-8h64A8.00008,8.00008,0,0,1,112,144ZM109.126,54.2217a7.995,7.995,0,0,0-6.55713-1.729l-64,11.63623A8.00017,8.00017,0,0,0,32,72v40a8.00008,8.00008,0,0,0,8,8h64a8.00008,8.00008,0,0,0,8-8V60.3633A7.99853,7.99853,0,0,0,109.126,54.2217ZM216,136H136a8.00008,8.00008,0,0,0-8,8v57.45459a7.99967,7.99967,0,0,0,6.56885,7.87061l80,14.5459A8.0001,8.0001,0,0,0,224,216V144A8.00008,8.00008,0,0,0,216,136Zm5.126-102.14209a7.99714,7.99714,0,0,0-6.55713-1.729l-80,14.5459A7.99965,7.99965,0,0,0,128,54.54543V112a8.00008,8.00008,0,0,0,8,8h80a8.00008,8.00008,0,0,0,8-8V40A8.00028,8.00028,0,0,0,221.126,33.85793Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "216 216 136 201.455 136 201.455 136 144 216 144 216 216",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "104 195.636 40 184 40 144 104 144 104 195.636",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "216 40 136 54.545 136 54.545 136 112 216 112 216 40",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("polygon", {
          points: "104 60.364 40 72 40 112 104 112 104 60.364",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWine = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M209.73047,110.01318,183.67285,21.73535A7.99985,7.99985,0,0,0,176,16H80a7.99985,7.99985,0,0,0-7.67285,5.73535L46.26953,110.01367A31.984,31.984,0,0,0,47.791,132.24951,88.23263,88.23263,0,0,0,120,183.62012V224H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.62012a88.2322,88.2322,0,0,0,72.209-51.3711A31.98167,31.98167,0,0,0,209.73047,110.01318ZM131.57764,96.84473C105.398,83.75488,84.38428,83.76318,69.66943,87.25586L85.97949,32h84.041l20.8125,70.5083C180.05664,107.001,159.75586,110.93359,131.57764,96.84473Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M80,24h96l26.05817,88.278a23.979,23.979,0,0,1-1.1376,16.67254,80.03345,80.03345,0,0,1-145.841.00041A23.979,23.979,0,0,1,53.942,112.27835Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M57.48453,100.27689C68.083,94.644,92.7349,86.36745,128,104c37.55571,18.77785,63.07475,8.17173,72.402,2.66713",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconWrench = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M210.91162,146.91211a72.37653,72.37653,0,0,1-79.84424,15.03613L79.0249,222.2002q-.19116.22119-.39746.42773a32.00021,32.00021,0,0,1-45.25537-45.25488c.1377-.1377.28076-.27051.42773-.39844l60.25293-52.043a72.02489,72.02489,0,0,1,94.06153-95.23437A8.004,8.004,0,0,1,190.648,42.72461L151.71387,81.6582l3.77148,18.85645,18.856,3.77148,38.93457-38.93457a8.00429,8.00429,0,0,1,13.02685,2.53418A71.72729,71.72729,0,0,1,210.91162,146.91211Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M184.99131,37.06756,143.02944,79.02944l5.65685,28.28427,28.28427,5.65685,41.96188-41.96187.0041-.00174a64.02489,64.02489,0,0,1-89.88113,81.03367l.00123-.00214L72.97056,216.97056a24,24,0,0,1-33.94112-33.94112L103.9608,126.944l-.00137.0007a64.02489,64.02489,0,0,1,81.03363-89.88122Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconX = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M139.31348,128l66.34326-66.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L128,116.68652,61.65674,50.34326A7.99984,7.99984,0,0,0,50.34326,61.65674L116.68652,128,50.34326,194.34326a7.99984,7.99984,0,1,0,11.31348,11.31348L128,139.31348l66.34326,66.34326a7.99984,7.99984,0,0,0,11.31348-11.31348Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "200",
          y1: "200",
          x2: "56",
          y2: "56",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconXCircle = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm37.65625,130.34375a7.99915,7.99915,0,1,1-11.3125,11.3125L128,139.3125l-26.34375,26.34375a7.99915,7.99915,0,0,1-11.3125-11.3125L116.6875,128,90.34375,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125L128,116.6875l26.34375-26.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L139.3125,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          strokeMiterlimit: "10",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconXOctagon = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M175.766 28.6875L227.312 80.2344C230.303 83.2416 231.987 87.3064 232 91.5472V164.453C231.987 168.694 230.303 172.758 227.312 175.766L175.766 227.313C172.759 230.302 168.694 231.987 164.453 232H91.5466C87.3058 231.987 83.2418 230.302 80.2346 227.313L28.6874 175.766C25.6974 172.758 24.0131 168.694 24 164.453V91.5472C24.0131 87.3064 25.6974 83.2416 28.6874 80.2344L80.2346 28.6875C83.2418 25.6974 87.3058 24.0132 91.5466 24H164.453C168.694 24.0132 172.759 25.6974 175.766 28.6875ZM167.387 156.932C166.984 155.962 166.393 155.079 165.649 154.337L139.306 127.993L165.649 101.65C167.147 100.149 167.987 98.1152 167.986 95.9952C167.985 93.8752 167.143 91.8416 165.643 90.3432C164.144 88.844 162.111 88.0008 159.991 88C157.871 87.9992 155.838 88.8392 154.337 90.3368L127.993 116.681L101.649 90.3368C100.149 88.8392 98.1146 87.9992 95.9946 88C93.8746 88.0008 91.8418 88.844 90.3426 90.3432C88.8434 91.8416 88.001 93.8752 88.0002 95.9952C87.9986 98.1152 88.8394 100.149 90.337 101.65L116.68 127.993L90.337 154.337C88.8394 155.838 87.9986 157.871 88.0002 159.991C88.001 162.111 88.8434 164.144 90.3426 165.643C91.8418 167.142 93.8746 167.985 95.9946 167.986C98.1146 167.987 100.149 167.147 101.649 165.65L127.993 139.306L154.337 165.65C155.079 166.394 155.961 166.984 156.932 167.387C157.903 167.79 158.943 167.998 159.995 167.998C161.046 167.999 162.087 167.792 163.059 167.39C164.03 166.988 164.912 166.398 165.655 165.655C166.399 164.912 166.988 164.03 167.39 163.058C167.792 162.087 167.999 161.046 167.999 159.995C167.998 158.944 167.79 157.903 167.387 156.932Z",
          fill: "currentColor"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M164.45 32H91.5496C90.4984 32 89.4584 32.207 88.488 32.609C87.5168 33.011 86.6352 33.6003 85.892 34.3431L34.3431 85.892C33.6003 86.6352 33.011 87.5168 32.609 88.488C32.207 89.4584 32 90.4984 32 91.5496V164.45C32 165.502 32.207 166.542 32.609 167.512C33.011 168.483 33.6003 169.365 34.3431 170.108L85.892 221.657C86.6352 222.4 87.5168 222.989 88.488 223.391C89.4584 223.793 90.4984 224 91.5496 224H164.45C165.502 224 166.542 223.793 167.512 223.391C168.483 222.989 169.365 222.4 170.108 221.657L221.657 170.108C222.4 169.365 222.989 168.483 223.391 167.512C223.793 166.542 224 165.502 224 164.45V91.5496C224 90.4984 223.793 89.4584 223.391 88.488C222.989 87.5168 222.4 86.6352 221.657 85.892L170.108 34.3431C169.365 33.6003 168.483 33.011 167.512 32.609C166.542 32.207 165.502 32 164.45 32Z",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "18",
          strokeMiterlimit: "10"
        }), React.createElement("path", {
          d: "M160 96L96 160",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "18",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), React.createElement("path", {
          d: "M160 160L96 96",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "18",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconXSquare = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M208.00146,32h-160a16.01582,16.01582,0,0,0-16,16V208a16.01583,16.01583,0,0,0,16,16h160a16.01582,16.01582,0,0,0,16-16V48A16.01581,16.01581,0,0,0,208.00146,32ZM165.65771,154.34375a7.99915,7.99915,0,1,1-11.3125,11.3125L128.00146,139.3125l-26.34375,26.34375a7.99915,7.99915,0,0,1-11.3125-11.3125L116.689,128,90.34521,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125l26.34375,26.34375,26.34375-26.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L139.314,128Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          strokeWidth: "18",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
/* GENERATED FILE */

var IconYoutubeLogo = /*#__PURE__*/forwardRef(function (props, ref) {
  var path;

  switch (props.weight) {
    case 'fill':
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("path", {
          d: "M234.33057,69.79736a23.96369,23.96369,0,0,0-14.50489-16.34619C185.55615,40.28223,130.97949,40.39209,128,40.40771c-2.978-.02392-57.55518-.126-91.8252,13.04346A23.96415,23.96415,0,0,0,21.66992,69.79639C19.083,79.72705,16,97.88574,16,128c0,30.11377,3.083,48.27246,5.66943,58.20264a23.96369,23.96369,0,0,0,14.50489,16.34619c32.80615,12.60693,84.22168,13.04541,91.167,13.04541.6206.00049.69678.00049,1.31738,0,6.95069-.00049,58.36231-.43945,91.16651-13.04541a23.96415,23.96415,0,0,0,14.50488-16.34522C236.917,176.273,240,158.11426,240,128,240,97.88623,236.917,79.72754,234.33057,69.79736Zm-72.11182,61.53076-48,32A3.99967,3.99967,0,0,1,108,160V96a3.99968,3.99968,0,0,1,6.21875-3.32813l48,32a3.99979,3.99979,0,0,1,0,6.65625Z"
        }));
      };

      break;

    default:
      path = function path() {
        return React.createElement(React.Fragment, null, React.createElement("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }), React.createElement("path", {
          d: "M24,128c0,29.75546,3.07414,47.21382,5.41108,56.18664a15.91682,15.91682,0,0,0,9.63282,10.89441C72.52083,207.94575,128,207.5925,128,207.5925s55.47857.35324,88.9558-12.51137a15.91684,15.91684,0,0,0,9.6329-10.89432C228.92572,175.214,232,157.75554,232,128s-3.07415-47.21382-5.41108-56.18664A15.91682,15.91682,0,0,0,216.9561,60.919C183.47917,48.05425,128,48.4075,128,48.4075s-55.47857-.35324-88.9558,12.51137a15.91684,15.91684,0,0,0-9.6329,10.89432C27.07427,80.786,24,98.24446,24,128Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "18"
        }));
      };

      break;
  }

  var renderPath = function renderPath(weight) {
    return renderPathForWeight(weight, path);
  };

  var _useIconContext = useIconContext(),
      useIconProps = _useIconContext.useIconProps;

  var parsedProps = useIconProps(props);
  return React.createElement(IconBase, Object.assign({
    ref: ref
  }, parsedProps, {
    renderPath: renderPath
  }));
});
export { IconActivity, IconAddressBook, IconAirplane, IconAirplaneInFlight, IconAirplaneLanding, IconAirplaneTakeoff, IconAirplaneTilt, IconAirplay, IconAlarm, IconAlignBottom, IconAlignCenterHorizontal, IconAlignCenterVertical, IconAlignLeft, IconAlignRight, IconAlignTop, IconAnchor, IconAnchorSimple, IconAndroidLogo, IconAperture, IconAppWindow, IconAppleLogo, IconArchive, IconArchiveBox, IconArchiveTray, IconArmchair, IconArrowArcLeft, IconArrowArcRight, IconArrowBendDoubleUpLeft, IconArrowBendDoubleUpRight, IconArrowBendDownLeft, IconArrowBendDownRight, IconArrowBendLeftDown, IconArrowBendLeftUp, IconArrowBendRightDown, IconArrowBendRightUp, IconArrowBendUpLeft, IconArrowBendUpRight, IconArrowCircleDown, IconArrowCircleDownLeft, IconArrowCircleDownRight, IconArrowCircleLeft, IconArrowCircleRight, IconArrowCircleUp, IconArrowCircleUpLeft, IconArrowCircleUpRight, IconArrowClockwise, IconArrowCounterClockwise, IconArrowDown, IconArrowDownLeft, IconArrowDownRight, IconArrowElbowDownLeft, IconArrowElbowDownRight, IconArrowElbowLeft, IconArrowElbowLeftDown, IconArrowElbowLeftUp, IconArrowElbowRight, IconArrowElbowRightDown, IconArrowElbowRightUp, IconArrowElbowUpLeft, IconArrowElbowUpRight, IconArrowFatDown, IconArrowFatLeft, IconArrowFatLineDown, IconArrowFatLineLeft, IconArrowFatLineRight, IconArrowFatLineUp, IconArrowFatLinesDown, IconArrowFatLinesLeft, IconArrowFatLinesRight, IconArrowFatLinesUp, IconArrowFatRight, IconArrowFatUp, IconArrowLeft, IconArrowLineDown, IconArrowLineDownLeft, IconArrowLineDownRight, IconArrowLineLeft, IconArrowLineRight, IconArrowLineUp, IconArrowLineUpLeft, IconArrowLineUpRight, IconArrowRight, IconArrowSquareDown, IconArrowSquareDownLeft, IconArrowSquareDownRight, IconArrowSquareIn, IconArrowSquareLeft, IconArrowSquareOut, IconArrowSquareRight, IconArrowSquareUp, IconArrowSquareUpLeft, IconArrowSquareUpRight, IconArrowUDownLeft, IconArrowUDownRight, IconArrowULeftDown, IconArrowULeftUp, IconArrowURightDown, IconArrowURightUp, IconArrowUUpLeft, IconArrowUUpRight, IconArrowUp, IconArrowUpLeft, IconArrowUpRight, IconArrowsClockwise, IconArrowsCounterClockwise, IconArrowsDownUp, IconArrowsIn, IconArrowsInCardinal, IconArrowsInLineHorizontal, IconArrowsInLineVertical, IconArrowsInSimple, IconArrowsLeftRight, IconArrowsOut, IconArrowsOutCardinal, IconArrowsOutLineHorizontal, IconArrowsOutLineVertical, IconArrowsOutSimple, IconArticle, IconArticleMedium, IconArticleNyTimes, IconAsterisk, IconAt, IconAtom, IconBaby, IconBackspace, IconBag, IconBagSimple, IconBandaids, IconBank, IconBarbell, IconBarcode, IconBase, IconBaseball, IconBasketball, IconBatteryCharging, IconBatteryChargingVertical, IconBatteryEmpty, IconBatteryFull, IconBatteryHigh, IconBatteryLow, IconBatteryMedium, IconBatteryWarning, IconBatteryWarningVertical, IconBed, IconBell, IconBellRinging, IconBellSimple, IconBellSimpleRinging, IconBellSimpleSlash, IconBellSimpleZ, IconBellSlash, IconBellZ, IconBicycle, IconBird, IconBluetooth, IconBluetoothConnected, IconBluetoothSlash, IconBluetoothX, IconBoat, IconBook, IconBookBookmark, IconBookOpen, IconBookmark, IconBookmarkSimple, IconBookmarks, IconBookmarksSimple, IconBooks, IconBoundingBox, IconBracketsAngle, IconBracketsCurly, IconBracketsRound, IconBracketsSquare, IconBrain, IconBrandy, IconBriefcase, IconBriefcaseMetal, IconBroadcast, IconBrowser, IconBrowsers, IconBug, IconBugBeetle, IconBugDroid, IconBuildings, IconBus, IconCake, IconCalculator, IconCalendar, IconCalendarBlank, IconCalendarCheck, IconCalendarPlus, IconCalendarX, IconCamera, IconCameraSlash, IconCar, IconCarSimple, IconCardholder, IconCards, IconCaretCircleDoubleDown, IconCaretCircleDoubleLeft, IconCaretCircleDoubleRight, IconCaretCircleDoubleUp, IconCaretCircleDown, IconCaretCircleLeft, IconCaretCircleRight, IconCaretCircleUp, IconCaretDoubleDown, IconCaretDoubleLeft, IconCaretDoubleRight, IconCaretDoubleUp, IconCaretDown, IconCaretLeft, IconCaretRight, IconCaretUp, IconCat, IconCellSignalFull, IconCellSignalHigh, IconCellSignalLow, IconCellSignalMedium, IconCellSignalNone, IconCellSignalSlash, IconCellSignalX, IconChalkboard, IconChalkboardSimple, IconChalkboardTeacher, IconChartBar, IconChartBarHorizontal, IconChartLine, IconChartLineUp, IconChartPie, IconChartPieSlice, IconChat, IconChatCentered, IconChatCenteredDots, IconChatCenteredText, IconChatCircle, IconChatCircleDots, IconChatCircleText, IconChatDots, IconChatTeardrop, IconChatTeardropDots, IconChatTeardropText, IconChatText, IconChats, IconChatsCircle, IconChatsTeardrop, IconCheck, IconCheckCircle, IconCheckSquare, IconCheckSquareOffset, IconChecks, IconCircle, IconCircleDashed, IconCircleHalf, IconCircleHalfTilt, IconCircleWavy, IconCircleWavyCheck, IconCircleWavyQuestion, IconCircleWavyWarning, IconCirclesFour, IconCirclesThree, IconCirclesThreePlus, IconClipboard, IconClipboardText, IconClock, IconClockAfternoon, IconClockClockwise, IconClockCounterClockwise, IconClosedCaptioning, IconCloud, IconCloudArrowDown, IconCloudArrowUp, IconCloudCheck, IconCloudFog, IconCloudLightning, IconCloudMoon, IconCloudRain, IconCloudSlash, IconCloudSnow, IconCloudSun, IconClub, IconCode, IconCodeSimple, IconCoffee, IconCoin, IconColumns, IconCommand, IconCompass, IconComputerTower, IconContext, IconCookie, IconCookingPot, IconCopy, IconCopySimple, IconCopyright, IconCornersIn, IconCornersOut, IconCpu, IconCreditCard, IconCrop, IconCrosshair, IconCrosshairSimple, IconCrown, IconCrownSimple, IconCube, IconCurrencyBtc, IconCurrencyCircleDollar, IconCurrencyCny, IconCurrencyDollar, IconCurrencyDollarSimple, IconCurrencyEur, IconCurrencyGbp, IconCurrencyInr, IconCurrencyJpy, IconCurrencyKrw, IconCurrencyRub, IconCursor, IconDatabase, IconDesktop, IconDesktopTower, IconDeviceMobile, IconDeviceMobileCamera, IconDeviceMobileSpeaker, IconDeviceTablet, IconDeviceTabletCamera, IconDeviceTabletSpeaker, IconDiamond, IconDiceFive, IconDiceFour, IconDiceOne, IconDiceSix, IconDiceThree, IconDiceTwo, IconDisc, IconDiscordLogo, IconDivide, IconDog, IconDoor, IconDotsNine, IconDotsSix, IconDotsSixVertical, IconDotsThree, IconDotsThreeCircle, IconDotsThreeCircleVertical, IconDotsThreeOutline, IconDotsThreeOutlineVertical, IconDotsThreeVertical, IconDownload, IconDownloadSimple, IconDribbbleLogo, IconDrop, IconDropHalf, IconEar, IconEarSlash, IconEject, IconEjectSimple, IconEnvelope, IconEnvelopeOpen, IconEnvelopeSimple, IconEnvelopeSimpleOpen, IconEquals, IconEraser, IconExport, IconEye, IconEyeClosed, IconEyeSlash, IconEyedropper, IconFaceMask, IconFacebookLogo, IconFactory, IconFaders, IconFadersHorizontal, IconFastForward, IconFastForwardCircle, IconFigmaLogo, IconFile, IconFileArrowDown, IconFileArrowUp, IconFileDotted, IconFileMinus, IconFilePdf, IconFilePlus, IconFileSearch, IconFileText, IconFileX, IconFiles, IconFilmStrip, IconFingerprint, IconFingerprintSimple, IconFinnTheHuman, IconFire, IconFireSimple, IconFirstAid, IconFirstAidKit, IconFish, IconFishSimple, IconFlag, IconFlagBanner, IconFlame, IconFlashlight, IconFlask, IconFloppyDisk, IconFloppyDiskBack, IconFlowArrow, IconFlower, IconFlowerLotus, IconFolder, IconFolderMinus, IconFolderNotch, IconFolderNotchMinus, IconFolderNotchOpen, IconFolderNotchPlus, IconFolderOpen, IconFolderPlus, IconFolderSimple, IconFolderSimpleMinus, IconFolderSimplePlus, IconFolders, IconFootball, IconForkKnife, IconFrameCorners, IconFramerLogo, IconFunnel, IconFunnelSimple, IconGameController, IconGasPump, IconGauge, IconGear, IconGearSix, IconGenderFemale, IconGenderIntersex, IconGenderMale, IconGenderNeuter, IconGenderNonbinary, IconGenderTransgender, IconGhost, IconGif, IconGift, IconGitBranch, IconGitCommit, IconGitDiff, IconGitFork, IconGitMerge, IconGitPullRequest, IconGithubLogo, IconGitlabLogo, IconGitlabLogoSimple, IconGlobe, IconGlobeHemisphereEast, IconGlobeHemisphereWest, IconGlobeSimple, IconGlobeStand, IconGoogleLogo, IconGooglePlayLogo, IconGraduationCap, IconGridFour, IconHand, IconHandFist, IconHandGrabbing, IconHandPalm, IconHandPointing, IconHandSoap, IconHandWaving, IconHandbag, IconHandbagSimple, IconHandsClapping, IconHandshake, IconHardDrive, IconHardDrives, IconHash, IconHashStraight, IconHeadlights, IconHeadphones, IconHeadset, IconHeart, IconHeartStraight, IconHeartbeat, IconHexagon, IconHighlighterCircle, IconHorse, IconHourglass, IconHourglassHigh, IconHourglassLow, IconHourglassMedium, IconHourglassSimple, IconHourglassSimpleHigh, IconHourglassSimpleLow, IconHourglassSimpleMedium, IconHouse, IconHouseLine, IconHouseSimple, IconIdentificationBadge, IconIdentificationCard, IconImage, IconImageSquare, IconInfinity, IconInfo, IconInstagramLogo, IconIntersect, IconJeep, IconKey, IconKeyReturn, IconKeyboard, IconKnife, IconLamp, IconLaptop, IconLayout, IconLeaf, IconLifebuoy, IconLightbulb, IconLightbulbFilament, IconLightning, IconLightningSlash, IconLineSegment, IconLineSegments, IconLink, IconLinkBreak, IconLinkSimple, IconLinkSimpleBreak, IconLinkSimpleHorizontal, IconLinkSimpleHorizontalBreak, IconLinkedinLogo, IconList, IconListBullets, IconListDashes, IconListNumbers, IconListPlus, IconLock, IconLockKey, IconLockKeyOpen, IconLockLaminated, IconLockLaminatedOpen, IconLockOpen, IconLockSimple, IconLockSimpleOpen, IconMagicWand, IconMagnet, IconMagnetStraight, IconMagnifyingGlass, IconMagnifyingGlassMinus, IconMagnifyingGlassPlus, IconMapPin, IconMapPinLine, IconMapTrifold, IconMarkerCircle, IconMartini, IconMathOperations, IconMedal, IconMediumLogo, IconMegaphone, IconMegaphoneSimple, IconMessengerLogo, IconMicrophone, IconMicrophoneSlash, IconMinus, IconMinusCircle, IconMoney, IconMonitor, IconMonitorPlay, IconMoon, IconMoonStars, IconMouse, IconMouseSimple, IconMusicNote, IconMusicNoteSimple, IconMusicNotes, IconMusicNotesSimple, IconNavigationArrow, IconNewspaper, IconNewspaperClipping, IconNote, IconNoteBlank, IconNotePencil, IconNotebook, IconNotepad, IconNotification, IconNumberCircleEight, IconNumberCircleFive, IconNumberCircleFour, IconNumberCircleNine, IconNumberCircleOne, IconNumberCircleSeven, IconNumberCircleSix, IconNumberCircleThree, IconNumberCircleTwo, IconNumberCircleZero, IconNumberEight, IconNumberFive, IconNumberFour, IconNumberNine, IconNumberOne, IconNumberSeven, IconNumberSix, IconNumberSquareEight, IconNumberSquareFive, IconNumberSquareFour, IconNumberSquareNine, IconNumberSquareOne, IconNumberSquareSeven, IconNumberSquareSix, IconNumberSquareThree, IconNumberSquareTwo, IconNumberSquareZero, IconNumberThree, IconNumberTwo, IconNumberZero, IconNut, IconNyTimesLogo, IconOctagon, IconPackage, IconPaintBrush, IconPaintBrushBroad, IconPaintBrushHousehold, IconPaintBucket, IconPaintRoller, IconPalette, IconPaperPlane, IconPaperPlaneRight, IconPaperPlaneTilt, IconPaperclip, IconPaperclipHorizontal, IconPath, IconPause, IconPauseCircle, IconPawPrint, IconPeace, IconPen, IconPenNib, IconPenNibStraight, IconPencil, IconPencilCircle, IconPencilLine, IconPencilSimple, IconPercent, IconPerson, IconPersonSimple, IconPersonSimpleRun, IconPersonSimpleWalk, IconPhone, IconPhoneCall, IconPhoneDisconnect, IconPhoneIncoming, IconPhoneOutgoing, IconPhoneSlash, IconPhoneX, IconPhosphorLogo, IconPictureInPicture, IconPill, IconPinterestLogo, IconPizza, IconPlaceholder, IconPlanet, IconPlay, IconPlayCircle, IconPlaylist, IconPlus, IconPlusCircle, IconPlusMinus, IconPokerChip, IconPolygon, IconPower, IconPrescription, IconPresentation, IconPresentationChart, IconPrinter, IconProhibit, IconProhibitInset, IconProjectorScreen, IconProjectorScreenChart, IconPushPin, IconPushPinSimple, IconPushPinSimpleSlash, IconPushPinSlash, IconPuzzlePiece, IconQrCode, IconQuestion, IconQueue, IconQuotes, IconRadical, IconRadio, IconRainbow, IconRainbowCloud, IconReceipt, IconRecord, IconRectangle, IconRecycle, IconRedditLogo, IconRepeat, IconRepeatOnce, IconRewind, IconRewindCircle, IconRobot, IconRocket, IconRocketLaunch, IconRows, IconRss, IconRssSimple, IconRuler, IconScales, IconScissors, IconScreencast, IconScribbleLoop, IconSelection, IconSelectionAll, IconSelectionBackground, IconSelectionForeground, IconSelectionInverse, IconSelectionPlus, IconSelectionSlash, IconShare, IconShareNetwork, IconShield, IconShieldCheck, IconShieldCheckered, IconShieldChevron, IconShieldPlus, IconShieldSlash, IconShieldWarning, IconShoppingBag, IconShoppingBagOpen, IconShoppingCart, IconShoppingCartSimple, IconShower, IconShuffle, IconShuffleAngular, IconShuffleSimple, IconSignIn, IconSignOut, IconSimCard, IconSketchLogo, IconSkipBack, IconSkipBackCircle, IconSkipForward, IconSkipForwardCircle, IconSlackLogo, IconSliders, IconSlidersHorizontal, IconSmiley, IconSmileyBlank, IconSmileyMeh, IconSmileyNervous, IconSmileySad, IconSmileySticker, IconSmileyWink, IconSmileyXEyes, IconSnapchatLogo, IconSnowflake, IconSoccerBall, IconSortAscending, IconSortDescending, IconSpade, IconSparkle, IconSpeakerHigh, IconSpeakerLow, IconSpeakerNone, IconSpeakerSimpleHigh, IconSpeakerSimpleLow, IconSpeakerSimpleNone, IconSpeakerSimpleSlash, IconSpeakerSimpleX, IconSpeakerSlash, IconSpeakerX, IconSpinner, IconSpinnerGap, IconSpotifyLogo, IconSquare, IconSquareHalf, IconSquareLogo, IconSquaresFour, IconStack, IconStackSimple, IconStar, IconStarFour, IconStarHalf, IconSticker, IconStop, IconStopCircle, IconStorefront, IconStripeLogo, IconStudent, IconSuitcase, IconSuitcaseSimple, IconSun, IconSunDim, IconSunHorizon, IconSwap, IconSwatches, IconSword, IconTShirt, IconTable, IconTag, IconTagChevron, IconTagSimple, IconTarget, IconTelegramLogo, IconTelevision, IconTelevisionSimple, IconTennisBall, IconTerminal, IconTerminalWindow, IconTestTube, IconTextAa, IconTextAlignCenter, IconTextAlignJustify, IconTextAlignLeft, IconTextAlignRight, IconTextBolder, IconTextH, IconTextHFive, IconTextHFour, IconTextHOne, IconTextHSix, IconTextHThree, IconTextHTwo, IconTextItalic, IconTextStrikethrough, IconTextT, IconTextUnderline, IconThermometer, IconThermometerCold, IconThermometerHot, IconThermometerSimple, IconThumbsDown, IconThumbsUp, IconTicket, IconTiktokLogo, IconTimer, IconToggleLeft, IconToggleRight, IconToiletPaper, IconTote, IconToteSimple, IconTrafficSign, IconTrain, IconTrainRegional, IconTrainSimple, IconTranslate, IconTrash, IconTrashSimple, IconTray, IconTree, IconTreeEvergreen, IconTreeStructure, IconTrendDown, IconTrendUp, IconTriangle, IconTrophy, IconTruck, IconTwitchLogo, IconTwitterLogo, IconUmbrella, IconUmbrellaSimple, IconUpload, IconUploadSimple, IconUser, IconUserCircle, IconUserCircleGear, IconUserCircleMinus, IconUserCirclePlus, IconUserFocus, IconUserGear, IconUserList, IconUserMinus, IconUserPlus, IconUserRectangle, IconUserSquare, IconUsers, IconUsersFour, IconUsersThree, IconVibrate, IconVideoCamera, IconVideoCameraSlash, IconVoicemail, IconVolleyball, IconWall, IconWallet, IconWarning, IconWarningCircle, IconWarningOctagon, IconWatch, IconWaves, IconWhatsappLogo, IconWheelchair, IconWifiHigh, IconWifiLow, IconWifiMedium, IconWifiNone, IconWifiSlash, IconWifiX, IconWind, IconWindowsLogo, IconWine, IconWrench, IconX, IconXCircle, IconXOctagon, IconXSquare, IconYoutubeLogo, createIconProvider, renderPathForWeight, useIconContext };